// @ts-nocheck
import React, { useState, useRef, useEffect, useMemo } from "react";
import { initializeApp } from "firebase/app";
import {
  getAuth,
  signInAnonymously,
  signInWithCustomToken,
  onAuthStateChanged,
  RecaptchaVerifier,
  signInWithPhoneNumber,
} from "firebase/auth";
import {
  getFirestore,
  collection,
  doc,
  setDoc,
  updateDoc,
  query,
  where,
  orderBy,
  getDocs,
  addDoc,
  getDoc,
  limit,
  serverTimestamp,
} from "firebase/firestore";
import {
  getStorage,
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";
import {
  Building2,
  FileText,
  Check,
  CheckCircle,
  Lock,
  UserCheck,
  CreditCard,
  PenTool,
  Download,
  Upload,
  FileSpreadsheet,
  Play,
  AlertCircle,
  AlertTriangle,
  RefreshCcw,
  Mail,
  ChevronRight,
  ChevronLeft,
  Loader2,
  Search,
  X,
  List,
  ArrowLeft,
  ChevronDown,
  History,
  BarChart3,
  Activity,
  ShieldCheck,
  Trash2,
  Undo2,
  Info,
  Bug,
  Smartphone,
  Leaf,
  Truck,
  Award,
  Clock3,
  LockKeyhole,
  ClipboardCheck,
  Waves,
} from "lucide-react";
import CorepInviteFlow from "./CorepInviteFlow";
import PaymentDepositLedger from "./PaymentDepositLedger";
import ErpBridgePanel from "./erp-bridge/ErpBridgePanel";
import AdminIntegratedDashboard from "./admin-dashboard/AdminIntegratedDashboard";
import {
  getDashboardDateRange,
  getDashboardPaymentLoadRange,
} from "./admin-dashboard/adminDashboardStats";
import {
  buildPaymentCopyPreview as buildPaymentCopyPreviewImpl,
  buildPaymentLinkMessage as buildPaymentLinkMessageImpl,
} from "./paymentLinkMessage";
import { maskKoreanMobilePhone } from "./paymentLinkPhone";
import VendorImportPanel from "./vendor-master/VendorImportPanel";
import VendorLifecyclePanel from "./vendor-master/VendorLifecyclePanel";
import VendorMasterEditor from "./vendor-master/VendorMasterEditor";
import VendorMasterReviewPanel from "./vendor-master/VendorMasterReviewPanel";
import {
  createVendorMasterEditorState,
  editVendorMasterEditorState,
  getCanonicalVendorMasterId,
  getVendorMasterEditorRequest,
  updateVendorMasterEditorState,
} from "./vendor-master/vendorMasterEditorState";
import {
  getCorepInviteTokenHashFromCorepRoute,
  getCorepInviteTokenFromCorepRoute,
  loadCorepKcpReturnContext,
  shouldRouteToCorepInviteFlow,
} from "./corepKcpReturnContext";

/* ================= 설정 및 리소스 ================= */
const LOGO_URL = "/logo.png";
const SEAL_URL_1 = "/seal1.png";
const SEAL_URL_2 = "/seal2.png";

// 담당자 설정 기본값(fallback) - 실제 데이터는 Firestore에서 로드
// Firestore 경로: artifacts/cnfood-final-v48/config/managers (문서 id: list)
// { managers: [ { code: "yh", name: "...", email: "..." }, ... ] }
// Firebase 콘솔에서 직접 수정 가능 → 코드 배포 없이 담당자 추가/수정/삭제
const MANAGER_CONFIG_DEFAULT = [
  { code: "yh", name: "4영훈은옥", email: "manager1@cnfood.com" },
  { code: "sh", name: "3승현", email: "manager2@cnfood.com" },
  { code: "default", name: "본사", email: "park.yh@seanfood.com" },
];

export const SALES_LOOKUP_PASSWORD = "8639";
export const SALES_LOOKUP_MANAGER = {
  code: "sales_lookup",
  name: "영업 조회",
  email: "",
};
export const PAYMENT_MANAGER = {
  code: "payment",
  name: "결제 담당",
  email: "",
};
export const SALES_PAYMENT_MANAGER = {
  code: "sales_payment",
  name: "영업 문자링크 요청",
  email: "",
};
export const SALES_CONTRACT_SEARCH_LIMIT = 500;

const HEADQUARTER_EMAIL = "mizzang102@naver.com";
const NTS_API_KEY =
  "a9252955706e1ae613abf5ab0a99743376911ead3affa79ea2042c9a4eb8d72f";

const getFirebaseConfig = () => {
  const defaults = {
    apiKey: "AIzaSyAOFIr8GKihFNx9hIvzyNneO6N0EEGW1Qw",
    authDomain: "cnfood-contract.firebaseapp.com",
    projectId: "cnfood-contract",
    storageBucket: "cnfood-contract.firebasestorage.app",
    messagingSenderId: "1022207262780",
    appId: "1:1022207262780:web:89fff2c1ce6e60cd798339",
    measurementId: "G-PGRSR055XE",
  };

  if (typeof window !== "undefined" && window["__firebase_config"]) {
    try {
      return Object.assign(defaults, JSON.parse(window["__firebase_config"]));
    } catch (e) {
      return defaults;
    }
  }
  return defaults;
};

const app = initializeApp(getFirebaseConfig());
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
// 운영 데이터 조회/저장은 반드시 기존 cnfood-final-v48 경로를 유지한다.
const appId = "cnfood-final-v48";

export const CNFOOD_BUSINESS_PROFILE = {
  companyName: "농업회사법인 주식회사 씨엔푸드",
  businessNumber: "343-88-00695",
  representativeName: "유인식",
  mainPhone: "1522-8639",
  businessAddress: "경기도 화성시 송산면 송산포도로 575",
};

export type PrintableFieldSupplierMode = "DEFAULT_DUAL" | "EXPLICIT_BRANCH";

export const DEFAULT_FIELD_PRINT_SUPPLIERS = [
  {
    companyName: "주식회사 씨엔푸드 화성지점",
    businessNumber: "627-85-01397",
    representativeName: "유인식",
    mainPhone: "1522-8639",
    businessAddress: "경기도 화성시 송산면 송산포도로 575",
    sealUrl: SEAL_URL_1,
    includePhone: true,
  },
  {
    ...CNFOOD_BUSINESS_PROFILE,
    sealUrl: SEAL_URL_2,
    includePhone: false,
  },
] as const;

export const buildBusinessInfoFooterRows = (
  profile = CNFOOD_BUSINESS_PROFILE
) => [
  { label: "상호명", value: profile.companyName },
  { label: "사업자번호", value: profile.businessNumber },
  { label: "대표자명", value: profile.representativeName },
  { label: "대표번호", value: profile.mainPhone },
  { label: "사업장 주소", value: profile.businessAddress },
];

export const buildSupplierInfoSnapshot = (
  profile = CNFOOD_BUSINESS_PROFILE
) => ({
  companyName: profile.companyName,
  businessNumber: profile.businessNumber,
  representativeName: profile.representativeName,
  mainPhone: profile.mainPhone,
  businessAddress: profile.businessAddress,
});

export const buildContractCompanyBranchSnapshot = ({
  branch = null,
  fallbackProfile = CNFOOD_BUSINESS_PROFILE,
} = {}) => {
  const branchSnapshot = buildCompanyBranchSnapshot(branch || {});
  if (branchSnapshot) return branchSnapshot;
  return {
    id: "",
    branchName: fallbackProfile.companyName,
    corporationName: fallbackProfile.companyName,
    businessNumber: fallbackProfile.businessNumber,
    representativeName: fallbackProfile.representativeName,
    address: fallbackProfile.businessAddress,
  };
};

export type ValidationSettings = {
  enableBizNumberCheck: boolean;
  enablePhoneVerification: boolean;
  ntsBusinessVerification?: {
    enabled?: boolean;
    mode?: "REQUIRED" | "OPTIONAL" | "MANUAL_REVIEW" | "DISABLED";
    updatedAt?: string;
    updatedBy?: string;
  };
};

export type TextSizeMode = "MEDIUM" | "LARGE";

export const DEFAULT_VALIDATION_SETTINGS: ValidationSettings = {
  enableBizNumberCheck: true,
  enablePhoneVerification: true,
  ntsBusinessVerification: {
    enabled: true,
    mode: "MANUAL_REVIEW",
  },
};

export const VALIDATION_SETTINGS_STORAGE_KEY = "cnfood.validation.settings.v1";
export const TEXT_SIZE_MODE_STORAGE_KEY = "cnfood-text-size-mode";
export const NOTIFICATION_SETTINGS_DOC_ID = "notification_settings";
export const NOTIFICATION_EMAILS_CONFIG_DOC_ID = "notification_emails";
export const APP_STATUS_CONFIG_DOC_ID = "app_status";
export const CONTRACT_COMPLETION_EMAIL_NOTIFICATION_ENABLED = false;
// TODO: Re-enable contract completion email notification after production SMTP/KCP notification policy is finalized.
export const CREDIT_CHECK_COMPANY =
  "코리아크레딧뷰(주), 한국평가데이터(주) 등";

export type ContractAppStatusCode =
  | "OPEN"
  | "NOTICE_ONLY"
  | "START_PAUSED"
  | "FULL_PAUSED"
  | "ADMIN_TEST_ONLY";

export type ContractAppStatusAction = "START" | "KCP" | "SMS" | "SUBMIT";

export type ContractAppStatus = {
  status: ContractAppStatusCode;
  title: string;
  message: string;
  supportPhone: string;
  expectedResumeAt: string;
  updatedAt: string;
  updatedBy: string;
  reason: string;
  allowInProgressSubmit: boolean;
  showBanner: boolean;
};

export const CONTRACT_APP_STATUS_PRESETS: Record<
  ContractAppStatusCode,
  Omit<ContractAppStatus, "updatedAt" | "updatedBy" | "reason">
> = {
  OPEN: {
    status: "OPEN",
    title: "전자계약 작성 가능",
    message: "전자계약 서비스를 정상적으로 이용할 수 있습니다.",
    supportPhone: "010-9988-8639",
    expectedResumeAt: "",
    allowInProgressSubmit: true,
    showBanner: false,
  },
  NOTICE_ONLY: {
    status: "NOTICE_ONLY",
    title: "시스템 업데이트 안내",
    message:
      "전자계약 시스템 업데이트가 진행 중입니다. 계약 작성은 정상 이용 가능합니다.",
    supportPhone: "010-9988-8639",
    expectedResumeAt: "",
    allowInProgressSubmit: true,
    showBanner: true,
  },
  START_PAUSED: {
    status: "START_PAUSED",
    title: "전자계약 신규 작성 일시중단",
    message:
      "현재 시스템 업데이트로 인해 신규 전자계약 작성이 잠시 중단되어 있습니다. 이미 작성 중인 계약은 담당자 안내에 따라 진행해 주세요.",
    supportPhone: "010-9988-8639",
    expectedResumeAt: "",
    allowInProgressSubmit: true,
    showBanner: true,
  },
  FULL_PAUSED: {
    status: "FULL_PAUSED",
    title: "전자계약 작성 일시중단",
    message:
      "현재 시스템 점검으로 인해 전자계약 작성이 잠시 중단된 상태입니다. 안전한 계약 진행을 위해 점검 완료 후 다시 접속해 주세요.",
    supportPhone: "010-9988-8639",
    expectedResumeAt: "",
    allowInProgressSubmit: false,
    showBanner: true,
  },
  ADMIN_TEST_ONLY: {
    status: "ADMIN_TEST_ONLY",
    title: "전자계약 점검 중",
    message: "현재 관리자 확인을 위해 전자계약 작성이 잠시 제한되어 있습니다.",
    supportPhone: "010-9988-8639",
    expectedResumeAt: "",
    allowInProgressSubmit: false,
    showBanner: true,
  },
};

export const normalizeContractAppStatusCode = (
  status = ""
): ContractAppStatusCode =>
  status === "NOTICE_ONLY" ||
  status === "START_PAUSED" ||
  status === "FULL_PAUSED" ||
  status === "ADMIN_TEST_ONLY"
    ? status
    : "OPEN";

export const buildContractAppStatus = (
  input: Partial<ContractAppStatus> = {}
): ContractAppStatus => {
  const status = normalizeContractAppStatusCode(input.status);
  const preset = CONTRACT_APP_STATUS_PRESETS[status];
  return {
    ...preset,
    title: String(input.title || preset.title).trim(),
    message: String(input.message || preset.message).trim(),
    supportPhone: String(input.supportPhone || preset.supportPhone).trim(),
    expectedResumeAt: String(input.expectedResumeAt || "").trim(),
    updatedAt: String(input.updatedAt || "").trim(),
    updatedBy: String(input.updatedBy || "본사").trim(),
    reason: String(input.reason || "").trim(),
    allowInProgressSubmit:
      typeof input.allowInProgressSubmit === "boolean"
        ? input.allowInProgressSubmit
        : preset.allowInProgressSubmit,
    showBanner:
      typeof input.showBanner === "boolean" ? input.showBanner : preset.showBanner,
  };
};

export const getContractAppStatusPreset = (status: ContractAppStatusCode) =>
  buildContractAppStatus(CONTRACT_APP_STATUS_PRESETS[normalizeContractAppStatusCode(status)]);

export const shouldShowContractAppStatusBanner = (
  appStatus: Partial<ContractAppStatus> | null
) => {
  const status = buildContractAppStatus(appStatus || {});
  return status.status !== "OPEN" || status.showBanner === true;
};

export const getContractAppStatusDisplayName = (
  status: ContractAppStatusCode | string = "OPEN"
) =>
  ({
    OPEN: "정상 운영",
    NOTICE_ONLY: "업데이트 안내",
    START_PAUSED: "신규 작성 일시중단",
    FULL_PAUSED: "전체 작성 일시중단",
    ADMIN_TEST_ONLY: "관리자 테스트 모드",
  }[normalizeContractAppStatusCode(status)] || "정상 운영");

export const evaluateContractAppStatusAccess = ({
  appStatus = {},
  action = "START",
  step = 0,
  isAdmin = false,
  bypassPause = false,
}: {
  appStatus?: Partial<ContractAppStatus> | null;
  action?: ContractAppStatusAction;
  step?: number;
  isAdmin?: boolean;
  bypassPause?: boolean;
} = {}) => {
  const status = buildContractAppStatus(appStatus || {});
  const inProgress = Number(step || 0) > 0;
  const canBypassPause = Boolean(isAdmin && bypassPause);
  if (status.status === "ADMIN_TEST_ONLY" && !isAdmin) {
    return {
      allowed: false,
      code: "ADMIN_TEST_ONLY",
      message:
        status.message ||
        "현재 관리자 확인을 위해 전자계약 작성이 잠시 제한되어 있습니다.",
      appStatus: status,
    };
  }
  if (status.status === "FULL_PAUSED" && !canBypassPause) {
    return {
      allowed: false,
      code: "FULL_PAUSED",
      message:
        action === "SUBMIT"
          ? "현재 시스템 점검으로 최종 제출이 잠시 제한됩니다. 점검 후 다시 제출해 주세요."
          : status.message,
      appStatus: status,
    };
  }
  if (status.status === "START_PAUSED" && !canBypassPause) {
    if (action === "START") {
      return {
        allowed: false,
        code: "START_PAUSED",
        message: status.message,
        appStatus: status,
      };
    }
    if (action === "SUBMIT" && (!inProgress || status.allowInProgressSubmit === false)) {
      return {
        allowed: false,
        code: "START_PAUSED_SUBMIT_BLOCKED",
        message:
          "현재 시스템 업데이트로 최종 제출이 잠시 제한됩니다. 점검 후 다시 제출해 주세요.",
        appStatus: status,
      };
    }
  }
  return { allowed: true, code: "OPEN", message: "", appStatus: status };
};

export const APP_STATUS_LOADING_MESSAGE =
  "전자계약 운영 상태를 확인하고 있습니다. 잠시 후 다시 시도해 주세요.";

export const canStartNewContract = (
  appStatus: Partial<ContractAppStatus> | null = {},
  viewerContext: {
    isAdmin?: boolean;
    statusLoaded?: boolean;
    bypassPause?: boolean;
  } = {}
) => {
  const status = buildContractAppStatus(appStatus || {});
  if (viewerContext.statusLoaded === false) {
    return {
      allowed: false,
      code: "APP_STATUS_LOADING",
      message: APP_STATUS_LOADING_MESSAGE,
      appStatus: status,
    };
  }
  return evaluateContractAppStatusAccess({
    appStatus: status,
    action: "START",
    step: 0,
    isAdmin: Boolean(viewerContext.isAdmin),
    bypassPause: Boolean(viewerContext.bypassPause),
  });
};

export const canProceedCurrentContract = (
  appStatus: Partial<ContractAppStatus> | null = {},
  currentStep = 0,
  options: {
    action?: ContractAppStatusAction;
    isAdmin?: boolean;
    statusLoaded?: boolean;
    bypassPause?: boolean;
  } = {}
) => {
  const status = buildContractAppStatus(appStatus || {});
  if (options.statusLoaded === false) {
    return {
      allowed: false,
      code: "APP_STATUS_LOADING",
      message: APP_STATUS_LOADING_MESSAGE,
      appStatus: status,
    };
  }
  return evaluateContractAppStatusAccess({
    appStatus: status,
    action: options.action || "START",
    step: currentStep,
    isAdmin: Boolean(options.isAdmin),
    bypassPause: Boolean(options.bypassPause),
  });
};
export const CUSTOMER_TRUST_TYPOGRAPHY = {
  pageTitle: "text-2xl font-black leading-tight text-slate-900 break-keep",
  sectionTitle: "text-xl font-black leading-snug text-slate-900 break-keep",
  label: "text-base font-black text-slate-800 break-keep",
  input:
    "min-h-[56px] rounded-2xl px-4 py-4 text-lg font-semibold text-slate-900",
  primaryButton:
    "min-h-[56px] rounded-2xl px-4 py-3 text-base font-black",
  helpBox:
    "rounded-2xl border border-blue-100 bg-blue-50/70 px-4 py-3 text-[15px] font-bold leading-7 break-keep text-blue-900",
  prominentHelpBox:
    "rounded-2xl border border-blue-100 bg-blue-50/80 px-5 py-4 text-base font-bold leading-7 break-keep text-blue-900 shadow-sm",
  errorBox:
    "rounded-2xl border border-red-200 bg-red-50 px-4 py-4 text-base font-bold leading-7 text-red-700 break-keep",
} as const;

export const CNFOOD_SUPPORT_PHONE = "010-9988-8639";
export const INTRO_UPDATE_SUPPORT_TEXT = "씨엔푸드 메인콜센터 010-9988-8639";

type UpdateNote = {
  version: string;
  title: string;
  summary: string;
  items: string[];
};

const INTRO_UPDATE_HIGHLIGHTS = [
  "대표자 본인확인 및 서명 증빙 강화",
  "공동사업자/공동대표 작성 안내 보강",
  "계약 저장 중복 제출 방지",
  "작성 완료 및 접수 확인 안정성 개선",
];

const UPDATE_NOTES: UpdateNote[] = [
  {
    version: "v5",
    title: "계약 저장 안정성 강화",
    summary:
      "전자계약 작성 완료 시 동일 계약이 중복 저장되지 않도록 안정성을 강화했습니다.",
    items: [
      "최종 제출 버튼 중복 클릭 방지",
      "계약 저장 중 버튼 자동 비활성화",
      "저장 중 오류 발생 후 재시도 시 기존 계약 정보를 이어서 처리",
      "작성 완료 후 새 계약 작성 시 이전 계약 정보가 섞이지 않도록 개선",
    ],
  },
  {
    version: "v4",
    title: "작성 완료 및 접수 확인 안정화",
    summary: "계약 작성 완료 후 접수 확인 흐름을 보강했습니다.",
    items: [
      "계약 완료 상태 확인 강화",
      "저장 실패 또는 네트워크 오류 안내 개선",
      "완료 화면 진입 조건 안정화",
      "작성 완료 후 주요 계약 정보 확인 흐름 개선",
    ],
  },
  {
    version: "v3",
    title: "공동사업자 및 공동대표 안내 개선",
    summary:
      "공동사업자 또는 공동대표 형태의 거래처도 전자계약을 더 쉽게 진행할 수 있도록 안내를 보강했습니다.",
    items: [
      "공동사업자 작성 안내 추가",
      "계약 권한이 있는 대표자 기준 안내",
      "공동대표 확인 흐름 보강",
      "담당자 문의 안내 강화",
    ],
  },
  {
    version: "v2",
    title: "대표자 확인 및 서명 증빙 강화",
    summary:
      "더 안전한 계약 진행을 위해 대표자 본인확인과 서명 증빙 기능을 강화했습니다.",
    items: [
      "대표자 본인확인 강화",
      "사업자번호, 대표자명, 주민번호 앞자리, 휴대폰 번호 기준 확인",
      "본인확인 완료 후 주요 정보 잠금",
      "전자서명 증빙 정보 강화",
    ],
  },
  {
    version: "v1",
    title: "담당자별 계약 관리 기능 개선",
    summary:
      "씨엔푸드 내부 담당자가 거래처 계약 진행 상태를 더 정확히 확인할 수 있도록 운영 기능을 보강했습니다.",
    items: [
      "담당자별 계약 조회 기능",
      "계약 작성 현황 확인",
      "계약 상세 확인 기능",
      "오류 확인 및 운영 점검 기능 개선",
    ],
  },
  {
    version: "v0",
    title: "전자계약 기본 기능 오픈",
    summary:
      "거래처가 종이 계약서 없이 온라인으로 공급계약서를 작성하고 서명할 수 있도록 전자계약 기능을 오픈했습니다.",
    items: [
      "사업자 및 업체 정보 입력",
      "휴대폰 본인인증",
      "계약서 확인",
      "전자서명",
      "계약 완료 확인",
    ],
  },
];

export type HelpTopic =
  | "BUSINESS_NUMBER"
  | "REPRESENTATIVE_IDENTITY"
  | "SSN"
  | "OPENING_DATE"
  | "KCP_VERIFICATION"
  | "NTS_VERIFICATION"
  | "CO_REPRESENTATIVE"
  | "DIRECT_SIGNATURE"
  | "DELEGATED_SIGNATURE"
  | "PERSONAL_GUARANTEE"
  | "SIGNATURE_QUALITY"
  | "ADDRESS_SEARCH"
  | "PDF_DOWNLOAD"
  | "LEGACY_CONTRACTS";

export const HELP_TOPIC_CONTENT: Record<
  HelpTopic,
  {
    title: string;
    body: string;
    steps?: string[];
    warning?: string;
    supportPhone?: string;
  }
> = {
  BUSINESS_NUMBER: {
    title: "사업자번호",
    body:
      "사업자등록증에 표시된 사업자등록번호를 입력해 주세요. 숫자만 입력해도 자동으로 정리됩니다.",
    steps: ["사업자등록증의 10자리 번호를 확인해 주세요."],
    supportPhone: CNFOOD_SUPPORT_PHONE,
  },
  REPRESENTATIVE_IDENTITY: {
    title: "대표자 본인확인",
    body:
      "사업자등록증 기준 대표자명을 입력해 주세요. 본인확인 결과의 이름과 일치해야 합니다.",
    steps: [
      "대표자 본인 명의 휴대폰으로 인증해 주세요.",
      "가족, 직원, 점장 명의 휴대폰은 계약 진행이 제한될 수 있습니다.",
    ],
    supportPhone: CNFOOD_SUPPORT_PHONE,
  },
  SSN: {
    title: "주민번호 입력",
    body:
      "주민번호 앞 6자리는 생년월일 확인에 사용됩니다. 뒷자리는 미수채권 관리 및 법적 증빙 목적으로 암호화 보관되며, 일반 화면에는 표시되지 않습니다.",
    warning: "주민번호 전체는 일반 화면, 오류신고, 관리자 목록에 노출하지 않습니다.",
    supportPhone: CNFOOD_SUPPORT_PHONE,
  },
  OPENING_DATE: {
    title: "개업일자",
    body:
      "국세청 사업자 진위확인을 위해 필요합니다. 사업자등록증에 표시된 개업연월일을 입력해 주세요. 모를 경우 본사 확인이 필요할 수 있습니다.",
    steps: ["YYYY-MM-DD 형식 또는 숫자 8자리로 입력해 주세요."],
    supportPhone: CNFOOD_SUPPORT_PHONE,
  },
  KCP_VERIFICATION: {
    title: "KCP 본인확인",
    body:
      "대표자명, 주민번호 앞 6자리, 휴대폰번호가 KCP 본인확인 결과와 일치해야 계약서 확인 단계로 진행할 수 있습니다.",
    steps: [
      "대표자 본인 명의 휴대폰으로 인증해 주세요.",
      "인증창이 열리지 않으면 브라우저 팝업 차단을 허용한 뒤 다시 시도해 주세요.",
      "시간이 초과되면 본인확인 다시하기를 눌러 주세요.",
    ],
    supportPhone: CNFOOD_SUPPORT_PHONE,
  },
  NTS_VERIFICATION: {
    title: "국세청 진위확인",
    body:
      "사업자번호, 대표자명, 개업일자를 국세청 등록정보와 비교합니다. 불일치하거나 서버가 지연되면 본사 확인이 필요할 수 있습니다.",
    steps: ["사업자등록증 원본 기준으로 세 항목을 다시 확인해 주세요."],
    supportPhone: CNFOOD_SUPPORT_PHONE,
  },
  CO_REPRESENTATIVE: {
    title: "공동계약인",
    body:
      "사업자등록증 또는 법인등기부에 공동계약인이 기재되어 있다면 모든 공동계약인 정보를 빠짐없이 입력해 주세요.",
    warning:
      "공동계약인이 누락되면 계약 체결 권한 확인이 어려워질 수 있고, 추후 미수금 또는 법적 분쟁 대응 시 증빙이 부족해질 수 있습니다.",
    supportPhone: CNFOOD_SUPPORT_PHONE,
  },
  DIRECT_SIGNATURE: {
    title: "공동계약인 직접서명",
    body:
      "공동계약인이 함께 있는 경우 직접 서명하는 것이 가장 명확합니다. 본인확인 완료 후 공동계약인 본인이 직접 서명란에 성명을 작성해 주세요.",
    supportPhone: CNFOOD_SUPPORT_PHONE,
  },
  DELEGATED_SIGNATURE: {
    title: "대리서명 동의",
    body:
      "공동계약인이 현장에 없어 직접 서명하기 어려운 경우에만 사용합니다. 공동계약인 본인확인과 대리서명 동의 기록이 증빙으로 저장됩니다.",
    warning: "공동계약인 본인확인 없이 대리서명 동의만으로는 완료 처리할 수 없습니다.",
    supportPhone: CNFOOD_SUPPORT_PHONE,
  },
  PERSONAL_GUARANTEE: {
    title: "법인 공동계약 확인이란?",
    body:
      "법인 대표자 서명은 법인을 대표해 계약을 체결하는 서명입니다. 법인 공동계약 확인 서명은 계약 내용과 거래 책임 범위를 대표자가 추가로 확인하는 별도 서명입니다.",
    warning:
      "법인 대표자 서명과 공동계약 확인 서명은 법적 의미가 다를 수 있습니다. 내용을 확인한 뒤 동의해 주세요.",
    supportPhone: CNFOOD_SUPPORT_PHONE,
  },
  SIGNATURE_QUALITY: {
    title: "서명 품질검증",
    body:
      "본인의 성명을 정자로 작성해 주세요. 서명란의 흐린 이름은 안내용이며 실제 서명은 직접 작성해야 합니다.",
    warning: "점, 짧은 선, 너무 작은 낙서는 서명으로 인정되지 않을 수 있습니다.",
    supportPhone: CNFOOD_SUPPORT_PHONE,
  },
  ADDRESS_SEARCH: {
    title: "주소검색",
    body:
      "주소검색을 이용하면 정확한 주소 입력이 가능합니다. 공동계약인별 자택주소는 각 공동계약인 카드에 따로 입력해야 합니다.",
    steps: ["주소검색 창이 열리지 않으면 팝업 차단을 확인하거나 주소를 직접 입력해 주세요."],
    supportPhone: CNFOOD_SUPPORT_PHONE,
  },
  PDF_DOWNLOAD: {
    title: "PDF 다운로드",
    body:
      "계약 완료 후 고객 보관용 PDF를 내려받을 수 있습니다. PDF 생성이 실패하면 네트워크 상태를 확인한 뒤 다시 시도해 주세요.",
    supportPhone: CNFOOD_SUPPORT_PHONE,
  },
  LEGACY_CONTRACTS: {
    title: "기존계약 관리",
    body:
      "수기/ERP 계약은 전자서명·본인확인·Hash 증빙이 없는 기존 자료로 별도 관리됩니다.",
    warning: "이미지/PDF 업로드 문서는 민감정보가 포함될 수 있으므로 운영자 권한으로만 관리해 주세요.",
    supportPhone: CNFOOD_SUPPORT_PHONE,
  },
};

export const ERROR_HELP_GUIDES = {
  KCP_POPUP_BLOCKED: {
    title: "본인확인 창이 열리지 않았습니다.",
    message:
      "팝업 차단이 켜져 있거나 브라우저 보안 설정으로 인증창이 차단되었을 수 있습니다. 팝업 허용 후 다시 시도해 주세요.",
    cause: "브라우저 팝업 차단 또는 인증창 차단",
    actionSteps: [
      "브라우저 주소창의 팝업 차단 표시를 눌러 허용해 주세요.",
      "통신사 본인확인 다시 시도를 눌러 주세요.",
      "문제가 계속되면 오류신고를 눌러 주세요.",
    ],
    supportPhone: CNFOOD_SUPPORT_PHONE,
    reportButton: true,
  },
  KCP_IDENTITY_MISMATCH: {
    title: "대표자 본인확인이 일치하지 않습니다.",
    message:
      "입력한 대표자명, 주민번호 앞 6자리, 휴대폰번호가 본인확인 결과와 일치해야 합니다. 대표자 본인 명의 휴대폰으로 다시 인증해 주세요.",
    cause: "입력값과 KCP 본인확인 결과 불일치",
    actionSteps: [
      "입력한 대표자명과 휴대폰번호를 확인해 주세요.",
      "주민번호 앞 6자리 또는 생년월일을 확인해 주세요.",
      "본인 명의 휴대폰으로 인증해 주세요.",
      "문제가 계속되면 오류신고를 눌러 주세요.",
    ],
    supportPhone: CNFOOD_SUPPORT_PHONE,
    reportButton: true,
  },
  KCP_TIMEOUT: {
    title: "본인확인 시간이 초과되었습니다.",
    message:
      "인증 시간이 지나 다시 진행해야 합니다. 입력값을 확인한 뒤 본인확인 다시하기를 눌러 주세요.",
    cause: "KCP 본인확인 응답 지연 또는 인증 시간 초과",
    actionSteps: [
      "입력값을 확인한 뒤 본인확인 다시하기를 눌러 주세요.",
      "인증창을 닫았다면 새 인증창에서 다시 완료해 주세요.",
      "문제가 계속되면 오류신고를 눌러 주세요.",
    ],
    supportPhone: CNFOOD_SUPPORT_PHONE,
    reportButton: true,
  },
  CO_REPRESENTATIVE_KCP_REQUIRED: {
    title: "공동계약인 본인확인이 완료되지 않았습니다.",
    message:
      "공동계약인 본인 명의 휴대폰으로 본인확인을 완료해 주세요. 본인확인 정보가 입력한 공동계약인 정보와 일치해야 다음 단계로 진행할 수 있습니다.",
    cause: "공동계약인 본인확인 또는 서명 증빙 미완료",
    actionSteps: [
      "공동계약인 본인 명의 휴대폰번호를 확인해 주세요.",
      "공동계약인 본인이 직접 본인확인을 완료해 주세요.",
      "본인확인 후 계약 내용을 확인하고 전자서명을 진행해 주세요.",
    ],
    supportPhone: CNFOOD_SUPPORT_PHONE,
    reportButton: true,
  },
  NTS_VERIFICATION_FAILED: {
    title: "국세청 진위확인이 완료되지 않았습니다.",
    message:
      "사업자번호, 대표자명 또는 개업일자가 국세청 등록정보와 일치하지 않습니다.",
    cause: "사업자등록증 정보 불일치 또는 국세청 응답 지연",
    actionSteps: [
      "사업자등록증 기준 사업자번호와 대표자명을 확인해 주세요.",
      "개업일자를 YYYY-MM-DD 또는 숫자 8자리로 입력해 주세요.",
      "국세청 확인이 지연되면 본사 확인을 요청해 주세요.",
    ],
    supportPhone: CNFOOD_SUPPORT_PHONE,
    reportButton: true,
  },
  ADDRESS_SEARCH_FAILED: {
    title: "주소검색 창이 열리지 않았습니다.",
    message:
      "주소검색 창이 열리지 않았습니다. 브라우저 팝업 차단을 확인하거나 주소를 직접 입력해 주세요.",
    cause: "주소검색 스크립트 지연 또는 브라우저 차단",
    actionSteps: [
      "잠시 후 주소검색을 다시 눌러 주세요.",
      "팝업 차단이 켜져 있으면 허용해 주세요.",
      "계속 열리지 않으면 주소를 직접 입력해 주세요.",
    ],
    supportPhone: CNFOOD_SUPPORT_PHONE,
    reportButton: true,
  },
  PDF_DOWNLOAD_FAILED: {
    title: "PDF 생성에 문제가 발생했습니다.",
    message:
      "계약서 PDF를 생성하지 못했습니다. 네트워크 상태를 확인한 뒤 다시 시도해 주세요.",
    cause: "PDF 모듈 로딩 지연 또는 계약서 이미지 생성 실패",
    actionSteps: [
      "네트워크 연결을 확인해 주세요.",
      "잠시 후 PDF 다운로드를 다시 눌러 주세요.",
      "문제가 계속되면 오류신고를 눌러 주세요.",
    ],
    supportPhone: CNFOOD_SUPPORT_PHONE,
    reportButton: true,
  },
};

export const ADMIN_OPERATION_HELP = {
  CONTRACT_START:
    "관리자 테스트 작성, 거래처 작성 링크 발급, KCP/PASS 복귀 상태 점검을 한 곳에서 진행합니다. 거래처 대표자 또는 계약 권한이 있는 당사자가 직접 본인인증, 동의, 전자서명을 완료해야 합니다.",
  LIST:
    "계약 목록은 신규, 확정, 반려, 휴지통 상태를 빠르게 확인하는 운영 화면입니다. 상세 처리는 계약 상세에서 진행합니다.",
  DETAIL:
    "계약 상세는 완료본, 본인확인, 서명, 제출 기록을 확인하는 화면입니다. 기존 완료 계약의 finalSnapshot, contractHash, signatureHash는 변경하지 않습니다.",
  LEGAL_EVIDENCE:
    "법적 증빙자료는 계약 Hash, 본인확인, 서명, 제출 기록을 묶어 생성합니다. 민감정보 원문은 포함하지 않습니다.",
  BUSINESS_CORRECTION:
    "사업자 정보 정정은 상호명 표기 오류만 운영 메타데이터로 기록합니다. finalSnapshot, contractHash, signatureHash는 변경하지 않습니다.",
  CONTRACT_TEMPLATE:
    "새 조항은 새 계약부터 적용됩니다. 기존 완료 계약은 작성 당시 조항을 유지합니다.",
  LEGACY_CONTRACTS:
    "수기/ERP 계약은 전자서명·본인확인·Hash 증빙이 없는 기존 자료로 별도 관리됩니다.",
  TRASH_PURGE:
    "휴지통 비우기는 되돌릴 수 없습니다. 운영 환경에서는 별도 승인과 환경변수가 필요합니다.",
  SALES_SEARCH:
    "영업조회는 계약 작성 여부와 기본 현황을 민감정보 없이 기본정보로만 확인합니다.",
  VENDOR_MASTER:
    "거래처 마스터는 사업자번호 기준으로 전자계약, 수기계약, 담당자, 결제 준비 상태를 연결합니다. 계약 원본과 Hash 증빙은 변경하지 않습니다.",
  PAYMENT_MANAGEMENT:
    "결제관리는 거래처 마스터에서 대상을 선택해 문자링크, 키인 대기열, 등록카드 결제를 관리합니다. 거래처 ID·사업자번호·상호명만 결제요청에 연결하며 일회성 카드 원문은 Firestore와 운영 로그에 저장하지 않습니다.",
  STATS:
    "통합 현황은 전자공급계약서와 링크결제의 현재 상태를 읽기 전용으로 요약합니다. 지표 정의와 데이터 신뢰도 표기를 함께 확인해 주세요.",
  DB_BACKUP:
    "관리자가 필요한 시점에 현재 DB 상태를 백업하고, 선택한 백업에서 전체 또는 일부 데이터 묶음만 복원합니다. 복원은 선택한 문서만 되돌리며 현재 DB에만 있는 문서를 삭제하지 않습니다.",
  OPERATION_STATUS:
    "전자계약 운영 상태를 즉시 전환합니다. 장애 대응 중 신규 작성, 최종 제출, 안내 배너 노출을 조정할 수 있습니다.",
  REPORTS:
    "각종현황데이터는 영업사원, 알림, 검증 설정처럼 운영 중 문의 대응에 필요한 상태를 모아 보여줍니다.",
  DEBUG:
    "DEBUG 화면은 오류 로그 확인용입니다. CI/DI 원문, 주민번호 전체, KCP 암호문은 표시하지 않습니다.",
};

export const normalizeTextSizeMode = (value = ""): TextSizeMode =>
  value === "LARGE" ? "LARGE" : "MEDIUM";

export const loadTextSizeMode = (
  storage =
    typeof window !== "undefined" ? window.localStorage : undefined
): TextSizeMode => {
  try {
    return normalizeTextSizeMode(storage?.getItem(TEXT_SIZE_MODE_STORAGE_KEY) || "");
  } catch {
    return "MEDIUM";
  }
};

export const saveTextSizeMode = (
  mode: TextSizeMode,
  storage =
    typeof window !== "undefined" ? window.localStorage : undefined
): TextSizeMode => {
  const normalized = normalizeTextSizeMode(mode);
  try {
    storage?.setItem(TEXT_SIZE_MODE_STORAGE_KEY, normalized);
  } catch {
    // Text size is a display preference only; storage failures should not block contracts.
  }
  return normalized;
};

export const getTextSizeModeClassName = (mode: TextSizeMode = "MEDIUM") =>
  normalizeTextSizeMode(mode) === "LARGE"
    ? "cnfood-text-large"
    : "cnfood-text-medium";

const TEXT_SIZE_MODE_STYLE = `
  .cnfood-text-medium {
    --cnfood-readable-font-size: 1rem;
    --cnfood-control-font-size: 1rem;
  }
  .cnfood-text-large {
    --cnfood-readable-font-size: 1.125rem;
    --cnfood-control-font-size: 1.125rem;
  }
  .cnfood-text-large .cnfood-readable-text {
    font-size: var(--cnfood-readable-font-size);
    line-height: 1.75;
  }
  .cnfood-text-large label,
  .cnfood-text-large input:not([type="checkbox"]):not([type="radio"]),
  .cnfood-text-large select,
  .cnfood-text-large textarea,
  .cnfood-text-large button {
    font-size: var(--cnfood-control-font-size);
    line-height: 1.5;
  }
  .cnfood-text-large input:not([type="checkbox"]):not([type="radio"]),
  .cnfood-text-large select,
  .cnfood-text-large textarea {
    min-height: 56px;
  }
  .cnfood-text-large .cnfood-text-size-control button {
    min-height: 44px;
  }
`;

export type RequiredConsentKey =
  | "privacy-consent"
  | "credit-check-consent"
  | "collection-consent"
  | "contract-agreement"
  | "representative-personal-guarantee"
  | "contract-authority";

export type RequiredConsentItem = {
  key: RequiredConsentKey;
  checked: boolean;
  message?: string;
};

export const REQUIRED_CONSENT_ERROR_TITLE = "필수 동의가 필요합니다.";
export const REQUIRED_CONSENT_ERROR_MESSAGE =
  "이 항목에 동의해야 다음 단계로 진행할 수 있습니다. 체크박스를 눌러 동의해 주세요.";

export const getRequiredConsentProgress = (
  items: RequiredConsentItem[] = []
) => {
  const total = items.length;
  const completed = items.filter((item) => item.checked).length;
  return { completed, total, allCompleted: total > 0 && completed === total };
};

export const getFirstMissingRequiredConsent = (
  items: RequiredConsentItem[] = []
) => items.find((item) => !item.checked) || null;

const useButtonActivationPulse = (ready: boolean, durationMs = 900) => {
  const wasReadyRef = useRef(ready);
  const [shouldPulse, setShouldPulse] = useState(false);

  useEffect(() => {
    if (ready && !wasReadyRef.current) {
      setShouldPulse(true);
      const timeoutId = window.setTimeout(() => {
        setShouldPulse(false);
      }, durationMs);
      wasReadyRef.current = ready;
      return () => window.clearTimeout(timeoutId);
    }

    wasReadyRef.current = ready;
    if (!ready) {
      setShouldPulse(false);
    }
  }, [durationMs, ready]);

  return shouldPulse;
};

export type RepresentativeVerificationStatus =
  | "NOT_AVAILABLE"
  | "PENDING_KCP"
  | "MATCHED"
  | "MISMATCHED"
  | "PARTIAL"
  | "PENDING"
  | "FAILED";

export type CoRepresentativeCheckStatus =
  | "UNKNOWN"
  | "NOT_DETECTED"
  | "DETECTED"
  | "USER_DECLARED"
  | "NTS_NOT_SUPPORTED";

export type CoRepresentativeInfo = {
  status: CoRepresentativeCheckStatus;
  detectedAt?: string;
  source: "NTS" | "USER_INPUT" | "ADMIN" | "UNKNOWN";
  messageShown: boolean;
  additionalRepresentativeSignupRecommended: boolean;
};

export const CO_REPRESENTATIVE_NOTICE_TITLE = "공동계약인 확인 안내";
export const CO_REPRESENTATIVE_NOTICE_TEXT =
  "공동계약인 또는 공동사업자로 확인되었습니다. 다른 대표자에게도 전자계약 참여를 안내해 주세요.";
export const CO_REPRESENTATIVE_HELP_TEXT =
  "이 사업자는 공동계약인 또는 공동사업자일 수 있습니다. 계약 권한 확인을 위해 다른 대표자에게도 전자계약 참여를 안내해 주세요.";
export const CO_REPRESENTATIVE_DELEGATED_SIGNATURE_CONSENT_VERSION =
  "corep-delegated-signature-v1";
export const CO_REPRESENTATIVE_DELEGATED_SIGNATURE_CONSENT_TEXT =
  "본인은 위 사업자의 공동계약인로서 본인확인을 완료하였으며, 본 계약의 체결과 관련하여 주대표자가 본인의 공동계약인 서명란을 대리 작성 또는 표시하는 것에 동의합니다. 본 동의는 본 전자계약 체결 및 증빙 보존을 위한 목적으로 기록됩니다.";
export const CO_REPRESENTATIVE_SIGNATURE_MODE_DIRECT = "DIRECT_SIGNATURE";
export const CO_REPRESENTATIVE_SIGNATURE_MODE_DELEGATED =
  "DELEGATED_BY_PRINCIPAL";
export const CO_REPRESENTATIVE_DIRECT_SIGNATURE_LABEL = "공동계약인 직접서명";
export const CO_REPRESENTATIVE_LOCKED_FIELD_NAMES = new Set([
  "name",
  "birthDate",
  "ssnFront",
  "ssnBack",
  "phone",
  "homeAddress",
  "homeAddressDetail",
]);
export const CO_REPRESENTATIVE_REQUIRED_NOTICE_TITLE =
  "공동계약인 이름과 휴대폰번호만 입력해 주세요";
export const CO_REPRESENTATIVE_REQUIRED_NOTICE_LINES = [
  "주대표자 화면에서는 공동계약인 이름과 휴대폰번호만 입력합니다.",
  "공동계약인 주민번호, 자택주소, 본인확인과 전자서명은 공동계약인 본인이 별도 링크에서 직접 진행합니다.",
  "공동계약인 인증 요청 링크 발송만으로 본인확인 또는 CI/DI 보관 완료로 표시하지 않습니다.",
];
export const CO_REP_ADDRESS_SEARCH_VISIBLE_LABEL = "주소 검색";
export const CO_REP_FIELD_HELP = {
  name: "사업자등록증 또는 법인등기부에 기재된 공동계약인 성명을 정확히 입력해 주세요.",
  ssnFront: "주민번호 앞 6자리는 생년월일 확인에 사용됩니다. 예: 820210",
  ssnBack:
    "미수채권 관리 및 법적 증빙을 위해 암호화 보관됩니다. 화면에는 마스킹되어 표시됩니다.",
  phone:
    "해당 번호로 공동계약인 본인 명의 KCP 본인확인을 진행합니다. 공동계약인 본인 명의 휴대폰번호를 입력해 주세요.",
  homeAddress:
    "법인 공동계약인의 주소 확인 및 채권관리 증빙을 위해 입력합니다. 주민등록상 주소 기준으로 입력해 주세요.",
  homeAddressDetail: "동·호수, 건물명 등 상세주소가 있다면 입력해 주세요.",
};

export const createCoRepresentativeDraft = (overrides = {}) => ({
  id: createStableId("co_rep"),
  name: "",
  birthDate: "",
  ssnFront: "",
  ssnBack: "",
  phone: "",
  homeAddress: "",
  homeAddressDetail: "",
  memo: "",
  kcpSessionId: "",
  kcpStatus: "PENDING",
  identityStatus: "PENDING",
  identityVerification: null,
  ntsStatus: "NTS_NOT_SUPPORTED_OR_MANUAL_REVIEW",
  inviteToken: "",
  delegatedSignatureConsent: {
    agreed: false,
    agreedAt: null,
    consentTextVersion: CO_REPRESENTATIVE_DELEGATED_SIGNATURE_CONSENT_VERSION,
    consentText: CO_REPRESENTATIVE_DELEGATED_SIGNATURE_CONSENT_TEXT,
    principalSignerName: "",
  },
  signatureMode: CO_REPRESENTATIVE_SIGNATURE_MODE_DIRECT,
  signatureEvidence: null,
  signatureHash: "",
  signatureImageDataUrl: "",
  signatureStatus: "PENDING",
  signedAt: null,
  ...overrides,
});

export const createCoRepresentativeInfo = ({
  status = "UNKNOWN",
  detectedAt = "",
  source = "UNKNOWN",
  messageShown,
  additionalRepresentativeSignupRecommended,
}: Partial<CoRepresentativeInfo> = {}): CoRepresentativeInfo => {
  const shouldRecommend =
    status === "DETECTED" || status === "USER_DECLARED";
  return {
    status,
    ...(detectedAt ? { detectedAt } : {}),
    source,
    messageShown:
      typeof messageShown === "boolean" ? messageShown : shouldRecommend,
    additionalRepresentativeSignupRecommended:
      typeof additionalRepresentativeSignupRecommended === "boolean"
        ? additionalRepresentativeSignupRecommended
        : shouldRecommend,
  };
};

const normalizeCoRepresentativeSignal = (value: unknown) => {
  if (typeof value === "boolean") return value;
  if (typeof value === "number") return value > 1;
  const normalized = String(value ?? "").trim().toLowerCase();
  if (!normalized) return false;
  if (
    ["n", "no", "false", "0"].includes(normalized) ||
    ["없음", "미해당", "아님", "not_detected"].some((signal) =>
      normalized.includes(signal)
    )
  ) {
    return false;
  }
  return ["y", "yes", "true", "1", "detected", "공동", "있음", "해당"].some(
    (signal) => normalized.includes(signal)
  );
};

export const deriveCoRepresentativeInfoFromNtsBusinessStatus = (
  response: Record<string, unknown> = {},
  now = new Date().toISOString()
): CoRepresentativeInfo => {
  const records = Array.isArray(response?.data)
    ? (response.data as Array<Record<string, unknown>>)
    : [response];
  const record = records.find((item) => item && typeof item === "object") || {};
  const explicitKeys = [
    "co_representative_yn",
    "coRepresentativeYn",
    "coRepresentative",
    "joint_representative_yn",
    "jointRepresentativeYn",
    "joint_business_yn",
    "jointBusinessYn",
    "multi_representative_yn",
    "multiRepresentativeYn",
  ];

  for (const key of explicitKeys) {
    if (Object.prototype.hasOwnProperty.call(record, key)) {
      return createCoRepresentativeInfo({
        status: normalizeCoRepresentativeSignal(record[key])
          ? "DETECTED"
          : "NOT_DETECTED",
        source: "NTS",
        detectedAt: normalizeCoRepresentativeSignal(record[key]) ? now : "",
      });
    }
  }

  const representativeNames =
    record.representativeNames || record.representatives || record.rep_names;
  if (Array.isArray(representativeNames)) {
    return createCoRepresentativeInfo({
      status: representativeNames.length > 1 ? "DETECTED" : "NOT_DETECTED",
      source: "NTS",
      detectedAt: representativeNames.length > 1 ? now : "",
    });
  }

  const countValue =
    record.representative_count ||
    record.representativeCount ||
    record.rep_count ||
    record.repCount;
  if (countValue !== undefined && countValue !== null && countValue !== "") {
    const count = Number(countValue);
    return createCoRepresentativeInfo({
      status: Number.isFinite(count) && count > 1 ? "DETECTED" : "NOT_DETECTED",
      source: "NTS",
      detectedAt: Number.isFinite(count) && count > 1 ? now : "",
    });
  }

  return createCoRepresentativeInfo({
    status: "NTS_NOT_SUPPORTED",
    source: "NTS",
    messageShown: false,
    additionalRepresentativeSignupRecommended: false,
  });
};

export const resolveCoRepresentativeInfo = ({
  userDeclared = false,
  ntsInfo = null,
  now = new Date().toISOString(),
}: {
  userDeclared?: boolean;
  ntsInfo?: CoRepresentativeInfo | null;
  now?: string;
} = {}): CoRepresentativeInfo => {
  if (userDeclared) {
    return createCoRepresentativeInfo({
      status: "USER_DECLARED",
      source: "USER_INPUT",
      detectedAt: ntsInfo?.detectedAt || now,
    });
  }
  if (ntsInfo?.status) return createCoRepresentativeInfo(ntsInfo);
  return createCoRepresentativeInfo();
};

export const shouldShowCoRepresentativeGuidance = (
  info: CoRepresentativeInfo | null | undefined
) => info?.status === "DETECTED" || info?.status === "USER_DECLARED";

export const shouldShowCoRepresentativeSmsRequest = (source = null) => {
  const info =
    source?.coRepresentativeInfo ||
    source?.finalSnapshot?.coRepresentativeInfo ||
    source;
  return (
    info?.status === "DETECTED" ||
    info?.status === "USER_DECLARED" ||
    info?.additionalRepresentativeSignupRecommended === true ||
    source?.coRepresentativeDeclared === true
  );
};

export const maskHomeAddressForEvidence = (address = "") => {
  const value = String(address || "").trim().replace(/\s+/g, " ");
  if (!value) return null;
  const parts = value.split(" ");
  if (parts.length <= 1) return "****";
  return `${parts.slice(0, -1).join(" ")} ****`;
};

export const getCoRepresentativeFullHomeAddress = (representative = {}) =>
  [
    representative?.homeAddress,
    representative?.homeAddressDetail || representative?.addressDetail,
  ]
    .map((value) => String(value || "").trim())
    .filter(Boolean)
    .join(" ")
    .replace(/\s+/g, " ");

export const hasCompleteCoRepresentativeRequiredFields = (representative = {}) => {
  const name = normalizeRepresentativeNameForMatch(representative?.name || "");
  const birthDate = normalizeBirthDateForMatch(
    representative?.birthDate ||
      representative?.ssnFront ||
      representative?.birthDateMasked ||
      representative?.ssnMasked ||
      ""
  );
  const hasSsn =
    Boolean(representative?.ssnMasked) ||
    (birthDate &&
      String(representative?.ssnBack || "")
        .replace(/[^0-9]/g, "")
        .length === 7);
  const phone = representative?.phone || representative?.phoneMasked || "";
  const hasPhone =
    Boolean(representative?.phoneMasked) || isValidPhoneNumberFormat(phone);
  const homeAddress =
    representative?.homeAddressMasked ||
    getCoRepresentativeFullHomeAddress(representative);
  return Boolean(name && birthDate && hasSsn && hasPhone && homeAddress);
};

export const PRIMARY_CO_REP_SPLIT_FLOW_ENABLED = true;

export const CO_REP_WORKFLOW_STATUS = {
  NOT_REQUIRED: "NOT_REQUIRED",
  PENDING: "PENDING",
  PARTIAL: "PARTIAL",
  COMPLETED: "COMPLETED",
};

export const CO_REP_CONTRACT_STATUS_PENDING = "PENDING_CO_REP_VERIFICATION";

export const hasPrimaryCoRepresentativeContactFields = (representative = {}) => {
  const name = normalizeRepresentativeNameForMatch(representative?.name || "");
  const phone = representative?.phone || representative?.phoneMasked || "";
  const hasPhone =
    Boolean(representative?.phoneMasked) || isValidPhoneNumberFormat(phone);
  return Boolean(name && hasPhone);
};

export const hasAnyPrimaryCoRepresentativeContactInput = (
  representative = {}
) => {
  const name = normalizeRepresentativeNameForMatch(representative?.name || "");
  const phone = String(
    representative?.phone || representative?.phoneMasked || ""
  ).trim();
  return Boolean(name || phone);
};

export const normalizePrimaryCoRepresentativeContactRows = (
  representatives = []
) =>
  (Array.isArray(representatives) ? representatives : []).filter((item) =>
    hasAnyPrimaryCoRepresentativeContactInput(item)
  );

export const normalizePrimaryCoRepresentativeUiRows = ({
  declared = false,
  representatives = [],
} = {}) => {
  const source = Array.isArray(representatives) ? representatives : [];
  if (!declared) return source;
  const rowsWithInput = source.filter((item) =>
    hasAnyPrimaryCoRepresentativeContactInput(item)
  );
  return rowsWithInput.length > 0
    ? rowsWithInput
    : [createCoRepresentativeDraft()];
};

export const getPrimaryCoRepresentativeDisplayRows = ({
  declared = false,
  representatives = [],
} = {}) => {
  const source = Array.isArray(representatives)
    ? representatives.filter(Boolean)
    : [];
  return source;
};

const CONTACT_SNAPSHOT_ALLOWED_STATUS = new Set([
  "READY",
  "SENT",
  "DRAFT_OPENED",
  "OPENED",
  "EXPIRED",
  "PENDING",
  "MATCHED",
  "MISMATCHED",
  "FAILED",
  "SIGNED",
  "COMPLETED",
]);

const normalizeCoRepresentativeContactStatus = (
  value = "",
  fallback = "PENDING"
) => {
  const status = String(value || "").trim().toUpperCase();
  return CONTACT_SNAPSHOT_ALLOWED_STATUS.has(status) ? status : fallback;
};

export const buildCoRepresentativesContactSnapshot = ({
  declared = false,
  representatives = [],
} = {}) => {
  if (!declared) return [];
  const source = Array.isArray(representatives) ? representatives : [];
  return source
    .map((item, index) => {
      const name = normalizeRepresentativeNameForMatch(item?.name || "");
      const phone = String(item?.phone || "").trim();
      const phoneMasked =
        String(item?.phoneMasked || "").trim() || maskPhoneNumber(phone);
      if (!name && !phone && !phoneMasked) return null;
      return {
        id: String(item?.id || "").trim() || createStableId(`co_rep_${index + 1}`),
        name,
        phone,
        phoneMasked,
        inviteStatus: normalizeCoRepresentativeContactStatus(
          item?.inviteStatus,
          "READY"
        ),
        inviteTokenHash: item?.inviteTokenHash || "",
        inviteCreatedAt: item?.inviteCreatedAt || null,
        inviteSentAt: item?.inviteSentAt || null,
        openedAt: item?.openedAt || null,
        verificationStatus: normalizeCoRepresentativeContactStatus(
          item?.verificationStatus || item?.kcpStatus,
          "PENDING"
        ),
        signatureStatus: normalizeCoRepresentativeContactStatus(
          item?.signatureStatus,
          "PENDING"
        ),
        overallStatus: normalizeCoRepresentativeContactStatus(
          item?.overallStatus,
          "PENDING"
        ),
        verifiedAt: item?.verifiedAt || null,
        signedAt: item?.signedAt || null,
        completedAt: item?.completedAt || null,
      };
    })
    .filter(Boolean);
};

export const mergeCoRepresentativesContactSnapshot = ({
  current = [],
  snapshot = [],
} = {}) => {
  const currentList = Array.isArray(current) ? current : [];
  const snapshotList = Array.isArray(snapshot) ? snapshot.filter(Boolean) : [];
  if (snapshotList.length === 0) return currentList;

  const currentById = new Map(
    currentList
      .filter((item) => item?.id)
      .map((item) => [String(item.id), item])
  );
  const restoredIds = new Set();
  const restored = snapshotList.map((item, index) => {
    const id = String(item?.id || "").trim() || createStableId(`co_rep_${index + 1}`);
    restoredIds.add(id);
    const existing = currentById.get(id) || {};
    const phone = String(item?.phone || existing?.phone || "").trim();
    const phoneMasked =
      String(item?.phoneMasked || existing?.phoneMasked || "").trim() ||
      maskPhoneNumber(phone);
    return {
      ...existing,
      ...item,
      id,
      name: normalizeRepresentativeNameForMatch(
        item?.name || existing?.name || ""
      ),
      phone,
      phoneMasked,
      inviteStatus: normalizeCoRepresentativeContactStatus(
        item?.inviteStatus || existing?.inviteStatus,
        "READY"
      ),
      verificationStatus: normalizeCoRepresentativeContactStatus(
        item?.verificationStatus || existing?.verificationStatus,
        "PENDING"
      ),
      signatureStatus: normalizeCoRepresentativeContactStatus(
        item?.signatureStatus || existing?.signatureStatus,
        "PENDING"
      ),
      overallStatus: normalizeCoRepresentativeContactStatus(
        item?.overallStatus || existing?.overallStatus,
        "PENDING"
      ),
    };
  });

  currentList.forEach((item) => {
    if (
      (!item?.id || !restoredIds.has(String(item.id))) &&
      hasAnyPrimaryCoRepresentativeContactInput(item)
    ) {
      restored.push(item);
    }
  });
  return restored;
};

export const validatePrimaryCoRepresentativeContacts = ({
  declared = false,
  representatives = [],
} = {}) => {
  if (!declared) return { ok: true, message: "", step: null };
  const source = normalizePrimaryCoRepresentativeContactRows(representatives);
  if (source.length === 0) {
    return {
      ok: false,
      step: 0,
      message: "공동계약인이 있는 경우 공동계약인 이름과 휴대폰번호를 입력해 주세요.",
    };
  }
  const invalidIndex = source.findIndex(
    (item) => !hasPrimaryCoRepresentativeContactFields(item)
  );
  if (invalidIndex >= 0) {
    return {
      ok: false,
      step: 0,
      message: `공동계약인 ${invalidIndex + 1}의 이름과 휴대폰번호를 입력해 주세요.`,
    };
  }
  return { ok: true, message: "", step: null };
};

export const buildPrimaryCoRepresentativeRecords = ({
  declared = false,
  representatives = [],
  businessNumber = "",
} = {}) => {
  if (!declared) return [];
  return normalizePrimaryCoRepresentativeContactRows(representatives)
    .map((item, index) => {
      const name = normalizeRepresentativeNameForMatch(item?.name || "");
      const phoneMasked = item?.phoneMasked || maskPhoneNumber(item?.phone || "");
      if (!name && !phoneMasked) return null;
      const identityMatched = isCoRepresentativeIdentityMatched(item);
      const signatureCompleted = hasCoRepresentativeSignatureCompletion(item);
      const overallCompleted = identityMatched && signatureCompleted;
      return {
        id: item?.id || createStableId(`co_rep_${index + 1}`),
        name,
        phoneMasked,
        businessNumber: String(businessNumber || "").trim(),
        inviteTokenHash: item?.inviteTokenHash || "",
        inviteCreatedAt: item?.inviteCreatedAt || null,
        inviteStatus: item?.inviteStatus || "READY",
        verificationStatus: identityMatched
          ? "MATCHED"
          : item?.verificationStatus || item?.kcpStatus || "PENDING",
        signatureStatus: signatureCompleted
          ? "SIGNED"
          : item?.signatureStatus || "PENDING",
        overallStatus: overallCompleted ? "COMPLETED" : "PENDING",
        identityVerification: item?.identityVerification || null,
        hasCi: hasCoRepresentativeIdentityEvidenceStored(item),
        hasDi: hasCoRepresentativeIdentityEvidenceStored(item),
        verifiedAt: item?.verifiedAt || item?.identityVerification?.verifiedAt || null,
        signedAt: item?.signedAt || item?.signatureEvidence?.signedAt || null,
      };
    })
    .filter(Boolean);
};

export const buildCoRepresentativeWorkflow = ({
  required = false,
  representatives = [],
  updatedAt = "",
} = {}) => {
  if (!required) {
    return {
      required: false,
      status: CO_REP_WORKFLOW_STATUS.NOT_REQUIRED,
      totalCount: 0,
      completedCount: 0,
      pendingCount: 0,
      updatedAt: updatedAt || null,
    };
  }
  const source = Array.isArray(representatives) ? representatives : [];
  const completedCount = source.filter(
    (item) =>
      item?.overallStatus === "COMPLETED" ||
      (item?.verificationStatus === "MATCHED" && item?.signatureStatus === "SIGNED")
  ).length;
  const totalCount = source.length;
  const pendingCount = Math.max(totalCount - completedCount, 0);
  const status =
    totalCount === 0 || completedCount === 0
      ? CO_REP_WORKFLOW_STATUS.PENDING
      : completedCount >= totalCount
      ? CO_REP_WORKFLOW_STATUS.COMPLETED
      : CO_REP_WORKFLOW_STATUS.PARTIAL;
  return {
    required: true,
    status,
    totalCount,
    completedCount,
    pendingCount,
    updatedAt: updatedAt || null,
  };
};

export const deriveContractDisplayStatus = (contract = {}) => {
  const workflow =
    contract?.coRepresentativeWorkflow ||
    buildCoRepresentativeWorkflow({
      required:
        contract?.coRepresentativeDeclared === true ||
        String(contract?.contractStatus || "").includes("CO_REP"),
      representatives: contract?.coRepresentatives || [],
    });
  if (workflow.required) {
    if (workflow.status === CO_REP_WORKFLOW_STATUS.PENDING) {
      return "공동계약인 인증 대기중";
    }
    if (workflow.status === CO_REP_WORKFLOW_STATUS.PARTIAL) {
      return "공동계약인 일부 완료";
    }
    if (workflow.status === CO_REP_WORKFLOW_STATUS.COMPLETED) {
      return "작성완료";
    }
  }
  const status = getAdminContractStatusKey(contract);
  if (status === "confirmed") return "확정";
  if (status === "rejected") return "반려";
  if (status === "deleted") return "휴지통";
  return "작성완료";
};

export const hasCoRepresentativeIdentityEvidenceStored = (representative = {}) => {
  const verification = representative?.identityVerification || representative || {};
  const kcpSnapshot = verification?.kcpSnapshot || {};
  const hasCi = Boolean(
    verification?.hasCi ||
      verification?.ciHash ||
      verification?.ciHmac ||
      kcpSnapshot?.ciHash ||
      kcpSnapshot?.ciHmac
  );
  const hasDi = Boolean(
    verification?.hasDi ||
      verification?.diHash ||
      verification?.diHmac ||
      kcpSnapshot?.diHash ||
      kcpSnapshot?.diHmac
  );
  return hasCi && hasDi;
};

const normalizeCoRepresentativeSignatureValidation = (validation = {}) => ({
  valid: validation?.valid === true,
  ...(validation?.reason ? { reason: validation.reason } : {}),
  inkPixels: Number(validation?.inkPixels || 0),
  boundingWidth: Number(validation?.boundingWidth || 0),
  boundingHeight: Number(validation?.boundingHeight || 0),
  inkRatio: Number(validation?.inkRatio || 0),
});

export const getCoRepresentativeSignatureMode = (representative = {}) => {
  const mode = String(representative?.signatureMode || "");
  if (mode === CO_REPRESENTATIVE_SIGNATURE_MODE_DELEGATED) {
    return CO_REPRESENTATIVE_SIGNATURE_MODE_DELEGATED;
  }
  if (mode === CO_REPRESENTATIVE_SIGNATURE_MODE_DIRECT) {
    return CO_REPRESENTATIVE_SIGNATURE_MODE_DIRECT;
  }
  if (
    representative?.signatureStatus === "DELEGATED_BY_PRINCIPAL" ||
    representative?.delegatedSignatureConsent?.agreed === true
  ) {
    return CO_REPRESENTATIVE_SIGNATURE_MODE_DELEGATED;
  }
  return CO_REPRESENTATIVE_SIGNATURE_MODE_DIRECT;
};

export const sanitizeCoRepresentativeDirectSignatureEvidence = (
  representative = {}
) => {
  const rawEvidence = representative?.signatureEvidence || null;
  const evidence = rawEvidence || {};
  const signatureHash =
    evidence?.signatureHash ||
    evidence?.imageHash ||
    representative?.signatureHash ||
    null;
  const valid = evidence?.valid === true && Boolean(signatureHash);
  if (!rawEvidence && !signatureHash) return null;
  return {
    role: "CO_REPRESENTATIVE_DIRECT",
    label:
      evidence?.label ||
      representative?.signatureLabel ||
      CO_REPRESENTATIVE_DIRECT_SIGNATURE_LABEL,
    signerName: normalizeRepresentativeNameForMatch(
      evidence?.signerName || representative?.name || ""
    ),
    valid,
    validation: normalizeCoRepresentativeSignatureValidation(
      evidence?.validation || representative?.signatureValidation || {}
    ),
    signatureHash,
    signedAt: evidence?.signedAt || representative?.signedAt || null,
  };
};

export const hasCoRepresentativeDirectSignatureEvidence = (
  representative = {}
) => {
  const evidence = sanitizeCoRepresentativeDirectSignatureEvidence(representative);
  return (
    getCoRepresentativeSignatureMode(representative) ===
      CO_REPRESENTATIVE_SIGNATURE_MODE_DIRECT &&
    evidence?.valid === true &&
    Boolean(evidence?.signatureHash)
  );
};

export const getCoRepresentativeStatusBadges = (
  representative = {},
  { kcpInProgress = false } = {}
) => {
  const matched = isCoRepresentativeIdentityMatched(representative);
  const signatureMode = getCoRepresentativeSignatureMode(representative);
  const consented = hasCoRepresentativeDelegatedSignatureConsent(representative);
  const directSigned = hasCoRepresentativeDirectSignatureEvidence(representative);
  const evidenceStored = hasCoRepresentativeIdentityEvidenceStored(representative);
  if (isIdentityTestSimulation(representative?.identityVerification)) {
    return [
      { label: "TEST MODE", tone: "amber" },
      { label: "실제 KCP 대기", tone: "slate" },
    ];
  }
  const kcpStatus = String(
    representative?.kcpStatus ||
      representative?.identityVerification?.status ||
      representative?.identityStatus ||
      "PENDING"
  );
  if (kcpInProgress || kcpStatus === "VERIFYING" || kcpStatus === "REGISTERED") {
    return [{ label: "KCP 인증 진행 중", tone: "blue" }];
  }
  if (
    ["MISMATCHED", "FAILED"].includes(kcpStatus) ||
    ["MISMATCHED", "FAILED"].includes(String(representative?.identityStatus || ""))
  ) {
    return [
      { label: "본인확인 불일치", tone: "red" },
      { label: "재인증 필요", tone: "amber" },
    ];
  }
  if (matched) {
    return [
      { label: "본인확인 완료", tone: "emerald" },
      {
        label: evidenceStored ? "CI/DI 보관됨" : "CI/DI 확인 필요",
        tone: evidenceStored ? "emerald" : "amber",
      },
      ...(signatureMode === CO_REPRESENTATIVE_SIGNATURE_MODE_DIRECT
        ? directSigned
          ? [{ label: "공동계약인 직접서명 완료", tone: "emerald" }]
          : [{ label: "공동계약인 직접서명 대기", tone: "amber" }]
        : consented
        ? [{ label: "대리서명 동의 완료", tone: "emerald" }]
        : [{ label: "대리서명 동의 대기", tone: "amber" }]),
    ];
  }
  if (hasCompleteCoRepresentativeRequiredFields(representative)) {
    return [{ label: "본인확인 대기", tone: "slate" }];
  }
  return [{ label: "입력 필요", tone: "amber" }];
};

const getCoRepresentativeBadgeClass = (tone = "slate") => {
  if (tone === "emerald") {
    return "border-emerald-200 bg-emerald-50 text-emerald-800";
  }
  if (tone === "red") {
    return "border-red-200 bg-red-50 text-red-700";
  }
  if (tone === "amber") {
    return "border-amber-200 bg-amber-50 text-amber-800";
  }
  if (tone === "blue") {
    return "border-blue-200 bg-blue-50 text-blue-800";
  }
  return "border-slate-200 bg-slate-50 text-slate-700";
};

export const sanitizeNumericInput = (value = "", maxLength = 0) => {
  const cleaned = String(value || "").replace(/[^0-9]/g, "");
  const limit = Number(maxLength || 0);
  return Number.isFinite(limit) && limit > 0 ? cleaned.slice(0, limit) : cleaned;
};

const normalizeResidentRegistrationDigits = (front = "", back = "") => {
  const safeFront = sanitizeNumericInput(front, 6);
  const safeBack = sanitizeNumericInput(back, 7);
  return safeFront.length === 6 && safeBack.length === 7
    ? `${safeFront}${safeBack}`
    : "";
};

export const buildCoRepresentativeResidentNumberPatch = (
  field = "ssnFront",
  value = ""
) => {
  if (field === "ssnBack") {
    return { ssnBack: sanitizeNumericInput(value, 7) };
  }
  const ssnFront = sanitizeNumericInput(value, 6);
  return { ssnFront, birthDate: ssnFront };
};

export const buildResidentNumberSecurityEvidence = async ({
  ssnFront = "",
  ssnBack = "",
  encryptedValue = null,
  hmacSecret =
    process.env.REACT_APP_SSN_HMAC_KEY ||
    process.env.REACT_APP_SSN_ENCRYPT_KEY ||
    "cnfood-local-ssn-hmac-fallback",
}: {
  ssnFront?: string;
  ssnBack?: string;
  encryptedValue?: string | null;
  hmacSecret?: string;
} = {}) => {
  const residentDigits = normalizeResidentRegistrationDigits(ssnFront, ssnBack);
  const safeFront = residentDigits.slice(0, 6);
  const ssnHash = residentDigits
    ? await createSha256Hash(`cnfood-ssn-hash-v1:${residentDigits}`)
    : null;
  const ssnHmac = residentDigits
    ? await createSha256Hash(
        `cnfood-ssn-hmac-v1:${String(hmacSecret || "")}:${residentDigits}`
      )
    : null;

  return {
    ssnEncrypted: encryptedValue || null,
    ssnMasked: safeFront ? maskResidentRegistrationNumber(safeFront) : null,
    ssnHash,
    ssnHmac,
  };
};

export const buildDelegatedSignatureConsent = ({
  agreed = false,
  agreedAt = "",
  principalSignerName = "",
  consentText = CO_REPRESENTATIVE_DELEGATED_SIGNATURE_CONSENT_TEXT,
} = {}) => ({
  agreed: agreed === true,
  agreedAt: agreed ? agreedAt || new Date().toISOString() : null,
  consentTextVersion: CO_REPRESENTATIVE_DELEGATED_SIGNATURE_CONSENT_VERSION,
  consentText,
  principalSignerName: normalizeRepresentativeNameForMatch(principalSignerName || ""),
});

export const buildCoRepresentativeIdentityVerification = ({
  input = {},
  kcp = {},
  coRepresentativeId = "",
  verifiedAt = new Date().toISOString(),
} = {}) => ({
  ...buildRepresentativeIdentityVerification({
    subjectType: "CO_REP",
    input: {
      representativeName: input.name || input.representativeName || "",
      birthDate: input.birthDate || input.ssnFront || input.principalRepSsnFront || "",
      principalRepSsnFront: input.ssnFront || input.principalRepSsnFront || "",
      principalRepSsnBack: input.ssnBack || input.principalRepSsnBack || "",
      phone: input.phone || input.representativePhone || "",
      businessNumber: input.businessNumber || "",
    },
    kcp,
    verifiedAt,
  }),
  coRepresentativeId: String(coRepresentativeId || input.id || ""),
});

export const isCoRepresentativeIdentityMatched = (representative = {}) => {
  const verification = representative.identityVerification || representative;
  return (
    verification?.provider === "KCP" &&
    verification?.status === "MATCHED" &&
    verification?.checks?.nameMatched === true &&
    verification?.checks?.birthDateMatched === true &&
    verification?.checks?.phoneMatched === true &&
    (representative.kcpStatus || verification.status) === "MATCHED"
  );
};

export const hasCoRepresentativeDelegatedSignatureConsent = (
  representative = {}
) =>
  getCoRepresentativeSignatureMode(representative) ===
    CO_REPRESENTATIVE_SIGNATURE_MODE_DELEGATED &&
  (representative.delegatedSignatureConsent?.agreed === true &&
    Boolean(representative.delegatedSignatureConsent?.agreedAt));

export const hasCoRepresentativeSignatureCompletion = (representative = {}) =>
  getCoRepresentativeSignatureMode(representative) ===
  CO_REPRESENTATIVE_SIGNATURE_MODE_DIRECT
    ? hasCoRepresentativeDirectSignatureEvidence(representative)
    : hasCoRepresentativeDelegatedSignatureConsent(representative);

export const buildCoRepresentativeSigningRecords = ({
  declared = false,
  representatives = [],
  businessNumber = "",
} = {}) => {
  if (!declared) return [];
  return (Array.isArray(representatives) ? representatives : [])
    .map((item, index) => {
      const name = normalizeRepresentativeNameForMatch(item?.name || "");
      const birthDateMasked = normalizeBirthDateForMatch(
        item?.birthDate || item?.ssnFront || item?.birthDateMasked || item?.ssnMasked || ""
      );
      const ssnMasked =
        item?.ssnMasked || maskResidentRegistrationNumber(item?.ssnFront || "");
      const phoneMasked = item?.phoneMasked || maskPhoneNumber(item?.phone || "");
      const fullHomeAddress = getCoRepresentativeFullHomeAddress(item);
      const homeAddressMasked =
        item?.homeAddressMasked || maskHomeAddressForEvidence(fullHomeAddress);
      if (!name && !birthDateMasked && !phoneMasked && !ssnMasked) return null;
      const identityVerification = item?.identityVerification || null;
      const kcpStatus =
        item?.kcpStatus || identityVerification?.status || item?.identityStatus || "PENDING";
      const delegatedSignatureConsent = buildDelegatedSignatureConsent({
        ...(item?.delegatedSignatureConsent || {}),
        principalSignerName:
          item?.delegatedSignatureConsent?.principalSignerName ||
          item?.principalSignerName ||
          "",
      });
      const signatureMode = getCoRepresentativeSignatureMode(item);
      const directSignatureEvidence =
        signatureMode === CO_REPRESENTATIVE_SIGNATURE_MODE_DIRECT
          ? sanitizeCoRepresentativeDirectSignatureEvidence(item)
          : null;
      const signatureStatus =
        signatureMode === CO_REPRESENTATIVE_SIGNATURE_MODE_DIRECT
          ? directSignatureEvidence?.valid
            ? "SIGNED_DIRECTLY"
            : item?.signatureStatus || "PENDING"
          : delegatedSignatureConsent.agreed
          ? "DELEGATED_BY_PRINCIPAL"
          : item?.signatureStatus || "PENDING";
      return {
        id: item?.id || createStableId(`co_rep_${index + 1}`),
        name,
        birthDateMasked,
        ssnMasked,
        ssnEncrypted: item?.ssnEncrypted || null,
        ssnHash: item?.ssnHash || null,
        ssnHmac: item?.ssnHmac || null,
        phoneMasked,
        homeAddressEncrypted: item?.homeAddressEncrypted || null,
        homeAddressMasked,
        homeAddressDetailMasked: item?.homeAddressDetail
          ? maskHomeAddressForEvidence(item.homeAddressDetail)
          : null,
        memo: String(item?.memo || "").trim(),
        businessNumber: String(businessNumber || "").trim(),
        kcpSessionId: item?.kcpSessionId || "",
        kcpStatus,
        identityStatus:
          item?.identityStatus ||
          (kcpStatus === "MATCHED" ? "VERIFIED" : "PENDING"),
        identityVerification,
        ntsStatus: item?.ntsStatus || "NTS_NOT_SUPPORTED_OR_MANUAL_REVIEW",
        inviteTokenHash: item?.inviteTokenHash || "",
        inviteCreatedAt: item?.inviteCreatedAt || null,
        inviteStatus: item?.inviteStatus || "READY",
        signatureMode,
        delegatedSignatureConsent:
          signatureMode === CO_REPRESENTATIVE_SIGNATURE_MODE_DELEGATED
            ? delegatedSignatureConsent
            : null,
        signatureEvidence: directSignatureEvidence,
        signatureHash: directSignatureEvidence?.signatureHash || null,
        signatureStatus,
        signedAt:
          directSignatureEvidence?.signedAt ||
          item?.signedAt ||
          delegatedSignatureConsent.agreedAt ||
          null,
      };
    })
    .filter(Boolean);
};

export const buildSecureCoRepresentativeEvidenceRecords = async ({
  declared = false,
  representatives = [],
  businessNumber = "",
  inviteToken = "",
  principalSignerName = "",
  encryptValue,
}: {
  declared?: boolean;
  representatives?: Array<Record<string, unknown>>;
  businessNumber?: string;
  inviteToken?: string;
  principalSignerName?: string;
  encryptValue?: (value: string) => Promise<string>;
} = {}) => {
  if (!declared) return [];
  const source = Array.isArray(representatives) ? representatives : [];
  const enrichedRepresentatives = await Promise.all(
    source.map(async (item) => {
      const ssnFront = String(item?.ssnFront || item?.birthDate || "").replace(
        /[^0-9]/g,
        ""
      );
      const ssnBack = String(item?.ssnBack || "").replace(/[^0-9]/g, "");
      const hasCompleteResidentNumber =
        ssnFront.length === 6 && ssnBack.length === 7;
      const ssnEncrypted =
        item?.ssnEncrypted ||
        (hasCompleteResidentNumber && encryptValue
          ? await encryptValue(`${ssnFront}|${ssnBack}`)
          : null);
      const ssnEvidence = hasCompleteResidentNumber
        ? await buildResidentNumberSecurityEvidence({
            ssnFront,
            ssnBack,
            encryptedValue: ssnEncrypted as string | null,
          })
        : {
            ssnEncrypted: ssnEncrypted || null,
            ssnMasked: ssnFront ? maskResidentRegistrationNumber(ssnFront) : null,
            ssnHash: item?.ssnHash || null,
            ssnHmac: item?.ssnHmac || null,
          };
      const homeAddress = getCoRepresentativeFullHomeAddress(item);
      const homeAddressEncrypted =
        item?.homeAddressEncrypted ||
        (homeAddress && encryptValue ? await encryptValue(homeAddress) : null);

      return {
        ...item,
        ssnEncrypted: ssnEvidence.ssnEncrypted,
        ssnMasked: ssnEvidence.ssnMasked,
        ssnHash: ssnEvidence.ssnHash,
        ssnHmac: ssnEvidence.ssnHmac,
        homeAddressEncrypted,
        homeAddressMasked:
          item?.homeAddressMasked || maskHomeAddressForEvidence(homeAddress),
        delegatedSignatureConsent: {
          ...(item?.delegatedSignatureConsent || {}),
          principalSignerName:
            item?.delegatedSignatureConsent?.principalSignerName ||
            principalSignerName,
        },
      };
    })
  );

  return buildCoRepresentativeSigningRecords({
    declared,
    representatives: enrichedRepresentatives,
    businessNumber,
    inviteToken,
  });
};

export const buildCoRepresentativeSmsMessage = ({
  businessName = "",
  representativeName = "",
  requestLink = "",
} = {}) => {
  const safeRequestLink = String(requestLink || "").trim();
  return [
    "씨엔푸드 전자계약 공동계약인 확인이 필요합니다.",
    "아래 링크로 접속하여 계약 내용을 확인하고 본인확인 및 전자서명을 진행해 주세요.",
    "소요시간은 약 1~2분입니다.",
    "",
    safeRequestLink,
    "",
    `문의: 씨엔푸드 메인콜센터 ${CNFOOD_SUPPORT_PHONE}`,
  ].join("\n");
};

export const buildSmsHref = (phone = "", message = "") => {
  const digits = normalizePhoneDigits(phone);
  const encodedMessage = encodeURIComponent(String(message || ""));
  return `sms:${digits}?body=${encodedMessage}`;
};

export const buildRepresentativeIdentityRequestMessage = ({
  requestLink = "",
} = {}) =>
  [
    REPRESENTATIVE_IDENTITY_REQUEST_SMS_MESSAGE,
    "",
    String(requestLink || "").trim(),
    "",
    "인증은 발송자가 완료 처리하지 않습니다. 대표자 본인이 직접 완료해야 합니다.",
    "문의: 씨엔푸드 메인콜센터 010-9988-8639",
  ].join("\n");

export const buildCoRepresentativeRequestLink = ({
  activeInvite = null,
  inviteToken = "",
  origin = "",
  currentHref = "",
} = {}) => {
  const defaultOrigin = "https://cn-food-contract.vercel.app";
  const getAbsoluteUrl = (value = "") => {
    const raw = String(value || "").trim();
    if (!raw) return "";
    try {
      return new URL(raw).toString();
    } catch {
      const originForRelative = String(origin || defaultOrigin).replace(/\/$/, "");
      try {
        return new URL(raw, `${originForRelative}/`).toString();
      } catch {
        return "";
      }
    }
  };
  const explicitLink =
    activeInvite?.inviteUrl || activeInvite?.url || activeInvite?.link || "";
  const absoluteExplicitLink = getAbsoluteUrl(explicitLink);
  if (absoluteExplicitLink) return absoluteExplicitLink;

  const token =
    activeInvite?.token ||
    activeInvite?.inviteToken ||
    inviteToken ||
    "";
  const baseUrl =
    String(origin || "").replace(/\/$/, "") ||
    getAbsoluteUrl(currentHref).replace(/[?#].*$/, "") ||
    defaultOrigin;
  const baseUrlForInvite = /^https?:\/\/[^/]+$/i.test(baseUrl)
    ? `${baseUrl}/`
    : baseUrl;
  if (token && baseUrlForInvite) return buildInviteUrl(baseUrlForInvite, token);
  return getAbsoluteUrl(baseUrl) || defaultOrigin;
};

export const buildCorepInviteUrl = ({
  token = "",
  origin = "",
}: {
  token?: string;
  origin?: string;
} = {}) => {
  const safeToken = String(token || "").trim();
  const defaultOrigin = "https://cn-food-contract.vercel.app/";
  const base = String(origin || defaultOrigin).trim() || defaultOrigin;
  const url = (() => {
    try {
      return new URL(base);
    } catch {
      return new URL(defaultOrigin);
    }
  })();
  url.searchParams.delete("invite");
  url.searchParams.delete("testToken");
  url.searchParams.set("corepInvite", safeToken);
  return url.toString();
};

export const buildCorepSignatureOnlyInviteUrl = ({
  token = "",
  origin = "",
}: {
  token?: string;
  origin?: string;
} = {}) => {
  const url = new URL(buildCorepInviteUrl({ token, origin }));
  url.searchParams.set("corepSignatureOnly", "1");
  return url.toString();
};

export const getCorepSignatureOnlyFromUrl = (search = "") => {
  const source =
    search ||
    (typeof window !== "undefined" ? window.location.search || "" : "");
  try {
    return new URLSearchParams(source).get("corepSignatureOnly") === "1";
  } catch {
    return false;
  }
};

export const getCorepInviteTokenFromUrl = (search = "") => {
  const source =
    search ||
    (typeof window !== "undefined" ? window.location.search || "" : "");
  try {
    return new URLSearchParams(source).get("corepInvite") || "";
  } catch {
    return "";
  }
};

export const createCorepInviteToken = () => {
  const bytes = new Uint8Array(32);
  if (typeof window !== "undefined" && window.crypto?.getRandomValues) {
    window.crypto.getRandomValues(bytes);
  } else {
    for (let index = 0; index < bytes.length; index += 1) {
      bytes[index] = Math.floor(Math.random() * 256);
    }
  }
  return Array.from(bytes)
    .map((item) => item.toString(16).padStart(2, "0"))
    .join("");
};

export const buildCoRepresentativeInviteLinkRecords = async ({
  representatives = [],
  origin = "",
  now = "",
}: {
  representatives?: Array<Record<string, unknown>>;
  origin?: string;
  now?: string;
} = {}) => {
  const createdAt = now || new Date().toISOString();
  const links: Array<Record<string, string>> = [];
  const records = await Promise.all(
    (Array.isArray(representatives) ? representatives : []).map(async (item) => {
      if (item?.overallStatus === "COMPLETED" && item?.inviteTokenHash) {
        return item;
      }
      const token = createCorepInviteToken();
      const inviteTokenHash = await createSha256Hash(token);
      const inviteUrl = buildCorepInviteUrl({ token, origin });
      links.push({
        coRepresentativeId: String(item?.id || ""),
        name: String(item?.name || ""),
        phoneMasked: String(item?.phoneMasked || ""),
        inviteUrl,
        token,
        inviteStatus: String(item?.inviteStatus || "READY"),
      });
      const nextRecord = {
        ...item,
        inviteTokenHash,
        inviteCreatedAt: item?.inviteCreatedAt || createdAt,
        inviteStatus: item?.inviteStatus || "READY",
      };
      delete nextRecord.inviteToken;
      delete nextRecord.corepInviteToken;
      return nextRecord;
    })
  );
  return {
    records,
    links,
    tokenHashes: records.map((item) => item?.inviteTokenHash).filter(Boolean),
  };
};

export type NotificationSettings = {
  notificationEmails: string[];
  updatedAt?: string | null;
  updatedBy?: string | null;
};

export const VALIDATION_SETTINGS_NTS_MODES = [
  "REQUIRED",
  "OPTIONAL",
  "MANUAL_REVIEW",
  "DISABLED",
];

export const normalizeNtsVerificationMode = (mode = "") => {
  const normalized = String(mode || "").trim().toUpperCase();
  if (normalized === "OPTIONAL") return "MANUAL_REVIEW";
  return ["REQUIRED", "MANUAL_REVIEW", "DISABLED"].includes(normalized)
    ? normalized
    : "MANUAL_REVIEW";
};

export const normalizeValidationSettings = (settings = {}): ValidationSettings => {
  const rawNts =
    settings?.ntsBusinessVerification &&
    typeof settings.ntsBusinessVerification === "object"
      ? settings.ntsBusinessVerification
      : {};
  const mode = normalizeNtsVerificationMode(
    rawNts.mode ||
      (rawNts.enabled === false
        || settings?.enableBizNumberCheck === false
        ? "DISABLED"
        : DEFAULT_VALIDATION_SETTINGS.ntsBusinessVerification?.mode)
  );
  return {
    enableBizNumberCheck:
      typeof settings?.enableBizNumberCheck === "boolean"
        ? settings.enableBizNumberCheck
        : DEFAULT_VALIDATION_SETTINGS.enableBizNumberCheck,
    enablePhoneVerification:
      typeof settings?.enablePhoneVerification === "boolean"
        ? settings.enablePhoneVerification
        : DEFAULT_VALIDATION_SETTINGS.enablePhoneVerification,
    ntsBusinessVerification: {
      enabled:
        typeof rawNts.enabled === "boolean" ? rawNts.enabled : mode !== "DISABLED",
      mode: mode as "REQUIRED" | "MANUAL_REVIEW" | "DISABLED",
      ...(rawNts.updatedAt ? { updatedAt: String(rawNts.updatedAt) } : {}),
      ...(rawNts.updatedBy ? { updatedBy: String(rawNts.updatedBy) } : {}),
    },
  };
};

export const getDefaultValidationSettings = (): ValidationSettings =>
  normalizeValidationSettings(DEFAULT_VALIDATION_SETTINGS);

export const loadValidationSettings = (): ValidationSettings => {
  if (typeof window === "undefined") {
    return getDefaultValidationSettings();
  }

  try {
    const storage = window.localStorage;
    if (!storage) return getDefaultValidationSettings();

    const raw = storage.getItem(VALIDATION_SETTINGS_STORAGE_KEY);
    if (!raw) return getDefaultValidationSettings();

    const parsed = JSON.parse(raw);
    return normalizeValidationSettings(parsed);
  } catch {
    return getDefaultValidationSettings();
  }
};

export const saveValidationSettings = (settings: ValidationSettings) => {
  if (typeof window === "undefined" || !window.localStorage) return;
  window.localStorage.setItem(
    VALIDATION_SETTINGS_STORAGE_KEY,
    JSON.stringify(normalizeValidationSettings(settings))
  );
};

export const isValidNotificationEmail = (email = "") => {
  const normalized = String(email || "").trim().toLowerCase();
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized);
};

export const normalizeNotificationEmails = (emails = []) => {
  const inputList = Array.isArray(emails) ? emails : [emails];
  const seen = new Set<string>();
  return inputList
    .map((email) => String(email || "").trim().toLowerCase())
    .filter((email) => {
      if (!isValidNotificationEmail(email)) return false;
      if (seen.has(email)) return false;
      seen.add(email);
      return true;
    });
};

export const buildNotificationSettingsPayload = (
  emails = [],
  updatedBy = "admin",
  updatedAt = new Date().toISOString()
) => ({
  notificationEmails: normalizeNotificationEmails(emails),
  updatedAt,
  updatedBy: updatedBy || "admin",
});

export const buildContractCompletedNotificationPayload = ({
  contractId,
  documentId,
  appId: targetAppId = appId,
} = {}) => ({
  contractId,
  documentId: documentId || null,
  appId: targetAppId || appId,
});

export const SALES_REPS_CONFIG_DOC_ID = "sales_reps";
export const SALES_REPS_STORAGE_KEY = "cnfood.sales.reps.v1";
export const SALES_REPS_LOCAL_FALLBACK_TOAST =
  "서버 저장에 실패해 이 브라우저에만 임시 저장되었습니다. 다른 기기에서는 보이지 않을 수 있습니다.";
export const SALES_REPS_LOCAL_STATUS_MESSAGE =
  "현재 영업사원 목록은 임시 저장소 기준입니다.";
export const SALES_REPS_LOCAL_INVITE_BLOCK_MESSAGE =
  "임시 저장된 영업사원으로는 초대 링크를 생성할 수 없습니다. 본사 직접 관리를 선택하거나 Firestore 저장 권한을 확인해 주세요.";
export const SALES_REPS_LOCAL_INVITE_NOTICE_MESSAGE =
  "현재 영업사원 목록은 임시 저장소 기준입니다. 영업사원 배정 초대는 서버에 저장된 영업사원만 사용할 수 있습니다. 본사 직접 관리를 선택하거나 Firestore 저장 권한을 확인해 주세요.";
export const DEFAULT_INVITE_EXPIRES_DAYS = 14;

export const normalizePhoneDigits = (phone = "") =>
  String(phone || "").replace(/[^0-9]/g, "");

export const formatPhoneNumberForDisplay = (phone = "") => {
  const digits = normalizePhoneDigits(phone);
  if (digits.length === 11) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
  }
  if (digits.length === 10) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return String(phone || "").trim();
};

export const createStableId = (prefix = "id") => {
  const randomPart =
    typeof crypto !== "undefined" && crypto.getRandomValues
      ? Array.from(crypto.getRandomValues(new Uint8Array(8)))
          .map((byte) => byte.toString(16).padStart(2, "0"))
          .join("")
      : Math.random().toString(36).slice(2, 14);
  return `${prefix}_${Date.now().toString(36)}_${randomPart}`;
};

export const createInviteToken = () => {
  if (typeof crypto !== "undefined" && crypto.getRandomValues) {
    const bytes = crypto.getRandomValues(new Uint8Array(24));
    return Array.from(bytes)
      .map((byte) => byte.toString(16).padStart(2, "0"))
      .join("");
  }
  return `${Math.random().toString(36).slice(2)}${Date.now().toString(36)}${Math.random()
    .toString(36)
    .slice(2)}`;
};

export const hashInviteToken = (token = "") => {
  const input = String(token || "");
  let hash = 2166136261;
  for (let index = 0; index < input.length; index += 1) {
    hash ^= input.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return `fnv1a_${(hash >>> 0).toString(16).padStart(8, "0")}`;
};

export type SalesManager = {
  id: string;
  name: string;
  departmentPart: string;
  part: string;
  phone: string;
  email: string;
  createdAt: string;
  updatedAt: string;
  isActive: boolean;
  active: boolean;
};

export type SalesRepStorageSource =
  | "FIRESTORE"
  | "LOCAL_STORAGE_FALLBACK"
  | "EMPTY";

export type InviteOwnerType = "HQ" | "SALES_REP";
export type IdentityProvider = "FIREBASE_SMS" | "KCP";
export type IdentityVerificationMethod = "KCP_IDENTITY" | "SMS_PHONE_CHECK";
export type KcpFallbackReason =
  | "KCP_START_FAILED"
  | "KCP_TIMEOUT"
  | "KCP_ENV_MISSING"
  | "KCP_REGISTRATION_FAILED"
  | "KCP_CALL_URL_MISSING"
  | "KCP_REG_CERT_KEY_MISSING"
  | "KCP_USER_CANCELLED"
  | "KCP_UNKNOWN_ERROR";
export type KcpAttemptStatus =
  | "NOT_ATTEMPTED"
  | "START_FAILED"
  | "FAILED"
  | "CANCELLED"
  | "VERIFIED";
export type KcpIdentityStatus =
  | ""
  | "REGISTERED"
  | "RETURNED"
  | "VERIFYING"
  | "VERIFIED"
  | "FAILED"
  | "CANCELLED"
  | "EXPIRED";

export const IDENTITY_TEST_MODE_ENV_NAME = "ENABLE_IDENTITY_TEST_MODE";
export const IDENTITY_TEST_MODE_REACT_ENV_NAME =
  "REACT_APP_ENABLE_IDENTITY_TEST_MODE";
export const IDENTITY_TEST_DEVICE_TOKEN_HASH_ENV_NAME =
  "TEST_DEVICE_TOKEN_HASH";
export const IDENTITY_TEST_DEVICE_TOKEN_HASH_REACT_ENV_NAME =
  "REACT_APP_TEST_DEVICE_TOKEN_HASH";
export const IDENTITY_TEST_DEVICE_TOKEN_STORAGE_KEY =
  "cnfood-test-device-token";
export const IDENTITY_TEST_SIMULATION_PROVIDER = "TEST_SIMULATION";
export const IDENTITY_TEST_SIMULATION_STATUS = "SIMULATED";
export const IDENTITY_TEST_MODE_NOTICE =
  "테스트 모드입니다. 실제 KCP 인증이 아닙니다.";
export const IDENTITY_TEST_SIMULATION_WARNING =
  "테스트 모드 인증입니다. 실제 KCP 본인확인이 아닙니다.";
export const REPRESENTATIVE_KCP_REQUIRED_MESSAGE =
  "대표자 본인확인이 완료되지 않았습니다. 대표자 본인 명의 휴대폰으로 KCP 본인확인을 진행해 주세요.";
export const REPRESENTATIVE_KCP_PENDING_STATUS =
  "PENDING_REPRESENTATIVE_KCP";
export const REPRESENTATIVE_KCP_MISMATCH_STATUS =
  "REPRESENTATIVE_KCP_MISMATCH";
export const REPRESENTATIVE_KCP_VERIFIED_STATUS =
  "REPRESENTATIVE_KCP_VERIFIED";
export const IDENTITY_TEST_CONTRACT_STATUS = "TEST_DRAFT";
export const TEST_MODE_PDF_NOTICE =
  "TEST / 실제 계약 아님 / KCP/PASS 실제 인증 아님 / CI/DI 없음 / 법적 제출용 사용 불가";
export const REPRESENTATIVE_IDENTITY_REQUEST_SMS_MESSAGE =
  "씨엔푸드 전자계약 대표자 본인확인이 필요합니다. 대표자 본인 명의 휴대폰으로 아래 링크에 접속해 인증을 진행해 주세요.";

export const isIdentityTestModeEnabled = (env = null) => {
  const runtimeEnv =
    env ||
    (typeof process !== "undefined" && process?.env ? process.env : {});
  const raw =
    runtimeEnv?.[IDENTITY_TEST_MODE_ENV_NAME] ??
    runtimeEnv?.[IDENTITY_TEST_MODE_REACT_ENV_NAME] ??
    (typeof window !== "undefined"
      ? window.__CNFOOD_ENABLE_IDENTITY_TEST_MODE
      : "");
  return ["true", "1", "yes", "y", "on"].includes(
    String(raw || "").trim().toLowerCase()
  );
};

export const getIdentityTestDeviceTokenHash = (env = null) => {
  const runtimeEnv =
    env ||
    (typeof process !== "undefined" && process?.env ? process.env : {});
  return String(
    runtimeEnv?.[IDENTITY_TEST_DEVICE_TOKEN_HASH_ENV_NAME] ??
      runtimeEnv?.[IDENTITY_TEST_DEVICE_TOKEN_HASH_REACT_ENV_NAME] ??
      (typeof window !== "undefined"
        ? window.__CNFOOD_TEST_DEVICE_TOKEN_HASH
        : "") ??
      ""
  )
    .trim()
    .toLowerCase();
};

export const isIdentityTestDeviceTokenAuthorized = async ({
  token = "",
  env = null,
} = {}) => {
  const expectedHash = getIdentityTestDeviceTokenHash(env);
  const normalizedToken = String(token || "").trim();
  if (!expectedHash || !normalizedToken) return false;
  try {
    return (await createSha256Hash(normalizedToken)).toLowerCase() === expectedHash;
  } catch {
    return false;
  }
};

export const canShowIdentityTestModeForDevice = ({
  env = null,
  adminAuthorized = false,
  deviceTokenAuthorized = false,
} = {}) =>
  isIdentityTestModeEnabled(env) &&
  adminAuthorized === true &&
  deviceTokenAuthorized === true;

export const isIdentityTestSimulation = (verification = null) =>
  verification?.provider === IDENTITY_TEST_SIMULATION_PROVIDER ||
  verification?.status === IDENTITY_TEST_SIMULATION_STATUS ||
  verification?.isTestMode === true;
export type VerificationMode =
  | "KCP_PRIMARY"
  | "KCP_FAILED"
  | "SMS_FALLBACK_SELECTED"
  | "SMS_ONLY";

export const KCP_START_TIMEOUT_MS = 15000;
export const KCP_POPUP_RESULT_POLL_INTERVAL_MS = 3000;
export const KCP_POPUP_RESULT_MAX_WAIT_MS = 60000;
export const KCP_VERIFIED_GRACE_MS = 5000;
export const KCP_LAUNCH_TIMEOUT_MS = 18000;
export const KCP_LAUNCH_FALLBACK_MS = KCP_LAUNCH_TIMEOUT_MS;

export const KCP_LAUNCH_UI_STATES = {
  IDLE: "IDLE",
  PREPARING: "PREPARING",
  OPENING: "OPENING",
  WAITING_RETURN: "WAITING_RETURN",
  RETURN_CHECKING: "RETURN_CHECKING",
  VERIFIED: "VERIFIED",
  FAILED: "FAILED",
  LAUNCH_TIMEOUT: "LAUNCH_TIMEOUT",
} as const;

export type KcpLaunchUiState =
  (typeof KCP_LAUNCH_UI_STATES)[keyof typeof KCP_LAUNCH_UI_STATES];

export const shouldApplyKcpLaunchTimeout = (state = "") =>
  [KCP_LAUNCH_UI_STATES.PREPARING, KCP_LAUNCH_UI_STATES.OPENING].includes(
    String(state || "") as KcpLaunchUiState
  );

export const shouldShowKcpLaunchRecoveryState = (
  state = "",
  fallbackVisible = false
) =>
  state === KCP_LAUNCH_UI_STATES.LAUNCH_TIMEOUT ||
  (fallbackVisible &&
    [
      KCP_LAUNCH_UI_STATES.PREPARING,
      KCP_LAUNCH_UI_STATES.OPENING,
    ].includes(String(state || "") as KcpLaunchUiState));

export const shouldShowKcpLaunchOverlay = (
  state = "",
  { kcpReturnSyncState = "" }: { kcpReturnSyncState?: string } = {}
) =>
  kcpReturnSyncState !== "CHECKING_STATUS" &&
  [
    KCP_LAUNCH_UI_STATES.PREPARING,
    KCP_LAUNCH_UI_STATES.OPENING,
    KCP_LAUNCH_UI_STATES.WAITING_RETURN,
    KCP_LAUNCH_UI_STATES.LAUNCH_TIMEOUT,
  ].includes(String(state || "") as KcpLaunchUiState);

export type KcpPopupCloseStatusDecision =
  | "PENDING"
  | "VERIFIED"
  | "FALLBACK"
  | "TIMEOUT";

export const getKcpPopupCloseStatusDecision = ({
  status = "",
  elapsedMs = 0,
  maxWaitMs = KCP_POPUP_RESULT_MAX_WAIT_MS,
}: {
  status?: string;
  elapsedMs?: number;
  maxWaitMs?: number;
} = {}): KcpPopupCloseStatusDecision => {
  const normalizedStatus = String(status || "").toUpperCase();
  if (normalizedStatus === "VERIFIED") return "VERIFIED";
  if (["FAILED", "CANCELLED", "EXPIRED"].includes(normalizedStatus)) {
    return "FALLBACK";
  }
  if (elapsedMs >= maxWaitMs) return "TIMEOUT";
  return "PENDING";
};

export const getKcpStartErrorMessage = ({
  status = 0,
  result = null,
  errorName = "",
}: {
  status?: number;
  result?: { code?: string; message?: string } | null;
  errorName?: string;
} = {}) => {
  const code = String(result?.code || "").trim();
  if (
    errorName === "AbortError" ||
    code === "KCP_TIMEOUT" ||
    code === "KCP_REGISTER_TIMEOUT"
  ) {
    return "본인확인 응답이 지연되고 있습니다. 다시 시도해 주세요.";
  }
  if (code === "SERVER_ENV_MISSING" || code === "KCP_ENV_MISSING") {
    return "본인확인 서버 설정이 누락되었습니다.";
  }
  if (code === "KCP_ENV_INVALID") {
    return "본인확인 서버 설정이 올바르지 않습니다.";
  }
  if (code === "KCP_CALL_URL_MISSING") {
    return "본인확인 요청 데이터가 올바르지 않습니다.";
  }
  if (code === "KCP_REG_CERT_KEY_MISSING") {
    return "본인확인 요청 승인값이 누락되었습니다.";
  }
  if (code === "KCP_REGISTRATION_FAILED") {
    return result?.message || "KCP 거래등록에 실패했습니다.";
  }
  if (code === "KCP_REGISTRATION_INVALID_RESPONSE") {
    return "본인확인 서버 응답을 읽지 못했습니다.";
  }
  if (code === "KCP_SESSION_SAVE_FAILED") {
    return "본인확인 세션을 저장하지 못했습니다.";
  }
  if (code === "KCP_NETWORK_ERROR" || code === "KCP_REGISTRATION_NETWORK_ERROR") {
    return "본인확인 서버에 연결하지 못했습니다. 잠시 후 다시 시도해 주세요.";
  }
  if (code === "KCP_OPEN_FAILED") {
    return "본인확인 페이지를 열지 못했습니다.";
  }
  if (code === "KCP_FORM_BUILD_FAILED" || code === "KCP_FORM_SUBMIT_FAILED") {
    return "본인확인 화면을 불러오지 못했습니다.";
  }
  if (status >= 500) {
    return result?.message || "본인확인 서버 요청 중 오류가 발생했습니다.";
  }
  return (
    result?.message ||
    "통신사 본인확인을 시작하지 못했습니다. 잠시 후 다시 시도해 주세요."
  );
};

export const getKcpStartInlineErrorMessage = (
  message: string,
  result?: { code?: string } | null
) => {
  const code = String(result?.code || "").trim();
  return code ? `${message} (오류코드: ${code})` : message;
};

export const buildKcpIdentityFormFields = ({
  regCertKey = "",
  pageSubmitYn = "Y",
}: {
  regCertKey?: string;
  pageSubmitYn?: string;
} = {}) => [
  { name: "reg_cert_key", value: String(regCertKey || "") },
  { name: "kcp_page_submit_yn", value: String(pageSubmitYn || "Y") },
];

const escapeKcpPopupHtmlText = (value = "") =>
  String(value || "").replace(/[&<>"']/g, (char) => {
    const entities: Record<string, string> = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
    };
    return entities[char] || char;
  });

export const buildKcpPopupWaitingHtml = ({
  title = "본인인증 화면을 준비하고 있습니다",
  subtitle = "잠시만 기다려 주세요.",
  description = "통신사 본인인증 화면이 열리면 인증을 완료해 주세요.",
  warning = "뒤로가기나 새로고침을 누르지 마세요.",
}: {
  title?: string;
  subtitle?: string;
  description?: string;
  warning?: string;
} = {}) => {
  const safeTitle = escapeKcpPopupHtmlText(title);
  const safeSubtitle = escapeKcpPopupHtmlText(subtitle);
  const safeDescription = escapeKcpPopupHtmlText(description);
  const safeWarning = escapeKcpPopupHtmlText(warning);

  return `<!doctype html>
<html lang="ko">
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width,initial-scale=1,viewport-fit=cover" />
  <title>CN FOOD 본인인증</title>
  <style>
    :root { color-scheme: light; }
    * { box-sizing: border-box; }
    html {
      width: 100%;
      min-width: 100vw;
      min-height: 100%;
      margin: 0;
      padding: 0;
      background: #eff6ff;
      -webkit-text-size-adjust: 100%;
      text-size-adjust: 100%;
    }
    body {
      position: fixed;
      inset: 0;
      margin: 0;
      width: 100vw;
      min-width: 100vw;
      min-height: 100vh;
      min-height: 100dvh;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      padding: max(24px, env(safe-area-inset-top)) 20px max(24px, env(safe-area-inset-bottom));
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", sans-serif;
      background: linear-gradient(180deg, #eff6ff 0%, #ffffff 46%, #f8fafc 100%);
      color: #0f172a;
    }
    .wrap {
      width: min(calc(100vw - 32px), 430px);
      max-width: 430px;
      margin: 0 auto;
      border: 1px solid #dbeafe;
      border-radius: 24px;
      background: rgba(255, 255, 255, 0.96);
      box-shadow: 0 24px 60px rgba(15, 23, 42, 0.16);
      padding: 28px 22px;
      text-align: center;
    }
    .badge {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-height: 32px;
      padding: 0 12px;
      border-radius: 999px;
      background: #dbeafe;
      color: #1d4ed8;
      font-size: 13px;
      font-weight: 800;
      letter-spacing: 0;
    }
    .spinner {
      width: 58px;
      height: 58px;
      margin: 22px auto 18px;
      border: 5px solid #dbeafe;
      border-top-color: #2563eb;
      border-radius: 999px;
      animation: spin 0.85s linear infinite;
    }
    h1 {
      margin: 0;
      font-size: 24px;
      line-height: 1.35;
      font-weight: 900;
      letter-spacing: 0;
      word-break: keep-all;
    }
    .subtitle {
      margin: 10px 0 0;
      font-size: 17px;
      line-height: 1.5;
      font-weight: 800;
      color: #1e40af;
      word-break: keep-all;
    }
    .description {
      margin: 14px 0 0;
      font-size: 15px;
      line-height: 1.65;
      font-weight: 650;
      color: #475569;
      word-break: keep-all;
    }
    .warning {
      margin-top: 18px;
      border-radius: 16px;
      background: #fff7ed;
      color: #9a3412;
      padding: 14px;
      font-size: 14px;
      line-height: 1.55;
      font-weight: 800;
      word-break: keep-all;
    }
    .footer {
      margin-top: 18px;
      color: #64748b;
      font-size: 13px;
      line-height: 1.55;
      word-break: keep-all;
    }
    .delayed-fallback {
      opacity: 0;
      max-height: 0;
      overflow: hidden;
      animation: revealFallback 0s linear 9s forwards;
    }
    @keyframes spin { to { transform: rotate(360deg); } }
    @keyframes revealFallback { to { opacity: 1; max-height: 160px; } }
    @media (prefers-reduced-motion: reduce) {
      .spinner { animation: none; border-top-color: #93c5fd; }
      .delayed-fallback { opacity: 1; max-height: 160px; animation: none; }
    }
    @media (max-width: 360px) {
      body { padding-left: 14px; padding-right: 14px; }
      .wrap { width: min(calc(100vw - 28px), 430px); padding: 24px 18px; }
      h1 { font-size: 22px; }
    }
  </style>
</head>
<body>
  <main class="wrap" role="status" aria-live="polite">
    <div class="badge">CN FOOD 전자계약</div>
    <div class="spinner" aria-hidden="true"></div>
    <h1>${safeTitle}</h1>
    <p class="subtitle">${safeSubtitle}</p>
    <p class="description">${safeDescription}</p>
    <p class="warning">${safeWarning}</p>
    <p class="footer delayed-fallback">화면이 오래 멈춰 있으면 창을 닫고 다시 시도해 주세요.</p>
  </main>
</body>
</html>`;
};

export const buildKcpPopupFailureHtml = ({
  title = "본인확인 창을 열지 못했습니다",
  description = "창을 닫고 다시 시도해 주세요.",
} = {}) => {
  const safeTitle = escapeKcpPopupHtmlText(title);
  const safeDescription = escapeKcpPopupHtmlText(description);
  return `<!doctype html>
<html lang="ko">
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1, viewport-fit=cover" />
  <title>CN FOOD 본인확인 오류</title>
  <style>
    * { box-sizing: border-box; }
    body {
      margin: 0;
      min-height: 100vh;
      min-height: 100dvh;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 24px 20px;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", sans-serif;
      background: #f8fafc;
      color: #0f172a;
    }
    .wrap {
      width: min(100%, 430px);
      border: 1px solid #fecaca;
      border-radius: 24px;
      background: #fff;
      box-shadow: 0 24px 60px rgba(15, 23, 42, 0.16);
      padding: 28px 22px;
      text-align: center;
    }
    .badge {
      display: inline-flex;
      min-height: 32px;
      align-items: center;
      justify-content: center;
      border-radius: 999px;
      background: #fee2e2;
      color: #b91c1c;
      padding: 0 12px;
      font-size: 13px;
      font-weight: 900;
    }
    h1 {
      margin: 18px 0 0;
      font-size: 23px;
      line-height: 1.35;
      font-weight: 900;
      word-break: keep-all;
    }
    p {
      margin: 14px 0 0;
      color: #475569;
      font-size: 15px;
      line-height: 1.65;
      font-weight: 700;
      word-break: keep-all;
    }
    button {
      margin-top: 20px;
      width: 100%;
      min-height: 52px;
      border: 0;
      border-radius: 16px;
      background: #0f172a;
      color: #fff;
      font-size: 16px;
      font-weight: 900;
    }
  </style>
</head>
<body>
  <main class="wrap" role="alert">
    <div class="badge">CN FOOD 전자계약</div>
    <h1>${safeTitle}</h1>
    <p>${safeDescription}</p>
    <button type="button" onclick="window.close()">창 닫기</button>
  </main>
</body>
</html>`;
};

export const KCP_DRAFT_RESTORE_STORAGE_KEY = "cnfood.kcp.restoreDraft.v1";
const KCP_LEGACY_DRAFT_RESTORE_STORAGE_KEY = "cnfood.kcp.draft.restore.v1";
export const KCP_SESSION_POINTER_STORAGE_KEY = "cnfood.kcp.sessionPointer.v1";
export const KCP_RETURN_NAVIGATION_KEY = "cnfood:kcp-return-navigation";
export const KCP_RETURN_NAVIGATION_TTL_MS = 10 * 60 * 1000;
const KCP_IDENTITY_POPUP_NAME = "kcp_auth_popup";

export const KCP_RETURN_SYNC_STATES = {
  IDLE: "IDLE",
  RETURN_DETECTED: "RETURN_DETECTED",
  CHECKING_STATUS: "CHECKING_STATUS",
  VERIFIED: "VERIFIED",
  MISMATCHED: "MISMATCHED",
  FAILED: "FAILED",
} as const;

export type KcpReturnSyncState =
  (typeof KCP_RETURN_SYNC_STATES)[keyof typeof KCP_RETURN_SYNC_STATES];

export const KCP_RETURN_SYNC_CHECKING_MESSAGE =
  "본인확인 완료 상태를 확인하고 있습니다. 잠시만 기다려 주세요. 인증 결과를 불러오는 중입니다.";

export const shouldHoldStepDuringKcpReturnSync = ({
  kcpReturnSyncState = KCP_RETURN_SYNC_STATES.IDLE,
  nextStep = 0,
} = {}) =>
  kcpReturnSyncState === KCP_RETURN_SYNC_STATES.CHECKING_STATUS &&
  Number(nextStep) <= 2;

export const shouldClearKcpReturnCheckingAfterVerifiedStatus = ({
  kcpReturnSyncState = KCP_RETURN_SYNC_STATES.IDLE,
  status = "",
  canProceed = false,
} = {}) =>
  kcpReturnSyncState === KCP_RETURN_SYNC_STATES.CHECKING_STATUS &&
  String(status || "").toUpperCase() === "VERIFIED" &&
  canProceed === true;

export const shouldCompleteKcpVerifiedStatusImmediately = ({
  status = "",
  canProceed = false,
  subjectType = "",
} = {}) =>
  String(status || "").toUpperCase() === "VERIFIED" &&
  canProceed === true &&
  String(subjectType || "").toUpperCase() !== "CO_REP";

export const isPrincipalKcpVerifiedWithoutMismatch = ({
  kcpIdentityStatus = "",
  representativeIdentityVerification = null,
  kcpIdentityEvidence = null,
} = {}) => {
  const normalizedStatus = String(
    kcpIdentityStatus || kcpIdentityEvidence?.status || ""
  ).toUpperCase();
  const verification =
    representativeIdentityVerification ||
    kcpIdentityEvidence?.representativeIdentityVerification ||
    kcpIdentityEvidence?.identityVerification ||
    null;
  const verificationStatus = String(verification?.status || "").toUpperCase();
  return normalizedStatus === "VERIFIED" && verificationStatus !== "MISMATCHED";
};

export const shouldShowKcpReauthenticationWarning = ({
  phoneVerificationSatisfied = false,
  checking = false,
  kcpIdentityStatus = "",
  representativeIdentityVerification = null,
  kcpIdentityEvidence = null,
} = {}) => {
  if (phoneVerificationSatisfied || checking) return false;
  return !isPrincipalKcpVerifiedWithoutMismatch({
    kcpIdentityStatus,
    representativeIdentityVerification,
    kcpIdentityEvidence,
  });
};

const sanitizeKcpReturnProcessPart = (value = "") =>
  String(value || "")
    .trim()
    .replace(/[^a-zA-Z0-9:_-]/g, "")
    .slice(0, 96);

export const buildKcpReturnProcessKey = ({
  result = "",
  status = "",
  kcpSessionId = "",
  draftId = "",
  targetStep = "",
  intent = null,
  createdAt = "",
} = {}) => {
  const safeSessionId = sanitizeKcpReturnProcessPart(kcpSessionId);
  const safeDraftId = sanitizeKcpReturnProcessPart(draftId);
  if (safeSessionId || safeDraftId) {
    return [
      "principal",
      `session:${safeSessionId || "none"}`,
      `draft:${safeDraftId || "none"}`,
    ].join("|");
  }
  const intentCreatedAt = intent?.createdAt || createdAt || "";
  const intentTargetStep = intent?.targetStep || targetStep || "";
  const parts = [
    "principal",
    "session:none",
    "draft:none",
    `status:${sanitizeKcpReturnProcessPart(status || result) || "unknown"}`,
    `target:${sanitizeKcpReturnProcessPart(intentTargetStep) || "unknown"}`,
    `intent:${sanitizeKcpReturnProcessPart(intentCreatedAt) || "none"}`,
  ];
  return parts.join("|");
};

const KCP_RETURN_TRACE_ALLOWED_KEYS = new Set([
  "source",
  "previousSyncState",
  "nextSyncState",
  "targetStep",
  "duplicateSkipped",
  "resetSuppressedByGrace",
  "timestamp",
]);

export const sanitizeKcpReturnTraceEvent = (event = {}) => {
  const safe: Record<string, unknown> = {};
  Object.entries(event || {}).forEach(([key, value]) => {
    if (!KCP_RETURN_TRACE_ALLOWED_KEYS.has(key)) return;
    if (value === undefined) return;
    if (typeof value === "number" || typeof value === "boolean") {
      safe[key] = value;
      return;
    }
    safe[key] = String(value || "").slice(0, 160);
  });
  return {
    timestamp: new Date().toISOString(),
    ...safe,
  };
};

const KCP_LAUNCH_TRACE_ALLOWED_KEYS = new Set([
  "source",
  "previousLaunchState",
  "nextLaunchState",
  "elapsedMs",
  "reason",
  "popupPresent",
  "popupClosed",
  "timestamp",
]);

export const sanitizeKcpLaunchTraceEvent = (event = {}) => {
  const safe: Record<string, unknown> = {};
  Object.entries(event || {}).forEach(([key, value]) => {
    if (!KCP_LAUNCH_TRACE_ALLOWED_KEYS.has(key)) return;
    if (value === undefined) return;
    if (typeof value === "number" || typeof value === "boolean") {
      safe[key] = value;
      return;
    }
    safe[key] = String(value || "").slice(0, 160);
  });
  return {
    timestamp: new Date().toISOString(),
    ...safe,
  };
};

export const shouldSuppressKcpVerifiedReset = ({
  now = Date.now(),
  graceUntil = 0,
  explicitIdentityEdit = false,
  force = false,
} = {}) =>
  !force &&
  !explicitIdentityEdit &&
  Number(graceUntil || 0) > 0 &&
  Number(now || 0) <= Number(graceUntil || 0);

export const getPostKcpVerifiedTargetStep = ({
  step0Issues = [],
  representativeMatched = true,
  hasResidentRegistrationEvidence = false,
  agreementsComplete = false,
} = {}) => {
  if (Array.isArray(step0Issues) && step0Issues.length > 0) return 0;
  if (
    representativeMatched &&
    hasResidentRegistrationEvidence &&
    agreementsComplete
  ) {
    return 2;
  }
  return 1;
};

export const getNextActionState = ({
  enabled = false,
  reason = "",
  label = "",
} = {}) => ({
  enabled: Boolean(enabled),
  reason: String(reason || ""),
  label: String(label || ""),
});

export const getInitialKcpReturnSyncState = (search = "") => {
  const params = new URLSearchParams(String(search || ""));
  if (params.has("corepInvite")) return KCP_RETURN_SYNC_STATES.IDLE;
  const subjectType = String(params.get("subjectType") || "").toUpperCase();
  if (subjectType === "CO_REP") return KCP_RETURN_SYNC_STATES.IDLE;
  const hasReturnSignal =
    params.has("kcpResult") ||
    params.has("kcpSessionId") ||
    params.has("draftId") ||
    params.has("res_cd") ||
    params.has("ordr_idxx");
  return hasReturnSignal
    ? KCP_RETURN_SYNC_STATES.CHECKING_STATUS
    : KCP_RETURN_SYNC_STATES.IDLE;
};

export type KcpReturnNavigationIntent = {
  pending: boolean;
  targetStep: number;
  createdAt: number;
};

export const saveKcpReturnNavigationIntent = (
  targetStep = 1,
  storage: Storage | null | undefined =
    typeof window !== "undefined" ? window.sessionStorage : undefined
) => {
  if (!storage) return false;
  const intent: KcpReturnNavigationIntent = {
    pending: true,
    targetStep: Number(targetStep) === 2 ? 2 : 1,
    createdAt: Date.now(),
  };
  const serialized = JSON.stringify(intent);
  if (/"(ssn|resident|phone|biz|business|name|reg_cert_key|enc_data|ci|di|signature)"\s*:/i.test(serialized)) {
    throw new Error("KCP return navigation intent contains sensitive fields");
  }
  storage.setItem(KCP_RETURN_NAVIGATION_KEY, serialized);
  return true;
};

export const loadKcpReturnNavigationIntent = (
  storage: Storage | null | undefined =
    typeof window !== "undefined" ? window.sessionStorage : undefined
): KcpReturnNavigationIntent | null => {
  if (!storage) return null;
  try {
    const raw = storage.getItem(KCP_RETURN_NAVIGATION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const createdAt = Number(parsed?.createdAt || 0);
    if (
      parsed?.pending !== true ||
      !createdAt ||
      Date.now() - createdAt > KCP_RETURN_NAVIGATION_TTL_MS
    ) {
      storage.removeItem(KCP_RETURN_NAVIGATION_KEY);
      return null;
    }
    return {
      pending: true,
      targetStep: Number(parsed.targetStep) === 2 ? 2 : 1,
      createdAt,
    };
  } catch {
    storage.removeItem(KCP_RETURN_NAVIGATION_KEY);
    return null;
  }
};

export const clearKcpReturnNavigationIntent = (
  storage: Storage | null | undefined =
    typeof window !== "undefined" ? window.sessionStorage : undefined
) => {
  if (!storage) return;
  storage.removeItem(KCP_RETURN_NAVIGATION_KEY);
};

const KCP_DRAFT_EXCLUDED_FORM_FIELDS = new Set([
  "ssnFront",
  "ssnBack",
  "principalRepSsnFront",
  "principalRepSsnBack",
  "guarantorSsnFront",
  "guarantorSsnBack",
  "signature",
  "signature2",
]);

type KcpRestoredSsnDraft = {
  principalRepSsnEncrypted?: string | null;
  principalRepSsnMasked?: string | null;
  guarantorSsnEncrypted?: string | null;
  guarantorSsnMasked?: string | null;
};

export type KcpDraftRestoreState = {
  draftId: string;
  step: number;
  bizType: string;
  formData: Record<string, unknown>;
  businessVerification?: Record<string, unknown> | null;
  selYear?: number;
  selMonth?: number;
  selDay?: number;
  isSameDayDeposit?: boolean;
  manualAddressMode?: boolean;
  manualCorpAddrMode?: boolean;
  ownerType?: InviteOwnerType;
  ownerLabel?: string;
  inviteToken?: string;
  activeInvite?: ContractInvite | null;
  agreements?: {
    privacy?: boolean;
    credit?: boolean;
    collection?: boolean;
  };
  coRepresentativeDeclared?: boolean;
  coRepresentativesContactSnapshot?: Array<Record<string, unknown>>;
  coRepresentativeWorkflow?: Record<string, unknown> | null;
  coRepresentativeNtsInfo?: CoRepresentativeInfo | null;
  kcpSessionId?: string;
  restoredSsnDraft?: KcpRestoredSsnDraft | null;
  updatedAt: string;
};

export const createKcpDraftRestoreState = ({
  draftId = "",
  step = 1,
  bizType = "INDIVIDUAL",
  formData = {},
  businessVerification = null,
  selYear,
  selMonth,
  selDay,
  isSameDayDeposit = false,
  manualAddressMode = false,
  manualCorpAddrMode = false,
  ownerType = "HQ",
  ownerLabel = INVITE_OWNER_HQ_LABEL,
  inviteToken = "",
  activeInvite = null,
  agreements = {},
  coRepresentativeDeclared = false,
  coRepresentativesContactSnapshot = [],
  coRepresentativeWorkflow = null,
  coRepresentativeNtsInfo = null,
  kcpSessionId = "",
  restoredSsnDraft = null,
  updatedAt = new Date().toISOString(),
}: Partial<KcpDraftRestoreState> & { formData?: Record<string, unknown> } = {}): KcpDraftRestoreState => {
  const safeFormData = Object.entries(formData || {}).reduce(
    (acc, [key, value]) => {
      if (!KCP_DRAFT_EXCLUDED_FORM_FIELDS.has(key)) {
        acc[key] = value;
      }
      return acc;
    },
    {} as Record<string, unknown>
  );

  return {
    draftId: String(draftId || ""),
    step: Number(step) || 1,
    bizType: String(bizType || "INDIVIDUAL"),
    formData: safeFormData,
    businessVerification:
      businessVerification && typeof businessVerification === "object"
        ? businessVerification
        : null,
    selYear,
    selMonth,
    selDay,
    isSameDayDeposit,
    manualAddressMode,
    manualCorpAddrMode,
    ownerType,
    ownerLabel,
    inviteToken,
    activeInvite,
    agreements,
    coRepresentativeDeclared,
    coRepresentativesContactSnapshot: buildCoRepresentativesContactSnapshot({
      declared: Boolean(coRepresentativeDeclared),
      representatives: coRepresentativesContactSnapshot,
    }),
    coRepresentativeWorkflow:
      coRepresentativeWorkflow && typeof coRepresentativeWorkflow === "object"
        ? coRepresentativeWorkflow
        : null,
    coRepresentativeNtsInfo,
    kcpSessionId,
    restoredSsnDraft,
    updatedAt,
  };
};

export const saveKcpDraftRestoreState = (
  state: KcpDraftRestoreState,
  storage: Storage | null | undefined =
    typeof window !== "undefined" ? window.sessionStorage : undefined
) => {
  if (!storage) return false;
  const serialized = JSON.stringify(state);
  if (/"(ssnBack|principalRepSsnBack|guarantorSsnBack|reg_cert_key|enc_data|CI|DI)"\s*:/.test(serialized)) {
    throw new Error("KCP draft contains sensitive fields");
  }
  storage.setItem(KCP_DRAFT_RESTORE_STORAGE_KEY, serialized);
  storage.removeItem(KCP_LEGACY_DRAFT_RESTORE_STORAGE_KEY);
  return true;
};

export const loadKcpDraftRestoreState = (
  draftId = "",
  storage: Storage | null | undefined =
    typeof window !== "undefined" ? window.sessionStorage : undefined
): KcpDraftRestoreState | null => {
  if (!storage) return null;
  try {
    const raw =
      storage.getItem(KCP_DRAFT_RESTORE_STORAGE_KEY) ||
      storage.getItem(KCP_LEGACY_DRAFT_RESTORE_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (draftId && parsed?.draftId && parsed.draftId !== draftId) return null;
    return parsed;
  } catch {
    return null;
  }
};

export const normalizeKcpDraftRestoreState = (
  value: unknown
): KcpDraftRestoreState | null => {
  if (!value || typeof value !== "object") return null;
  const draft = value as Partial<KcpDraftRestoreState>;
  if (!draft.draftId) return null;
  return createKcpDraftRestoreState({
    ...draft,
    formData:
      draft.formData && typeof draft.formData === "object"
        ? (draft.formData as Record<string, unknown>)
        : {},
  });
};

export const clearKcpDraftRestoreState = (
  storage: Storage | null | undefined =
    typeof window !== "undefined" ? window.sessionStorage : undefined
) => {
  if (!storage) return;
  storage.removeItem(KCP_DRAFT_RESTORE_STORAGE_KEY);
  storage.removeItem(KCP_LEGACY_DRAFT_RESTORE_STORAGE_KEY);
};

export const saveKcpSessionPointer = (
  {
    draftId = "",
    kcpSessionId = "",
    updatedAt = new Date().toISOString(),
  } = {},
  storage: Storage | null | undefined =
    typeof window !== "undefined" ? window.localStorage : undefined
) => {
  if (!storage || !kcpSessionId) return false;
  const pointer = {
    draftId: String(draftId || ""),
    kcpSessionId: String(kcpSessionId || ""),
    updatedAt: String(updatedAt || ""),
  };
  const serialized = JSON.stringify(pointer);
  if (/(ssn|resident|reg_cert_key|enc_data|ciEncrypted|diEncrypted|CI|DI)/i.test(serialized)) {
    throw new Error("KCP session pointer contains sensitive fields");
  }
  storage.setItem(KCP_SESSION_POINTER_STORAGE_KEY, serialized);
  return true;
};

export const loadKcpSessionPointer = (
  draftId = "",
  storage: Storage | null | undefined =
    typeof window !== "undefined" ? window.localStorage : undefined
) => {
  if (!storage) return null;
  try {
    const raw = storage.getItem(KCP_SESSION_POINTER_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.kcpSessionId) return null;
    if (draftId && parsed?.draftId && parsed.draftId !== draftId) return null;
    return {
      draftId: String(parsed.draftId || ""),
      kcpSessionId: String(parsed.kcpSessionId || ""),
      updatedAt: String(parsed.updatedAt || ""),
    };
  } catch {
    return null;
  }
};

export const clearKcpSessionPointer = (
  storage: Storage | null | undefined =
    typeof window !== "undefined" ? window.localStorage : undefined
) => {
  if (!storage) return;
  storage.removeItem(KCP_SESSION_POINTER_STORAGE_KEY);
};

export const isAllowedKcpMessageOrigin = (
  origin = "",
  currentOrigin =
    typeof window !== "undefined" ? window.location.origin : "https://cn-food-contract.vercel.app"
) => {
  const isLocalDevelopmentOrigin = (value: string) => {
    try {
      const parsed = new URL(value);
      return parsed.hostname === "localhost" || parsed.hostname === "127.0.0.1";
    } catch {
      return false;
    }
  };
  const allowedOrigins = new Set([
    "https://cn-food-contract.vercel.app",
  ]);
  if (isLocalDevelopmentOrigin(currentOrigin)) {
    allowedOrigins.add(currentOrigin);
  }
  return allowedOrigins.has(String(origin || ""));
};

const submitKcpIdentityForm = ({
  callUrl = "",
  regCertKey = "",
  pageSubmitYn = "Y",
  target = "_self",
  popup = null,
  popupName = "",
}: {
  callUrl?: string;
  regCertKey?: string;
  pageSubmitYn?: string;
  target?: string;
  popup?: Window | null;
  popupName?: string;
}) => {
  if (typeof document === "undefined") {
    throw new Error("KCP form submit is not available in this environment");
  }
  let submitDocument = document;
  if (popup && popupName) {
    try {
      if (!popup.closed && popup.document) {
        submitDocument = popup.document;
        if (!submitDocument.body) {
          submitDocument.open();
          submitDocument.write(buildKcpPopupWaitingHtml());
          submitDocument.close();
        }
      }
    } catch {
      submitDocument = document;
    }
  }
  if (!submitDocument.body) {
    throw new Error("KCP_FORM_BUILD_FAILED");
  }
  const form = submitDocument.createElement("form");
  form.method = "POST";
  form.action = callUrl;
  form.target = target || "_self";
  form.style.display = "none";

  const fields = buildKcpIdentityFormFields({ regCertKey, pageSubmitYn });
  fields.forEach((field) => {
    const input = submitDocument.createElement("input");
    input.type = "hidden";
    input.name = field.name;
    input.value = field.value;
    form.appendChild(input);
  });
  if (!fields.some((field) => field.name === "page_submit_yn")) {
    const pageSubmitInput = submitDocument.createElement("input");
    pageSubmitInput.type = "hidden";
    pageSubmitInput.name = "page_submit_yn";
    pageSubmitInput.value = String(pageSubmitYn || "Y");
    form.appendChild(pageSubmitInput);
  }

  submitDocument.body.appendChild(form);
  try {
    form.submit();
  } catch (error) {
    form.remove();
    throw error;
  }
  if (submitDocument === document) {
    form.remove();
  }
};

export const resolveIdentityProvider = ({
  kcpEnabled = false,
  kcpSessionStatus = "",
}: {
  kcpEnabled?: boolean;
  kcpSessionStatus?: KcpIdentityStatus | string;
} = {}): IdentityProvider => {
  if (!kcpEnabled) return "FIREBASE_SMS";
  if (kcpSessionStatus === "FAILED" || kcpSessionStatus === "CANCELLED") {
    return "FIREBASE_SMS";
  }
  return "KCP";
};

export const resolveVerificationMode = ({
  phoneVerificationEnabled = true,
  kcpAvailable = false,
  kcpFallbackReason = null,
  kcpSessionStatus = "",
  smsFallbackSelected = false,
}: {
  phoneVerificationEnabled?: boolean;
  kcpAvailable?: boolean;
  kcpFallbackReason?: KcpFallbackReason | null;
  kcpSessionStatus?: KcpIdentityStatus | string;
  smsFallbackSelected?: boolean;
} = {}): VerificationMode => {
  if (!phoneVerificationEnabled) return "SMS_ONLY";
  if (!kcpAvailable) return "SMS_ONLY";
  if (smsFallbackSelected) return "SMS_FALLBACK_SELECTED";

  const normalizedStatus = String(kcpSessionStatus || "").toUpperCase();
  if (
    kcpFallbackReason ||
    ["FAILED", "CANCELLED", "EXPIRED"].includes(normalizedStatus)
  ) {
    return "KCP_FAILED";
  }

  return "KCP_PRIMARY";
};

export const getIdentityProviderCopy = (provider: IdentityProvider) => {
  if (provider === "KCP") {
    return {
      title: "통신사 휴대폰 본인확인",
      description: "통신사 휴대폰 본인확인을 진행합니다.",
      actionLabel: "본인확인 시작",
      completedLabel: "본인확인 완료",
    };
  }

  return {
    title: "휴대폰 번호 확인",
    description: "휴대폰 번호 확인을 진행합니다.",
    actionLabel: "인증번호 발송",
    completedLabel: "휴대폰 번호 확인 완료",
  };
};

export type ContractInvite = {
  token?: string;
  status: "ACTIVE" | "USED" | "EXPIRED" | "CANCELLED" | "sent" | "opened" | "submitted" | "expired" | "cancelled";
  customerName: string;
  customerType?: "PERSONAL" | "BUSINESS" | string;
  businessType?: "individual" | "corporate" | string;
  businessNumber?: string;
  ownerType: InviteOwnerType;
  salesRepId?: string | null;
  salesRepName?: string | null;
  salesRepDepartmentPart?: string | null;
  salesRepPhone?: string | null;
  salesRepEmail?: string | null;
  ownerLabel: string;
  memo?: string;
  createdAt: string;
  expiresAt: string;
  createdByManagerCode?: "default" | "yh" | "sh" | string;
  createdByLabel?: string;
  usedAt?: string;
  submittedAt?: string | null;
  contractId?: string | null;
};

export const getSalesRepPart = (item = {}) =>
  String(item?.departmentPart || item?.part || "").trim();

export const validateSalesManagerForm = (draft = {}) => {
  const name = String(draft?.name || "").trim();
  const departmentPart = getSalesRepPart(draft);
  const phoneDigits = normalizePhoneDigits(draft?.phone || "");
  const email = String(draft?.email || "").trim();

  if (!name) {
    return { ok: false, message: "영업사원 이름을 입력해 주세요." };
  }
  if (!departmentPart) {
    return { ok: false, message: "부서/파트를 입력해 주세요." };
  }
  if (!/^01[016789]\d{7,8}$/.test(phoneDigits)) {
    return { ok: false, message: "휴대폰 번호를 올바르게 입력해 주세요." };
  }
  if (email && !isValidNotificationEmail(email)) {
    return { ok: false, message: "이메일 형식을 확인해 주세요." };
  }

  return { ok: true, message: "" };
};

export const normalizeSalesManagerItem = (item = {}): SalesManager | null => {
  const validation = validateSalesManagerForm(item);
  if (!validation.ok) return null;

  const now = new Date().toISOString();
  const departmentPart = getSalesRepPart(item);
  const active =
    item?.isActive === false || item?.active === false ? false : true;

  return {
    id: item?.id || createStableId("sales"),
    name: String(item?.name || "").trim(),
    part: departmentPart,
    departmentPart,
    phone: formatPhoneNumberForDisplay(item?.phone || ""),
    email: String(item?.email || "").trim().toLowerCase(),
    active,
    isActive: active,
    createdAt: item?.createdAt || now,
    updatedAt: item?.updatedAt || now,
  };
};

export const isValidSalesRepInput = (draft = {}) =>
  validateSalesManagerForm(draft).ok;

export const normalizeSalesRepItems = (items = []) => {
  const seen = new Set<string>();
  return (Array.isArray(items) ? items : [])
    .map((item) => {
      const normalized = normalizeSalesManagerItem(item);
      if (!normalized) return null;
      const duplicateKey = `${normalized.name}|${normalizePhoneDigits(
        normalized.phone
      )}`;
      if (seen.has(duplicateKey)) return null;
      seen.add(duplicateKey);
      return normalized;
    })
    .filter(Boolean);
};

export const getActiveSalesReps = (items = []) =>
  normalizeSalesRepItems(items).filter(
    (item) => item.active !== false && item.isActive !== false
  );

export const getSalesRepIdentityKey = (item = {}) => {
  const normalized = normalizeSalesManagerItem(item);
  if (!normalized) return "";
  return `${normalized.name}|${normalizePhoneDigits(normalized.phone)}`;
};

export const getMatchingSalesRepIndex = (items = [], draft = {}) => {
  const normalizedDraft = normalizeSalesManagerItem(draft);
  if (!normalizedDraft) return -1;
  const draftPhone = normalizePhoneDigits(normalizedDraft.phone);

  return normalizeSalesRepItems(items).findIndex((item) => {
    if (item.id && item.id === normalizedDraft.id) return true;
    if (item.name === normalizedDraft.name) return true;
    return normalizePhoneDigits(item.phone) === draftPhone;
  });
};

export const saveSalesRepsToLocalStorage = (items = []) => {
  const normalized = normalizeSalesRepItems(items);
  if (typeof window === "undefined" || !window.localStorage) return normalized;

  window.localStorage.setItem(
    SALES_REPS_STORAGE_KEY,
    JSON.stringify(normalized)
  );
  return normalized;
};

export const loadSalesRepsFromLocalStorage = () => {
  if (typeof window === "undefined" || !window.localStorage) return [];

  try {
    const raw = window.localStorage.getItem(SALES_REPS_STORAGE_KEY);
    if (!raw) return [];
    return normalizeSalesRepItems(JSON.parse(raw));
  } catch {
    return [];
  }
};

export const getSalesRepStorageSource = ({
  firestoreItems = [],
  localItems = [],
  storageMode = "",
  items = [],
} = {}): SalesRepStorageSource => {
  if (storageMode === "firestore") {
    return Array.isArray(items) && items.length > 0 ? "FIRESTORE" : "EMPTY";
  }
  if (storageMode === "localStorage") return "LOCAL_STORAGE_FALLBACK";
  if (Array.isArray(firestoreItems) && firestoreItems.length > 0) return "FIRESTORE";
  if (Array.isArray(localItems) && localItems.length > 0) {
    return "LOCAL_STORAGE_FALLBACK";
  }
  return "EMPTY";
};

export const persistSalesRepsWithFallback = async (
  items = [],
  {
    saveToFirestore,
    saveToFallback = saveSalesRepsToLocalStorage,
    successMessage = "영업사원 설정이 저장되었습니다.",
  } = {}
) => {
  const normalized = normalizeSalesRepItems(items);
  try {
    if (typeof saveToFirestore !== "function") {
      throw new Error("영업사원 서버 저장 함수가 없습니다.");
    }
    await saveToFirestore(normalized);
    saveToFallback(normalized);
    return {
      ok: true,
      items: normalized,
      storage: "firestore",
      toastMessage: successMessage,
      error: null,
    };
  } catch (error) {
    try {
      saveToFallback(normalized);
      return {
        ok: true,
        items: normalized,
        storage: "localStorage",
        toastMessage: SALES_REPS_LOCAL_FALLBACK_TOAST,
        error,
      };
    } catch (fallbackError) {
      return {
        ok: false,
        items: normalized,
        storage: "failed",
        toastMessage: "영업사원 정보를 저장하지 못했습니다. 다시 시도해 주세요.",
        error,
        fallbackError,
      };
    }
  }
};

export const parseSalesManagersBulkInput = (input = "") => {
  const errors = [];
  const items = [];
  String(input || "")
    .split(/\r?\n/)
    .forEach((line, index) => {
      const trimmed = line.trim();
      if (!trimmed) return;

      const values = (trimmed.includes("\t")
        ? trimmed.split(/\t+/)
        : trimmed.split(",")
      ).map((value) => value.trim());

      const draft = {
        name: values[0] || "",
        departmentPart: values[1] || "",
        part: values[1] || "",
        phone: values[2] || "",
        email: values.slice(3).join(",").trim(),
      };
      const validation = validateSalesManagerForm(draft);
      if (!validation.ok) {
        errors.push(`${index + 1}행: ${validation.message}`);
        return;
      }
      const normalized = normalizeSalesManagerItem(draft);
      if (normalized) items.push(normalized);
    });

  return { items, errors };
};

export const upsertSalesRepItems = (
  items = [],
  drafts = [],
  now = new Date().toISOString()
) => {
  let nextItems = normalizeSalesRepItems(items);
  (Array.isArray(drafts) ? drafts : [drafts]).forEach((draft) => {
    const validation = validateSalesManagerForm(draft);
    if (!validation.ok) {
      throw new Error(validation.message || "영업사원 정보를 확인해 주세요.");
    }

    const normalizedDraft = normalizeSalesManagerItem({
      ...draft,
      id: draft?.id || createStableId("sales"),
      active: draft?.active !== false && draft?.isActive !== false,
      isActive: draft?.active !== false && draft?.isActive !== false,
      createdAt: draft?.createdAt || now,
      updatedAt: now,
    });
    if (!normalizedDraft) {
      throw new Error("영업사원 정보를 확인해 주세요.");
    }

    const existingIndex = getMatchingSalesRepIndex(nextItems, normalizedDraft);

    if (existingIndex >= 0) {
      const previous = nextItems[existingIndex];
      nextItems[existingIndex] = normalizeSalesManagerItem({
        ...previous,
        ...normalizedDraft,
        id: previous.id,
        createdAt: previous.createdAt || normalizedDraft.createdAt,
        updatedAt: now,
      });
      return;
    }

    nextItems.push(normalizedDraft);
  });

  return normalizeSalesRepItems(nextItems);
};

export const addOrUpdateSalesRepItem = (items = [], draft = {}) =>
  upsertSalesRepItems(items, [draft]);

export const buildInviteUrl = (baseUrl = "", token = "") => {
  const safeBase = String(baseUrl || "").replace(/#.*$/, "");
  const [path, existingQuery = ""] = safeBase.split("?");
  const params = new URLSearchParams(existingQuery);
  params.set("invite", token);
  return `${path}?${params.toString()}`;
};

export const calculateInviteExpiresAt = (
  now = new Date().toISOString(),
  days = DEFAULT_INVITE_EXPIRES_DAYS
) => {
  const date = new Date(now);
  date.setDate(date.getDate() + Number(days || DEFAULT_INVITE_EXPIRES_DAYS));
  return date.toISOString();
};

export const INVITE_LINK_SUCCESS_TOAST = "초대 링크가 생성되었습니다.";
export const INVITE_LINK_PERMISSION_DENIED_TOAST =
  "초대 링크를 저장할 권한이 없습니다. Firestore 권한을 확인해 주세요.";
export const INVITE_LINK_FAILED_PRECONDITION_TOAST =
  "Firestore 인덱스 설정이 필요합니다.";
export const INVITE_LINK_GENERAL_FAILURE_TOAST =
  "초대 링크를 생성하지 못했습니다. 다시 시도해 주세요.";
export const INVITE_LINK_CREATING_TOAST = "초대 링크를 생성하는 중입니다.";
export const INVITE_LINK_API_NOT_FOUND_TOAST =
  "초대 링크 생성 API를 찾을 수 없습니다. 배포 환경을 확인해 주세요.";
export const INVITE_LINK_RESPONSE_PARSE_TOAST =
  "초대 링크 생성 API 응답을 읽지 못했습니다. 배포 환경을 확인해 주세요.";
export const INVITE_LINK_ADMIN_PASSWORD_REQUIRED_TOAST =
  "초대 링크 생성을 위해 관리자 비밀번호 확인이 필요합니다.";
export const INVITE_LINK_SERVER_ENV_MISSING_TOAST =
  "초대 링크 생성 서버 설정이 누락되었습니다.";
export const INVITE_OWNER_HQ_VALUE = "HQ";
export const INVITE_OWNER_SALES_REP_PREFIX = "SALES_REP:";
export const INVITE_OWNER_HQ_LABEL = "본사 직접 관리";
export const INVITE_SALES_REP_NOT_FOUND_MESSAGE =
  "선택한 영업사원을 찾을 수 없습니다.";

export const resolveInviteAdminPassword = (
  statePassword = "",
  sessionPassword = ""
) => String(statePassword || "").trim() || String(sessionPassword || "").trim();

export const normalizeBusinessNumber = (value = "") =>
  String(value || "").replace(/[^0-9]/g, "");

export const getInviteCreateErrorToastMessage = (error) => {
  const code = error?.code || "";
  if (code === "permission-denied") return INVITE_LINK_PERMISSION_DENIED_TOAST;
  if (code === "failed-precondition") return INVITE_LINK_FAILED_PRECONDITION_TOAST;
  return INVITE_LINK_GENERAL_FAILURE_TOAST;
};

export const getInviteCreateApiFailureMessage = ({
  status = 0,
  result = null,
  jsonParseFailed = false,
} = {}) => {
  const code = result?.code || "";
  if (status === 404) return INVITE_LINK_API_NOT_FOUND_TOAST;
  if (jsonParseFailed) return INVITE_LINK_RESPONSE_PARSE_TOAST;
  if (code === "SERVER_ENV_MISSING") {
    return result?.message || INVITE_LINK_SERVER_ENV_MISSING_TOAST;
  }
  if (status === 401 || status === 403 || code === "permission-denied") {
    return result?.message || INVITE_LINK_ADMIN_PASSWORD_REQUIRED_TOAST;
  }
  if (code === "failed-precondition") return INVITE_LINK_FAILED_PRECONDITION_TOAST;
  return result?.message || INVITE_LINK_GENERAL_FAILURE_TOAST;
};

export const parseInviteOwnerValue = (value = "", fallbackSalesRepId = "") => {
  const raw = String(value || "").trim();
  const fallbackId = String(fallbackSalesRepId || "").trim();

  if (!raw) {
    return fallbackId
      ? {
          ownerType: "SALES_REP" as InviteOwnerType,
          salesRepId: fallbackId,
          ownerValue: `${INVITE_OWNER_SALES_REP_PREFIX}${fallbackId}`,
        }
      : {
          ownerType: "HQ" as InviteOwnerType,
          salesRepId: null,
          ownerValue: INVITE_OWNER_HQ_VALUE,
        };
  }

  if (raw === INVITE_OWNER_HQ_VALUE) {
    return {
      ownerType: "HQ" as InviteOwnerType,
      salesRepId: null,
      ownerValue: INVITE_OWNER_HQ_VALUE,
    };
  }

  if (raw.startsWith(INVITE_OWNER_SALES_REP_PREFIX)) {
    const salesRepId = raw.slice(INVITE_OWNER_SALES_REP_PREFIX.length).trim();
    return {
      ownerType: "SALES_REP" as InviteOwnerType,
      salesRepId,
      ownerValue: `${INVITE_OWNER_SALES_REP_PREFIX}${salesRepId}`,
    };
  }

  if (raw === "SALES_REP") {
    return {
      ownerType: "SALES_REP" as InviteOwnerType,
      salesRepId: fallbackId,
      ownerValue: `${INVITE_OWNER_SALES_REP_PREFIX}${fallbackId}`,
    };
  }

  return {
    ownerType: "HQ" as InviteOwnerType,
    salesRepId: null,
    ownerValue: INVITE_OWNER_HQ_VALUE,
  };
};

export const getInviteOwnerSelection = (draft = {}) => {
  if (draft?.ownerValue) {
    return parseInviteOwnerValue(draft.ownerValue, draft?.salesRepId || "");
  }
  if (draft?.ownerType === "HQ") {
    return parseInviteOwnerValue(INVITE_OWNER_HQ_VALUE);
  }
  if (draft?.ownerType === "SALES_REP" || draft?.salesRepId) {
    return parseInviteOwnerValue("SALES_REP", draft?.salesRepId || "");
  }
  return parseInviteOwnerValue(INVITE_OWNER_HQ_VALUE);
};

export const getInviteOwnerLabel = (invite = {}) => {
  const explicit = String(invite?.ownerLabel || "").trim();
  if (explicit) return explicit;
  if (invite?.ownerType === "HQ") return INVITE_OWNER_HQ_LABEL;

  const departmentPart = String(
    invite?.salesRepDepartmentPart || invite?.salesPart || ""
  ).trim();
  const salesRepName = String(invite?.salesRepName || "").trim();
  const salesLabel = [departmentPart, salesRepName].filter(Boolean).join(" - ");
  if (salesLabel) return salesLabel;
  if (invite?.salesRepId) return "담당 미지정";
  return INVITE_OWNER_HQ_LABEL;
};

export const buildInviteOwnerSnapshot = ({
  ownerType = "HQ",
  salesRep = null,
  ownerLabel = "",
} = {}) => {
  if (ownerType === "SALES_REP") {
    const departmentPart = getSalesRepPart(salesRep || {});
    const repPhone = formatPhoneNumberForDisplay(salesRep?.phone || "");
    const repName = String(salesRep?.name || "").trim();
    return {
      ownerType: "SALES_REP" as InviteOwnerType,
      ownerLabel:
        String(ownerLabel || "").trim() ||
        [departmentPart, repName].filter(Boolean).join(" - ") ||
        "담당 미지정",
      salesRepId: salesRep?.id || null,
      salesPart: departmentPart || null,
      salesRepDepartmentPart: departmentPart || null,
      salesRepName: repName || null,
      salesRepPhone: repPhone || null,
      salesRepPhoneMasked: repPhone ? maskPhoneNumber(repPhone) : null,
      salesRepEmail: String(salesRep?.email || "").trim() || null,
    };
  }

  return {
    ownerType: "HQ" as InviteOwnerType,
    ownerLabel: INVITE_OWNER_HQ_LABEL,
    salesRepId: null,
    salesPart: null,
    salesRepDepartmentPart: null,
    salesRepName: null,
    salesRepPhone: null,
    salesRepPhoneMasked: null,
    salesRepEmail: null,
  };
};

export const validateInviteLinkDraft = (
  draft = {},
  salesReps = [],
  { salesRepStorageSource = "FIRESTORE" } = {}
) => {
  const customerName = String(draft?.customerName || "").trim();
  const businessNumber = normalizeBusinessNumber(draft?.businessNumber || "");
  const expiresInDays = Number(draft?.expiresDays || DEFAULT_INVITE_EXPIRES_DAYS);
  const ownerSelection = getInviteOwnerSelection(draft);
  const activeSalesReps = getActiveSalesReps(salesReps);
  const selectedRep =
    ownerSelection.ownerType === "SALES_REP"
      ? activeSalesReps.find((rep) => rep.id === ownerSelection.salesRepId)
      : null;

  if (!customerName) {
    return { ok: false, message: "거래처명을 입력해 주세요." };
  }
  if (businessNumber && !/^\d{10}$/.test(businessNumber)) {
    return { ok: false, message: "사업자번호는 숫자 10자리로 입력해 주세요." };
  }
  if (
    ownerSelection.ownerType === "SALES_REP" &&
    salesRepStorageSource === "LOCAL_STORAGE_FALLBACK"
  ) {
    return {
      ok: false,
      code: "LOCAL_SALES_REP_INVITE_BLOCKED",
      message: SALES_REPS_LOCAL_INVITE_BLOCK_MESSAGE,
    };
  }
  if (ownerSelection.ownerType === "SALES_REP" && !selectedRep) {
    return {
      ok: false,
      code: "SALES_REP_NOT_FOUND",
      message: INVITE_SALES_REP_NOT_FOUND_MESSAGE,
    };
  }
  if (!Number.isFinite(expiresInDays) || expiresInDays <= 0) {
    return { ok: false, message: "초대 링크 유효기간을 선택해 주세요." };
  }

  const ownerSnapshot = buildInviteOwnerSnapshot({
    ownerType: ownerSelection.ownerType,
    salesRep: selectedRep,
  });

  return {
    ok: true,
    customerName,
    businessType: draft?.businessType === "corporate" ? "corporate" : "individual",
    businessNumber,
    ownerType: ownerSelection.ownerType,
    ownerLabel: ownerSnapshot.ownerLabel,
    salesRepId: ownerSnapshot.salesRepId,
    salesRep: selectedRep,
    expiresInDays,
    memo: String(draft?.memo || "").trim(),
  };
};

export const buildInviteDocument = ({
  token,
  customerName,
  businessType = "individual",
  businessNumber = "",
  salesRep = {},
  ownerType = "",
  ownerLabel = "",
  memo = "",
  now = new Date().toISOString(),
  expiresAt = calculateInviteExpiresAt(now),
} = {}) => {
  const normalizedBusinessType =
    businessType === "corporate" ? "corporate" : "individual";
  const normalizedOwnerType =
    ownerType === "HQ" || ownerType === "SALES_REP"
      ? ownerType
      : salesRep?.id
      ? "SALES_REP"
      : "HQ";
  const ownerSnapshot = buildInviteOwnerSnapshot({
    ownerType: normalizedOwnerType,
    salesRep,
    ownerLabel,
  });
  return {
    inviteId: createStableId("invite"),
    tokenHash: hashInviteToken(token),
    tokenLast4: String(token || "").slice(-4),
    status: "ACTIVE",
    customerName: String(customerName || "").trim(),
    customerType: normalizedBusinessType === "corporate" ? "BUSINESS" : "PERSONAL",
    businessType: normalizedBusinessType,
    businessNumber: String(businessNumber || "").trim(),
    ...ownerSnapshot,
    createdAt: now,
    sentAt: now,
    openedAt: null,
    submittedAt: null,
    expiresAt,
    openCount: 0,
    contractId: null,
    memo: String(memo || "").trim(),
  };
};

export const createInviteLinkResult = async ({
  draft = {},
  salesReps = [],
  salesRepStorageSource = "FIRESTORE",
  baseUrl = "",
  now = new Date().toISOString(),
  token = createInviteToken(),
  saveToFirestore,
} = {}) => {
  const validation = validateInviteLinkDraft(draft, salesReps, {
    salesRepStorageSource,
  });
  if (!validation.ok) {
    return {
      ok: false,
      invite: null,
      token: "",
      inviteUrl: "",
      smsMessage: "",
      toastMessage: validation.message,
      error: null,
    };
  }

  const invite = buildInviteDocument({
    token,
    customerName: validation.customerName,
    businessType: validation.businessType,
    businessNumber: validation.businessNumber,
    salesRep: validation.salesRep,
    ownerType: validation.ownerType,
    ownerLabel: validation.ownerLabel,
    memo: validation.memo,
    now,
    expiresAt: calculateInviteExpiresAt(now, validation.expiresInDays),
  });
  const inviteUrl = buildInviteUrl(baseUrl, token);

  try {
    if (typeof saveToFirestore !== "function") {
      throw new Error("초대 링크 서버 저장 함수가 없습니다.");
    }
    await saveToFirestore(invite);
    return {
      ok: true,
      invite,
      token,
      inviteUrl,
      smsMessage: buildInviteSmsMessage({ invite, inviteUrl }),
      toastMessage: INVITE_LINK_SUCCESS_TOAST,
      error: null,
    };
  } catch (error) {
    return {
      ok: false,
      invite: null,
      token: "",
      inviteUrl: "",
      smsMessage: "",
      toastMessage: getInviteCreateErrorToastMessage(error),
      error,
    };
  }
};

export const buildInviteSmsMessage = ({ invite = {}, inviteUrl = "" } = {}) => {
  const ownerFields = buildInviteContractFields(invite);
  const greeting =
    ownerFields.ownerType === "HQ"
      ? "안녕하세요. CN FOOD 본사입니다."
      : `안녕하세요. CN FOOD ${invite.salesPart || invite.salesRepDepartmentPart || ""} ${
          invite.salesRepName || ""
        }입니다.`;

  return `[CN FOOD 전자계약 안내]\n\n${greeting}\n\n${
    invite.customerName || "거래처"
  } 공급계약서 작성을 위해 아래 링크에서 전자계약을 진행해 주세요.\n\n작성 소요: 약 3~5분\n담당자: ${
    ownerFields.ownerLabel
  }${invite.salesRepPhone ? ` / ${invite.salesRepPhone}` : ""}\n\n${inviteUrl}`.trim();
};

export const buildInvitationSnapshot = (invite = {}) => ({
  customerName: invite.customerName || null,
  ownerType:
    invite.ownerType === "SALES_REP" || (!invite.ownerType && invite.salesRepId)
      ? "SALES_REP"
      : "HQ",
  ownerLabel: getInviteOwnerLabel(invite),
  salesPart: invite.salesPart || null,
  salesRepName: invite.salesRepName || null,
  salesRepPhoneMasked: invite.salesRepPhoneMasked || null,
  openedAt: invite.openedAt || null,
});

export const buildInviteContractFields = (invite = {}) => {
  const ownerType =
    invite?.ownerType === "SALES_REP" || (!invite?.ownerType && invite?.salesRepId)
      ? "SALES_REP"
      : "HQ";
  const ownerLabel = getInviteOwnerLabel(invite);
  const salesRepDepartmentPart =
    ownerType === "SALES_REP"
      ? invite?.salesRepDepartmentPart || invite?.salesPart || null
      : null;

  return {
    inviteId: invite?.inviteId || invite?.id || null,
    ownerType,
    ownerLabel,
    salesRepId: ownerType === "SALES_REP" ? invite?.salesRepId || null : null,
    salesPart: salesRepDepartmentPart,
    salesRepDepartmentPart,
    salesRepName: ownerType === "SALES_REP" ? invite?.salesRepName || null : null,
    salesRepPhone: ownerType === "SALES_REP" ? invite?.salesRepPhone || null : null,
    salesRepEmail: ownerType === "SALES_REP" ? invite?.salesRepEmail || null : null,
    salesRepPhoneMasked:
      ownerType === "SALES_REP" ? invite?.salesRepPhoneMasked || null : null,
  };
};

export const buildContractInviteMetadata = (invite = null) => {
  const fields = buildInviteContractFields(invite || {});
  return {
    ...fields,
    invitationSnapshot: invite ? buildInvitationSnapshot(invite) : null,
  };
};

export const getInviteStatusMessage = (invite = {}) => {
  if (!invite) return "";
  const status = String(invite.status || "").toLowerCase();
  if (status === "expired") return "유효기간이 만료된 초대 링크입니다.";
  if (status === "cancelled") return "취소된 초대 링크입니다.";
  if (status === "submitted" || status === "used")
    return "이미 제출 완료된 초대 링크입니다.";
  if (invite.expiresAt && new Date(invite.expiresAt).getTime() < Date.now()) {
    return "유효기간이 만료된 초대 링크입니다.";
  }
  return "";
};

export const isValidBizNumberFormat = (bizNo = "") => {
  return bizNo.replace(/[^0-9]/g, "").length === 10;
};

export const isValidPhoneNumberFormat = (phone = "") => {
  const cleaned = phone.replace(/[^0-9]/g, "");
  return cleaned.length >= 10 && cleaned.length <= 11;
};

export const isValidKcpMobilePhoneNumber = (phone = "") => {
  const cleaned = normalizePhoneDigits(phone);
  return /^01[016789]\d{7,8}$/.test(cleaned);
};

export const canProceedPhoneVerificationStep = (
  settings: ValidationSettings,
  phone: string,
  phoneVerified: boolean
) => {
  if (settings.enablePhoneVerification) return phoneVerified;
  return isValidPhoneNumberFormat(phone);
};

export const shouldShowIntroScreen = (
  viewMode: string,
  showIntroPage: boolean,
  step: number
) => viewMode === "FORM" && showIntroPage && step === 0;

export const CONTRACT_EXIT_HISTORY_STATE_KEY = "cnfoodContractExitGuard";

export const shouldGuardContractExitNavigation = ({
  viewMode = "FORM",
  showIntroPage = false,
  step = 0,
  isCorepInviteRoute = false,
  kcpReturnNavigationIntentActive = false,
  kcpReturnSyncState = KCP_RETURN_SYNC_STATES.IDLE,
}: {
  viewMode?: string;
  showIntroPage?: boolean;
  step?: number;
  isCorepInviteRoute?: boolean;
  kcpReturnNavigationIntentActive?: boolean;
  kcpReturnSyncState?: KcpReturnSyncState | string;
} = {}) =>
  viewMode === "FORM" &&
  showIntroPage === false &&
  Number(step) >= 0 &&
  Number(step) < 5 &&
  !isCorepInviteRoute &&
  !kcpReturnNavigationIntentActive &&
  kcpReturnSyncState !== KCP_RETURN_SYNC_STATES.CHECKING_STATUS;

export const isAdminViewMode = (viewMode = "") =>
  ["ADMIN_LOGIN", "LIST", "DETAIL", "DEBUG"].includes(String(viewMode || ""));

export const shouldShowTextSizeSelector = ({
  viewMode = "FORM",
  showIntroPage = false,
  step = 0,
  isCorepInviteRoute = false,
}: {
  viewMode?: string;
  showIntroPage?: boolean;
  step?: number;
  isCorepInviteRoute?: boolean;
} = {}) =>
  viewMode === "FORM" &&
  showIntroPage === true &&
  Number(step) === 0 &&
  !isCorepInviteRoute;

export const isCustomerIssueReportVisible = ({
  viewMode = "FORM",
  step = 0,
  showIntroPage = false,
}: {
  viewMode?: string;
  step?: number;
  showIntroPage?: boolean;
} = {}) =>
  viewMode === "FORM" &&
  !showIntroPage &&
  Number(step) >= 0 &&
  Number(step) <= 4;

export const createRuntimeLogFingerprint = ({
  eventType = "",
  message = "",
  source = "",
  lineno = "",
  colno = "",
  viewMode = "",
  adminTab = "",
  step = "",
  draftId = "",
  contractId = "",
}: Record<string, unknown> = {}) =>
  [
    eventType,
    message,
    source,
    lineno,
    colno,
    viewMode,
    adminTab,
    step,
    draftId || contractId || "no-draft",
  ]
    .map((part) =>
      String(part ?? "")
        .replace(/[0-9]{6}-?[0-9]{7}/g, "[rrn]")
        .replace(/01[016789]-?\d{3,4}-?\d{4}/g, "[phone]")
        .slice(0, 120)
    )
    .join(":");

export const shouldPersistNetworkOfflineLog = ({
  viewMode = "",
  adminTab = "",
  step = 0,
  draftId = "",
  contractId = "",
  visibilityState = "visible",
  offlineDurationMs = 0,
  wasCriticalActionInProgress = false,
  nowMs = Date.now(),
  seenFingerprints = new Map<string, number>(),
}: {
  viewMode?: string;
  adminTab?: string;
  step?: number;
  draftId?: string;
  contractId?: string;
  visibilityState?: string;
  offlineDurationMs?: number;
  wasCriticalActionInProgress?: boolean;
  nowMs?: number;
  seenFingerprints?: Map<string, number>;
} = {}) => {
  const fingerprint = createRuntimeLogFingerprint({
    eventType: "NETWORK_OFFLINE",
    viewMode,
    adminTab,
    step,
    draftId,
    contractId,
  });
  if (isAdminViewMode(viewMode)) {
    return { persist: false, reason: "admin-view", fingerprint, severity: "LOW" };
  }
  if (visibilityState === "hidden") {
    return { persist: false, reason: "hidden-tab", fingerprint, severity: "LOW" };
  }
  if (!wasCriticalActionInProgress && Number(offlineDurationMs || 0) < 3000) {
    return { persist: false, reason: "short-offline", fingerprint, severity: "LOW" };
  }
  const lastSeenAt = seenFingerprints.get(fingerprint) || 0;
  if (lastSeenAt && Number(nowMs) - lastSeenAt < 10 * 60 * 1000) {
    return { persist: false, reason: "duplicate", fingerprint, severity: "LOW" };
  }
  seenFingerprints.set(fingerprint, Number(nowMs));
  return {
    persist: true,
    reason: "persist",
    fingerprint,
    severity: wasCriticalActionInProgress ? "HIGH" : "LOW",
  };
};

export const getOtpPhoneNumberFromForm = (formData = {}) => {
  return typeof formData.agentContact === "string"
    ? formData.agentContact.trim()
    : "";
};

export const toFirebaseKoreanPhoneNumber = (phone = "") => {
  const cleaned = String(phone || "").replace(/[^0-9]/g, "");
  if (cleaned.startsWith("82")) return `+${cleaned}`;
  return "+82" + (cleaned.startsWith("0") ? cleaned.slice(1) : cleaned);
};

export const getPhoneAuthErrorMessage = (error = {}) => {
  const code = String(error?.code || "");
  const message = String(error?.message || "").toLowerCase();
  const joined = `${code} ${message}`;

  if (
    joined.includes("captcha-check-failed") ||
    joined.includes("hostname match not found")
  ) {
    return "휴대폰 인증 보안 검증에 실패했습니다. 배포 주소와 Firebase 허용 도메인 설정을 확인해 주세요.";
  }

  if (joined.includes("billing-not-enabled")) {
    return "휴대폰 인증 발송이 현재 프로젝트 결제 설정 때문에 비활성화되어 있습니다. Firebase Billing/Blaze 설정을 확인해 주세요.";
  }

  if (joined.includes("invalid-phone-number")) {
    return "전화번호 형식을 확인해 주세요.";
  }

  if (
    joined.includes("too-many-requests") ||
    joined.includes("quota") ||
    joined.includes("rate-limit")
  ) {
    return "요청이 많아 잠시 후 다시 시도해 주세요.";
  }

  return "인증번호 발송에 실패했습니다. 잠시 후 다시 시도해 주세요.";
};

export const EVIDENCE_VERSION = "v1";
export const STRICT_IDENTITY_EVIDENCE_VERSION = "rep-corep-strict-v1";
export const LEGACY_CONTRACT_DOCUMENT_VERSION = "CNFOOD_SUPPLY_TERMS_V2_2026-05-19";
export const CONTRACT_DOCUMENT_VERSION = "CNFOOD_SUPPLY_TERMS_V2_2026-09-11";
export const DEFAULT_CONTRACT_TEMPLATE_TITLE = "씨앤푸드 공급계약서";

export type ContractClause = {
  id: string;
  title: string;
  body: string;
};

export const CANONICAL_CONTRACT_TERMS: ContractClause[] = [
  {
    id: "article_1",
    title: "제1조 【거래계약의 목적】",
    body: [
      "본 계약은 주식회사 씨앤푸드, 농업회사법인 주식회사 씨앤푸드 및 그 관계회사 또는 지정 공급자(이하 “공급자”)와 거래처 또는 구매자(이하 “구매자”) 사이에 발생하는 수산물, 축산물, 식품, 가공품 및 기타 관련 상품의 공급 거래에 관한 기본 조건을 정함을 목적으로 한다.",
      "",
      "공급자와 구매자는 본 계약, 개별 주문, 거래명세서, 세금계산서, 견적서, 발주서, 문자, 메신저, 전자문서 등 당사자 사이에 확인 가능한 거래자료에 따라 성실하게 거래를 이행한다.",
      "",
      "본 계약은 계속적 거래를 위한 기본계약이며, 개별 거래에 관하여 별도 합의가 있는 경우 그 별도 합의가 본 계약과 충돌하지 않는 범위에서 우선 적용된다.",
    ].join("\n"),
  },
  {
    id: "article_2",
    title: "제2조 【판매물품 및 거래범위】",
    body: [
      "① 공급자가 구매자에게 공급하는 물품은 수산물, 축산물, 식품, 가공품, 포장품 및 기타 당사자가 협의한 상품으로 한다.",
      "② 품목, 수량, 단가, 납품일, 납품장소, 결제조건 등 개별 거래조건은 발주서, 거래명세서, 견적서, 세금계산서, 전산자료, 문자, 메신저 등 확인 가능한 자료에 따른다.",
      "③ 공급자는 상품의 수급상황, 산지 가격, 재고, 원가, 계절적 요인, 품질, 물류상황 등에 따라 공급 가능 품목, 공급 수량, 납품 일정 및 가격 조건을 조정할 수 있다. 다만, 주요 변경사항은 가능한 범위에서 구매자에게 안내한다.",
      "④ 구매자는 공급받은 상품을 통상적인 거래 목적과 관계 법령에 맞게 보관, 취급, 판매하여야 하며, 위생, 냉장, 냉동, 보관, 유통 기준을 준수하여야 한다.",
    ].join("\n"),
  },
  {
    id: "article_3",
    title: "제3조 【계약기간】",
    body: [
      "① 본 계약의 유효기간은 계약 체결일로부터 1년으로 한다.",
      "② 계약기간 만료 1개월 전까지 어느 일방이 서면, 문자, 전자문서 등 확인 가능한 방법으로 계약 종료 의사를 표시하지 않는 경우, 본 계약은 동일한 조건으로 1년씩 자동 연장되는 것으로 한다.",
      "③ 계약기간의 만료 또는 계약 해지 이후에도 이미 발생한 물품대금, 반품, 클레임, 손해배상, 비밀유지, 증빙보존 및 사후 정산에 관한 의무는 그 이행이 완료될 때까지 유효하게 존속한다.",
    ].join("\n"),
  },
  {
    id: "article_4",
    title: "제4조 【판매대금의 지급】",
    body: [
      "① 구매자는 공급자가 발행한 거래명세서, 세금계산서, 청구서 또는 당사자가 별도로 합의한 결제조건에 따라 판매대금을 지급하여야 한다.",
      "② 결제일은 당사자가 별도로 정한 결제일 또는 거래 관행에 따른다. 별도 약정이 없는 경우 구매자는 공급자의 청구일 또는 세금계산서 발행일을 기준으로 합리적인 기한 내에 판매대금을 지급하여야 한다.",
      "③ 구매자가 지급기일을 경과하여 판매대금을 지급하지 않는 경우, 구매자는 지급기일 다음 날부터 완제일까지 미지급 판매대금에 대하여 연 12%의 비율로 계산한 지연손해금을 공급자에게 지급한다. 다만, 관계 법령상 허용되는 범위를 초과하는 경우에는 그 허용 범위 내에서 적용한다.",
      "④ 구매자가 대금 지급을 지체하거나 신용상태가 현저히 악화된 경우, 공급자는 추가 공급을 보류하거나 현금결제, 선결제, 담보 제공, 보증보험 가입, 거래한도 축소 등 합리적인 거래조건 변경을 요구할 수 있다.",
      "⑤ 구매자는 공급자의 사전 동의 없이 판매대금 채무를 제3자에게 이전하거나 임의로 상계, 공제할 수 없다. 다만, 당사자가 서면 또는 전자문서로 별도 합의한 경우에는 예외로 한다.",
    ].join("\n"),
  },
  {
    id: "article_5",
    title: "제5조 【판매가격의 조정】",
    body: [
      "① 상품의 원가, 산지 가격, 환율, 인건비, 물류비, 포장비, 시장상황, 계절적 요인 또는 수급상황이 변동되는 경우 공급자는 판매가격을 조정할 수 있다.",
      "② 공급자는 가격 조정이 필요한 경우 가능한 범위에서 구매자에게 사전 안내한다. 다만, 긴급한 수급 변동, 산지 가격 급등락, 물류상황 변화 등 사전 안내가 어려운 경우 사후 안내할 수 있다.",
      "③ 구매자가 조정 가격에 이의가 있는 경우 해당 조정 가격이 적용되는 발주 또는 납품 전에 공급자에게 이의를 제기하여야 한다. 이의 제기 없이 발주하거나 상품을 수령한 경우 해당 가격에 동의한 것으로 본다.",
      "④ 가격 조정은 이미 납품이 완료된 상품에는 소급 적용하지 않는 것을 원칙으로 한다. 다만, 당사자가 별도로 합의한 경우에는 예외로 한다.",
    ].join("\n"),
  },
  {
    id: "article_6",
    title: "제6조 【납품, 검수 및 위험부담】",
    body: [
      "① 공급자는 당사자가 정한 납품장소와 납품일정에 따라 상품을 공급한다. 다만, 천재지변, 교통상황, 산지 수급, 물류 지연, 기상 악화, 관계기관 조치 등 공급자의 합리적 통제를 벗어난 사유가 발생한 경우 납품 일정은 조정될 수 있다.",
      "② 구매자는 상품을 인도받은 즉시 품목, 수량, 외관, 포장상태, 온도, 품질 이상 여부를 확인하여야 한다.",
      "③ 구매자가 상품을 수령한 이후 보관, 취급, 진열, 판매, 재포장, 가공 또는 이동 과정에서 발생한 손상, 변질, 품질저하는 구매자의 책임으로 한다. 다만, 상품 자체의 하자 또는 공급자의 귀책사유가 명백한 경우에는 그러하지 아니하다.",
      "④ 신선식품, 냉장·냉동식품, 수산물, 축산물 등 시간과 보관상태에 따라 품질이 변동될 수 있는 상품은 수령 즉시 검수하여야 하며, 구매자는 이상 발견 시 지체 없이 공급자에게 통보하고 확인 가능한 자료를 제공하여야 한다.",
    ].join("\n"),
  },
  {
    id: "article_7",
    title: "제7조 【반품, 교환 및 클레임 처리】",
    body: [
      "① 상품의 하자, 오배송, 수량 차이, 파손, 변질 등 이상이 있는 경우 구매자는 수령 후 지체 없이 공급자에게 통보하고, 사진, 영상, 보관상태, 거래명세서 등 확인 가능한 자료를 제공하여야 한다.",
      "② 공급자의 귀책으로 확인되는 오배송, 하자, 수량 부족 등의 경우 공급자는 교환, 회수, 재공급, 대금 조정 등 합리적인 방법으로 처리한다.",
      "③ 다음 각 호의 경우 반품 또는 교환이 제한될 수 있다.",
      "",
      "구매자의 보관, 취급, 진열, 판매 과정에서 상품이 훼손되거나 변질된 경우",
      "구매자가 상품을 사용, 조리, 가공, 포장 개봉, 재판매 또는 소비한 경우",
      "수령 후 상당한 시간이 경과하여 상품 상태와 원인 확인이 어려운 경우",
      "구매자의 단순 변심, 판매 부진, 주문 착오에 따른 반품 요청인 경우",
      "주문제작, 특가, 행사, 한정수량, 별도 합의 품목 등 반품 제한 조건이 사전에 안내된 경우",
      "구매자의 위생, 냉장, 냉동, 보관 기준 미준수로 품질 문제가 발생한 경우",
      "",
      "④ 관계 법령상 공급자의 책임이 명백한 경우에는 본 조의 반품 제한에도 불구하고 관계 법령과 당사자 협의에 따라 처리한다.",
      "⑤ 클레임 처리 과정에서 당사자는 상품 상태, 보관 환경, 인도 시점, 사진, 영상, 거래기록 등 객관적 자료를 기준으로 원인을 확인한다.",
    ].join("\n"),
  },
  {
    id: "article_8",
    title: "제8조 【담보, 보증보험 및 신용보강】",
    body: [
      "① 공급자는 구매자의 거래규모, 미수금, 신용상태, 결제이력, 거래위험 등을 고려하여 보증보험, 담보 제공, 선결제, 거래한도 설정 등 합리적인 신용보강 조치를 요구할 수 있다.",
      "② 구매자는 공급자가 요청하는 경우 필요한 범위에서 보증보험 가입, 담보 제공, 결제조건 조정 등 신용보강 조치에 협조하여야 한다.",
      "③ 공급자는 구매자의 미수금 증가, 결제 지연, 신용상태 악화, 거래조건 위반 등 거래위험이 증가한 경우 추가 공급을 보류하거나 거래조건 변경을 요구할 수 있다.",
      "④ 공동계약인이 필요한 경우 공동계약인은 계약 참여 범위와 책임 내용을 별도로 확인하고 명시적으로 동의하여야 한다. 공동계약인의 확인 없이 본 계약만으로 공동계약인 책임이 발생하지 않는다.",
    ].join("\n"),
  },
  {
    id: "article_9",
    title: "제9조 【신용정보 및 개인정보 처리】",
    body: [
      "① 공급자는 거래 개시, 거래한도 설정, 미수금 관리, 채권보전, 분쟁 대응 등 거래 관리에 필요한 범위에서 구매자 또는 관련자의 사업자정보, 연락처, 거래정보, 결제정보, 본인확인 결과 및 전자계약 증빙자료를 수집·이용할 수 있다.",
      "② 개인신용정보 조회, 신용평가, 보증보험, 채권보전 등 별도 동의가 필요한 사항은 구매자 또는 관련자의 별도 동의를 받은 범위에서 처리한다.",
      "③ 공급자는 수집한 정보를 계약 이행, 거래 관리, 법령상 의무 이행, 분쟁 대응 및 증빙 보존 목적 범위 내에서 보관·이용하며, 보관기간이 경과하거나 처리 목적이 달성된 경우 관계 법령 및 내부 기준에 따라 파기 또는 분리 보관한다.",
      "④ 구매자는 계약 체결 및 거래 이행에 필요한 정보가 정확하게 입력되도록 협조하여야 하며, 정보 변경이 있는 경우 지체 없이 공급자에게 알려야 한다.",
    ].join("\n"),
  },
  {
    id: "article_10",
    title: "제10조 【영업비밀, 지식재산권 및 자료관리】",
    body: [
      "① 공급자와 구매자는 거래 과정에서 알게 된 상대방의 가격, 거래조건, 고객정보, 영업자료, 품질자료, 전산자료, 계약정보 등 비공개 정보를 상대방의 사전 동의 없이 제3자에게 제공하거나 목적 외로 사용하여서는 아니 된다.",
      "② 상품의 상표, 로고, 사진, 상세설명, 홍보자료, 전산자료, 문서 양식 등 지식재산권은 권리자에게 귀속된다.",
      "③ 구매자는 공급자의 상품 또는 자료를 무단 복제, 변형, 허위 표시, 오인 표시, 임의 재판매 조건 변경 등 부정한 방법으로 사용하여서는 아니 된다.",
      "④ 본 조의 의무는 계약 종료 후에도 유효하게 존속한다.",
    ].join("\n"),
  },
  {
    id: "article_11",
    title: "제11조 【계약의 해지 및 거래중지】",
    body: [
      "① 당사자 일방이 본 계약 또는 개별 거래조건을 위반하고, 상대방이 상당한 기간을 정하여 시정을 요청하였음에도 이를 시정하지 않는 경우 상대방은 본 계약을 해지하거나 거래를 중지할 수 있다.",
      "② 다음 각 호의 사유가 발생한 경우 공급자는 사전 통지 후 거래를 중지하거나 계약을 해지할 수 있다. 다만, 긴급한 손해 확대 방지가 필요한 경우 사후 통지할 수 있다.",
      "",
      "구매자가 판매대금을 지체하거나 지급불능 우려가 있는 경우",
      "구매자의 신용상태가 현저히 악화된 경우",
      "구매자가 허위 정보 또는 중요한 사실을 누락하여 계약한 경우",
      "구매자가 공급자의 상품, 상표, 영업정보를 부정하게 사용한 경우",
      "구매자가 관계 법령, 위생·보관 기준 또는 본 계약의 주요 의무를 위반한 경우",
      "기타 거래를 계속하기 어려운 중대한 사유가 발생한 경우",
      "",
      "③ 계약이 해지되더라도 해지 전 이미 발생한 판매대금, 반품, 손해배상, 비밀유지, 증빙 보존 등 사후 정산 의무는 소멸하지 않는다.",
    ].join("\n"),
  },
  {
    id: "article_12",
    title: "제12조 【불가항력】",
    body: [
      "① 천재지변, 화재, 전쟁, 감염병, 정부 또는 관계기관의 조치, 물류 중단, 산지 수급 중단, 정전, 통신장애, 시스템 장애, 기상 악화, 기타 당사자의 합리적 통제를 벗어난 사유로 계약 이행이 지연되거나 불가능한 경우 해당 당사자는 그 책임을 면할 수 있다.",
      "② 불가항력 사유가 발생한 당사자는 가능한 범위에서 상대방에게 그 사실을 통지하고 손해 확대 방지를 위해 합리적으로 노력하여야 한다.",
      "③ 불가항력 상태가 장기간 지속되어 계약 목적 달성이 현저히 곤란한 경우 당사자는 협의하여 거래조건 변경, 납품 일정 조정 또는 계약 종료 여부를 결정할 수 있다.",
    ].join("\n"),
  },
  {
    id: "article_13",
    title: "제13조 【전자계약, 전자서명 및 증빙보존】",
    body: [
      "① 본 계약은 전자문서 및 전자서명 방식으로 체결될 수 있으며, 구매자는 본인확인, 계약내용 확인, 필수 동의, 전자서명 및 제출 절차를 거쳐 본 계약을 체결한다.",
      "② 전자계약 체결 과정에서 생성되는 본인확인 결과, 서명정보, 계약 Hash, 서명 Hash, 제출시각, 접속기록, 동의내역, 계약서 Snapshot, PDF Hash 등은 계약 체결 사실, 계약 내용의 무결성 및 분쟁 대응을 위한 증빙자료로 보관될 수 있다.",
      "③ 구매자는 전자계약 화면에서 표시되는 계약 내용을 충분히 확인한 후 전자서명하여야 하며, 전자서명 완료 후 제출된 계약은 당사자 사이에 유효한 계약으로 취급된다.",
      "④ 공급자는 전자계약 증빙자료를 법령상 의무 이행, 계약 이행, 거래 관리 및 분쟁 대응에 필요한 기간 동안 보관할 수 있다.",
    ].join("\n"),
  },
  {
    id: "article_14",
    title: "제14조 【계약정보 정정 및 증빙】",
    body: [
      "① 구매자가 입력한 상호명, 연락처, 사업자 정보 등에 오기 또는 표기상 오류가 있는 경우, 공급자는 사업자등록증, 사업자등록 상태 확인, 고객 통화 확인 등 객관적 근거에 따라 해당 정보를 정정할 수 있다.",
      "② 제1항의 정정은 계약 당사자의 동일성이 유지되는 범위에서 단순 오기 또는 표기상 오류를 보정하기 위한 것으로 하며, 사업자번호 변경, 대표자 변경, 계약 당사자 변경 등 실질적 변경이 필요한 경우에는 별도 확인 또는 계약 재작성이 필요할 수 있다.",
      "③ 공급자는 정정 전 입력값, 정정 후 값, 정정 사유, 정정 근거, 정정자 및 정정시각을 별도 이력으로 보관한다.",
      "④ 본 조에 따른 정정은 기존 전자서명 시점의 계약 Hash, 서명 Hash, 계약 Snapshot 및 감사기록을 변경하지 않으며, 정정 이력은 분쟁 대응 및 증빙자료로 활용될 수 있다.",
    ].join("\n"),
  },
  {
    id: "article_15",
    title: "제15조 【분쟁해결 및 관할】",
    body: [
      "① 본 계약과 관련하여 분쟁이 발생한 경우 당사자는 우선 성실한 협의를 통해 해결하도록 노력한다.",
      "② 협의로 해결되지 않는 분쟁에 대하여는 민사소송법 등 관계 법령에서 정한 관할법원에 소를 제기할 수 있다. 다만, 당사자가 별도로 합의한 경우 공급자의 본점 소재지를 관할하는 법원을 제1심 관할법원으로 할 수 있다.",
      "③ 본 계약에 명시되지 않은 사항은 관계 법령, 상관례 및 당사자 간 개별 합의에 따른다.",
      "④ 본 계약의 일부 조항이 무효 또는 집행 불가능하게 되더라도, 나머지 조항의 효력에는 영향을 미치지 않는다.",
    ].join("\n"),
  },
];

// 기존 export를 유지하면서 화면/출력 모두 하나의 canonical 조항 배열을 사용한다.
export const CNFOOD_SUPPLY_TERMS_V2_CLAUSES = CANONICAL_CONTRACT_TERMS;

const LEGACY_DEFAULT_ARTICLE_4_BODY =
  "① 구매자는 공급자가 발행한 거래명세서, 세금계산서, 청구서 또는 당사자가 별도로 합의한 결제조건에 따라 판매대금을 지급하여야 한다.\n② 결제일은 당사자가 별도로 정한 결제일 또는 거래 관행에 따른다. 별도 약정이 없는 경우 구매자는 공급자의 청구일 또는 세금계산서 발행일을 기준으로 합리적인 기한 내에 판매대금을 지급하여야 한다.\n③ 구매자가 지급기일을 경과하여 판매대금을 지급하지 않는 경우, 공급자는 미수금 지급을 요청할 수 있으며, 관계 법령상 허용되는 범위에서 지연손해금, 회수비용 또는 그 밖의 손해를 청구할 수 있다.\n④ 구매자가 대금 지급을 지체하거나 신용상태가 현저히 악화된 경우, 공급자는 추가 공급을 보류하거나 현금결제, 선결제, 담보 제공, 보증보험 가입, 거래한도 축소 등 합리적인 거래조건 변경을 요구할 수 있다.\n⑤ 구매자는 공급자의 사전 동의 없이 판매대금 채무를 제3자에게 이전하거나 임의로 상계, 공제할 수 없다. 다만, 당사자가 서면 또는 전자문서로 별도 합의한 경우에는 예외로 한다.";

const LEGACY_DEFAULT_CONTRACT_CLAUSES: ContractClause[] =
  CNFOOD_SUPPLY_TERMS_V2_CLAUSES.map((clause) =>
    clause.id === "article_4"
      ? { ...clause, body: LEGACY_DEFAULT_ARTICLE_4_BODY }
      : { ...clause }
  );

export type PrintableContractType =
  | "CORPORATION_SINGLE"
  | "CORPORATION_JOINT_REP"
  | "SOLE_PROPRIETOR_SINGLE"
  | "SOLE_PROPRIETOR_JOINT";

// The electronic-contract party types remain unchanged. Blank field prints use
// this deliberately smaller, paper-only model and never persist its fields.
export type PrintableFieldOutputType = "CORPORATION" | "SOLE_PROPRIETOR";

export type ContractRenderMode = "SCREEN" | "PRINT";

type PrintableContractPartyDefinition = {
  type: PrintableContractType;
  label: string;
  title: string;
  businessFields: string[];
  addressField: string;
  signers: string[];
  acknowledgement: string;
};

export const PRINTABLE_CONTRACT_TYPE_OPTIONS: Array<{
  value: PrintableContractType;
  label: string;
}> = [
  { value: "CORPORATION_SINGLE", label: "법인 - 대표자 1인" },
  { value: "CORPORATION_JOINT_REP", label: "법인 - 공동대표 2인" },
  { value: "SOLE_PROPRIETOR_SINGLE", label: "개인사업자 - 1인" },
  { value: "SOLE_PROPRIETOR_JOINT", label: "개인사업자 - 공동사업자 2인" },
];

type PrintableFieldPersonBlock = {
  heading: string;
  fields: string[];
};

type PrintableFieldBuyerDefinition = {
  type: PrintableFieldOutputType;
  label: string;
  title: string;
  businessHeading: string;
  businessFields: string[];
  people: PrintableFieldPersonBlock[];
};

const FIELD_PRINT_PERSON_FIELDS = [
  "성명",
  "주민등록번호",
  "휴대전화",
  "자택 주소",
  "서명 또는 날인 (인)",
];

export const FIELD_PRINT_OUTPUT_TYPE_OPTIONS: Array<{
  value: PrintableFieldOutputType;
  label: string;
}> = [
  { value: "CORPORATION", label: "법인" },
  { value: "SOLE_PROPRIETOR", label: "개인사업자" },
];

export const getPrintableFieldPartyDefinition = (
  type: PrintableFieldOutputType
): PrintableFieldBuyerDefinition => {
  if (type === "SOLE_PROPRIETOR") {
    return {
      type,
      label: "개인사업자",
      title: "공급받는자 - 개인사업자",
      businessHeading: "개인사업자 정보",
      businessFields: [
        "상호명",
        "사업자등록번호",
        "사업장 주소",
        "업태",
        "종목",
        "사업장 전화",
      ],
      people: [
        { heading: "대표자 정보", fields: [...FIELD_PRINT_PERSON_FIELDS] },
        { heading: "공동계약인 1", fields: [...FIELD_PRINT_PERSON_FIELDS] },
        { heading: "공동계약인 2", fields: [...FIELD_PRINT_PERSON_FIELDS] },
      ],
    };
  }

  return {
    type: "CORPORATION",
    label: "법인",
    title: "공급받는자 - 법인",
    businessHeading: "법인 정보",
    businessFields: [
      "법인명",
      "사업자등록번호",
      "법인등록번호",
      "사업장 주소",
      "본점 주소",
      "대표전화",
    ],
    people: [
      { heading: "대표자 정보", fields: [...FIELD_PRINT_PERSON_FIELDS] },
      { heading: "공동대표자 1", fields: [...FIELD_PRINT_PERSON_FIELDS] },
      { heading: "공동대표자 2", fields: [...FIELD_PRINT_PERSON_FIELDS] },
      { heading: "공동대표자 3", fields: [...FIELD_PRINT_PERSON_FIELDS] },
    ],
  };
};

export const getPrintableContractPartyDefinition = (
  type: PrintableContractType
): PrintableContractPartyDefinition => {
  switch (type) {
    case "CORPORATION_JOINT_REP":
      return {
        type,
        label: "법인 - 공동대표 2인",
        title: "구매자 - 법인 공동대표",
        businessFields: ["법인명", "사업자등록번호", "연락처"],
        addressField: "법인 주소",
        signers: ["공동대표자 1", "공동대표자 2"],
        acknowledgement:
          "위 공동대표자들은 해당 법인을 대표하여 본 공급계약의 내용을 확인하고 이에 동의하여 각각 서명 또는 날인합니다.",
      };
    case "SOLE_PROPRIETOR_SINGLE":
      return {
        type,
        label: "개인사업자 - 1인",
        title: "구매자 - 개인사업자",
        businessFields: ["상호", "사업자등록번호", "대표자 성명", "연락처"],
        addressField: "사업장 주소",
        signers: ["대표자"],
        acknowledgement:
          "위 구매자는 본 공급계약의 내용을 확인하고 이에 동의하여 서명 또는 날인합니다.",
      };
    case "SOLE_PROPRIETOR_JOINT":
      return {
        type,
        label: "개인사업자 - 공동사업자 2인",
        title: "구매자 - 개인 공동사업자",
        businessFields: ["상호", "사업자등록번호", "연락처"],
        addressField: "사업장 주소",
        signers: ["대표공동사업자", "공동사업자 2"],
        acknowledgement:
          "위 대표공동사업자 및 공동사업자는 본 계약의 구매자 측 공동사업자로서 계약 내용을 확인하고 이에 동의하여 각각 서명 또는 날인합니다.",
      };
    case "CORPORATION_SINGLE":
    default:
      return {
        type: "CORPORATION_SINGLE",
        label: "법인 - 대표자 1인",
        title: "구매자",
        businessFields: ["법인명", "사업자등록번호", "대표자 성명", "연락처"],
        addressField: "법인 주소",
        signers: ["대표자"],
        acknowledgement:
          "위 구매자는 본 공급계약의 내용을 확인하고 이에 동의하여 서명 또는 날인합니다.",
      };
  }
};

export const buildPrintableContractSupplierInfo = (branch: any = null) => {
  const branchSnapshot = buildContractCompanyBranchSnapshot({ branch });
  return buildSupplierInfoSnapshot({
    companyName:
      branchSnapshot.corporationName || branchSnapshot.branchName || CNFOOD_BUSINESS_PROFILE.companyName,
    businessNumber: branchSnapshot.businessNumber || CNFOOD_BUSINESS_PROFILE.businessNumber,
    representativeName:
      branchSnapshot.representativeName || CNFOOD_BUSINESS_PROFILE.representativeName,
    mainPhone: branch?.phone || CNFOOD_BUSINESS_PROFILE.mainPhone,
    businessAddress: branchSnapshot.address || CNFOOD_BUSINESS_PROFILE.businessAddress,
  });
};

export const resolvePrintableFieldSupplierSealUrl = (branch: any = null) => {
  const sealIdentity = pickSalesLookupString(branch?.sealUrl, branch?.sealIdentity);
  if (sealIdentity === SEAL_URL_1 || sealIdentity === "SEAL_URL_1") return SEAL_URL_1;
  if (sealIdentity === SEAL_URL_2 || sealIdentity === "SEAL_URL_2") return SEAL_URL_2;

  const businessNumber = String(
    buildContractCompanyBranchSnapshot({ branch }).businessNumber || ""
  ).replace(/\D/g, "");
  if (businessNumber === "6278501397") return SEAL_URL_1;
  if (businessNumber === "3438800695") return SEAL_URL_2;
  return SEAL_URL_2;
};

export const buildPrintableFieldContractModel = ({
  outputType,
  clauses,
  branch = null,
  supplierMode = "DEFAULT_DUAL",
}: {
  outputType: PrintableFieldOutputType;
  clauses: ContractClause[];
  branch?: any;
  supplierMode?: PrintableFieldSupplierMode;
}) => {
  const resolvedSupplierMode =
    supplierMode === "EXPLICIT_BRANCH" && branch ? "EXPLICIT_BRANCH" : "DEFAULT_DUAL";
  const suppliers =
    resolvedSupplierMode === "EXPLICIT_BRANCH"
      ? [
          {
            ...buildPrintableContractSupplierInfo(branch),
            sealUrl: resolvePrintableFieldSupplierSealUrl(branch),
            includePhone: true,
          },
        ]
      : DEFAULT_FIELD_PRINT_SUPPLIERS.map((supplier) => ({ ...supplier }));

  return {
    title: "공급계약서",
    contractDatePlaceholder: "20____년 ____월 ____일",
    buyer: getPrintableFieldPartyDefinition(outputType),
    supplierMode: resolvedSupplierMode,
    suppliers,
    // Backward-compatible supplier projection for non-print callers; print rendering uses suppliers.
    supplier: suppliers[suppliers.length - 1],
    // Callers pass the resolved electronic-contract clauses; do not duplicate or transform legal text.
    clauses,
  };
};

const ContractTermsRenderer = ({
  terms,
  mode = "SCREEN",
}: {
  terms: ContractClause[];
  mode?: ContractRenderMode;
}) => (
  <div
    data-contract-terms-renderer={mode}
    className={mode === "PRINT" ? "space-y-4" : "space-y-3"}
  >
    {terms.map((clause) => (
      <section
        key={clause.id}
        className={mode === "PRINT" ? "cnfood-print-avoid-break" : "break-keep"}
      >
        <h3 className="font-black text-slate-900">{clause.title}</h3>
        <p className="mt-1 whitespace-pre-line leading-7 text-slate-700">{clause.body}</p>
      </section>
    ))}
  </div>
);

export const FIELD_PRINT_PRINT_STYLES = `
  @page { size: A4 portrait; margin: 0; }
  @media screen and (max-width: 700px) {
    .cnfood-field-contract-page { width: 100% !important; height: auto !important; min-width: 0 !important; }
  }
  @media print {
    html, body { width: 210mm !important; max-width: 210mm !important; min-height: 297mm !important; margin: 0 !important; padding: 0 !important; overflow: visible !important; box-sizing: border-box !important; }
    body { background: #fff !important; }
    body * { visibility: hidden !important; }
    .cnfood-field-print-overlay, .cnfood-field-print-dialog, .cnfood-field-print-preview-shell, .cnfood-field-contract-print, .cnfood-field-contract-document, .cnfood-field-contract-page { box-sizing: border-box !important; }
    .cnfood-field-print-overlay, .cnfood-field-print-dialog, .cnfood-field-print-preview-shell, .cnfood-field-contract-print, .cnfood-field-contract-document, .cnfood-field-contract-page, .cnfood-field-contract-print * { visibility: visible !important; }
    .cnfood-field-print-overlay { position: static !important; display: block !important; inset: auto !important; width: 210mm !important; max-width: 210mm !important; min-height: 0 !important; margin: 0 !important; padding: 0 !important; border: 0 !important; background: #fff !important; overflow: visible !important; }
    .cnfood-field-print-dialog { display: block !important; width: 210mm !important; max-width: 210mm !important; max-height: none !important; margin: 0 !important; padding: 0 !important; border: 0 !important; overflow: visible !important; border-radius: 0 !important; background: #fff !important; box-shadow: none !important; }
    .cnfood-field-print-preview-shell { display: block !important; width: 210mm !important; max-width: 210mm !important; margin: 0 !important; padding: 0 !important; border: 0 !important; overflow: visible !important; border-radius: 0 !important; background: #fff !important; }
    .cnfood-field-contract-print { position: static !important; display: block !important; width: 210mm !important; min-width: 210mm !important; max-width: 210mm !important; margin: 0 !important; padding: 0 !important; border: 0 !important; overflow: visible !important; }
    .cnfood-field-contract-document { display: block !important; width: 210mm !important; min-width: 210mm !important; max-width: 210mm !important; margin: 0 !important; padding: 0 !important; border: 0 !important; overflow: visible !important; background: #fff !important; box-shadow: none !important; }
    .cnfood-field-contract-page { display: block !important; width: 210mm !important; height: 297mm !important; min-width: 210mm !important; max-width: 210mm !important; margin: 0 !important; padding: 0 !important; border: 0 !important; overflow: visible !important; break-after: page; page-break-after: always; object-fit: contain !important; }
    .cnfood-field-contract-page:last-child { break-after: auto; page-break-after: auto; }
    .cnfood-field-print-controls, .cnfood-field-print-help { display: none !important; }
  }
`;

const PrintableFieldContract = ({
  pages,
}: {
  pages: string[];
}) => {
  return (
    <section className="cnfood-field-contract-print" data-field-print-contract="true">
      <style>{FIELD_PRINT_PRINT_STYLES}</style>
      <article className="cnfood-field-contract-document mx-auto w-[210mm] max-w-none bg-white shadow-sm">
        {pages.map((page, index) => (
          <img
            key={`${index}-${page.slice(-24)}`}
            src={page}
            alt={`빈 공급계약서 ${index + 1}쪽`}
            className="cnfood-field-contract-page block h-[297mm] w-[210mm] object-contain"
          />
        ))}
      </article>
    </section>
  );
};

export type ContractTemplate = {
  versionId: string;
  status?: "ACTIVE" | "FALLBACK" | string;
  title: string;
  clauses: ContractClause[];
  source?: "FIRESTORE" | "DEFAULT" | "MISSING_TEMPLATE" | string;
  changeReason?: string;
  previousVersion?: string | null;
  createdAt?: string;
  createdBy?: string;
};

export type ContractClauseSource =
  | "CONTRACT_SNAPSHOT"
  | "FINAL_SNAPSHOT"
  | "DATA_SNAPSHOT"
  | "ACTIVE_TEMPLATE"
  | "DEFAULT_TEMPLATE";

export type ResolvedContractClauseSource = {
  source: ContractClauseSource;
  versionId: string;
  title: string;
  clauses: ContractClause[];
};

export type ContractStatus =
  | "DRAFT"
  | "PHONE_VERIFIED"
  | "REVIEWED"
  | "SIGNED"
  | "COMPLETED"
  | "CANCELLED"
  | "EXPIRED";

export type ContractFinalSnapshot = {
  contractTemplateVersion: string;
  contractTemplateTitle?: string;
  contractClausesSnapshot?: ContractClause[];
  contractHtmlSnapshot: string;
  contractTextSnapshot: string;
  supplierInfoSnapshot: {
    companyName: string;
    businessNumber: string;
    representativeName: string;
    mainPhone: string;
    businessAddress: string;
  };
  businessInfoSnapshot: {
    companyName: string;
    businessNumber: string;
    representativeName: string;
    address: string;
    contactName: string;
    contactPhoneMasked: string | null;
  };
  ownerType: InviteOwnerType;
  ownerLabel: string;
  salesRepId?: string | null;
  salesRepName?: string | null;
  salesRepDepartmentPart?: string | null;
  signedAt: string;
  completedAt: string;
  signatureImageDataUrl?: string;
  signatureHash: string;
  contractHash: string;
  hasCreditCheckConsent?: boolean;
  creditCheckCompany?: string | null;
  creditCheckConsentAt?: string | null;
  representativeVerificationStatus?: RepresentativeVerificationStatus;
  identityVerificationMethod?: IdentityVerificationMethod;
  identityVerificationProvider?: IdentityProvider;
  identityVerificationStatus?: "VERIFIED" | "FAILED" | "FALLBACK_VERIFIED";
  identityVerification?: IdentityVerificationSnapshot | null;
  representativeIdentityVerification?: Record<string, unknown> | null;
  businessVerification?: Record<string, unknown> | null;
  lockedIdentityFields?: Record<string, unknown> | null;
  identityEvidenceVersion?: string;
  kcpFallbackReason?: KcpFallbackReason | null;
  consentSnapshot?: Record<string, unknown>;
  coRepresentativeInfo?: CoRepresentativeInfo;
  coRepresentatives?: Array<Record<string, unknown>>;
  signatureEvidence?: Record<string, unknown> | null;
  representativePersonalGuarantee?: Record<string, unknown> | null;
};

export type SignatureData = {
  imageDataUrl: string;
  imageHash: string;
  signedAt: string;
  canvasWidth: number;
  canvasHeight: number;
};

export type ContractEventType =
  | "DRAFT_CREATED"
  | "CONTRACT_CREATED"
  | "PHONE_OTP_VERIFIED"
  | "KCP_IDENTITY_START_REQUESTED"
  | "KCP_IDENTITY_START_FAILED"
  | "KCP_IDENTITY_TIMEOUT"
  | "KCP_LOOP_GUARD_TRIGGERED"
  | "KCP_STATUS_REHYDRATED"
  | "KCP_SUBMIT_RECHECK_FAILED"
  | "SMS_FALLBACK_ENABLED"
  | "SMS_PHONE_VERIFIED"
  | "CONTRACT_VIEWED"
  | "CONTRACT_SCROLLED_90"
  | "CONTRACT_AGREED"
  | "CONTRACT_AUTHORITY_CONFIRMED"
  | "SIGNATURE_CREATED"
  | "SIGNED"
  | "FINAL_CONFIRMED"
  | "CONTRACT_COMPLETED"
  | "COMPLETED"
  | "CONTRACT_RECEIPT_CONFIRMED"
  | "CONTRACT_RECEIPT_CONFIRM_FAILED"
  | "CONTRACT_RECEIPT_RECHECKED"
  | "ADMIN_VIEWED"
  | "ADMIN_STATUS_CHANGED"
  | "BUSINESS_NAME_CORRECTED"
  | "UPDATE_ADMIN_CONTRACT_DATE"
  | "ERROR_OCCURRED";

export type ContractEvent = {
  type: ContractEventType;
  contractId: string;
  createdAt: string;
  actorType: "CUSTOMER" | "ADMIN" | "SYSTEM";
  managerCode?: "default" | "yh" | "sh" | string;
  userAgent?: string;
  detail?: Record<string, string | number | boolean | null>;
};

export type ContractRecord = Record<string, any> & {
  contractDate?: string;
  adminContractDate?: string;
  adminContractDateUpdatedAt?: unknown;
  adminContractDateUpdatedBy?: string;
  adminContractDateUpdateReason?: string;
};

export const isValidDateOnlyString = (value = "") => {
  const text = String(value || "").trim();
  const match = text.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return false;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const parsed = new Date(Date.UTC(year, month - 1, day));
  return (
    parsed.getUTCFullYear() === year &&
    parsed.getUTCMonth() === month - 1 &&
    parsed.getUTCDate() === day
  );
};

const parseContractDateParts = (value = "") => {
  const parts = String(value || "").trim().split("-");
  if (parts.length !== 3) return null;
  const [year, month, day] = parts.map((part) => Number.parseInt(part, 10));
  if (!year || !month || !day) return null;
  return { year, month, day };
};

export const getContractDisplayDateValue = (contract: ContractRecord = {}) => {
  const adminContractDate = String(contract?.adminContractDate || "").trim();
  if (isValidDateOnlyString(adminContractDate)) return adminContractDate;
  return String(contract?.contractDate || "").trim();
};

export const getContractDisplayDate = (
  contract: ContractRecord = {},
  emptyLabel = ""
) => getContractDisplayDateValue(contract) || emptyLabel;

export const getContractDisplayDateParts = (contract: ContractRecord = {}) =>
  parseContractDateParts(getContractDisplayDateValue(contract));

export const hasAdminContractDateOverride = (contract: ContractRecord = {}) =>
  isValidDateOnlyString(contract?.adminContractDate || "");

export const isCompletedOrLockedContract = (contract = {}) =>
  contract.isLocked === true ||
  contract.contractStatus === "COMPLETED" ||
  contract.status === "completed";

export const createSha256Hash = async (value: string): Promise<string> => {
  const subtle = globalThis.crypto?.subtle;
  if (!subtle) {
    throw new Error("SHA-256 해시를 생성할 수 없습니다.");
  }
  const bytes = new TextEncoder().encode(String(value ?? ""));
  const digest = await subtle.digest("SHA-256", bytes);
  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");
};

export const createSha256HashFromArrayBuffer = async (
  value: ArrayBuffer
): Promise<string> => {
  const subtle = globalThis.crypto?.subtle;
  if (!subtle) {
    throw new Error("SHA-256 ?댁떆瑜??앹꽦?????놁뒿?덈떎.");
  }
  const digest = await subtle.digest("SHA-256", value);
  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");
};

type BuildPhoneVerificationEvidenceInput = {
  phoneVerificationEnabled: boolean;
  phoneVerified: boolean;
  phoneVerifiedAt: string | null;
  phoneNumber: string;
  identityProvider?: IdentityProvider;
};

export type PhoneVerificationEvidence = {
  verificationMethod: string | null;
  phoneVerified: boolean;
  phoneVerifiedAt: string | null;
  phoneMasked: string | null;
  verificationChannel: string | null;
  phoneVerificationSkipped: boolean;
  phoneVerificationSkipReason: string | null;
};

export type IdentityVerificationSummary = {
  identityVerificationMethod: IdentityVerificationMethod;
  identityVerificationProvider: IdentityProvider;
  identityVerificationStatus: "VERIFIED" | "FAILED" | "FALLBACK_VERIFIED";
  verifiedAt?: string;
  phoneMasked?: string | null;
  kcpAttempted: boolean;
  kcpAttemptStatus: KcpAttemptStatus;
  kcpFallbackReason?: KcpFallbackReason | null;
  representativeVerificationStatus: RepresentativeVerificationStatus;
};

export type IdentityVerificationSnapshot = {
  provider: IdentityProvider;
  method: IdentityVerificationMethod;
  sessionId?: string | null;
  orderId?: string | null;
  status: "VERIFIED" | "FAILED" | "FALLBACK_VERIFIED";
  verifiedName?: string | null;
  phoneMasked?: string | null;
  representativeMatchStatus: RepresentativeVerificationStatus;
  hasCi: boolean;
  hasDi: boolean;
  ciHash?: string | null;
  diHash?: string | null;
  ciHmac?: string | null;
  diHmac?: string | null;
  kcpResultCode?: string | null;
  verifiedAt?: string | null;
  evidenceVersion: string;
};

const pickSafeString = (value: unknown): string | null => {
  const normalized = String(value ?? "").trim();
  return normalized || null;
};

export const sanitizeFirestoreValue = (value: unknown): unknown => {
  if (value === undefined) return null;
  if (value === null) return null;

  const valueType = typeof value;
  if (
    valueType === "string" ||
    valueType === "number" ||
    valueType === "boolean"
  ) {
    return value;
  }
  if (value instanceof Date) return value;
  if (Array.isArray(value)) {
    return value.map((item) => sanitizeFirestoreValue(item));
  }
  if (
    valueType === "function" ||
    valueType === "symbol" ||
    valueType === "bigint"
  ) {
    return null;
  }
  if (typeof Blob !== "undefined" && value instanceof Blob) return null;
  if (typeof Element !== "undefined" && value instanceof Element) return null;

  if (valueType === "object") {
    return Object.entries(value as Record<string, unknown>).reduce(
      (acc, [key, item]) => {
        if (
          item === undefined ||
          typeof item === "function" ||
          typeof item === "symbol" ||
          typeof item === "bigint"
        ) {
          return acc;
        }
        acc[key] = sanitizeFirestoreValue(item);
        return acc;
      },
      {} as Record<string, unknown>
    );
  }

  return value;
};

export const findUndefinedPaths = (
  value: unknown,
  currentPath = ""
): string[] => {
  if (value === undefined) return [currentPath || "(root)"];
  if (value === null) return [];
  if (Array.isArray(value)) {
    return value.flatMap((item, index) =>
      findUndefinedPaths(item, `${currentPath}[${index}]`)
    );
  }
  if (typeof value === "object") {
    return Object.entries(value as Record<string, unknown>).flatMap(
      ([key, item]) =>
        findUndefinedPaths(item, currentPath ? `${currentPath}.${key}` : key)
    );
  }
  return [];
};

export const buildContractIdentityVerificationSnapshot = ({
  identitySummary,
  kcpEvidence = {},
}: {
  identitySummary: IdentityVerificationSummary;
  kcpEvidence?: Record<string, unknown>;
}): IdentityVerificationSnapshot => {
  const provider = identitySummary.identityVerificationProvider;
  const method = identitySummary.identityVerificationMethod;
  const isKcpVerified =
    provider === "KCP" &&
    method === "KCP_IDENTITY" &&
    identitySummary.identityVerificationStatus === "VERIFIED";
  const evidenceStatus = String(kcpEvidence.status || "").trim();
  const status =
    isKcpVerified && evidenceStatus === "VERIFIED"
      ? "VERIFIED"
      : identitySummary.identityVerificationStatus;
  const representativeMatchStatus =
    pickSafeString(kcpEvidence.representativeMatchStatus) ||
    identitySummary.representativeVerificationStatus ||
    "PENDING_KCP";

  return {
    provider,
    method,
    sessionId: pickSafeString(kcpEvidence.sessionId) || null,
    orderId: pickSafeString(kcpEvidence.orderId) || null,
    status,
    verifiedName: isKcpVerified
      ? pickSafeString(kcpEvidence.verifiedName)
      : null,
    phoneMasked:
      pickSafeString(kcpEvidence.phoneMasked) ||
      identitySummary.phoneMasked ||
      null,
    representativeMatchStatus:
      representativeMatchStatus as RepresentativeVerificationStatus,
    hasCi: isKcpVerified && Boolean(kcpEvidence.hasCi),
    hasDi: isKcpVerified && Boolean(kcpEvidence.hasDi),
    ciHash: isKcpVerified ? pickSafeString(kcpEvidence.ciHash) : null,
    diHash: isKcpVerified ? pickSafeString(kcpEvidence.diHash) : null,
    ciHmac: isKcpVerified ? pickSafeString(kcpEvidence.ciHmac) : null,
    diHmac: isKcpVerified ? pickSafeString(kcpEvidence.diHmac) : null,
    kcpResultCode: isKcpVerified
      ? pickSafeString(kcpEvidence.kcpResultCode)
      : null,
    verifiedAt:
      pickSafeString(kcpEvidence.verifiedAt) ||
      identitySummary.verifiedAt ||
      null,
    evidenceVersion: EVIDENCE_VERSION,
  };
};

export const maskPhoneNumber = (phone = "") => {
  const digits = String(phone || "").replace(/[^0-9]/g, "");
  if (!digits) return null;
  if (digits.length < 7) return "****";

  const prefix = digits.length >= 10 ? digits.slice(0, 3) : digits.slice(0, 2);
  const suffix = digits.slice(-4);
  return `${prefix}-****-${suffix}`;
};

export const normalizeRepresentativeNameForMatch = (value = "") =>
  String(value || "").trim().replace(/\s+/g, " ");

export const normalizeBirthDateForMatch = (value = "") => {
  const digits = String(value || "").replace(/[^0-9]/g, "");
  if (digits.length === 8) return digits.slice(2);
  if (digits.length === 6) return digits;
  return "";
};

export const formatOpeningDateForNts = (value = "") => {
  const digits = String(value || "").replace(/[^0-9]/g, "");
  if (digits.length !== 8) return "";
  return `${digits.slice(0, 4)}-${digits.slice(4, 6)}-${digits.slice(6, 8)}`;
};

const getPhoneMatchParts = (value = "") => {
  const raw = String(value || "").trim();
  const digits = normalizePhoneDigits(raw);
  const hasMask = raw.includes("*");
  if (!digits) {
    return { fullDigits: "", prefix: "", last4: "", masked: false };
  }
  if (!hasMask && digits.length >= 10) {
    return {
      fullDigits: digits,
      prefix: digits.slice(0, 3),
      last4: digits.slice(-4),
      masked: false,
    };
  }
  const prefixMatch = raw.match(/^(\d{2,3})/);
  return {
    fullDigits: "",
    prefix: prefixMatch?.[1] || (digits.length > 4 ? digits.slice(0, Math.min(3, digits.length - 4)) : ""),
    last4: digits.slice(-4),
    masked: true,
  };
};

const buildPhoneMatchResult = ({ inputPhone = "", kcpPhone = "", kcpPhoneMasked = "" } = {}) => {
  const input = getPhoneMatchParts(inputPhone);
  const kcpFull = getPhoneMatchParts(kcpPhone);
  if (input.fullDigits && kcpFull.fullDigits) {
    return {
      matched: input.fullDigits === kcpFull.fullDigits,
      confidence: "FULL",
    };
  }

  const kcpMasked = getPhoneMatchParts(kcpPhoneMasked || kcpPhone);
  const maskedMatched =
    Boolean(input.last4 && kcpMasked.last4 && input.last4 === kcpMasked.last4) &&
    (!kcpMasked.prefix || !input.prefix || kcpMasked.prefix === input.prefix);
  if (maskedMatched) {
    return {
      matched: true,
      confidence: "MASKED_LAST4",
    };
  }

  return {
    matched: false,
    confidence: kcpPhone || kcpPhoneMasked ? "UNKNOWN" : "UNKNOWN",
  };
};

const getRepresentativeIdentityMismatchMessage = (reason = "") => {
  if (reason === "NAME_MISMATCH") {
    return "입력한 대표자명과 본인확인 결과가 일치하지 않습니다. 대표자 본인 명의 휴대폰으로 다시 인증해 주세요.";
  }
  if (reason === "BIRTH_DATE_MISMATCH" || reason === "KCP_BIRTH_DATE_MISSING") {
    return "입력한 생년월일과 본인확인 결과가 일치하지 않습니다. 대표자 본인 명의 휴대폰으로 다시 인증해 주세요.";
  }
  if (reason === "PHONE_MISMATCH") {
    return "입력한 휴대폰번호와 본인확인 결과가 일치하지 않습니다. 대표자 본인 명의 휴대폰으로 다시 인증해 주세요.";
  }
  return "대표자 본인확인이 완료되지 않았습니다. 대표자 본인 명의 휴대폰으로 다시 인증해 주세요.";
};

export const buildRepresentativeIdentityVerification = ({
  subjectType = "PRINCIPAL",
  input = {},
  kcp = {},
  verifiedAt = new Date().toISOString(),
} = {}) => {
  const inputName = normalizeRepresentativeNameForMatch(
    input.representativeName || input.agentRep || ""
  );
  const kcpName = normalizeRepresentativeNameForMatch(
    kcp.verifiedName || kcp.user_name || kcp.name || ""
  );
  const inputBirth = normalizeBirthDateForMatch(
    input.birthDate ||
      input.representativeBirthDate ||
      input.principalRepSsnFront ||
      input.ssnFront ||
      ""
  );
  const inputSsnFront = normalizeBirthDateForMatch(
    input.principalRepSsnFront || input.ssnFront || inputBirth || ""
  );
  const kcpBirth = normalizeBirthDateForMatch(
    kcp.verifiedBirthDate || kcp.birthDate || kcp.birth_day || kcp.birth || ""
  );
  const inputPhone =
    input.phone || input.representativePhone || input.agentContact || "";
  const kcpPhone =
    kcp.verifiedPhone || kcp.phone || kcp.phone_no || kcp.tel_no || "";
  const kcpPhoneMasked = kcp.phoneMasked || kcp.verifiedPhoneMasked || "";
  const phoneMatch = buildPhoneMatchResult({
    inputPhone,
    kcpPhone,
    kcpPhoneMasked,
  });
  const hasCi = Boolean(kcp.hasCi || kcp.ciHash || kcp.ciHmac);
  const hasDi = Boolean(kcp.hasDi || kcp.diHash || kcp.diHmac);

  const hasAnyKcpValue = Boolean(kcpName || kcpBirth || kcpPhone || kcpPhoneMasked);
  const hasCompleteInput = Boolean(inputName && inputBirth && inputPhone);
  const nameMatched = Boolean(inputName && kcpName && inputName === kcpName);
  const birthDateMatched = Boolean(inputBirth && kcpBirth && inputBirth === kcpBirth);
  const phoneMatched = Boolean(inputPhone && phoneMatch.matched);
  let mismatchReason = null;
  if (!hasAnyKcpValue || !hasCompleteInput) mismatchReason = null;
  else if (!nameMatched) mismatchReason = "NAME_MISMATCH";
  else if (!kcpBirth) mismatchReason = "KCP_BIRTH_DATE_MISSING";
  else if (!birthDateMatched) mismatchReason = "BIRTH_DATE_MISMATCH";
  else if (!phoneMatched) mismatchReason = "PHONE_MISMATCH";

  const status = !hasAnyKcpValue || !hasCompleteInput
    ? "PENDING"
    : mismatchReason === "KCP_BIRTH_DATE_MISSING"
    ? "FAILED"
    : nameMatched && birthDateMatched && phoneMatched
    ? "MATCHED"
    : "MISMATCHED";

  return {
    provider: "KCP",
    subjectType,
    status,
    verifiedAt: verifiedAt || null,
    inputSnapshot: {
      representativeName: inputName,
      birthDateMasked: inputBirth,
      birth6: inputBirth,
      ssnMasked: inputSsnFront
        ? maskResidentRegistrationNumber(inputSsnFront)
        : null,
      phoneMasked: maskPhoneNumber(inputPhone),
      businessNumber: String(input.businessNumber || input.agentBizNo || "").trim(),
    },
    kcpSnapshot: {
      verifiedName: kcpName || null,
      birthDateMatched,
      phoneMatched,
      phoneMatchConfidence: phoneMatch.confidence,
      ciHash: kcp.ciHash || null,
      diHash: kcp.diHash || null,
      ciHmac: kcp.ciHmac || null,
      diHmac: kcp.diHmac || null,
    },
    checks: {
      nameMatched,
      birthDateMatched,
      phoneMatched,
      ssnBackVerifiedByKcp: false,
    },
    ciHash: kcp.ciHash || null,
    diHash: kcp.diHash || null,
    ciHmac: kcp.ciHmac || null,
    diHmac: kcp.diHmac || null,
    hasCi,
    hasDi,
    mismatchReason,
  };
};

export const isRepresentativeIdentityMatched = (verification = null) =>
  verification?.provider === "KCP" &&
  verification?.status === "MATCHED" &&
  verification?.checks?.nameMatched === true &&
  verification?.checks?.birthDateMatched === true &&
  verification?.checks?.phoneMatched === true;

export type KcpIdentityReadiness =
  | "NOT_STARTED"
  | "PENDING"
  | "VERIFIED"
  | "MATCHED"
  | "MISMATCHED"
  | "STALE"
  | "ERROR";

export const KCP_STATUS_RECHECK_MESSAGE =
  "본인확인 완료 상태를 다시 확인하고 있습니다. 잠시 후 다시 시도해 주세요.";
export const KCP_STATUS_REFRESH_MESSAGE =
  "본인확인이 완료되었지만 화면에 반영되지 않았을 수 있습니다. 인증 상태 새로고침을 눌러 주세요.";

export const KCP_STATUS_RETURN_POLL_DELAYS_MS = [
  300,
  700,
  1200,
  2000,
  3000,
  5000,
  7000,
];

export const shouldFinalizeKcpReturnProcessKey = ({
  status = "",
  code = "",
  timedOut = false,
} = {}) => {
  if (timedOut) return true;
  const normalizedStatus = String(status || "").toUpperCase();
  if (normalizedStatus === "VERIFIED") return true;
  if (["FAILED", "CANCELLED", "EXPIRED"].includes(normalizedStatus)) {
    return true;
  }
  const normalizedCode = String(code || "").toUpperCase();
  if (normalizedCode === "KCP_SESSION_NOT_FOUND") return false;
  return false;
};

export const shouldKeepKcpReturnChecking = ({
  status = "",
  code = "",
  reason = "",
} = {}) => {
  const normalizedStatus = String(status || "").trim().toUpperCase();
  const normalizedCode = String(code || "").trim().toUpperCase();
  const normalizedReason = String(reason || "").trim().toUpperCase();
  if (["REGISTERED", "RETURNED", "VERIFYING", "PENDING"].includes(normalizedStatus)) {
    return true;
  }
  if (normalizedCode === "KCP_SESSION_NOT_FOUND") {
    return true;
  }
  return (
    !normalizedStatus &&
    ["KCP_TIMEOUT", "KCP_WAITING_RETURN_FALLBACK"].includes(normalizedReason)
  );
};

export const waitForKcpStatusPollDelay = (delayMs = 0) =>
  new Promise((resolve) => {
    if (!delayMs) {
      resolve(undefined);
      return;
    }
    setTimeout(resolve, delayMs);
  });

const getRepresentativeVerificationFromKcpStatus = (value = {}) =>
  value?.representativeIdentityVerification ||
  value?.identityVerification?.representativeIdentityVerification ||
  value?.identityVerification ||
  null;

const isSameKcpSession = (left = "", right = "") =>
  !left || !right || String(left) === String(right);

export const resolveKcpIdentityReadiness = ({
  kcpStatus = "",
  identityVerification = null,
  representativeIdentityVerification = null,
  phoneVerified = false,
  kcpSessionId = "",
  latestStatusResponse = null,
  previousVerifiedStatus = null,
  userAgent = "",
} = {}) => {
  const localVerification =
    representativeIdentityVerification ||
    getRepresentativeVerificationFromKcpStatus(identityVerification);
  const latestVerification =
    getRepresentativeVerificationFromKcpStatus(latestStatusResponse);
  const previousVerification =
    getRepresentativeVerificationFromKcpStatus(previousVerifiedStatus);
  const latestStatus = String(latestStatusResponse?.status || "").toUpperCase();
  const localStatus = String(kcpStatus || "").toUpperCase();
  const latestSessionId = latestStatusResponse?.sessionId || "";
  const previousSessionId = previousVerifiedStatus?.sessionId || "";
  const safeReason = latestStatusResponse?.code || latestStatusResponse?.reason || "";

  if (
    isIdentityTestSimulation(localVerification) ||
    isIdentityTestSimulation(latestVerification) ||
    isIdentityTestSimulation(previousVerification)
  ) {
    return {
      ready: false,
      status: "PENDING" as KcpIdentityReadiness,
      reason: "TEST_SIMULATION_BLOCKED",
      canProceed: false,
      requiresRetry: true,
      requiresStatusRefresh: false,
      source: "TEST_SIMULATION",
    };
  }

  if (latestStatusResponse && latestStatusResponse.ok === false) {
    return {
      ready: false,
      status: "ERROR" as KcpIdentityReadiness,
      reason: safeReason || "KCP_STATUS_FAILED",
      canProceed: false,
      requiresRetry: false,
      requiresStatusRefresh: true,
      source: "SERVER_STATUS",
    };
  }

  if (latestStatus === "VERIFIED") {
    if (isRepresentativeIdentityMatched(latestVerification)) {
      return {
        ready: true,
        status: "MATCHED" as KcpIdentityReadiness,
        reason: "",
        canProceed: true,
        requiresRetry: false,
        requiresStatusRefresh: false,
        source: "SERVER_STATUS",
        representativeIdentityVerification: latestVerification,
      };
    }
    return {
      ready: false,
      status: latestVerification?.status === "MISMATCHED" ? "MISMATCHED" : "VERIFIED",
      reason: latestVerification?.mismatchReason || "KCP_REPRESENTATIVE_NOT_MATCHED",
      canProceed: false,
      requiresRetry: latestVerification?.status === "MISMATCHED",
      requiresStatusRefresh: latestVerification?.status !== "MISMATCHED",
      source: "SERVER_STATUS",
      representativeIdentityVerification: latestVerification,
    };
  }

  const previousMatchesCurrentSession =
    isRepresentativeIdentityMatched(previousVerification) &&
    isSameKcpSession(kcpSessionId || latestSessionId, previousSessionId);
  const localMatchesCurrentSession =
    localStatus === "VERIFIED" &&
    isRepresentativeIdentityMatched(localVerification);
  const latestIsDowngradeCandidate =
    latestStatus && ["REGISTERED", "RETURNED", "VERIFYING", "PENDING"].includes(latestStatus);

  if ((previousMatchesCurrentSession || localMatchesCurrentSession) && latestIsDowngradeCandidate) {
    return {
      ready: true,
      status: "MATCHED" as KcpIdentityReadiness,
      reason: "VERIFIED_DOWNGRADE_BLOCKED",
      canProceed: true,
      requiresRetry: false,
      requiresStatusRefresh: false,
      source: previousMatchesCurrentSession ? "PREVIOUS_VERIFIED" : "LOCAL_STATE",
      representativeIdentityVerification: previousVerification || localVerification,
    };
  }

  if (localMatchesCurrentSession) {
    return {
      ready: true,
      status: "MATCHED" as KcpIdentityReadiness,
      reason: "",
      canProceed: true,
      requiresRetry: false,
      requiresStatusRefresh: false,
      source: "LOCAL_STATE",
      representativeIdentityVerification: localVerification,
    };
  }

  if (latestStatus === "FAILED" || latestStatus === "CANCELLED" || latestStatus === "EXPIRED") {
    return {
      ready: false,
      status: "ERROR" as KcpIdentityReadiness,
      reason: latestStatus,
      canProceed: false,
      requiresRetry: true,
      requiresStatusRefresh: false,
      source: "SERVER_STATUS",
    };
  }

  if (localStatus === "VERIFIED" || phoneVerified) {
    return {
      ready: false,
      status: "STALE" as KcpIdentityReadiness,
      reason: "REPRESENTATIVE_MATCH_STALE",
      canProceed: false,
      requiresRetry: false,
      requiresStatusRefresh: true,
      source: userAgent ? "LOCAL_STATE" : "LOCAL_STATE",
    };
  }

  return {
    ready: false,
    status: kcpSessionId ? ("PENDING" as KcpIdentityReadiness) : ("NOT_STARTED" as KcpIdentityReadiness),
    reason: kcpSessionId ? "KCP_STATUS_PENDING" : "KCP_NOT_STARTED",
    canProceed: false,
    requiresRetry: Boolean(kcpSessionId),
    requiresStatusRefresh: Boolean(kcpSessionId),
    source: "LOCAL_STATE",
  };
};

export const buildBusinessVerificationInputKey = (input = {}) => {
  const businessNumber = normalizeBusinessNumber(
    input.businessNumber || input.agentBizNo || ""
  );
  const representativeName = normalizeRepresentativeNameForMatch(
    input.representativeName || input.agentRep || ""
  );
  const openingDate = formatOpeningDateForNts(input.openingDate || "");
  return {
    businessNumber,
    representativeName,
    openingDate,
    key: [businessNumber, representativeName, openingDate].join("|"),
  };
};

export const isNtsBusinessVerificationReady = (verification = null) => {
  if (!verification || verification.provider !== "NTS") return false;
  const status = String(verification.status || "").toUpperCase();
  const validationValid = verification.validationCheck?.valid;
  if (["INVALID", "FAILED"].includes(status) || validationValid === false) {
    return false;
  }
  return status === "VALID" || validationValid === true;
};

export const NTS_DISABLED_BY_ADMIN_STATUS = "DISABLED_BY_ADMIN";
export const NTS_MANUAL_REVIEW_REQUIRED_STATUS = "MANUAL_REVIEW_REQUIRED";

export const getNtsBusinessVerificationMode = (settings = {}) => {
  const nested = settings?.ntsBusinessVerification || {};
  const explicitMode = String(nested?.mode || "").trim().toUpperCase();
  if (explicitMode === "DISABLED") return "DISABLED";
  if (explicitMode === "MANUAL_REVIEW" || explicitMode === "OPTIONAL") {
    return "MANUAL_REVIEW";
  }
  if (explicitMode === "REQUIRED") return "REQUIRED";
  if (nested?.enabled === false) return "DISABLED";
  if (nested?.enabled === true) return "MANUAL_REVIEW";
  return settings?.enableBizNumberCheck === false ? "DISABLED" : "MANUAL_REVIEW";
};

export const shouldRunNtsBusinessVerification = (settings = {}) =>
  getNtsBusinessVerificationMode(settings) !== "DISABLED";

export const getNtsBusinessVerificationModeLabel = (settings = {}) => {
  const mode = getNtsBusinessVerificationMode(settings);
  if (mode === "REQUIRED") return "필수 검증";
  if (mode === "MANUAL_REVIEW") return "본사 확인 허용";
  return "사용 안 함";
};

export const buildNtsDisabledBusinessVerification = ({
  formData = {},
  message = "관리자 설정에 따라 국세청 사업자 진위확인을 사용하지 않았습니다.",
} = {}) => ({
  provider: "NTS",
  status: NTS_DISABLED_BY_ADMIN_STATUS,
  checkedAt: null,
  businessNumber: normalizeBusinessNumber(formData.agentBizNo || ""),
  representativeName: String(formData.agentRep || "").trim(),
  openingDate: formatOpeningDateForNts(formData.openingDate || ""),
  businessName: String(formData.agentName || "").trim(),
  validationCheck: {
    attempted: false,
    valid: null,
    message,
    rawStatusCode: "",
  },
  statusCheck: {
    attempted: false,
    businessStatus: "",
    taxType: "",
    closedDate: "",
  },
  requiresManualReview: true,
  disabledReason: "ADMIN_SETTING",
});

export const buildNtsManualReviewBusinessVerification = ({
  formData = {},
  sourceVerification = null,
  message = "사업자 정보가 국세청 정보와 바로 일치하지 않아 본사 확인이 필요합니다.",
} = {}) => ({
  provider: "NTS",
  status: NTS_MANUAL_REVIEW_REQUIRED_STATUS,
  checkedAt: sourceVerification?.checkedAt || new Date().toISOString(),
  businessNumber:
    sourceVerification?.businessNumber ||
    normalizeBusinessNumber(formData.agentBizNo || ""),
  representativeName:
    sourceVerification?.representativeName || String(formData.agentRep || "").trim(),
  openingDate:
    sourceVerification?.openingDate ||
    formatOpeningDateForNts(formData.openingDate || ""),
  businessName: sourceVerification?.businessName || String(formData.agentName || "").trim(),
  validationCheck: {
    attempted: sourceVerification?.validationCheck?.attempted !== false,
    valid:
      typeof sourceVerification?.validationCheck?.valid === "boolean"
        ? sourceVerification.validationCheck.valid
        : null,
    message: sourceVerification?.validationCheck?.message || message,
    rawStatusCode: sourceVerification?.validationCheck?.rawStatusCode || "",
  },
  statusCheck: {
    attempted: sourceVerification?.statusCheck?.attempted === true,
    businessStatus: sourceVerification?.statusCheck?.businessStatus || "",
    taxType: sourceVerification?.statusCheck?.taxType || "",
    closedDate: sourceVerification?.statusCheck?.closedDate || "",
  },
  requiresManualReview: true,
  manualReviewReason: "NTS_NOT_VALIDATED",
});

export const isNtsBusinessVerificationDisabledByAdmin = (
  verification = null
) =>
  verification?.provider === "NTS" &&
  String(verification?.status || "").toUpperCase() ===
    NTS_DISABLED_BY_ADMIN_STATUS;

export const isNtsBusinessVerificationManualReviewRequired = (
  verification = null
) =>
  verification?.provider === "NTS" &&
  String(verification?.status || "").toUpperCase() ===
    NTS_MANUAL_REVIEW_REQUIRED_STATUS;

export const isBusinessVerificationAllowedForContractProgress = (
  verification = null
) =>
  isNtsBusinessVerificationReady(verification) ||
  isNtsBusinessVerificationDisabledByAdmin(verification) ||
  isNtsBusinessVerificationManualReviewRequired(verification);

export const isSameBusinessVerificationInput = (
  verification = null,
  currentInput = {}
) => {
  if (!verification) return false;
  const verified = buildBusinessVerificationInputKey(verification);
  const current = buildBusinessVerificationInputKey(currentInput);
  return Boolean(
    verified.businessNumber &&
      verified.representativeName &&
      verified.openingDate &&
      verified.key === current.key
  );
};

const isEmptyBusinessVerificationUpdate = (verification = null) => {
  if (!verification) return true;
  const status = String(verification.status || "").toUpperCase();
  return ["", "NOT_CHECKED", "NEED_OPENING_DATE", "PENDING"].includes(status);
};

export const shouldKeepExistingBusinessVerification = (
  previous = null,
  next = null,
  currentInput = {}
) =>
  isNtsBusinessVerificationReady(previous) &&
  isSameBusinessVerificationInput(previous, currentInput) &&
  isEmptyBusinessVerificationUpdate(next);

export const resolveBusinessVerificationReadiness = ({
  currentInput = {},
  latestBusinessVerification = null,
  previousBusinessVerification = null,
  savedBusinessVerification = null,
} = {}) => {
  const latestStatus = String(latestBusinessVerification?.status || "").toUpperCase();
  const latestValidationInvalid =
    latestBusinessVerification?.validationCheck?.valid === false;
  if (isNtsBusinessVerificationDisabledByAdmin(latestBusinessVerification)) {
    return {
      ready: true,
      status: NTS_DISABLED_BY_ADMIN_STATUS,
      reason: "NTS_DISABLED_BY_ADMIN",
      businessVerification: latestBusinessVerification,
    };
  }
  if (isNtsBusinessVerificationManualReviewRequired(latestBusinessVerification)) {
    return {
      ready: true,
      status: NTS_MANUAL_REVIEW_REQUIRED_STATUS,
      reason: "NTS_MANUAL_REVIEW_REQUIRED",
      businessVerification: latestBusinessVerification,
    };
  }
  if (["INVALID", "FAILED"].includes(latestStatus) || latestValidationInvalid) {
    return {
      ready: false,
      status:
        latestValidationInvalid && latestStatus !== "FAILED"
          ? "INVALID"
          : latestStatus,
      reason:
        latestStatus === "FAILED"
          ? "NTS_STATUS_FAILED"
          : "NTS_STATUS_INVALID",
      businessVerification: latestBusinessVerification,
    };
  }

  const candidates = [
    latestBusinessVerification,
    previousBusinessVerification,
    savedBusinessVerification,
  ].filter(Boolean);
  const disabledByAdmin = candidates.find((candidate) =>
    isNtsBusinessVerificationDisabledByAdmin(candidate)
  );
  if (disabledByAdmin) {
    return {
      ready: true,
      status: NTS_DISABLED_BY_ADMIN_STATUS,
      reason: "NTS_DISABLED_BY_ADMIN",
      businessVerification: disabledByAdmin,
    };
  }
  const manualReviewRequired = candidates.find((candidate) =>
    isNtsBusinessVerificationManualReviewRequired(candidate)
  );
  if (manualReviewRequired) {
    return {
      ready: true,
      status: NTS_MANUAL_REVIEW_REQUIRED_STATUS,
      reason: "NTS_MANUAL_REVIEW_REQUIRED",
      businessVerification: manualReviewRequired,
    };
  }
  const validSameInput = candidates.find(
    (candidate) =>
      isNtsBusinessVerificationReady(candidate) &&
      isSameBusinessVerificationInput(candidate, currentInput)
  );
  if (validSameInput) {
    const latestIsReady =
      latestBusinessVerification === validSameInput &&
      isNtsBusinessVerificationReady(latestBusinessVerification);
    return {
      ready: true,
      status: "VALID",
      reason: latestIsReady ? "" : "PRESERVED_PREVIOUS_VALID",
      businessVerification: validSameInput,
    };
  }

  const changedValidCandidate = candidates.find((candidate) =>
    isNtsBusinessVerificationReady(candidate)
  );
  if (changedValidCandidate) {
    return {
      ready: false,
      status: "STALE",
      reason: "BUSINESS_VERIFICATION_INPUT_CHANGED",
      businessVerification: null,
    };
  }

  return {
    ready: false,
    status: latestStatus || "NOT_CHECKED",
    reason: latestStatus || "NTS_STATUS_MISSING",
    businessVerification: latestBusinessVerification || null,
  };
};

export const resolveVerifiedContractReadiness = ({
  formData = {},
  kcpStatus = "",
  identityVerification = null,
  representativeIdentityVerification = null,
  phoneVerified = false,
  kcpSessionId = "",
  latestStatusResponse = null,
  previousVerifiedStatus = null,
  latestBusinessVerification = null,
  savedDraft = null,
  userAgent = "",
} = {}) => {
  const kcpReadiness = resolveKcpIdentityReadiness({
    kcpStatus,
    identityVerification,
    representativeIdentityVerification,
    phoneVerified,
    kcpSessionId,
    latestStatusResponse,
    previousVerifiedStatus,
    userAgent,
  });
  const businessReadiness = resolveBusinessVerificationReadiness({
    currentInput: formData,
    latestBusinessVerification,
    previousBusinessVerification: savedDraft?.businessVerification || null,
  });
  return {
    kcpReady: kcpReadiness.canProceed === true,
    ntsReady: businessReadiness.ready === true,
    canProceedToSignature:
      kcpReadiness.canProceed === true && businessReadiness.ready === true,
    canSubmit:
      kcpReadiness.canProceed === true && businessReadiness.ready === true,
    kcpReason: kcpReadiness.reason || "",
    ntsReason: businessReadiness.reason || "",
    hydratedIdentityVerification:
      kcpReadiness.representativeIdentityVerification ||
      representativeIdentityVerification ||
      null,
    hydratedBusinessVerification:
      businessReadiness.businessVerification || latestBusinessVerification || null,
    kcpReadiness,
    businessReadiness,
  };
};

export const buildRepresentativeIdentityTestSimulation = ({
  formData = {},
  verifiedAt = new Date().toISOString(),
  subjectType = "PRINCIPAL",
} = {}) => {
  const representativeName = normalizeRepresentativeNameForMatch(
    formData.agentRep || formData.representativeName || ""
  );
  const birthDate = normalizeBirthDateForMatch(
    formData.representativeBirthDate ||
      formData.principalRepSsnFront ||
      formData.ssnFront ||
      ""
  );
  const phone = formData.agentContact || formData.representativePhone || "";
  return {
    provider: IDENTITY_TEST_SIMULATION_PROVIDER,
    subjectType,
    status: IDENTITY_TEST_SIMULATION_STATUS,
    isTestMode: true,
    verifiedAt: verifiedAt || null,
    inputSnapshot: {
      representativeName,
      birthDateMasked: birthDate,
      birth6: birthDate,
      ssnMasked: birthDate ? maskResidentRegistrationNumber(birthDate) : null,
      phoneMasked: maskPhoneNumber(phone),
      businessNumber: String(formData.agentBizNo || formData.businessNumber || "").trim(),
    },
    kcpSnapshot: {
      verifiedName: null,
      birthDateMatched: false,
      phoneMatched: false,
      phoneMatchConfidence: "TEST_SIMULATION",
    },
    checks: {
      nameMatched: true,
      birthDateMatched: true,
      phoneMatched: true,
      ssnBackVerifiedByKcp: false,
    },
    hasCi: false,
    hasDi: false,
    mismatchReason: null,
    warning: IDENTITY_TEST_SIMULATION_WARNING,
  };
};

export const buildCoRepresentativeIdentityTestSimulation = ({
  representative = {},
  businessNumber = "",
  verifiedAt = new Date().toISOString(),
} = {}) => ({
  ...buildRepresentativeIdentityTestSimulation({
    subjectType: "CO_REP",
    formData: {
      agentRep: representative.name || representative.representativeName || "",
      representativeBirthDate:
        representative.ssnFront || representative.birthDate || "",
      agentContact: representative.phone || "",
      agentBizNo: businessNumber,
    },
    verifiedAt,
  }),
  coRepresentativeId: String(representative.id || ""),
});

export const getRepresentativeKcpWorkflowStatus = (verification = null) => {
  if (isRepresentativeIdentityMatched(verification)) {
    return REPRESENTATIVE_KCP_VERIFIED_STATUS;
  }
  if (
    verification?.provider === "KCP" &&
    ["MISMATCHED", "FAILED"].includes(String(verification?.status || ""))
  ) {
    return REPRESENTATIVE_KCP_MISMATCH_STATUS;
  }
  return REPRESENTATIVE_KCP_PENDING_STATUS;
};

export const isIdentityTestModeContract = (contract = {}) => {
  const identity =
    contract.identityVerification ||
    contract.finalSnapshot?.identityVerification ||
    {};
  const representativeIdentity =
    contract.representativeIdentityVerification ||
    contract.finalSnapshot?.representativeIdentityVerification ||
    {};
  return (
    contract.isIdentityTestMode === true ||
    contract.isTestMode === true ||
    String(contract.contractStatus || "") === IDENTITY_TEST_CONTRACT_STATUS ||
    isIdentityTestSimulation(identity) ||
    isIdentityTestSimulation(representativeIdentity)
  );
};

export const STRICT_IDENTITY_FIELD_NAMES = new Set([
  "agentBizNo",
  "agentRep",
  "corpRepName",
  "representativeBirthDate",
  "principalRepSsnFront",
  "principalRepSsnBack",
  "ssnFront",
  "ssnBack",
  "agentContact",
  "corpRepAddress",
  "corpRepAddressDetail",
  "openingDate",
]);

const BUSINESS_VERIFICATION_INPUT_FIELD_NAMES = new Set([
  "agentBizNo",
  "agentRep",
  "openingDate",
]);

export const REPRESENTATIVE_PERSONAL_GUARANTEE_CONSENT_VERSION =
  "rep-personal-guarantee-v1";
export const REPRESENTATIVE_PERSONAL_GUARANTEE_CONSENT_TEXT =
  "본인은 위 법인의 대표자로서 본 계약 내용을 확인하였으며, 본 계약에 따라 발생하는 법인의 물품대금, 미수금, 지연손해금 및 기타 거래 책임 범위를 충분히 이해하고 공동계약 확인에 동의합니다.";

export type SignatureRole =
  | "PRINCIPAL_REPRESENTATIVE"
  | "CORPORATE_REPRESENTATIVE"
  | "REPRESENTATIVE_PERSONAL_GUARANTEE"
  | "CO_REPRESENTATIVE_DIRECT"
  | "CO_REPRESENTATIVE_DELEGATED"
  | "CORPORATE_GUARANTOR"
  | "JOINT_GUARANTOR"
  | "OPTIONAL_SECONDARY";

export const getPrimarySignatureRoleDescriptor = ({
  bizType = "INDIVIDUAL",
  coRepresentativesRequired = false,
} = {}): { role: SignatureRole; label: string; signerType: string } => {
  if (isCorporateContract(bizType)) {
    return coRepresentativesRequired
      ? {
          role: "CORPORATE_REPRESENTATIVE",
          label: "주대표자 서명",
          signerType: "CORPORATE_REPRESENTATIVE",
        }
      : {
          role: "CORPORATE_REPRESENTATIVE",
          label: "법인 대표자 서명",
          signerType: "CORPORATE_REPRESENTATIVE",
        };
  }
  return {
    role: "PRINCIPAL_REPRESENTATIVE",
    label: "대표자 서명",
    signerType: "PRINCIPAL_REPRESENTATIVE",
  };
};

const normalizeSignatureValidation = (validation = {}) => ({
  valid: validation?.valid === true,
  ...(validation?.reason ? { reason: validation.reason } : {}),
  inkPixels: Number(validation?.inkPixels || 0),
  boundingWidth: Number(validation?.boundingWidth || 0),
  boundingHeight: Number(validation?.boundingHeight || 0),
  inkRatio: Number(validation?.inkRatio || 0),
});

export const buildSignatureEvidence = ({
  bizType = "INDIVIDUAL",
  signerName = "",
  coRepresentativesRequired = false,
  primaryHash = "",
  primaryValidation = {},
  primarySignedAt = "",
  representativePersonalGuaranteeRequired,
  representativePersonalGuaranteeAgreed = false,
  representativePersonalGuaranteeAgreedAt = "",
  representativePersonalGuaranteeHash = "",
  representativePersonalGuaranteeValidation = {},
  representativePersonalGuaranteeSignedAt = "",
  signerSsnMasked = "",
  signerPhoneMasked = "",
  signerAddressMasked = "",
} = {}) => {
  const primaryDescriptor = getPrimarySignatureRoleDescriptor({
    bizType,
    coRepresentativesRequired,
  });
  const normalizedSignerName = normalizeRepresentativeNameForMatch(signerName || "");
  const personalGuaranteeRequired =
    typeof representativePersonalGuaranteeRequired === "boolean"
      ? representativePersonalGuaranteeRequired
      : isCorporateContract(bizType);
  const primaryNormalizedValidation =
    normalizeSignatureValidation(primaryValidation);
  const guaranteeNormalizedValidation = normalizeSignatureValidation(
    representativePersonalGuaranteeValidation
  );

  return {
    primary: {
      role: primaryDescriptor.role,
      label: primaryDescriptor.label,
      signerName: normalizedSignerName,
      signerType: primaryDescriptor.signerType,
      imageHash: primaryHash || null,
      valid: primaryNormalizedValidation.valid,
      validation: primaryNormalizedValidation,
      signedAt: primarySignedAt || null,
    },
    representativePersonalGuarantee: {
      role: "REPRESENTATIVE_PERSONAL_GUARANTEE",
      label: "대표자 공동계약 확인 서명",
      required: personalGuaranteeRequired,
      agreed: representativePersonalGuaranteeAgreed === true,
      agreedAt:
        representativePersonalGuaranteeAgreed === true
          ? representativePersonalGuaranteeAgreedAt || null
          : null,
      consentTextVersion: REPRESENTATIVE_PERSONAL_GUARANTEE_CONSENT_VERSION,
      signerName: normalizedSignerName,
      signerSsnMasked: signerSsnMasked || null,
      signerPhoneMasked: signerPhoneMasked || null,
      signerAddressMasked: signerAddressMasked || null,
      imageHash: representativePersonalGuaranteeHash || null,
      valid: guaranteeNormalizedValidation.valid,
      validation: guaranteeNormalizedValidation,
      signedAt: representativePersonalGuaranteeSignedAt || null,
    },
    secondary: null,
  };
};

export const buildLockedIdentityFieldsSnapshot = ({
  formData = {},
  lockedAt = new Date().toISOString(),
} = {}) => ({
  businessNumber: normalizeBusinessNumber(
    formData.agentBizNo || formData.businessNumber || ""
  ),
  representativeName: normalizeRepresentativeNameForMatch(
    formData.agentRep || formData.representativeName || ""
  ),
  birthDateMasked: normalizeBirthDateForMatch(
    formData.representativeBirthDate ||
      formData.principalRepSsnFront ||
      formData.ssnFront ||
      ""
  ),
  ssnMasked: maskResidentRegistrationNumber(
    normalizeBirthDateForMatch(
      formData.principalRepSsnFront ||
        formData.ssnFront ||
        formData.representativeBirthDate ||
        ""
    )
  ),
  phoneMasked: maskPhoneNumber(formData.agentContact || formData.phone || ""),
  openingDate: formatOpeningDateForNts(formData.openingDate || ""),
  ...(formData.corpRepAddress || formData.corpRepAddressDetail
    ? {
        homeAddressMasked: maskHomeAddressForEvidence(
          [formData.corpRepAddress, formData.corpRepAddressDetail]
            .filter(Boolean)
            .join(" ")
        ),
      }
    : {}),
  lockedAt,
});

export const getLockedIdentityFieldMismatch = ({
  formData = {},
  lockedIdentityFields = null,
} = {}) => {
  if (!lockedIdentityFields) return null;
  const current = buildLockedIdentityFieldsSnapshot({
    formData,
    lockedAt: lockedIdentityFields.lockedAt || "",
  });
  for (const key of [
    "businessNumber",
    "representativeName",
    "birthDateMasked",
    "ssnMasked",
    "phoneMasked",
    "openingDate",
  ]) {
    const currentVal = String(current[key] || "");
    const lockedVal = String(lockedIdentityFields[key] || "");
    // Skip ssnMasked mismatch while SSN front is partially entered (< 6 digits)
    // so typing the first digits after KCP doesn't immediately reset verification
    if (key === "ssnMasked" && !currentVal && lockedVal) continue;
    if (currentVal !== lockedVal) {
      return key;
    }
  }
  return null;
};

export const validateStrictRepresentativeIdentity = ({
  kcpIdentityStatus = "",
  representativeIdentityVerification = null,
  businessVerification = null,
  coRepresentativesRequired = false,
  coRepresentatives = [],
} = {}) => {
  if (isIdentityTestSimulation(representativeIdentityVerification)) {
    return {
      ok: false,
      step: 1,
      message: REPRESENTATIVE_KCP_REQUIRED_MESSAGE,
    };
  }

  if (kcpIdentityStatus !== "VERIFIED") {
    return {
      ok: false,
      step: 1,
      message: REPRESENTATIVE_KCP_REQUIRED_MESSAGE,
    };
  }

  if (!isRepresentativeIdentityMatched(representativeIdentityVerification)) {
    return {
      ok: false,
      step: 1,
      message: getRepresentativeIdentityMismatchMessage(
        representativeIdentityVerification?.mismatchReason
      ),
    };
  }

  const ntsAllowed =
    isBusinessVerificationAllowedForContractProgress(businessVerification);
  if (!ntsAllowed) {
    return {
      ok: false,
      step: 0,
      message:
        businessVerification?.status === "FAILED"
          ? "국세청 확인이 일시적으로 지연됩니다. 본사 확인이 필요할 수 있습니다."
          : "사업자번호, 대표자명 또는 개업일자가 국세청 등록정보와 일치하지 않습니다.",
    };
  }

  if (coRepresentativesRequired) {
    const representatives = Array.isArray(coRepresentatives)
      ? coRepresentatives
      : [];
    if (representatives.length === 0) {
      return {
        ok: false,
        step: 0,
        message:
          "공동계약인 정보가 누락되었습니다. 사업자등록증 또는 법인등기부에 공동계약인이 있는 경우 모든 공동계약인 정보를 입력해야 합니다.",
      };
    }
    const missingRequiredFields = representatives.some(
      (item) => !hasCompleteCoRepresentativeRequiredFields(item)
    );
    if (missingRequiredFields) {
      return {
        ok: false,
        step: 0,
        message:
          "공동계약인 정보가 누락되었습니다. 사업자등록증 또는 법인등기부에 공동계약인이 있는 경우 모든 공동계약인 정보를 입력해야 합니다.",
      };
    }
    const missingIdentity = representatives.some(
      (item) => !isCoRepresentativeIdentityMatched(item)
    );
    if (missingIdentity) {
      return {
        ok: false,
        step: 0,
        message: "공동계약인 본인확인이 완료되지 않았습니다.",
      };
    }
    const missingIdentityEvidence = representatives.some(
      (item) => !hasCoRepresentativeIdentityEvidenceStored(item)
    );
    if (missingIdentityEvidence) {
      return {
        ok: false,
        step: 0,
        message: "공동계약인 CI/DI 증빙 보관이 확인되지 않았습니다.",
      };
    }
    const missingDirectSignature = representatives.some(
      (item) =>
        getCoRepresentativeSignatureMode(item) ===
          CO_REPRESENTATIVE_SIGNATURE_MODE_DIRECT &&
        !hasCoRepresentativeDirectSignatureEvidence(item)
    );
    if (missingDirectSignature) {
      return {
        ok: false,
        step: 0,
        message: "공동계약인 직접서명이 완료되지 않았습니다.",
      };
    }
    const missingConsent = representatives.some(
      (item) =>
        getCoRepresentativeSignatureMode(item) ===
          CO_REPRESENTATIVE_SIGNATURE_MODE_DELEGATED &&
        !hasCoRepresentativeDelegatedSignatureConsent(item)
    );
    if (missingConsent) {
      return {
        ok: false,
        step: 0,
        message: "공동계약인 대리서명 동의가 필요합니다.",
      };
    }
  }

  return { ok: true, step: null, message: "" };
};

// ---------------------------------------------------------------------------
// StepEvidence – snapshot of each step's completion facts.
// Used by validateFinalSubmissionEvidence so submitContract can trust
// evidence over stale local state (e.g. after KCP mobile redirect).
// ---------------------------------------------------------------------------

type StepEvidenceSource =
  | "STEP_0_VALIDATED"
  | "KCP_STATUS_VERIFIED"
  | "STEP_2_REVIEWED"
  | "STEP_3_SIGNED";

interface StepEvidenceBusinessInfo {
  completed: boolean;
  completedAt: string;
  businessNumber: string;
  representativeName: string;
  openingDate: string;
  phoneMasked: string;
  source: StepEvidenceSource;
}

interface StepEvidenceIdentity {
  completed: boolean;
  completedAt: string;
  provider: string;
  status: string;
  kcpSessionId: string;
  hasCi: boolean;
  hasDi: boolean;
  nameMatched: boolean;
  birthDateMatched: boolean;
  phoneMatched: boolean;
  ssnEvidencePresent: boolean;
  source: StepEvidenceSource;
}

interface StepEvidenceContractReview {
  completed: boolean;
  completedAt: string;
  scrollCompleted: boolean;
  source: StepEvidenceSource;
}

interface StepEvidenceSignature {
  completed: boolean;
  completedAt: string;
  primarySignatureValid: boolean;
  personalGuaranteeSignatureValid: boolean;
  source: StepEvidenceSource;
}

interface StepEvidence {
  businessInfo: StepEvidenceBusinessInfo | null;
  identity: StepEvidenceIdentity | null;
  contractReview: StepEvidenceContractReview | null;
  signature: StepEvidenceSignature | null;
}

export const validateFinalSubmissionEvidence = ({
  stepEvidence,
  kcpIdentityStatus = "",
  representativeIdentityVerification = null,
  restoredSsnDraft = null,
  lockedIdentityFields = null,
}: {
  stepEvidence: StepEvidence | null;
  kcpIdentityStatus?: string;
  representativeIdentityVerification?: unknown;
  restoredSsnDraft?: { principalRepSsnEncrypted?: string } | null;
  lockedIdentityFields?: { ssnMasked?: string } | null;
}) => {
  // If step evidence says identity is completed, trust it over stale local state
  if (stepEvidence?.identity?.completed) {
    return { ok: true };
  }

  // Fall back to checking KCP state evidence
  const hasKcpVerified =
    kcpIdentityStatus === "VERIFIED" &&
    isRepresentativeIdentityMatched(representativeIdentityVerification);
  const hasSsnEvidence =
    Boolean((restoredSsnDraft as { principalRepSsnEncrypted?: string } | null)?.principalRepSsnEncrypted) ||
    Boolean((lockedIdentityFields as { ssnMasked?: string } | null)?.ssnMasked);

  if (hasKcpVerified && hasSsnEvidence) {
    return { ok: true };
  }

  if (hasKcpVerified && !hasSsnEvidence) {
    return { ok: true }; // KCP matched is sufficient
  }

  return {
    ok: false,
    targetStep: 1,
    reason: "IDENTITY_EVIDENCE_MISSING" as const,
    message: "본인확인 증빙이 확인되지 않습니다. 본인확인을 다시 진행해 주세요.",
  };
};

export const shouldUseFinalSubmissionEvidenceOverride = ({
  strictValidation = null,
  evidenceCheck = null,
} = {}) =>
  strictValidation?.ok === false &&
  evidenceCheck?.ok === true &&
  strictValidation?.step !== 0;

// ---------------------------------------------------------------------------

const getSafePhoneMasked = (phone = "") => {
  const value = String(phone || "").trim();
  if (!value) return null;
  return value.includes("*") ? value : maskPhoneNumber(value);
};

const pickAdminRawPhone = (...values) =>
  values
    .map((value) => String(value || "").trim())
    .find((value) => value && !value.includes("*"));

export const getAdminDisplayContact = (contract = {}) => {
  const rawPhone = pickAdminRawPhone(
    contract.agentContact,
    contract.contactPhone,
    contract.phone,
    contract.representativePhone,
    contract.customerPhone,
    contract.finalSnapshot?.businessInfoSnapshot?.contactPhone
  );
  if (rawPhone) return formatPhoneNumberForDisplay(rawPhone) || rawPhone;

  const maskedPhone =
    contract.phoneMasked ||
    contract.kcpVerifiedPhoneMasked ||
    contract.identityVerification?.phoneMasked ||
    contract.finalSnapshot?.identityVerification?.phoneMasked ||
    contract.verifiedPhone ||
    contract.finalSnapshot?.businessInfoSnapshot?.contactPhoneMasked;
  return String(maskedPhone || "").trim() || "미수집";
};

export const BUSINESS_NAME_CORRECTION_REASON_OPTIONS = [
  "사업자등록증 기준 오기 정정",
  "국세청 사업자 상태 확인 후 표기 정정",
  "고객 통화 확인",
  "띄어쓰기/특수문자 표기 정정",
  "기타",
];

export const BUSINESS_NAME_CORRECTION_SOURCE_OPTIONS = [
  {
    value: "BUSINESS_REGISTRATION_CONFIRMED",
    label: "사업자등록증 확인",
  },
  {
    value: "NTS_STATUS_CONFIRMED",
    label: "국세청 사업자 상태 확인",
  },
  {
    value: "CUSTOMER_CALL_CONFIRMED",
    label: "고객 통화 확인",
  },
  {
    value: "SPELLING_FORMAT_CORRECTION",
    label: "띄어쓰기/특수문자 표기 확인",
  },
  {
    value: "OTHER",
    label: "기타 근거",
  },
];

const trimBusinessNameCorrectionText = (value = "") =>
  String(value || "").trim();

export const getBusinessNameCorrection = (contract = {}) => {
  const correction = contract?.businessNameCorrection;
  return correction && typeof correction === "object" ? correction : null;
};

export const getBusinessNameCorrectionOriginalName = (contract = {}) => {
  const correction = getBusinessNameCorrection(contract);
  return (
    trimBusinessNameCorrectionText(correction?.originalName) ||
    trimBusinessNameCorrectionText(contract.agentName) ||
    trimBusinessNameCorrectionText(contract.customerName) ||
    trimBusinessNameCorrectionText(
      contract.finalSnapshot?.businessInfoSnapshot?.companyName
    )
  );
};

export const getAdminDisplayBusinessName = (contract = {}) => {
  const correction = getBusinessNameCorrection(contract);
  return (
    trimBusinessNameCorrectionText(correction?.correctedName) ||
    getBusinessNameCorrectionOriginalName(contract) ||
    "미수집"
  );
};

const pickOutputRawPhone = (...values) =>
  values
    .map((value) => String(value || "").trim())
    .find((value) => value && !value.includes("*"));

export const getContractOutputPhoneDisplay = (contract = {}) => {
  const rawPhone = pickOutputRawPhone(
    contract.agentContact,
    contract.contactPhone,
    contract.phone,
    contract.representativePhone,
    contract.customerPhone,
    contract.verifiedPhone,
    contract.finalSnapshot?.businessInfoSnapshot?.contactPhone
  );
  if (rawPhone) return formatPhoneNumberForDisplay(rawPhone) || rawPhone;
  return (
    contract.phoneMasked ||
    contract.kcpVerifiedPhoneMasked ||
    contract.identityVerification?.phoneMasked ||
    contract.finalSnapshot?.identityVerification?.phoneMasked ||
    contract.verifiedPhone ||
    contract.finalSnapshot?.businessInfoSnapshot?.contactPhoneMasked ||
    ""
  );
};

export const getContractOutputCoRepresentativePhoneDisplay = (
  representative = {}
) => {
  const rawPhone = pickOutputRawPhone(
    representative.adminOutputPhone,
    representative.phone,
    representative.verifiedPhone,
    representative.identityVerification?.inputSnapshot?.phone,
    representative.identityVerification?.verifiedPhone
  );
  if (rawPhone) return formatPhoneNumberForDisplay(rawPhone) || rawPhone;
  return representative.phoneMasked || "";
};

const getCoRepresentativeOutputMatchId = (representative = {}) =>
  String(
    representative?.id ||
      representative?.coRepresentativeId ||
      representative?.identityVerification?.coRepresentativeId ||
      representative?.signatureEvidence?.coRepresentativeId ||
      ""
  ).trim();

const findMatchingCoRepresentativeOutputRow = (rows = [], representative = {}) => {
  const source = Array.isArray(rows) ? rows : [];
  const id = getCoRepresentativeOutputMatchId(representative);
  const name = normalizeRepresentativeNameForMatch(representative?.name || "");
  return (
    (id &&
      source.find((item) => getCoRepresentativeOutputMatchId(item) === id)) ||
    (name &&
      source.find(
        (item) => normalizeRepresentativeNameForMatch(item?.name || "") === name
      )) ||
    null
  );
};

const findMatchingCoRepresentativeOutputRows = (rows = [], representative = {}) => {
  const source = Array.isArray(rows) ? rows.filter(Boolean) : [];
  const id = getCoRepresentativeOutputMatchId(representative);
  const name = normalizeRepresentativeNameForMatch(representative?.name || "");
  return source.filter((item) => {
    const itemId = getCoRepresentativeOutputMatchId(item);
    const itemName = normalizeRepresentativeNameForMatch(item?.name || "");
    return Boolean((id && itemId === id) || (name && itemName === name));
  });
};

const getCoRepresentativeOutputContactRows = (contract = {}) => [
  ...(Array.isArray(contract.coRepresentativesContactSnapshot)
    ? contract.coRepresentativesContactSnapshot
    : []),
  ...(Array.isArray(contract.finalSnapshot?.coRepresentativesContactSnapshot)
    ? contract.finalSnapshot.coRepresentativesContactSnapshot
    : []),
  ...(Array.isArray(contract.finalSnapshot?.coRepresentatives)
    ? contract.finalSnapshot.coRepresentatives
    : []),
].filter(Boolean);

const getRevealedCoRepresentativeResidentNumber = (
  revealedResidentNumbers = {},
  representative = {}
) => {
  const normalizedRows = Array.isArray(revealedResidentNumbers)
    ? revealedResidentNumbers
    : Object.entries(revealedResidentNumbers || {}).map(([key, value]) => ({
        key,
        value,
      }));
  const id = getCoRepresentativeOutputMatchId(representative);
  const name = normalizeRepresentativeNameForMatch(representative?.name || "");
  const matched = normalizedRows.find((item) => {
    const itemId = getCoRepresentativeOutputMatchId(item) || String(item?.key || "");
    const itemName = normalizeRepresentativeNameForMatch(item?.name || item?.key || "");
    return (id && itemId === id) || (name && itemName === name);
  });
  const value =
    matched?.residentNumber ||
    matched?.adminOutputResidentNumber ||
    matched?.outputResidentNumber ||
    matched?.value ||
    "";
  return formatDecryptedResidentRegistrationNumber(value || "");
};

const mergeAdminOutputCoRepresentatives = (
  contract = {},
  { revealedResidentNumbers = {} } = {}
) => {
  const rows = Array.isArray(contract.coRepresentatives)
    ? contract.coRepresentatives
    : [];
  const contactRows = getCoRepresentativeOutputContactRows(contract);
  return rows.map((item) => {
    const matchedContactRows = findMatchingCoRepresentativeOutputRows(
      contactRows,
      item
    );
    const contactRow = matchedContactRows[0] || {};
    const contactPhoneCandidates = matchedContactRows.flatMap((row) => [
      row?.adminOutputPhone,
      row?.phone,
      row?.verifiedPhone,
      row?.identityVerification?.inputSnapshot?.phone,
      row?.identityVerification?.verifiedPhone,
    ]);
    const rawPhone = pickOutputRawPhone(
      item?.adminOutputPhone,
      item?.phone,
      item?.verifiedPhone,
      item?.identityVerification?.inputSnapshot?.phone,
      item?.identityVerification?.verifiedPhone,
      ...contactPhoneCandidates
    );
    const fullResidentNumber = getRevealedCoRepresentativeResidentNumber(
      revealedResidentNumbers,
      item
    );
    return {
      ...item,
      ...(rawPhone ? { adminOutputPhone: rawPhone, phone: rawPhone } : {}),
      ...(fullResidentNumber
        ? { adminOutputResidentNumber: fullResidentNumber }
        : {}),
      phoneMasked: item?.phoneMasked || contactRow?.phoneMasked || "",
    };
  });
};

export const getContractOutputPrincipalResidentNumberDisplay = (
  contract = {}
) => {
  const fullResidentNumber = formatDecryptedResidentRegistrationNumber(
    contract.adminOutputPrincipalResidentNumber ||
      contract.outputPrincipalResidentNumber ||
      ""
  );
  return fullResidentNumber || getPrincipalRepSsnDisplayValue(contract);
};

export const getContractOutputCoRepresentativeResidentNumberDisplay = (
  representative = {}
) => {
  const fullResidentNumber = formatDecryptedResidentRegistrationNumber(
    representative.adminOutputResidentNumber ||
      representative.outputResidentNumber ||
      ""
  );
  return fullResidentNumber || representative.ssnMasked || "";
};

const pickCoRepresentativeSignatureImageDataUrl = (record = {}) =>
  record?.signatureImageDataUrl ||
  record?.signatureDataUrl ||
  record?.imageDataUrl ||
  record?.signatureEvidence?.signatureImageDataUrl ||
  record?.signatureEvidence?.signatureDataUrl ||
  record?.signatureEvidence?.imageDataUrl ||
  "";

const pickCoRepresentativeSignatureImageReference = (record = {}) =>
  pickCoRepresentativeSignatureImageDataUrl(record) ||
  record?.signatureImageUrl ||
  record?.signatureStoragePath ||
  record?.signatureEvidence?.signatureImageUrl ||
  record?.signatureEvidence?.signatureStoragePath ||
  "";

const getCoRepresentativeSignatureOutputCandidates = (
  contract = {},
  representative = {}
) => {
  const id = getCoRepresentativeOutputMatchId(representative);
  const name = normalizeRepresentativeNameForMatch(representative?.name || "");
  const imageRows = Array.isArray(contract.coRepresentativeSignatureImages)
    ? contract.coRepresentativeSignatureImages
    : [];
  const sourceRows = Array.isArray(contract.coRepresentatives)
    ? contract.coRepresentatives
    : [];
  const matches = [
    representative,
    id
      ? imageRows.find((item) => getCoRepresentativeOutputMatchId(item) === id)
      : null,
    id
      ? sourceRows.find((item) => getCoRepresentativeOutputMatchId(item) === id)
      : null,
    name
      ? imageRows.find(
          (item) => normalizeRepresentativeNameForMatch(item?.name || "") === name
        )
      : null,
    name
      ? sourceRows.find(
          (item) => normalizeRepresentativeNameForMatch(item?.name || "") === name
        )
      : null,
  ].filter(Boolean);
  return matches;
};

export const getContractOutputCoRepresentativeSignatureImage = (
  contract = {},
  representative = {}
) => {
  const candidates = getCoRepresentativeSignatureOutputCandidates(
    contract,
    representative
  );
  return candidates.map(pickCoRepresentativeSignatureImageDataUrl).find(Boolean) || "";
};

export const getContractOutputCoRepresentativeSignatureDisplay = (
  contract = {},
  representative = {}
) => {
  const candidates = getCoRepresentativeSignatureOutputCandidates(
    contract,
    representative
  );
  const imageDataUrl =
    candidates.map(pickCoRepresentativeSignatureImageDataUrl).find(Boolean) ||
    "";
  const evidence =
    candidates.map((item) => item?.signatureEvidence).find(Boolean) || {};
  const status = String(
    candidates.map((item) => item?.signatureStatus).find(Boolean) || ""
  );
  const completed =
    Boolean(imageDataUrl) ||
    evidence?.valid === true ||
    ["SIGNED", "SIGNED_DIRECTLY"].includes(status);
  return {
    completed,
    imageDataUrl,
    signedAt:
      evidence?.signedAt ||
      candidates.map((item) => item?.signedAt).find(Boolean) ||
      "",
    signerName:
      evidence?.signerName ||
      candidates.map((item) => item?.name).find(Boolean) ||
    "",
  };
};

export const shouldRenderLegacyCorporateSignatureBlock = ({
  contract = {},
  signUrl2 = "",
} = {}) => {
  if (!isCorporateContract(contract?.bizType)) return false;
  const representativePersonalGuarantee =
    contract?.representativePersonalGuarantee ||
    contract?.finalSnapshot?.representativePersonalGuarantee ||
    contract?.signatureEvidence?.representativePersonalGuarantee ||
    {};
  const hasLegacyMarker = Boolean(
    contract?.legacyCorporateSignatureBlock === true ||
      contract?.legacyPersonalGuaranteeFlow === true ||
      representativePersonalGuarantee?.legacy === true ||
      representativePersonalGuarantee?.legacySignatureBlock === true ||
      representativePersonalGuarantee?.source === "LEGACY" ||
      representativePersonalGuarantee?.evidenceSource === "LEGACY"
  );
  const hasLegacyEvidence = Boolean(
    signUrl2 ||
      contract?.signature2 ||
      representativePersonalGuarantee?.imageHash ||
      representativePersonalGuarantee?.signatureHash ||
      representativePersonalGuarantee?.signedAt ||
      representativePersonalGuarantee?.agreedAt ||
      representativePersonalGuarantee?.valid === true ||
      representativePersonalGuarantee?.signatureValidation?.valid === true
  );
  return hasLegacyMarker && hasLegacyEvidence;
};

const getRepresentativeIdentityStatusForPdf = (contract = {}) => {
  const representativeIdentity =
    contract?.representativeIdentityVerification ||
    contract?.finalSnapshot?.representativeIdentityVerification ||
    {};
  if (
    representativeIdentity?.status === "MATCHED" ||
    representativeIdentity?.status === "VERIFIED" ||
    contract?.representativeVerificationStatus === "MATCHED"
  ) {
    return "대표자 본인확인 완료";
  }
  return (
    representativeIdentity?.status ||
    contract?.representativeVerificationStatus ||
    "본인확인 미완료"
  );
};

const isSameCorporateCoRepresentativePdfRow = (left = {}, right = {}) => {
  const leftId = getCoRepresentativeOutputMatchId(left);
  const rightId = getCoRepresentativeOutputMatchId(right);
  if (leftId && rightId && leftId === rightId) return true;
  const leftName = normalizeRepresentativeNameForMatch(left?.name || "");
  const rightName = normalizeRepresentativeNameForMatch(right?.name || "");
  if (leftName && rightName && leftName === rightName) return true;
  const leftSsn = String(left?.ssnMasked || left?.outputResidentNumber || "").trim();
  const rightSsn = String(right?.ssnMasked || right?.outputResidentNumber || "").trim();
  return Boolean(leftSsn && rightSsn && leftSsn === rightSsn);
};

export const buildCorporateCoRepresentativePdfRows = (
  contract = {},
  {
    outputPrincipalResidentNumber = "",
    outputPhoneNumber = "",
    signUrl2 = "",
  } = {}
) => {
  const coRepresentativeRows = sanitizeCoRepresentativesForEvidenceSnapshot(
    contract?.coRepresentatives || []
  );
  if (!isCorporateContract(contract?.bizType)) return coRepresentativeRows;

  const representativePersonalGuarantee =
    contract?.representativePersonalGuarantee ||
    contract?.finalSnapshot?.representativePersonalGuarantee ||
    contract?.signatureEvidence?.representativePersonalGuarantee ||
    {};
  const principalName =
    contract?.corpRepName || contract?.agentRep || representativePersonalGuarantee?.signerName || "";
  const corporateRepresentativeSignatureImage =
    signUrl2 || contract?.signature2 || "";
  const corporateRepresentativeSignedAt =
    representativePersonalGuarantee?.signedAt ||
    contract?.signatureCompletedAt ||
    contract?.signedAt ||
    "";
  const corporateRepresentativeSigned = Boolean(
    corporateRepresentativeSignatureImage ||
      representativePersonalGuarantee?.valid === true ||
      representativePersonalGuarantee?.signatureValidation?.valid === true ||
      corporateRepresentativeSignedAt
  );
  const principalRow = {
    id: "__principal_representative__",
    coRepresentativeId: "__principal_representative__",
    name: normalizeRepresentativeNameForMatch(principalName) || principalName,
    ssnMasked:
      outputPrincipalResidentNumber ||
      representativePersonalGuarantee?.signerSsnMasked ||
      getPrincipalRepSsnDisplayValue(contract),
    outputResidentNumber:
      outputPrincipalResidentNumber ||
      representativePersonalGuarantee?.signerSsnMasked ||
      "",
    phone:
      contract?.adminOutputPhone ||
      contract?.agentContact ||
      contract?.verifiedPhone ||
      "",
    adminOutputPhone:
      contract?.adminOutputPhone ||
      contract?.agentContact ||
      contract?.verifiedPhone ||
      "",
    phoneMasked:
      outputPhoneNumber ||
      representativePersonalGuarantee?.signerPhoneMasked ||
      contract?.phoneMasked ||
      maskPhoneNumber(contract?.agentContact || ""),
    homeAddressMasked:
      representativePersonalGuarantee?.signerAddressMasked ||
      contract?.principalRepHomeAddressMasked ||
      maskHomeAddressForEvidence(
        [contract?.corpRepAddress, contract?.corpRepAddressDetail]
          .filter(Boolean)
          .join(" ")
      ),
    kcpStatus: getRepresentativeIdentityStatusForPdf(contract),
    signatureImageDataUrl: corporateRepresentativeSignatureImage,
    signatureEvidence: {
      role: "CORPORATE_REPRESENTATIVE",
      label: "주대표자 서명",
      signerName: normalizeRepresentativeNameForMatch(principalName) || principalName,
      valid: corporateRepresentativeSigned,
      signedAt: corporateRepresentativeSignedAt || null,
      signatureHash:
        representativePersonalGuarantee?.imageHash ||
        representativePersonalGuarantee?.signatureHash ||
        contract?.signature2Hash ||
        contract?.signatureHash ||
        null,
    },
    signatureStatus: corporateRepresentativeSigned ? "SIGNED" : "PENDING",
    signedAt: corporateRepresentativeSignedAt || null,
  };

  const dedupedRows = coRepresentativeRows.filter(
    (item) => !isSameCorporateCoRepresentativePdfRow(principalRow, item)
  );
  return [principalRow, ...dedupedRows];
};

export const getCoContractorPdfBlockLayout = ({
  blockY = 0,
  fieldBottomY = 0,
  hasSignatureImage = false,
} = {}) => {
  const signatureHeight = 68;
  const signatureBottomPadding = 18;
  const signatureRowY = Math.max(Number(fieldBottomY || 0) + 10, blockY + 146);
  const baseBlockHeight = hasSignatureImage ? 232 : 202;
  const blockHeight = Math.max(
    188,
    baseBlockHeight,
    signatureRowY + signatureHeight + signatureBottomPadding - blockY
  );
  return {
    blockY,
    blockHeight,
    signatureRowY,
    signatureHeight,
    signatureBottomPadding,
  };
};

const CO_REP_ADMIN_ACTION_STATUS = {
  NEEDS_INFO: "NEEDS_INFO",
  INVITE_NOT_ISSUED: "INVITE_NOT_ISSUED",
  INVITE_REISSUE_REQUIRED: "INVITE_REISSUE_REQUIRED",
  VERIFICATION_PENDING: "VERIFICATION_PENDING",
  SIGNATURE_PENDING: "SIGNATURE_PENDING",
  SIGNED_MISSING_IMAGE: "SIGNED_MISSING_IMAGE",
  COMPLETED: "COMPLETED",
};

const hasAdminCoRepresentativeSignal = (contract = {}) => {
  const representatives = Array.isArray(contract.coRepresentatives)
    ? contract.coRepresentatives
    : [];
  const contactSnapshot = Array.isArray(contract.coRepresentativesContactSnapshot)
    ? contract.coRepresentativesContactSnapshot
    : [];
  return Boolean(
    contract.coRepresentativeDeclared === true ||
      contract.hasCoRepresentative === true ||
      representatives.length > 0 ||
      contactSnapshot.length > 0 ||
      contract.coRepresentativeWorkflow?.required === true ||
      String(contract.contractStatus || "").includes("CO_REP") ||
      String(contract.status || "").includes("co_rep") ||
      (Array.isArray(contract.coRepresentativeInviteTokenHashes) &&
        contract.coRepresentativeInviteTokenHashes.length > 0) ||
      (Array.isArray(contract.coRepresentativeSignatureImages) &&
        contract.coRepresentativeSignatureImages.length > 0)
  );
};

const buildAdminCoRepresentativeRows = (contract = {}) => {
  const representatives = Array.isArray(contract.coRepresentatives)
    ? contract.coRepresentatives.filter(Boolean)
    : [];
  const contactRows = getCoRepresentativeOutputContactRows(contract);
  const restoredContactIds = new Set();
  const rows = representatives.map((item) => {
    const matchedContactRows = findMatchingCoRepresentativeOutputRows(
      contactRows,
      item
    );
    const contactRow = matchedContactRows[0] || {};
    const contactId = getCoRepresentativeOutputMatchId(contactRow);
    if (contactId) restoredContactIds.add(contactId);
    const contactPhoneCandidates = matchedContactRows.flatMap((row) => [
      row?.adminOutputPhone,
      row?.phone,
      row?.verifiedPhone,
      row?.identityVerification?.inputSnapshot?.phone,
      row?.identityVerification?.verifiedPhone,
    ]);
    const rawPhone = pickOutputRawPhone(
      item?.adminOutputPhone,
      item?.phone,
      item?.verifiedPhone,
      item?.identityVerification?.inputSnapshot?.phone,
      item?.identityVerification?.verifiedPhone,
      ...contactPhoneCandidates
    );
    return {
      ...contactRow,
      ...item,
      ...(rawPhone ? { adminOutputPhone: rawPhone, phone: rawPhone } : {}),
      phoneMasked: item?.phoneMasked || contactRow?.phoneMasked || "",
    };
  });

  contactRows.forEach((item, index) => {
    const id = getCoRepresentativeOutputMatchId(item);
    const name = normalizeRepresentativeNameForMatch(item?.name || "");
    const alreadyRestored =
      (id && restoredContactIds.has(id)) ||
      rows.some(
        (row) =>
          (id && getCoRepresentativeOutputMatchId(row) === id) ||
          (name &&
            normalizeRepresentativeNameForMatch(row?.name || "") === name)
      );
    if (alreadyRestored) return;
    rows.push({
      ...item,
      id: id || `__co_rep_admin_contact_${index + 1}__`,
      adminContactOnly: true,
      adminOutputPhone: item?.phone || item?.verifiedPhone || "",
      phone: item?.phone || item?.verifiedPhone || "",
      phoneMasked: item?.phoneMasked || maskPhoneNumber(item?.phone || ""),
    });
  });

  if (rows.length === 0 && hasAdminCoRepresentativeSignal(contract)) {
    return [
      {
        id: "__co_rep_info_required__",
        name: "공동계약인 정보 입력 필요",
        adminPlaceholder: true,
        verificationStatus: "NEEDS_INFO",
        signatureStatus: "NEEDS_INFO",
        overallStatus: "NEEDS_INFO",
      },
    ];
  }
  return rows;
};

export const getAdminCoRepresentativePhoneDisplay = (representative = {}) => {
  const rawPhone = pickOutputRawPhone(
    representative.adminOutputPhone,
    representative.phone,
    representative.verifiedPhone,
    representative.identityVerification?.inputSnapshot?.phone,
    representative.identityVerification?.verifiedPhone
  );
  if (rawPhone) return formatPhoneNumberForDisplay(rawPhone) || rawPhone;
  return representative.phoneMasked
    ? `${representative.phoneMasked} (원문 미수집)`
    : "휴대폰 미수집";
};

const isCoRepresentativeInviteExpiredForAdmin = (representative = {}) => {
  const status = String(
    representative.inviteStatus ||
      representative.signatureOnlyInviteStatus ||
      ""
  ).toUpperCase();
  if (status.includes("EXPIRED")) return true;
  const expiresAt =
    representative.inviteExpiresAt ||
    representative.expiresAt ||
    representative.inviteExpiredAt ||
    "";
  const expiresAtMs = expiresAt ? Date.parse(String(expiresAt)) : NaN;
  return Number.isFinite(expiresAtMs) && expiresAtMs > 0 && expiresAtMs < Date.now();
};

const isCoRepresentativeVerifiedForAdmin = (representative = {}) => {
  const verificationStatus = String(
    representative.verificationStatus ||
      representative.identityStatus ||
      representative.kcpStatus ||
      representative.identityVerification?.status ||
      ""
  ).toUpperCase();
  return (
    verificationStatus === "MATCHED" ||
    verificationStatus === "VERIFIED" ||
    representative.hasCi === true ||
    representative.identityVerification?.hasCi === true
  );
};

const isCoRepresentativeSignedForAdmin = (representative = {}) => {
  const signatureStatus = String(representative.signatureStatus || "").toUpperCase();
  return Boolean(
    representative.overallStatus === "COMPLETED" ||
      signatureStatus === "SIGNED" ||
      signatureStatus === "SIGNED_DIRECTLY" ||
      representative.signatureEvidence?.valid === true ||
      representative.completedAt ||
      representative.signedAt
  );
};

const hasCoRepresentativeSignatureImageForAdmin = (
  contract = {},
  representative = {}
) =>
  getCoRepresentativeSignatureOutputCandidates(contract, representative).some(
    (item) => Boolean(pickCoRepresentativeSignatureImageReference(item))
  );

const getCoRepAdminActionStatus = ({
  contract = {},
  representative = {},
  issuedLink = "",
} = {}) => {
  if (representative.adminPlaceholder || representative.adminContactOnly) {
    return CO_REP_ADMIN_ACTION_STATUS.NEEDS_INFO;
  }
  const hasName = Boolean(String(representative.name || "").trim());
  const hasAnyPhone = Boolean(
    pickOutputRawPhone(
      representative.adminOutputPhone,
      representative.phone,
      representative.verifiedPhone
    ) || representative.phoneMasked
  );
  if (!hasName || !hasAnyPhone) return CO_REP_ADMIN_ACTION_STATUS.NEEDS_INFO;

  const signed = isCoRepresentativeSignedForAdmin(representative);
  const hasSignatureImage = hasCoRepresentativeSignatureImageForAdmin(
    contract,
    representative
  );
  if (signed && !hasSignatureImage) {
    return CO_REP_ADMIN_ACTION_STATUS.SIGNED_MISSING_IMAGE;
  }
  if (
    representative.overallStatus === "COMPLETED" ||
    (isCoRepresentativeVerifiedForAdmin(representative) && signed)
  ) {
    return CO_REP_ADMIN_ACTION_STATUS.COMPLETED;
  }
  if (isCoRepresentativeVerifiedForAdmin(representative) && !signed) {
    return CO_REP_ADMIN_ACTION_STATUS.SIGNATURE_PENDING;
  }
  if (!issuedLink && isCoRepresentativeInviteExpiredForAdmin(representative)) {
    return CO_REP_ADMIN_ACTION_STATUS.INVITE_REISSUE_REQUIRED;
  }
  if (!issuedLink && representative.inviteTokenHash) {
    return CO_REP_ADMIN_ACTION_STATUS.INVITE_REISSUE_REQUIRED;
  }
  if (!issuedLink && !representative.inviteTokenHash) {
    return CO_REP_ADMIN_ACTION_STATUS.INVITE_NOT_ISSUED;
  }
  return CO_REP_ADMIN_ACTION_STATUS.VERIFICATION_PENDING;
};

const getCoRepAdminActionStatusMeta = (status = "") => {
  switch (status) {
    case CO_REP_ADMIN_ACTION_STATUS.NEEDS_INFO:
      return {
        label: "공동계약인 체크됨 / 정보 입력 필요",
        tone: "red",
        message: "공동계약인 이름과 휴대폰번호를 먼저 확인해 주세요.",
      };
    case CO_REP_ADMIN_ACTION_STATUS.INVITE_NOT_ISSUED:
      return {
        label: "공동계약인 링크 미발급",
        tone: "amber",
        message: "공동계약인 인증 링크를 생성해 전달해야 합니다.",
      };
    case CO_REP_ADMIN_ACTION_STATUS.INVITE_REISSUE_REQUIRED:
      return {
        label: "공동계약인 링크 재발급 필요",
        tone: "amber",
        message:
          "기존 링크는 보안상 재표시할 수 없습니다. 필요 시 재발급하세요.",
      };
    case CO_REP_ADMIN_ACTION_STATUS.SIGNATURE_PENDING:
      return {
        label: "공동계약인 인증 완료 / 서명 미완료",
        tone: "blue",
        message: "공동계약인 전자서명 완료 여부를 확인해 주세요.",
      };
    case CO_REP_ADMIN_ACTION_STATUS.SIGNED_MISSING_IMAGE:
      return {
        label: "공동계약인 서명 완료 / 서명 이미지 확인 필요",
        tone: "red",
        message:
          "공동계약인 서명 완료 상태이나 출력 가능한 서명 이미지가 없습니다. 출력 전 확인이 필요합니다.",
      };
    case CO_REP_ADMIN_ACTION_STATUS.COMPLETED:
      return {
        label: "공동계약인 인증 및 서명 완료",
        tone: "emerald",
        message: "공동계약인 본인확인과 전자서명이 완료되었습니다.",
      };
    case CO_REP_ADMIN_ACTION_STATUS.VERIFICATION_PENDING:
    default:
      return {
        label: "공동계약인 인증 대기",
        tone: "amber",
        message: "공동계약인 본인확인 완료 여부를 확인해 주세요.",
      };
  }
};

export const buildAdminContractOutputData = (
  contract = {},
  {
    revealedPrincipalResidentNumber = null,
    revealedCoRepresentativeResidentNumbers = {},
  } = {}
) => {
  const displayBusinessName = getAdminDisplayBusinessName(contract);
  const fullResidentNumber = formatDecryptedResidentRegistrationNumber(
    revealedPrincipalResidentNumber || ""
  );
  const coRepresentativesForOutput = mergeAdminOutputCoRepresentatives(contract, {
    revealedResidentNumbers: revealedCoRepresentativeResidentNumbers,
  });
  return {
    ...contract,
    agentName: displayBusinessName || contract.agentName,
    adminOutputBusinessName: displayBusinessName || contract.agentName || "",
    coRepresentatives: coRepresentativesForOutput,
    ...(fullResidentNumber
      ? { adminOutputPrincipalResidentNumber: fullResidentNumber }
      : {}),
  };
};

export const getBusinessNameCorrectionSourceLabel = (source = "") =>
  BUSINESS_NAME_CORRECTION_SOURCE_OPTIONS.find(
    (option) => option.value === source
  )?.label || trimBusinessNameCorrectionText(source) || "미수집";

export const buildBusinessNameCorrectionPatch = ({
  contract = {},
  correctedName = "",
  reason = "",
  source = "",
  correctedBy = "",
  correctedAt = new Date().toISOString(),
} = {}) => {
  const normalizedCorrectedName = trimBusinessNameCorrectionText(correctedName);
  const normalizedReason = trimBusinessNameCorrectionText(reason);
  const normalizedSource = trimBusinessNameCorrectionText(source);
  const originalName = getBusinessNameCorrectionOriginalName(contract);

  if (!originalName) {
    return {
      ok: false,
      message: "기존 고객 입력 상호명을 확인할 수 없습니다.",
    };
  }
  if (!normalizedCorrectedName) {
    return {
      ok: false,
      message: "정정할 상호명을 입력해 주세요.",
    };
  }
  if (!normalizedReason) {
    return {
      ok: false,
      message: "사업자 정보 정정 사유를 선택해 주세요.",
    };
  }
  if (!normalizedSource) {
    return {
      ok: false,
      message: "사업자 정보 정정 근거를 선택해 주세요.",
    };
  }

  return {
    ok: true,
    patch: {
      businessNameCorrection: {
        originalName,
        correctedName: normalizedCorrectedName,
        reason: normalizedReason,
        source: normalizedSource,
        correctedBy: trimBusinessNameCorrectionText(correctedBy) || "관리자",
        correctedAt,
        businessNumber: trimBusinessNameCorrectionText(
          contract.agentBizNo || contract.businessNumber
        ),
        affectsContractParty: false,
      },
    },
  };
};

export const getKcpFallbackReasonFromStartFailure = ({
  result = null,
  errorName = "",
}: {
  result?: { code?: string } | null;
  errorName?: string;
} = {}): KcpFallbackReason => {
  const code = String(result?.code || "").trim();
  if (
    errorName === "AbortError" ||
    code === "KCP_TIMEOUT" ||
    code === "KCP_REGISTER_TIMEOUT"
  ) {
    return "KCP_TIMEOUT";
  }
  if (code === "KCP_ENV_MISSING" || code === "SERVER_ENV_MISSING") {
    return "KCP_ENV_MISSING";
  }
  if (code === "KCP_REGISTRATION_FAILED") {
    return "KCP_REGISTRATION_FAILED";
  }
  if (code === "KCP_CALL_URL_MISSING") {
    return "KCP_CALL_URL_MISSING";
  }
  if (code === "KCP_REG_CERT_KEY_MISSING") {
    return "KCP_REG_CERT_KEY_MISSING";
  }
  if (
    code === "KCP_OPEN_FAILED" ||
    code === "KCP_FORM_BUILD_FAILED" ||
    code === "KCP_FORM_SUBMIT_FAILED" ||
    code === "KCP_NETWORK_ERROR" ||
    code === "KCP_REGISTRATION_NETWORK_ERROR"
  ) {
    return "KCP_START_FAILED";
  }
  return code ? "KCP_UNKNOWN_ERROR" : "KCP_START_FAILED";
};

const escapeHtml = (value = "") =>
  String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");

export const buildCreditCheckConsentLines = () => [
  "[신용정보 조회 및 활용 동의]",
  "본인은 공급자가 본 계약의 체결 및 거래 유지, 채권관리, 미수금 관리, 신용거래 여부 판단을 위하여 아래의 신용정보를 조회·활용하는 것에 동의합니다.",
  "1. 목적: 상거래 관계의 설정 및 유지 여부 판단, 채권추심 등 거래관계 유지 및 관리",
  `2. 신용정보 조회회사: ${CREDIT_CHECK_COMPANY}`,
  "3. 조회할 신용정보: 개인신용평점, 신용거래정보, 연체정보, 채무불이행정보, 공공정보 등",
  "4. 이용기간: 계약의 종료 또는 채무 변제 완료 시까지",
  "5. 유의사항: 본 동의를 거부할 수 있으나, 동의하지 않을 경우 신용거래 조건의 제공 또는 계약 진행이 제한될 수 있습니다.",
];

export const getRepresentativeVerificationStatus =
  (): RepresentativeVerificationStatus => {
    return "PENDING_KCP";
  };

export const SUPPLY_CONTRACT_IMAGE_TERM_LAYOUT = {
  columnWidth: 510,
  titleLineHeight: 17,
  bodyLineHeight: 15,
  titleFontSize: 14,
  bodyFontSize: 13,
  sectionGap: 5,
};

export const buildSupplyContractImageTermColumns = ({
  year = "",
  month = "",
  day = "",
  depositText = "당일",
  clauses = null,
  contractData = {},
  activeTemplate = null,
} = {}) => {
  const normalizedInputClauses = normalizeContractTemplateClauses(clauses || []);
  const inferredContractDate =
    contractData.contractDate ||
    (year && month && day
      ? `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`
      : "");
  const inferredDepositDay =
    contractData.depositDay ||
    (String(depositText).match(/\d+/)?.[0] || "");
  const resolvedClauses =
    normalizedInputClauses.length > 0
      ? normalizedInputClauses
      : resolveContractClauseSource({
          activeTemplate,
          contractData: {
            ...contractData,
            contractDate: inferredContractDate,
            depositDay: inferredDepositDay,
          },
        }).clauses;
  const sections = resolvedClauses.map((clause) => ({
    title: clause.title,
    lines: String(clause.body || "")
      .split(/\r?\n/)
      .filter((line) => line.trim()),
  }));
  const midpoint = Math.ceil(sections.length / 2);

  return {
    left: sections.slice(0, midpoint),
    right: sections.slice(midpoint),
  };
};

export const measureSupplyContractImageTermColumnHeight = ({
  ctx,
  sections = [],
  width = SUPPLY_CONTRACT_IMAGE_TERM_LAYOUT.columnWidth,
  layout = SUPPLY_CONTRACT_IMAGE_TERM_LAYOUT,
} = {}) =>
  sections.reduce((height, section) => {
    const titleBox = splitTextToFitBox({
      ctx,
      text: section.title,
      width,
      lineHeight: layout.titleLineHeight,
      fontSize: layout.titleFontSize,
      minFontSize: layout.titleFontSize,
      fontFamily: "sans-serif",
      fontWeight: "bold",
    });
    const bodyHeight = (section.lines || []).reduce((sum, line) => {
      const bodyBox = splitTextToFitBox({
        ctx,
        text: line,
        width,
        lineHeight: layout.bodyLineHeight,
        fontSize: layout.bodyFontSize,
        minFontSize: layout.bodyFontSize,
        fontFamily: "sans-serif",
      });
      return sum + bodyBox.height;
    }, 0);
    return height + titleBox.height + bodyHeight + layout.sectionGap;
  }, 0);

export const CONTRACT_CLAUSE_PDF_PAGE_LAYOUT = {
  width: 1240,
  height: 1754,
  contentX: 70,
  contentStartY: 270,
  contentWidth: 1100,
  bottomY: 1605,
  titleLineHeight: 30,
  bodyLineHeight: 24,
  paragraphGap: 10,
  clauseGap: 18,
  titleFont: "bold 20px sans-serif",
  bodyFont: "17px sans-serif",
};

export const CONTRACT_SIGNATURE_PDF_LAYOUT = {
  contentStartY: 270,
  minimumHeight: 1050,
};

export type ContractClauseRenderItem = {
  clauseId: string;
  kind: "title" | "body" | "gap";
  text: string;
  height: number;
  font: string;
  lineHeight: number;
};

export type ContractClauseRenderPage = {
  pageIndex: number;
  startY: number;
  endY: number;
  items: ContractClauseRenderItem[];
};

export const wrapCanvasTextForPdf = ({
  ctx,
  text = "",
  maxWidth = CONTRACT_CLAUSE_PDF_PAGE_LAYOUT.contentWidth,
  font = CONTRACT_CLAUSE_PDF_PAGE_LAYOUT.bodyFont,
}: {
  ctx: Pick<CanvasRenderingContext2D, "font" | "measureText">;
  text?: string;
  maxWidth?: number;
  font?: string;
}) => {
  const value = String(text || "");
  if (!value) return [""];
  ctx.font = font;
  const lines: string[] = [];
  let line = "";

  for (let index = 0; index < value.length; index += 1) {
    const char = value[index];
    const testLine = line + char;
    if (line && ctx.measureText(testLine).width > maxWidth) {
      lines.push(line);
      line = char;
    } else {
      line = testLine;
    }
  }

  if (line) lines.push(line);
  return lines.length > 0 ? lines : [value];
};

export const buildContractClauseRenderPages = ({
  ctx,
  clauses = [],
  layout = CONTRACT_CLAUSE_PDF_PAGE_LAYOUT,
  firstContentStartY = layout.contentStartY,
}: {
  ctx: Pick<CanvasRenderingContext2D, "font" | "measureText">;
  clauses?: ContractClause[];
  layout?: typeof CONTRACT_CLAUSE_PDF_PAGE_LAYOUT;
  firstContentStartY?: number;
}): ContractClauseRenderPage[] => {
  const normalizedClauses = normalizeContractTemplateClauses(clauses);
  const pages: ContractClauseRenderPage[] = [];
  let currentItems: ContractClauseRenderItem[] = [];
  let currentPageStartY = firstContentStartY;
  let currentY = firstContentStartY;

  const pushPage = () => {
    if (currentItems.length === 0) return;
    pages.push({
      pageIndex: pages.length,
      startY: currentPageStartY,
      endY: currentY,
      items: currentItems,
    });
    currentItems = [];
    currentPageStartY = layout.contentStartY;
    currentY = layout.contentStartY;
  };

  const remainingSpace = () => layout.bottomY - currentY;
  const ensureSpace = (height: number) => {
    if (currentItems.length > 0 && remainingSpace() < height) {
      pushPage();
    }
  };
  const addItem = (item: ContractClauseRenderItem) => {
    ensureSpace(item.height);
    currentItems.push(item);
    currentY += item.height;
  };

  normalizedClauses.forEach((clause) => {
    const bodyParagraphs = String(clause.body || "").split(/\r?\n/);
    const firstBodyLines = bodyParagraphs
      .filter((line) => line.trim())
      .flatMap((line) =>
        wrapCanvasTextForPdf({
          ctx,
          text: line.trim(),
          maxWidth: layout.contentWidth,
          font: layout.bodyFont,
        })
      );
    const minimumStartHeight =
      layout.titleLineHeight +
      Math.max(1, Math.min(2, firstBodyLines.length)) * layout.bodyLineHeight +
      layout.clauseGap;
    ensureSpace(minimumStartHeight);

    addItem({
      clauseId: clause.id,
      kind: "title",
      text: clause.title,
      height: layout.titleLineHeight,
      font: layout.titleFont,
      lineHeight: layout.titleLineHeight,
    });

    bodyParagraphs.forEach((paragraph) => {
      const trimmed = paragraph.trim();
      if (!trimmed) {
        addItem({
          clauseId: clause.id,
          kind: "gap",
          text: "",
          height: layout.paragraphGap,
          font: layout.bodyFont,
          lineHeight: layout.paragraphGap,
        });
        return;
      }

      wrapCanvasTextForPdf({
        ctx,
        text: trimmed,
        maxWidth: layout.contentWidth,
        font: layout.bodyFont,
      }).forEach((line) => {
        addItem({
          clauseId: clause.id,
          kind: "body",
          text: line,
          height: layout.bodyLineHeight,
          font: layout.bodyFont,
          lineHeight: layout.bodyLineHeight,
        });
      });
    });

    addItem({
      clauseId: clause.id,
      kind: "gap",
      text: "",
      height: layout.clauseGap,
      font: layout.bodyFont,
      lineHeight: layout.clauseGap,
    });
  });

  pushPage();
  return pages;
};

export const buildDefaultContractTermLines = (contractData = {}) => {
  const receiverName = contractData.agentName || "공급받는자";
  const receiverRep =
    contractData.corpRepName || contractData.agentRep || "대표자/담당자";
  const receiverAddress = [
    contractData.agentAddress,
    contractData.agentAddressDetail,
  ]
    .filter(Boolean)
    .join(" ");

  return [
    ...buildDefaultContractClauses(contractData).flatMap((clause) => [
      clause.title,
      ...String(clause.body || "").split(/\r?\n/),
    ]),
    "",
    "계약 당사자 정보",
    `공급받는자: ${receiverName}`,
    `대표자 또는 계약 담당자: ${receiverRep}`,
    `사업장 주소: ${receiverAddress || "미입력"}`,
    "",
    ...buildCreditCheckConsentLines(),
  ];
};

export const normalizeContractTemplateClauses = (clauses = []): ContractClause[] => {
  if (!Array.isArray(clauses)) return [];
  return clauses
    .map((clause, index) => {
      const title = String(clause?.title || "").trim();
      const body = String(clause?.body || "").trim();
      const id =
        String(clause?.id || "")
          .trim()
          .replace(/[^a-zA-Z0-9_-]/g, "") || `clause_${index + 1}`;
      if (!title && !body) return null;
      return { id, title, body };
    })
    .filter((clause): clause is ContractClause =>
      Boolean(clause && clause.title && clause.body)
    );
};

export const buildDefaultContractClauses = (_contractData = {}): ContractClause[] => {
  return LEGACY_DEFAULT_CONTRACT_CLAUSES.map((clause) => ({ ...clause }));
};

export const buildDefaultContractTemplate = (contractData = {}): ContractTemplate => ({
  versionId: LEGACY_CONTRACT_DOCUMENT_VERSION,
  status: "FALLBACK",
  source: "DEFAULT",
  title: DEFAULT_CONTRACT_TEMPLATE_TITLE,
  clauses: buildDefaultContractClauses(contractData),
});

export const buildNewContractTemplate = (_contractData = {}): ContractTemplate => ({
  versionId: CONTRACT_DOCUMENT_VERSION,
  status: "FALLBACK",
  source: "DEFAULT",
  title: DEFAULT_CONTRACT_TEMPLATE_TITLE,
  clauses: CNFOOD_SUPPLY_TERMS_V2_CLAUSES.map((clause) => ({ ...clause })),
});

const isCompletedContractLike = (contract: any = {}) =>
  Boolean(
    contract?.finalSnapshot ||
      contract?.completedAt ||
      String(contract?.status || "").toLowerCase() === "completed" ||
      String(contract?.contractStatus || "").toUpperCase() === "COMPLETED"
  );

// Only new corporate submissions receive this output revision in the existing version field.
export const CONTRACT_PRINT_R2_VERSION_SUFFIX = "::PRINT_R2_2026-10-12";

type CorporateContractPrintHistory = {
  bizType?: string;
  finalSnapshot?: { completedAt?: unknown } | null;
  completedAt?: unknown;
  submittedAt?: unknown;
  status?: string;
  contractStatus?: string;
  documentId?: string;
  id?: string;
  contractId?: string;
  documentVersion?: unknown;
  isLocked?: boolean;
  lockedAt?: unknown;
};

const hasCorporateContractPrintHistory = (
  contract: CorporateContractPrintHistory = {},
  existingContract = false
): boolean => {
  return Boolean(
    existingContract ||
    isCompletedContractLike(contract) || contract.submittedAt ||
      contract.documentId || contract.id || contract.contractId ||
      contract.documentVersion !== undefined || contract.isLocked || contract.lockedAt
  );
};

export const getContractDocumentVersionForSubmission = (
  bizType: string,
  contract: CorporateContractPrintHistory = {},
  existingContract = false
): unknown => {
  if (!isCorporateContract(bizType)) return CONTRACT_DOCUMENT_VERSION;
  if (hasCorporateContractPrintHistory(contract, existingContract)) {
    return contract.documentVersion;
  }
  return `${CONTRACT_DOCUMENT_VERSION}${CONTRACT_PRINT_R2_VERSION_SUFFIX}`;
};

export const shouldUseCorporateContractPrintR2 = (
  contract: CorporateContractPrintHistory = {}
): boolean => isCorporateContract(contract.bizType);

export const shouldPreserveExistingCorporatePdfEvidence = (
  contract: CorporateContractPrintHistory = {},
  existingContract = false
): boolean => {
  if (!isCorporateContract(contract.bizType)) return false;
  if (!hasCorporateContractPrintHistory(contract, existingContract)) return false;
  return !(typeof contract.documentVersion === "string" &&
    contract.documentVersion.length > CONTRACT_PRINT_R2_VERSION_SUFFIX.length &&
    contract.documentVersion.endsWith(CONTRACT_PRINT_R2_VERSION_SUFFIX));
};

type CorporateContractDepositOutputOptions = {
  bizType?: string;
  depositDay?: string | number | null;
  legacyDepositText: string;
  enabled: boolean;
  sameDayDeposit?: boolean;
  completedContract?: boolean;
};

export const getCorporateContractDepositOutputText = ({
  bizType = "",
  depositDay,
  legacyDepositText,
  enabled,
  sameDayDeposit = false,
  completedContract = false,
}: CorporateContractDepositOutputOptions): string => {
  const legacy = `입금 예정일: ${legacyDepositText}`;
  if (!enabled || !isCorporateContract(bizType)) return legacy;
  const rawDay = String(depositDay ?? "");
  if (!rawDay) {
    return sameDayDeposit || completedContract ? legacy : "당월 마감후 익월 ____일";
  }
  if (/^_+$/.test(rawDay)) return `당월 마감후 익월 ${rawDay}일`;
  if (!/^[0-9]+$/.test(rawDay)) return legacy;
  const day = Number(rawDay);
  if (!Number.isInteger(day) || day < 1 || day > 31) return legacy;
  return `당월 마감후 익월 ${day === 31 ? "30" : rawDay}일`;
};

const pickTemplateVersion = (...values: any[]) =>
  values.map((value) => String(value || "").trim()).find(Boolean) ||
  LEGACY_CONTRACT_DOCUMENT_VERSION;

const pickTemplateTitle = (...values: any[]) =>
  values.map((value) => String(value || "").trim()).find(Boolean) ||
  DEFAULT_CONTRACT_TEMPLATE_TITLE;

export const resolveContractClauseSource = ({
  contract = {},
  activeTemplate = null,
  contractData = {},
}: {
  contract?: any;
  activeTemplate?: Partial<ContractTemplate> | null;
  contractData?: any;
} = {}): ResolvedContractClauseSource => {
  const completedLike = isCompletedContractLike(contract);
  const contractSnapshot = normalizeContractTemplateClauses(
    contract?.contractClausesSnapshot || []
  );
  if (contractSnapshot.length > 0) {
    return {
      source: "CONTRACT_SNAPSHOT",
      versionId: pickTemplateVersion(
        contract?.contractTemplateVersion,
        contract?.finalSnapshot?.contractTemplateVersion
      ),
      title: pickTemplateTitle(
        contract?.contractTemplateTitle,
        contract?.finalSnapshot?.contractTemplateTitle
      ),
      clauses: contractSnapshot,
    };
  }

  const finalSnapshot = normalizeContractTemplateClauses(
    contract?.finalSnapshot?.contractClausesSnapshot || []
  );
  if (finalSnapshot.length > 0) {
    return {
      source: "FINAL_SNAPSHOT",
      versionId: pickTemplateVersion(
        contract?.finalSnapshot?.contractTemplateVersion,
        contract?.contractTemplateVersion
      ),
      title: pickTemplateTitle(
        contract?.finalSnapshot?.contractTemplateTitle,
        contract?.contractTemplateTitle
      ),
      clauses: finalSnapshot,
    };
  }

  const dataSnapshot = normalizeContractTemplateClauses(
    contractData?.contractClausesSnapshot || []
  );
  if (dataSnapshot.length > 0) {
    return {
      source: "DATA_SNAPSHOT",
      versionId: pickTemplateVersion(
        contractData?.contractTemplateVersion,
        contract?.contractTemplateVersion
      ),
      title: pickTemplateTitle(
        contractData?.contractTemplateTitle,
        contract?.contractTemplateTitle
      ),
      clauses: dataSnapshot,
    };
  }

  const templateCandidate = completedLike
    ? null
    : activeTemplate || contractData?.contractTemplate || contract?.contractTemplate;
  const templateClauses = normalizeContractTemplateClauses(
    templateCandidate?.clauses || []
  );
  if (templateClauses.length > 0) {
    return {
      source: "ACTIVE_TEMPLATE",
      versionId: pickTemplateVersion(templateCandidate?.versionId),
      title: pickTemplateTitle(templateCandidate?.title),
      clauses: templateClauses,
    };
  }

  const fallback = buildDefaultContractTemplate(contractData || contract || {});
  return {
    source: "DEFAULT_TEMPLATE",
    versionId: fallback.versionId,
    title: fallback.title,
    clauses: fallback.clauses,
  };
};

export const buildContractClausesSnapshot = (
  template: Partial<ContractTemplate> | null | undefined,
  contractData = {}
): ContractClause[] => {
  const normalized = normalizeContractTemplateClauses(template?.clauses || []);
  if (normalized.length > 0) return normalized;
  return buildDefaultContractTemplate(contractData).clauses;
};

export const buildContractTemplateSnapshotFields = (
  template: Partial<ContractTemplate> | null | undefined,
  contractData = {}
) => {
  const resolved = resolveContractClauseSource({
    contract: contractData,
    activeTemplate: template || null,
    contractData,
  });
  return {
    contractTemplateVersion: resolved.versionId,
    contractTemplateTitle: resolved.title,
    contractClausesSnapshot: resolved.clauses,
  };
};

export const flattenContractClausesForDisplay = (clauses = []) =>
  normalizeContractTemplateClauses(clauses).flatMap((clause) => [
    clause.title,
    ...String(clause.body || "").split(/\r?\n/),
  ]);

export const buildContractTermLines = (contractData = {}) => {
  const clauses = resolveContractClauseSource({
    contract: contractData,
    activeTemplate: contractData.contractTemplate || null,
    contractData,
  }).clauses;
  const receiverName = contractData.agentName || "공급받는자";
  const receiverRep =
    contractData.corpRepName || contractData.agentRep || "대표자/담당자";
  const receiverAddress = [
    contractData.agentAddress,
    contractData.agentAddressDetail,
  ]
    .filter(Boolean)
    .join(" ");
  return [
    ...flattenContractClausesForDisplay(clauses),
    "",
    "계약 당사자 정보",
    `공급받는자: ${receiverName}`,
    `대표자 또는 계약 담당자: ${receiverRep}`,
    `사업장 주소: ${receiverAddress || "미입력"}`,
    "",
    ...buildCreditCheckConsentLines(),
  ];
};

export const buildContractTextSnapshot = (contractData = {}) => {
  const clauseSource = resolveContractClauseSource({
    contract: contractData,
    activeTemplate: contractData.contractTemplate || null,
    contractData,
  });
  const address = [
    contractData.agentAddress,
    contractData.agentAddressDetail,
  ]
    .filter(Boolean)
    .join(" ");
  const branchSnapshot = contractData.contractCompanyBranch || null;
  const supplierLines =
    branchSnapshot?.id
      ? [
          `공급자: ${formatEvidenceValue(
            branchSnapshot.corporationName || branchSnapshot.branchName
          )} / 대표자 ${formatEvidenceValue(
            branchSnapshot.representativeName
          )} / 사업자번호 ${formatEvidenceValue(branchSnapshot.businessNumber)}`,
        ]
      : [
          `공급자 1: ${formatEvidenceValue(contractData.supplier1)} / 대표자 ${formatEvidenceValue(
            contractData.rep1
          )} / 사업자번호 ${formatEvidenceValue(contractData.bizNo1)}`,
          `공급자 2: ${formatEvidenceValue(contractData.supplier2)} / 대표자 ${formatEvidenceValue(
            contractData.rep2
          )} / 사업자번호 ${formatEvidenceValue(contractData.bizNo2)}`,
        ];
  const signerName = isCorporateContract(contractData.bizType)
    ? contractData.corpRepName || contractData.agentRep
    : contractData.agentRep;

  return [
    `계약서 버전: ${clauseSource.versionId}`,
    `계약 ID: ${formatEvidenceValue(contractData.contractId, "임시")}`,
    ...supplierLines,
    `공급받는자: ${formatEvidenceValue(contractData.agentName)}`,
    `대표자/성명: ${formatEvidenceValue(signerName)}`,
    `사업자번호: ${formatEvidenceValue(contractData.agentBizNo)}`,
    `주소: ${formatEvidenceValue(address)}`,
    `휴대폰 번호: ${formatEvidenceValue(
      getSafePhoneMasked(contractData.phoneMasked || contractData.agentContact)
    )}`,
    `입금일: ${
      contractData.depositDay ? `${contractData.depositDay}일` : "당일"
    }`,
    `계약일: ${formatEvidenceValue(contractData.contractDate)}`,
    `휴대폰 번호 확인: ${getPhoneVerificationDisplayMethod(contractData)}`,
    `계약 내용 확인 및 동의: ${
      contractData.hasReadAndAgreedContract ? "동의" : "미확인"
    }`,
    `계약 체결 권한 확인: ${
      contractData.hasContractAuthority ? "확인" : "미확인"
    }`,
    `신용정보 조회 및 활용 동의: ${
      contractData.hasCreditCheckConsent ? "동의" : "미확인"
    }`,
    `신용정보 조회회사: ${formatEvidenceValue(
      contractData.creditCheckCompany || CREDIT_CHECK_COMPANY
    )}`,
    `대표자 검증 상태: ${formatEvidenceValue(
      contractData.representativeVerificationStatus ||
        getRepresentativeVerificationStatus()
    )}`,
    "",
    "계약 주요 내용",
    ...buildContractTermLines(contractData),
  ].join("\n");
};

export const buildContractHtmlSnapshot = (
  contractData = {},
  textSnapshot = buildContractTextSnapshot(contractData)
) => {
  const templateVersion =
    contractData.contractTemplateVersion || LEGACY_CONTRACT_DOCUMENT_VERSION;
  return [
    `<article data-template-version="${escapeHtml(templateVersion)}">`,
    "<h1>통합 공급계약서</h1>",
    `<pre>${escapeHtml(textSnapshot)}</pre>`,
    "</article>",
  ].join("");
};

export const sanitizeCoRepresentativesForEvidenceSnapshot = (
  representatives = []
) =>
  (Array.isArray(representatives) ? representatives : [])
    .map((item) => {
      if (!item || typeof item !== "object") return null;
      const signatureMode = getCoRepresentativeSignatureMode(item);
      const signatureEvidence = sanitizeCoRepresentativeDirectSignatureEvidence(item);
      return {
        id: item.id || "",
        name: normalizeRepresentativeNameForMatch(item.name || ""),
        ssnMasked:
          item.ssnMasked || maskResidentRegistrationNumber(item.ssnFront || ""),
        ssnHash: item.ssnHash || null,
        ssnHmac: item.ssnHmac || null,
        phoneMasked: item.phoneMasked || maskPhoneNumber(item.phone || ""),
        homeAddressMasked:
          item.homeAddressMasked ||
          maskHomeAddressForEvidence(getCoRepresentativeFullHomeAddress(item)),
        kcpSessionId: item.kcpSessionId || "",
        kcpStatus: item.kcpStatus || item.identityVerification?.status || "PENDING",
        identityStatus: item.identityStatus || "PENDING",
        ntsStatus: item.ntsStatus || "NTS_NOT_SUPPORTED_OR_MANUAL_REVIEW",
        identityVerification: item.identityVerification
          ? {
              provider: item.identityVerification.provider || "KCP",
              subjectType: item.identityVerification.subjectType || "CO_REP",
              coRepresentativeId:
                item.identityVerification.coRepresentativeId || item.id || "",
              status: item.identityVerification.status || "PENDING",
              verifiedAt: item.identityVerification.verifiedAt || null,
              checks: {
                nameMatched:
                  item.identityVerification.checks?.nameMatched === true,
                birthDateMatched:
                  item.identityVerification.checks?.birthDateMatched === true,
                phoneMatched:
                  item.identityVerification.checks?.phoneMatched === true,
                ssnBackVerifiedByKcp: false,
              },
              ciHash: item.identityVerification.ciHash || null,
              diHash: item.identityVerification.diHash || null,
              ciHmac: item.identityVerification.ciHmac || null,
              diHmac: item.identityVerification.diHmac || null,
              hasCi: Boolean(
                item.identityVerification.hasCi ||
                  item.identityVerification.ciHash ||
                  item.identityVerification.ciHmac ||
                  item.identityVerification.kcpSnapshot?.ciHash ||
                  item.identityVerification.kcpSnapshot?.ciHmac
              ),
              hasDi: Boolean(
                item.identityVerification.hasDi ||
                  item.identityVerification.diHash ||
                  item.identityVerification.diHmac ||
                  item.identityVerification.kcpSnapshot?.diHash ||
                  item.identityVerification.kcpSnapshot?.diHmac
              ),
            }
          : null,
        delegatedSignatureConsent: item.delegatedSignatureConsent
          ? {
              agreed: item.delegatedSignatureConsent.agreed === true,
              agreedAt: item.delegatedSignatureConsent.agreedAt || null,
              consentTextVersion:
                item.delegatedSignatureConsent.consentTextVersion ||
                CO_REPRESENTATIVE_DELEGATED_SIGNATURE_CONSENT_VERSION,
              principalSignerName:
                item.delegatedSignatureConsent.principalSignerName || "",
            }
          : null,
        signatureMode,
        signatureEvidence,
        signatureHash: signatureEvidence?.signatureHash || null,
        signatureStatus:
          signatureMode === CO_REPRESENTATIVE_SIGNATURE_MODE_DIRECT &&
          signatureEvidence?.valid
            ? "SIGNED_DIRECTLY"
            : item.signatureStatus || "PENDING",
        signedAt: signatureEvidence?.signedAt || item.signedAt || null,
        openedAt: item.openedAt || null,
        verifiedAt: item.verifiedAt || item.identityVerification?.verifiedAt || null,
        completedAt: item.completedAt || null,
        signerIpHash: item.signerIpHash || item.ipHash || "",
        userAgent: item.userAgent || item.signerUserAgent || "",
      };
    })
    .filter(Boolean);

export const createContractFinalSnapshot = async ({
  contractData = {},
  contractHtmlSnapshot = "",
  contractTextSnapshot = "",
  signatureImageDataUrl = "",
  signedAt = "",
  completedAt = "",
  contractTemplateVersion = LEGACY_CONTRACT_DOCUMENT_VERSION,
} = {}): Promise<ContractFinalSnapshot> => {
  const templateSnapshotFields = buildContractTemplateSnapshotFields(
    {
      versionId:
        contractData.contractTemplateVersion || contractTemplateVersion,
      title:
        contractData.contractTemplateTitle || DEFAULT_CONTRACT_TEMPLATE_TITLE,
      clauses: contractData.contractClausesSnapshot,
    },
    contractData
  );
  const effectiveContractData = {
    ...contractData,
    ...templateSnapshotFields,
  };
  const textSnapshot =
    contractTextSnapshot || buildContractTextSnapshot(effectiveContractData);
  const htmlSnapshot =
    contractHtmlSnapshot ||
    buildContractHtmlSnapshot(effectiveContractData, textSnapshot);
  const address = [
    contractData.agentAddress,
    contractData.agentAddressDetail,
  ]
    .filter(Boolean)
    .join(" ");
  const representativeName =
    contractData.corpRepName || contractData.agentRep || contractData.contactName || "";
  const contactName = contractData.contactName || representativeName;
  const businessInfoSnapshot = {
    companyName: contractData.agentName || "",
    businessNumber: contractData.agentBizNo || "",
    representativeName,
    address,
    contactName,
    contactPhoneMasked: getSafePhoneMasked(
      contractData.phoneMasked || contractData.agentContact || ""
    ),
  };
  const contractCompanyBranch = buildContractCompanyBranchSnapshot({
    branch:
      contractData.contractCompanyBranch ||
      contractData.companyBranchSnapshot ||
      null,
  });
  const supplierInfoSnapshot = buildSupplierInfoSnapshot({
    companyName:
      contractCompanyBranch.corporationName ||
      contractCompanyBranch.branchName ||
      CNFOOD_BUSINESS_PROFILE.companyName,
    businessNumber:
      contractCompanyBranch.businessNumber ||
      CNFOOD_BUSINESS_PROFILE.businessNumber,
    representativeName:
      contractCompanyBranch.representativeName ||
      CNFOOD_BUSINESS_PROFILE.representativeName,
    mainPhone: contractData.companyBranchPhone || CNFOOD_BUSINESS_PROFILE.mainPhone,
    businessAddress:
      contractCompanyBranch.address || CNFOOD_BUSINESS_PROFILE.businessAddress,
  });
  const ownerFields = buildInviteContractFields(contractData);
  const ownerType = ownerFields.ownerType;
  const ownerLabel = ownerFields.ownerLabel;
  const salesRepId = ownerFields.salesRepId;
  const salesRepName = ownerFields.salesRepName;
  const salesRepDepartmentPart = ownerFields.salesRepDepartmentPart;
  const hasCreditCheckConsent = contractData.hasCreditCheckConsent === true;
  const creditCheckCompany =
    contractData.creditCheckCompany || CREDIT_CHECK_COMPANY;
  const creditCheckConsentAt = contractData.creditCheckConsentAt || null;
  const representativeVerificationStatus =
    contractData.representativeVerificationStatus ||
    getRepresentativeVerificationStatus();
  const identityVerificationMethod =
    contractData.identityVerificationMethod || null;
  const identityVerificationProvider =
    contractData.identityVerificationProvider || null;
  const identityVerificationStatus =
    contractData.identityVerificationStatus || null;
  const identityVerification = contractData.identityVerification || null;
  const representativeIdentityVerification =
    contractData.representativeIdentityVerification || null;
  const businessVerification = contractData.businessVerification || null;
  const lockedIdentityFields = contractData.lockedIdentityFields || null;
  const identityEvidenceVersion =
    contractData.identityEvidenceVersion || STRICT_IDENTITY_EVIDENCE_VERSION;
  const kcpFallbackReason = contractData.kcpFallbackReason || null;
  const consentSnapshot = contractData.consentSnapshot || null;
  const signatureEvidence = contractData.signatureEvidence || null;
  const representativePersonalGuarantee =
    contractData.representativePersonalGuarantee || null;
  const coRepresentativeInfo = resolveCoRepresentativeInfo({
    ntsInfo: contractData.coRepresentativeInfo || null,
    userDeclared:
      contractData.coRepresentativeInfo?.status === "USER_DECLARED" ||
      contractData.coRepresentativeDeclared === true,
  });
  const coRepresentatives = sanitizeCoRepresentativesForEvidenceSnapshot(
    contractData.coRepresentatives || []
  );
  const signatureHash = await createSha256Hash(signatureImageDataUrl || "");
  const contractHash = await createSha256Hash(
    JSON.stringify({
      contractTemplateVersion: templateSnapshotFields.contractTemplateVersion,
      contractTemplateTitle: templateSnapshotFields.contractTemplateTitle,
      contractClausesSnapshot: templateSnapshotFields.contractClausesSnapshot,
      contractHtmlSnapshot: htmlSnapshot,
      contractTextSnapshot: textSnapshot,
      supplierInfoSnapshot,
      contractCompanyBranch,
      businessInfoSnapshot,
      ownerType,
      ownerLabel,
      salesRepId,
      salesRepName,
      salesRepDepartmentPart,
      signedAt,
      completedAt,
      signatureHash,
      contractId: contractData.contractId || null,
      hasReadAndAgreedContract:
        contractData.hasReadAndAgreedContract === true,
      hasContractAuthority: contractData.hasContractAuthority === true,
      hasCreditCheckConsent,
      creditCheckCompany,
      creditCheckConsentAt,
      representativeVerificationStatus,
      identityVerificationMethod,
      identityVerificationProvider,
      identityVerificationStatus,
      identityVerification,
      representativeIdentityVerification,
      businessVerification,
      lockedIdentityFields,
      identityEvidenceVersion,
      kcpFallbackReason,
      consentSnapshot,
      coRepresentativeInfo,
      coRepresentatives,
      signatureEvidence,
      representativePersonalGuarantee,
    })
  );

  return {
    contractTemplateVersion: templateSnapshotFields.contractTemplateVersion,
    contractTemplateTitle: templateSnapshotFields.contractTemplateTitle,
    contractClausesSnapshot: templateSnapshotFields.contractClausesSnapshot,
    contractHtmlSnapshot: htmlSnapshot,
    contractTextSnapshot: textSnapshot,
    supplierInfoSnapshot,
    contractCompanyBranch,
    businessInfoSnapshot,
    ownerType,
    ownerLabel,
    salesRepId,
    salesRepName,
    salesRepDepartmentPart,
    signedAt,
    completedAt,
    signatureImageDataUrl: signatureImageDataUrl || undefined,
    signatureHash,
    contractHash,
    hasCreditCheckConsent,
    creditCheckCompany,
    creditCheckConsentAt,
    representativeVerificationStatus,
    identityVerificationMethod: identityVerificationMethod || undefined,
    identityVerificationProvider: identityVerificationProvider || undefined,
    identityVerificationStatus: identityVerificationStatus || undefined,
    identityVerification,
    representativeIdentityVerification,
    businessVerification,
    lockedIdentityFields,
    identityEvidenceVersion,
    kcpFallbackReason,
    consentSnapshot: consentSnapshot || undefined,
    coRepresentativeInfo,
    coRepresentatives,
    signatureEvidence,
    representativePersonalGuarantee,
  };
};

const sanitizeLogText = (value = "") => {
  return String(value ?? "")
    .replace(/data:image\/[a-zA-Z0-9.+-]+;base64,[A-Za-z0-9+/=]+/g, "[removed-data-url]")
    .replace(/\b(reg_cert_key|enc_data|rv|enc_key|kcp_enc_key|ci|di)\s*[:=]\s*[^&\s,)]+/gi, "$1=[removed]")
    .replace(/(\d{6})[-\s]?(\d{7})/g, "$1-*******")
    .replace(/01[016789][-\s]?\d{3,4}[-\s]?\d{4}/g, (match) =>
      maskPhoneNumber(match) || "****"
    )
    .replace(/(생년월일\s*[:：]?\s*)\d{6}/g, "$1******");
};

const SENSITIVE_LOG_KEYS = new Set([
  "signature",
  "signature2",
  "signatureImageDataUrl",
  "imageDataUrl",
  "ssnBack",
  "principalRepSsnBack",
  "guarantorSsnBack",
  "ssnEncrypted",
  "principalRepSsnEncrypted",
  "guarantorSsnEncrypted",
  "encryptionKey",
  "encryptKey",
  "ci",
  "di",
  "ciEncrypted",
  "diEncrypted",
  "regCertKey",
  "reg_cert_key",
  "enc_data",
  "rv",
  "rawResponse",
  "credential",
]);

export const sanitizeLogDetail = (value) => {
  if (value === null) return null;
  if (value === undefined) return null;
  if (typeof value === "string") return sanitizeLogText(value);
  if (typeof value === "number" || typeof value === "boolean") return value;
  if (Array.isArray(value))
    return value
      .filter((item) => item !== undefined)
      .map((item) => sanitizeLogDetail(item));
  if (typeof value === "object") {
    return Object.entries(value).reduce((acc, [key, item]) => {
      if (item === undefined) {
        return acc;
      }
      if (SENSITIVE_LOG_KEYS.has(key)) {
        acc[key] = "[removed]";
        return acc;
      }
      if (
        typeof item === "string" &&
        (key.toLowerCase().includes("phone") ||
          key.toLowerCase().includes("contact"))
      ) {
        acc[key] = getSafePhoneMasked(item) || "";
        return acc;
      }
      const sanitizedItem = sanitizeLogDetail(item);
      if (sanitizedItem !== undefined) {
        acc[key] = sanitizedItem;
      }
      return acc;
    }, {});
  }
  return null;
};

const getRuntimeErrorRawType = (value: unknown) => {
  if (value === null) return "null";
  if (Array.isArray(value)) return "array";
  return typeof value;
};

const safeStringifyRuntimeValue = (value: unknown) => {
  const seen = new WeakSet<object>();
  try {
    return JSON.stringify(value, (_key, item) => {
      if (typeof item === "function") return "[function]";
      if (typeof item === "object" && item !== null) {
        if (seen.has(item)) return "[circular]";
        seen.add(item);
        if (typeof Element !== "undefined" && item instanceof Element) {
          return `[${item.tagName.toLowerCase()}]`;
        }
      }
      return item;
    });
  } catch {
    return "";
  }
};

export const normalizeRuntimeError = (input: unknown, eventMeta = {}) => {
  const rawType = getRuntimeErrorRawType(input);
  const constructorName =
    input && typeof input === "object" && (input as any).constructor?.name
      ? String((input as any).constructor.name)
      : rawType;
  const objectKeys =
    input && typeof input === "object" ? Object.keys(input as Record<string, unknown>) : [];
  const sourceEvent =
    typeof ErrorEvent !== "undefined" && input instanceof ErrorEvent
      ? input
      : null;
  const rejectionEvent =
    typeof PromiseRejectionEvent !== "undefined" &&
    input instanceof PromiseRejectionEvent
      ? input
      : null;
  const candidate = sourceEvent?.error || rejectionEvent?.reason || input;
  const candidateObject =
    candidate && typeof candidate === "object"
      ? (candidate as Record<string, unknown>)
      : {};
  const fallbackText =
    typeof candidate === "string" ||
    typeof candidate === "number" ||
    typeof candidate === "boolean"
      ? String(candidate)
      : safeStringifyRuntimeValue(candidate);

  return sanitizeLogDetail({
    name:
      (candidateObject as any).name ||
      sourceEvent?.type ||
      (constructorName && constructorName !== "object" ? constructorName : "RuntimeError"),
    message:
      (candidateObject as any).message ||
      sourceEvent?.message ||
      fallbackText ||
      `Runtime error value was ${rawType}`,
    stack: (candidateObject as any).stack
      ? String((candidateObject as any).stack).slice(0, 1600)
      : null,
    code: (candidateObject as any).code || (candidateObject as any).status || null,
    cause: (candidateObject as any).cause
      ? safeStringifyRuntimeValue((candidateObject as any).cause).slice(0, 800)
      : null,
    rawType,
    constructorName,
    objectKeys,
    source: sourceEvent?.filename || (eventMeta as any)?.source || null,
    lineno: sourceEvent?.lineno || (eventMeta as any)?.lineno || null,
    colno: sourceEvent?.colno || (eventMeta as any)?.colno || null,
    url:
      (typeof window !== "undefined" ? window.location.href : "") ||
      (eventMeta as any)?.url ||
      null,
  });
};

export const sanitizeErrorForLog = (error) => {
  const normalized = normalizeRuntimeError(error);
  return normalized;
};

export const getContractEventFailureMessage = (error = {}) => {
  const code = String(error?.code || "");
  if (code === "permission-denied") {
    return "Firestore 권한 문제로 계약 완료 이벤트 로그 저장에 실패했습니다.";
  }
  if (code === "failed-precondition") {
    return "Firestore 인덱스 또는 쿼리 조건 문제로 계약 완료 이벤트 로그 저장에 실패했습니다.";
  }
  return "계약 완료 이벤트 로그 저장에 실패했습니다.";
};

export const getContractEventCollectionPath = (
  documentId = "",
  targetAppId = appId
) =>
  `artifacts/${targetAppId}/public/data/contracts/${sanitizeLogText(
    documentId || ""
  )}/events`;

export const buildContractEventFailureReportPayload = ({
  eventType = "",
  appId: targetAppId = appId,
  collectionPath = "",
  docId,
  contractId = "",
  draftId,
  currentStep = 5,
  error = {},
} = {}) => {
  const payload = {
    message: getContractEventFailureMessage(error),
    eventType,
    appId: targetAppId,
    collectionPath,
    contractId,
    currentStep,
    error: sanitizeErrorForLog(error),
  };
  if (docId) {
    (payload as any).docId = docId;
  }
  if (draftId) {
    (payload as any).draftId = draftId;
  }
  return sanitizeLogDetail(payload);
};

export const isSignatureMeaningful = ({
  inkPixelCount,
  inkPixels,
  boundingWidth = 0,
  boundingHeight = 0,
  canvasWidth = 0,
  canvasHeight = 0,
} = {}) =>
  validateSignatureQualityMetrics({
    inkPixels: inkPixels ?? inkPixelCount,
    boundingWidth,
    boundingHeight,
    canvasWidth,
    canvasHeight,
  }).valid;

export const validateSignatureQualityMetrics = ({
  inkPixels = 0,
  boundingWidth = 0,
  boundingHeight = 0,
  canvasWidth = 0,
  canvasHeight = 0,
} = {}) => {
  const safeCanvasWidth = Number(canvasWidth || 0);
  const safeCanvasHeight = Number(canvasHeight || 0);
  const safeInkPixels = Number(inkPixels || 0);
  const safeBoundingWidth = Number(boundingWidth || 0);
  const safeBoundingHeight = Number(boundingHeight || 0);
  const minBoundingWidth = Math.max(35, safeCanvasWidth * 0.08);
  const minBoundingHeight = Math.max(18, safeCanvasHeight * 0.08);
  const minInkPixels = Math.max(
    80,
    safeCanvasWidth && safeCanvasHeight
      ? safeCanvasWidth * safeCanvasHeight * 0.0005
      : 80
  );
  const inkRatio =
    safeCanvasWidth && safeCanvasHeight
      ? safeInkPixels / (safeCanvasWidth * safeCanvasHeight)
      : 0;

  if (safeInkPixels <= 0) {
    return {
      valid: false,
      reason: "EMPTY",
      inkPixels: safeInkPixels,
      boundingWidth: safeBoundingWidth,
      boundingHeight: safeBoundingHeight,
      inkRatio,
    };
  }
  if (safeBoundingWidth < minBoundingWidth) {
    return {
      valid: false,
      reason: "TOO_NARROW",
      inkPixels: safeInkPixels,
      boundingWidth: safeBoundingWidth,
      boundingHeight: safeBoundingHeight,
      inkRatio,
    };
  }
  if (safeBoundingHeight < minBoundingHeight) {
    return {
      valid: false,
      reason: "TOO_SHORT",
      inkPixels: safeInkPixels,
      boundingWidth: safeBoundingWidth,
      boundingHeight: safeBoundingHeight,
      inkRatio,
    };
  }
  if (safeInkPixels < minInkPixels) {
    return {
      valid: false,
      reason: "LOW_INK",
      inkPixels: safeInkPixels,
      boundingWidth: safeBoundingWidth,
      boundingHeight: safeBoundingHeight,
      inkRatio,
    };
  }
  return {
    valid: true,
    inkPixels: safeInkPixels,
    boundingWidth: safeBoundingWidth,
    boundingHeight: safeBoundingHeight,
    inkRatio,
  };
};

export const getSignatureQualityErrorMessage = (reason = "") => {
  if (reason === "EMPTY") {
    return "서명란 안에 이름을 알아볼 수 있도록 작성해 주세요.";
  }
  if (reason === "TOO_NARROW" || reason === "TOO_SHORT") {
    return "점이나 짧은 선은 서명으로 인정되지 않습니다.";
  }
  return "서명이 너무 작거나 인식되지 않았습니다. 성함을 다시 서명해 주세요.";
};

export const getCanvasSignatureMetrics = (canvas) => {
  if (!canvas) {
    return {
      inkPixels: 0,
      boundingWidth: 0,
      boundingHeight: 0,
      inkRatio: 0,
      canvasWidth: 0,
      canvasHeight: 0,
    };
  }
  try {
    const ctx = canvas.getContext("2d", { willReadFrequently: true });
    const image = ctx.getImageData(0, 0, canvas.width, canvas.height);
    let inkPixels = 0;
    let minX = canvas.width;
    let minY = canvas.height;
    let maxX = -1;
    let maxY = -1;
    for (let y = 0; y < canvas.height; y += 1) {
      for (let x = 0; x < canvas.width; x += 1) {
        const index = (y * canvas.width + x) * 4;
        const r = image.data[index];
        const g = image.data[index + 1];
        const b = image.data[index + 2];
        const a = image.data[index + 3];
        if (a > 0 && (r < 245 || g < 245 || b < 245)) {
          inkPixels += 1;
          minX = Math.min(minX, x);
          minY = Math.min(minY, y);
          maxX = Math.max(maxX, x);
          maxY = Math.max(maxY, y);
        }
      }
    }
    const boundingWidth = inkPixels ? maxX - minX + 1 : 0;
    const boundingHeight = inkPixels ? maxY - minY + 1 : 0;
    return {
      inkPixels,
      boundingWidth,
      boundingHeight,
      inkRatio:
        canvas.width && canvas.height ? inkPixels / (canvas.width * canvas.height) : 0,
      canvasWidth: canvas.width,
      canvasHeight: canvas.height,
    };
  } catch {
    return {
      inkPixels: 0,
      boundingWidth: 0,
      boundingHeight: 0,
      inkRatio: 0,
      canvasWidth: canvas?.width || 0,
      canvasHeight: canvas?.height || 0,
    };
  }
};

export const countCanvasInkPixels = (canvas) => {
  return getCanvasSignatureMetrics(canvas).inkPixels;
};

export const buildPhoneVerificationEvidence = ({
  phoneVerificationEnabled,
  phoneVerified,
  phoneVerifiedAt,
  phoneNumber,
  identityProvider = "FIREBASE_SMS",
}: BuildPhoneVerificationEvidenceInput): PhoneVerificationEvidence => {
  const phoneMasked = maskPhoneNumber(phoneNumber);

  if (phoneVerificationEnabled && phoneVerified && phoneVerifiedAt) {
    if (identityProvider === "KCP") {
      return {
        verificationMethod: "kcp_mobile_identity",
        phoneVerified: true,
        phoneVerifiedAt,
        phoneMasked,
        verificationChannel: "kcp",
        phoneVerificationSkipped: false,
        phoneVerificationSkipReason: null,
      };
    }

    return {
      verificationMethod: "sms_otp",
      phoneVerified: true,
      phoneVerifiedAt,
      phoneMasked,
      verificationChannel: "self_otp",
      phoneVerificationSkipped: false,
      phoneVerificationSkipReason: null,
    };
  }

  if (!phoneVerificationEnabled) {
    return {
      verificationMethod: "bypassed_by_admin_setting",
      phoneVerified: false,
      phoneVerifiedAt: null,
      phoneMasked,
      verificationChannel: "admin_bypass",
      phoneVerificationSkipped: true,
      phoneVerificationSkipReason: "admin_setting",
    };
  }

  return {
    verificationMethod: null,
    phoneVerified: false,
    phoneVerifiedAt: null,
    phoneMasked,
    verificationChannel: null,
    phoneVerificationSkipped: false,
    phoneVerificationSkipReason: null,
  };
};

const getKcpAttemptStatusFromFallbackReason = (
  reason: KcpFallbackReason | null | undefined
): KcpAttemptStatus => {
  if (!reason) return "NOT_ATTEMPTED";
  if (reason === "KCP_USER_CANCELLED") return "CANCELLED";
  if (reason === "KCP_TIMEOUT") return "START_FAILED";
  return "START_FAILED";
};

export const buildIdentityVerificationSummary = ({
  phoneEvidence,
  identityProvider = "FIREBASE_SMS",
  phoneNumber = "",
  kcpFallbackReason = null,
  representativeVerificationStatus = "PENDING_KCP",
  kcpIdentityStatus = "",
}: {
  phoneEvidence: PhoneVerificationEvidence;
  identityProvider?: IdentityProvider;
  phoneNumber?: string;
  kcpFallbackReason?: KcpFallbackReason | null;
  representativeVerificationStatus?: RepresentativeVerificationStatus;
  kcpIdentityStatus?: KcpIdentityStatus | string;
}): IdentityVerificationSummary => {
  const phoneMasked = phoneEvidence.phoneMasked || maskPhoneNumber(phoneNumber);
  const verifiedAt = phoneEvidence.phoneVerifiedAt || undefined;

  if (kcpFallbackReason) {
    return {
      identityVerificationMethod: "SMS_PHONE_CHECK",
      identityVerificationProvider: "FIREBASE_SMS",
      identityVerificationStatus: phoneEvidence.phoneVerified
        ? "FALLBACK_VERIFIED"
        : "FAILED",
      verifiedAt,
      phoneMasked,
      kcpAttempted: true,
      kcpAttemptStatus: getKcpAttemptStatusFromFallbackReason(kcpFallbackReason),
      kcpFallbackReason,
      representativeVerificationStatus: "PENDING_KCP",
    };
  }

  if (identityProvider === "KCP" && phoneEvidence.phoneVerified) {
    return {
      identityVerificationMethod: "KCP_IDENTITY",
      identityVerificationProvider: "KCP",
      identityVerificationStatus: "VERIFIED",
      verifiedAt,
      phoneMasked,
      kcpAttempted: true,
      kcpAttemptStatus:
        kcpIdentityStatus === "VERIFIED" ? "VERIFIED" : "NOT_ATTEMPTED",
      kcpFallbackReason: null,
      representativeVerificationStatus,
    };
  }

  return {
    identityVerificationMethod: "SMS_PHONE_CHECK",
    identityVerificationProvider: "FIREBASE_SMS",
    identityVerificationStatus: phoneEvidence.phoneVerified
      ? "VERIFIED"
      : "FAILED",
    verifiedAt,
    phoneMasked,
    kcpAttempted: false,
    kcpAttemptStatus: "NOT_ATTEMPTED",
    kcpFallbackReason: null,
    representativeVerificationStatus:
      identityProvider === "KCP" ? representativeVerificationStatus : "PENDING_KCP",
  };
};

export const formatEvidenceValue = (value, emptyLabel = "미수집") => {
  if (value === null || value === undefined || value === "") return emptyLabel;
  return String(value);
};

export const formatEvidenceDate = (value, emptyLabel = "미수집") => {
  if (!value) return emptyLabel;
  const dateValue =
    typeof value?.toDate === "function" ? value.toDate() : value;
  const parsed = new Date(dateValue);
  return Number.isNaN(parsed.getTime())
    ? String(value)
    : parsed.toLocaleString("ko-KR");
};

export const COMPLETION_RECEIPT_FALLBACK_MANAGER = "본사 확인 예정";
export const COMPLETION_RECEIPT_CONFIRMED_LABEL = "접수 완료";
export const COMPLETION_RECEIPT_PENDING_LABEL = "접수 확인 지연";

const pickCompletionReceiptString = (...values) =>
  values.map((value) => String(value ?? "").trim()).find(Boolean) || "";

export const maskHashForReceipt = (value = "") => {
  const text = String(value || "").trim();
  if (!text) return null;
  if (text.length <= 16) return text;
  return `${text.slice(0, 8)}...${text.slice(-6)}`;
};

export const maskDocumentIdForReceipt = (value = "") => {
  const text = String(value || "").trim();
  if (!text) return "";
  return text.length <= 8 ? text : text.slice(0, 8);
};

export const getReceiptManagerDisplay = (contract = {}) => {
  const salesReceipt =
    contract?.salesReceipt && typeof contract.salesReceipt === "object"
      ? contract.salesReceipt
      : {};
  const inviteLabel = getInviteOwnerLabel(contract);
  const managerName = pickCompletionReceiptString(
    salesReceipt.managerName,
    contract.salesRepName && contract.salesRepDepartmentPart
      ? `${contract.salesRepDepartmentPart} - ${contract.salesRepName}`
      : "",
    contract.salesRepName,
    contract.assignedManagerName,
    contract.managerName,
    inviteLabel
  );
  const normalized = managerName.toUpperCase();
  const unknown =
    !managerName ||
    ["본사", "본사 직접 관리", "HQ", "HEADQUARTERS"].includes(managerName) ||
    ["본사", "본사 직접 관리", "HQ", "HEADQUARTERS"].includes(normalized) ||
    managerName.includes("미지정");

  return {
    managerName: unknown ? COMPLETION_RECEIPT_FALLBACK_MANAGER : managerName,
    managerSource:
      salesReceipt.managerSource ||
      (contract.salesRepName || contract.salesRepId || contract.inviteId
        ? "INVITE"
        : unknown
        ? "UNKNOWN"
        : "ADMIN_ASSIGNMENT"),
  };
};

export const buildSalesReceiptMetadata = ({
  contract = {},
  inviteMetadata = {},
  manager = {},
  submittedAt = "",
} = {}) => {
  const inviteManagerName = pickCompletionReceiptString(
    inviteMetadata.salesRepName && inviteMetadata.salesRepDepartmentPart
      ? `${inviteMetadata.salesRepDepartmentPart} - ${inviteMetadata.salesRepName}`
      : "",
    inviteMetadata.salesRepName,
    inviteMetadata.ownerLabel
  );
  const managerName = pickCompletionReceiptString(
    inviteManagerName,
    contract.salesRepName && contract.salesRepDepartmentPart
      ? `${contract.salesRepDepartmentPart} - ${contract.salesRepName}`
      : "",
    contract.salesRepName,
    contract.managerName,
    manager.name
  );
  const normalized = managerName.toUpperCase();
  const isUnknown =
    !managerName ||
    ["본사", "본사 직접 관리", "HQ", "HEADQUARTERS"].includes(managerName) ||
    ["본사", "본사 직접 관리", "HQ", "HEADQUARTERS"].includes(normalized) ||
    managerName.includes("미지정");

  return {
    managerName: isUnknown ? COMPLETION_RECEIPT_FALLBACK_MANAGER : managerName,
    managerSource:
      inviteMetadata.salesRepName || inviteMetadata.salesRepId
        ? "INVITE"
        : isUnknown
        ? "UNKNOWN"
        : "ADMIN_ASSIGNMENT",
    assignedAt: submittedAt || null,
    visibleToSalesLookup: true,
  };
};

export const hasContractReceiptConfirmation = (contract = {}) =>
  contract?.receiptConfirmed === true ||
  Boolean(contract?.receiptConfirmedAt) ||
  contract?.salesReceipt?.visibleToSalesLookup === true;

export const getCompletionReceiptStatusLabel = (contract = {}, options = {}) => {
  if (options.confirmed === true || hasContractReceiptConfirmation(contract)) {
    return COMPLETION_RECEIPT_CONFIRMED_LABEL;
  }
  if (options.confirmed === false || contract?.receiptStatus === "PENDING_CONFIRMATION") {
    return COMPLETION_RECEIPT_PENDING_LABEL;
  }
  const status = String(contract?.status || contract?.contractStatus || "").trim();
  if (status === "confirmed" || status === "CONFIRMED") return "확정 완료";
  if (status === "rejected" || status === "REJECTED") return "반려";
  return "작성 완료";
};

export const buildCompletionReceiptFromContract = (
  contract = {},
  options = {}
) => {
  const documentId = pickCompletionReceiptString(
    options.documentId,
    contract.documentId,
    contract.id
  );
  const contractNumber = pickCompletionReceiptString(
    contract.contractNumber,
    contract.contractId
  );
  const manager = getReceiptManagerDisplay(contract);
  const confirmed =
    options.confirmed ?? (contract.receiptConfirmed === true || Boolean(contract.receiptConfirmedAt));
  const status = pickCompletionReceiptString(contract.status, contract.contractStatus, "submitted");
  const submittedAt = pickCompletionReceiptString(
    contract.submittedAt,
    contract.completedAt,
    contract.createdAt
  );

  return {
    confirmed: Boolean(confirmed),
    documentId,
    contractId: contractNumber,
    contractNumber,
    confirmationNumber: maskDocumentIdForReceipt(documentId),
    businessName: getAdminDisplayBusinessName(contract),
    representativeName: pickCompletionReceiptString(
      contract.agentRep,
      contract.corpRepName,
      contract.representativeName,
      "미수집"
    ),
    managerName: manager.managerName,
    managerSource: manager.managerSource,
    submittedAt,
    receiptConfirmedAt: pickCompletionReceiptString(
      options.receiptConfirmedAt,
      contract.receiptConfirmedAt
    ),
    status,
    statusLabel: getCompletionReceiptStatusLabel(contract, {
      confirmed: options.confirmed,
    }),
    contractHash: maskHashForReceipt(
      contract.contractHash || contract.finalSnapshot?.contractHash
    ),
    signatureHash: maskHashForReceipt(
      contract.signatureHash || contract.finalSnapshot?.signatureHash
    ),
    eventCreated: Boolean(options.eventCreated ?? contract.receiptEventCreated),
    receiptStatus: contract.receiptStatus || (confirmed ? "CONFIRMED" : "PENDING_CONFIRMATION"),
  };
};

export const buildPendingCompletionReceipt = ({
  contract = {},
  documentId = "",
  message = "",
} = {}) => ({
  ...buildCompletionReceiptFromContract(
    {
      ...contract,
      documentId: documentId || contract.documentId || contract.id,
      receiptStatus: "PENDING_CONFIRMATION",
    },
    { confirmed: false }
  ),
  confirmed: false,
  statusLabel: COMPLETION_RECEIPT_PENDING_LABEL,
  receiptStatus: "PENDING_CONFIRMATION",
  message:
    message ||
    "계약 제출은 처리되었을 수 있으나, 현재 접수 확인 정보를 불러오지 못했습니다.",
});

export const canShowCompletionStep = ({
  completionReceipt = null,
  savedContractId = "",
  lastSubmittedContractData = null,
  formData = null,
} = {}) =>
  Boolean(
    completionReceipt?.confirmed ||
      completionReceipt?.documentId ||
      savedContractId ||
      isCompletedOrLockedContract(lastSubmittedContractData || {}) ||
      isCompletedOrLockedContract(formData || {})
  );

export const ADMIN_DETAIL_CARD_CLASS =
  "max-w-md w-full overflow-x-hidden bg-white rounded-2xl shadow p-4 mb-10";
export const ADMIN_EVIDENCE_SECTION_CLASS =
  "mb-4 max-w-full overflow-hidden rounded-xl border border-slate-200 bg-white p-4";
export const ADMIN_EVIDENCE_ROW_CLASS =
  "grid max-w-full grid-cols-[112px_minmax(0,1fr)] gap-3 overflow-hidden border-b border-slate-100 py-2 text-xs last:border-b-0 sm:grid-cols-[132px_minmax(0,1fr)]";
export const ADMIN_EVIDENCE_LABEL_CLASS =
  "min-w-0 break-keep font-bold text-slate-500";
export const ADMIN_EVIDENCE_VALUE_CLASS =
  "min-w-0 break-all break-words whitespace-normal text-left font-semibold text-slate-800 sm:text-right";
export const ADMIN_LEGAL_EVIDENCE_ACTION_CLASS =
  "mb-4 rounded-2xl border border-indigo-200 bg-indigo-50 p-4 shadow-sm";

export const isKcpSmsFallbackContract = (contract = {}) =>
  contract.identityVerificationStatus === "FALLBACK_VERIFIED" ||
  Boolean(
    contract.kcpAttempted === true &&
      contract.verificationMethod === "sms_otp" &&
      contract.phoneVerified === true
  );

export const getPhoneVerificationDisplayMethod = (contract = {}) => {
  if (isKcpSmsFallbackContract(contract)) {
    return "문자 인증 대체 완료";
  }

  if (
    contract.verificationMethod === "bypassed_by_admin_setting" ||
    contract.phoneVerificationSkipped
  ) {
    return "휴대폰 번호 확인 생략(관리자 설정)";
  }

  if (
    contract.verificationMethod === "kcp_mobile_identity" &&
    contract.phoneVerified === true
  ) {
    return "통신사 휴대폰 본인확인";
  }

  if (
    contract.verificationMethod === "sms_otp" &&
    contract.phoneVerified === true
  ) {
    return "SMS OTP 확인";
  }

  return "미수집";
};

export const getPhoneVerificationResult = (contract = {}) => {
  if (isKcpSmsFallbackContract(contract)) {
    return "KCP 실패 후 문자 인증으로 확인";
  }

  if (
    contract.verificationMethod === "bypassed_by_admin_setting" ||
    contract.phoneVerificationSkipped
  ) {
    return "관리자 설정으로 생략";
  }

  if (
    contract.verificationMethod === "kcp_mobile_identity" &&
    contract.phoneVerified === true
  ) {
    return "확인 완료";
  }

  if (
    contract.verificationMethod === "sms_otp" &&
    contract.phoneVerified === true
  ) {
    return "확인 완료";
  }

  return "미수집";
};

export const getCoRepresentativeDisplayValue = (
  info: CoRepresentativeInfo | null | undefined
) => {
  if (!info?.status || info.status === "UNKNOWN") return "확인 전";
  if (info.status === "NTS_NOT_SUPPORTED") {
    return "국세청 응답에서 자동 확인 불가";
  }
  if (info.status === "NOT_DETECTED") return "공동계약인 정보 없음";
  if (info.status === "DETECTED") {
    return "공동계약인/공동사업자 안내 필요";
  }
  if (info.status === "USER_DECLARED") {
    return "사용자 신고: 공동계약인/공동사업자 안내 필요";
  }
  return info.status;
};

export const getBusinessVerificationEvidenceDisplayValue = (
  businessVerification = {}
) => {
  if (isNtsBusinessVerificationDisabledByAdmin(businessVerification)) {
    return "국세청 확인 미사용 / 본사 확인 필요";
  }
  if (isNtsBusinessVerificationManualReviewRequired(businessVerification)) {
    return "국세청 확인 본사 검토 필요";
  }
  return businessVerification.status
    ? `${businessVerification.status} / valid: ${
        businessVerification.validationCheck?.valid === true
          ? "true"
          : businessVerification.validationCheck?.valid === false
          ? "false"
          : "미수집"
      }`
    : "미수집";
};

export const getContractEvidenceRows = (contract = {}) => {
  const signerName =
    isCorporateContract(contract.bizType)
      ? contract.corpRepName || contract.agentRep
      : contract.agentRep;
  const maskedPhone =
    contract.phoneMasked ||
    maskPhoneNumber(contract.verifiedPhone || contract.agentContact || "");
  const identityVerification =
    contract.identityVerification ||
    contract.finalSnapshot?.identityVerification ||
    {};
  const hasKcpIdentityEvidence =
    identityVerification.provider === "KCP" ||
    contract.identityVerificationProvider === "KCP";
  const representativeIdentityVerification =
    contract.representativeIdentityVerification ||
    contract.finalSnapshot?.representativeIdentityVerification ||
    {};
  const businessVerification =
    contract.businessVerification ||
    contract.finalSnapshot?.businessVerification ||
    {};
  const lockedIdentityFields =
    contract.lockedIdentityFields ||
    contract.finalSnapshot?.lockedIdentityFields ||
    {};
  const coRepresentativeEvidenceRows = sanitizeCoRepresentativesForEvidenceSnapshot(
    contract.coRepresentatives || contract.finalSnapshot?.coRepresentatives || []
  );
  const signatureEvidence =
    contract.signatureEvidence || contract.finalSnapshot?.signatureEvidence || {};
  const primarySignatureEvidence = signatureEvidence.primary || {};
  const representativePersonalGuaranteeEvidence =
    contract.representativePersonalGuarantee ||
    contract.finalSnapshot?.representativePersonalGuarantee ||
    signatureEvidence.representativePersonalGuarantee ||
    {};
  const identityTestModeContract = isIdentityTestModeContract(contract);

  return [
    ...(identityTestModeContract
      ? [
          {
            label: "TEST MODE",
            value: TEST_MODE_PDF_NOTICE,
          },
        ]
      : []),
    { label: "계약 ID", value: formatEvidenceValue(contract.contractId) },
    {
      label: "문서 버전",
      value: formatEvidenceValue(contract.documentVersion, "해당 없음"),
    },
    {
      label: "계약 Hash",
      value: formatEvidenceValue(contract.contractHash || contract.finalSnapshot?.contractHash),
    },
    {
      label: "서명 Hash",
      value: formatEvidenceValue(contract.signatureHash || contract.signatureData?.imageHash),
    },
    {
      label: "서명 역할",
      value: [
        `역할: ${formatEvidenceValue(
          primarySignatureEvidence.label || primarySignatureEvidence.role
        )}`,
        `서명자: ${formatEvidenceValue(primarySignatureEvidence.signerName || signerName)}`,
        `품질검증: ${
          primarySignatureEvidence.valid
            ? "통과"
            : formatEvidenceValue(primarySignatureEvidence.validation?.reason, "미수집")
        }`,
      ].join(" / "),
    },
    {
      label: "공동계약인 확인",
      value: representativePersonalGuaranteeEvidence.required
        ? [
            `동의: ${
              representativePersonalGuaranteeEvidence.agreed ? "완료" : "미완료"
            }`,
            `동의시각: ${formatEvidenceDate(
              representativePersonalGuaranteeEvidence.agreedAt,
              "미수집"
            )}`,
            `서명품질: ${
              representativePersonalGuaranteeEvidence.valid ||
              representativePersonalGuaranteeEvidence.signatureValidation?.valid
                ? "통과"
                : formatEvidenceValue(
                    representativePersonalGuaranteeEvidence.validation?.reason ||
                      representativePersonalGuaranteeEvidence.signatureValidation?.reason,
                    "미수집"
                  )
            }`,
            `주민번호: ${formatEvidenceValue(
              representativePersonalGuaranteeEvidence.signerSsnMasked
            )}`,
            `주소: ${formatEvidenceValue(
              representativePersonalGuaranteeEvidence.signerAddressMasked
            )}`,
          ].join(" / ")
        : "해당 없음",
    },
    {
      label: "완료 Snapshot",
      value: contract.finalSnapshot ? "저장됨" : "완료 snapshot 없음",
    },
    {
      label: "계약 체결 권한",
      value: contract.hasContractAuthority ? "확인됨" : "미확인",
    },
    {
      label: "신용정보 동의",
      value: contract.hasCreditCheckConsent
        ? `${contract.creditCheckCompany || CREDIT_CHECK_COMPANY} 조회·활용 동의`
        : "미확인",
    },
    {
      label: "대표자 검증",
      value: formatEvidenceValue(
        representativeIdentityVerification.status ||
          contract.representativeVerificationStatus ||
          contract.finalSnapshot?.representativeVerificationStatus ||
          getRepresentativeVerificationStatus()
      ),
    },
    {
      label: "대표자 본인확인",
      value:
        representativeIdentityVerification.status === "MATCHED"
          ? "이름·생년월일·휴대폰 일치"
          : representativeIdentityVerification.status
          ? `불일치/미완료: ${representativeIdentityVerification.status}`
          : "구버전 계약: 대표자 본인확인 강화 전 체결",
    },
    {
      label: "대표자 본인확인 상세",
      value: [
        `이름: ${
          representativeIdentityVerification.checks?.nameMatched ? "일치" : "미확인"
        }`,
        `생년월일: ${
          representativeIdentityVerification.checks?.birthDateMatched ? "일치" : "미확인"
        }`,
        `휴대폰: ${
          representativeIdentityVerification.checks?.phoneMatched ? "일치" : "미확인"
        }`,
        `필드 잠금: ${formatEvidenceDate(lockedIdentityFields.lockedAt, "미수집")}`,
      ].join(" / "),
    },
    {
      label: "국세청 진위확인",
      value: getBusinessVerificationEvidenceDisplayValue(businessVerification),
    },
    {
      label: "공동계약인 안내",
      value: getCoRepresentativeDisplayValue(
        contract.coRepresentativeInfo ||
          contract.finalSnapshot?.coRepresentativeInfo ||
          null
      ),
    },
    ...coRepresentativeEvidenceRows.map((item, index) => ({
      label: `공동계약인 ${index + 1} 본인확인`,
      value: [
        `성명: ${formatEvidenceValue(item.name)}`,
        `주민번호: ${formatEvidenceValue(item.ssnMasked)}`,
        `휴대폰: ${formatEvidenceValue(item.phoneMasked)}`,
        `주소: ${formatEvidenceValue(item.homeAddressMasked)}`,
        `KCP: ${formatEvidenceValue(item.kcpStatus)}`,
        `CI/DI: ${
          item.identityVerification?.ciHash || item.identityVerification?.diHash
            ? "Hash/HMAC 보관"
            : "미수집"
        }`,
        `signatureMode: ${formatEvidenceValue(item.signatureMode)}`,
        item.signatureMode === CO_REPRESENTATIVE_SIGNATURE_MODE_DIRECT
          ? `서명 방식: 공동계약인 직접서명 / signatureHash: ${formatEvidenceValue(
              item.signatureEvidence?.signatureHash || item.signatureHash
            )} / 서명일시: ${formatEvidenceDate(
              item.signatureEvidence?.signedAt || item.signedAt,
              "미수집"
            )}`
          : `서명 방식: 공동계약인 본인확인 및 대리서명 동의 / 주대표자 대리서명 / 동의일시: ${formatEvidenceDate(
              item.delegatedSignatureConsent?.agreedAt,
              "미수집"
            )}`,
      ].join(" / "),
    })),
    ...(getBusinessNameCorrection(contract)?.correctedName
      ? [
          {
            label: "상호 정정 이력",
            value: [
              `고객 입력값: ${
                getBusinessNameCorrection(contract)?.originalName ||
                getBusinessNameCorrectionOriginalName(contract) ||
                "미수집"
              }`,
              `관리자 정정: ${getBusinessNameCorrection(contract)?.correctedName}`,
              `사유: ${getBusinessNameCorrection(contract)?.reason || "미수집"}`,
              `근거: ${getBusinessNameCorrectionSourceLabel(
                getBusinessNameCorrection(contract)?.source
              )}`,
              `정정자: ${getBusinessNameCorrection(contract)?.correctedBy || "관리자"}`,
              `정정시각: ${formatEvidenceDate(
                getBusinessNameCorrection(contract)?.correctedAt
              )}`,
            ].join(" / "),
          },
        ]
      : []),
    { label: "서명자", value: formatEvidenceValue(signerName) },
    { label: "휴대폰 번호", value: formatEvidenceValue(maskedPhone) },
    {
      label: "확인 방식",
      value: getPhoneVerificationDisplayMethod(contract),
    },
    {
      label: "본인확인 제공자",
      value:
        isKcpSmsFallbackContract(contract)
          ? "Firebase SMS (KCP 실패 후 대체)"
          : contract.identityVerificationProvider === "KCP"
          ? "KCP"
          : contract.verificationMethod === "sms_otp"
          ? "Firebase SMS"
          : "미수집",
    },
    {
      label: "KCP 대체 사유",
      value: isKcpSmsFallbackContract(contract)
        ? formatEvidenceValue(contract.kcpFallbackReason, "KCP_UNKNOWN_ERROR")
        : "해당 없음",
    },
    {
      label: "KCP 상태",
      value: contract.kcpIdentityStatus || "해당 없음",
    },
    {
      label: "KCP 주문번호",
      value: formatEvidenceValue(identityVerification.orderId),
    },
    {
      label: "KCP result code",
      value: formatEvidenceValue(
        identityVerification.kcpResultCode || contract.kcpResultCode
      ),
    },
    {
      label: "KCP 인증자명",
      value: formatEvidenceValue(
        identityVerification.verifiedName || contract.kcpVerifiedName
      ),
    },
    {
      label: "KCP 인증 휴대폰",
      value: formatEvidenceValue(
        identityVerification.phoneMasked || contract.kcpVerifiedPhoneMasked
      ),
    },
    {
      label: "KCP CI 존재 여부",
      value: hasKcpIdentityEvidence
        ? identityVerification.hasCi
          ? "있음"
          : "없음"
        : "해당 없음",
    },
    {
      label: "KCP DI 존재 여부",
      value: hasKcpIdentityEvidence
        ? identityVerification.hasDi
          ? "있음"
          : "없음"
        : "해당 없음",
    },
    {
      label: "CI/DI",
      value:
        isKcpSmsFallbackContract(contract)
          ? "없음"
          : contract.identityVerificationProvider === "KCP"
          ? "암호화 또는 Hash 저장됨"
          : "해당 없음",
    },
    { label: "확인 결과", value: getPhoneVerificationResult(contract) },
    {
      label: "본 대표 주민번호",
      value: formatEvidenceValue(getPrincipalRepSsnDisplayValue(contract)),
    },
    ...(isCorporateContract(contract.bizType)
      ? [
          {
            label: "공동계약인 주민번호",
            value: formatEvidenceValue(getGuarantorSsnDisplayValue(contract), "데이터 없음"),
          },
        ]
      : []),
    {
      label: "주민번호 확인",
      value: getSsnVerificationStatus(contract),
    },
    {
      label: "휴대폰 확인 시각",
      value:
        contract.phoneVerificationSkipped ||
        contract.verificationMethod === "bypassed_by_admin_setting"
          ? "관리자 설정으로 생략"
          : formatEvidenceDate(contract.phoneVerifiedAt),
    },
    {
      label: "계약 열람 완료",
      value: formatEvidenceDate(contract.contractReviewedAt),
    },
    {
      label: "전자서명 완료",
      value: formatEvidenceDate(contract.signatureCompletedAt),
    },
    { label: "제출 완료", value: formatEvidenceDate(contract.submittedAt) },
    { label: "IP", value: formatEvidenceValue(contract.submittedIp) },
    {
      label: "User-Agent",
      value: formatEvidenceValue(contract.submittedUserAgent),
    },
  ];
};

export const getAdminContractEvidenceRows = (contract = {}) => {
  const adminContract = buildAdminContractOutputData(contract);
  const adminCoRepresentativeRows = Array.isArray(adminContract.coRepresentatives)
    ? adminContract.coRepresentatives
    : [];
  return getContractEvidenceRows(adminContract).map((row) => {
    if (row.label === "휴대폰 번호") {
      return {
        ...row,
        value: formatEvidenceValue(getAdminDisplayContact(adminContract)),
      };
    }
    const coRepresentativeMatch = String(row.label || "").match(
      /^공동계약인\s+(\d+)\s+본인확인$/
    );
    if (!coRepresentativeMatch) return row;
    const representativeIndex = Number(coRepresentativeMatch[1]) - 1;
    const representative = adminCoRepresentativeRows[representativeIndex] || {};
    const phoneDisplay = getContractOutputCoRepresentativePhoneDisplay(representative);
    if (!phoneDisplay) return row;
    const phoneText = `휴대폰: ${formatEvidenceValue(phoneDisplay)}`;
    const value = String(row.value || "");
    return {
      ...row,
      value: value.includes("휴대폰:")
        ? value.replace(/휴대폰:\s*[^/]+/, phoneText)
        : [value, phoneText].filter(Boolean).join(" / "),
    };
  });
};

export const getLegalEvidencePackageReadiness = (contract = {}) => {
  const identityVerification =
    contract.identityVerification ||
    contract.finalSnapshot?.identityVerification ||
    {};
  const hasContractHash = Boolean(contract.contractHash || contract.finalSnapshot?.contractHash);
  const hasSignatureHash = Boolean(
    contract.signatureHash ||
      contract.finalSnapshot?.signatureHash ||
      contract.signatureData?.imageHash
  );
  const hasFinalSnapshot = Boolean(contract.finalSnapshot);
  const isKcpVerified =
    identityVerification.provider === "KCP" &&
    identityVerification.status === "VERIFIED";
  const hasCi = Boolean(identityVerification.hasCi);
  const hasDi = Boolean(identityVerification.hasDi);
  const hasSessionId = Boolean(identityVerification.sessionId);
  const hasOrderId = Boolean(identityVerification.orderId);
  const hasCompletedAt = Boolean(contract.completedAt || contract.finalSnapshot?.completedAt);
  const representativeIdentityVerification =
    contract.representativeIdentityVerification ||
    contract.finalSnapshot?.representativeIdentityVerification ||
    {};
  const businessVerification =
    contract.businessVerification ||
    contract.finalSnapshot?.businessVerification ||
    {};
  const grade =
    hasContractHash &&
    hasSignatureHash &&
    isKcpVerified &&
    hasCi &&
    hasDi &&
    hasSessionId &&
    hasCompletedAt
      ? "A"
      : hasContractHash && hasSignatureHash && isKcpVerified
      ? "B"
      : "C";

  return {
    grade,
    contractHash: hasContractHash ? "있음" : "없음",
    signatureHash: hasSignatureHash ? "있음" : "없음",
    finalSnapshot: hasFinalSnapshot ? "있음" : "없음",
    kcpStatus: identityVerification.status || "없음",
    ciDi: hasCi && hasDi ? "있음" : "없음",
    sessionId: hasSessionId ? "있음" : "없음",
    orderId: hasOrderId ? "있음" : "없음",
    representativeMatchStatus:
      representativeIdentityVerification.status ||
      identityVerification.representativeMatchStatus ||
      identityVerification.representativeVerificationStatus ||
      "미수집",
    businessVerificationStatus: businessVerification.status || "미수집",
  };
};

/* ================= SSN 암호화 유틸리티 (AES-256-GCM) =================
 * 대표자 주민번호는 AES-256-GCM으로 암호화하여 Firestore에 저장하고
 * 관리자 화면/PDF에는 원문을 표시하지 않는다.
 *
 * 암호화 키 설정 방법:
 *   1) Vercel 대시보드 → Settings → Environment Variables
 *      REACT_APP_SSN_ENCRYPT_KEY = <base64 인코딩된 32바이트 랜덤값>
 *   2) 로컬 개발: 프로젝트 루트에 .env.local 파일 생성 후 위 값 추가
 *
 * 키 생성 명령어 (터미널):
 *   node -e "console.log(require('crypto').randomBytes(32).toString('base64'))"
 * ================================================================== */
const getEncryptKey = async (): Promise<CryptoKey> => {
  const keyB64 = process.env.REACT_APP_SSN_ENCRYPT_KEY;
  let keyBytes: Uint8Array;
  if (keyB64) {
    const binary = atob(keyB64);
    keyBytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) keyBytes[i] = binary.charCodeAt(i);
  } else {
    throw new Error("SSN_ENCRYPTION_KEY_REQUIRED");
  }
  return crypto.subtle.importKey("raw", keyBytes, { name: "AES-GCM" }, false, [
    "encrypt",
    "decrypt",
  ]);
};

const encryptText = async (plaintext: string): Promise<string> => {
  const key = await getEncryptKey();
  const iv = crypto.getRandomValues(new Uint8Array(12));
  const encrypted = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    key,
    new TextEncoder().encode(plaintext)
  );
  const combined = new Uint8Array(iv.byteLength + encrypted.byteLength);
  combined.set(iv);
  combined.set(new Uint8Array(encrypted), iv.byteLength);
  return btoa(String.fromCharCode(...combined));
};

const decryptText = async (cipherB64: string): Promise<string | null> => {
  try {
    const key = await getEncryptKey();
    const combined = Uint8Array.from(atob(cipherB64), (char) =>
      char.charCodeAt(0)
    );
    const iv = combined.slice(0, 12);
    const encrypted = combined.slice(12);
    const decrypted = await crypto.subtle.decrypt(
      { name: "AES-GCM", iv },
      key,
      encrypted
    );
    return new TextDecoder().decode(decrypted);
  } catch (error) {
    console.error("SSN decrypt failed", error);
    return null;
  }
};

/* ================= 유틸리티 함수 ================= */
const getClientIP = async () => {
  try {
    const res = await fetch("https://api.ipify.org?format=json");
    const data = await res.json();
    return data.ip;
  } catch {
    return "unknown";
  }
};

// [신규] 디바이스 상세 정보 수집 함수
const getDeviceInfo = () => {
  if (typeof window === "undefined") return {};
  return {
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    language: navigator.language,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight,
    pixelRatio: window.devicePixelRatio,
    isIOS: /iPhone|iPad|iPod/i.test(navigator.userAgent),
    isAndroid: /Android/i.test(navigator.userAgent),
    isMobile: /Mobi/i.test(navigator.userAgent),
  };
};

const createLog = async (action, note = "") => {
  const ip = await getClientIP();
  const now = new Date();
  return {
    action,
    timestamp: now.toISOString(),
    formattedTime: now.toLocaleString("ko-KR"),
    ip,
    device: navigator.userAgent,
    note,
  };
};

const fetchRequestMeta = async () => {
  const fallbackUserAgent =
    typeof navigator !== "undefined" ? navigator.userAgent : null;

  try {
    const response = await fetch("/api/request-meta");
    if (!response.ok) {
      throw new Error(`request-meta failed with ${response.status}`);
    }

    const data = await response.json();
    return {
      ok: data?.ok === true,
      ip: data?.ip || null,
      userAgent: data?.userAgent || fallbackUserAgent,
      capturedAt: data?.capturedAt || null,
    };
  } catch (error) {
    console.error("request meta collection failed", error);
    return {
      ok: false,
      ip: null,
      userAgent: fallbackUserAgent,
      capturedAt: null,
    };
  }
};

export const notifyContractCompleted = async (payload = {}) => {
  if (!CONTRACT_COMPLETION_EMAIL_NOTIFICATION_ENABLED) {
    return {
      ok: true,
      skipped: true,
      reason: "contract_completion_email_disabled",
    };
  }
  const body = buildContractCompletedNotificationPayload(payload);
  const response = await fetch("/api/notify-contract-completed", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data?.ok !== true) {
    const error = new Error(
      data?.message || `notify-contract-completed failed with ${response.status}`
    );
    (error as any).status = response.status;
    (error as any).response = data;
    throw error;
  }
  return data;
};

// [신규] 에러 자동 리포팅 함수
const reportError = async (
  errorType,
  errorMessage,
  stepInfo,
  extraData = {}
) => {
  try {
    const safeError = sanitizeErrorForLog(errorMessage);
    const deviceInfo = getDeviceInfo();
    const ip = await getClientIP();
    await addDoc(collection(db, "artifacts", appId, "error_reports"), {
      timestamp: new Date().toISOString(),
      errorType,
      message: safeError?.message || sanitizeLogText(errorMessage),
      step: stepInfo,
      ip,
      deviceInfo, // 상세 기기 정보 저장
      extraData: sanitizeLogDetail(extraData),
    });
    console.error("Error Reported to DB:", safeError?.message || "sanitized error");
  } catch (e) {
    console.error("Failed to report error:", e);
  }
};

const logAdminAction = async (action, contractId, managerName, detail = "") => {
  try {
    const log = await createLog(action, detail);
    await addDoc(collection(db, "artifacts", appId, "admin_logs"), {
      ...log,
      contractId,
      managerName,
    });
    return true;
  } catch (e) {
    console.error("Log failed", e);
    return false;
  }
};

const getContractsCollectionRef = () =>
  collection(db, "artifacts", appId, "public", "data", "contracts");

const getContractDocumentRef = (documentId) =>
  doc(db, "artifacts", appId, "public", "data", "contracts", documentId);

const logContractEventWithResult = async (
  documentId,
  event: Partial<ContractEvent>
) => {
  const collectionPath = getContractEventCollectionPath(documentId);
  if (!documentId || !event?.type) return false;
  try {
    const eventDocRef = await addDoc(collection(getContractDocumentRef(documentId), "events"), sanitizeLogDetail({
      type: event.type,
      contractId: event.contractId || null,
      createdAt: event.createdAt || new Date().toISOString(),
      actorType: event.actorType || "SYSTEM",
      managerCode: event.managerCode || null,
      userAgent:
        event.userAgent ||
        (typeof navigator !== "undefined" ? navigator.userAgent : null),
      detail: sanitizeLogDetail(event.detail || {}),
    }));
    return {
      ok: true,
      collectionPath,
      docId: eventDocRef.id,
      eventType: event.type,
    };
  } catch (error) {
    console.error("[CNFOOD] contract event log failed", sanitizeErrorForLog(error));
    return {
      ok: false,
      collectionPath,
      docId: null,
      eventType: event.type,
      error,
    };
  }
};

const logContractEvent = async (documentId, event: Partial<ContractEvent>) => {
  const result = await logContractEventWithResult(documentId, event);
  return result?.ok === true;
};

const getFirestoreErrorToastMessage = (
  error,
  fallback = "처리 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요."
) => {
  const code = error?.code || "";
  if (code === CONTRACT_SUBMIT_AUTH_UNAVAILABLE_CODE) {
    return CONTRACT_SUBMIT_AUTH_UNAVAILABLE_MESSAGE;
  }
  if (code === "permission-denied") {
    return "권한이 없어 데이터를 처리할 수 없습니다.";
  }
  if (code === "failed-precondition") {
    return "Firestore 인덱스 설정이 필요합니다.";
  }
  return fallback;
};

export const CONTRACT_SUBMIT_AUTH_UNAVAILABLE_CODE =
  "contract-submit-auth-unavailable";

export const CONTRACT_SUBMIT_AUTH_UNAVAILABLE_MESSAGE =
  "계약 저장 권한 확인에 실패했습니다. 네트워크 연결을 확인한 뒤 다시 제출해 주세요.";

export const ensureFirebaseAnonymousAuth = async (
  authClient = auth,
  signInFn = signInAnonymously
) => {
  if (authClient?.currentUser) {
    return authClient.currentUser;
  }

  try {
    const credential = await signInFn(authClient);
    const activeUser = credential?.user || authClient?.currentUser || null;
    if (activeUser) return activeUser;

    const emptyUserError = new Error("Firebase anonymous auth returned no user");
    emptyUserError.code = CONTRACT_SUBMIT_AUTH_UNAVAILABLE_CODE;
    throw emptyUserError;
  } catch (error) {
    if (error?.code === CONTRACT_SUBMIT_AUTH_UNAVAILABLE_CODE) {
      throw error;
    }
    const authError = new Error("Firebase anonymous auth is unavailable");
    authError.code = CONTRACT_SUBMIT_AUTH_UNAVAILABLE_CODE;
    authError.cause = error;
    throw authError;
  }
};

export const isPermissionDeniedError = (error) => {
  const code = error?.code || error?.result?.code || "";
  const status = Number(error?.status || error?.result?.status || 0);
  const message = String(error?.message || "");
  return (
    code === "permission-denied" ||
    status === 401 ||
    status === 403 ||
    message.includes("permission-denied")
  );
};

const submitContractViaServer = async ({
  contractData = {},
  documentId = "",
} = {}) => {
  const response = await fetch("/api/contract-submit", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      mode: "contract-submit",
      appId,
      documentId,
      contractData,
    }),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok || !result?.ok) {
    const error = new Error(
      result?.message || "server contract submit failed"
    );
    error.code = result?.code || (response.status === 403 ? "permission-denied" : "");
    error.status = response.status;
    error.result = result;
    throw error;
  }
  return result;
};

export const validateSSN = (front, back) => {
  if (!front || !back || front.length !== 6 || back.length !== 7) return false;
  const ssn = front + back;
  if (!/^[0-9]+$/.test(ssn)) return false;
  const multipliers = [2, 3, 4, 5, 6, 7, 8, 9, 2, 3, 4, 5];
  let sum = 0;
  for (let i = 0; i < 12; i++) sum += parseInt(ssn[i]) * multipliers[i];
  const remainder = sum % 11;
  const checkDigit = (11 - remainder) % 10;
  return checkDigit === parseInt(ssn[12]);
};

export const isCorporateContract = (bizType = "") => {
  const normalized = String(bizType || "").trim().toUpperCase();
  return normalized === "CORPORATE" || normalized === "CORP";
};

export type LegacyGuarantorSsnRequirementOptions = {
  splitFlowEnabled?: boolean;
};

export const shouldRequireLegacyGuarantorSsnInPrimaryStep = (
  bizType = "",
  {
    splitFlowEnabled = PRIMARY_CO_REP_SPLIT_FLOW_ENABLED,
  }: LegacyGuarantorSsnRequirementOptions = {}
) => isCorporateContract(bizType) && splitFlowEnabled !== true;

export const shouldShowCorporateSsnFields = (bizType = "") =>
  shouldRequireLegacyGuarantorSsnInPrimaryStep(bizType);

export const shouldShowResidentRegistrationFields = (_bizType = "") => true;

export const maskResidentRegistrationNumber = (front = "") => {
  const cleanedFront = String(front || "").replace(/[^0-9]/g, "").slice(0, 6);
  return cleanedFront.length === 6 ? `${cleanedFront}-*******` : null;
};

export const isValidResidentRegistrationInput = (
  bizType = "",
  ssnFront = "",
  ssnBack = ""
) => {
  return (
    String(ssnFront || "").length === 6 &&
    String(ssnBack || "").length === 7 &&
    validateSSN(ssnFront, ssnBack)
  );
};

export const isValidCorporateSsnInput = isValidResidentRegistrationInput;

export const canProceedStep1ToContractReview = ({
  settings,
  phone,
  phoneVerified,
  bizType,
  ssnFront,
  ssnBack,
  principalRepSsnFront,
  principalRepSsnBack,
  guarantorSsnFront,
  guarantorSsnBack,
  agreements,
}) => {
  const principalFront = principalRepSsnFront || ssnFront;
  const principalBack = principalRepSsnBack || ssnBack;
  const principalValid = isValidResidentRegistrationInput(
    bizType,
    principalFront,
    principalBack
  );
  const legacyGuarantorSsnRequired =
    shouldRequireLegacyGuarantorSsnInPrimaryStep(bizType);
  const guarantorValid = legacyGuarantorSsnRequired
    ? isValidResidentRegistrationInput(
        bizType,
        guarantorSsnFront,
        guarantorSsnBack
      )
    : true;

  return (
    Boolean(agreements?.privacy) &&
    Boolean(agreements?.credit) &&
    Boolean(agreements?.collection) &&
    canProceedPhoneVerificationStep(settings, phone, phoneVerified) &&
    principalValid &&
    guarantorValid
  );
};

export type ValidationIssue = {
  fieldId: string;
  message: string;
  helperText?: string;
};

export const SENIOR_FIELD_HELP_TEXT: Record<string, string> = {
  agentName: "사업자등록증에 적힌 상호명을 그대로 입력해 주세요.",
  agentRep:
    "사업자등록증 기준 대표자명을 입력해 주세요. 본인확인 결과의 이름과 일치해야 합니다.",
  agentBizNo:
    "사업자등록증에 표시된 사업자등록번호를 입력해 주세요. 숫자만 입력해도 자동으로 정리됩니다.",
  agentAddress:
    "대표자 자택주소 또는 사업자등록증/법인등기부 기준 주소를 입력해 주세요. 주소검색을 이용하면 정확하게 입력할 수 있습니다.",
  depositDay:
    "입금 예정일을 숫자로 입력해 주세요. 당일 입금이면 '당일 입금'을 선택해 주세요.",
  agentContact:
    "대표자 본인 명의 휴대폰번호를 입력해 주세요. 가족, 직원, 점장 명의 휴대폰으로 인증하면 계약 진행이 제한될 수 있습니다.",
  representativeBirthDate:
    "주민번호 앞 6자리는 생년월일 확인에 사용됩니다. 뒷자리는 미수채권 관리 및 법적 증빙 목적으로 암호화 보관되며, 일반 화면에는 표시되지 않습니다.",
  openingDate:
    "국세청 사업자 진위확인을 위해 필요합니다. 사업자등록증에 표시된 개업연월일을 입력해 주세요. 모를 경우 본사 확인이 필요할 수 있습니다.",
  principalRepSsnFront:
    "외상거래 및 채권관리 목적의 정보입니다. 주민번호 앞 6자리를 입력해 주세요.",
  principalRepSsnBack:
    "외상거래 및 채권관리 목적의 정보입니다. 뒤 7자리는 화면과 로그에 노출하지 않도록 보호합니다.",
  guarantorSsnFront:
    "legacy 공동계약인 주민번호 앞 6자리입니다. 현재 분리 플로우에서는 주대표 화면에서 요구하지 않습니다.",
  guarantorSsnBack:
    "legacy 공동계약인 주민번호 뒤 7자리입니다. 입력값은 화면과 로그에 노출하지 않습니다.",
};

const createValidationIssue = (
  fieldId: string,
  message: string,
  helperText = SENIOR_FIELD_HELP_TEXT[fieldId] || ""
): ValidationIssue => ({ fieldId, message, helperText });

export const validateStep0RequiredFields = ({
  formData = {},
  bizType = "INDIVIDUAL",
  isSameDayDeposit = false,
  manualAddressMode = false,
  validationSettings = DEFAULT_VALIDATION_SETTINGS,
} = {}): ValidationIssue[] => {
  const issues: ValidationIssue[] = [];
  if (!String(formData.agentName || "").trim()) {
    issues.push(
      createValidationIssue(
        "agentName",
        "상호명을 입력해 주세요. 사업자등록증에 적힌 이름을 그대로 입력하면 됩니다."
      )
    );
  }
  if (!String(formData.agentRep || "").trim()) {
    issues.push(
      createValidationIssue(
        "agentRep",
        "대표자명을 입력해 주세요. 사업자등록증에 적힌 대표자명을 입력해 주세요."
      )
    );
  }
  if (!normalizeBirthDateForMatch(formData.representativeBirthDate || "")) {
    issues.push(
      createValidationIssue(
        "representativeBirthDate",
        "대표자 생년월일을 입력해 주세요. 주민번호 전체가 아니라 생년월일만 입력합니다."
      )
    );
  }
  if (!isValidBizNumberFormat(formData.agentBizNo || "")) {
    issues.push(
      createValidationIssue("agentBizNo", "사업자번호는 숫자 10자리로 입력해 주세요.")
    );
  }
  if (
    getNtsBusinessVerificationMode(validationSettings) === "REQUIRED" &&
    !formatOpeningDateForNts(formData.openingDate || "")
  ) {
    issues.push(
      createValidationIssue(
        "openingDate",
        "개업일자를 입력해 주세요. 사업자등록증 기준 YYYY-MM-DD 또는 숫자 8자리입니다."
      )
    );
  }
  if (!String(formData.agentAddress || "").trim()) {
    issues.push(
      createValidationIssue(
        "agentAddress",
        manualAddressMode
          ? "사업장 주소를 입력해 주세요."
          : "사업장 주소를 검색하거나 직접 입력으로 전환해 주세요."
      )
    );
  }
  if (!isSameDayDeposit && !String(formData.depositDay || "").trim()) {
    issues.push(
      createValidationIssue(
        "depositDay",
        "입금 예정일을 입력해 주세요. 당일 입금이면 당일 입금을 체크해 주세요."
      )
    );
  }
  if (isCorporateContract(bizType)) {
    if (!String(formData.corpRepName || "").trim()) {
      issues.push(
        createValidationIssue("corpRepName", "법인 대표자 성명을 입력해 주세요.")
      );
    }
    if (!String(formData.corpRepAddress || "").trim()) {
      issues.push(
        createValidationIssue("corpRepAddress", "법인 대표자 주소를 입력해 주세요.")
      );
    }
  }
  return issues;
};

export const validateStep1RequiredFields = ({
  settings,
  phone,
  phoneVerified,
  bizType,
  ssnFront,
  ssnBack,
  principalRepSsnFront,
  principalRepSsnBack,
  guarantorSsnFront,
  guarantorSsnBack,
  agreements,
  restoredSsnDraft = null,
}): ValidationIssue[] => {
  const issues: ValidationIssue[] = [];
  if (!isValidPhoneNumberFormat(phone || "")) {
    issues.push(
      createValidationIssue(
        "agentContact",
        "휴대폰 번호를 입력해 주세요. 본인확인을 받을 번호입니다."
      )
    );
  } else if (settings?.enablePhoneVerification && !phoneVerified) {
    issues.push(
      createValidationIssue(
        "agentContact",
        "휴대폰 번호 확인을 완료해 주세요."
      )
    );
  }

  const principalFront = principalRepSsnFront || ssnFront;
  const principalBack = principalRepSsnBack || ssnBack;
  const principalRawValid = isValidResidentRegistrationInput(
    bizType,
    principalFront,
    principalBack
  );
  const principalRestored = Boolean(restoredSsnDraft?.principalRepSsnEncrypted);
  if (!principalRawValid && !principalRestored) {
    issues.push(
      createValidationIssue(
        !principalFront ? "principalRepSsnFront" : "principalRepSsnBack",
        "본 대표 주민등록번호를 정확히 입력해 주세요."
      )
    );
  }

  const legacyGuarantorSsnRequired =
    shouldRequireLegacyGuarantorSsnInPrimaryStep(bizType);
  const guarantorRawValid =
    !legacyGuarantorSsnRequired ||
    isValidResidentRegistrationInput(
      bizType,
      guarantorSsnFront,
      guarantorSsnBack
    );
  const guarantorRestored =
    !legacyGuarantorSsnRequired ||
    Boolean(restoredSsnDraft?.guarantorSsnEncrypted);
  if (!guarantorRawValid && !guarantorRestored) {
    issues.push(
      createValidationIssue(
        !guarantorSsnFront ? "guarantorSsnFront" : "guarantorSsnBack",
        "공동계약인 주민등록번호를 정확히 입력해 주세요."
      )
    );
  }

  if (!agreements?.privacy) {
    issues.push(
      createValidationIssue("agreementPrivacy", "개인정보 수집·이용 동의에 체크해 주세요.")
    );
  }
  if (!agreements?.credit) {
    issues.push(
      createValidationIssue("agreementCredit", "신용정보 조회 및 활용 동의에 체크해 주세요.")
    );
  }
  if (!agreements?.collection) {
    issues.push(
      createValidationIssue("agreementCollection", "채권추심 및 법적 절차 목적 이용 동의에 체크해 주세요.")
    );
  }

  return issues;
};

export const shouldResetIdentityForPhoneChange = (
  previousPhone = "",
  nextPhone = ""
) =>
  String(previousPhone || "").replace(/[^0-9]/g, "") !==
  String(nextPhone || "").replace(/[^0-9]/g, "");

export const maskInviteTokenForReport = (token = "") => {
  const value = String(token || "");
  if (!value) return "";
  if (value.length <= 10) return `${value.slice(0, 2)}****${value.slice(-2)}`;
  return `${value.slice(0, 6)}****${value.slice(-4)}`;
};

export const buildMaskedReportSnapshotDataUrl = ({
  page = "",
  step = 0,
  message = "",
  userMessage = "",
  width = 390,
  height = 720,
} = {}) => {
  const safeLines = [
    "(주)씨엔푸드 전자계약 오류신고 화면 요약",
    `화면: ${sanitizeLogText(page)}`,
    `단계: ${step}`,
    `오류: ${sanitizeLogText(message).slice(0, 240)}`,
    `사용자 설명: ${sanitizeLogText(userMessage).slice(0, 360)}`,
  ];
  const textElements = safeLines
    .map(
      (line, index) =>
        `<text x="24" y="${44 + index * 34}" font-size="18" fill="#0f172a">${escapeHtml(line)}</text>`
    )
    .join("");
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${Math.min(
    Math.max(Number(width) || 390, 320),
    900
  )}" height="${Math.min(Math.max(Number(height) || 720, 360), 1200)}" viewBox="0 0 ${Math.min(
    Math.max(Number(width) || 390, 320),
    900
  )} ${Math.min(Math.max(Number(height) || 720, 360), 1200)}"><rect width="100%" height="100%" fill="#f8fafc"/><rect x="12" y="12" width="calc(100% - 24px)" height="220" rx="18" fill="#ffffff" stroke="#e2e8f0"/>${textElements}</svg>`;
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
};

export const isValidScreenshotDataUrl = (value = "") => {
  const dataUrl = String(value || "");
  if (!/^data:image\/(png|jpeg|jpg|webp|svg\+xml);/i.test(dataUrl)) {
    return false;
  }
  return dataUrl.length > 1024;
};

export const isProbablyBlankCanvas = (canvas: HTMLCanvasElement | null) => {
  if (!canvas || !canvas.width || !canvas.height) return true;
  try {
    const ctx = canvas.getContext("2d", { willReadFrequently: true });
    if (!ctx) return true;
    const sampleSize = 24;
    let blankishPixels = 0;
    let sampledPixels = 0;
    const stepX = Math.max(1, Math.floor(canvas.width / sampleSize));
    const stepY = Math.max(1, Math.floor(canvas.height / sampleSize));
    for (let y = 0; y < canvas.height; y += stepY) {
      for (let x = 0; x < canvas.width; x += stepX) {
        const [r, g, b, a] = ctx.getImageData(x, y, 1, 1).data;
        sampledPixels += 1;
        if (a < 8 || (r > 245 && g > 245 && b > 245)) {
          blankishPixels += 1;
        }
      }
    }
    if (!sampledPixels) return true;
    return blankishPixels / sampledPixels > 0.985;
  } catch {
    return false;
  }
};

export const createSafeUserErrorReportPayload = ({
  page = "FORM",
  step = 0,
  visibleErrorMessage = "",
  userMessage = "",
  viewportWidth = 0,
  viewportHeight = 0,
  userAgent = "",
  contractDraftId = "",
  inviteToken = "",
  managerCode = "",
  screenshotDataUrl = "",
  captureError = "",
  capturedAt = "",
} = {}) => ({
  reportKind: "USER_REPORT",
  errorType: "USER_REPORTED_ISSUE",
  status: "NEW",
  message: sanitizeLogText(visibleErrorMessage || userMessage || "사용자 오류신고"),
  page: sanitizeLogText(page),
  step,
  visibleErrorMessage: sanitizeLogText(visibleErrorMessage),
  userMessage: sanitizeLogText(userMessage),
  screenshotDataUrl: isValidScreenshotDataUrl(screenshotDataUrl)
    ? String(screenshotDataUrl)
    : "",
  viewportWidth,
  viewportHeight,
  userAgent: sanitizeLogText(userAgent).slice(0, 500),
  contractDraftId: sanitizeLogText(contractDraftId),
  inviteTokenMasked: maskInviteTokenForReport(inviteToken),
  managerCode: sanitizeLogText(managerCode),
  captureError: sanitizeLogText(captureError),
  capturedAt: sanitizeLogText(capturedAt),
});

export const buildSsnPersistenceFields = (
  bizType = "",
  principalRepSsnEncrypted: string | null = null,
  principalRepSsnFront = "",
  guarantorSsnEncrypted: string | null = null,
  guarantorSsnFront = "",
  principalRepSsnHash: string | null = null,
  principalRepSsnHmac: string | null = null,
  guarantorSsnHash: string | null = null,
  guarantorSsnHmac: string | null = null
) => ({
  ssnFront: null,
  ssnBack: null,
  principalRepSsnFront: null,
  principalRepSsnBack: null,
  guarantorSsnFront: null,
  guarantorSsnBack: null,
  // Legacy fields are kept as principal representative SSN for old readers.
  ssnEncrypted: principalRepSsnEncrypted || null,
  ssnMasked: principalRepSsnEncrypted
    ? maskResidentRegistrationNumber(principalRepSsnFront)
    : null,
  principalRepSsnEncrypted: principalRepSsnEncrypted || null,
  principalRepSsnMasked: principalRepSsnEncrypted
    ? maskResidentRegistrationNumber(principalRepSsnFront)
    : null,
  ...(principalRepSsnHash ? { principalRepSsnHash } : {}),
  ...(principalRepSsnHmac ? { principalRepSsnHmac } : {}),
  guarantorSsnEncrypted:
    isCorporateContract(bizType) && guarantorSsnEncrypted
      ? guarantorSsnEncrypted
      : null,
  guarantorSsnMasked:
    isCorporateContract(bizType) && guarantorSsnEncrypted
      ? maskResidentRegistrationNumber(guarantorSsnFront)
      : null,
  ...(isCorporateContract(bizType) && guarantorSsnHash
    ? { guarantorSsnHash }
    : {}),
  ...(isCorporateContract(bizType) && guarantorSsnHmac
    ? { guarantorSsnHmac }
    : {}),
});

export const getSsnDisplayValue = (contract = {}) => {
  if (contract.principalRepSsnMasked) return contract.principalRepSsnMasked;
  if (contract.ssnMasked) return contract.ssnMasked;
  if (contract.ssnFront) return maskResidentRegistrationNumber(contract.ssnFront);
  if (contract.principalRepSsnEncrypted || contract.ssnEncrypted)
    return "암호화 저장";
  return "미수집";
};

export const getPrincipalRepSsnDisplayValue = (contract = {}) =>
  getSsnDisplayValue(contract);

export const getPrincipalRepSsnCipherText = (contract = {}) =>
  contract.principalRepSsnEncrypted || contract.ssnEncrypted || null;

export const formatDecryptedResidentRegistrationNumber = (decrypted = "") => {
  const raw = String(decrypted || "").trim();
  const [frontFromPair, backFromPair] = raw.split("|");
  const front = frontFromPair || "";
  const back = backFromPair || "";

  if (/^\d{6}$/.test(front) && /^\d{7}$/.test(back)) {
    return `${front}-${back}`;
  }

  const digits = raw.replace(/[^\d]/g, "");
  if (/^\d{13}$/.test(digits)) {
    return `${digits.slice(0, 6)}-${digits.slice(6)}`;
  }

  return null;
};

export const getLegacyPlainSsnDisplayValue = (contract = {}) => {
  const front = contract.principalRepSsnFront || contract.ssnFront || "";
  const back = contract.principalRepSsnBack || contract.ssnBack || "";
  return /^\d{6}$/.test(front) && /^\d{7}$/.test(back)
    ? `${front}-${back}`
    : null;
};

export const getGuarantorSsnDisplayValue = (contract = {}) => {
  if (contract.guarantorSsnMasked) return contract.guarantorSsnMasked;
  if (contract.guarantorSsnEncrypted) return "암호화 저장";
  return "데이터 없음";
};

export const getSsnVerificationStatus = (contract = {}) => {
  return contract.principalRepSsnEncrypted ||
    contract.principalRepSsnMasked ||
    contract.guarantorSsnEncrypted ||
    contract.guarantorSsnMasked ||
    contract.ssnEncrypted ||
    contract.ssnMasked ||
    contract.ssnFront
    ? "주민번호 확인 완료"
    : "미수집";
};

export const buildSsnAccessRecord = ({
  managerName = "",
  managerEmail = "",
  ip = null,
  userAgent = null,
  accessedAt = new Date().toISOString(),
} = {}) => ({
  accessedAt,
  managerName: managerName || "알 수 없음",
  managerEmail: managerEmail || null,
  ip: ip || null,
  userAgent: userAgent || null,
});

export const formatSsnAccessMemoLine = (record = {}) => {
  const accessedAt = formatEvidenceDate(record.accessedAt, "미수집");
  const managerName = record.managerName || "알 수 없음";
  const ip = record.ip || "미수집";
  return `[주민번호 확인] ${accessedAt} / 확인자: ${managerName} / IP: ${ip}`;
};

export const appendSsnAccessMemoLine = (memo = "", record = {}) => {
  const line = formatSsnAccessMemoLine(record);
  const trimmedMemo = String(memo || "").trimEnd();
  return trimmedMemo ? `${trimmedMemo}\n${line}` : line;
};

export const getAgentSignatureStampLayout = ({
  baselineY = 0,
  sealTextX = 835,
  boxRightX = 1200,
  stampWidth = 90,
  stampHeight = 42,
  rightPadding = 35,
  sealOverlapOffset = 38,
  minX = 760,
  baselineTopOffset = 22,
} = {}) => {
  const maxX = boxRightX - stampWidth - rightPadding;
  const x = Math.min(Math.max(sealTextX - sealOverlapOffset, minX), maxX);
  return {
    x,
    y: baselineY - baselineTopOffset,
    width: stampWidth,
    height: stampHeight,
  };
};

export const getPendingConfirmScrollOptions = ({
  scope = "",
  scrollToTop = false,
} = {}) => {
  if (scope !== "DETAIL" || !scrollToTop) return null;
  return { top: 0, left: 0, behavior: "smooth" };
};

const setPdfFont = (ctx, fontSize = 16, fontFamily = "serif", fontWeight = "") => {
  if (!ctx) return;
  ctx.font = `${fontWeight ? `${fontWeight} ` : ""}${fontSize}px ${fontFamily}`;
};

const wrapTextLines = (ctx, text = "", width = 100) => {
  const normalized = String(text ?? "");
  if (!normalized) return [""];

  const lines: string[] = [];
  normalized.split(/\n/).forEach((paragraph) => {
    let line = "";
    const tokens = paragraph.split(/(\s+)/).filter((token) => token !== "");

    const pushLine = () => {
      lines.push(line.trimEnd());
      line = "";
    };

    const appendByCharacter = (token) => {
      for (const char of token) {
        const next = line + char;
        if (line && ctx.measureText(next).width > width) {
          pushLine();
          line = char;
        } else {
          line = next;
        }
      }
    };

    tokens.forEach((token) => {
      const next = line + token;
      if (ctx.measureText(next).width <= width) {
        line = next;
        return;
      }

      if (ctx.measureText(token).width > width) {
        if (line.trim()) pushLine();
        appendByCharacter(token);
        return;
      }

      pushLine();
      line = token.trimStart();
    });

    lines.push(line.trimEnd());
  });

  return lines.filter((line, index) => line || index === 0);
};

export const splitTextToFitBox = ({
  ctx,
  text = "",
  width = 100,
  lineHeight = 20,
  fontSize = 16,
  minFontSize = 11,
  fontFamily = "serif",
  fontWeight = "",
  maxLines = null,
} = {}) => {
  let size = fontSize;
  let lines: string[] = [];

  while (size >= minFontSize) {
    setPdfFont(ctx, size, fontFamily, fontWeight);
    lines = wrapTextLines(ctx, text, width);
    if (!maxLines || lines.length <= maxLines || size === minFontSize) break;
    size -= 1;
  }

  if (maxLines && lines.length > maxLines) {
    lines = lines.slice(0, maxLines);
    const lastIndex = lines.length - 1;
    let lastLine = lines[lastIndex] || "";
    while (lastLine && ctx.measureText(`${lastLine}...`).width > width) {
      lastLine = lastLine.slice(0, -1);
    }
    lines[lastIndex] = `${lastLine}...`;
  }

  return {
    lines,
    fontSize: size,
    lineHeight,
    height: Math.max(lineHeight, lines.length * lineHeight),
  };
};

export const drawWrappedTextInBox = (
  ctx,
  {
    text = "",
    x = 0,
    y = 0,
    width = 100,
    lineHeight = 20,
    fontSize = 16,
    minFontSize = 11,
    fontFamily = "serif",
    fontWeight = "",
    maxLines = null,
    color = "#000",
  } = {}
) => {
  const wrapped = splitTextToFitBox({
    ctx,
    text,
    width,
    lineHeight,
    fontSize,
    minFontSize,
    fontFamily,
    fontWeight,
    maxLines,
  });
  if (ctx) {
    ctx.fillStyle = color;
    setPdfFont(ctx, wrapped.fontSize, fontFamily, fontWeight);
    wrapped.lines.forEach((line, index) => {
      ctx.fillText(line, x, y + index * lineHeight);
    });
  }

  return {
    x,
    y,
    width,
    height: wrapped.height,
    bottom: y + wrapped.height,
    lines: wrapped.lines,
    fontSize: wrapped.fontSize,
  };
};

export const measureWrappedTextHeight = (args = {}) =>
  splitTextToFitBox(args).height;

export const getNextYAfterBox = (box = {}, gap = 0) =>
  (box.bottom ?? (box.y || 0) + (box.height || 0)) + gap;

export const getRepresentativeSignatureRowLayout = ({
  x = 0,
  y = 0,
  width = 520,
  labelWidth = 95,
  nameTextWidth = null,
  signatureWidth = 110,
  signatureHeight = 54,
  signatureGap = 8,
  baselineTopOffset = 18,
  rowGap = 10,
  rowPaddingTop = 6,
  rowPaddingBottom = 12,
} = {}) => {
  const nameValueX = x + labelWidth;
  const maxSignatureX = x + width - signatureWidth;
  const hasMeasuredNameText = Number.isFinite(nameTextWidth);
  const safeNameTextWidth = hasMeasuredNameText
    ? Math.max(40, Number(nameTextWidth))
    : Math.max(40, maxSignatureX - nameValueX - signatureGap);
  const signatureX = Math.min(
    maxSignatureX,
    nameValueX + safeNameTextWidth + signatureGap
  );
  const signatureY = y - baselineTopOffset;
  const signatureBox = {
    x: signatureX,
    y: signatureY,
    width: signatureWidth,
    height: signatureHeight,
  };
  const nameValueBox = {
    x: nameValueX,
    y,
    width: Math.max(40, signatureBox.x - nameValueX - signatureGap),
    height: signatureHeight,
  };
  const rowTop = signatureBox.y - rowPaddingTop;
  const rowBottom = signatureBox.y + signatureBox.height + rowPaddingBottom;
  return {
    rowY: y,
    rowTop,
    rowBottom,
    labelBox: { x, y, width: labelWidth, height: signatureHeight },
    nameValueBox,
    signatureBox,
    nextY: rowBottom + rowGap,
  };
};

export const getContainedImageRect = ({
  imageWidth = 1,
  imageHeight = 1,
  box = {},
} = {}) => {
  const safeImageWidth = Math.max(1, imageWidth || 1);
  const safeImageHeight = Math.max(1, imageHeight || 1);
  const scale = Math.min(
    (box.width || 0) / safeImageWidth,
    (box.height || 0) / safeImageHeight
  );
  const width = safeImageWidth * scale;
  const height = safeImageHeight * scale;
  return {
    x: (box.x || 0) + ((box.width || 0) - width) / 2,
    y: (box.y || 0) + ((box.height || 0) - height) / 2,
    width,
    height,
  };
};

export const drawSignatureInBox = (ctx, url, box = {}) => {
  return new Promise((resolve) => {
    if (!url) {
      resolve(null);
      return;
    }

    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      const rect = getContainedImageRect({
        imageWidth: img.naturalWidth || img.width,
        imageHeight: img.naturalHeight || img.height,
        box,
      });
      ctx.drawImage(img, rect.x, rect.y, rect.width, rect.height);
      resolve(rect);
    };
    img.onerror = () => resolve(null);
    img.src = url;
  });
};

const checkBizStatus = async (bizNo) => {
  if (!NTS_API_KEY) return { valid: true, msg: "API 키 없음" };
  const cleanBizNo = bizNo.replace(/-/g, "");
  try {
    const response = await fetch(
      `https://api.odcloud.kr/api/nts-businessman/v1/status?serviceKey=${NTS_API_KEY}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ b_no: [cleanBizNo] }),
      }
    );
    const data = await response.json();
    const coRepresentativeInfo =
      deriveCoRepresentativeInfoFromNtsBusinessStatus(data);
    if (data.data && data.data.length > 0) {
      const status = data.data[0].b_stt_cd;
      if (status === "01")
        return { valid: true, msg: "정상 사업자", coRepresentativeInfo };
      else if (status === "02")
        return { valid: false, msg: "휴업 중인 사업자", coRepresentativeInfo };
      else if (status === "03")
        return { valid: false, msg: "폐업한 사업자", coRepresentativeInfo };
      else return { valid: false, msg: "국세청 미등록 번호", coRepresentativeInfo };
    }
    return { valid: false, msg: "조회 불가", coRepresentativeInfo };
  } catch (error) {
    return { valid: true, msg: "서버 응답 지연" };
  }
};

const verifyBusinessWithNts = async ({ formData = {} } = {}) => {
  const response = await fetch("/api/nts-business-verify", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      mode: "nts-business-verify",
      businessNumber: formData.agentBizNo,
      representativeName: formData.agentRep,
      openingDate: formData.openingDate,
      businessName: formData.agentName,
    }),
  });
  const result = await response.json().catch(() => null);
  if (!result?.businessVerification) {
    return {
      ok: false,
      businessVerification: {
        provider: "NTS",
        checkedAt: new Date().toISOString(),
        status: "FAILED",
        businessNumber: normalizeBusinessNumber(formData.agentBizNo || ""),
        representativeName: String(formData.agentRep || "").trim(),
        openingDate: formatOpeningDateForNts(formData.openingDate || ""),
        validationCheck: {
          attempted: true,
          valid: null,
          message: result?.message || "국세청 진위확인 응답을 확인하지 못했습니다.",
          rawStatusCode: "",
        },
        statusCheck: {
          attempted: false,
          businessStatus: "",
          taxType: "",
          closedDate: "",
        },
      },
      message: result?.message || "국세청 확인이 일시적으로 지연됩니다. 본사 확인이 필요할 수 있습니다.",
    };
  }
  return {
    ok: response.ok && result.businessVerification.status === "VALID",
    businessVerification: result.businessVerification,
    message:
      result.message ||
      (result.businessVerification.status === "VALID"
        ? "국세청 사업자 진위확인이 완료되었습니다."
        : "사업자번호, 대표자명 또는 개업일자가 국세청 등록정보와 일치하지 않습니다."),
  };
};

const dataURLtoBlob = (dataurl) => {
  var arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
};

export const wrapCanvasTextLines = ({
  ctx,
  text,
  maxWidth,
  font = "16px sans-serif",
}) => {
  ctx.font = font;
  const content = formatEvidenceValue(text);
  const lines = [];
  const paragraphs = String(content).split(/\r?\n/);

  paragraphs.forEach((paragraph, paragraphIndex) => {
    let line = "";
    for (let i = 0; i < paragraph.length; i += 1) {
      const testLine = line + paragraph[i];
      if (ctx.measureText(testLine).width > maxWidth && line) {
        lines.push(line);
        line = paragraph[i];
      } else {
        line = testLine;
      }
    }
    lines.push(line || " ");
    if (paragraphIndex < paragraphs.length - 1) lines.push(" ");
  });

  return lines.length ? lines : [" "];
};

const drawCanvasTextLines = (
  ctx,
  lines,
  x,
  y,
  lineHeight,
  font = "16px sans-serif"
) => {
  ctx.font = font;
  let currentY = y;
  lines.forEach((line) => {
    ctx.fillText(line, x, currentY);
    currentY += lineHeight;
  });
  return currentY;
};

const drawWrappedCanvasText = (
  ctx,
  text,
  x,
  y,
  maxWidth,
  lineHeight,
  font = "16px sans-serif"
) => {
  const lines = wrapCanvasTextLines({ ctx, text, maxWidth, font });
  return drawCanvasTextLines(ctx, lines, x, y, lineHeight, font);
};

type ViewMode = "FORM" | "LIST" | "DETAIL" | "ADMIN_LOGIN" | "DEBUG";
type AdminTab =
  | "CONTRACT_START"
  | "SALES_SEARCH"
  | "LEGACY_ARCHIVE"
  | "VENDOR_MASTER"
  | "PAYMENT_MANAGEMENT"
  | "COMPANY_BRANCHES"
  | "DB_BACKUP"
  | "SETTINGS"
  | "LIST"
  | "STATS"
  | "REPORTS"
  | "TEMPLATES";
type ManagerTarget =
  | "default"
  | "field_print"
  | "debug"
  | "sales_lookup"
  | "sales_payment"
  | "payment";
export type SalesPaymentLoginOption = {
  code: string;
  name: string;
};
type AdminAccessMode =
  | "ADMIN"
  | "FIELD_PRINT"
  | "SALES_LOOKUP"
  | "SALES_PAYMENT"
  | "PAYMENT";
type PaymentWorkspaceRoute = "ALL" | "SALES_REQUEST" | "OPERATIONS";
type LoadingContext = "login" | "list" | "debug" | "screen" | null;

export const getAdminLoginVerificationMode = (target: ManagerTarget | null) => {
  if (target === "field_print") return "field_print";
  if (target === "debug") return "debug";
  if (target === "sales_lookup") return "sales_lookup";
  if (target === "payment") return "payment";
  if (target === "sales_payment") return "sales_payment";
  return "admin";
};

const normalizeSalesPaymentManagerSearch = (value: unknown): string =>
  String(value ?? "")
    .trim()
    .replace(/\s+/g, " ")
    .toLocaleLowerCase("ko-KR");

export const filterSalesPaymentLoginOptions = (
  options: SalesPaymentLoginOption[],
  search: string
): SalesPaymentLoginOption[] => {
  const normalizedSearch = normalizeSalesPaymentManagerSearch(search);
  if (!normalizedSearch) return options;

  return options.filter((option) =>
    [option.name, option.code].some((value) =>
      normalizeSalesPaymentManagerSearch(value).includes(normalizedSearch)
    )
  );
};

export const getSalesPaymentLoginOptionByCode = (
  options: SalesPaymentLoginOption[],
  code: string
): SalesPaymentLoginOption | null =>
  options.find((option) => option.code === code.trim()) || null;

export const getSalesPaymentManagerSelection = (option: SalesPaymentLoginOption) => ({
  salesPaymentCode: option.code,
  managerSearch: option.name,
  isListOpen: false,
});

export const SALES_PAYMENT_LOGIN_SCROLL_CONTAINER_CLASS =
  "fixed inset-0 z-50 flex min-h-screen min-h-[100dvh] items-start justify-center overflow-x-hidden overflow-y-auto overscroll-y-contain bg-black/50 p-4 pb-[calc(env(safe-area-inset-bottom)+1rem)] touch-pan-y sm:items-center";
export const SALES_PAYMENT_LOGIN_LISTBOX_CLASS =
  "absolute left-0 right-0 top-full z-50 mt-2 max-h-[min(38dvh,15rem)] overflow-y-auto overscroll-contain rounded-2xl border border-slate-200 bg-white p-1 shadow-2xl sm:max-h-72";
export const SALES_PAYMENT_LOGIN_ACTION_CLASS =
  "sticky bottom-0 z-40 -mx-6 -mb-6 mt-4 flex gap-2 border-t border-slate-200 bg-white/95 px-6 pt-3 pb-[calc(env(safe-area-inset-bottom)+0.75rem)] backdrop-blur";

export const ADMIN_DESKTOP_MIN_WIDTH = 1024;
export const SALES_CONTRACT_STATUS_OPTIONS = [
  { value: "all", label: "전체" },
  { value: "not_started", label: "작성 전" },
  { value: "draft", label: "작성 중" },
  { value: "completed", label: "작성 완료" },
  { value: "pending", label: "확인 대기" },
  { value: "confirmed", label: "확정 완료" },
  { value: "rejected", label: "반려" },
  { value: "exclude_deleted", label: "휴지통 제외" },
];
export const LEGACY_CONTRACT_TEMPLATE_COLUMNS = [
  "상호명",
  "사업자번호",
  "대표자명",
  "연락처",
  "주소",
  "담당영업사원",
  "계약일자",
  "계약상태",
  "메모",
];
export const LEGACY_CONTRACT_STATUS_OPTIONS = [
  { value: "all", label: "전체" },
  { value: "ACTIVE", label: "거래중" },
  { value: "ENDED", label: "종료" },
  { value: "UNKNOWN", label: "미확인" },
  { value: "DISPUTE", label: "분쟁" },
  { value: "BAD_DEBT", label: "미수" },
];
export const LEGACY_DOCUMENT_TYPE_OPTIONS = [
  { value: "CONTRACT", label: "수기계약서" },
  { value: "UNPAID_CONFIRMATION", label: "미수확인서" },
  { value: "LEGAL_DISPUTE", label: "법적 다툼 서류" },
  { value: "BUSINESS_LICENSE", label: "사업자등록증" },
  { value: "ETC", label: "기타" },
];
export const LEGACY_HISTORY_TYPE_OPTIONS = [
  { value: "NOTE", label: "상담 메모" },
  { value: "CALL", label: "통화" },
  { value: "PAYMENT_PROMISE", label: "결제 약속" },
  { value: "BAD_DEBT", label: "미수 발생" },
  { value: "LEGAL", label: "법적 대응" },
  { value: "DOCUMENT_ADDED", label: "문서 등록" },
  { value: "ETC", label: "기타" },
];

export const VENDOR_MASTER_TEMPLATE_COLUMNS = [
  "거래처코드",
  "ERP사업장코드",
  "ERP관할사업장명",
  "담당사업장",
  "상호명",
  "사업자번호",
  "대표자명",
  "전화번호",
  "주소",
  "파트",
  "담당영업사원",
  "관리상태",
  "메모",
  "결제링크허용",
  "키인결제허용",
];

export const VENDOR_ERP_DETAIL_FIELDS = [
  ["shortName", "약칭"],
  ["groupName", "그룹"],
  ["contactName", "ERP 담당자"],
  ["landlinePhone", "전화번호"],
  ["mobilePhone", "핸드폰"],
  ["settlementDay", "결제일"],
  ["paymentDueMemo", "결제예정일 메모"],
  ["postalCode", "우편번호"],
  ["addressLine1", "주소"],
  ["addressDetail", "번지"],
  ["businessType", "업태"],
  ["businessItem", "종목"],
  ["priceTier", "적용단가"],
  ["email", "이메일"],
  ["orderId", "주문 ID"],
  ["note", "비고"],
  ["extendedMemo", "메모2"],
  ["vatCode", "부가세 코드"],
  ["erpCreatedAt", "ERP 최초 등록일"],
  ["erpUpdatedAt", "ERP 최종 수정일"],
  ["lastTransactionAt", "최종 거래일"],
  ["erpUpdatedBy", "ERP 최종 수정자"],
  ["vatName", "부가세명"],
  ["tradeStopFlag", "거래중지 여부"],
  ["invoiceType", "계산서 형태"],
  ["shoppingMallLinkInfo", "쇼핑몰 연동정보"],
  ["discountRate", "할인율"],
  ["pointsBasis", "포인트 기준"],
  ["cmsCode", "CMS 코드"],
] as const;

export const COMPANY_BRANCH_PG_STATUS_OPTIONS = [
  { value: "NOT_APPLIED", label: "미신청" },
  { value: "APPLIED", label: "신청중" },
  { value: "ACTIVE", label: "활성" },
  { value: "SUSPENDED", label: "중지" },
];

export const COMPANY_BRANCH_SEED_TEMPLATE_NAMES = ["화성법인", "인천법인"];

export const VENDOR_MASTER_STATUS_OPTIONS = [
  { value: "managed", label: "삭제 제외" },
  { value: "all", label: "전체" },
  { value: "ACTIVE", label: "거래중" },
  { value: "INACTIVE", label: "거래중지" },
  { value: "WATCH", label: "주의" },
  { value: "LEGAL", label: "법적관리" },
  { value: "DELETED", label: "삭제" },
];

export const VENDOR_MASTER_LINK_FILTER_OPTIONS = [
  { value: "all", label: "전체 연결" },
  { value: "electronic", label: "전자계약 연결" },
  { value: "legacy", label: "수기계약 보유" },
  { value: "manualReview", label: "본사 확인 필요" },
  { value: "watchLegal", label: "주의/법적관리" },
];

export const PAYMENT_REQUEST_TYPE_OPTIONS = [
  { value: "BUYLINK", label: "문자링크결제" },
  { value: "AUTOPAY", label: "키인결제" },
];

export const LINK_PAYMENT_PROFILE_OPTIONS = [
  {
    value: "CNFOOD_LINK",
    label: "주식회사 씨엔푸드",
    siteCd: "ALUAQ",
  },
  {
    value: "PARTNERSHIP_LINK",
    label: "농업회사법인 주식회사 씨엔푸드",
    siteCd: "ALUAW",
  },
];

export const getCompanyBranchLinkPaymentDisplay = (pgProfile = {}) => {
  const profileId = String(pgProfile?.linkPaymentProfileId || "")
    .trim()
    .toUpperCase();
  const profile = LINK_PAYMENT_PROFILE_OPTIONS.find(
    (option) => option.value === profileId
  );
  return {
    profileId,
    companyName:
      profile?.label || pickSalesLookupString(pgProfile?.paymentCompanyName),
    siteCd:
      profile?.siteCd ||
      pickSalesLookupString(
        pgProfile?.linkSiteCdMasked,
        pgProfile?.siteCdMasked
      ),
  };
};

export const KEYIN_PAYMENT_PROFILE_OPTIONS = [
  {
    value: "CNFOOD_KEYIN",
    label: "주식회사 씨엔푸드",
    siteCd: "ALUAO",
  },
  {
    value: "PARTNERSHIP_KEYIN",
    label: "농업회사법인 주식회사 씨엔푸드",
    siteCd: "ALUAV",
  },
];

export const AUTOPAY_PROFILE_OPTIONS = [
  {
    value: "CNFOOD_AUTOPAY",
    label: "주식회사 씨엔푸드",
  },
  {
    value: "PARTNERSHIP_AUTOPAY",
    label: "농업회사법인 주식회사 씨엔푸드",
  },
];

const COMPANY_BRANCH_PAYMENT_PROFILE_ALIASES = {
  주식회사씨엔푸드: {
    linkPaymentProfileId: "CNFOOD_LINK",
    keyinPaymentProfileId: "CNFOOD_KEYIN",
    autopayProfileId: "CNFOOD_AUTOPAY",
  },
  농업회사법인주식회사씨엔푸드: {
    linkPaymentProfileId: "PARTNERSHIP_LINK",
    keyinPaymentProfileId: "PARTNERSHIP_KEYIN",
    autopayProfileId: "PARTNERSHIP_AUTOPAY",
  },
  동업회사법인주식회사씨엔푸드: {
    linkPaymentProfileId: "PARTNERSHIP_LINK",
    keyinPaymentProfileId: "PARTNERSHIP_KEYIN",
    autopayProfileId: "PARTNERSHIP_AUTOPAY",
  },
};

export const normalizeCompanyLegalEntityName = (value = "") =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^0-9a-z가-힣]/g, "");

export const resolveCompanyBranchPaymentProfiles = (row = {}) => {
  const corporationName = pickSalesLookupString(row.corporationName, row["법인명"]);
  const sourcePg = row.pgProfile || {};
  const alias =
    COMPANY_BRANCH_PAYMENT_PROFILE_ALIASES[
      normalizeCompanyLegalEntityName(corporationName)
    ] || null;
  const definitions = [
    {
      field: "linkPaymentProfileId",
      label: "문자링크 결제",
      options: LINK_PAYMENT_PROFILE_OPTIONS,
    },
    {
      field: "keyinPaymentProfileId",
      label: "키인결제",
      options: KEYIN_PAYMENT_PROFILE_OPTIONS,
    },
    {
      field: "autopayProfileId",
      label: "등록카드 결제",
      options: AUTOPAY_PROFILE_OPTIONS,
    },
  ];
  const resolved = {};
  const errors = [];
  definitions.forEach(({ field, label, options }) => {
    const requestedId = String(sourcePg[field] || row[field] || "")
      .trim()
      .toUpperCase();
    const allowed = options.some((option) => option.value === requestedId);
    if (requestedId && !allowed) {
      errors.push(`${label} 프로필이 올바르지 않습니다.`);
      resolved[field] = "";
      return;
    }
    const inferredId = alias?.[field] || "";
    if (requestedId && inferredId && requestedId !== inferredId) {
      errors.push(`${label} 프로필과 사업장 법인이 일치하지 않습니다.`);
      resolved[field] = "";
      return;
    }
    resolved[field] = requestedId || inferredId;
  });
  const linkProfile = LINK_PAYMENT_PROFILE_OPTIONS.find(
    (profile) => profile.value === resolved.linkPaymentProfileId
  );
  const keyinProfile = KEYIN_PAYMENT_PROFILE_OPTIONS.find(
    (profile) => profile.value === resolved.keyinPaymentProfileId
  );
  const autopayProfile = AUTOPAY_PROFILE_OPTIONS.find(
    (profile) => profile.value === resolved.autopayProfileId
  );
  return {
    ...resolved,
    paymentCompanyName:
      linkProfile?.label || keyinProfile?.label || autopayProfile?.label || "",
    linkSiteCdMasked: linkProfile?.siteCd
      ? `${linkProfile.siteCd.slice(0, 3)}**`
      : "",
    keyinSiteCdMasked: keyinProfile?.siteCd
      ? `${keyinProfile.siteCd.slice(0, 3)}**`
      : "",
    profileMappingSource: alias ? "LEGAL_ENTITY_ALIAS" : "ADMIN_SELECTED",
    errors,
  };
};

export const DEFAULT_PAYMENT_ITEM_NAME = "물품대금";

export const createEmptyPaymentRequestForm = () => ({
  requestType: "BUYLINK",
  vendorId: "",
  paymentProfileId: "CNFOOD_LINK",
  keyinProfileId: "CNFOOD_KEYIN",
  autopayProfileId: "CNFOOD_AUTOPAY",
  identityType: "BUSINESS",
  amount: "",
  itemName: DEFAULT_PAYMENT_ITEM_NAME,
  customerName: "",
  buyerPhone: "",
  buyerEmail: "",
  keyinConfirmation: "",
  quota: "00",
  cardLabel: "",
  cardLast4: "",
  memo: "",
});

export const applyPaymentVendorToRequestForm = (form = {}, vendor = {}) => {
  const isBuylink = form.requestType === "BUYLINK";
  return {
    ...form,
    vendorId: vendor.vendorId || "",
    customerName: vendor.businessName || "",
    buyerPhone: isBuylink
      ? String(vendor.contactPhone || "").replace(/\D/g, "").slice(0, 11)
      : form.buyerPhone || "",
    buyerEmail: isBuylink
      ? String(vendor.contactEmail || "").trim().toLowerCase().slice(0, 100)
      : form.buyerEmail || "",
    itemName: String(form.itemName || "").trim()
      ? form.itemName
      : DEFAULT_PAYMENT_ITEM_NAME,
    paymentProfileId:
      vendor.linkPaymentProfileId || form.paymentProfileId,
    keyinProfileId:
      vendor.keyinPaymentProfileId || form.keyinProfileId,
    autopayProfileId: vendor.autopayProfileId || form.autopayProfileId,
  };
};

const normalizePaymentVendorLookupValue = (value = "") =>
  String(value || "")
    .normalize("NFKC")
    .toLocaleLowerCase("ko-KR")
    .replace(/[\[\]]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

export const PAYMENT_VENDOR_SERVER_SEARCH_MIN_LENGTH = 2;
export const PAYMENT_VENDOR_SERVER_SEARCH_LIMIT = 200;

type PaymentVendorDirectoryRecord = {
  vendorId: string;
  vendorCode?: string;
  businessName?: string;
  partName?: string;
  representativeName?: string;
  salesManagerName?: string;
  companyBranchName?: string;
  status?: string;
  contactPhone?: string;
  contactEmail?: string;
  companyBranchResolved?: boolean;
  companyBranchActive?: boolean;
  linkPaymentProfileId?: string;
  keyinPaymentProfileId?: string;
  autopayProfileId?: string;
  paymentCompanyName?: string;
  [key: string]: unknown;
};

type PaymentDirectoryPaginationState = {
  nextCursor: string;
  returnedCount: number;
  totalCount: number;
  collectionTotalCount: number;
  hasMore: boolean;
  query: string;
  scopeDiagnostics: Record<string, unknown>;
};

type PaymentDirectoryState = {
  vendors: PaymentVendorDirectoryRecord[];
  pagination: PaymentDirectoryPaginationState;
};

type PaymentDirectoryRequestContext = {
  requestId: number;
  query: string;
  cursor: string;
  requestType?: string;
};

export const normalizePaymentVendorRequestQuery = (value = "") =>
  String(value || "").trim();

export const createPaymentDirectoryState = (
  collectionTotalCount = 0
): PaymentDirectoryState => ({
  vendors: [],
  pagination: {
    nextCursor: "",
    returnedCount: 0,
    totalCount: 0,
    collectionTotalCount: Math.max(Number(collectionTotalCount) || 0, 0),
    hasMore: false,
    query: "",
    scopeDiagnostics: {},
  },
});

export const getPaymentVendorCanonicalSearchKind = (value = "") => {
  const raw = String(value || "").trim();
  const normalized = normalizePaymentVendorLookupValue(raw);
  const digits = raw.replace(/\D/g, "");
  const numericLookup = /^[\d\s-]+$/.test(raw);
  if (/^\d{6}$/.test(raw)) return "VENDOR_CODE";
  if (numericLookup && digits.length === 10) return "BUSINESS_NUMBER";
  if (
    normalized.length >= PAYMENT_VENDOR_SERVER_SEARCH_MIN_LENGTH &&
    !numericLookup
  ) {
    return "BUSINESS_NAME";
  }
  return "NONE";
};

export const shouldLoadPaymentVendorCanonicalSearch = (value = "") =>
  getPaymentVendorCanonicalSearchKind(value) !== "NONE";

export const shouldSchedulePaymentVendorCanonicalSearch = (
  value = "",
  isComposing = false
) => !isComposing && shouldLoadPaymentVendorCanonicalSearch(value);

export const buildPaymentDirectoryListRequestPayload = ({
  vendorQuery = "",
  cursor = "",
  requestType = "",
} = {}) => {
  const normalizedQuery = normalizePaymentVendorRequestQuery(vendorQuery);
  return {
    pageSize: normalizedQuery ? PAYMENT_VENDOR_SERVER_SEARCH_LIMIT : 100,
    cursor: String(cursor || "").trim(),
    vendorQuery: normalizedQuery,
    ...(requestType ? { requestType } : {}),
  };
};

export const shouldApplyPaymentDirectoryResponse = ({
  requestId = 0,
  latestRequestId = 0,
  requestQuery = "",
  latestRequestQuery = "",
  currentInputQuery = "",
  requestCursor = "",
  latestRequestCursor = "",
  requestType = "",
  latestRequestType = "",
  currentRequestType = "",
} = {}) =>
  requestId === latestRequestId &&
  requestType === latestRequestType &&
  requestType === currentRequestType &&
  normalizePaymentVendorRequestQuery(requestQuery) ===
    normalizePaymentVendorRequestQuery(latestRequestQuery) &&
  normalizePaymentVendorRequestQuery(requestQuery) ===
    normalizePaymentVendorRequestQuery(currentInputQuery) &&
  String(requestCursor || "") === String(latestRequestCursor || "");

export const buildPaymentDirectoryState = (
  previous: PaymentDirectoryState,
  result = {},
  { append = false, query = "" } = {}
): PaymentDirectoryState => {
  const normalizedQuery = normalizePaymentVendorRequestQuery(query);
  const responseVendors = Array.isArray(result.vendors)
    ? (result.vendors as PaymentVendorDirectoryRecord[])
    : [];
  const canAppend =
    append && previous.pagination.query === normalizedQuery;
  const merged = canAppend
    ? [...previous.vendors, ...responseVendors]
    : [...responseVendors];
  const vendors = Array.from(
    new Map(
      merged
        .filter((vendor) => String(vendor?.vendorId || "").trim())
        .map((vendor) => [vendor.vendorId, vendor])
    ).values()
  );
  const nextCursor = String(result.nextCursor || "").trim();
  return {
    vendors,
    pagination: {
      nextCursor,
      returnedCount: Math.max(
        Number(result.returnedCount ?? responseVendors.length) || 0,
        0
      ),
      totalCount: Math.max(Number(result.totalCount || 0), 0),
      collectionTotalCount: Math.max(
        Number(
          result.collectionTotalCount ??
            previous.pagination.collectionTotalCount
        ) || 0,
        0
      ),
      hasMore: result.hasMore === true && Boolean(nextCursor),
      query: normalizedQuery,
      scopeDiagnostics:
        result.scopeDiagnostics && typeof result.scopeDiagnostics === "object"
          ? result.scopeDiagnostics
          : {},
    },
  };
};

export const getPaymentVendorDirectoryDisplayOptions = (
  vendors = [],
  search = "",
  loadedQuery = ""
) => {
  const currentQuery = String(search || "").trim();
  if (currentQuery !== String(loadedQuery || "").trim()) return [];
  return Array.isArray(vendors) ? vendors : [];
};

export const shouldShowPaymentDirectoryLoadMore = ({
  pagination = createPaymentDirectoryState().pagination,
  currentQuery = "",
  resultCount = 0,
  loading = false,
} = {}) =>
  !loading &&
  Number(resultCount) > 0 &&
  pagination.hasMore === true &&
  Boolean(String(pagination.nextCursor || "").trim()) &&
  normalizePaymentVendorRequestQuery(pagination.query) ===
    normalizePaymentVendorRequestQuery(currentQuery);

export const isPaymentDirectorySearchPending = ({
  pagination = createPaymentDirectoryState().pagination,
  currentQuery = "",
  loading = false,
} = {}) => {
  const normalizedQuery = normalizePaymentVendorRequestQuery(currentQuery);
  return Boolean(
    normalizedQuery &&
      (loading ||
        normalizePaymentVendorRequestQuery(pagination.query) !== normalizedQuery)
  );
};

export const getPaymentDirectoryResultMessage = ({
  pagination = createPaymentDirectoryState().pagination,
  currentQuery = "",
  resultCount = 0,
  loading = false,
  requestType = "",
} = {}) => {
  const normalizedQuery = normalizePaymentVendorRequestQuery(currentQuery);
  const vendorLabel = requestType === "BUYLINK" ? "수금 가능 거래처" : "활성 거래처";
  if (isPaymentDirectorySearchPending({ pagination, currentQuery, loading })) {
    return "거래처를 검색하는 중입니다.";
  }
  if (normalizedQuery && Number(pagination.totalCount) === 0) {
    return `검색어와 일치하는 ${vendorLabel}가 없습니다.`;
  }
  if (normalizedQuery) {
    return `검색 결과 ${Number(pagination.totalCount) || 0}건 / ${vendorLabel} ${
      Number(pagination.collectionTotalCount) || 0
    }건`;
  }
  return `불러온 결과 ${Number(resultCount) || 0}건 / ${vendorLabel} ${
    Number(pagination.collectionTotalCount) || 0
  }건`;
};

export const buildPaymentVendorLookupLabel = (vendor = {}) => {
  if (!vendor?.vendorId) return "";
  const vendorCode = normalizeVendorCode(vendor.vendorCode) || "코드미연결";
  return `[${vendorCode}] ${String(vendor.businessName || "거래처명 미입력").trim()}`;
};

export const filterPaymentVendorOptionsForLookup = (
  vendors = [],
  search = ""
) => {
  const tokens = normalizePaymentVendorLookupValue(search)
    .split(/\s+/)
    .filter(Boolean);
  if (tokens.length === 0) return Array.isArray(vendors) ? [...vendors] : [];
  return (Array.isArray(vendors) ? vendors : [])
    .filter((vendor) => {
      const searchText = [
        vendor?.vendorCode,
        vendor?.businessName,
        vendor?.partName,
        vendor?.representativeName,
        vendor?.salesManagerName,
        vendor?.businessNumber,
      ]
        .map(normalizePaymentVendorLookupValue)
        .join(" ");
      return tokens.every((token) => searchText.includes(token));
    });
};

export const getPaymentDirectoryErrorMessage = (error = {}) => {
  const code = String(error?.code || "").trim().toLowerCase();
  if (["permission-denied", "permission_denied"].includes(code)) {
    return "결제 거래처를 조회할 권한이 없습니다. 관리자 권한을 확인해 주세요.";
  }
  if (["failed-precondition", "failed_precondition"].includes(code)) {
    return "결제 거래처 조회에 필요한 Firestore 설정 또는 인덱스가 준비되지 않았습니다.";
  }
  return error?.message || "결제 거래처와 등록카드를 불러오지 못했습니다.";
};

export const getPaymentDirectoryDiagnosticMessage = (diagnostics = {}) => {
  if (
    Number(diagnostics.inactiveCount) > 0 &&
    Number(diagnostics.activeCanonicalCount) === 0 &&
    !(Number(diagnostics.visibleCount) > 0)
  ) {
    return "일치하는 거래처는 비활성 상태입니다. 본사 거래처 관리에서 상태를 확인해 주세요.";
  }
  if (Number(diagnostics.unassignedCount) > 0) {
    return `담당자 미배정 거래처 ${Number(
      diagnostics.unassignedCount
    )}건은 영업 계정의 검색 결과에서 제외됩니다. 본사 결제관리자에서는 조회할 수 있습니다.`;
  }
  if (Number(diagnostics.outsideRoleCount) > 0 && Number(diagnostics.visibleCount) === 0) {
    return "일치하는 거래처가 있지만 현재 로그인 담당자의 조회 범위 밖입니다.";
  }
  if (Number(diagnostics.branchMismatchCount) > 0) {
    return "일부 거래처의 법인·사업장 연결을 확인해 주세요.";
  }
  if (Number(diagnostics.paymentProfileMissingCount) > 0) {
    return "일부 거래처의 결제 프로필이 연결되지 않았습니다.";
  }
  if (Number(diagnostics.matchedCanonicalCount) === 0) {
    return "canonical 거래처에 일치하는 결과가 없습니다.";
  }
  return "";
};

const normalizePaymentRuntimeEnvironment = (value = "") => {
  const normalized = String(value || "").trim().toLowerCase();
  if (["prod", "production", "live"].includes(normalized)) return "production";
  if (["test", "sandbox", "staging", "preview"].includes(normalized)) return "test";
  return "";
};

export const getPaymentOperationEnvironmentBlockMessage = (
  storedEnvironment = "",
  runtimeEnvironment = ""
) => {
  const stored = normalizePaymentRuntimeEnvironment(storedEnvironment);
  const runtime = normalizePaymentRuntimeEnvironment(runtimeEnvironment);
  if (!stored || !runtime || stored === runtime) return "";
  if (stored === "test" && runtime === "production") {
    return "Sandbox 테스트 거래입니다. Production 인증정보로 조회·취소할 수 없습니다.";
  }
  return "승인 당시 KCP 환경과 현재 실행 환경이 달라 조회·취소할 수 없습니다.";
};

export const isAutopayMethodReadyForCharge = (method = {}) =>
  method.status === "ACTIVE" &&
  method.providerRegistrationVerified === true &&
  method.operatorConfirmed === true;

export const groupAutopayMethodsByVendor = (methods = []) => {
  const groups = new Map();
  methods.forEach((method) => {
    if (!method?.billingMethodId || method.status === "DELETED") return;
    const vendorId = String(method.vendorId || "unlinked");
    if (!groups.has(vendorId)) {
      groups.set(vendorId, {
        vendorId,
        businessName: method.vendorBusinessName || method.customerName || "미연결 거래처",
        businessNumber: method.vendorBusinessNumber || "",
        methods: [],
      });
    }
    groups.get(vendorId).methods.push(method);
  });
  return Array.from(groups.values())
    .map((group) => ({
      ...group,
      methods: group.methods.sort((a, b) => {
        if (a.isPrimary !== b.isPrimary) return a.isPrimary ? -1 : 1;
        return String(b.createdAt || "").localeCompare(String(a.createdAt || ""));
      }),
    }))
    .sort((a, b) =>
      String(a.businessName).localeCompare(String(b.businessName), "ko")
    );
};

export const buildPaymentLinkMessage = buildPaymentLinkMessageImpl;
export const buildPaymentCopyPreview = buildPaymentCopyPreviewImpl;

export const buildAutopayRegistrationMessage = (registration = {}) => {
  const registrationUrl = String(registration.registrationUrl || "").trim();
  if (!registrationUrl) return "";
  const customerName = String(registration.customerName || "").trim();
  const greeting = customerName ? `${customerName}님, ` : "";
  return `[CNFOOD] ${greeting}공급대금 결제용 카드등록 링크입니다. 모바일에서 열어 카드사진을 보내지 말고 KCP 보안 화면에 직접 등록해 주세요. 카드 등록 단계에서는 결제되지 않습니다.\n${registrationUrl}`;
};

export const createEmptySensitiveCardInput = () => ({
  cardNumber: "",
  cardExpiry: "",
  cardTaxNo: "",
  cardPassword: "",
});

export const formatPaymentCardNumberInput = (value = "") =>
  String(value || "")
    .replace(/\D/g, "")
    .slice(0, 19)
    .replace(/(.{4})/g, "$1 ")
    .trim();

export const formatPaymentCardExpiryInput = (value = "") => {
  const digits = String(value || "").replace(/\D/g, "").slice(0, 4);
  return digits.length > 2 ? `${digits.slice(0, 2)}/${digits.slice(2)}` : digits;
};

export const PAYMENT_BATCH_MAX_SIZE = 100;
export const PAYMENT_BATCH_TEMPLATE_HEADERS = [
  "외부요청번호",
  "고객명",
  "결제금액",
  "결제내용",
  "메모",
];

const PAYMENT_BATCH_HEADER_ALIASES = {
  externalRequestId: ["외부요청번호", "요청번호", "externalrequestid"],
  customerName: ["고객명", "customername"],
  amount: ["결제금액", "금액", "amount"],
  itemName: ["결제내용", "상품명", "itemname"],
  memo: ["메모", "memo"],
};

const FORBIDDEN_PAYMENT_BATCH_HEADERS = new Set([
  "card",
  "cardno",
  "cardnumber",
  "pan",
  "cvc",
  "cvv",
  "cid",
  "expiry",
  "expirydate",
  "exp",
  "password",
  "phone",
  "mobile",
  "rrn",
  "ssn",
  "카드",
  "카드번호",
  "유효기간",
  "만료일",
  "비밀번호",
  "주민등록번호",
  "주민번호",
  "휴대폰",
  "휴대폰번호",
  "전화번호",
]);

export const normalizePaymentBatchHeader = (value = "") =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[\s_.\-()/]/g, "");

const pickPaymentBatchCell = (row = {}, aliases = []) => {
  const normalizedAliases = new Set(aliases.map(normalizePaymentBatchHeader));
  const entry = Object.entries(row || {}).find(([key]) =>
    normalizedAliases.has(normalizePaymentBatchHeader(key))
  );
  return entry ? entry[1] : "";
};

export const containsPotentialPaymentBatchAccountNumber = (value = "") => {
  const candidates = String(value || "").match(/\d[\d\s-]{11,25}\d/g) || [];
  return candidates.some((candidate) => {
    const digits = candidate.replace(/\D/g, "");
    return digits.length >= 13 && digits.length <= 19;
  });
};

export const buildPaymentBatchImportPreview = (rawRows = []) => {
  const rows = Array.isArray(rawRows) ? rawRows : [];
  const headers = Array.from(new Set(rows.flatMap((row) => Object.keys(row || {}))));
  const forbiddenHeaders = headers.filter((header) =>
    FORBIDDEN_PAYMENT_BATCH_HEADERS.has(normalizePaymentBatchHeader(header))
  );
  const errors: Array<{ rowNumber: number; message: string }> = [];
  const safeRows = [];
  const previewRows = [];
  const seenExternalRequestIds = new Set<string>();

  if (rows.length === 0) {
    errors.push({ rowNumber: 0, message: "엑셀에 등록할 행이 없습니다." });
  }
  if (rows.length > PAYMENT_BATCH_MAX_SIZE) {
    errors.push({
      rowNumber: 0,
      message: `한 번에 최대 ${PAYMENT_BATCH_MAX_SIZE}건까지 등록할 수 있습니다.`,
    });
  }
  if (forbiddenHeaders.length > 0) {
    errors.push({
      rowNumber: 1,
      message: `민감정보 열은 업로드할 수 없습니다: ${forbiddenHeaders.join(", ")}`,
    });
  }

  rows.forEach((row, index) => {
    const rowNumber = index + 2;
    const externalRequestId = String(
      pickPaymentBatchCell(row, PAYMENT_BATCH_HEADER_ALIASES.externalRequestId) || ""
    )
      .trim()
      .slice(0, 80);
    const customerName = String(
      pickPaymentBatchCell(row, PAYMENT_BATCH_HEADER_ALIASES.customerName) || ""
    )
      .trim()
      .slice(0, 50);
    const amount = Number(
      String(pickPaymentBatchCell(row, PAYMENT_BATCH_HEADER_ALIASES.amount) ?? "").replace(
        /,/g,
        ""
      )
    );
    const itemName = String(
      pickPaymentBatchCell(row, PAYMENT_BATCH_HEADER_ALIASES.itemName) || ""
    )
      .trim()
      .slice(0, 100);
    const memo = String(pickPaymentBatchCell(row, PAYMENT_BATCH_HEADER_ALIASES.memo) || "")
      .trim()
      .slice(0, 300);
    const rowMessages = [];

    if (Object.values(row || {}).some(containsPotentialPaymentBatchAccountNumber)) {
      rowMessages.push("카드번호 또는 주민등록번호로 보이는 13~19자리 값이 있습니다.");
    }
    if (!Number.isSafeInteger(amount) || amount <= 0) {
      rowMessages.push("결제금액은 1원 이상의 정수여야 합니다.");
    }
    if (!itemName) rowMessages.push("결제내용은 필수입니다.");
    if (externalRequestId) {
      if (seenExternalRequestIds.has(externalRequestId)) {
        rowMessages.push("외부요청번호가 중복되었습니다.");
      } else {
        seenExternalRequestIds.add(externalRequestId);
      }
    }

    const normalized = { externalRequestId, customerName, amount, itemName, memo };
    previewRows.push({ ...normalized, rowNumber, valid: rowMessages.length === 0 });
    if (rowMessages.length > 0) {
      errors.push({ rowNumber, message: rowMessages.join(" ") });
    } else {
      safeRows.push(normalized);
    }
  });

  return {
    totalRows: rows.length,
    headers,
    forbiddenHeaders,
    errors,
    rows: safeRows,
    previewRows,
    canImport:
      rows.length > 0 &&
      rows.length <= PAYMENT_BATCH_MAX_SIZE &&
      errors.length === 0 &&
      safeRows.length === rows.length,
  };
};

export const getDefaultPaymentHistoryRange = (now = new Date()) => {
  const local = new Date(now);
  const toDate = new Date(local.getFullYear(), local.getMonth(), local.getDate());
  const fromDate = new Date(local.getFullYear(), local.getMonth(), 1);
  const format = (date) =>
    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
      date.getDate()
    ).padStart(2, "0")}`;
  return {
    dateFrom: format(fromDate),
    dateTo: format(toDate),
    requestType: "ALL",
    status: "ALL",
    query: "",
    paymentCompany: "ALL",
    createdBy: "ALL",
    environment: "ALL",
    sort: "NEWEST",
  };
};

export const normalizePaymentHistoryDate = (value: unknown = "") => {
  let dateValue = value;
  if (dateValue && typeof dateValue === "object") {
    const timestampLike = dateValue as { toDate?: () => unknown };
    if (typeof timestampLike.toDate === "function") {
      try {
        dateValue = timestampLike.toDate();
      } catch {
        return "";
      }
    }
  }
  if (dateValue instanceof Date) {
    const timestamp = dateValue.getTime();
    return Number.isFinite(timestamp)
      ? new Date(timestamp + 9 * 60 * 60 * 1000).toISOString().slice(0, 10)
      : "";
  }
  if (typeof dateValue === "number") {
    const milliseconds =
      Math.abs(dateValue) < 1_000_000_000_000 ? dateValue * 1000 : dateValue;
    return Number.isFinite(milliseconds)
      ? new Date(milliseconds + 9 * 60 * 60 * 1000).toISOString().slice(0, 10)
      : "";
  }
  const timestampText = String(dateValue || "").trim();
  const kcpTimestamp = /^(\d{4})(\d{2})(\d{2})\d{0,6}$/.exec(timestampText);
  if (kcpTimestamp) {
    const [, year, month, day] = kcpTimestamp;
    if (
      Number(month) >= 1 &&
      Number(month) <= 12 &&
      Number(day) >= 1 &&
      Number(day) <= 31
    ) {
      const parsedCalendarDate = new Date(`${year}-${month}-${day}T00:00:00Z`);
      if (
        parsedCalendarDate.getUTCFullYear() === Number(year) &&
        parsedCalendarDate.getUTCMonth() + 1 === Number(month) &&
        parsedCalendarDate.getUTCDate() === Number(day)
      ) {
        return `${year}-${month}-${day}`;
      }
    }
  }
  const calendarPrefix = /^(\d{4})-(\d{2})-(\d{2})(?:$|T)/.exec(timestampText);
  if (calendarPrefix) {
    const [, year, month, day] = calendarPrefix;
    const parsedCalendarDate = new Date(`${year}-${month}-${day}T00:00:00Z`);
    if (
      parsedCalendarDate.getUTCFullYear() !== Number(year) ||
      parsedCalendarDate.getUTCMonth() + 1 !== Number(month) ||
      parsedCalendarDate.getUTCDate() !== Number(day)
    ) {
      return "";
    }
    if (timestampText.length === 10) return timestampText;
  }
  const timestamp = Date.parse(timestampText);
  return Number.isFinite(timestamp)
    ? new Date(timestamp + 9 * 60 * 60 * 1000).toISOString().slice(0, 10)
    : "";
};

export const filterPaymentRequestsByPeriod = (requests = [], filters = {}) => {
  const dateFrom = /^\d{4}-\d{2}-\d{2}$/.test(String(filters.dateFrom || ""))
    ? String(filters.dateFrom)
    : "";
  const dateTo = /^\d{4}-\d{2}-\d{2}$/.test(String(filters.dateTo || ""))
    ? String(filters.dateTo)
    : "";
  const requestType = String(filters.requestType || "ALL").toUpperCase();
  const operationsStatus = String(filters.status || "ALL").toUpperCase();
  const query = String(filters.query || "").trim().toLocaleLowerCase("ko-KR");
  const paymentCompany = String(filters.paymentCompany || "ALL");
  const createdBy = String(filters.createdBy || "ALL");
  const environment = String(filters.environment || "ALL").toLowerCase();
  const sort = String(filters.sort || "NEWEST").toUpperCase();
  const filtered = (Array.isArray(requests) ? requests : []).filter((request) => {
    const createdDate = normalizePaymentHistoryDate(
      request.approvedAt || request.paidAt || request.createdAt || ""
    );
    if (dateFrom && createdDate && createdDate < dateFrom) return false;
    if (dateTo && createdDate && createdDate > dateTo) return false;
    if (requestType !== "ALL" && request.requestType !== requestType) return false;
    if (
      operationsStatus !== "ALL" &&
      getPaymentOperationsStatus(request).value !== operationsStatus
    ) {
      return false;
    }
    if (
      paymentCompany !== "ALL" &&
      String(request.paymentCompanyName || "") !== paymentCompany
    ) {
      return false;
    }
    if (createdBy !== "ALL" && String(request.createdBy || "") !== createdBy) {
      return false;
    }
    if (
      environment !== "all" &&
      String(request.environment || "").toLowerCase() !== environment
    ) {
      return false;
    }
    if (query) {
      const searchableText = [
        request.vendorCode,
        request.vendorErpSiteCode,
        request.vendorErpSiteName,
        request.vendorBusinessName,
        request.vendorBusinessNumber,
        request.vendorCompanyBranchName,
        request.customerName,
        request.itemName,
        request.memo,
        request.createdBy,
        request.paymentCompanyName,
        request.paymentSiteCd,
        request.externalRequestId,
        request.approvalCode,
        request.transactionId,
      ]
        .filter(Boolean)
        .join(" ")
        .toLocaleLowerCase("ko-KR");
      const compactQuery = query.replace(/[^0-9a-z가-힣]/gi, "");
      const compactSearchableText = searchableText.replace(/[^0-9a-z가-힣]/gi, "");
      if (
        !searchableText.includes(query) &&
        (!compactQuery || !compactSearchableText.includes(compactQuery))
      ) {
        return false;
      }
    }
    return true;
  });
  const getSortNumber = (request) => {
    const value = String(
      request.approvedAt || request.paidAt || request.createdAt || ""
    ).trim();
    const kcpTimestamp = /^(\d{4})(\d{2})(\d{2})(\d{2})?(\d{2})?(\d{2})?$/.exec(
      value
    );
    if (kcpTimestamp) {
      const [, year, month, day, hour = "00", minute = "00", second = "00"] =
        kcpTimestamp;
      const timestamp = Date.parse(
        `${year}-${month}-${day}T${hour}:${minute}:${second}+09:00`
      );
      if (Number.isFinite(timestamp)) return timestamp;
    }
    const timestamp = Date.parse(value);
    return Number.isFinite(timestamp) ? timestamp : 0;
  };
  return filtered.sort((left, right) => {
    if (sort === "OLDEST") return getSortNumber(left) - getSortNumber(right);
    if (sort === "AMOUNT_DESC") {
      return (Number(right.amount) || 0) - (Number(left.amount) || 0);
    }
    if (sort === "AMOUNT_ASC") {
      return (Number(left.amount) || 0) - (Number(right.amount) || 0);
    }
    return getSortNumber(right) - getSortNumber(left);
  });
};

export const PAYMENT_OPERATIONS_STATUS_OPTIONS = Object.freeze([
  {
    value: "WAITING_CUSTOMER",
    label: "링크 발급·미승인",
    shortLabel: "미승인",
    description: "거래처 결제를 기다리는 링크입니다.",
    nextAction: "거래처에 링크를 다시 안내하거나 승인결과를 확인하세요.",
    badgeClassName: "bg-blue-100 text-blue-800",
  },
  {
    value: "APPROVED",
    label: "승인 완료",
    shortLabel: "승인",
    description: "KCP 승인번호와 거래번호가 확인된 결제입니다.",
    nextAction: "입금 처리 또는 ERP 반영 여부를 확인하세요.",
    badgeClassName: "bg-emerald-100 text-emerald-800",
  },
  {
    value: "PARTIALLY_CANCELED",
    label: "부분취소",
    shortLabel: "부분취소",
    description: "승인금액 일부가 취소되고 잔액이 남은 결제입니다.",
    nextAction: "취소 누계와 승인 잔액을 확인하세요.",
    badgeClassName: "bg-amber-100 text-amber-900",
  },
  {
    value: "CANCELED",
    label: "취소 완료",
    shortLabel: "취소",
    description: "승인 잔액이 모두 취소된 결제입니다.",
    nextAction: "카드사 반영과 ERP 취소 처리를 확인하세요.",
    badgeClassName: "bg-slate-200 text-slate-800",
  },
  {
    value: "FAILED",
    label: "처리 실패",
    shortLabel: "실패",
    description: "승인 또는 외부 처리 중 오류가 발생했습니다.",
    nextAction: "오류코드와 거래상태를 확인한 뒤 재처리 여부를 판단하세요.",
    badgeClassName: "bg-red-100 text-red-800",
  },
  {
    value: "DRAFT",
    label: "초안·생성대기",
    shortLabel: "초안",
    description: "아직 거래처에 전달할 결제 링크가 준비되지 않았습니다.",
    nextAction: "설정과 거래처 정보를 확인한 뒤 결제 요청을 생성하세요.",
    badgeClassName: "bg-violet-100 text-violet-800",
  },
  {
    value: "PROCESSING",
    label: "확인 필요",
    shortLabel: "확인",
    description: "외부 처리 또는 상태 동기화 확인이 필요한 결제입니다.",
    nextAction: "거래조회 또는 승인결과 확인을 실행하세요.",
    badgeClassName: "bg-orange-100 text-orange-900",
  },
]);

const PAYMENT_OPERATIONS_STATUS_BY_VALUE = Object.freeze(
  Object.fromEntries(
    PAYMENT_OPERATIONS_STATUS_OPTIONS.map((option) => [option.value, option])
  )
);

export const getPaymentOperationsStatus = (request: any = {}) => {
  const status = String(request.status || "").toUpperCase();
  const approvalStatus = String(request.approvalStatus || "").toUpperCase();
  const executionStatus = String(request.executionStatus || "").toUpperCase();
  const remainingAmount = Number(request.remainingAmount ?? request.amount) || 0;
  const cancelledAmount = Number(request.cancelledAmount) || 0;

  if (
    status === "CANCELED" ||
    (cancelledAmount > 0 && remainingAmount <= 0)
  ) {
    return PAYMENT_OPERATIONS_STATUS_BY_VALUE.CANCELED;
  }
  if (status === "PARTIALLY_CANCELED" || cancelledAmount > 0) {
    return PAYMENT_OPERATIONS_STATUS_BY_VALUE.PARTIALLY_CANCELED;
  }
  if (
    [status, approvalStatus, executionStatus].some((value) =>
      /PROCESSING|APPROVING|REGISTERING|DELETING|RECONCILIATION_REQUIRED|REVIEW_REQUIRED/.test(
        value
      )
    )
  ) {
    return PAYMENT_OPERATIONS_STATUS_BY_VALUE.PROCESSING;
  }
  if (
    [status, approvalStatus, executionStatus].some((value) =>
      /FAILED|ERROR|REJECTED/.test(value)
    ) ||
    request.errorCode ||
    request.errorMessage
  ) {
    return PAYMENT_OPERATIONS_STATUS_BY_VALUE.FAILED;
  }
  if (
    status === "APPROVED" ||
    approvalStatus === "APPROVED" ||
    String(request.transactionId || "").trim()
  ) {
    return PAYMENT_OPERATIONS_STATUS_BY_VALUE.APPROVED;
  }
  if (
    ["STANDARD_READY", "LINK_READY"].includes(status) ||
    approvalStatus === "WAITING_CUSTOMER" ||
    (request.requestType === "BUYLINK" && request.paymentUrl)
  ) {
    return PAYMENT_OPERATIONS_STATUS_BY_VALUE.WAITING_CUSTOMER;
  }
  if (
    ["DRAFT", "QUEUED", "NOT_STARTED", "PREFLIGHT_VALIDATED"].includes(status) ||
    (!status && !approvalStatus)
  ) {
    return PAYMENT_OPERATIONS_STATUS_BY_VALUE.DRAFT;
  }
  return PAYMENT_OPERATIONS_STATUS_BY_VALUE.PROCESSING;
};

export const buildPaymentOperationsSummary = (requests = []) => {
  const summary = {
    totalCount: 0,
    approvedGrossAmount: 0,
    cancelledAmount: 0,
    remainingAmount: 0,
    byStatus: Object.fromEntries(
      PAYMENT_OPERATIONS_STATUS_OPTIONS.map((option) => [option.value, 0])
    ),
  };
  (Array.isArray(requests) ? requests : []).forEach((request) => {
    const status = getPaymentOperationsStatus(request).value;
    const amount = Number(request.amount) || 0;
    const cancelledAmount = Number(request.cancelledAmount) || 0;
    const remainingAmount = Number(request.remainingAmount ?? amount) || 0;
    summary.totalCount += 1;
    summary.byStatus[status] = (summary.byStatus[status] || 0) + 1;
    if (["APPROVED", "PARTIALLY_CANCELED", "CANCELED"].includes(status)) {
      summary.approvedGrossAmount += amount;
      summary.cancelledAmount += cancelledAmount;
      summary.remainingAmount += remainingAmount;
    }
  });
  return summary;
};

export const getPaymentHistoryFilterOptions = (requests = []) => {
  const uniqueSorted = (values) =>
    [...new Set(values.map((value) => String(value || "").trim()).filter(Boolean))].sort(
      (left, right) => left.localeCompare(right, "ko-KR")
    );
  const safeRequests = Array.isArray(requests) ? requests : [];
  return {
    paymentCompanies: uniqueSorted(
      safeRequests.map((request) => request.paymentCompanyName)
    ),
    createdBy: uniqueSorted(safeRequests.map((request) => request.createdBy)),
  };
};

export const buildPaymentOperatorStatusMessage = (request: any = {}) => {
  const status = getPaymentOperationsStatus(request);
  const amount = Number(request.amount) || 0;
  const cancelledAmount = Number(request.cancelledAmount) || 0;
  const remainingAmount = Number(request.remainingAmount ?? amount) || 0;
  return [
    "[결제 상태 안내]",
    `거래처: ${request.vendorBusinessName || request.customerName || "미연결"}`,
    request.vendorCode ? `ERP 거래처코드: ${request.vendorCode}` : "",
    `결제내용: ${request.itemName || "미입력"}`,
    `요청금액: ${amount.toLocaleString("ko-KR")}원`,
    `현재상태: ${status.label}`,
    ["APPROVED", "PARTIALLY_CANCELED", "CANCELED"].includes(status.value)
      ? `승인잔액: ${remainingAmount.toLocaleString("ko-KR")}원`
      : "",
    cancelledAmount > 0
      ? `취소누계: ${cancelledAmount.toLocaleString("ko-KR")}원`
      : "",
    request.createdAt ? `요청일시: ${String(request.createdAt)}` : "",
    `다음 확인: ${status.nextAction}`,
  ]
    .filter(Boolean)
    .join("\n");
};

export const buildPaymentOperationsSummaryMessage = (
  requests = [],
  filters: any = {}
) => {
  const summary = buildPaymentOperationsSummary(requests);
  const count = (status) => summary.byStatus[status] || 0;
  return [
    "[결제 운영 현황]",
    `조회기간: ${filters.dateFrom || "전체"} ~ ${filters.dateTo || "전체"}`,
    `전체: ${summary.totalCount}건`,
    `링크 발급·미승인: ${count("WAITING_CUSTOMER")}건`,
    `승인 완료: ${count("APPROVED")}건`,
    `부분취소: ${count("PARTIALLY_CANCELED")}건`,
    `취소 완료: ${count("CANCELED")}건`,
    `처리 실패: ${count("FAILED")}건`,
    `초안·생성대기: ${count("DRAFT")}건`,
    `승인잔액 합계: ${summary.remainingAmount.toLocaleString("ko-KR")}원`,
    `취소누계 합계: ${summary.cancelledAmount.toLocaleString("ko-KR")}원`,
  ].join("\n");
};

export const getPaymentCancellationHistoryRows = (request: any = {}) =>
  (Array.isArray(request.cancellationHistory) ? [...request.cancellationHistory] : [])
    .reverse()
    .map((history, index) => ({
      id:
        String(history?.partialCancellationSequence || history?.completedAt || "").trim() ||
        `cancellation-${index + 1}`,
      kcpModType:
        history?.kcpModType === "STSC" || history?.kcpModType === "STPC"
          ? history.kcpModType
          : history?.effectiveType === "FULL"
          ? "STSC"
          : "STPC",
      cancelledAmount: Number(history?.cancelledAmount) || 0,
      remainingAmount: Number(history?.remainingAmount) || 0,
      responseCode: String(history?.responseCode || "").trim(),
      reason: String(history?.reason || "").trim(),
      completedAt: String(history?.completedAt || "").trim(),
      partialCancellationSequence: String(
        history?.partialCancellationSequence || ""
      ).trim(),
    }));

const KCP_TRANSACTION_STATUS_LABELS = Object.freeze({
  STSR: "승인",
  STSC: "승인취소",
  STPC: "부분취소",
  STMR: "매입요청",
  STMT: "매입청구",
  STMD: "매입취소요청",
  STJC: "매입취소청구",
  STJO: "매입취소완료",
  STJS: "매입취소실패",
  STMO: "취소정산완료",
  STCA: "취소접수",
  STCD: "취소대기",
  STPY: "부분취소청구완료",
});

export const getKcpTransactionStatusLabel = (statusCode = "") => {
  const normalizedCode = String(statusCode || "").trim().toUpperCase();
  if (!normalizedCode) return "-";
  const label = KCP_TRANSACTION_STATUS_LABELS[normalizedCode];
  return label ? `${label} (${normalizedCode})` : normalizedCode;
};

const parsePaymentOperationTimestamp = (value) => {
  const timestampText = String(value || "").trim();
  const kcpTimestamp = /^(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})$/.exec(
    timestampText
  );
  const timestamp = kcpTimestamp
    ? Date.parse(
        `${kcpTimestamp[1]}-${kcpTimestamp[2]}-${kcpTimestamp[3]}T${kcpTimestamp[4]}:${kcpTimestamp[5]}:${kcpTimestamp[6]}+09:00`
      )
    : Date.parse(timestampText);
  return Number.isFinite(timestamp) ? timestamp : null;
};

const formatPaymentElapsedDuration = (milliseconds) => {
  const elapsedMinutes = Math.max(0, Math.floor(milliseconds / 60_000));
  if (elapsedMinutes < 1) return "1분 이내";
  if (elapsedMinutes < 60) return `${elapsedMinutes}분`;
  const elapsedHours = Math.floor(elapsedMinutes / 60);
  const remainingMinutes = elapsedMinutes % 60;
  if (elapsedHours < 24) {
    return `${elapsedHours}시간${remainingMinutes ? ` ${remainingMinutes}분` : ""}`;
  }
  const elapsedDays = Math.floor(elapsedHours / 24);
  const remainingHours = elapsedHours % 24;
  return `${elapsedDays}일${remainingHours ? ` ${remainingHours}시간` : ""}`;
};

export const getPaymentCancellationTimingSummary = (
  request: any = {},
  now = new Date()
) => {
  const successfulCancellationTimestamps = getPaymentCancellationHistoryRows(request)
    .filter((history) => history.responseCode === "0000")
    .map((history) => parsePaymentOperationTimestamp(history.completedAt))
    .filter((timestamp): timestamp is number => timestamp !== null);
  const fallbackCancellationTimestamp =
    request.status === "CANCELED" || request.cancellationState === "COMPLETED"
      ? parsePaymentOperationTimestamp(request.lastCancellationAt)
      : null;
  const cancellationTimestamp = [
    ...successfulCancellationTimestamps,
    fallbackCancellationTimestamp,
  ]
    .filter((timestamp): timestamp is number => timestamp !== null)
    .sort((left, right) => right - left)[0];

  if (!Number.isFinite(cancellationTimestamp)) {
    return {
      approvalToCancellation: "",
      cancellationElapsed: "",
      issuerPostingGuidance: "",
    };
  }

  const approvalTimestamp = parsePaymentOperationTimestamp(
    request.approvedAt || request.paidAt || request.createdAt
  );
  const nowTimestamp = now instanceof Date ? now.getTime() : Date.parse(String(now || ""));
  return {
    approvalToCancellation:
      approvalTimestamp !== null && cancellationTimestamp >= approvalTimestamp
        ? `승인 후 ${formatPaymentElapsedDuration(
            cancellationTimestamp - approvalTimestamp
          )} 만에 KCP 취소 승인`
        : "KCP 취소 승인 완료",
    cancellationElapsed:
      Number.isFinite(nowTimestamp) && nowTimestamp >= cancellationTimestamp
        ? `KCP 취소 승인 후 ${formatPaymentElapsedDuration(
            nowTimestamp - cancellationTimestamp
          )} 경과`
        : "",
    issuerPostingGuidance:
      "카드사 앱·이용한도 반영은 취소전표 접수 시점에 따라 즉시 되지 않을 수 있습니다.",
  };
};

export const buildPaymentHistoryExportRows = (requests = []) =>
  (Array.isArray(requests) ? requests : []).map((request) => ({
    배치ID: request.batchId || "",
    순번: request.batchSequence || "",
    전체건수: request.batchTotal || "",
    외부요청번호: request.externalRequestId || "",
    결제요청ID: request.paymentRequestId || request.id || "",
    결제유형:
      request.requestType === "KEYIN"
        ? "키인결제"
        : request.requestType === "AUTOPAY"
        ? "키인결제(등록카드)"
        : "문자링크결제",
    등록카드ID: request.billingMethodId || "",
    결제법인: request.paymentCompanyName || "",
    KCP사이트코드: request.paymentSiteCd || request.paymentSiteCdMasked || "",
    거래처ID: request.vendorId || "",
    거래처코드: normalizeVendorCode(request.vendorCode),
    ERP사업장코드: request.vendorErpSiteCode || "",
    ERP관할사업장명: request.vendorErpSiteName || "",
    거래처사업자번호: request.vendorBusinessNumber || "",
    거래처상호명: request.vendorBusinessName || "",
    고객명: request.customerName || "",
    결제금액: Number(request.amount) || 0,
    결제내용: request.itemName || "",
    메모: request.memo || "",
    처리상태: request.status || "",
    승인상태: request.approvalStatus || "",
    링크전달상태: request.deliveryStatus || "",
    외부실행상태: request.executionStatus || "LOCKED",
    시도횟수: Number(request.attemptCount) || 0,
    승인번호: request.approvalCode || "",
    거래번호: request.transactionId || "",
    카드사: request.approvalCardName || "",
    카드번호마스킹: request.approvalCardNumberMasked || "",
    할부개월: request.approvalQuota || "",
    취소누계금액: Number(request.cancelledAmount) || 0,
    취소후잔액: Number(request.remainingAmount ?? request.amount) || 0,
    취소상태: request.cancellationState || "",
    취소오류코드: request.cancellationErrorCode || "",
    취소오류내용: request.cancellationErrorMessage || "",
    마지막취소시각: request.lastCancellationAt || "",
    마지막취소담당자: request.lastCancellationBy || "",
    마지막거래조회시각: request.lastInquiryAt || "",
    거래조회응답코드: request.inquiryResponseCode || "",
    KCP거래상태: request.inquiryShopStatus || request.inquiryFinalStatusCode || "",
    오류코드: request.errorCode || "",
    오류내용: request.errorMessage || "",
    링크생성시각: request.linkRegisteredAt || "",
    등록시각: request.createdAt || "",
    카드입력검증시각: request.preflightValidatedAt || "",
    마지막승인시도시각: request.lastAttemptAt || "",
    승인시각: request.approvedAt || "",
    실패시각: request.failedAt || "",
    등록자: request.createdBy || "",
    수정시각: request.updatedAt || "",
    수정자: request.updatedBy || "",
  }));

export const buildPaymentErpExportRows = (requests = []) =>
  (Array.isArray(requests) ? requests : [])
    .filter(
      (request) =>
        /^\d{6}$/.test(normalizeVendorCode(request.vendorCode)) &&
        (request.approvalStatus === "APPROVED" ||
          ["APPROVED", "PAID", "COMPLETED"].includes(
            String(request.status || "").toUpperCase()
          )) &&
        Boolean(request.transactionId)
    )
    .map((request) => {
    const amount = Number(request.amount) || 0;
    const cancelledAmount = Number(request.cancelledAmount) || 0;
    return {
      거래일시: request.approvedAt || request.paidAt || request.createdAt || "",
      거래처코드: normalizeVendorCode(request.vendorCode),
      거래처상호명: request.vendorBusinessName || "",
      ERP사업장코드: request.vendorErpSiteCode || "",
      ERP관할사업장명: request.vendorErpSiteName || "",
      수금법인: request.paymentCompanyName || "",
      KCP사이트코드: request.paymentSiteCd || request.paymentSiteCdMasked || "",
      결제유형:
        request.requestType === "KEYIN"
          ? "키인결제"
          : request.requestType === "AUTOPAY"
          ? "등록카드 결제"
          : request.requestType === "STANDARD"
          ? "표준결제"
          : "문자링크결제",
      승인금액: amount,
      취소금액: cancelledAmount,
      순수금액: amount - cancelledAmount,
      처리상태: request.status || "",
      승인번호: request.approvalCode || "",
      거래번호: request.transactionId || "",
      카드사: request.approvalCardName || "",
      카드번호마스킹: request.approvalCardNumberMasked || "",
      할부개월: request.approvalQuota || "",
      결제내용: request.itemName || "",
      담당자: request.createdBy || "",
    };
    });

export const getDefaultSalesContractSearchRange = (
  now = new Date()
) => {
  const formatDateInput = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const to = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate()
  );
  const from = new Date(to);
  const targetDay = to.getDate();
  from.setMonth(from.getMonth() - 1);
  if (from.getDate() !== targetDay) {
    from.setDate(0);
  }
  return { dateFrom: formatDateInput(from), dateTo: formatDateInput(to) };
};
export const ADMIN_CONTRACT_START_TAB: {
  value: AdminTab;
  label: string;
  description: string;
} = {
  value: "CONTRACT_START",
  label: "계약 시작하기",
  description: "관리자 테스트 작성, 작성 링크, KCP 상태 점검",
};

export const DB_BACKUP_DATASET_OPTIONS = [
  {
    key: "contracts",
    label: "전자계약 contracts",
    description: "계약 문서와 계약 이벤트",
  },
  {
    key: "vendors",
    label: "거래처 마스터 vendors",
    description: "거래처 관리 화면 데이터",
  },
  {
    key: "companyBranches",
    label: "우리회사 사업장",
    description: "화성/인천 등 사업장 설정",
  },
  {
    key: "legacyContracts",
    label: "기존/수기계약",
    description: "legacyContracts와 문서/이력",
  },
  {
    key: "config",
    label: "운영 설정 config",
    description: "관리자 설정 문서",
  },
  {
    key: "contractTemplates",
    label: "계약서 조항",
    description: "발행된 계약서 템플릿",
  },
  {
    key: "invites",
    label: "작성 초대",
    description: "거래처 작성 초대 상태",
  },
];
export const DEFAULT_DB_BACKUP_DATASET_KEYS = DB_BACKUP_DATASET_OPTIONS.map(
  (dataset) => dataset.key
);

export const ADMIN_PAGE_TABS: Array<{
  value: AdminTab;
  label: string;
  description: string;
}> = [
  {
    value: "SALES_SEARCH",
    label: "거래처 계약 현황",
    description: "계약 작성 여부 검색",
  },
  {
    value: "LEGACY_ARCHIVE",
    label: "기존계약 관리",
    description: "수기 계약, 미수확인서, 법적 증빙 보관",
  },
  {
    value: "VENDOR_MASTER",
    label: "거래처 관리",
    description: "사업자번호 기준 거래처, 계약, 결제 준비 관리",
  },
  {
    value: "PAYMENT_MANAGEMENT",
    label: "결제관리",
    description: "문자링크·키인 대기열·등록카드 결제 관리",
  },
  {
    value: "COMPANY_BRANCHES",
    label: "우리회사 사업장 관리",
    description: "화성법인, 인천법인, PG 상태 관리",
  },
  {
    value: "DB_BACKUP",
    label: "DB 백업/복원",
    description: "관리자 수동 백업과 선택 복원",
  },
  {
    value: "SETTINGS",
    label: "설정",
    description: "검증, 알림, 영업사원, 초대 링크",
  },
  {
    value: "LIST",
    label: "계약서 데이터",
    description: "계약서 검색, 목록, 상세 진입",
  },
  {
    value: "STATS",
    label: "통합 현황",
    description: "전자공급계약서와 링크결제 본사 요약",
  },
  {
    value: "REPORTS",
    label: "각종현황데이터",
    description: "운영 설정과 관리 데이터 요약",
  },
  {
    value: "TEMPLATES",
    label: "계약서 조항 관리",
    description: "새 계약부터 적용되는 조항 버전 발행",
  },
];

export const getDefaultAdminTabForViewport = (
  width =
    typeof window !== "undefined" && typeof window.innerWidth === "number"
      ? window.innerWidth
      : 0
): AdminTab => (Number(width) >= ADMIN_DESKTOP_MIN_WIDTH ? "STATS" : "LIST");

export const isReactEventLikeArgument = (value = null) =>
  Boolean(
    value &&
      typeof value === "object" &&
      (typeof value.preventDefault === "function" ||
        "nativeEvent" in value ||
        ("currentTarget" in value && "target" in value))
  );

export const resolveContractsLoadManager = (
  managerOverride = null,
  fallbackManager = null
) =>
  isReactEventLikeArgument(managerOverride)
    ? fallbackManager
    : managerOverride || fallbackManager;

export const getAdminContractStatusKey = (contract = {}) => {
  const status = String(contract?.status || "").trim().toLowerCase();
  if (status === "deleted") return "deleted";
  if (status === "confirmed") return "confirmed";
  if (status === "rejected") return "rejected";
  return "completed";
};

const pickSalesLookupString = (...values) =>
  values.map((value) => String(value ?? "").trim()).find(Boolean) || "";

const joinSalesLookupAddressParts = (...parts) =>
  parts.map((part) => String(part ?? "").trim()).filter(Boolean).join(" ").trim();

const formatSalesLookupBusinessNumber = (value = "") => {
  const digits = normalizeBusinessNumber(value);
  if (digits.length === 10) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
  }
  return String(value || "").trim();
};

export const getEmptySalesLookupFilters = () => ({
  keyword: "",
  businessNumber: "",
  representativeName: "",
  addressKeyword: "",
  companyBranchId: "",
  dateFrom: "",
  dateTo: "",
  status: "all",
});

export const getSalesLookupStatusKey = (contract = {}) => {
  const status = String(contract?.status || "").trim().toLowerCase();
  const contractStatus = String(contract?.contractStatus || "").trim().toUpperCase();
  if (
    status === "deleted" ||
    contractStatus === "DELETED" ||
    contract.isDeleted === true ||
    Boolean(contract.deletedAt)
  ) {
    return "deleted";
  }
  if (status === "confirmed" || contractStatus === "CONFIRMED") return "confirmed";
  if (status === "rejected" || contractStatus === "REJECTED") return "rejected";
  if (status === "not_started" || contractStatus === "NOT_STARTED") return "not_started";
  if (status === "draft" || contractStatus === "DRAFT") return "draft";
  if (
    contractStatus === "PENDING_CO_REP_VERIFICATION" ||
    contractStatus === "PARTIAL_CO_REP_COMPLETED" ||
    status === "pending_co_rep_verification"
  ) {
    return "pending";
  }
  if (status === "pending" || contractStatus === "PENDING") return "pending";
  if (status === "completed" || contractStatus === "COMPLETED") return "completed";
  return pickSalesLookupString(
    contract.completedAt,
    contract.submittedAt,
    contract.createdAt,
    contract.updatedAt
  )
    ? "completed"
    : "draft";
};

export const getSalesLookupStatusLabel = (status = "") =>
  SALES_CONTRACT_STATUS_OPTIONS.find((option) => option.value === status)?.label ||
  "작성 완료";

export const getSalesLookupContractStatusLabel = (status = "", contract = {}) =>
  status === "completed" && hasContractReceiptConfirmation(contract)
    ? COMPLETION_RECEIPT_CONFIRMED_LABEL
    : getSalesLookupStatusLabel(status);

export const getSalesLookupDateValue = (contract = {}) =>
  pickSalesLookupString(
    contract.completedAt,
    contract.submittedAt,
    contract.createdAt,
    contract.updatedAt
  );

export const getSalesLookupBusinessAddress = (contract = {}) =>
  joinSalesLookupAddressParts(contract.agentAddress, contract.agentAddressDetail) ||
  joinSalesLookupAddressParts(
    contract.businessAddress,
    contract.businessAddressDetail
  ) ||
  joinSalesLookupAddressParts(
    contract.businessPlaceAddress,
    contract.businessPlaceAddressDetail
  ) ||
  joinSalesLookupAddressParts(contract.companyAddress, contract.companyAddressDetail) ||
  joinSalesLookupAddressParts(contract.roadAddress, contract.detailAddress) ||
  joinSalesLookupAddressParts(contract.address, contract.addressDetail) ||
  pickSalesLookupString(contract.finalSnapshot?.businessInfoSnapshot?.address);

export const getSalesLookupAssignmentSummary = (contract = {}) => {
  const assignment =
    contract.salesAssignment && typeof contract.salesAssignment === "object"
      ? contract.salesAssignment
      : {};
  const code = pickSalesLookupString(
    assignment.salesRepCode,
    contract.salesReceipt?.managerCode,
    contract.managerCode,
    contract.salesRepId,
    contract.assignedManagerCode
  );
  const name = pickSalesLookupString(
    assignment.salesRepName,
    contract.salesReceipt?.managerName,
    contract.managerName,
    contract.salesRepName,
    contract.assignedManagerName,
    contract.ownerLabel
  );
  const normalizedName = name.toUpperCase();
  const isUnassigned =
    (!code && !name) ||
    code === "default" ||
    ["본사", "본사 직접 관리", "HQ", "HEADQUARTERS"].includes(name) ||
    ["본사", "본사 직접 관리", "HQ", "HEADQUARTERS"].includes(normalizedName) ||
    name.includes("미지정");

  return {
    managerCode: isUnassigned ? null : code || null,
    managerName: isUnassigned ? null : name || null,
    salesAssignment: assignment.salesRepCode || assignment.salesRepName ? assignment : null,
    isUnassigned,
    assignmentStatusLabel: isUnassigned ? "담당자 미지정" : name || code || "담당자 미지정",
  };
};

export const hasSalesLookupCoRepresentative = (contract = {}) => {
  const info = contract.coRepresentativeInfo || {};
  const status = String(info.status || contract.coRepresentativeCheckStatus || "").trim();
  return (
    contract.coRepresentativeDeclared === true ||
    status === "DETECTED" ||
    status === "USER_DECLARED"
  );
};

export const buildSalesLookupRows = (contracts = []) =>
  (Array.isArray(contracts) ? contracts : []).map((contract) => {
    const correction = getBusinessNameCorrection(contract);
    const status = getSalesLookupStatusKey(contract);
    const assignment = getSalesLookupAssignmentSummary(contract);
    const dateValue = getSalesLookupDateValue(contract);
    const coRepresentativeWorkflow =
      contract.coRepresentativeWorkflow ||
      buildCoRepresentativeWorkflow({
        required: hasSalesLookupCoRepresentative(contract),
        representatives: contract.coRepresentatives || [],
        updatedAt: contract.updatedAt || contract.completedAt || "",
      });
    const coRepresentativeDisplayStatus =
      coRepresentativeWorkflow.required === true
        ? coRepresentativeWorkflow.status === CO_REP_WORKFLOW_STATUS.COMPLETED
          ? "공동계약인 완료"
          : coRepresentativeWorkflow.status === CO_REP_WORKFLOW_STATUS.PARTIAL
          ? "공동계약인 일부 완료"
          : "공동계약인 인증 대기중"
        : "공동계약인 없음";
    return {
      documentId: pickSalesLookupString(contract.id, contract.documentId),
      contractId: pickSalesLookupString(contract.contractId),
      businessName: getAdminDisplayBusinessName(contract),
      businessNumber: formatSalesLookupBusinessNumber(
        pickSalesLookupString(contract.agentBizNo, contract.businessNumber, contract.bizNo)
      ),
      representativeName: pickSalesLookupString(
        contract.agentRep,
        contract.corpRepName,
        contract.representativeName
      ) || "미수집",
      address: getSalesLookupBusinessAddress(contract) || "주소 미입력",
      companyBranchId: pickSalesLookupString(
        contract.companyBranchId,
        contract.contractCompanyBranch?.id,
        contract.finalSnapshot?.contractCompanyBranch?.id
      ),
      companyBranchName:
        pickSalesLookupString(
          contract.companyBranchName,
          contract.contractCompanyBranch?.branchName,
          contract.finalSnapshot?.contractCompanyBranch?.branchName
        ) || "사업장 미지정",
      managerCode: assignment.managerCode,
      managerName: assignment.managerName,
      salesAssignment: assignment.salesAssignment,
      isUnassigned: assignment.isUnassigned,
      assignmentStatusLabel: assignment.assignmentStatusLabel,
      status,
      statusLabel: getSalesLookupContractStatusLabel(status, contract),
      receiptConfirmed: hasContractReceiptConfirmation(contract),
      receiptConfirmedAt: pickSalesLookupString(contract.receiptConfirmedAt),
      receiptStatusLabel: hasContractReceiptConfirmation(contract)
        ? COMPLETION_RECEIPT_CONFIRMED_LABEL
        : "",
      contractDate: getContractDisplayDateValue(contract),
      adminContractDate: pickSalesLookupString(contract.adminContractDate),
      submittedAt: pickSalesLookupString(contract.submittedAt),
      completedAt: pickSalesLookupString(contract.completedAt),
      createdAt: pickSalesLookupString(contract.createdAt),
      updatedAt: pickSalesLookupString(contract.updatedAt || dateValue),
      dateValue,
      confirmed: status === "confirmed",
      rejected: status === "rejected",
      contactPhone: getAdminDisplayContact(contract),
      coRepresentative: hasSalesLookupCoRepresentative(contract),
      coRepresentativeWorkflow,
      coRepresentativeDisplayStatus,
      coRepresentativeCompletedCount: coRepresentativeWorkflow.completedCount,
      coRepresentativeTotalCount: coRepresentativeWorkflow.totalCount,
      coRepresentativeNextAction:
        coRepresentativeWorkflow.required && coRepresentativeWorkflow.pendingCount > 0
          ? "공동계약인 링크 발송 또는 인증 대기"
          : coRepresentativeWorkflow.required
          ? "공동계약인 완료"
          : "",
      businessVerificationStatus:
        contract.businessVerification?.status ||
        contract.businessVerificationStatus ||
        contract.ntsStatus ||
        "",
      businessVerificationStatusLabel:
        contract.businessVerification?.status === "MANUAL_REVIEW_REQUIRED"
          ? "국세청 확인 본사 검토 필요"
          : contract.businessVerification?.status === "DISABLED_BY_ADMIN"
          ? "국세청 확인 미사용 / 본사 확인 필요"
          : contract.businessVerification?.status || "",
      requiresManualReview:
        contract.businessVerification?.requiresManualReview === true ||
        contract.requiresManualReview === true ||
        contract.businessVerification?.status === "MANUAL_REVIEW_REQUIRED" ||
        contract.businessVerification?.status === "DISABLED_BY_ADMIN",
      businessNameCorrected: Boolean(
        String(correction?.correctedName || "").trim()
      ),
    };
  });

export const buildSafeContractExportRows = (rows = []) =>
  (Array.isArray(rows) ? rows : []).map((row) => ({
    계약구분: row.sourceLabel || "전자계약",
    계약번호: row.contractId || "",
    계약일: row.contractDate || "",
    상태: row.statusLabel || row.status || "",
    상호명: row.businessName || "",
    사업자번호: row.businessNumber || "",
    대표자명: row.representativeName || "",
    담당사업장: row.companyBranchName || "",
    담당영업사원:
      row.assignmentStatusLabel || row.managerName || row.salesAssignment || "",
    연락처: row.contactPhone || row.phone || "",
    접수일시: row.submittedAt || row.createdAt || "",
    완료일시: row.completedAt || "",
    국세청확인상태:
      row.businessVerificationStatusLabel ||
      row.businessVerificationStatus ||
      row.ntsStatus ||
      "",
    본사확인필요:
      row.requiresManualReview || row.manualReviewRequired ? "예" : "아니오",
    공동계약인여부: row.coRepresentative ? "있음" : "없음",
    공동계약인인증상태: row.coRepresentativeDisplayStatus || "",
    공동계약인완료수:
      row.coRepresentativeTotalCount > 0
        ? `${row.coRepresentativeCompletedCount || 0}/${row.coRepresentativeTotalCount}`
        : "",
    비고: row.coRepresentativeNextAction || "",
  }));

const normalizeSalesLookupDateBoundary = (value = "", endOfDay = false) => {
  const text = String(value || "").trim();
  if (!text) return null;
  const suffix = endOfDay ? "T23:59:59.999Z" : "T00:00:00.000Z";
  const date = new Date(/T/.test(text) ? text : `${text}${suffix}`);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const applySalesLookupFilters = (rows = [], filters = {}) => {
  const keyword = String(filters.keyword || "").trim().toLowerCase();
  const businessNumber = normalizeBusinessNumber(filters.businessNumber || "");
  const representativeName = String(filters.representativeName || "").trim();
  const addressKeyword = String(filters.addressKeyword || "").trim();
  const companyBranchId = String(filters.companyBranchId || "").trim();
  const statusFilter = String(filters.status || "all").trim();
  const from = normalizeSalesLookupDateBoundary(filters.dateFrom);
  const to = normalizeSalesLookupDateBoundary(filters.dateTo, true);

  return (Array.isArray(rows) ? rows : []).filter((row) => {
    if (
      statusFilter &&
      statusFilter !== "all" &&
      statusFilter !== row.status &&
      !(statusFilter === "exclude_deleted" && row.status !== "deleted")
    ) {
      return false;
    }
    if (keyword) {
      const haystack = [
        row.vendorCode,
        row.erpSiteCode,
        row.erpSiteName,
        row.businessName,
        row.businessNumber,
        row.representativeName,
        row.address,
        row.contractId,
      ]
        .map((value) => String(value || "").toLowerCase())
        .join(" ");
      if (!haystack.includes(keyword)) return false;
    }
    if (
      businessNumber &&
      !normalizeBusinessNumber(row.businessNumber || "").includes(businessNumber)
    ) {
      return false;
    }
    if (
      representativeName &&
      !String(row.representativeName || "").includes(representativeName)
    ) {
      return false;
    }
    if (addressKeyword && !String(row.address || "").includes(addressKeyword)) {
      return false;
    }
    if (companyBranchId && String(row.companyBranchId || "") !== companyBranchId) {
      return false;
    }
    if (from || to) {
      if (!row.dateValue) return false;
      const date = new Date(row.dateValue);
      if (Number.isNaN(date.getTime())) return false;
      if (from && date < from) return false;
      if (to && date > to) return false;
    }
    return true;
  });
};

export const hasActiveSalesLookupFilters = (filters = {}) =>
  Boolean(
    String(filters.keyword || "").trim() ||
      String(filters.businessNumber || "").trim() ||
      String(filters.representativeName || "").trim() ||
      String(filters.addressKeyword || "").trim() ||
      String(filters.companyBranchId || "").trim() ||
      String(filters.dateFrom || "").trim() ||
      String(filters.dateTo || "").trim() ||
      (filters.status && filters.status !== "all")
  );

export const getLegacyContractStatusLabel = (status = "") =>
  LEGACY_CONTRACT_STATUS_OPTIONS.find((option) => option.value === status)?.label ||
  "미확인";

export const buildLegacyContractDisplayRows = (legacyContracts = []) =>
  (Array.isArray(legacyContracts) ? legacyContracts : []).map((contract) => {
    const status = String(contract.contractStatus || "UNKNOWN").trim().toUpperCase();
    return {
      documentId: pickSalesLookupString(contract.id, contract.documentId, contract.legacyId),
      legacyId: pickSalesLookupString(contract.legacyId, contract.id, contract.documentId),
      sourceType: "LEGACY_MANUAL",
      sourceLabel: "기존계약",
      evidenceLevel: "MANUAL_DOCUMENT_ONLY",
      businessName: pickSalesLookupString(contract.businessName) || "상호명 미수집",
      businessNumber: formatSalesLookupBusinessNumber(contract.businessNumber),
      representativeName:
        pickSalesLookupString(contract.representativeName) || "대표자 미수집",
      phone: formatPhoneNumberForDisplay(contract.phone),
      address: pickSalesLookupString(contract.address) || "주소 미입력",
      salesRepName: pickSalesLookupString(contract.salesRepName) || "담당자 미지정",
      companyBranchId: pickSalesLookupString(contract.companyBranchId),
      companyBranchName:
        pickSalesLookupString(
          contract.companyBranchName,
          contract.companyBranchSnapshot?.branchName
        ) || "사업장 미지정",
      companyBranchSnapshot: contract.companyBranchSnapshot || null,
      contractStatus: status,
      contractStatusLabel: getLegacyContractStatusLabel(status),
      contractDate: pickSalesLookupString(contract.contractDate),
      memo: pickSalesLookupString(contract.memo),
      documentsCount: Number(contract.documentsCount || 0),
      historyCount: Number(contract.historyCount || 0),
      updatedAt: pickSalesLookupString(contract.updatedAt, contract.createdAt),
      hasIdentityVerification: false,
      hasElectronicSignature: false,
      hasContractHash: false,
    };
  });

export const normalizeVendorMasterStatus = (value = "") => {
  const status = String(value || "").trim().toUpperCase();
  return VENDOR_MASTER_STATUS_OPTIONS.some(
    (option) => !["all", "managed"].includes(option.value) && option.value === status
  )
    ? status
    : "ACTIVE";
};

export const getVendorMasterStatusLabel = (status = "") =>
  VENDOR_MASTER_STATUS_OPTIONS.find(
    (option) => option.value === String(status || "").trim().toUpperCase()
  )?.label || "거래중";

export const buildVendorIdFromBusinessNumber = (value = "") => {
  const digits = normalizeBusinessNumber(value);
  return digits.length === 10 ? `vendor_bn_${digits}` : "";
};

export const normalizeVendorCode = (value = "") => {
  const text = String(value || "").trim();
  if (!text) return "";
  const digits = text.replace(/\D/g, "");
  return /^\d{1,6}$/.test(digits) ? digits.padStart(6, "0") : text.slice(0, 40);
};

export const buildVendorIdFromVendorCode = (value = "") => {
  const vendorCode = normalizeVendorCode(value);
  return /^\d{6}$/.test(vendorCode) ? `vendor_code_${vendorCode}` : "";
};

export const getVendorMasterDuplicateKey = (vendor = {}) => {
  const vendorCode = normalizeVendorCode(
    vendor.vendorCode || vendor.erpVendorCode || vendor["거래처코드"] || vendor["코드"]
  );
  if (vendorCode) return `vendorCode:${vendorCode}`;
  const businessNumber = normalizeBusinessNumber(
    vendor.businessNumber || vendor["사업자번호"]
  );
  if (businessNumber) return `businessNumber:${businessNumber}`;
  const fallback = [
    pickSalesLookupString(vendor.businessName, vendor["상호명"]),
    pickSalesLookupString(vendor.representativeName, vendor["대표자명"]),
    normalizePhoneDigits(vendor.phone || vendor["전화번호"]),
  ].join("|");
  return fallback.replace(/\|/g, "") ? `fallback:${fallback}` : "";
};

const normalizeVendorNameForComparison = (value = "") =>
  String(value || "")
    .normalize("NFKC")
    .toLocaleLowerCase("ko-KR")
    .replace(/[^\p{L}\p{N}]/gu, "");

export const findSimilarVendorMasterNames = (
  vendors = [],
  candidate = {},
  excludedVendorId = "",
  limit = 3
) => {
  const candidateName = normalizeVendorNameForComparison(candidate.businessName);
  if (candidateName.length < 2) return [];
  return (Array.isArray(vendors) ? vendors : [])
    .filter((vendor) => {
      const vendorId = pickSalesLookupString(vendor.vendorId, vendor.id);
      if (excludedVendorId && vendorId === excludedVendorId) return false;
      const existingName = normalizeVendorNameForComparison(vendor.businessName);
      if (!existingName) return false;
      return (
        existingName === candidateName ||
        (Math.min(existingName.length, candidateName.length) >= 4 &&
          (existingName.includes(candidateName) || candidateName.includes(existingName)))
      );
    })
    .slice(0, Math.max(1, Number(limit) || 3));
};

export const getVendorMasterApiErrorMessage = (
  error = {},
  fallbackMessage = "거래처 관리 요청을 처리하지 못했습니다."
) => {
  const code = String(error?.code || "").trim().toLowerCase();
  if (code === "permission-denied") {
    return "거래처 정보를 처리할 권한이 없습니다. 본사 관리자 권한을 확인해 주세요.";
  }
  if (code === "failed-precondition") {
    return "거래처 조회에 필요한 Firestore 설정 또는 인덱스가 준비되지 않았습니다.";
  }
  return error?.message || fallbackMessage;
};

export const buildVendorErpDetails = (row = {}) => {
  const current =
    row?.erpDetails && typeof row.erpDetails === "object" ? row.erpDetails : {};
  const read = (key, rawKey, maxLength = 200) =>
    pickSalesLookupString(row[key], row[rawKey], current[key]).slice(0, maxLength);
  const legacyBusinessDigits = normalizeBusinessNumber(row["사업.주민번호"]);

  return {
    shortName: read("shortName", "약칭", 100),
    groupName: read("groupName", "그룹", 100),
    contactName: read("contactName", "담당자", 100),
    landlinePhone: formatPhoneNumberForDisplay(read("landlinePhone", "전화번호", 40)),
    mobilePhone: formatPhoneNumberForDisplay(read("mobilePhone", "핸드폰", 40)),
    settlementDay: read("settlementDay", "결제일", 20),
    paymentDueMemo: read("paymentDueMemo", "결제예정일메모", 300),
    postalCode: read("postalCode", "우편번호", 20),
    addressLine1: read("addressLine1", "주소", 300),
    addressDetail: read("addressDetail", "번지", 200),
    businessType: read("businessType", "업태", 150),
    businessItem: read("businessItem", "종목", 200),
    priceTier: read("priceTier", "적용단가", 100),
    email: read("email", "이메일", 200),
    orderId: read("orderId", "주문ID", 100),
    note: read("note", "비고", 1000),
    extendedMemo: read("extendedMemo", "메모2", 2000),
    vatCode: read("vatCode", "부가세", 20),
    erpCreatedAt: read("erpCreatedAt", "최초 등록일", 50),
    erpUpdatedAt: read("erpUpdatedAt", "최종 수정일", 50),
    lastTransactionAt: read("lastTransactionAt", "최종거래일", 50),
    erpUpdatedBy: read("erpUpdatedBy", "최종수정자", 100),
    vatName: read("vatName", "부가세명", 50),
    tradeStopFlag: read("tradeStopFlag", "거래중지여부", 20),
    invoiceType: read("invoiceType", "계산서 형태", 100),
    shoppingMallLinkInfo: read("shoppingMallLinkInfo", "쇼핑몰연동정보", 500),
    discountRate: read("discountRate", "할인율", 50),
    pointsBasis: read("pointsBasis", "포인트기준", 100),
    cmsCode: read("cmsCode", "CMS코드", 100),
    businessIdentityDisposition:
      current.businessIdentityDisposition ||
      (legacyBusinessDigits.length === 10
        ? "BUSINESS_NUMBER_ACCEPTED"
        : legacyBusinessDigits.length > 0
        ? "NON_BUSINESS_IDENTIFIER_EXCLUDED"
        : "EMPTY"),
  };
};

export const getVendorErpDetailDisplayRows = (vendor = {}) =>
  VENDOR_ERP_DETAIL_FIELDS.map(([key, label]) => ({
    key,
    label,
    value: vendor?.erpDetails?.[key] || "",
  }));

export const buildSafeVendorWorkbookImportRows = (rows = []) =>
  (Array.isArray(rows) ? rows : []).map((row = {}) => {
    const legacyBusinessDigits = normalizeBusinessNumber(row["사업.주민번호"]);
    const explicitBusinessDigits = normalizeBusinessNumber(
      row.businessNumber || row["사업자번호"]
    );
    const stopValue = pickSalesLookupString(row["거래중지여부"]).toUpperCase();
    const hasStatusColumn = ["status", "관리상태", "거래중지여부"].some(
      (key) => Object.prototype.hasOwnProperty.call(row, key) && String(row[key] ?? "").trim()
    );
    const hasLinkPaymentColumn = ["allowLinkPayment", "결제링크허용"].some(
      (key) => Object.prototype.hasOwnProperty.call(row, key) && String(row[key] ?? "").trim()
    );
    const hasKeyinPaymentColumn = ["allowKeyinPayment", "키인결제허용"].some(
      (key) => Object.prototype.hasOwnProperty.call(row, key) && String(row[key] ?? "").trim()
    );
    const address = [row["주소"], row["번지"]]
      .map((value) => pickSalesLookupString(value))
      .filter(Boolean)
      .join(" ");
    return {
      거래처코드: normalizeVendorCode(
        pickSalesLookupString(
          row.vendorCode,
          row.erpVendorCode,
          row["거래처코드"],
          row["코드"]
        )
      ),
      ERP사업장코드: pickSalesLookupString(
        row.erpSiteCode,
        row["ERP사업장코드"],
        row["사업장코드"]
      ),
      ERP관할사업장명: pickSalesLookupString(
        row.erpSiteName,
        row["ERP관할사업장명"],
        row["관할사업장명"]
      ),
      상호명: pickSalesLookupString(row.businessName, row["상호명"]),
      사업자번호:
        legacyBusinessDigits.length === 10
          ? formatSalesLookupBusinessNumber(legacyBusinessDigits)
          : explicitBusinessDigits.length === 10
          ? formatSalesLookupBusinessNumber(explicitBusinessDigits)
          : "",
      대표자명: pickSalesLookupString(row.representativeName, row["대표자명"], row["대표자"]),
      전화번호: formatPhoneNumberForDisplay(
        row.phone || row["전화번호"] || row["핸드폰"]
      ),
      주소: pickSalesLookupString(row.address, address),
      파트: pickSalesLookupString(row.partName, row["파트"], row["그룹"]),
      담당영업사원: pickSalesLookupString(
        row.salesManagerName,
        row["담당영업사원"],
        row["담당자"]
      ),
      ...(hasStatusColumn
        ? {
            관리상태: pickSalesLookupString(
              row.status,
              row["관리상태"],
              stopValue && !["0", "N", "NO", "FALSE"].includes(stopValue)
                ? "INACTIVE"
                : "ACTIVE"
            ),
          }
        : {}),
      ...(hasLinkPaymentColumn
        ? { 결제링크허용: row.allowLinkPayment ?? row["결제링크허용"] }
        : {}),
      ...(hasKeyinPaymentColumn
        ? { 키인결제허용: row.allowKeyinPayment ?? row["키인결제허용"] }
        : {}),
      erpDetails: buildVendorErpDetails(row),
    };
  });

const normalizeVendorBoolean = (value = false) => {
  if (typeof value === "boolean") return value;
  const text = String(value || "").trim().toUpperCase();
  return ["Y", "YES", "TRUE", "1", "허용", "사용", "가능", "O"].includes(text);
};

export const normalizeCompanyBranchPgStatus = (value = "") => {
  const status = String(value || "").trim().toUpperCase();
  return COMPANY_BRANCH_PG_STATUS_OPTIONS.some((option) => option.value === status)
    ? status
    : "NOT_APPLIED";
};

export const maskCompanyBranchKcpSiteCd = (value = "") => {
  const text = String(value || "").trim();
  if (!text) return "";
  if (text.includes("*")) return text.slice(0, 40);
  if (text.length <= 4) return text;
  return `${text.slice(0, 2)}${"*".repeat(Math.min(text.length - 4, 8))}${text.slice(-2)}`;
};

export const buildCompanyBranchSnapshot = (branch = {}) => {
  if (!branch || typeof branch !== "object") return null;
  const id = pickSalesLookupString(branch.id, branch.branchId);
  const branchName = pickSalesLookupString(branch.branchName);
  if (!id && !branchName) return null;
  return {
    id,
    branchName,
    corporationName: pickSalesLookupString(branch.corporationName),
    businessNumber: formatSalesLookupBusinessNumber(branch.businessNumber || ""),
    representativeName: pickSalesLookupString(branch.representativeName),
    address: pickSalesLookupString(branch.address),
  };
};

export const normalizeCompanyBranchRow = (row = {}, options = {}) => {
  const now = options.now || new Date().toISOString();
  const updatedBy = pickSalesLookupString(options.updatedBy, options.createdBy, "본사");
  const branchName = pickSalesLookupString(row.branchName, row["사업장명"]);
  const corporationName = pickSalesLookupString(row.corporationName, row["법인명"]);
  const businessNumber = formatSalesLookupBusinessNumber(
    row.businessNumber || row["사업자번호"]
  );
  const businessNumberNormalized = normalizeBusinessNumber(businessNumber);
  const sourcePg = row.pgProfile || {};
  const resolvedProfiles = resolveCompanyBranchPaymentProfiles({
    ...row,
    corporationName,
    pgProfile: sourcePg,
  });
  const errors = [];
  if (!branchName) errors.push("사업장명은 필수입니다.");
  if (!corporationName) errors.push("법인명은 필수입니다.");
  if (businessNumber && businessNumberNormalized.length !== 10) {
    errors.push("사업자번호는 10자리 숫자여야 합니다.");
  }
  errors.push(...resolvedProfiles.errors);
  const branchId =
    pickSalesLookupString(row.branchId, row.id) ||
    `branch_${branchName.replace(/\s+/g, "_") || createStableId("branch_manual")}`;
  const branch = {
    id: branchId,
    branchId,
    branchName,
    corporationName,
    businessNumber,
    businessNumberNormalized,
    representativeName: pickSalesLookupString(row.representativeName, row["대표자명"]),
    address: pickSalesLookupString(row.address, row["주소"]),
    phone: formatPhoneNumberForDisplay(row.phone || row["전화번호"]),
    email: pickSalesLookupString(row.email, row["이메일"]),
    pgProfile: {
      provider: "KCP",
      siteCdMasked: maskCompanyBranchKcpSiteCd(
        sourcePg.siteCdMasked ||
          row.siteCdMasked ||
          row["KCP site_cd"] ||
          resolvedProfiles.linkSiteCdMasked
      ),
      buyLinkEnabled: normalizeVendorBoolean(
        sourcePg.buyLinkEnabled ?? row.buyLinkEnabled ?? row["바이링크사용"]
      ),
      keyinEnabled: normalizeVendorBoolean(
        sourcePg.keyinEnabled ?? row.keyinEnabled ?? row["키인결제사용"]
      ),
      autopayEnabled: normalizeVendorBoolean(
        sourcePg.autopayEnabled ?? row.autopayEnabled ?? row["등록카드결제사용"]
      ),
      cancelEnabled: normalizeVendorBoolean(
        sourcePg.cancelEnabled ?? row.cancelEnabled ?? row["취소사용"]
      ),
      status: normalizeCompanyBranchPgStatus(sourcePg.status || row.pgStatus || row["PG상태"]),
      linkPaymentProfileId: resolvedProfiles.linkPaymentProfileId,
      keyinPaymentProfileId: resolvedProfiles.keyinPaymentProfileId,
      autopayProfileId: resolvedProfiles.autopayProfileId,
      paymentCompanyName: resolvedProfiles.paymentCompanyName,
      linkSiteCdMasked: resolvedProfiles.linkSiteCdMasked,
      keyinSiteCdMasked: resolvedProfiles.keyinSiteCdMasked,
      profileMappingSource: resolvedProfiles.profileMappingSource,
    },
    isDefault: row.isDefault === true || row["기본사업장"] === true,
    active: row.active === false || row["활성"] === false ? false : true,
    memo: pickSalesLookupString(row.memo, row["메모"]),
    createdAt: row.createdAt || now,
    updatedAt: now,
    createdBy: pickSalesLookupString(row.createdBy, updatedBy),
    updatedBy,
  };
  return {
    ok: errors.length === 0,
    errors,
    branch,
    snapshot: buildCompanyBranchSnapshot(branch),
  };
};

export const createCompanyBranchSeedRows = (now = new Date().toISOString()) =>
  COMPANY_BRANCH_SEED_TEMPLATE_NAMES.map((branchName, index) =>
    normalizeCompanyBranchRow(
      {
        branchName,
        corporationName: "",
        active: true,
        isDefault: index === 0,
      },
      { now, createdBy: "SYSTEM" }
    ).branch
  );

export const resolveDefaultCompanyBranch = (branches = []) => {
  const activeBranches = (Array.isArray(branches) ? branches : []).filter(
    (branch) => branch && branch.active !== false
  );
  return (
    activeBranches.find((branch) => branch.isDefault === true) ||
    activeBranches[0] ||
    null
  );
};

export const matchCompanyBranchByName = (branches = [], branchName = "") => {
  const normalized = String(branchName || "").replace(/\s+/g, "").toLowerCase();
  if (!normalized) return null;
  return (
    (Array.isArray(branches) ? branches : []).find((branch) =>
      [branch.branchName, branch.corporationName, branch.companyBranchName]
        .map((value) => String(value || "").replace(/\s+/g, "").toLowerCase())
        .includes(normalized)
    ) || null
  );
};

export const resolveCompanyBranchSelection = ({
  companyBranches = [],
  companyBranchId = "",
  companyBranchName = "",
  allowDefault = true,
} = {}) => {
  const branches = Array.isArray(companyBranches) ? companyBranches : [];
  const id = pickSalesLookupString(companyBranchId);
  const byId = id
    ? branches.find(
        (branch) => pickSalesLookupString(branch.branchId, branch.id) === id && branch.active !== false
      )
    : null;
  const byName = byId ? null : matchCompanyBranchByName(branches, companyBranchName);
  const fallback = allowDefault ? resolveDefaultCompanyBranch(branches) : null;
  const branch = byId || byName || fallback || null;
  return {
    branch,
    snapshot: branch ? buildCompanyBranchSnapshot(branch) : null,
    source: byId ? "ID" : byName ? "NAME" : fallback ? "DEFAULT" : "NONE",
  };
};

export const getCompanyBranchStableId = (branch = {}) =>
  pickSalesLookupString(branch.branchId, branch.id);

export const resolveFieldPrintSupplierMode = ({
  selectedBranchId = "",
  branch = null,
}: {
  selectedBranchId?: string;
  branch?: any;
}): PrintableFieldSupplierMode => {
  const selectedId = pickSalesLookupString(selectedBranchId);
  const resolvedId = getCompanyBranchStableId(branch || {});
  return selectedId && resolvedId && selectedId === resolvedId
    ? "EXPLICIT_BRANCH"
    : "DEFAULT_DUAL";
};

export const findCompanyBranchById = (branches = [], branchId = "") => {
  const targetId = pickSalesLookupString(branchId);
  if (!targetId) return null;
  return (
    (Array.isArray(branches) ? branches : []).find(
      (branch) => getCompanyBranchStableId(branch) === targetId
    ) || null
  );
};

export const normalizeVendorMasterBranchIds = (vendor = {}) => {
  const rawIds = [
    ...(Array.isArray(vendor.companyBranchIds) ? vendor.companyBranchIds : []),
    ...(Array.isArray(vendor.siteIds) ? vendor.siteIds : []),
    vendor.companyBranchId,
    vendor.companyBranchSnapshot?.id,
  ];
  return Array.from(
    new Set(rawIds.map((value) => pickSalesLookupString(value)).filter(Boolean))
  );
};

export const buildVendorMasterBranchSnapshots = ({
  branchIds = [],
  companyBranches = [],
  existingSnapshots = [],
} = {}) =>
  (Array.isArray(branchIds) ? branchIds : [])
    .map((branchId) => {
      const branch = findCompanyBranchById(companyBranches, branchId);
      if (branch) return buildCompanyBranchSnapshot(branch);
      return (
        (Array.isArray(existingSnapshots) ? existingSnapshots : []).find(
          (snapshot) => pickSalesLookupString(snapshot?.id) === branchId
        ) || null
      );
    })
    .filter(Boolean);

export const getVendorMasterBranchDisplayName = (vendor = {}) => {
  const names = [
    ...(Array.isArray(vendor.companyBranchSnapshots)
      ? vendor.companyBranchSnapshots.map((snapshot) => snapshot?.branchName)
      : []),
    vendor.companyBranchName,
    vendor.companyBranchSnapshot?.branchName,
  ]
    .map((value) => pickSalesLookupString(value))
    .filter(Boolean);
  return Array.from(new Set(names)).join(", ");
};

export const buildCompanyBranchKpis = ({
  branches = [],
  vendors = [],
  electronicContracts = [],
  legacyContracts = [],
} = {}) =>
  (Array.isArray(branches) ? branches : []).map((branch) => {
    const branchId = pickSalesLookupString(branch.branchId, branch.id);
    const branchName = pickSalesLookupString(branch.branchName);
    const matches = (item) => {
      const itemBranchIds = normalizeVendorMasterBranchIds(item);
      const itemBranchNames = [
        item.companyBranchName,
        item.companyBranchSnapshot?.branchName,
        item.contractCompanyBranch?.branchName,
        ...(Array.isArray(item.companyBranchSnapshots)
          ? item.companyBranchSnapshots.map((snapshot) => snapshot?.branchName)
          : []),
      ]
        .map((value) => pickSalesLookupString(value))
        .filter(Boolean);
      return (
        itemBranchIds.includes(branchId) ||
        pickSalesLookupString(item.contractCompanyBranch?.id) === branchId ||
        itemBranchNames.includes(branchName)
      );
    };
    return {
      branchId,
      branchName,
      vendorCount: (Array.isArray(vendors) ? vendors : []).filter(matches).length,
      electronicContractCount: (Array.isArray(electronicContracts)
        ? electronicContracts
        : []
      ).filter(matches).length,
      legacyContractCount: (Array.isArray(legacyContracts) ? legacyContracts : []).filter(
        matches
      ).length,
      coRepPendingCount: (Array.isArray(electronicContracts)
        ? electronicContracts
        : []
      ).filter(
        (contract) =>
          matches(contract) &&
          ["PENDING_CO_REP_VERIFICATION", "PARTIAL_CO_REP_COMPLETED"].includes(
            String(contract.contractStatus || contract.status || "").trim().toUpperCase()
          )
      ).length,
    };
  });

export const normalizeVendorMasterRow = (row = {}, options = {}) => {
  const now = options.now || new Date().toISOString();
  const updatedBy = pickSalesLookupString(options.updatedBy, options.createdBy, "본사");
  const companyBranches = Array.isArray(options.companyBranches)
    ? options.companyBranches
    : [];
  const requireCompanyBranch = options.requireCompanyBranch === true;
  const vendorCode = normalizeVendorCode(
    pickSalesLookupString(
      row.vendorCode,
      row.erpVendorCode,
      row["거래처코드"],
      row["코드"]
    )
  );
  const legacyBusinessDigits = normalizeBusinessNumber(row["사업.주민번호"]);
  const explicitBusinessNumber = pickSalesLookupString(
    row.businessNumber,
    row["사업자번호"]
  );
  const explicitBusinessDigits = normalizeBusinessNumber(explicitBusinessNumber);
  const businessName = pickSalesLookupString(row.businessName, row["상호명"]);
  const businessNumber = formatSalesLookupBusinessNumber(
    (explicitBusinessDigits.length === 10 ? explicitBusinessDigits : "") ||
      (legacyBusinessDigits.length === 10 ? legacyBusinessDigits : "")
  );
  const businessNumberNormalized = normalizeBusinessNumber(businessNumber);
  const representativeName = pickSalesLookupString(
    row.representativeName,
    row["대표자명"]
  );
  const phone = formatPhoneNumberForDisplay(
    row.phone || row["전화번호"] || row["핸드폰"]
  );
  const address = pickSalesLookupString(row.address, row["주소"]);
  const partName = pickSalesLookupString(row.partName, row["파트"], row["그룹"]);
  const salesManagerName = pickSalesLookupString(
    row.salesManagerName,
    row["담당영업사원"],
    row["담당자"]
  );
  const erpSiteCode = pickSalesLookupString(
    row.erpSiteCode,
    row["ERP사업장코드"],
    row["사업장코드"]
  );
  const erpSiteName = pickSalesLookupString(
    row.erpSiteName,
    row["ERP관할사업장명"],
    row["관할사업장명"]
  );
  const inputCompanyBranchId = pickSalesLookupString(
    row.companyBranchId,
    row["담당사업장ID"]
  );
  const inputCompanyBranchName = pickSalesLookupString(
    row.companyBranchName,
    row["담당사업장"],
    erpSiteName
  );
  const inputCompanyBranchIds = Array.from(
    new Set(
      [
        ...(Array.isArray(row.companyBranchIds) ? row.companyBranchIds : []),
        ...(Array.isArray(row.siteIds) ? row.siteIds : []),
        inputCompanyBranchId,
      ]
        .map((value) => pickSalesLookupString(value))
        .filter(Boolean)
    )
  );
  const branchSelection = resolveCompanyBranchSelection({
    companyBranches,
    companyBranchId: inputCompanyBranchId,
    companyBranchName: inputCompanyBranchName,
    allowDefault: true,
  });
  const companyBranchIds =
    inputCompanyBranchIds.length > 0
      ? inputCompanyBranchIds
      : branchSelection.snapshot?.id
      ? [branchSelection.snapshot.id]
      : [];
  const companyBranchSnapshots = buildVendorMasterBranchSnapshots({
    branchIds: companyBranchIds,
    companyBranches,
    existingSnapshots: [
      ...(Array.isArray(row.companyBranchSnapshots) ? row.companyBranchSnapshots : []),
      row.companyBranchSnapshot,
    ].filter(Boolean),
  });
  const primaryCompanyBranchSnapshot =
    companyBranchSnapshots[0] || branchSelection.snapshot || null;
  const legacyStopValue = pickSalesLookupString(row["거래중지여부"]).toUpperCase();
  const status = normalizeVendorMasterStatus(
    row.status ||
      row["관리상태"] ||
      (legacyStopValue
        ? ["0", "N", "NO", "FALSE"].includes(legacyStopValue)
          ? "ACTIVE"
          : "INACTIVE"
        : "")
  );
  const errors = [];
  if (!businessName) errors.push("상호명은 필수입니다.");
  if (vendorCode && !/^\d{6}$/.test(vendorCode)) {
    errors.push("거래처코드는 6자리 숫자여야 합니다.");
  }
  if (!vendorCode && !businessNumber) {
    errors.push("거래처코드 또는 사업자번호가 필요합니다.");
  }
  if (explicitBusinessNumber && explicitBusinessDigits.length !== 10) {
    errors.push("사업자번호는 10자리 숫자여야 합니다.");
  }
  if (
    (row.status || row["관리상태"]) &&
    !VENDOR_MASTER_STATUS_OPTIONS.some(
      (option) => option.value === String(row.status || row["관리상태"]).trim().toUpperCase()
    )
  ) {
    errors.push("관리상태 값을 확인해 주세요.");
  }
  if (
    inputCompanyBranchName &&
    branchSelection.source === "DEFAULT" &&
    inputCompanyBranchIds.length === 0
  ) {
    errors.push("담당사업장명을 등록된 우리회사 사업장과 일치시켜 주세요.");
  }
  if (inputCompanyBranchId && branchSelection.source !== "ID") {
    errors.push("담당사업장 ID를 확인해 주세요.");
  }
  if (requireCompanyBranch && !branchSelection.branch) {
    errors.push("담당사업장을 선택해 주세요.");
  }
  const vendorId =
    pickSalesLookupString(row.vendorId, row.id) ||
    buildVendorIdFromVendorCode(vendorCode) ||
    buildVendorIdFromBusinessNumber(businessNumber) ||
    createStableId("vendor_manual");
  const vendor = {
    id: vendorId,
    vendorId,
    vendorCode,
    erpSiteCode,
    erpSiteName,
    businessNumber,
    businessNumberNormalized,
    businessName,
    representativeName,
    phone,
    address,
    partName,
    salesManagerName,
    erpDetails: buildVendorErpDetails(row),
    companyBranchId: primaryCompanyBranchSnapshot?.id || inputCompanyBranchId,
    companyBranchName:
      companyBranchSnapshots.map((snapshot) => snapshot.branchName).join(", ") ||
      primaryCompanyBranchSnapshot?.branchName ||
      inputCompanyBranchName,
    companyBranchSnapshot: primaryCompanyBranchSnapshot,
    companyBranchIds,
    companyBranchSnapshots,
    siteIds: companyBranchIds,
    status,
    source: pickSalesLookupString(row.source) || options.source || "MANUAL",
    memo: pickSalesLookupString(row.memo, row["메모"]),
    createdAt: row.createdAt || now,
    updatedAt: now,
    createdBy: pickSalesLookupString(row.createdBy, updatedBy),
    updatedBy,
    contractLinks: {
      electronicContractIds: Array.isArray(row.contractLinks?.electronicContractIds)
        ? row.contractLinks.electronicContractIds
        : [],
      legacyContractIds: Array.isArray(row.contractLinks?.legacyContractIds)
        ? row.contractLinks.legacyContractIds
        : [],
    },
    paymentProfile: {
      allowLinkPayment: normalizeVendorBoolean(
        row.paymentProfile?.allowLinkPayment ?? row.allowLinkPayment ?? row["결제링크허용"]
      ),
      allowKeyinPayment: normalizeVendorBoolean(
        row.paymentProfile?.allowKeyinPayment ?? row.allowKeyinPayment ?? row["키인결제허용"]
      ),
      defaultPaymentMemo: pickSalesLookupString(row.paymentProfile?.defaultPaymentMemo),
    },
    riskFlags: {
      unpaid: row.riskFlags?.unpaid === true,
      legalDispute: row.riskFlags?.legalDispute === true || status === "LEGAL",
      manualReviewRequired:
        row.riskFlags?.manualReviewRequired === true || status === "WATCH",
    },
  };
  return {
    ok: errors.length === 0,
    rowNumber: Number(options.rowNumber || 0) || 0,
    errors,
    duplicateKey: getVendorMasterDuplicateKey(vendor),
    vendor,
  };
};

export const buildVendorMasterImportPreview = ({
  rows = [],
  existingVendors = [],
  companyBranches = [],
  now = new Date().toISOString(),
  createdBy = "본사",
} = {}) => {
  const existingKeys = new Set(
    (Array.isArray(existingVendors) ? existingVendors : [])
      .map(getVendorMasterDuplicateKey)
      .filter(Boolean)
  );
  const seenKeys = new Set();
  const previewRows = (Array.isArray(rows) ? rows : []).map((row, index) => {
    const normalized = normalizeVendorMasterRow(row, {
      rowNumber: index + 2,
      now,
      createdBy,
      source: "EXCEL_IMPORT",
      companyBranches,
      requireCompanyBranch: true,
    });
    let status = normalized.ok ? "READY" : "ERROR";
    const errors = [...normalized.errors];
    if (normalized.ok && normalized.duplicateKey) {
      if (existingKeys.has(normalized.duplicateKey) || seenKeys.has(normalized.duplicateKey)) {
        status = "DUPLICATE";
        errors.push("중복 거래처입니다.");
      }
      seenKeys.add(normalized.duplicateKey);
    }
    return { ...normalized, status, errors };
  });
  return {
    total: previewRows.length,
    readyCount: previewRows.filter((row) => row.status === "READY").length,
    duplicateCount: previewRows.filter((row) => row.status === "DUPLICATE").length,
    errorCount: previewRows.filter((row) => row.status === "ERROR").length,
    rows: previewRows,
  };
};

export const getVendorMasterBusinessNumber = (vendor = {}) =>
  normalizeBusinessNumber(
    vendor.businessNumberNormalized ||
      vendor.businessNumber ||
      vendor.agentBizNo ||
      vendor.bizNo ||
      vendor.agentBizNumber
  );

export const isVendorMasterConfirmedElectronicContract = (contract = {}) => {
  const statusKey = getSalesLookupStatusKey(contract);
  if (["deleted", "rejected", "draft", "not_started", "pending"].includes(statusKey)) {
    return false;
  }
  return (
    hasContractReceiptConfirmation(contract) ||
    statusKey === "confirmed" ||
    (statusKey === "completed" &&
      (contract.isLocked === true || Boolean(contract.submittedAt || contract.completedAt)))
  );
};

export const buildVendorMasterRowFromElectronicContract = (
  contract = {},
  companyBranches = []
) => {
  const businessNumber = getVendorMasterBusinessNumber(contract);
  if (!businessNumber) return null;
  const assignment = getSalesLookupAssignmentSummary(contract);
  const companyBranchId = pickSalesLookupString(
    contract.companyBranchId,
    contract.contractCompanyBranch?.id,
    contract.finalSnapshot?.contractCompanyBranch?.id
  );
  const companyBranchName = pickSalesLookupString(
    contract.companyBranchName,
    contract.contractCompanyBranch?.branchName,
    contract.finalSnapshot?.contractCompanyBranch?.branchName
  );
  const branchSelection = resolveCompanyBranchSelection({
    companyBranches,
    companyBranchId,
    companyBranchName,
    allowDefault: false,
  });
  const branchSnapshot =
    branchSelection.snapshot ||
    contract.contractCompanyBranch ||
    contract.finalSnapshot?.contractCompanyBranch ||
    null;
  const contractDocumentId = pickSalesLookupString(
    contract.id,
    contract.documentId,
    contract.contractId
  );
  const branchIds = branchSnapshot?.id ? [branchSnapshot.id] : companyBranchId ? [companyBranchId] : [];
  const branchSnapshots = branchSnapshot ? [buildCompanyBranchSnapshot(branchSnapshot) || branchSnapshot] : [];
  return {
    id: buildVendorIdFromBusinessNumber(businessNumber),
    vendorId: buildVendorIdFromBusinessNumber(businessNumber),
    businessNumber: formatSalesLookupBusinessNumber(businessNumber),
    businessNumberNormalized: businessNumber,
    businessName: getAdminDisplayBusinessName(contract),
    representativeName: pickSalesLookupString(
      contract.agentRep,
      contract.corpRepName,
      contract.representativeName
    ),
    phone: formatPhoneNumberForDisplay(
      pickSalesLookupString(contract.agentContact, contract.phone, contract.contactPhone)
    ),
    address: getSalesLookupBusinessAddress(contract),
    partName: pickSalesLookupString(contract.salesRepDepartmentPart, contract.partName),
    salesManagerName: assignment.managerName || "",
    companyBranchId: branchIds[0] || "",
    companyBranchName:
      branchSnapshots.map((snapshot) => snapshot.branchName).filter(Boolean).join(", ") ||
      companyBranchName,
    companyBranchSnapshot: branchSnapshots[0] || null,
    companyBranchIds: branchIds,
    companyBranchSnapshots: branchSnapshots,
    siteIds: branchIds,
    status: "ACTIVE",
    source: "E_CONTRACT",
    memo: "",
    createdAt: pickSalesLookupString(contract.submittedAt, contract.completedAt, contract.createdAt),
    updatedAt: pickSalesLookupString(contract.receiptConfirmedAt, contract.updatedAt),
    contractLinks: {
      electronicContractIds: contractDocumentId ? [contractDocumentId] : [],
      legacyContractIds: [],
    },
    paymentProfile: {
      allowLinkPayment: false,
      allowKeyinPayment: false,
      defaultPaymentMemo: "",
    },
    riskFlags: {
      unpaid: false,
      legalDispute: false,
      manualReviewRequired: false,
    },
  };
};

export const buildVendorMasterRowFromLegacyContract = (
  contract = {},
  companyBranches = []
) => {
  const businessNumber = getVendorMasterBusinessNumber(contract);
  if (!businessNumber) return null;
  const companyBranchId = pickSalesLookupString(
    contract.companyBranchId,
    contract.companyBranchSnapshot?.id
  );
  const companyBranchName = pickSalesLookupString(
    contract.companyBranchName,
    contract.companyBranchSnapshot?.branchName
  );
  const branchSelection = resolveCompanyBranchSelection({
    companyBranches,
    companyBranchId,
    companyBranchName,
    allowDefault: false,
  });
  const branchSnapshot = branchSelection.snapshot || contract.companyBranchSnapshot || null;
  const branchIds = branchSnapshot?.id ? [branchSnapshot.id] : companyBranchId ? [companyBranchId] : [];
  const branchSnapshots = branchSnapshot ? [buildCompanyBranchSnapshot(branchSnapshot) || branchSnapshot] : [];
  const legacyDocumentId = pickSalesLookupString(contract.legacyId, contract.id, contract.documentId);
  return {
    id: buildVendorIdFromBusinessNumber(businessNumber),
    vendorId: buildVendorIdFromBusinessNumber(businessNumber),
    businessNumber: formatSalesLookupBusinessNumber(businessNumber),
    businessNumberNormalized: businessNumber,
    businessName: pickSalesLookupString(contract.businessName) || "상호명 미수집",
    representativeName: pickSalesLookupString(contract.representativeName),
    phone: formatPhoneNumberForDisplay(contract.phone || ""),
    address: pickSalesLookupString(contract.address),
    partName: pickSalesLookupString(contract.partName),
    salesManagerName: pickSalesLookupString(contract.salesRepName, contract.salesManagerName),
    companyBranchId: branchIds[0] || "",
    companyBranchName:
      branchSnapshots.map((snapshot) => snapshot.branchName).filter(Boolean).join(", ") ||
      companyBranchName,
    companyBranchSnapshot: branchSnapshots[0] || null,
    companyBranchIds: branchIds,
    companyBranchSnapshots: branchSnapshots,
    siteIds: branchIds,
    status: "ACTIVE",
    source: "LEGACY_CONTRACT",
    memo: pickSalesLookupString(contract.memo),
    createdAt: pickSalesLookupString(contract.createdAt, contract.contractDate),
    updatedAt: pickSalesLookupString(contract.updatedAt, contract.contractDate),
    contractLinks: {
      electronicContractIds: [],
      legacyContractIds: legacyDocumentId ? [legacyDocumentId] : [],
    },
    paymentProfile: {
      allowLinkPayment: false,
      allowKeyinPayment: false,
      defaultPaymentMemo: "",
    },
    riskFlags: {
      unpaid: false,
      legalDispute: String(contract.contractStatus || "").toUpperCase() === "DISPUTE",
      manualReviewRequired: false,
    },
  };
};

export const mergeVendorMasterBaseRow = (base = {}, fallback = {}) => ({
  ...fallback,
  ...base,
  businessNumber: base.businessNumber || fallback.businessNumber,
  businessNumberNormalized:
    base.businessNumberNormalized || fallback.businessNumberNormalized,
  businessName: base.businessName || fallback.businessName,
  representativeName: base.representativeName || fallback.representativeName,
  phone: base.phone || fallback.phone,
  address: base.address || fallback.address,
  partName: base.partName || fallback.partName,
  salesManagerName: base.salesManagerName || fallback.salesManagerName,
  companyBranchId: base.companyBranchId || fallback.companyBranchId,
  companyBranchName: base.companyBranchName || fallback.companyBranchName,
  companyBranchSnapshot: base.companyBranchSnapshot || fallback.companyBranchSnapshot,
  companyBranchIds:
    normalizeVendorMasterBranchIds(base).length > 0
      ? normalizeVendorMasterBranchIds(base)
      : normalizeVendorMasterBranchIds(fallback),
  companyBranchSnapshots:
    Array.isArray(base.companyBranchSnapshots) && base.companyBranchSnapshots.length > 0
      ? base.companyBranchSnapshots
      : fallback.companyBranchSnapshots || [],
  siteIds:
    normalizeVendorMasterBranchIds(base).length > 0
      ? normalizeVendorMasterBranchIds(base)
      : normalizeVendorMasterBranchIds(fallback),
  source: base.source || fallback.source,
  status: base.status || fallback.status || "ACTIVE",
  memo: base.memo || fallback.memo,
  contractLinks: {
    electronicContractIds: Array.from(
      new Set([
        ...(Array.isArray(fallback.contractLinks?.electronicContractIds)
          ? fallback.contractLinks.electronicContractIds
          : []),
        ...(Array.isArray(base.contractLinks?.electronicContractIds)
          ? base.contractLinks.electronicContractIds
          : []),
      ])
    ),
    legacyContractIds: Array.from(
      new Set([
        ...(Array.isArray(fallback.contractLinks?.legacyContractIds)
          ? fallback.contractLinks.legacyContractIds
          : []),
        ...(Array.isArray(base.contractLinks?.legacyContractIds)
          ? base.contractLinks.legacyContractIds
          : []),
      ])
    ),
  },
});

export const deriveVendorMasterContractLinks = ({
  vendor = {},
  electronicContracts = [],
  legacyContracts = [],
} = {}) => {
  const businessNumber = normalizeBusinessNumber(
    vendor.businessNumberNormalized || vendor.businessNumber
  );
  if (!businessNumber) {
    return {
      electronicContracts: [],
      legacyContracts: [],
      latestContractAt: "",
      coRepPendingCount: 0,
      manualReviewRequiredCount: 0,
    };
  }
  const electronicMatches = (Array.isArray(electronicContracts)
    ? electronicContracts.filter(isVendorMasterConfirmedElectronicContract)
    : []
  ).filter(
    (contract) =>
      normalizeBusinessNumber(
        contract.agentBizNo || contract.businessNumber || contract.bizNo
      ) === businessNumber
  );
  const legacyMatches = (Array.isArray(legacyContracts) ? legacyContracts : []).filter(
    (contract) => normalizeBusinessNumber(contract.businessNumber) === businessNumber
  );
  const latestContractAt =
    [...electronicMatches, ...legacyMatches]
      .map((contract) =>
        pickSalesLookupString(
          contract.completedAt,
          contract.submittedAt,
          contract.contractDate,
          contract.updatedAt
        )
      )
      .filter(Boolean)
      .sort()
      .pop() || "";
  return {
    electronicContracts: electronicMatches,
    legacyContracts: legacyMatches,
    latestContractAt,
    coRepPendingCount: electronicMatches.filter((contract) =>
      ["PENDING_CO_REP_VERIFICATION", "PARTIAL_CO_REP_COMPLETED"].includes(
        String(contract.contractStatus || contract.status || "").trim().toUpperCase()
      )
    ).length,
    manualReviewRequiredCount: electronicMatches.filter(
      (contract) =>
        contract.requiresManualReview === true ||
        ["MANUAL_REVIEW_REQUIRED", "DISABLED_BY_ADMIN"].includes(
          String(
            contract.businessVerification?.status || contract.businessVerificationStatus || ""
          ).trim()
        )
    ).length,
  };
};

export const buildVendorMasterDisplayRows = ({
  vendors = [],
  electronicContracts = [],
  legacyContracts = [],
  companyBranches = [],
} = {}) => {
  const rowsByKey = new Map();
  const codedBusinessNumberCounts = new Map();
  (Array.isArray(vendors) ? vendors : []).forEach((vendor) => {
    const vendorCode = normalizeVendorCode(vendor.vendorCode);
    const businessNumber = getVendorMasterBusinessNumber(vendor);
    if (vendorCode && businessNumber) {
      codedBusinessNumberCounts.set(
        businessNumber,
        Number(codedBusinessNumberCounts.get(businessNumber) || 0) + 1
      );
    }
  });
  const uniqueCodedKeyByBusinessNumber = new Map();
  const appendRow = (vendor = {}) => {
    const vendorCode = normalizeVendorCode(vendor.vendorCode);
    const businessNumber = getVendorMasterBusinessNumber(vendor);
    const key =
      (vendorCode ? `vendorCode:${vendorCode}` : "") ||
      (businessNumber && codedBusinessNumberCounts.get(businessNumber) === 1
        ? uniqueCodedKeyByBusinessNumber.get(businessNumber)
        : "") ||
      (businessNumber ? `businessNumber:${businessNumber}` : "") ||
      pickSalesLookupString(vendor.vendorId, vendor.id) ||
      `vendor_row_${rowsByKey.size}`;
    const existing = rowsByKey.get(key);
    rowsByKey.set(key, existing ? mergeVendorMasterBaseRow(existing, vendor) : vendor);
    if (vendorCode && businessNumber && codedBusinessNumberCounts.get(businessNumber) === 1) {
      uniqueCodedKeyByBusinessNumber.set(businessNumber, key);
    }
  };

  (Array.isArray(vendors) ? vendors : []).forEach(appendRow);

  return Array.from(rowsByKey.values()).map((vendor) => {
    const links = deriveVendorMasterContractLinks({
      vendor,
      electronicContracts,
      legacyContracts,
    });
    const branchIds = normalizeVendorMasterBranchIds(vendor);
    const branchSnapshots = buildVendorMasterBranchSnapshots({
      branchIds,
      companyBranches,
      existingSnapshots: [
        ...(Array.isArray(vendor.companyBranchSnapshots)
          ? vendor.companyBranchSnapshots
          : []),
        vendor.companyBranchSnapshot,
      ].filter(Boolean),
    });
    const branchSelection = resolveCompanyBranchSelection({
      companyBranches,
      companyBranchId: branchIds[0] || vendor.companyBranchId,
      companyBranchName: vendor.companyBranchName,
      allowDefault: false,
    });
    const resolvedSnapshots = branchSnapshots.length
      ? branchSnapshots
      : branchSelection.snapshot
      ? [branchSelection.snapshot]
      : [];
    const resolvedBranchIds = resolvedSnapshots.length
      ? resolvedSnapshots.map((snapshot) => snapshot.id).filter(Boolean)
      : branchIds;
    const companyBranchName =
      resolvedSnapshots.map((snapshot) => snapshot.branchName).filter(Boolean).join(", ") ||
      getVendorMasterBranchDisplayName(vendor);
    return {
      ...vendor,
      id: vendor.vendorId || vendor.id,
      vendorId: vendor.vendorId || vendor.id,
      companyBranchId: resolvedBranchIds[0] || vendor.companyBranchId || "",
      companyBranchIds: resolvedBranchIds,
      siteIds: resolvedBranchIds,
      companyBranchName,
      companyBranchSnapshot: resolvedSnapshots[0] || vendor.companyBranchSnapshot || null,
      companyBranchSnapshots: resolvedSnapshots,
      companyBranchPgProfile: branchSelection.branch?.pgProfile || null,
      statusLabel: getVendorMasterStatusLabel(vendor.status),
      electronicContracts: links.electronicContracts,
      legacyContracts: links.legacyContracts,
      electronicContractCount: links.electronicContracts.length,
      legacyContractCount: links.legacyContracts.length,
      latestContractAt: links.latestContractAt,
      coRepPendingCount: links.coRepPendingCount,
      manualReviewRequiredCount: links.manualReviewRequiredCount,
      paymentAllowed:
        vendor.paymentProfile?.allowLinkPayment === true ||
        vendor.paymentProfile?.allowKeyinPayment === true,
    };
  });
};

export const buildVendorMasterKpis = (rows = []) =>
  (Array.isArray(rows) ? rows : []).reduce(
    (acc, row) => {
      acc.total += 1;
      if (row.electronicContractCount > 0) acc.electronicLinked += 1;
      if (row.legacyContractCount > 0) acc.legacyLinked += 1;
      acc.coRepPending += Number(row.coRepPendingCount || 0);
      acc.manualReviewRequired += Number(row.manualReviewRequiredCount || 0);
      if (["WATCH", "LEGAL"].includes(String(row.status || "").toUpperCase())) {
        acc.watchOrLegal += 1;
      }
      const branchNames = [
        ...(Array.isArray(row.companyBranchSnapshots)
          ? row.companyBranchSnapshots.map((snapshot) => snapshot?.branchName)
          : []),
        row.companyBranchName,
      ]
        .flatMap((value) => String(value || "").split(","))
        .map((value) => value.trim())
        .filter(Boolean);
      Array.from(new Set(branchNames)).forEach((branchName) => {
        acc.byCompanyBranch[branchName] = (acc.byCompanyBranch[branchName] || 0) + 1;
      });
      return acc;
    },
    {
      total: 0,
      electronicLinked: 0,
      legacyLinked: 0,
      coRepPending: 0,
      manualReviewRequired: 0,
      watchOrLegal: 0,
      byCompanyBranch: {},
    }
  );

export const applyVendorMasterFilters = (rows = [], filters = {}) => {
  const keywordTokens = normalizePaymentVendorLookupValue(filters.keyword || "")
    .split(/\s+/)
    .filter(Boolean);
  const businessNumber = normalizeBusinessNumber(filters.businessNumber || "");
  const status = String(filters.status || "all").trim().toUpperCase();
  const linkStatus = String(filters.linkStatus || "all").trim();
  const partName = String(filters.partName || "").trim();
  const salesManagerName = String(filters.salesManagerName || "").trim();
  const companyBranchId = String(filters.companyBranchId || "").trim();
  return (Array.isArray(rows) ? rows : []).filter((row) => {
    if (status === "MANAGED" && String(row.status || "").toUpperCase() === "DELETED") {
      return false;
    }
    if (status && !["ALL", "MANAGED"].includes(status) && String(row.status || "").toUpperCase() !== status) {
      return false;
    }
    if (linkStatus === "electronic" && Number(row.electronicContractCount || 0) < 1) {
      return false;
    }
    if (linkStatus === "legacy" && Number(row.legacyContractCount || 0) < 1) {
      return false;
    }
    if (linkStatus === "manualReview" && Number(row.manualReviewRequiredCount || 0) < 1) {
      return false;
    }
    if (
      linkStatus === "watchLegal" &&
      !["WATCH", "LEGAL"].includes(String(row.status || "").toUpperCase())
    ) {
      return false;
    }
    if (
      businessNumber &&
      !normalizeBusinessNumber(row.businessNumber || "").includes(businessNumber)
    ) {
      return false;
    }
    if (partName && !String(row.partName || "").includes(partName)) return false;
    if (
      salesManagerName &&
      !String(row.salesManagerName || "").includes(salesManagerName)
    ) {
      return false;
    }
    if (
      companyBranchId &&
      !normalizeVendorMasterBranchIds(row).includes(companyBranchId)
    ) {
      return false;
    }
    if (keywordTokens.length > 0) {
      const haystack = [
        row.vendorCode,
        row.businessName,
        row.businessNumber,
        row.representativeName,
        row.partName,
        row.salesManagerName,
        row.phone,
        row.address,
        row.memo,
      ]
        .map(normalizePaymentVendorLookupValue)
        .join(" ");
      if (!keywordTokens.every((token) => haystack.includes(token))) return false;
    }
    return true;
  });
};

export const buildSafeVendorMasterExportRows = (rows = []) =>
  (Array.isArray(rows) ? rows : []).map((row) => ({
    코드: normalizeVendorCode(row.vendorCode),
    상호명: row.businessName || "",
    약칭: row.erpDetails?.shortName || "",
    그룹: row.erpDetails?.groupName || row.partName || "",
    대표자: row.representativeName || "",
    담당자: row.erpDetails?.contactName || row.salesManagerName || "",
    전화번호: row.erpDetails?.landlinePhone || "",
    핸드폰: row.erpDetails?.mobilePhone || row.phone || "",
    "사업.주민번호": formatSalesLookupBusinessNumber(row.businessNumber || ""),
    결제일: row.erpDetails?.settlementDay || "",
    결제예정일메모: row.erpDetails?.paymentDueMemo || "",
    우편번호: row.erpDetails?.postalCode || "",
    주소: row.erpDetails?.addressLine1 || row.address || "",
    번지: row.erpDetails?.addressDetail || "",
    업태: row.erpDetails?.businessType || "",
    종목: row.erpDetails?.businessItem || "",
    적용단가: row.erpDetails?.priceTier || "",
    이메일: row.erpDetails?.email || "",
    주문ID: row.erpDetails?.orderId || "",
    비고: row.erpDetails?.note || "",
    메모2: row.erpDetails?.extendedMemo || "",
    부가세: row.erpDetails?.vatCode || "",
    "최초 등록일": row.erpDetails?.erpCreatedAt || "",
    "최종 수정일": row.erpDetails?.erpUpdatedAt || "",
    최종거래일: row.erpDetails?.lastTransactionAt || "",
    최종수정자: row.erpDetails?.erpUpdatedBy || "",
    사업장코드: row.erpSiteCode || "",
    관할사업장명: row.erpSiteName || "",
    부가세명: row.erpDetails?.vatName || "",
    거래중지여부: row.erpDetails?.tradeStopFlag || "",
    "계산서 형태": row.erpDetails?.invoiceType || "",
    쇼핑몰연동정보: row.erpDetails?.shoppingMallLinkInfo || "",
    할인율: row.erpDetails?.discountRate || "",
    포인트기준: row.erpDetails?.pointsBasis || "",
    CMS코드: row.erpDetails?.cmsCode || "",
  }));

export const buildVendorImportPreviewSummary = (preview = null, existingRows = []) => {
  const existingKeys = new Set(
    (Array.isArray(existingRows) ? existingRows : [])
      .map(getVendorMasterDuplicateKey)
      .filter(Boolean)
  );
  const seenKeys = new Set();
  return (preview?.rows || []).reduce(
    (acc, row) => {
      const duplicateKey = getVendorMasterDuplicateKey(row.vendor || {});
      const hasIdentityError =
        !duplicateKey ||
        (Array.isArray(row.errors) &&
          row.errors.some((message) =>
            /거래처코드 또는 사업자번호|6자리 숫자/.test(String(message || ""))
          ));
      if (hasIdentityError) {
        acc.businessNumberErrorCount += 1;
        return acc;
      }
      if (seenKeys.has(duplicateKey)) {
        acc.duplicateBusinessNumberCount += 1;
        return acc;
      }
      seenKeys.add(duplicateKey);
      if (row.status === "ERROR") {
        acc.reviewRequiredCount += 1;
        return acc;
      }
      if (existingKeys.has(duplicateKey) || row.status === "DUPLICATE") {
        acc.updateCount += 1;
      } else {
        acc.newCount += 1;
      }
      acc.readyToApplyCount += 1;
      return acc;
    },
    {
      newCount: 0,
      updateCount: 0,
      businessNumberErrorCount: 0,
      duplicateBusinessNumberCount: 0,
      reviewRequiredCount: 0,
      readyToApplyCount: 0,
    }
  );
};

export const buildVendorImportApplyRows = (preview = null, existingRows = []) => {
  const existingKeys = new Set(
    (Array.isArray(existingRows) ? existingRows : [])
      .map(getVendorMasterDuplicateKey)
      .filter(Boolean)
  );
  const seenKeys = new Set();
  return (preview?.rows || []).reduce((acc, row) => {
    const vendor = row.vendor || {};
    const duplicateKey = getVendorMasterDuplicateKey(vendor);
    if (!duplicateKey || row.status === "ERROR" || seenKeys.has(duplicateKey)) {
      return acc;
    }
    seenKeys.add(duplicateKey);
    acc.push({
      vendor,
      action: existingKeys.has(duplicateKey) || row.status === "DUPLICATE" ? "UPDATE" : "CREATE",
    });
    return acc;
  }, []);
};

export const buildPaymentRequestDraft = ({
  vendor = {},
  companyBranch = null,
  requestType = "BUYLINK",
  amount = 0,
  itemName = "",
  memo = "",
  createdBy = "본사",
  createdAt = new Date().toISOString(),
} = {}) => {
  const branchSnapshot =
    buildCompanyBranchSnapshot(companyBranch) ||
    vendor.companyBranchSnapshot ||
    (vendor.companyBranchId || vendor.companyBranchName
      ? {
          id: vendor.companyBranchId || "",
          branchName: vendor.companyBranchName || "",
          corporationName: "",
          businessNumber: "",
          representativeName: "",
          address: "",
        }
      : null);
  const pgProfileSnapshot = branchSnapshot
    ? {
        provider: "KCP",
        siteCdMasked: companyBranch?.pgProfile?.siteCdMasked || "",
        buyLinkEnabled: companyBranch?.pgProfile?.buyLinkEnabled === true,
        keyinEnabled: companyBranch?.pgProfile?.keyinEnabled === true,
        cancelEnabled: companyBranch?.pgProfile?.cancelEnabled === true,
        status: companyBranch?.pgProfile?.status || "NOT_APPLIED",
      }
    : null;
  return {
    vendorId: vendor.vendorId || vendor.id || "",
    vendorCode: normalizeVendorCode(vendor.vendorCode),
    erpSiteCode: vendor.erpSiteCode || "",
    erpSiteName: vendor.erpSiteName || "",
    businessNumber: formatSalesLookupBusinessNumber(vendor.businessNumber || ""),
    businessName: vendor.businessName || "",
    companyBranchId: branchSnapshot?.id || "",
    companyBranchSnapshot: branchSnapshot,
    pgProvider: pgProfileSnapshot?.provider || "KCP",
    pgProfileSnapshot,
    requestType: PAYMENT_REQUEST_TYPE_OPTIONS.some(
      (option) => option.value === String(requestType || "").trim().toUpperCase()
    )
      ? String(requestType || "").trim().toUpperCase()
      : "BUYLINK",
    amount: Number(amount) || 0,
    itemName: String(itemName || "").trim(),
    memo: String(memo || "").trim(),
    status: "DRAFT",
    kcp: {
      siteCdMasked: pgProfileSnapshot?.siteCdMasked || "",
      orderId: "",
      tno: "",
      approvalNo: "",
      cardName: "",
      cardNoMasked: "",
    },
    createdAt,
    createdBy,
    sentAt: null,
    paidAt: null,
    canceledAt: null,
  };
};

export const buildAdminContractStats = (contracts = []) => {
  const list = Array.isArray(contracts) ? contracts : [];
  const stats = {
    total: 0,
    completed: 0,
    confirmed: 0,
    rejected: 0,
    deleted: 0,
  };

  list.forEach((contract) => {
    const status = getAdminContractStatusKey(contract);
    if (status === "deleted") {
      stats.deleted += 1;
      return;
    }
    stats.total += 1;
    if (status === "confirmed") {
      stats.confirmed += 1;
      return;
    }
    if (status === "rejected") {
      stats.rejected += 1;
      return;
    }
    stats.completed += 1;
  });

  return stats;
};

export const ADMIN_ACCESS_OPTIONS: Array<{
  value: ManagerTarget;
  label: string;
  description: string;
}> = [
  {
    value: "default",
    label: "본사 관리자 조회",
    description: "관리자 비밀번호 입력 후 전체 계약을 조회합니다.",
  },
  {
    value: "field_print",
    label: "계약서 출력 및 다운로드",
    description: "본사 관리자 비밀번호 입력 후 빈 계약서를 출력하거나 PDF로 저장합니다.",
  },
  {
    value: "sales_lookup",
    label: "영업 조회 모드",
    description: "거래처 전자계약 작성 여부를 기본정보로만 조회합니다.",
  },
  {
    value: "payment",
    label: "결제관리 전용",
    description: "문자링크, 키인 대기열, 등록카드 결제 화면만 관리합니다.",
  },
  {
    value: "sales_payment",
    label: "영업 문자링크 요청",
    description: "본인 담당 거래처의 문자링크만 생성합니다.",
  },
  {
    value: "debug",
    label: "개발자 디버그",
    description: "개발자 비밀번호 입력 후 에러 로그 화면으로 이동합니다.",
  },
];

export const getVisibleAdminPageTabs = (
  isHeadquartersAdmin: boolean,
  isSalesLookupMode: boolean,
  isPaymentOnlyMode = false,
  isSalesPaymentMode = false
) => {
  if (isSalesLookupMode) {
    return ADMIN_PAGE_TABS.filter((tab) => tab.value === "SALES_SEARCH");
  }
  if (isPaymentOnlyMode) {
    const paymentTabValues = ["PAYMENT_MANAGEMENT", "COMPANY_BRANCHES"];
    return paymentTabValues
      .map((value) => ADMIN_PAGE_TABS.find((tab) => tab.value === value))
      .filter(Boolean);
  }
  if (isSalesPaymentMode) {
    return ADMIN_PAGE_TABS.filter((tab) => tab.value === "PAYMENT_MANAGEMENT").map(
      (tab) => ({
        ...tab,
        label: "문자링크 요청",
        description: "본인 담당 거래처의 KCP BUYLINK 생성",
      })
    );
  }
  return [
    ADMIN_CONTRACT_START_TAB,
    ...ADMIN_PAGE_TABS.filter(
      (tab) => isHeadquartersAdmin || tab.value === "SALES_SEARCH"
    ),
  ].filter(
    (tab, index, source) =>
      source.findIndex((item) => item.value === tab.value) === index
  );
};

export const getAdminOperationHelpForTab = (
  tab: AdminTab | string = "LIST",
  statusFilter = ""
) => {
  if (tab === "CONTRACT_START") return ADMIN_OPERATION_HELP.CONTRACT_START;
  if (tab === "SALES_SEARCH") return ADMIN_OPERATION_HELP.SALES_SEARCH;
  if (tab === "LEGACY_ARCHIVE") return ADMIN_OPERATION_HELP.LEGACY_CONTRACTS;
  if (tab === "VENDOR_MASTER") return ADMIN_OPERATION_HELP.VENDOR_MASTER;
  if (tab === "PAYMENT_MANAGEMENT") return ADMIN_OPERATION_HELP.PAYMENT_MANAGEMENT;
  if (tab === "COMPANY_BRANCHES") return ADMIN_OPERATION_HELP.VENDOR_MASTER;
  if (tab === "DB_BACKUP") return ADMIN_OPERATION_HELP.DB_BACKUP;
  if (tab === "SETTINGS") return ADMIN_OPERATION_HELP.OPERATION_STATUS;
  if (tab === "STATS") return ADMIN_OPERATION_HELP.STATS;
  if (tab === "REPORTS") return ADMIN_OPERATION_HELP.REPORTS;
  if (tab === "TEMPLATES") return ADMIN_OPERATION_HELP.CONTRACT_TEMPLATE;
  if (tab === "LIST" && statusFilter === "deleted") {
    return ADMIN_OPERATION_HELP.TRASH_PURGE;
  }
  return ADMIN_OPERATION_HELP.LIST;
};

export const getInitialManagerTargetFromUrl = (
  mCode?: string | null,
  pathname = ""
): ManagerTarget | null => {
  const normalizedPath = String(pathname || "").replace(/\/+$/, "");
  if (normalizedPath === "/payment-link-request") return "sales_payment";
  if (normalizedPath === "/payment-operations") return "payment";
  if (!mCode) return null;
  if (mCode === "admin_debug" || mCode === "debug") return "debug";
  if (mCode === "sales_lookup" || mCode === "sales") return "sales_lookup";
  if (mCode === "payment" || mCode === "payment_only") return "payment";
  if (mCode === "sales_payment" || mCode === "payment_request") {
    return "sales_payment";
  }
  if (mCode === "default" || mCode === "yh" || mCode === "sh") return "default";
  return null;
};

export const getPaymentWorkspaceRoute = (
  pathname = ""
): PaymentWorkspaceRoute => {
  const normalizedPath = String(pathname || "").replace(/\/+$/, "");
  if (normalizedPath === "/payment-link-request") return "SALES_REQUEST";
  if (normalizedPath === "/payment-operations") return "OPERATIONS";
  return "ALL";
};

export const getGlobalLoadingMessage = (
  isLoading: boolean,
  isTransitioning: boolean,
  context: LoadingContext,
  _kcpReturnSyncState: KcpReturnSyncState | "" = KCP_RETURN_SYNC_STATES.IDLE
) => {
  if (isLoading && context === "login") return "관리자 로그인 중...";
  if (isLoading && context === "list") return "계약 목록 불러오는 중...";
  if (isLoading && context === "debug") return "디버그 로그 불러오는 중...";
  if (isLoading || isTransitioning) return "화면을 불러오는 중...";
  return "";
};

/* ================= 개인정보처리방침 모달 ================= */
const PrivacyPolicyModal = ({ onClose }) => (
  <div className="fixed inset-0 z-[9999] bg-black/60 flex items-end justify-center">
    <div className="bg-white w-full max-w-md rounded-t-3xl max-h-[90vh] flex flex-col">
      <div className="flex items-center justify-between px-5 py-4 border-b shrink-0">
        <h2 className="font-black text-base text-slate-900">개인정보 처리방침</h2>
        <button onClick={onClose} className="p-1 text-slate-400"><X className="w-5 h-5" /></button>
      </div>
      <div className="overflow-y-auto p-5 text-[12px] leading-relaxed text-slate-700 space-y-4">
        <p className="text-[11px] text-slate-500">시행일: 2025년 1월 1일 | 운영: 주식회사 씨엔푸드</p>

        <section>
          <h3 className="font-black text-slate-900 mb-1">1. 수집하는 개인정보 항목</h3>
          <div className="bg-slate-50 rounded-xl p-3 space-y-1">
            <p><strong>[공통]</strong> 휴대폰번호 (SMS 인증번호 발송 및 휴대폰 번호 확인용)</p>
            <p><strong>[법인계약 추가]</strong> 대표자 성명, 주민등록번호 전체 (공동계약 확인 및 채권 관리 목적)</p>
            <p><strong>[계약정보]</strong> 상호명, 사업자등록번호, 주소, 전자서명 이미지</p>
          </div>
        </section>

        <section>
          <h3 className="font-black text-slate-900 mb-1">2. 수집 및 이용 목적</h3>
          <ul className="list-disc list-inside space-y-1 bg-slate-50 rounded-xl p-3">
            <li>공급계약 체결 및 이행</li>
            <li>휴대폰 번호 확인 및 공동계약인 신원 확인</li>
            <li>신용한도 설정 및 신용정보 조회</li>
            <li className="font-bold text-red-700">미수금 발생 시 채권추심 업무 수행</li>
            <li className="font-bold text-red-700">채권 회수를 위한 민사소송, 지급명령, 강제집행 등 법적 절차 진행</li>
            <li>법원 제출용 소송 서류 작성 (미수금 확인서 포함)</li>
          </ul>
        </section>

        <section>
          <h3 className="font-black text-slate-900 mb-1">3. 보유 및 이용기간</h3>
          <div className="bg-slate-50 rounded-xl p-3 space-y-1">
            <p>계약 존속기간 + 계약 종료 후 <strong>5년</strong></p>
            <p className="text-slate-500 text-[11px]">※ 상법 제64조(상사채권 소멸시효 5년) 및 민법 제766조(불법행위 손해배상청구권 소멸시효)에 따름</p>
            <p className="text-slate-500 text-[11px]">※ 소송 진행 중인 경우 판결 확정 후 추가 10년 보유 (민사집행법상 집행권원 유효기간)</p>
          </div>
        </section>

        <section>
          <h3 className="font-black text-slate-900 mb-1">4. 제3자 제공</h3>
          <div className="bg-slate-50 rounded-xl p-3 space-y-1">
            <p>원칙적으로 제3자에게 제공하지 않습니다.</p>
            <p className="text-[11px] text-slate-500">※ 예외: 법원, 검찰, 수사기관 등이 법령에 의해 요청하는 경우, 채권추심 위탁업체(위탁 계약 체결 시 고지)</p>
          </div>
        </section>

        <section>
          <h3 className="font-black text-slate-900 mb-1">5. 고유식별정보(주민등록번호) 처리</h3>
          <div className="bg-amber-50 border border-amber-200 rounded-xl p-3 space-y-1">
            <p>개인/법인 계약의 대표자 주민등록번호는 다음 목적으로 수집됩니다:</p>
            <ul className="list-disc list-inside text-[11px] space-y-0.5">
              <li>공급계약서 기재 (법적 요건)</li>
              <li>채권추심 및 법적 절차 진행 시 신원 확인</li>
              <li>미수금 확인서·소장 등 법원 제출 서류 작성</li>
            </ul>
            <p className="text-[11px] text-slate-500 mt-1">※ AES-256-GCM 암호화 보관, 관리자 화면과 PDF에는 원문 미표시</p>
          </div>
        </section>

        <section>
          <h3 className="font-black text-slate-900 mb-1">6. 정보주체의 권리</h3>
          <p className="bg-slate-50 rounded-xl p-3">개인정보 열람, 정정, 삭제, 처리정지를 요청하실 수 있습니다. 단, 채권 관련 법적 절차 진행 중에는 관련 법령에 따라 삭제가 제한될 수 있습니다.</p>
          <p className="text-[11px] text-slate-400 mt-1">문의: park.yh@seanfood.com</p>
        </section>
      </div>
      <div className="px-5 py-4 border-t shrink-0">
        <button onClick={onClose} className="w-full py-3 bg-slate-900 text-white rounded-2xl font-black">확인</button>
      </div>
    </div>
  </div>
);

const Toast = ({ message, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);
  return (
    <div className="fixed top-5 left-1/2 -translate-x-1/2 z-[10000] w-full max-w-sm px-4 pointer-events-none">
      <div className="bg-slate-800/90 backdrop-blur-sm text-white px-6 py-4 rounded-2xl shadow-2xl flex items-center justify-center gap-3 text-sm font-bold animate-in slide-in-from-top-2 fade-in duration-300">
        <AlertCircle className="w-5 h-5 text-yellow-400 shrink-0" />
        <span>{message}</span>
      </div>
    </div>
  );
};

const GlobalLoadingOverlay = ({ message }) => {
  if (!message) return null;
  return (
    <div className="fixed inset-0 z-[9999] bg-slate-950/45 backdrop-blur-[2px] flex items-center justify-center px-4">
      <div className="rounded-2xl bg-white px-6 py-5 shadow-2xl border border-slate-100 flex flex-col items-center gap-3 min-w-[220px]">
        <Loader2 className="w-8 h-8 animate-spin text-red-600" />
        <p className="text-sm font-black text-slate-800">{message}</p>
      </div>
    </div>
  );
};

const FieldHelp = ({ step, children, prominent = false }) => (
  <p
    className={`cnfood-readable-text mt-3 flex items-start gap-3 ${
      prominent
        ? CUSTOMER_TRUST_TYPOGRAPHY.prominentHelpBox
        : CUSTOMER_TRUST_TYPOGRAPHY.helpBox
    }`}
  >
    <span
      className={`mt-0.5 flex shrink-0 items-center justify-center rounded-full bg-blue-600 font-black text-white ${
        prominent ? "h-7 w-7 text-sm" : "h-6 w-6 text-xs"
      }`}
    >
      {step}
    </span>
    <span className="min-w-0 whitespace-normal break-keep">{children}</span>
  </p>
);

const SectionHelp = ({ children }) => (
  <div className="cnfood-readable-text rounded-2xl border border-slate-200 bg-slate-50 px-4 py-4 text-base font-bold leading-7 text-slate-700 break-keep">
    <div className="mb-2 flex items-center gap-2 font-black text-slate-900">
      <Info className="h-4 w-4 text-blue-600" />
      입력 도움말
    </div>
    <p className="whitespace-normal break-keep">{children}</p>
  </div>
);

const CustomerErrorMessage = ({ children }) => (
  <div className={`cnfood-readable-text ${CUSTOMER_TRUST_TYPOGRAPHY.errorBox}`}>
    <div className="flex items-start gap-2">
      <AlertCircle className="mt-1 h-4 w-4 shrink-0" />
      <span className="min-w-0">{children}</span>
    </div>
  </div>
);

const HelpModal = ({
  title = "",
  body = "",
  steps = [],
  warning = "",
  supportPhone = CNFOOD_SUPPORT_PHONE,
  onClose = () => {},
}) => (
  <div className="fixed inset-0 z-[10000] flex items-end justify-center bg-slate-950/45 p-3 sm:items-center">
    <div className="cnfood-readable-text max-h-[90vh] w-full max-w-md overflow-y-auto rounded-[1.5rem] bg-white p-5 text-left shadow-2xl">
      <div className="mb-4 flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-xs font-black tracking-[0.16em] text-blue-600">
            도움말
          </p>
          <h3 className="mt-1 text-xl font-black leading-snug text-slate-950 break-keep">
            {title}
          </h3>
        </div>
        <button
          type="button"
          onClick={onClose}
          className="rounded-full bg-slate-100 p-2 text-slate-500"
          aria-label="도움말 닫기"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
      <p className="text-base font-bold leading-7 text-slate-700 break-keep whitespace-normal [word-break:keep-all]">
        {body}
      </p>
      {steps.length > 0 && (
        <ol className="mt-4 space-y-2">
          {steps.map((stepText, index) => (
            <li
              key={`${stepText}-${index}`}
              className="flex gap-3 rounded-2xl bg-blue-50 px-4 py-3 text-base font-bold leading-7 text-blue-900 break-keep"
            >
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-blue-700 text-sm font-black text-white">
                {index + 1}
              </span>
              <span className="min-w-0">{stepText}</span>
            </li>
          ))}
        </ol>
      )}
      {warning && (
        <div className="mt-4 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-base font-bold leading-7 text-amber-900 break-keep">
          <div className="mb-1 flex items-center gap-2 font-black">
            <AlertTriangle className="h-4 w-4 shrink-0" />
            주의
          </div>
          <p>{warning}</p>
        </div>
      )}
      {supportPhone && (
        <p className="mt-4 rounded-2xl bg-slate-50 px-4 py-3 text-base font-black leading-7 text-slate-700 break-keep">
          문의: 씨엔푸드 메인콜센터 {supportPhone}
        </p>
      )}
      <button
        type="button"
        onClick={onClose}
        className="mt-5 min-h-[52px] w-full rounded-2xl bg-slate-900 px-4 py-3 text-base font-black text-white"
      >
        확인
      </button>
    </div>
  </div>
);

const HelpButton = ({
  topic,
  title = "",
  body = "",
  steps = undefined,
  warning = "",
  supportPhone = undefined,
  className = "",
  label = "도움말",
  compact = false,
}: {
  topic?: HelpTopic;
  title?: string;
  body?: string;
  steps?: string[];
  warning?: string;
  supportPhone?: string;
  className?: string;
  label?: string;
  compact?: boolean;
}) => {
  const [open, setOpen] = useState(false);
  const topicContent = topic ? HELP_TOPIC_CONTENT[topic] : null;
  const content = {
    ...(topicContent || {}),
    ...(title ? { title } : {}),
    ...(body ? { body } : {}),
    ...(steps ? { steps } : {}),
    ...(warning ? { warning } : {}),
    ...(supportPhone ? { supportPhone } : {}),
  };
  if (!content.title || !content.body) return null;
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label={`${content.title} 도움말 열기`}
        className={`inline-flex shrink-0 items-center justify-center gap-1 rounded-full border border-blue-200 bg-blue-50 font-black text-blue-800 active:scale-95 ${
          compact ? "min-h-[36px] px-3 py-1.5 text-xs" : "min-h-[44px] px-4 py-2 text-sm"
        } ${className}`}
      >
        <Info className={compact ? "h-3.5 w-3.5" : "h-4 w-4"} />
        <span className="whitespace-nowrap">{label}</span>
      </button>
      {open && <HelpModal {...content} onClose={() => setOpen(false)} />}
    </>
  );
};

const ErrorHelpModal = ({
  title = "",
  message = "",
  cause = "",
  actionSteps = [],
  supportPhone = CNFOOD_SUPPORT_PHONE,
  errorCode = "",
  reportButton = false,
  onOpenReport = () => {},
  onClose = () => {},
}) => {
  if (!title && !message) return null;
  return (
    <div className="fixed inset-0 z-[10000] flex items-end justify-center bg-slate-950/50 p-3 sm:items-center">
      <div className="cnfood-readable-text max-h-[90vh] w-full max-w-md overflow-y-auto rounded-[1.5rem] bg-white p-5 text-left shadow-2xl">
        <div className="mb-4 flex items-start justify-between gap-3">
          <div className="min-w-0">
            <p className="text-xs font-black tracking-[0.16em] text-red-600">
              오류 안내
            </p>
            <h3 className="mt-1 text-xl font-black leading-snug text-slate-950 break-keep">
              {title || "계약 진행에 문제가 발생했습니다."}
            </h3>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-full bg-slate-100 p-2 text-slate-500"
            aria-label="오류 안내 닫기"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <p className="text-base font-bold leading-7 text-slate-700 break-keep whitespace-normal [word-break:keep-all]">
          {message || "입력값 또는 인증 상태를 확인한 뒤 다시 시도해 주세요."}
        </p>
        {cause && (
          <p className="mt-3 rounded-2xl border border-red-100 bg-red-50 px-4 py-3 text-sm font-bold leading-6 text-red-700 break-keep">
            원인: {cause}
          </p>
        )}
        {actionSteps.length > 0 && (
          <ol className="mt-4 space-y-2">
            {actionSteps.map((stepText, index) => (
              <li
                key={`${stepText}-${index}`}
                className="flex gap-3 rounded-2xl bg-slate-50 px-4 py-3 text-base font-bold leading-7 text-slate-700 break-keep"
              >
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-slate-900 text-sm font-black text-white">
                  {index + 1}
                </span>
                <span className="min-w-0">{stepText}</span>
              </li>
            ))}
          </ol>
        )}
        {supportPhone && (
          <p className="mt-4 rounded-2xl bg-blue-50 px-4 py-3 text-base font-black leading-7 text-blue-900 break-keep">
            문의: 씨엔푸드 메인콜센터 {supportPhone}
          </p>
        )}
        {errorCode && (
          <p className="mt-2 break-all text-xs font-bold text-slate-400">
            오류코드: {errorCode}
          </p>
        )}
        <div className="mt-5 grid grid-cols-1 gap-2 sm:grid-cols-2">
          <button
            type="button"
            onClick={onClose}
            className="min-h-[52px] rounded-2xl border border-slate-200 px-4 py-3 text-base font-black text-slate-700"
          >
            닫기
          </button>
          {reportButton ? (
            <button
              type="button"
              onClick={onOpenReport}
              className="min-h-[52px] rounded-2xl bg-red-600 px-4 py-3 text-base font-black text-white"
            >
              오류신고
            </button>
          ) : (
            <button
              type="button"
              onClick={onClose}
              className="min-h-[52px] rounded-2xl bg-slate-900 px-4 py-3 text-base font-black text-white"
            >
              확인
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

const AdminHelpBox = ({ children, className = "" }) => (
  <div
    className={`rounded-2xl border border-blue-100 bg-blue-50 px-4 py-3 text-sm font-bold leading-6 text-blue-900 break-keep ${className}`}
  >
    <div className="mb-1 flex items-center gap-2 font-black text-blue-950">
      <Info className="h-4 w-4 shrink-0" />
      관리자 운영 도움말
    </div>
    <p>{children}</p>
  </div>
);

const BusinessInfoFooter = ({ className = "" }) => {
  const rows = buildBusinessInfoFooterRows();

  return (
    <footer
      aria-label="사업자 정보"
      className={`rounded-2xl border border-slate-200 bg-white/90 px-4 py-4 text-[11px] leading-5 text-slate-500 shadow-sm ${className}`}
    >
      <p className="mb-2 text-xs font-black text-slate-700">
        씨엔푸드 사업자정보
      </p>
      <dl className="grid grid-cols-1 gap-x-3 gap-y-1 sm:grid-cols-2">
        {rows.map((row) => (
          <div key={row.label} className="min-w-0">
            <dt className="inline font-bold text-slate-600">{row.label}: </dt>
            <dd
              className={`inline whitespace-normal ${
                row.label === "사업장 주소" ? "break-keep" : "break-words"
              }`}
            >
              {row.value}
            </dd>
          </div>
        ))}
      </dl>
    </footer>
  );
};

const TextSizeControls = ({
  textSizeMode = "MEDIUM",
  onTextSizeModeChange,
  className = "",
  compact = false,
}: {
  textSizeMode?: TextSizeMode;
  onTextSizeModeChange: (mode: TextSizeMode) => void;
  className?: string;
  compact?: boolean;
}) => {
  const options: Array<{ mode: TextSizeMode; label: string }> = [
    { mode: "MEDIUM", label: "중간보기" },
    { mode: "LARGE", label: "크게보기" },
  ];

  return (
    <section
      aria-label="글자 크기 보기 옵션"
      className={`cnfood-text-size-control rounded-2xl border border-slate-200 bg-white/90 p-3 shadow-sm ${className}`}
    >
      <div
        className={`flex ${
          compact ? "flex-col gap-2 sm:flex-row sm:items-center" : "flex-col gap-3"
        }`}
      >
        <p className="cnfood-readable-text text-sm font-bold leading-6 text-slate-600 break-keep whitespace-normal [word-break:keep-all]">
          글자가 작게 보이면 크게보기를 선택해 주세요.
        </p>
        <div
          role="group"
          aria-label="글자 크기 선택"
          className="grid min-w-[176px] grid-cols-2 gap-2"
        >
          {options.map((option) => {
            const selected = textSizeMode === option.mode;
            return (
              <button
                key={option.mode}
                type="button"
                aria-pressed={selected}
                onClick={() => onTextSizeModeChange(option.mode)}
                className={`min-h-[44px] rounded-xl border px-3 py-2 text-sm font-black transition focus:outline-none focus:ring-2 focus:ring-blue-200 ${
                  selected
                    ? "border-blue-700 bg-blue-700 text-white shadow-sm"
                    : "border-slate-200 bg-white text-slate-700"
                }`}
              >
                {option.label}
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
};

const ContractAppStatusBanner = ({
  appStatus = buildContractAppStatus(),
  compact = false,
  className = "",
}) => {
  const status = buildContractAppStatus(appStatus);
  if (!shouldShowContractAppStatusBanner(status)) return null;
  const tone =
    status.status === "FULL_PAUSED" || status.status === "ADMIN_TEST_ONLY"
      ? "border-red-200 bg-red-50 text-red-950"
      : status.status === "START_PAUSED"
      ? "border-amber-200 bg-amber-50 text-amber-950"
      : "border-blue-100 bg-blue-50 text-blue-950";
  const iconTone =
    status.status === "FULL_PAUSED" || status.status === "ADMIN_TEST_ONLY"
      ? "bg-red-100 text-red-700"
      : status.status === "START_PAUSED"
      ? "bg-amber-100 text-amber-700"
      : "bg-blue-100 text-blue-700";

  return (
    <section
      className={`${className} rounded-3xl border ${tone} p-4 text-left shadow-sm`}
      aria-live="polite"
    >
      <div className="flex items-start gap-3">
        <div className={`mt-0.5 flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl ${iconTone}`}>
          {status.status === "NOTICE_ONLY" || status.status === "OPEN" ? (
            <Info className="h-5 w-5" />
          ) : (
            <AlertTriangle className="h-5 w-5" />
          )}
        </div>
        <div className="min-w-0">
          <p className="text-xs font-black tracking-[0.12em] opacity-75">
            {getContractAppStatusDisplayName(status.status)}
          </p>
          <h3
            className={`mt-1 font-black leading-snug break-keep whitespace-normal [word-break:keep-all] ${
              compact ? "text-base" : "text-lg"
            }`}
          >
            {status.title}
          </h3>
          <p className="mt-2 whitespace-pre-line text-sm font-bold leading-relaxed break-keep [word-break:keep-all]">
            {status.message}
          </p>
          {status.expectedResumeAt && (
            <p className="mt-2 text-sm font-black leading-6 break-keep">
              예상 재개 시간: {status.expectedResumeAt}
            </p>
          )}
          {status.supportPhone && (
            <p className="mt-2 text-sm font-black leading-6 break-keep">
              문의: 씨엔푸드 메인콜센터 {status.supportPhone}
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      message: sanitizeLogText(error?.message || "Unknown error"),
    };
  }

  componentDidCatch(error, info) {
    console.error("[CNFOOD] React render error", sanitizeErrorForLog(error), {
      componentStack: sanitizeLogText(info?.componentStack || ""),
    });
    reportError("REACT_ERROR_BOUNDARY", error?.message || "Unknown error", "APP", {
      stack: error?.stack || null,
      componentStack: info?.componentStack || null,
    });
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-10">
        <div className="w-full max-w-sm rounded-3xl bg-white p-6 shadow-xl border border-slate-100 text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-amber-50 text-amber-600">
            <AlertCircle className="h-6 w-6" />
          </div>
          <h1 className="text-lg font-black text-slate-900">
            일시적인 오류가 발생했습니다.
          </h1>
          <p className="mt-2 text-sm leading-6 text-slate-500">
            화면을 다시 불러오면 대부분 복구됩니다. 문제가 반복되면 관리자에게 문의해 주세요.
          </p>
          <div className="mt-5 grid grid-cols-1 gap-2">
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="rounded-2xl bg-slate-900 px-4 py-3 text-sm font-black text-white"
            >
              새로고침
            </button>
            <button
              type="button"
              onClick={() => {
                window.location.href = `${window.location.origin}${window.location.pathname}`;
              }}
              className="rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-black text-slate-700"
            >
              처음으로 돌아가기
            </button>
          </div>
          <p className="mt-4 text-[11px] text-slate-400">
            관리자에게 문의할 때 현재 시간과 사용 기기를 함께 알려주세요.
          </p>
        </div>
      </div>
    );
  }
}

const ContractIntroPage = ({
  onStart,
  onAdminAccess,
  onOpenPrivacy,
  invite,
  inviteMessage = "",
  textSizeMode = "MEDIUM",
  onTextSizeModeChange = () => {},
  appStatus = buildContractAppStatus(),
  appStatusLoaded = true,
  isAdminSession = false,
  identityTestModeEnabled = false,
}) => {
  const [showUpdateDetails, setShowUpdateDetails] = useState(false);
  const valueCards = [
    {
      title: "안정감",
      description: "안전한 시스템과 철저한 보안",
      icon: ShieldCheck,
      accent: "from-blue-50 to-sky-100 text-blue-800",
    },
    {
      title: "신선함",
      description: "수산·식품 유통에 최적화",
      icon: Leaf,
      accent: "from-teal-50 to-emerald-100 text-teal-700",
    },
    {
      title: "배송",
      description: "빠르고 정확한 배송 지원",
      icon: Truck,
      accent: "from-sky-50 to-blue-100 text-blue-700",
    },
    {
      title: "품질",
      description: "엄격한 품질 관리와 신뢰",
      icon: Award,
      accent: "from-cyan-50 to-teal-100 text-teal-700",
    },
  ];
  const contractSteps = [
    { title: "계약 정보 입력", icon: FileText },
    { title: "상대방 확인", icon: UserCheck },
    { title: "계약 내용 검토", icon: ClipboardCheck },
    { title: "전자서명 및 완료", icon: ShieldCheck },
  ];
  const startGate = canStartNewContract(appStatus, {
    isAdmin: isAdminSession,
    statusLoaded: appStatusLoaded,
  });
  const startDisabled = Boolean(inviteMessage) || !startGate.allowed;

  return (
    <div
      className={`${getTextSizeModeClassName(
        textSizeMode
      )} min-h-screen bg-gradient-to-b from-white via-sky-50 to-white px-4 py-4 text-slate-900`}
      style={{ fontFamily: '"Noto Sans KR", sans-serif' }}
    >
      <style>{`
        ${TEXT_SIZE_MODE_STYLE}
        @keyframes cnfoodShimmer {
          0% { background-position: -180% 0; }
          100% { background-position: 180% 0; }
        }
        @keyframes cnfoodPulse {
          0%, 100% { box-shadow: 0 18px 44px rgba(14, 71, 151, 0.28), 0 0 0 0 rgba(45, 212, 191, 0.22); }
          50% { box-shadow: 0 22px 54px rgba(14, 71, 151, 0.38), 0 0 0 9px rgba(45, 212, 191, 0); }
        }
        @keyframes cnfoodFloat {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-5px); }
        }
        @keyframes cnfoodLogoSoftGlow {
          0%, 100% { box-shadow: 0 10px 26px rgba(255, 255, 255, 0.16); transform: translateY(0); }
          45% { box-shadow: 0 14px 34px rgba(144, 231, 255, 0.34); transform: translateY(-1px); }
        }
        @keyframes cnfoodHeroShimmerSweep {
          0% { transform: translateX(-140%) rotate(10deg); opacity: 0; }
          22% { opacity: 0.18; }
          48% { opacity: 0.08; }
          100% { transform: translateX(150%) rotate(10deg); opacity: 0; }
        }
        @keyframes cnfoodPremiumGlow {
          0%, 100% { box-shadow: 0 24px 54px rgba(8, 47, 103, 0.22), inset 0 1px 0 rgba(255, 255, 255, 0.12); }
          50% { box-shadow: 0 30px 72px rgba(8, 88, 156, 0.32), 0 0 0 1px rgba(125, 211, 252, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.22); }
        }
        @keyframes cnfoodCtaEntrance {
          0% { opacity: 0.82; transform: translateY(10px) scale(0.985); }
          58% { opacity: 1; transform: translateY(-2px) scale(1.018); }
          100% { opacity: 1; transform: translateY(0) scale(1); }
        }
        @keyframes cnfoodCtaShimmerOnce {
          0% { transform: translateX(-145%) skewX(-18deg); opacity: 0; }
          20% { opacity: 0.45; }
          100% { transform: translateX(160%) skewX(-18deg); opacity: 0; }
        }
        @keyframes cnfoodIdentityCtaGlow {
          0%, 100% { box-shadow: 0 18px 36px rgba(6, 182, 212, 0.28), 0 0 0 0 rgba(125, 211, 252, 0.2); }
          50% { box-shadow: 0 24px 52px rgba(14, 165, 233, 0.4), 0 0 0 8px rgba(125, 211, 252, 0); }
        }
        @keyframes cnfoodIdentityCtaShimmer {
          0% { transform: translateX(-150%) rotate(12deg); opacity: 0; }
          24% { opacity: 0.5; }
          100% { transform: translateX(260%) rotate(12deg); opacity: 0; }
        }
        @keyframes cnfoodButtonReadyPulse {
          0% { transform: scale(1); box-shadow: 0 18px 38px rgba(220, 38, 38, 0.18); }
          45% { transform: scale(1.025); box-shadow: 0 22px 52px rgba(220, 38, 38, 0.32), 0 0 0 8px rgba(248, 113, 113, 0.12); }
          100% { transform: scale(1); box-shadow: 0 18px 38px rgba(220, 38, 38, 0.18); }
        }
        .cnfood-premium-glow {
          animation: cnfoodPremiumGlow 5.8s ease-in-out infinite;
        }
        .cnfood-intro-logo-glow {
          animation: cnfoodLogoSoftGlow 4.8s ease-in-out infinite;
        }
        .cnfood-intro-hero-shimmer {
          position: relative;
          overflow: hidden;
        }
        .cnfood-intro-hero-shimmer::after {
          content: "";
          position: absolute;
          inset: -45% auto -45% -32%;
          width: 34%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.32), transparent);
          transform: translateX(-140%) rotate(10deg);
          animation: cnfoodHeroShimmerSweep 6.8s ease-in-out infinite;
          pointer-events: none;
        }
        .cnfood-button-ready-pulse {
          animation: cnfoodButtonReadyPulse 900ms ease-out 1;
          will-change: transform, box-shadow;
        }
        .cnfood-sea-title {
          background: linear-gradient(110deg, #eef6ff 0%, #ffffff 18%, #90e7ff 38%, #ffffff 54%, #d7ecff 72%, #ffffff 100%);
          background-size: 220% 100%;
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          animation: cnfoodShimmer 5.5s ease-in-out infinite;
        }
        .cnfood-cta-pulse { animation: cnfoodPulse 3.4s ease-in-out infinite; }
        .cnfood-intro-primary-cta {
          position: relative;
          overflow: hidden;
          animation: cnfoodCtaEntrance 760ms ease-out 1, cnfoodPulse 3.8s ease-in-out 900ms infinite;
          will-change: transform, box-shadow;
        }
        .cnfood-intro-primary-cta::after {
          content: "";
          position: absolute;
          inset: -22% auto -22% -28%;
          width: 30%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.42), transparent);
          animation: cnfoodCtaShimmerOnce 1.5s ease-out 420ms 1;
          pointer-events: none;
        }
        .cnfood-identity-cta-glow {
          animation: cnfoodIdentityCtaGlow 3.8s ease-in-out infinite;
          will-change: box-shadow;
        }
        .cnfood-identity-cta-shimmer {
          animation: cnfoodIdentityCtaShimmer 4.6s ease-in-out infinite;
        }
        .cnfood-float { animation: cnfoodFloat 5s ease-in-out infinite; }
        @media (prefers-reduced-motion: reduce) {
          .cnfood-sea-title,
          .cnfood-cta-pulse,
          .cnfood-intro-primary-cta,
          .cnfood-premium-glow,
          .cnfood-float,
          .cnfood-intro-logo-glow,
          .cnfood-intro-hero-shimmer::after,
          .cnfood-intro-primary-cta::after,
          .cnfood-identity-cta-glow,
          .cnfood-identity-cta-shimmer,
          .cnfood-button-ready-pulse {
            animation: none;
            transition: none;
          }
        }
      `}</style>
      <div className="mx-auto flex min-h-[calc(100vh-2.5rem)] w-full max-w-md flex-col">
        <div className="cnfood-premium-glow relative overflow-hidden rounded-[2rem] bg-gradient-to-br from-[#071b46] via-[#0a3d78] to-[#0b78a8] px-5 pb-5 pt-4 text-white shadow-2xl shadow-blue-950/20">
          <div className="absolute -left-16 top-20 h-36 w-36 rounded-full border border-cyan-200/20" />
          <div className="absolute -right-12 top-8 h-28 w-28 rounded-full bg-cyan-300/10 blur-2xl" />
          <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-cyan-300/15 to-transparent" />
          <button
            type="button"
            onClick={onAdminAccess}
            aria-label="관리자 접속"
            className="absolute right-4 top-4 z-10 rounded-full border border-white/15 bg-white/10 p-2 text-white/75 transition hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-cyan-200"
          >
            <Lock className="h-4 w-4" />
          </button>
          <div className="relative flex flex-col items-center text-center">
            <div className="cnfood-intro-logo-glow mb-2 flex h-14 w-14 items-center justify-center rounded-2xl bg-white/95 shadow-lg">
              <img src={LOGO_URL} alt="CN FOOD" className="h-10 w-10 object-contain" />
            </div>
            <p className="text-xs font-black tracking-[0.28em] text-cyan-100">
              CN FOOD
            </p>
            <div className="cnfood-intro-hero-shimmer mt-4 w-full rounded-[2rem] border border-white/25 bg-[#08275b]/85 px-4 py-5 shadow-2xl shadow-slate-950/35 backdrop-blur">
              <div className="mb-4 flex items-center justify-center gap-2 text-cyan-200">
                <Waves className="h-5 w-5" />
                <span className="h-px w-16 bg-cyan-300/60" />
              </div>
              <h1
                className="cnfood-sea-title text-4xl font-black leading-none tracking-normal sm:text-5xl"
                style={{ fontFamily: "Georgia, 'Times New Roman', serif" }}
              >
                Sea&Food
              </h1>
              <h2 className="mt-4 text-2xl font-black tracking-tight sm:text-3xl">
                전자계약 작성 안내
              </h2>
              <p className="mt-3 text-base font-bold leading-7 text-cyan-100 break-keep whitespace-normal [word-break:keep-all] [text-wrap:balance]">
                수산·식품 유통에 최적화된{" "}
                <span className="whitespace-nowrap">계약 플랫폼</span>
              </p>
            </div>
          </div>
        </div>
      {identityTestModeEnabled && (
        <div className="mx-auto mb-4 max-w-3xl rounded-2xl border-2 border-red-200 bg-red-50 px-4 py-3 text-red-900 shadow-sm">
          <span className="rounded-full bg-red-700 px-3 py-1 text-xs font-black uppercase tracking-[0.16em] text-white">
            TEST MODE
          </span>
          <p className="mt-2 text-sm font-bold leading-6 break-keep">
            ENABLE_IDENTITY_TEST_MODE=true 상태입니다. TEST_SIMULATION은 실제 KCP/PASS 인증이 아니며 법적 제출용 증빙으로 표시하지 않습니다.
          </p>
        </div>
      )}
        <main className="flex-1 px-1 pb-6 pt-4">
          <section className="text-center">
            <p className="text-lg font-bold leading-8 text-slate-700 break-keep whitespace-normal [word-break:keep-all] [text-wrap:balance]">
              씨앤푸드 전자계약은{" "}
              <span className="whitespace-nowrap text-blue-700">안전하고 간편합니다.</span>
              <br />
              지금 바로 신뢰할 수 있는 계약을 시작하세요.
            </p>
          </section>

          <button
            type="button"
            onClick={onStart}
            disabled={startDisabled}
            className="cnfood-intro-primary-cta mt-4 flex min-h-[66px] w-full items-center justify-center gap-3 rounded-[1.7rem] border border-cyan-200 bg-gradient-to-r from-[#06255a] via-[#0754a3] to-[#0485ad] px-5 py-5 text-xl font-black text-white shadow-2xl shadow-blue-900/30 ring-1 ring-cyan-100/60 transition active:scale-[0.98] focus:outline-none focus:ring-4 focus:ring-cyan-200 disabled:opacity-50 disabled:active:scale-100 sm:text-2xl"
          >
            <PenTool className="h-6 w-6 text-cyan-200 sm:h-7 sm:w-7" />
            {startGate.allowed ? "전자계약 시작하기" : "현재 신규 작성 일시중단"}
            <ChevronRight className="h-6 w-6 sm:h-7 sm:w-7" />
          </button>
          <p className="mt-3 text-center text-sm font-black leading-6 text-blue-800 break-keep">
            1~2분 내 간편하게 작성할 수 있습니다.
          </p>
          <TextSizeControls
            textSizeMode={textSizeMode}
            onTextSizeModeChange={onTextSizeModeChange}
            className="mt-4"
          />
          <ContractAppStatusBanner appStatus={appStatus} className="mt-4" />
          <section className="mt-4 rounded-3xl border border-blue-100 bg-white/95 p-4 text-left shadow-lg shadow-blue-100/60">
            <div className="flex items-center gap-2">
              <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-2xl bg-blue-50 text-blue-700">
                <ShieldCheck className="h-5 w-5" />
              </div>
              <span className="rounded-full bg-blue-50 px-3 py-1 text-xs font-black tracking-[0.12em] text-blue-700">
                업데이트 안내 v5
              </span>
            </div>
            <h3 className="cnfood-readable-text mt-3 text-lg font-black leading-7 text-slate-950 break-keep whitespace-normal [word-break:keep-all]">
              전자계약 작성 안정성과 대표자 확인 기능이 강화되었습니다.
            </h3>
            <p className="cnfood-readable-text mt-2 text-sm font-bold leading-6 text-slate-700 break-keep whitespace-normal [word-break:keep-all]">
              더 안전한 계약 진행을 위해 대표자 확인, 공동사업자 안내, 서명 증빙, 중복 저장 방지 기능을 개선했습니다.
            </p>
            <div className="mt-3 grid grid-cols-1 gap-2 text-sm font-black leading-6 text-slate-700">
              {INTRO_UPDATE_HIGHLIGHTS.map((item) => (
                <div
                  key={item}
                  className="flex items-start gap-2 rounded-2xl bg-slate-50 px-3 py-2 break-keep whitespace-normal [word-break:keep-all]"
                >
                  <CheckCircle className="mt-0.5 h-4 w-4 shrink-0 text-blue-700" />
                  <span>{item}</span>
                </div>
              ))}
            </div>
            {showUpdateDetails && (
              <div className="mt-4 rounded-3xl border border-slate-100 bg-slate-50 p-3">
                <div className="mb-3">
                  <h4 className="text-base font-black leading-6 text-slate-950">
                    업데이트 기록
                  </h4>
                  <p className="mt-1 text-xs font-bold leading-5 text-slate-500 break-keep">
                    v0부터 현재 버전까지 개선된 내용을 확인할 수 있습니다.
                  </p>
                </div>
                <div className="space-y-3">
                  {UPDATE_NOTES.map((note) => (
                    <article
                      key={note.version}
                      className="rounded-2xl border border-blue-50 bg-white px-3 py-3 shadow-sm"
                    >
                      <div className="flex items-start gap-2">
                        <span className="mt-0.5 rounded-full bg-blue-600 px-2 py-0.5 text-[11px] font-black text-white">
                          {note.version}
                        </span>
                        <div className="min-w-0">
                          <h5 className="text-sm font-black leading-6 text-slate-900 break-keep">
                            {note.title}
                          </h5>
                          <p className="mt-1 text-xs font-bold leading-5 text-slate-600 break-keep">
                            {note.summary}
                          </p>
                        </div>
                      </div>
                      <ul className="mt-2 space-y-1.5 text-xs font-bold leading-5 text-slate-600">
                        {note.items.map((item) => (
                          <li key={item} className="flex items-start gap-2 break-keep">
                            <CheckCircle className="mt-0.5 h-3.5 w-3.5 shrink-0 text-blue-600" />
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>
                    </article>
                  ))}
                </div>
              </div>
            )}
            <div className="mt-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
              <button
                type="button"
                onClick={() => setShowUpdateDetails((prev) => !prev)}
                className="inline-flex min-h-[44px] items-center justify-center gap-2 rounded-2xl border border-blue-200 bg-blue-50 px-4 py-2 text-sm font-black text-blue-800"
              >
                {showUpdateDetails ? "접기" : "자세히 보기"}
                <ChevronDown
                  className={`h-4 w-4 transition-transform ${
                    showUpdateDetails ? "rotate-180" : ""
                  }`}
                />
              </button>
              <p className="text-sm font-black leading-6 text-slate-700 break-keep">
                문의: {INTRO_UPDATE_SUPPORT_TEXT}
              </p>
            </div>
          </section>
          <div className="mt-4 flex items-center justify-center gap-3 text-sm font-bold text-slate-500">
            <span className="inline-flex items-center gap-1">
              <Clock3 className="h-4 w-4" /> 약 3~5분 소요
            </span>
            <span className="h-4 w-px bg-slate-300" />
            <span className="inline-flex items-center gap-1">
              <LockKeyhole className="h-4 w-4" /> 안전하게 보호됩니다
            </span>
          </div>

          {(invite || inviteMessage) && (
            <section
              className={`mt-6 rounded-3xl border p-5 text-left shadow-lg ${
                inviteMessage
                  ? "border-amber-200 bg-amber-50 text-amber-900"
                  : "border-cyan-100 bg-white text-slate-800"
              }`}
            >
              <p className="text-xs font-black tracking-[0.18em] text-blue-700">
                CN FOOD 전자계약 요청
              </p>
              {inviteMessage ? (
                <p className="mt-3 text-sm font-bold leading-6">
                  {inviteMessage}
                </p>
              ) : (
                <>
                  <h3 className="mt-2 text-lg font-black text-slate-900">
                    {invite.customerName} 공급계약서 작성을 요청드립니다.
                  </h3>
                  <div className="mt-3 space-y-1 text-sm font-bold text-slate-600">
                    <p>관리 주체: {getInviteOwnerLabel(invite)}</p>
                    {buildInviteContractFields(invite).ownerType === "SALES_REP" && (
                      <>
                        <p>요청 부서: {invite.salesPart || invite.salesRepDepartmentPart || "미수집"}</p>
                        <p>담당자: {invite.salesRepName || "미수집"}</p>
                        <p>연락처: {invite.salesRepPhoneMasked || "미수집"}</p>
                      </>
                    )}
                  </div>
                  <p className="mt-3 rounded-2xl bg-cyan-50 p-3 text-xs font-bold leading-5 text-cyan-800">
                    위 관리 주체의 요청으로 전자계약 작성을 진행합니다.
                  </p>
                </>
              )}
            </section>
          )}

          <section className="mt-7 grid grid-cols-2 gap-3">
            {valueCards.map((card) => {
              const Icon = card.icon;
              return (
                <div
                  key={card.title}
                  className="flex min-h-[172px] flex-col rounded-3xl border border-slate-100 bg-white p-3.5 text-center shadow-lg shadow-slate-200/60 sm:p-4"
                >
                  <div
                    className={`cnfood-float mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-gradient-to-br ${card.accent} sm:h-16 sm:w-16`}
                  >
                    <Icon className="h-7 w-7 sm:h-8 sm:w-8" />
                  </div>
                  <h3 className="text-lg font-black text-slate-900">
                    {card.title}
                  </h3>
                  <div className="mx-auto my-2 h-1 w-7 rounded-full bg-teal-400" />
                  <p className="mx-auto max-w-[8.5rem] text-[13px] font-bold leading-6 text-slate-600 break-keep whitespace-normal [word-break:keep-all] [text-wrap:balance] sm:max-w-[9.5rem] sm:text-sm">
                    {card.description}
                  </p>
                </div>
              );
            })}
          </section>

          <section className="mt-7 rounded-3xl border border-slate-100 bg-white p-5 shadow-lg shadow-slate-200/60">
            <div className="mb-5 flex items-center justify-center gap-2">
              <span className="h-2 w-2 rounded-full bg-teal-400" />
              <h3 className="text-lg font-black text-slate-900">
                간편한 전자계약 절차
              </h3>
              <span className="h-2 w-2 rounded-full bg-teal-400" />
            </div>
            <div className="grid grid-cols-4 gap-2">
              {contractSteps.map((item, index) => {
                const Icon = item.icon;
                return (
                  <div key={item.title} className="text-center">
                    <div className="relative mx-auto mb-2 flex h-14 w-14 items-center justify-center rounded-full border border-slate-100 bg-slate-50 shadow-inner">
                      <span className="absolute -left-1 -top-1 flex h-6 w-6 items-center justify-center rounded-full bg-blue-900 text-[11px] font-black text-white">
                        {index + 1}
                      </span>
                      <Icon className="h-7 w-7 text-blue-800" />
                    </div>
                    <p className="text-[11px] font-black leading-4 text-slate-700">
                      {item.title}
                    </p>
                  </div>
                );
              })}
            </div>
          </section>

          <button
            type="button"
            onClick={onOpenPrivacy}
            className="mx-auto mt-4 flex items-center justify-center gap-2 rounded-full px-3 py-2 text-sm font-bold text-blue-700 transition hover:bg-blue-50 focus:outline-none focus:ring-2 focus:ring-blue-200"
          >
            <FileText className="h-4 w-4" />
            개인정보 처리방침 및 이용 안내 보기
            <ChevronRight className="h-4 w-4" />
          </button>
          <BusinessInfoFooter className="mt-5" />
        </main>
      </div>
    </div>
  );
};

const ConfirmPanel = ({
  title,
  message,
  confirmLabel = "확인",
  cancelLabel = "취소",
  tone = "warning",
  busy = false,
  onConfirm,
  onCancel,
}) => {
  const toneStyles =
    tone === "danger"
      ? {
          wrapper: "border-red-200 bg-red-50",
          title: "text-red-900",
          message: "text-red-700",
          confirm: "bg-red-600 text-white",
        }
      : {
          wrapper: "border-amber-200 bg-amber-50",
          title: "text-amber-900",
          message: "text-amber-700",
          confirm: "bg-slate-900 text-white",
        };

  return (
    <div className={`rounded-2xl border p-4 shadow-sm ${toneStyles.wrapper}`}>
      <div className="flex items-start gap-3">
        <div className="mt-0.5 rounded-full bg-white/70 p-2">
          <AlertCircle className="h-4 w-4 text-current" />
        </div>
        <div className="flex-1">
          <p className={`text-sm font-black ${toneStyles.title}`}>{title}</p>
          <p className={`mt-1 whitespace-pre-line text-xs leading-6 ${toneStyles.message}`}>
            {message}
          </p>
          <div className="mt-4 flex gap-2">
            <button
              type="button"
              onClick={onCancel}
              disabled={busy}
              className="flex-1 rounded-xl border border-white/70 bg-white px-3 py-2 text-sm font-bold text-slate-600 disabled:opacity-50"
            >
              {cancelLabel}
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={busy}
              className={`flex-1 rounded-xl px-3 py-2 text-sm font-black disabled:opacity-50 ${toneStyles.confirm}`}
            >
              {busy ? "처리 중..." : confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const ContractExitConfirmModal = ({
  open = false,
  onContinue,
  onExit,
}) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[10020] flex items-center justify-center bg-slate-950/70 px-4 backdrop-blur-sm"
      role="presentation"
    >
      <section
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="contract-exit-confirm-title"
        aria-describedby="contract-exit-confirm-description"
        className="w-full max-w-sm rounded-3xl border border-red-100 bg-white p-6 shadow-2xl"
      >
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-red-50 text-red-600">
          <AlertTriangle className="h-7 w-7" />
        </div>
        <h2
          id="contract-exit-confirm-title"
          className="mt-4 text-center text-xl font-black leading-tight text-slate-950 break-keep"
        >
          작성 중인 내용이 모두 사라집니다
        </h2>
        <p
          id="contract-exit-confirm-description"
          className="mt-3 whitespace-pre-line text-center text-base font-bold leading-7 text-slate-600 break-keep"
        >
          초기화면으로 이동하면 현재 작성 중인 내용이 모두 삭제되고 복구할 수
          없습니다.{"\n"}초기화면으로 이동하시겠습니까?
        </p>
        <div className="mt-6 grid grid-cols-1 gap-3">
          <button
            type="button"
            onClick={onContinue}
            className="min-h-[54px] rounded-2xl bg-slate-900 px-4 py-3 text-base font-black text-white"
          >
            기존 화면에서 계속 작성
          </button>
          <button
            type="button"
            onClick={onExit}
            className="min-h-[54px] rounded-2xl border-2 border-red-200 bg-red-50 px-4 py-3 text-base font-black text-red-700"
          >
            작성 내용 삭제 후 초기화면
          </button>
        </div>
      </section>
    </div>
  );
};

/* ================= Main App ================= */
const App = () => {
  const canvasRef = useRef(null);
  const canvasRef2 = useRef(null);
  const contractCanvasRef = useRef(null);
  const auditCanvasRef = useRef(null);
  const customerFlowCaptureRef = useRef<HTMLDivElement | null>(null);
  const postcodeRef = useRef(null);
  const postcodeContainerRef = useRef(null);
  const detailAddrRef = useRef(null);
  const contractPreviewRef = useRef(null);
  const paymentBatchFileInputRef = useRef(null);
  const auditLogsRef = useRef([]);
  const recaptchaVerifierRef = useRef(null);
  const recaptchaWidgetIdRef = useRef(null);
  const confirmationResultRef = useRef(null);
  const contractEventQueueRef = useRef([]);
  const draftCreatedEventQueuedRef = useRef(false);
  const contractScrolledEventLoggedRef = useRef(false);
  const completedEventFailureReportedKeysRef = useRef(new Set<string>());
  const runtimeLogFingerprintRef = useRef(new Map<string, number>());
  const offlineStartedAtRef = useRef<number | null>(null);
  const offlineLogTimerRef = useRef<number | null>(null);
  const lastUserErrorReportSubmitRef = useRef<{
    fingerprint: string;
    submittedAtMs: number;
  } | null>(null);
  const signatureStrokeCountRef = useRef(0);
  const signature2StrokeCountRef = useRef(0);
  const coRepresentativeSignatureCanvasRefs = useRef<Record<string, HTMLCanvasElement | null>>({});
  const agentNameInputRef = useRef<HTMLInputElement | null>(null);
  const agentRepInputRef = useRef<HTMLInputElement | null>(null);
  const agentBizNoInputRef = useRef<HTMLInputElement | null>(null);
  const representativeBirthDateInputRef = useRef<HTMLInputElement | null>(null);
  const openingDateInputRef = useRef<HTMLInputElement | null>(null);
  const agentContactInputRef = useRef<HTMLInputElement | null>(null);
  const agentAddressInputRef = useRef<HTMLInputElement | null>(null);
  const depositDayInputRef = useRef<HTMLInputElement | null>(null);
  const corpRepNameInputRef = useRef<HTMLInputElement | null>(null);
  const corpRepAddressInputRef = useRef<HTMLInputElement | null>(null);
  const principalRepSsnFrontInputRef = useRef<HTMLInputElement | null>(null);
  const principalRepSsnBackInputRef = useRef<HTMLInputElement | null>(null);
  const guarantorSsnFrontInputRef = useRef<HTMLInputElement | null>(null);
  const guarantorSsnBackInputRef = useRef<HTMLInputElement | null>(null);
  const requiredConsentRefs = useRef<
    Partial<Record<RequiredConsentKey, HTMLElement | null>>
  >({});
  const corepKcpReturnContext = loadCorepKcpReturnContext();
  const isCorepInviteRoute = shouldRouteToCorepInviteFlow({
    context: corepKcpReturnContext,
  });
  const corepInviteTokenForRoute = getCorepInviteTokenFromCorepRoute({
    context: corepKcpReturnContext,
  });
  const corepInviteTokenHashForRoute = getCorepInviteTokenHashFromCorepRoute({
    context: corepKcpReturnContext,
  });
  const corepSignatureOnlyForRoute = getCorepSignatureOnlyFromUrl();

  const [step, setStep] = useState(0);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingContext, setLoadingContext] = useState<LoadingContext>(null);
  const [isSigned, setIsSigned] = useState(false);
  const [signatureStrokeCount, setSignatureStrokeCount] = useState(0);
  const [signature2StrokeCount, setSignature2StrokeCount] = useState(0);
  const [signatureHash, setSignatureHash] = useState<string | null>(null);
  const [signature2Hash, setSignature2Hash] = useState<string | null>(null);
  const [imageGenerating, setImageGenerating] = useState(false);
  const [isSubmittingFinal, setIsSubmittingFinal] = useState(false);
  const submitContractInFlightRef = useRef(false);
  const pendingSavedDocumentIdRef = useRef<string | null>(null);
  const pendingSubmittedContractRef = useRef<any | null>(null);
  const [transitioning, setTransitioning] = useState(false); // 화면 전환 로딩 상태
  const [showIntroPage, setShowIntroPage] = useState(true);
  const [showContractExitConfirm, setShowContractExitConfirm] = useState(false);
  const contractExitAllowedRef = useRef(false);
  const stepRef = useRef(step);
  const showIntroPageRef = useRef(showIntroPage);
  const kcpVerifiedNavigationPendingRef = useRef(false);
  const kcpVerifiedNavigationRetryRef = useRef<number | null>(null);
  const kcpLaunchFallbackTimerRef = useRef<number | null>(null);
  const kcpLaunchTimeoutRef = useRef<number | null>(null);
  const kcpLaunchAttemptStartedAtRef = useRef<number | null>(null);
  const [textSizeMode, setTextSizeMode] = useState<TextSizeMode>(() =>
    loadTextSizeMode()
  );

  const [viewMode, setViewMode] = useState<ViewMode>("FORM");
  const [adminAccessMode, setAdminAccessMode] =
    useState<AdminAccessMode>("ADMIN");
  const [adminTestModeAuthorized, setAdminTestModeAuthorized] = useState(false);
  const [adminContractStartMode, setAdminContractStartMode] = useState(false);
  const [identityTestDeviceAuthorized, setIdentityTestDeviceAuthorized] =
    useState(false);
  const [adminPassword, setAdminPassword] = useState("");
  const adminSessionPasswordRef = useRef("");
  const [fieldPrintDialogOpen, setFieldPrintDialogOpen] = useState(false);
  const [fieldPrintPreviewOpen, setFieldPrintPreviewOpen] = useState(false);
  const [fieldPrintPages, setFieldPrintPages] = useState<string[]>([]);
  const [fieldPrintPreparing, setFieldPrintPreparing] = useState(false);
  const [fieldPrintContractType, setFieldPrintContractType] =
    useState<PrintableFieldOutputType>("CORPORATION");
  const [fieldPrintCompanyBranchId, setFieldPrintCompanyBranchId] = useState("");
  const [contractList, setContractList] = useState([]);
  const [errorReports, setErrorReports] = useState([]); // 에러 리포트 목록
  const [selectedContract, setSelectedContract] = useState(null);
  const [rejectReason, setRejectReason] = useState("");
  const [showRejectInput, setShowRejectInput] = useState(false);
  const [adminTab, setAdminTab] = useState<AdminTab>(() =>
    getDefaultAdminTabForViewport()
  );
  const [adminLogs, setAdminLogs] = useState([]);
  const [adminMemoDraft, setAdminMemoDraft] = useState("");
  const [memoSaving, setMemoSaving] = useState(false);
  const [adminContractDateDraft, setAdminContractDateDraft] = useState("");
  const [adminContractDateUpdateReason, setAdminContractDateUpdateReason] =
    useState("");
  const [adminContractDateSaving, setAdminContractDateSaving] = useState(false);
  const [showBusinessNameCorrectionModal, setShowBusinessNameCorrectionModal] =
    useState(false);
  const [businessNameCorrectionDraft, setBusinessNameCorrectionDraft] = useState({
    correctedName: "",
    reason: "",
    source: "BUSINESS_REGISTRATION_CONFIRMED",
  });
  const [businessNameCorrectionError, setBusinessNameCorrectionError] =
    useState("");
  const [businessNameCorrectionSaving, setBusinessNameCorrectionSaving] =
    useState(false);
  const [revealedSsn, setRevealedSsn] = useState<string | null>(null);
  const [revealedCoRepresentativeSsns, setRevealedCoRepresentativeSsns] =
    useState<Record<string, string>>({});
  const [ssnRevealReason, setSsnRevealReason] = useState("");
  const [ssnRevealLoading, setSsnRevealLoading] = useState(false);
  const [
    coRepresentativeSsnRevealLoadingId,
    setCoRepresentativeSsnRevealLoadingId,
  ] = useState("");
  const legalEvidenceDownloadUrlRef = useRef<string | null>(null);
  const [showLegalEvidenceModal, setShowLegalEvidenceModal] = useState(false);
  const [legalEvidenceReason, setLegalEvidenceReason] = useState("");
  const [legalEvidenceFormat, setLegalEvidenceFormat] = useState<"html" | "json">("json");
  const [legalEvidenceIncludeContractPdf, setLegalEvidenceIncludeContractPdf] =
    useState(false);
  const [legalEvidenceGenerating, setLegalEvidenceGenerating] = useState(false);
  const [legalEvidenceError, setLegalEvidenceError] = useState("");
  const [legalEvidenceDownload, setLegalEvidenceDownload] = useState<{
    url: string;
    fileName: string;
    contentType: string;
  } | null>(null);
  const [showTrashPurgeModal, setShowTrashPurgeModal] = useState(false);
  const [trashPurgeDryRun, setTrashPurgeDryRun] = useState(null);
  const [trashPurgeResult, setTrashPurgeResult] = useState(null);
  const [trashPurgeReason, setTrashPurgeReason] = useState("");
  const [trashPurgeConfirmText, setTrashPurgeConfirmText] = useState("");
  const [trashPurgeError, setTrashPurgeError] = useState("");
  const [trashPurgeLoading, setTrashPurgeLoading] = useState(false);
  const [dbBackups, setDbBackups] = useState<any[]>([]);
  const [dbBackupLoading, setDbBackupLoading] = useState(false);
  const [dbBackupCreating, setDbBackupCreating] = useState(false);
  const [dbBackupScope, setDbBackupScope] = useState<"FULL" | "PARTIAL">("FULL");
  const [dbBackupSelectedDatasetKeys, setDbBackupSelectedDatasetKeys] = useState<string[]>(
    DEFAULT_DB_BACKUP_DATASET_KEYS
  );
  const [dbBackupSummary, setDbBackupSummary] = useState("");
  const [dbBackupDescription, setDbBackupDescription] = useState("");
  const [dbRestoreSelectedBackupId, setDbRestoreSelectedBackupId] = useState("");
  const [dbRestoreScope, setDbRestoreScope] = useState<"FULL" | "PARTIAL">("FULL");
  const [dbRestoreSelectedDatasetKeys, setDbRestoreSelectedDatasetKeys] = useState<string[]>(
    DEFAULT_DB_BACKUP_DATASET_KEYS
  );
  const [dbRestoreReason, setDbRestoreReason] = useState("");
  const [dbRestoreConfirmText, setDbRestoreConfirmText] = useState("");
  const [dbRestorePreview, setDbRestorePreview] = useState<any | null>(null);
  const [dbRestoreLoading, setDbRestoreLoading] = useState(false);
  const [dbRestoreApplying, setDbRestoreApplying] = useState(false);
  const [dbBackupError, setDbBackupError] = useState("");
  const [trashPurgeApplying, setTrashPurgeApplying] = useState(false);
  const [validationSettings, setValidationSettings] =
    useState<ValidationSettings>(() => getDefaultValidationSettings());
  const [validationSettingsDraft, setValidationSettingsDraft] =
    useState<ValidationSettings>(() => getDefaultValidationSettings());
  const [contractAppStatus, setContractAppStatus] =
    useState<ContractAppStatus>(() => buildContractAppStatus());
  const [contractAppStatusDraft, setContractAppStatusDraft] =
    useState<ContractAppStatus>(() => buildContractAppStatus());
  const [contractAppStatusLoading, setContractAppStatusLoading] =
    useState(false);
  const [contractAppStatusLoaded, setContractAppStatusLoaded] =
    useState(false);
  const [contractAppStatusSaving, setContractAppStatusSaving] =
    useState(false);
  const [contractAppStatusError, setContractAppStatusError] = useState("");
  const [activeContractTemplate, setActiveContractTemplate] =
    useState<ContractTemplate | null>(null);
  const [contractTemplateDraft, setContractTemplateDraft] = useState(() => ({
    versionId: CONTRACT_DOCUMENT_VERSION,
    title: DEFAULT_CONTRACT_TEMPLATE_TITLE,
    clauses: buildNewContractTemplate({}).clauses,
    changeReason: "",
  }));
  const [contractTemplateLoading, setContractTemplateLoading] = useState(false);
  const [contractTemplateSaving, setContractTemplateSaving] = useState(false);
  const [contractTemplateError, setContractTemplateError] = useState("");
  const [contractTemplatePreviewMode, setContractTemplatePreviewMode] =
    useState<"mobile" | "desktop">("mobile");
  const [notificationEmails, setNotificationEmails] = useState<string[]>([]);
  const [notificationEmailDraft, setNotificationEmailDraft] = useState("");
  const [notificationSettingsLoading, setNotificationSettingsLoading] =
    useState(false);
  const [notificationSettingsSaving, setNotificationSettingsSaving] =
    useState(false);
  const [salesReps, setSalesReps] = useState([]);
  const [salesRepDraft, setSalesRepDraft] = useState({
    id: "",
    name: "",
    part: "",
    phone: "",
    email: "",
    active: true,
  });
  const [salesRepBulkText, setSalesRepBulkText] = useState("");
  const [salesRepsLoading, setSalesRepsLoading] = useState(false);
  const [salesRepsSaving, setSalesRepsSaving] = useState(false);
  const [salesRepStorageSource, setSalesRepStorageSource] =
    useState<SalesRepStorageSource>("EMPTY");
  const [isSavingSalesManager, setIsSavingSalesManager] = useState(false);
  const [isSavingSalesManagersBulk, setIsSavingSalesManagersBulk] =
    useState(false);
  const [inviteDraft, setInviteDraft] = useState({
    customerName: "",
    businessType: "individual",
    businessNumber: "",
    ownerValue: INVITE_OWNER_HQ_VALUE,
    salesRepId: "",
    expiresDays: "14",
    memo: "",
  });
  const [inviteResult, setInviteResult] = useState(null);
  const [inviteCreating, setInviteCreating] = useState(false);
  const [inviteCreateErrorMessage, setInviteCreateErrorMessage] = useState("");
  const [activeInvite, setActiveInvite] = useState(null);
  const [inviteLoadMessage, setInviteLoadMessage] = useState("");

  const [statusFilter, setStatusFilter] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const [salesContractSearchForm, setSalesContractSearchForm] = useState(() => ({
    keyword: "",
    businessNumber: "",
    representativeName: "",
    addressKeyword: "",
    status: "all",
    dateFrom: "",
    dateTo: "",
  }));
  const salesLookupRows = useMemo(
    () => buildSalesLookupRows(contractList),
    [contractList]
  );
  const salesContractSearchResults = useMemo(
    () => applySalesLookupFilters(salesLookupRows, salesContractSearchForm),
    [salesLookupRows, salesContractSearchForm]
  );
  const salesContractSearchTotal = salesLookupRows.length;
  const salesContractSearchMeta = useMemo(
    () => ({
      returned: salesContractSearchResults.length,
      limit: SALES_CONTRACT_SEARCH_LIMIT,
      hasMore: false,
      debugSummary: null,
    }),
    [salesContractSearchResults.length]
  );
  const [salesContractSearchLoading, setSalesContractSearchLoading] =
    useState(false);
  const [salesContractSearchError, setSalesContractSearchError] = useState("");
  const [salesAssignmentModal, setSalesAssignmentModal] = useState(null);
  const [salesAssignmentDraft, setSalesAssignmentDraft] = useState({
    nextSalesRepCode: "",
    nextSalesRepName: "",
    nextPartName: "",
    reason: "",
    syncVendorMaster: false,
  });
  const [salesAssignmentSaving, setSalesAssignmentSaving] = useState(false);
  const [salesAssignmentError, setSalesAssignmentError] = useState("");
  const [legacyContracts, setLegacyContracts] = useState([]);
  const legacyContractRows = useMemo(
    () => buildLegacyContractDisplayRows(legacyContracts),
    [legacyContracts]
  );
  const [legacyContractsLoading, setLegacyContractsLoading] = useState(false);
  const [legacyContractsError, setLegacyContractsError] = useState("");
  const [legacyImportRows, setLegacyImportRows] = useState([]);
  const [legacyImportPreview, setLegacyImportPreview] = useState(null);
  const [legacyImportApplying, setLegacyImportApplying] = useState(false);
  const [selectedLegacyContract, setSelectedLegacyContract] = useState(null);
  const [legacyDocuments, setLegacyDocuments] = useState([]);
  const [legacyHistory, setLegacyHistory] = useState([]);
  const [legacyDocumentDraft, setLegacyDocumentDraft] = useState({
    documentType: "CONTRACT",
    title: "",
    description: "",
  });
  const [legacyHistoryDraft, setLegacyHistoryDraft] = useState({
    type: "NOTE",
    title: "",
    body: "",
  });
  const [legacyDocumentUploading, setLegacyDocumentUploading] = useState(false);
  const [legacyHistorySaving, setLegacyHistorySaving] = useState(false);
  const [vendorMasters, setVendorMasters] = useState([]);
  const [companyBranches, setCompanyBranches] = useState([]);
  const companyBranchKpis = useMemo(
    () =>
      buildCompanyBranchKpis({
        branches: companyBranches,
        vendors: vendorMasters,
        electronicContracts: contractList,
        legacyContracts,
      }),
    [companyBranches, vendorMasters, contractList, legacyContracts]
  );
  const vendorMasterRows = useMemo(
    () =>
      buildVendorMasterDisplayRows({
        vendors: vendorMasters,
        electronicContracts: contractList,
        legacyContracts,
        companyBranches,
      }),
    [vendorMasters, contractList, legacyContracts, companyBranches]
  );
  const [vendorMasterFilters, setVendorMasterFilters] = useState({
    keyword: "",
    businessNumber: "",
    partName: "",
    salesManagerName: "",
    companyBranchId: "",
    linkStatus: "all",
    status: "managed",
  });
  const vendorMasterFilteredRows = useMemo(
    () => applyVendorMasterFilters(vendorMasterRows, vendorMasterFilters),
    [vendorMasterRows, vendorMasterFilters]
  );
  const visibleVendorMasterRows = useMemo(
    () => vendorMasterFilteredRows.slice(0, 100),
    [vendorMasterFilteredRows]
  );
  const vendorMasterKpis = useMemo(
    () => buildVendorMasterKpis(vendorMasterRows),
    [vendorMasterRows]
  );
  const [vendorMastersLoading, setVendorMastersLoading] = useState(false);
  const [vendorMastersError, setVendorMastersError] = useState("");
  const [vendorMastersWarning, setVendorMastersWarning] = useState("");
  const [vendorMasterView, setVendorMasterView] = useState<
    "REGISTERED" | "UNREGISTERED" | "DUPLICATES"
  >("REGISTERED");
  const [vendorMasterPagination, setVendorMasterPagination] = useState({
    cursor: "",
    nextCursor: "",
    cursorStack: [] as string[],
    returnedCount: 0,
    totalCount: 0,
    collectionTotalCount: 0,
    pageSize: 100,
    hasMore: false,
  });
  const [vendorReviewData, setVendorReviewData] = useState(null);
  const [vendorReviewLoading, setVendorReviewLoading] = useState(false);
  const [vendorReviewError, setVendorReviewError] = useState("");
  const [vendorImportRows, setVendorImportRows] = useState([]);
  const [vendorImportPreview, setVendorImportPreview] = useState(null);
  const [vendorImportApplying, setVendorImportApplying] = useState(false);
  const [vendorImportReason, setVendorImportReason] = useState("");
  const [vendorImportResult, setVendorImportResult] = useState(null);
  const [selectedVendorMaster, setSelectedVendorMaster] = useState(null);
  const [vendorMasterEditorState, setVendorMasterEditorState] = useState(null);
  const [vendorMasterSaving, setVendorMasterSaving] = useState(false);
  const [vendorLifecycleSaving, setVendorLifecycleSaving] = useState(false);
  const [vendorMasterSelectedIds, setVendorMasterSelectedIds] = useState<string[]>(
    []
  );
  const [vendorMasterBulkBranchId, setVendorMasterBulkBranchId] = useState("");
  const [vendorMasterBulkReason, setVendorMasterBulkReason] = useState("");
  const [vendorMasterBulkConfirmOpen, setVendorMasterBulkConfirmOpen] =
    useState(false);
  const [vendorMasterBulkSaving, setVendorMasterBulkSaving] = useState(false);
  const vendorMasterForm = vendorMasterEditorState?.vendor || {};
  const [vendorMasterSaveReason, setVendorMasterSaveReason] = useState("");
  const vendorMasterSimilarNames = useMemo(
    () =>
      findSimilarVendorMasterNames(
        vendorMasters,
        vendorMasterForm,
        vendorMasterEditorState?.mode === "edit"
          ? vendorMasterEditorState.vendorId
          : ""
      ),
    [vendorMasterEditorState, vendorMasterForm, vendorMasters]
  );
  const vendorMasterSelectedIdSet = useMemo(
    () => new Set(vendorMasterSelectedIds),
    [vendorMasterSelectedIds]
  );
  const vendorMasterFilteredIds = useMemo(
    () =>
      vendorMasterFilteredRows
        .map((vendor) => pickSalesLookupString(vendor.vendorId, vendor.id))
        .filter(Boolean),
    [vendorMasterFilteredRows]
  );
  const allFilteredVendorMastersSelected =
    vendorMasterFilteredIds.length > 0 &&
    vendorMasterFilteredIds.every((id) => vendorMasterSelectedIdSet.has(id));
  useEffect(() => {
    setVendorMasterSelectedIds([]);
    setVendorMasterBulkConfirmOpen(false);
  }, [vendorMasterFilters]);
  const [paymentRequests, setPaymentRequests] = useState([]);
  const [paymentRequestsMeta, setPaymentRequestsMeta] = useState(() => ({
    loaded: false,
    truncated: false,
    total: 0,
    dateFrom: "",
    dateTo: "",
  }));
  const [dashboardPaymentRange, setDashboardPaymentRange] = useState(() =>
    getDashboardPaymentLoadRange(getDashboardDateRange("MONTH"))
  );
  const dashboardPaymentLoadKeyRef = useRef("");
  const paymentRequestsLoadRequestIdRef = useRef(0);
  const [paymentHistoryFilters, setPaymentHistoryFilters] = useState(() =>
    getDefaultPaymentHistoryRange()
  );
  const [paymentManagementSection, setPaymentManagementSection] = useState<
    "OPERATIONS" | "DEPOSITS" | "ERP_BRIDGE"
  >("OPERATIONS");
  const [erpBridgeSummary, setErpBridgeSummary] = useState(null);
  const [erpBridgeLoading, setErpBridgeLoading] = useState(false);
  const [erpBridgeError, setErpBridgeError] = useState("");
  const [erpCardConfiguration, setErpCardConfiguration] = useState(null);
  const [erpCardConfigurationLoading, setErpCardConfigurationLoading] = useState(false);
  const [erpCardConfigurationSaving, setErpCardConfigurationSaving] = useState(false);
  const [erpCardConfigurationError, setErpCardConfigurationError] = useState("");
  const [paymentDirectoryState, setPaymentDirectoryState] = useState<PaymentDirectoryState>(
    () => createPaymentDirectoryState()
  );
  const paymentVendorOptions = paymentDirectoryState.vendors;
  const paymentDirectoryPagination = paymentDirectoryState.pagination;
  const [paymentVendorSearch, setPaymentVendorSearch] = useState("");
  const [paymentVendorSearchComposing, setPaymentVendorSearchComposing] =
    useState(false);
  const [paymentVendorLookupOpen, setPaymentVendorLookupOpen] = useState(false);
  const [paymentVendorActiveIndex, setPaymentVendorActiveIndex] = useState(0);
  const [paymentDirectoryLoading, setPaymentDirectoryLoading] = useState(false);
  const [paymentDirectoryLoaded, setPaymentDirectoryLoaded] = useState(false);
  const [paymentDirectoryError, setPaymentDirectoryError] = useState("");
  const [paymentDirectoryWarning, setPaymentDirectoryWarning] = useState("");
  const paymentDirectoryRequestIdRef = useRef(0);
  const paymentDirectoryLatestRequestRef = useRef<PaymentDirectoryRequestContext>({
    requestId: 0,
    query: "",
    cursor: "",
  });
  const paymentDirectoryAbortControllerRef = useRef<AbortController | null>(null);
  const paymentVendorSearchRef = useRef("");
  const paymentVendorSearchTimerRef = useRef<number | null>(null);
  const [paymentRequestsLoading, setPaymentRequestsLoading] = useState(false);
  const [paymentRequestSaving, setPaymentRequestSaving] = useState(false);
  const [paymentRequestsError, setPaymentRequestsError] = useState("");
  const [paymentOperationErrors, setPaymentOperationErrors] = useState<
    Record<string, string>
  >({});
  const [paymentOperationNotices, setPaymentOperationNotices] = useState<
    Record<string, string>
  >({});
  const [paymentLinkConfig, setPaymentLinkConfig] = useState({
    environment: "test",
    executionEnabled: false,
    profiles: LINK_PAYMENT_PROFILE_OPTIONS.map((profile) => ({
      id: profile.value,
      configured: false,
      executionEnabled: false,
    })),
  });
  const [standardPaymentConfig, setStandardPaymentConfig] = useState({
    environment: "test",
    executionEnabled: false,
    profiles: LINK_PAYMENT_PROFILE_OPTIONS.map((profile) => ({
      id: profile.value,
      configured: false,
      executionEnabled: false,
    })),
  });
  const [keyinPaymentConfig, setKeyinPaymentConfig] = useState({
    environment: "test",
    executionEnabled: false,
    profiles: KEYIN_PAYMENT_PROFILE_OPTIONS.map((profile) => ({
      id: profile.value,
      configured: false,
      executionEnabled: false,
    })),
  });
  const [autopayConfig, setAutopayConfig] = useState({
    environment: "test",
    executionEnabled: false,
    profiles: AUTOPAY_PROFILE_OPTIONS.map((profile) => ({
      id: profile.value,
      configured: false,
      executionEnabled: false,
    })),
  });
  const [autopayRegistrations, setAutopayRegistrations] = useState([]);
  const [autopayMethods, setAutopayMethods] = useState([]);
  const [autopayAction, setAutopayAction] = useState("REGISTER");
  const [selectedAutopayMethodId, setSelectedAutopayMethodId] = useState("");
  const [autopayConfirmation, setAutopayConfirmation] = useState("");
  const [autopayChargeAttempt, setAutopayChargeAttempt] = useState({
    fingerprint: "",
    key: "",
  });
  const [keyinExecutionAttempt, setKeyinExecutionAttempt] = useState({
    fingerprint: "",
    key: "",
  });
  const [autopayDeleteMethodId, setAutopayDeleteMethodId] = useState("");
  const [autopayDeleteReason, setAutopayDeleteReason] = useState("");
  const [autopayDeleteConfirmation, setAutopayDeleteConfirmation] = useState("");
  const [autopayDeleteSaving, setAutopayDeleteSaving] = useState(false);
  const [autopayVerifyMethodId, setAutopayVerifyMethodId] = useState("");
  const [autopayVerifyForm, setAutopayVerifyForm] = useState({
    cardLabel: "",
    cardLast4: "",
    reason: "",
    confirmation: "",
  });
  const [autopayVerifySaving, setAutopayVerifySaving] = useState(false);
  const [autopayPrimarySavingId, setAutopayPrimarySavingId] = useState("");
  const [paymentOperationTargetId, setPaymentOperationTargetId] = useState("");
  const [paymentOperationSavingId, setPaymentOperationSavingId] = useState("");
  const [paymentDepositSavingId, setPaymentDepositSavingId] = useState("");
  const [paymentCopyPreview, setPaymentCopyPreview] = useState<{
    kind: string;
    title: string;
    text: string;
  } | null>(null);
  const [paymentCancellationForm, setPaymentCancellationForm] = useState({
    cancellationType: "FULL",
    amount: "",
    taxAmount: "",
    vatAmount: "",
    freeAmount: "",
    reason: "",
    confirmation: "",
  });
  const [paymentCancellationAttempt, setPaymentCancellationAttempt] = useState({
    fingerprint: "",
    key: "",
  });
  const [paymentRequestForm, setPaymentRequestForm] = useState(() =>
    createEmptyPaymentRequestForm()
  );
  const paymentDirectoryRequestTypeRef = useRef(paymentRequestForm.requestType);
  const paymentDirectoryCurrentTypeRef = useRef(paymentRequestForm.requestType);
  paymentDirectoryCurrentTypeRef.current = paymentRequestForm.requestType;
  const paymentHistorySummaryRequests = useMemo(
    () =>
      filterPaymentRequestsByPeriod(paymentRequests, {
        ...paymentHistoryFilters,
        status: "ALL",
      }),
    [paymentHistoryFilters, paymentRequests]
  );
  const filteredPaymentRequests = useMemo(
    () => filterPaymentRequestsByPeriod(paymentRequests, paymentHistoryFilters),
    [paymentHistoryFilters, paymentRequests]
  );
  const paymentOperationsSummary = useMemo(
    () => buildPaymentOperationsSummary(paymentHistorySummaryRequests),
    [paymentHistorySummaryRequests]
  );
  const filteredPaymentOperationsSummary = useMemo(
    () => buildPaymentOperationsSummary(filteredPaymentRequests),
    [filteredPaymentRequests]
  );
  const paymentHistoryFilterOptions = useMemo(
    () => getPaymentHistoryFilterOptions(paymentRequests),
    [paymentRequests]
  );
  const [sensitiveCardInput, setSensitiveCardInput] = useState(() =>
    createEmptySensitiveCardInput()
  );
  const [paymentBatchImportPreview, setPaymentBatchImportPreview] = useState(null);
  const [paymentBatchImportFileName, setPaymentBatchImportFileName] = useState("");
  const [paymentBatchImportSaving, setPaymentBatchImportSaving] = useState(false);
  const [activePaymentQueueItemId, setActivePaymentQueueItemId] = useState("");
  const activePaymentQueueItem = useMemo(
    () =>
      paymentRequests.find(
        (request) =>
          (request.paymentRequestId || request.id) === activePaymentQueueItemId
      ) || null,
    [paymentRequests, activePaymentQueueItemId]
  );
  const selectedPaymentLinkProfileStatus = useMemo(
    () =>
      ((paymentRequestForm.requestType === "STANDARD"
        ? standardPaymentConfig
        : paymentLinkConfig
      )?.profiles || []).find(
        (profile) => profile.id === paymentRequestForm.paymentProfileId
      ) || null,
    [
      paymentLinkConfig,
      paymentRequestForm.paymentProfileId,
      paymentRequestForm.requestType,
      standardPaymentConfig,
    ]
  );
  const selectedKeyinProfileStatus = useMemo(
    () =>
      (keyinPaymentConfig?.profiles || []).find(
        (profile) => profile.id === paymentRequestForm.keyinProfileId
      ) || null,
    [keyinPaymentConfig, paymentRequestForm.keyinProfileId]
  );
  const selectedPaymentVendor = useMemo(
    () =>
      paymentVendorOptions.find(
        (vendor) => vendor.vendorId === paymentRequestForm.vendorId
      ) || null,
    [paymentVendorOptions, paymentRequestForm.vendorId]
  );
  const filteredPaymentVendorOptions = useMemo(() => {
    return getPaymentVendorDirectoryDisplayOptions(
      paymentVendorOptions,
      paymentVendorSearch,
      paymentDirectoryPagination.query
    );
  }, [
    paymentDirectoryPagination.query,
    paymentVendorOptions,
    paymentVendorSearch,
  ]);
  const paymentDirectoryResultMessage = getPaymentDirectoryResultMessage({
    pagination: paymentDirectoryPagination,
    currentQuery: paymentVendorSearch,
    resultCount: filteredPaymentVendorOptions.length,
    loading: paymentDirectoryLoading,
    requestType: paymentRequestForm.requestType,
  });
  const paymentDirectoryCanLoadMore = shouldShowPaymentDirectoryLoadMore({
    pagination: paymentDirectoryPagination,
    currentQuery: paymentVendorSearch,
    resultCount: filteredPaymentVendorOptions.length,
    loading: paymentDirectoryLoading,
  });
  const paymentDirectorySearchPending = isPaymentDirectorySearchPending({
    pagination: paymentDirectoryPagination,
    currentQuery: paymentVendorSearch,
    loading: paymentDirectoryLoading,
  });
  const paymentRuntimeEnvironmentByType = useMemo(
    () => ({
      STANDARD: standardPaymentConfig.environment,
      BUYLINK: paymentLinkConfig.environment,
      KEYIN: keyinPaymentConfig.environment,
      AUTOPAY: autopayConfig.environment,
    }),
    [
      autopayConfig.environment,
      keyinPaymentConfig.environment,
      paymentLinkConfig.environment,
      standardPaymentConfig.environment,
    ]
  );
  const selectedVendorPaymentProfileId = selectedPaymentVendor
    ? paymentRequestForm.requestType === "AUTOPAY"
      ? selectedPaymentVendor.autopayProfileId
      : paymentRequestForm.requestType === "KEYIN"
      ? selectedPaymentVendor.keyinPaymentProfileId
      : selectedPaymentVendor.linkPaymentProfileId
    : "";
  const selectedVendorPaymentMappingReady = Boolean(
    /^\d{6}$/.test(normalizeVendorCode(selectedPaymentVendor?.vendorCode)) &&
      selectedPaymentVendor?.companyBranchResolved &&
      selectedPaymentVendor?.companyBranchActive &&
      selectedVendorPaymentProfileId
  );
  const selectedVendorPaymentOperationReady = Boolean(
    selectedVendorPaymentMappingReady &&
      selectedPaymentVendor?.companyBranchPgStatus === "ACTIVE" &&
      (paymentRequestForm.requestType === "AUTOPAY"
        ? selectedPaymentVendor?.autopayPaymentEnabled
        : paymentRequestForm.requestType === "KEYIN"
        ? selectedPaymentVendor?.keyinPaymentEnabled
        : selectedPaymentVendor?.linkPaymentEnabled)
  );
  const selectedAutopayProfileStatus = useMemo(
    () =>
      (autopayConfig?.profiles || []).find(
        (profile) => profile.id === paymentRequestForm.autopayProfileId
      ) || null,
    [autopayConfig, paymentRequestForm.autopayProfileId]
  );
  const selectedAutopayMethod = useMemo(
    () =>
      autopayMethods.find(
        (method) => method.billingMethodId === selectedAutopayMethodId
      ) || null,
    [autopayMethods, selectedAutopayMethodId]
  );
  const verifiedAutopayMethods = useMemo(
    () => autopayMethods.filter(isAutopayMethodReadyForCharge),
    [autopayMethods]
  );
  const selectedVendorChargeMethods = useMemo(() => {
    const vendorId = String(paymentRequestForm.vendorId || "");
    if (!vendorId) return [];
    return verifiedAutopayMethods
      .filter((method) => String(method.vendorId || "") === vendorId)
      .sort((a, b) => {
        if (a.isPrimary !== b.isPrimary) return a.isPrimary ? -1 : 1;
        return String(b.createdAt || "").localeCompare(String(a.createdAt || ""));
      });
  }, [paymentRequestForm.vendorId, verifiedAutopayMethods]);
  const autopayMethodGroups = useMemo(
    () => groupAutopayMethodsByVendor(autopayMethods),
    [autopayMethods]
  );
  const selectedVendorAutopayMethods = useMemo(() => {
    const vendorId = String(selectedVendorMaster?.vendorId || selectedVendorMaster?.id || "");
    if (!vendorId) return [];
    return autopayMethods.filter((method) => String(method?.vendorId || "") === vendorId);
  }, [autopayMethods, selectedVendorMaster]);
  const [companyBranchesLoading, setCompanyBranchesLoading] = useState(false);
  const [companyBranchesError, setCompanyBranchesError] = useState("");
  const [companyBranchModalOpen, setCompanyBranchModalOpen] = useState(false);
  const [companyBranchSaving, setCompanyBranchSaving] = useState(false);
  const [companyBranchForm, setCompanyBranchForm] = useState(() =>
    normalizeCompanyBranchRow({
      branchName: "",
      corporationName: "",
      active: true,
      pgProfile: { provider: "KCP", status: "NOT_APPLIED" },
    }).branch
  );
  const [companyBranchSaveReason, setCompanyBranchSaveReason] = useState("");
  const [errors, setErrors] = useState({});
  const [toastMessage, setToastMessage] = useState(null);
  const [errorHelpModal, setErrorHelpModal] = useState(null);
  const [focusedField, setFocusedField] = useState("");
  const [activeValidationIssue, setActiveValidationIssue] =
    useState<ValidationIssue | null>(null);
  const [showUserErrorReport, setShowUserErrorReport] = useState(false);
  const [userErrorReportMessage, setUserErrorReportMessage] = useState("");
  const [userErrorReportSaving, setUserErrorReportSaving] = useState(false);
  const [pendingUserErrorReportSnapshot, setPendingUserErrorReportSnapshot] =
    useState(null);
  const [pendingConfirm, setPendingConfirm] = useState(null);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const today = new Date();
  const [selYear, setSelYear] = useState(today.getFullYear());
  const [selMonth, setSelMonth] = useState(today.getMonth() + 1);
  const [selDay, setSelDay] = useState(today.getDate());

  const [isSameDayDeposit, setIsSameDayDeposit] = useState(false);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [manualAddressMode, setManualAddressMode] = useState(false);

  const [bizType, setBizType] = useState("INDIVIDUAL");
  const [coRepresentativeDeclared, setCoRepresentativeDeclared] =
    useState(false);
  const [coRepresentatives, setCoRepresentatives] = useState(() => [
    createCoRepresentativeDraft(),
  ]);
  const visibleCoRepresentatives = useMemo(
    () =>
      getPrimaryCoRepresentativeDisplayRows({
        declared: coRepresentativeDeclared,
        representatives: coRepresentatives,
      }),
    [coRepresentativeDeclared, coRepresentatives]
  );
  const [activeCoRepHelpKey, setActiveCoRepHelpKey] = useState("");
  const [coRepresentativeNtsInfo, setCoRepresentativeNtsInfo] =
    useState<CoRepresentativeInfo | null>(null);
  const [coRepresentativeSmsPhone, setCoRepresentativeSmsPhone] = useState("");
  const [coRepresentativeSmsError, setCoRepresentativeSmsError] = useState("");
  const [coRepresentativeInviteLinks, setCoRepresentativeInviteLinks] = useState([]);
  const [adminCoRepresentativeInviteLinks, setAdminCoRepresentativeInviteLinks] =
    useState({});
  const [
    adminCoRepresentativeSignatureLinks,
    setAdminCoRepresentativeSignatureLinks,
  ] = useState({});
  const [
    adminCoRepresentativeInviteReasons,
    setAdminCoRepresentativeInviteReasons,
  ] = useState({});
  const [adminCoRepresentativeInviteLoadingId, setAdminCoRepresentativeInviteLoadingId] =
    useState("");
  const [
    adminPostCompletionCoRepresentativeForm,
    setAdminPostCompletionCoRepresentativeForm,
  ] = useState({
    name: "",
    phone: "",
    reason: "",
  });
  const [
    adminPostCompletionCoRepresentativeLoading,
    setAdminPostCompletionCoRepresentativeLoading,
  ] = useState(false);
  const [signature2, setSignature2] = useState(null);

  const [agreements, setAgreements] = useState({
    privacy: false,
    credit: false,
    collection: false, // 채권추심·소송 목적 동의
  });
  const [highlightedConsentKey, setHighlightedConsentKey] =
    useState<RequiredConsentKey | null>(null);
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  // 주소 검색: "agent"=사업장주소, "corp"=대표자자택주소, "coRep"=공동계약인자택주소
  const [addressTarget, setAddressTarget] = useState<"agent" | "corp" | "coRep">("agent");
  const [coRepAddressTargetId, setCoRepAddressTargetId] = useState("");
  const [manualCorpAddrMode, setManualCorpAddrMode] = useState(false);
  const [otpCooldown, setOtpCooldown] = useState(0); // OTP 재발송 쿨다운(초)
  const [finalContractImage, setFinalContractImage] = useState(null);
  const [contractScrolled, setContractScrolled] = useState(false);
  const [contractAgreed, setContractAgreed] = useState(false);
  const [hasContractAuthority, setHasContractAuthority] = useState(false);
  const [
    representativePersonalGuaranteeAgreed,
    setRepresentativePersonalGuaranteeAgreed,
  ] = useState(false);
  // 담당자 설정: Firestore에서 로드, 로드 전엔 기본값 사용
  const [managersConfig, setManagersConfig] = useState(MANAGER_CONFIG_DEFAULT);
  const [managerTarget, setManagerTarget] = useState<ManagerTarget | null>(null);
  const [salesPaymentCode, setSalesPaymentCode] = useState("");
  const [salesPaymentManagerSearch, setSalesPaymentManagerSearch] = useState("");
  const [salesPaymentManagerListOpen, setSalesPaymentManagerListOpen] =
    useState(false);
  const [salesPaymentLoginOptions, setSalesPaymentLoginOptions] = useState<
    SalesPaymentLoginOption[]
  >([]);
  const [salesPaymentLoginOptionsLoading, setSalesPaymentLoginOptionsLoading] =
    useState(false);
  const [salesPaymentLoginOptionsError, setSalesPaymentLoginOptionsError] =
    useState("");
  const salesPaymentManagerPickerRef = useRef<HTMLDivElement | null>(null);
  const salesPaymentManagerInputRef = useRef<HTMLInputElement | null>(null);
  const salesPaymentEnterButtonRef = useRef<HTMLButtonElement | null>(null);
  const salesPaymentActorCodeRef = useRef("");
  const [currentManager, setCurrentManager] = useState(
    MANAGER_CONFIG_DEFAULT.find((m) => m.code === "default") || MANAGER_CONFIG_DEFAULT[0]
  );
  const paymentWorkspaceRoute = getPaymentWorkspaceRoute(
    typeof window !== "undefined" ? window.location.pathname : ""
  );
  const [editModeId, setEditModeId] = useState(null);

  useEffect(() => {
    if (!salesPaymentManagerListOpen) return undefined;

    const handleOutsidePointerDown = (event: PointerEvent): void => {
      if (
        event.target instanceof Node &&
        !salesPaymentManagerPickerRef.current?.contains(event.target)
      ) {
        setSalesPaymentManagerListOpen(false);
      }
    };

    document.addEventListener("pointerdown", handleOutsidePointerDown);
    return () => {
      document.removeEventListener("pointerdown", handleOutsidePointerDown);
    };
  }, [salesPaymentManagerListOpen]);

  // ── 휴대폰 번호 확인 (Phone OTP) state ──
  const [contractDraftId] = useState(() => createStableId("draft"));
  const [otpCode, setOtpCode] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [phoneVerified, setPhoneVerified] = useState(false);
  const [phoneVerifiedAt, setPhoneVerifiedAt] = useState<string | null>(null);
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [kcpAvailable, setKcpAvailable] = useState(false);
  const [kcpSessionId, setKcpSessionId] = useState("");
  const [kcpIdentityStatus, setKcpIdentityStatus] =
    useState<KcpIdentityStatus>("");
  const [kcpVerifiedName, setKcpVerifiedName] = useState("");
  const [kcpPhoneMasked, setKcpPhoneMasked] = useState("");
  const [kcpRepresentativeMatchStatus, setKcpRepresentativeMatchStatus] =
    useState<RepresentativeVerificationStatus>("PENDING_KCP");
  const [
    representativeIdentityVerification,
    setRepresentativeIdentityVerification,
  ] = useState(null);
  const [businessVerification, setBusinessVerification] = useState(null);
  const [lockedIdentityFields, setLockedIdentityFields] = useState(null);
  const [kcpIdentityEvidence, setKcpIdentityEvidence] = useState<Record<string, unknown> | null>(null);
  const [kcpFallbackReason, setKcpFallbackReason] =
    useState<KcpFallbackReason | null>(null);
  const [smsFallbackSelected, setSmsFallbackSelected] = useState(false);
  const [kcpLoading, setKcpLoading] = useState(false);
  const [kcpLaunchUiState, setKcpLaunchUiState] =
    useState<KcpLaunchUiState>(KCP_LAUNCH_UI_STATES.IDLE);
  const kcpLaunchUiStateRef = useRef<KcpLaunchUiState>(
    KCP_LAUNCH_UI_STATES.IDLE
  );
  const [kcpLaunchFallbackVisible, setKcpLaunchFallbackVisible] =
    useState(false);
  const [kcpReturnSyncState, setKcpReturnSyncState] =
    useState<KcpReturnSyncState>(() =>
      typeof window === "undefined"
        ? KCP_RETURN_SYNC_STATES.IDLE
        : getInitialKcpReturnSyncState(window.location.search)
    );
  const [kcpReturnNavigationIntentActive, setKcpReturnNavigationIntentActive] =
    useState(() =>
      typeof window !== "undefined" &&
      (Boolean(loadKcpReturnNavigationIntent()) ||
        getInitialKcpReturnSyncState(window.location.search) ===
          KCP_RETURN_SYNC_STATES.CHECKING_STATUS)
    );
  const [activeCoRepresentativeKcpId, setActiveCoRepresentativeKcpId] =
    useState("");
  const [restoredSsnDraft, setRestoredSsnDraft] =
    useState<KcpRestoredSsnDraft | null>(null);
  const [stepEvidence, setStepEvidence] = useState<StepEvidence>({
    businessInfo: null,
    identity: null,
    contractReview: null,
    signature: null,
  });
  const kcpPopupRef = useRef<Window | null>(null);
  const kcpPopupPollRef = useRef<number | null>(null);
  const lastVerifiedPrincipalKcpRef = useRef(null);
  const kcpReturnSyncStateRef = useRef<KcpReturnSyncState>(kcpReturnSyncState);
  const kcpReturnProcessingRef = useRef(false);
  const kcpReturnProcessedKeyRef = useRef("");
  const kcpVerifiedGraceUntilRef = useRef(0);
  const postKcpNavigationAppliedRef = useRef(false);
  const lastIdentityFieldUserEditAtRef = useRef(0);
  const lastValidBusinessVerificationRef = useRef(null);
  const kcpStatusSyncInFlightRef = useRef<Promise<unknown> | null>(null);
  const kcpStatusSyncLastRunRef = useRef(0);
  const kcpStatusSyncSeqRef = useRef(0);
  const [contractReviewedAt, setContractReviewedAt] = useState<string | null>(
    null
  );
  const [signatureCompletedAt, setSignatureCompletedAt] = useState<
    string | null
  >(null);
  const [lastSubmittedContractData, setLastSubmittedContractData] =
    useState(null);
  const [completionReceipt, setCompletionReceipt] = useState(null);
  const [completionReceiptError, setCompletionReceiptError] = useState("");
  const [completionReceiptChecking, setCompletionReceiptChecking] =
    useState(false);
  const [savedContractDocumentId, setSavedContractDocumentId] = useState("");
  const [submitState, setSubmitState] = useState("IDLE");

  const [formData, setFormData] = useState({
    supplier1: "주식회사 씨엔푸드 화성지점",
    rep1: "유인식",
    bizNo1: "627-85-01397",
    address1: "경기도 화성시 송산면 송산포도로 575",
    supplier2: "농업회사법인 주식회사 씨엔푸드",
    rep2: "유인식",
    bizNo2: "343-88-00695",
    address2: "경기도 화성시 송산면 송산포도로 575",
    mainPhone: "1522-8639",
    agentName: "",
    agentRep: "",
    agentBizNo: "",
    representativeBirthDate: "",
    openingDate: "",
    agentContact: "",
    agentAddress: "",
    agentAddressDetail: "",
    depositDay: "",
    ssnFront: "",
    ssnBack: "",
    principalRepSsnFront: "",
    principalRepSsnBack: "",
    guarantorSsnFront: "",
    guarantorSsnBack: "",
    corpRepName: "",
    corpRepAddress: "",
    corpRepAddressDetail: "",
    signature: null,
    signature2: null,
    contractId: "",
  });
  const formDataRef = useRef(formData);
  formDataRef.current = formData;

  const handleEditVerifiedIdentityInformation = () => {
    resetStrictIdentityState(true, {
      clearBusinessVerification: true,
      explicitIdentityEdit: true,
      reason: "edit-verified-identity-information",
    });
    setCoRepresentativeNtsInfo(null);
    setToastMessage(
      "정보 수정을 위해 본인확인과 국세청 확인 상태를 초기화했습니다. 수정 후 다시 확인해 주세요."
    );
    focusValidationIssue(
      createValidationIssue(
        "openingDate",
        "사업자번호, 대표자명, 개업일자를 수정한 뒤 국세청 진위확인과 본인확인을 다시 진행해 주세요."
      )
    );
  };

  useEffect(() => {
    stepRef.current = step;
  }, [step]);

  useEffect(() => {
    kcpReturnSyncStateRef.current = kcpReturnSyncState;
  }, [kcpReturnSyncState]);

  useEffect(() => {
    let cancelled = false;
    const authorizeDeviceToken = async () => {
      if (typeof window === "undefined") return;
      try {
        const params = new URLSearchParams(window.location.search);
        const urlToken = params.get("testToken") || "";
        if (urlToken && window.localStorage) {
          window.localStorage.setItem(
            IDENTITY_TEST_DEVICE_TOKEN_STORAGE_KEY,
            urlToken
          );
          params.delete("testToken");
          const nextQuery = params.toString();
          window.history.replaceState(
            {},
            "",
            `${window.location.pathname}${nextQuery ? `?${nextQuery}` : ""}${
              window.location.hash || ""
            }`
          );
        }
        const storedToken =
          window.localStorage?.getItem(IDENTITY_TEST_DEVICE_TOKEN_STORAGE_KEY) ||
          "";
        const authorized = await isIdentityTestDeviceTokenAuthorized({
          token: storedToken,
        });
        if (!cancelled) {
          setIdentityTestDeviceAuthorized(authorized);
        }
      } catch {
        if (!cancelled) {
          setIdentityTestDeviceAuthorized(false);
        }
      }
    };
    authorizeDeviceToken();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (isNtsBusinessVerificationReady(businessVerification)) {
      lastValidBusinessVerificationRef.current = businessVerification;
    }
  }, [businessVerification]);

  useEffect(() => {
    showIntroPageRef.current = showIntroPage;
  }, [showIntroPage]);

  const contractExitGuardEnabled = shouldGuardContractExitNavigation({
    viewMode,
    showIntroPage,
    step,
    isCorepInviteRoute,
    kcpReturnNavigationIntentActive,
    kcpReturnSyncState,
  });

  useEffect(() => {
    if (!contractExitGuardEnabled || typeof window === "undefined") {
      setShowContractExitConfirm(false);
      contractExitAllowedRef.current = false;
      return;
    }

    const getHistoryState = () =>
      window.history.state && typeof window.history.state === "object"
        ? window.history.state
        : {};
    const ensureGuardHistoryEntry = () => {
      const currentState = getHistoryState();
      if (currentState[CONTRACT_EXIT_HISTORY_STATE_KEY] === true) return;
      window.history.pushState(
        {
          ...currentState,
          [CONTRACT_EXIT_HISTORY_STATE_KEY]: true,
        },
        "",
        window.location.href
      );
    };

    ensureGuardHistoryEntry();
    const handleContractHistoryBack = () => {
      if (contractExitAllowedRef.current) return;
      const currentState = getHistoryState();
      window.history.pushState(
        {
          ...currentState,
          [CONTRACT_EXIT_HISTORY_STATE_KEY]: true,
        },
        "",
        window.location.href
      );
      setShowContractExitConfirm(true);
    };

    window.addEventListener("popstate", handleContractHistoryBack);
    return () => {
      window.removeEventListener("popstate", handleContractHistoryBack);
    };
  }, [contractExitGuardEnabled]);

  const handleContinueContractAfterBack = () => {
    setShowContractExitConfirm(false);
  };

  const handleExitContractAfterBack = () => {
    contractExitAllowedRef.current = true;
    setShowContractExitConfirm(false);
    if (typeof window !== "undefined") {
      window.location.replace(window.location.pathname);
    }
  };

  const shouldTraceKcpReturnLifecycle = () =>
    process.env.NODE_ENV !== "production" ||
    adminAccessMode === "ADMIN" ||
    adminAccessMode === "SALES_LOOKUP" ||
    viewMode === "DEBUG";

  const traceKcpReturnLifecycle = (event = {}) => {
    if (!shouldTraceKcpReturnLifecycle()) return;
    console.info(
      "[kcp-return]",
      sanitizeKcpReturnTraceEvent({
        ...event,
        timestamp: new Date().toISOString(),
      })
    );
  };

  const traceKcpLaunchLifecycle = (event = {}) => {
    if (!shouldTraceKcpReturnLifecycle()) return;
    console.info(
      "[kcp-launch]",
      sanitizeKcpLaunchTraceEvent({
        ...event,
        timestamp: new Date().toISOString(),
      })
    );
  };

  const setPrincipalKcpReturnSyncState = (
    nextState: KcpReturnSyncState,
    { source = "unknown", force = false, targetStep = undefined } = {}
  ) => {
    const previousSyncState = kcpReturnSyncStateRef.current;
    if (
      !force &&
      previousSyncState === KCP_RETURN_SYNC_STATES.VERIFIED &&
      [KCP_RETURN_SYNC_STATES.CHECKING_STATUS, KCP_RETURN_SYNC_STATES.IDLE].includes(
        nextState
      ) &&
      shouldSuppressKcpVerifiedReset({
        graceUntil: kcpVerifiedGraceUntilRef.current,
      })
    ) {
      traceKcpReturnLifecycle({
        source,
        previousSyncState,
        nextSyncState: nextState,
        targetStep,
        resetSuppressedByGrace: true,
      });
      return false;
    }
    kcpReturnSyncStateRef.current = nextState;
    setKcpReturnSyncState(nextState);
    traceKcpReturnLifecycle({
      source,
      previousSyncState,
      nextSyncState: nextState,
      targetStep,
    });
    return true;
  };

  const clearKcpLaunchFallbackTimer = () => {
    if (
      typeof window !== "undefined" &&
      kcpLaunchFallbackTimerRef.current !== null
    ) {
      window.clearTimeout(kcpLaunchFallbackTimerRef.current);
      kcpLaunchFallbackTimerRef.current = null;
    }
  };

  const clearKcpLaunchTimeout = () => {
    if (
      typeof window !== "undefined" &&
      kcpLaunchTimeoutRef.current !== null
    ) {
      window.clearTimeout(kcpLaunchTimeoutRef.current);
      kcpLaunchTimeoutRef.current = null;
    }
  };

  const startKcpLaunchFallbackTimer = () => {
    if (typeof window === "undefined") return;
    clearKcpLaunchFallbackTimer();
    setKcpLaunchFallbackVisible(false);
    kcpLaunchFallbackTimerRef.current = window.setTimeout(() => {
      kcpLaunchFallbackTimerRef.current = null;
      if (kcpLaunchUiStateRef.current === KCP_LAUNCH_UI_STATES.WAITING_RETURN) {
        setKcpLaunchFallbackVisible(false);
        const target = getKcpIdentityStatusLookupTarget();
        if (target.sessionId) {
          void processPrincipalKcpReturnOnce({
            source: "waiting-return-fallback",
            kcpSessionId: target.sessionId,
            draftId: target.draftId || contractDraftId,
            reason: "KCP_WAITING_RETURN_FALLBACK",
          });
        } else {
          setPrincipalKcpReturnSyncState(KCP_RETURN_SYNC_STATES.CHECKING_STATUS, {
            source: "waiting-return-fallback",
            targetStep: 1,
          });
          setPrincipalKcpLaunchUiState(KCP_LAUNCH_UI_STATES.RETURN_CHECKING, {
            source: "waiting-return-fallback",
          });
          setOtpError(KCP_RETURN_SYNC_CHECKING_MESSAGE);
          setToastMessage(KCP_RETURN_SYNC_CHECKING_MESSAGE);
          setKcpLaunchFallbackVisible(true);
        }
        return;
      }
      setKcpLaunchFallbackVisible(true);
    }, KCP_LAUNCH_FALLBACK_MS);
  };

  const scheduleKcpLaunchTimeout = (source = "unknown") => {
    if (typeof window === "undefined") return;
    clearKcpLaunchTimeout();
    kcpLaunchAttemptStartedAtRef.current = Date.now();
    kcpLaunchTimeoutRef.current = window.setTimeout(() => {
      kcpLaunchTimeoutRef.current = null;
      const previousLaunchState = kcpLaunchUiStateRef.current;
      if (!shouldApplyKcpLaunchTimeout(previousLaunchState)) {
        traceKcpLaunchLifecycle({
          source,
          previousLaunchState,
          nextLaunchState: previousLaunchState,
          elapsedMs:
            Date.now() - Number(kcpLaunchAttemptStartedAtRef.current || Date.now()),
          reason: "launch-timeout-ignored",
          popupPresent: Boolean(kcpPopupRef.current),
          popupClosed: Boolean(kcpPopupRef.current?.closed),
        });
        return;
      }
      const nextLaunchState = KCP_LAUNCH_UI_STATES.LAUNCH_TIMEOUT;
      kcpLaunchUiStateRef.current = nextLaunchState;
      setKcpLaunchUiState(nextLaunchState);
      setKcpLaunchFallbackVisible(true);
      setKcpLoading(false);
      setOtpError("본인인증 화면이 열리지 않았습니다. 다시 시도해 주세요.");
      setKcpFallbackReason("KCP_START_FAILED");
      clearActiveKcpReturnNavigationIntent();
      clearKcpVerifiedNavigationRetry();
      writeKcpPopupFailurePage({
        title: "본인인증 화면이 열리지 않았습니다",
        description:
          "브라우저가 인증창을 차단했거나 네트워크가 지연되었습니다. 창을 닫고 다시 시도해 주세요.",
      });
      traceKcpLaunchLifecycle({
        source,
        previousLaunchState,
        nextLaunchState,
        elapsedMs:
          Date.now() - Number(kcpLaunchAttemptStartedAtRef.current || Date.now()),
        reason: "launch-timeout",
        popupPresent: Boolean(kcpPopupRef.current),
        popupClosed: Boolean(kcpPopupRef.current?.closed),
      });
    }, KCP_LAUNCH_TIMEOUT_MS);
  };

  const setPrincipalKcpLaunchUiState = (
    nextState: KcpLaunchUiState,
    { withFallbackTimer = false, source = "unknown" } = {}
  ) => {
    const previousLaunchState = kcpLaunchUiStateRef.current;
    kcpLaunchUiStateRef.current = nextState;
    setKcpLaunchUiState(nextState);
    traceKcpLaunchLifecycle({
      source,
      previousLaunchState,
      nextLaunchState: nextState,
      elapsedMs:
        kcpLaunchAttemptStartedAtRef.current === null
          ? 0
          : Date.now() - kcpLaunchAttemptStartedAtRef.current,
      reason: "state-change",
      popupPresent: Boolean(kcpPopupRef.current),
      popupClosed: Boolean(kcpPopupRef.current?.closed),
    });
    if (withFallbackTimer) {
      startKcpLaunchFallbackTimer();
      if (nextState === KCP_LAUNCH_UI_STATES.RETURN_CHECKING) {
        setKcpLaunchFallbackVisible(false);
      }
      if (shouldApplyKcpLaunchTimeout(nextState)) {
        scheduleKcpLaunchTimeout(source);
      } else {
        clearKcpLaunchTimeout();
      }
      return;
    }
    if (
      nextState === KCP_LAUNCH_UI_STATES.IDLE ||
      nextState === KCP_LAUNCH_UI_STATES.VERIFIED ||
      nextState === KCP_LAUNCH_UI_STATES.FAILED
    ) {
      clearKcpLaunchFallbackTimer();
      clearKcpLaunchTimeout();
      setKcpLaunchFallbackVisible(false);
    }
  };

  const goToStep = (nextStep: number, options = {}) => {
    const isAdminSession =
      adminAccessMode === "ADMIN" &&
      (Boolean(currentManager?.name) || adminContractStartMode);
    const hasKcpResumeTarget = Boolean(
      kcpSessionId ||
        loadKcpDraftRestoreState(contractDraftId)?.kcpSessionId ||
        loadKcpSessionPointer(contractDraftId)?.kcpSessionId
    );
    const allowDuringKcpReturnSync = Boolean(
      (options as { allowDuringKcpReturnSync?: boolean })
        .allowDuringKcpReturnSync
    );
    if (
      !allowDuringKcpReturnSync &&
      shouldHoldStepDuringKcpReturnSync({
        kcpReturnSyncState,
        hasPendingKcpSession: hasKcpResumeTarget,
        nextStep,
      })
    ) {
      setOtpError(KCP_RETURN_SYNC_CHECKING_MESSAGE);
      setToastMessage(KCP_RETURN_SYNC_CHECKING_MESSAGE);
      return false;
    }
    const isNewEntryAttempt =
      showIntroPageRef.current &&
      Number(nextStep || 0) <= 1 &&
      !hasKcpResumeTarget &&
      !activeInvite;
    if (isNewEntryAttempt) {
      const gate = canStartNewContract(contractAppStatus, {
        isAdmin: isAdminSession,
        statusLoaded: contractAppStatusLoaded,
        bypassPause: adminContractStartMode,
      });
      if (!gate.allowed) {
        setToastMessage(gate.message);
        return false;
      }
    }
    if (
      nextStep === 5 &&
      !canShowCompletionStep({
        completionReceipt: options.completionReceipt || completionReceipt,
        savedContractId: options.savedContractId || savedContractDocumentId,
        lastSubmittedContractData:
          options.lastSubmittedContractData || lastSubmittedContractData,
        formData: options.formData || formData,
      })
    ) {
      setToastMessage("접수 정보가 확인되지 않았습니다. 계약 정보를 먼저 저장해 주세요.");
      nextStep = 0;
    }
    setStep(nextStep);
    if (typeof window !== "undefined") {
      window.scrollTo(0, 0);
    }
    return true;
  };

  const handleTextSizeModeChange = (mode: TextSizeMode) => {
    setTextSizeMode(saveTextSizeMode(mode));
  };

  const fieldFocusRefs: Record<string, React.RefObject<HTMLInputElement>> = {
    agentName: agentNameInputRef,
    agentRep: agentRepInputRef,
    agentBizNo: agentBizNoInputRef,
    representativeBirthDate: representativeBirthDateInputRef,
    openingDate: openingDateInputRef,
    agentContact: agentContactInputRef,
    agentAddress: agentAddressInputRef,
    depositDay: depositDayInputRef,
    corpRepName: corpRepNameInputRef,
    corpRepAddress: corpRepAddressInputRef,
    principalRepSsnFront: principalRepSsnFrontInputRef,
    principalRepSsnBack: principalRepSsnBackInputRef,
    guarantorSsnFront: guarantorSsnFrontInputRef,
    guarantorSsnBack: guarantorSsnBackInputRef,
  };

  const validationFieldToConsentKey: Record<string, RequiredConsentKey> = {
    agreementPrivacy: "privacy-consent",
    agreementCredit: "credit-check-consent",
    agreementCollection: "collection-consent",
  };

  const setRequiredConsentRef =
    (key: RequiredConsentKey): React.RefCallback<HTMLElement> =>
    (node) => {
      requiredConsentRefs.current[key] = node;
    };

  const focusRequiredConsent = (
    key: RequiredConsentKey,
    message: string
  ) => {
    setHighlightedConsentKey(key);
    setToastMessage(message);
    window.setTimeout(() => {
      const node = requiredConsentRefs.current[key];
      if (node) {
        node.scrollIntoView({ behavior: "smooth", block: "center" });
        node.focus({ preventScroll: true });
      }
    }, 0);
  };

  const focusValidationIssue = (issue: ValidationIssue | null) => {
    if (!issue) return;
    setActiveValidationIssue(issue);
    setFocusedField(issue.fieldId);
    setToastMessage(issue.message);
    const consentKey = validationFieldToConsentKey[issue.fieldId];
    if (consentKey) {
      focusRequiredConsent(consentKey, issue.message);
      return;
    }
    window.setTimeout(() => {
      const ref = fieldFocusRefs[issue.fieldId]?.current;
      if (ref) {
        ref.scrollIntoView({ behavior: "smooth", block: "center" });
        ref.focus();
      }
    }, 0);
  };

  const activateKcpReturnNavigationIntent = (targetStep = 1) => {
    saveKcpReturnNavigationIntent(targetStep);
    setKcpReturnNavigationIntentActive(true);
    kcpVerifiedNavigationPendingRef.current = true;
  };

  const clearActiveKcpReturnNavigationIntent = () => {
    clearKcpReturnNavigationIntent();
    setKcpReturnNavigationIntentActive(false);
    kcpVerifiedNavigationPendingRef.current = false;
  };

  const focusStep1SsnInputAfterKcp = () => {
    if (typeof window === "undefined") return;
    let attempts = 0;
    const runFocus = () => {
      attempts += 1;
      const node = principalRepSsnFrontInputRef.current;
      if (!node) {
        if (attempts < 3) {
          window.setTimeout(scheduleFocus, 80);
        }
        return;
      }
      node.scrollIntoView({ behavior: "smooth", block: "center" });
      if (!node.disabled && !node.readOnly) {
        node.focus({ preventScroll: true });
      }
      clearActiveKcpReturnNavigationIntent();
      console.info("[kcp-identity] focus ssn input after verification");
    };
    const scheduleFocus = () => {
      if (typeof window.requestAnimationFrame === "function") {
        window.requestAnimationFrame(() => window.requestAnimationFrame(runFocus));
        return;
      }
      window.setTimeout(runFocus, 0);
    };
    window.setTimeout(scheduleFocus, 50);
  };

  const clearKcpVerifiedNavigationRetry = () => {
    if (
      typeof window !== "undefined" &&
      kcpVerifiedNavigationRetryRef.current !== null
    ) {
      window.clearTimeout(kcpVerifiedNavigationRetryRef.current);
      kcpVerifiedNavigationRetryRef.current = null;
    }
  };

  const scheduleKcpVerifiedStep1Recovery = () => {
    if (typeof window === "undefined") return;
    clearKcpVerifiedNavigationRetry();
    kcpVerifiedNavigationRetryRef.current = window.setTimeout(() => {
      kcpVerifiedNavigationRetryRef.current = null;
      if (!kcpVerifiedNavigationPendingRef.current) return;
      kcpVerifiedNavigationPendingRef.current = false;
      if (stepRef.current !== 0) {
        clearActiveKcpReturnNavigationIntent();
        return;
      }
      console.info("[kcp-identity] force return to step1 ssn input");
      goToStep(1, { allowDuringKcpReturnSync: true });
      focusStep1SsnInputAfterKcp();
    }, 120);
  };

  const getFocusedFieldHelp = (fieldId: string) => {
    if (activeValidationIssue?.fieldId === fieldId) {
      return activeValidationIssue.helperText || activeValidationIssue.message;
    }
    if (focusedField === fieldId) return SENIOR_FIELD_HELP_TEXT[fieldId] || "";
    return "";
  };

  const renderSeniorFieldHelp = (fieldId: string) => {
    const helperText = getFocusedFieldHelp(fieldId);
    if (!helperText) return null;
    return (
      <div className="mt-2 w-full max-w-full whitespace-normal break-keep rounded-2xl border border-blue-100 bg-blue-50 px-4 py-3 text-base font-bold leading-7 text-blue-900">
        {helperText}
      </div>
    );
  };

  const getRequiredConsentCardClass = (
    key: RequiredConsentKey,
    checked: boolean,
    checkedClass = "border-slate-900 bg-slate-900 text-white"
  ) => {
    const baseClass =
      "w-full min-h-[72px] rounded-2xl border-2 p-4 text-left transition-all flex items-start gap-4 focus:outline-none focus-visible:ring-4 focus-visible:ring-red-100";
    if (highlightedConsentKey === key && !checked) {
      return `${baseClass} border-red-400 bg-red-50 text-red-800 ring-2 ring-red-200`;
    }
    return `${baseClass} ${
      checked ? checkedClass : "border-slate-200 bg-white text-slate-700"
    }`;
  };

  const renderRequiredConsentBadge = () => (
    <span className="inline-flex min-h-[28px] shrink-0 items-center rounded-full bg-red-600 px-2.5 py-1 text-sm font-black leading-none text-white">
      필수
    </span>
  );

  const renderRequiredConsentCheckIcon = (
    checked: boolean,
    highlighted: boolean
  ) => (
    <span
      className={`mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-lg border-2 ${
        checked
          ? "border-white bg-white/10 text-white"
          : highlighted
          ? "border-red-400 bg-white text-red-600"
          : "border-slate-300 bg-white text-transparent"
      }`}
      aria-hidden="true"
    >
      <Check className="h-4 w-4" />
    </span>
  );

  const renderRequiredConsentError = (
    key: RequiredConsentKey,
    checked: boolean
  ) => {
    if (highlightedConsentKey !== key || checked) return null;
    return (
      <div className="mt-3 rounded-2xl border border-red-200 bg-red-50 px-4 py-4 text-base font-bold leading-7 text-red-700 break-keep">
        <p className="font-black">{REQUIRED_CONSENT_ERROR_TITLE}</p>
        <p>{REQUIRED_CONSENT_ERROR_MESSAGE}</p>
      </div>
    );
  };

  const renderRequiredConsentProgress = (
    items: RequiredConsentItem[]
  ) => {
    const progress = getRequiredConsentProgress(items);
    return (
      <div
        className={`rounded-2xl border px-4 py-4 text-base font-black leading-7 break-keep ${
          progress.allCompleted
            ? "border-emerald-200 bg-emerald-50 text-emerald-800"
            : "border-amber-200 bg-amber-50 text-amber-800"
        }`}
      >
        {progress.allCompleted
          ? "필수 동의가 모두 완료되었습니다."
          : `필수 동의 ${progress.total}개 중 ${progress.completed}개 완료`}
      </div>
    );
  };

  const openErrorHelpModal = (guide, overrides = {}) => {
    const resolvedGuide =
      typeof guide === "string" ? ERROR_HELP_GUIDES[guide] : guide;
    setErrorHelpModal({
      title: "계약 진행에 문제가 발생했습니다.",
      message: "입력값 또는 인증 상태를 확인한 뒤 다시 시도해 주세요.",
      cause: "",
      actionSteps: [
        "입력한 대표자명과 휴대폰번호를 확인해 주세요.",
        "본인 명의 휴대폰으로 인증해 주세요.",
        "문제가 계속되면 오류신고를 눌러 주세요.",
      ],
      supportPhone: CNFOOD_SUPPORT_PHONE,
      reportButton: true,
      ...(resolvedGuide || {}),
      ...(overrides || {}),
    });
  };

  const closeErrorHelpModal = () => setErrorHelpModal(null);

  const toggleStep1Agreement = (
    key: "privacy" | "credit" | "collection",
    consentKey: RequiredConsentKey
  ) => {
    setAgreements((prev) => {
      const nextChecked = !prev[key];
      if (nextChecked) {
        setHighlightedConsentKey((current) =>
          current === consentKey ? null : current
        );
      }
      return { ...prev, [key]: nextChecked };
    });
  };

  const handleContractAgreementChange = (checked: boolean) => {
    setContractAgreed(checked);
    if (checked) {
      setHighlightedConsentKey((current) =>
        current === "contract-agreement" ? null : current
      );
    }
  };

  const handleContractAuthorityChange = (checked: boolean) => {
    setHasContractAuthority(checked);
    if (checked) {
      setHighlightedConsentKey((current) =>
        current === "contract-authority" ? null : current
      );
    }
  };

  const getGroupedSeniorHelpField = (fieldIds: string[]) => {
    if (
      activeValidationIssue?.fieldId &&
      fieldIds.includes(activeValidationIssue.fieldId)
    ) {
      return activeValidationIssue.fieldId;
    }
    if (focusedField && fieldIds.includes(focusedField)) return focusedField;
    return "";
  };

  const getCurrentVisibleErrorMessage = () =>
    activeValidationIssue?.message ||
    otpError ||
    inviteLoadMessage ||
    inviteCreateErrorMessage ||
    toastMessage ||
    "";

  const waitForNextPaint = () =>
    new Promise<void>((resolve) => {
      if (typeof window === "undefined" || !window.requestAnimationFrame) {
        resolve();
        return;
      }
      window.requestAnimationFrame(() => window.requestAnimationFrame(() => resolve()));
    });

  const buildIssueReportCaptureError = (
    reason = "capture-failed",
    extra: Record<string, unknown> = {}
  ) =>
    sanitizeLogDetail({
      reason,
      viewMode,
      step,
      userAgent: typeof navigator !== "undefined" ? navigator.userAgent : "",
      createdAt: new Date().toISOString(),
      ...extra,
    });

  const captureUserErrorReportScreenBeforeModal = async () => {
    const viewportWidth =
      typeof window !== "undefined" ? window.innerWidth : 0;
    const viewportHeight =
      typeof window !== "undefined" ? window.innerHeight : 0;
    const visibleErrorMessage = getCurrentVisibleErrorMessage();
    const baseSnapshot = {
      page: viewMode,
      step,
      visibleErrorMessage,
      viewportWidth,
      viewportHeight,
      capturedAt: new Date().toISOString(),
    };

    try {
      if (
        !isCustomerIssueReportVisible({
          viewMode,
          step,
          showIntroPage,
        })
      ) {
        return {
          ...baseSnapshot,
          screenshotDataUrl: "",
          captureError: JSON.stringify(
            buildIssueReportCaptureError("not-customer-contract-flow")
          ),
        };
      }
      const target =
        customerFlowCaptureRef.current ||
        (typeof document !== "undefined"
          ? document.querySelector("[data-customer-contract-flow='true']")
          : null);
      if (!target) {
        return {
          ...baseSnapshot,
          screenshotDataUrl: "",
          captureError: JSON.stringify(
            buildIssueReportCaptureError("capture-target-missing")
          ),
        };
      }
      await waitForNextPaint();
      const html2canvasModule = await import("html2canvas");
      const html2canvas = html2canvasModule.default || html2canvasModule;
      const canvas = await html2canvas(target as HTMLElement, {
        backgroundColor: "#ffffff",
        useCORS: true,
        scale: Math.min(window.devicePixelRatio || 1, 2),
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight,
        ignoreElements: (element) =>
          element?.getAttribute?.("data-html2canvas-ignore") === "true",
      });
      const dataUrl =
        canvas && canvas.width && canvas.height ? canvas.toDataURL("image/png", 0.82) : "";
      if (!canvas || !canvas.width || !canvas.height || !isValidScreenshotDataUrl(dataUrl)) {
        return {
          ...baseSnapshot,
          screenshotDataUrl: "",
          captureError: JSON.stringify(
            buildIssueReportCaptureError("invalid-canvas", {
              targetWidth: canvas?.width || 0,
              targetHeight: canvas?.height || 0,
              dataUrlLength: dataUrl.length,
            })
          ),
        };
      }
      if (isProbablyBlankCanvas(canvas)) {
        return {
          ...baseSnapshot,
          screenshotDataUrl: "",
          captureError: JSON.stringify(
            buildIssueReportCaptureError("blank-canvas", {
              targetWidth: canvas.width,
              targetHeight: canvas.height,
              dataUrlLength: dataUrl.length,
            })
          ),
        };
      }
      return {
        ...baseSnapshot,
        screenshotDataUrl: dataUrl,
        captureError: "",
      };
    } catch (captureError) {
      const safeCaptureError = sanitizeErrorForLog(captureError);
      console.error(
        "[CNFOOD] user error report screen capture failed",
        safeCaptureError
      );
      return {
        ...baseSnapshot,
        screenshotDataUrl: "",
        captureError:
          safeCaptureError?.message || "screen capture failed before report modal",
      };
    }
  };

  const handleOpenUserErrorReport = async () => {
    if (
      !isCustomerIssueReportVisible({
        viewMode,
        step,
        showIntroPage,
      })
    ) {
      setToastMessage("관리자 화면에서는 사용자 오류신고를 사용할 수 없습니다.");
      return;
    }
    const snapshot = await captureUserErrorReportScreenBeforeModal();
    setPendingUserErrorReportSnapshot(snapshot);
    setShowUserErrorReport(true);
  };

  const handleSubmitUserErrorReport = async () => {
    if (userErrorReportSaving) return;
    if (
      !isCustomerIssueReportVisible({
        viewMode,
        step,
        showIntroPage,
      })
    ) {
      setToastMessage("관리자 화면에서는 사용자 오류신고를 사용할 수 없습니다.");
      return;
    }
    setUserErrorReportSaving(true);
    try {
      const snapshot = pendingUserErrorReportSnapshot || {};
      const viewportWidth =
        snapshot.viewportWidth ||
        (typeof window !== "undefined" ? window.innerWidth : 0);
      const viewportHeight =
        snapshot.viewportHeight ||
        (typeof window !== "undefined" ? window.innerHeight : 0);
      const visibleErrorMessage =
        snapshot.visibleErrorMessage || getCurrentVisibleErrorMessage();
      const screenshotDataUrl = snapshot.screenshotDataUrl || "";
      const payload = createSafeUserErrorReportPayload({
        page: snapshot.page || viewMode,
        step: typeof snapshot.step === "number" ? snapshot.step : step,
        visibleErrorMessage,
        userMessage: userErrorReportMessage,
        viewportWidth,
        viewportHeight,
        userAgent:
          typeof navigator !== "undefined" ? navigator.userAgent : "",
        contractDraftId,
        inviteToken: activeInvite?.token || activeInvite?.inviteId || "",
        managerCode: currentManager?.code || "",
        screenshotDataUrl,
        captureError: snapshot.captureError || "",
        capturedAt: snapshot.capturedAt || "",
      });
      const nowMs = Date.now();
      const reportFingerprint = [
        payload.contractDraftId || "no-draft",
        payload.step,
        payload.visibleErrorMessage || "",
        payload.userMessage || "",
      ].join("|");
      if (
        lastUserErrorReportSubmitRef.current?.fingerprint === reportFingerprint &&
        nowMs - lastUserErrorReportSubmitRef.current.submittedAtMs < 10000
      ) {
        setToastMessage("같은 오류신고가 이미 접수되었습니다. 잠시 후 다시 시도해 주세요.");
        return;
      }
      const now = new Date().toISOString();
      let requestMeta = { ip: "unknown" };
      try {
        requestMeta = await fetchRequestMeta();
      } catch (metaError) {
        console.info("[CNFOOD] error report meta fallback", sanitizeErrorForLog(metaError));
      }
      await addDoc(collection(db, "artifacts", appId, "error_reports"), {
        ...payload,
        timestamp: now,
        createdAt: now,
        deviceInfo: getDeviceInfo(),
        ip: requestMeta.ip || "unknown",
      });
      lastUserErrorReportSubmitRef.current = {
        fingerprint: reportFingerprint,
        submittedAtMs: nowMs,
      };
      setToastMessage("오류신고가 접수되었습니다. 확인 후 개선하겠습니다.");
      setUserErrorReportMessage("");
      setPendingUserErrorReportSnapshot(null);
      setShowUserErrorReport(false);
    } catch (error) {
      console.error("[CNFOOD] user error report failed", sanitizeErrorForLog(error));
      setToastMessage("오류신고를 저장하지 못했습니다. 잠시 후 다시 시도해 주세요.");
    } finally {
      setUserErrorReportSaving(false);
    }
  };

  const applyKcpDraftRestoreState = (draftState: KcpDraftRestoreState | null) => {
    if (!draftState) return false;
    const businessReadiness = resolveBusinessVerificationReadiness({
      currentInput: draftState.formData || {},
      latestBusinessVerification: draftState.businessVerification || null,
      previousBusinessVerification:
        businessVerification || lastValidBusinessVerificationRef.current,
    });
    setFormData((prev) => ({
      ...prev,
      ...(draftState.formData || {}),
      ssnFront: "",
      ssnBack: "",
      principalRepSsnFront: "",
      principalRepSsnBack: "",
      guarantorSsnFront: "",
      guarantorSsnBack: "",
    }));
    setBizType(draftState.bizType || "INDIVIDUAL");
    if (draftState.selYear) setSelYear(draftState.selYear);
    if (draftState.selMonth) setSelMonth(draftState.selMonth);
    if (draftState.selDay) setSelDay(draftState.selDay);
    setIsSameDayDeposit(Boolean(draftState.isSameDayDeposit));
    setManualAddressMode(Boolean(draftState.manualAddressMode));
    setManualCorpAddrMode(Boolean(draftState.manualCorpAddrMode));
    if (draftState.agreements) {
      setAgreements((prev) => ({ ...prev, ...draftState.agreements }));
    }
    if (draftState.activeInvite) setActiveInvite(draftState.activeInvite);
    setCoRepresentativeDeclared(Boolean(draftState.coRepresentativeDeclared));
    if (
      Array.isArray(draftState.coRepresentativesContactSnapshot) &&
      draftState.coRepresentativesContactSnapshot.length > 0
    ) {
      setCoRepresentatives((prev) =>
        mergeCoRepresentativesContactSnapshot({
          current: prev,
          snapshot: draftState.coRepresentativesContactSnapshot,
        })
      );
    }
    setCoRepresentativeNtsInfo(draftState.coRepresentativeNtsInfo || null);
    setRestoredSsnDraft(draftState.restoredSsnDraft || null);
    if (businessReadiness.businessVerification) {
      setBusinessVerification(businessReadiness.businessVerification);
    }
    setShowIntroPage(false);
    setViewMode("FORM");
    return true;
  };

  const createEncryptedSsnDraftForKcpRestore = async (): Promise<KcpRestoredSsnDraft | null> => {
    const principalFront = formData.principalRepSsnFront || formData.ssnFront;
    const principalBack = formData.principalRepSsnBack || formData.ssnBack;
    const guarantorFront = formData.guarantorSsnFront;
    const guarantorBack = formData.guarantorSsnBack;
    const nextDraft: KcpRestoredSsnDraft = {};
    const legacyGuarantorSsnRequired =
      shouldRequireLegacyGuarantorSsnInPrimaryStep(bizType);

    if (principalFront || principalBack) {
      if (!isValidResidentRegistrationInput(bizType, principalFront, principalBack)) {
        throw new Error("INVALID_PRINCIPAL_SSN");
      }
      nextDraft.principalRepSsnEncrypted = await encryptText(`${principalFront}|${principalBack}`);
      nextDraft.principalRepSsnMasked = maskResidentRegistrationNumber(principalFront);
    }

    if (legacyGuarantorSsnRequired && (guarantorFront || guarantorBack)) {
      if (!isValidResidentRegistrationInput(bizType, guarantorFront, guarantorBack)) {
        throw new Error("INVALID_GUARANTOR_SSN");
      }
      nextDraft.guarantorSsnEncrypted = await encryptText(`${guarantorFront}|${guarantorBack}`);
      nextDraft.guarantorSsnMasked = maskResidentRegistrationNumber(guarantorFront);
    }

    return Object.keys(nextDraft).length > 0 ? nextDraft : null;
  };

  const persistKcpDraftRestoreBeforeStart = async (sessionId = "") => {
    const nextRestoredSsnDraft =
      (await createEncryptedSsnDraftForKcpRestore()) || restoredSsnDraft;
    const inviteMetadata = buildContractInviteMetadata(activeInvite);
    const coRepresentativesContactSnapshot = buildCoRepresentativesContactSnapshot({
      declared: coRepresentativeDeclared,
      representatives: coRepresentatives,
    });
    const safeCoRepresentativeRecords = buildPrimaryCoRepresentativeRecords({
      declared: coRepresentativeDeclared,
      representatives: coRepresentativesContactSnapshot,
      businessNumber: formData.agentBizNo,
    });
    const draftState = createKcpDraftRestoreState({
      draftId: contractDraftId,
      step,
      bizType,
      formData,
      businessVerification,
      selYear,
      selMonth,
      selDay,
      isSameDayDeposit,
      manualAddressMode,
      manualCorpAddrMode,
      ownerType: inviteMetadata.ownerType,
      ownerLabel: inviteMetadata.ownerLabel,
      inviteToken: activeInvite?.token || "",
      activeInvite,
      agreements,
      coRepresentativeDeclared,
      coRepresentativesContactSnapshot,
      coRepresentativeWorkflow: buildCoRepresentativeWorkflow({
        required: coRepresentativeDeclared,
        representatives: safeCoRepresentativeRecords,
      }),
      coRepresentativeNtsInfo,
      kcpSessionId: sessionId,
      restoredSsnDraft: nextRestoredSsnDraft,
    });
    saveKcpDraftRestoreState(draftState);
    if (sessionId) {
      saveKcpSessionPointer({
        draftId: contractDraftId,
        kcpSessionId: sessionId,
        updatedAt: draftState.updatedAt,
      });
    }
    setRestoredSsnDraft(nextRestoredSsnDraft || null);
    return draftState;
  };

  const queueContractEvent = (
    type: ContractEventType,
    detail = {},
    actorType: "CUSTOMER" | "ADMIN" | "SYSTEM" = "CUSTOMER"
  ) => {
    contractEventQueueRef.current.push({
      type,
      createdAt: new Date().toISOString(),
      actorType,
      managerCode: currentManager?.code || null,
      userAgent:
        typeof navigator !== "undefined" ? navigator.userAgent : null,
      detail: sanitizeLogDetail(detail),
    });
  };

  const flushQueuedContractEvents = async (documentId, contractId) => {
    const events = contractEventQueueRef.current.splice(0);
    for (const event of events) {
      await logContractEvent(documentId, { ...event, contractId });
    }
  };

  const reportCompletedEventLogFailureOnce = async ({
    contractId = "",
    draftId = "",
    documentId = "",
    eventResult = {},
    eventType = "CONTRACT_COMPLETED",
  } = {}) => {
    const idempotencyKey = `cnfood.completed-event-log-failed.v1.${
      contractId || draftId || documentId || "unknown"
    }`;
    if (completedEventFailureReportedKeysRef.current.has(idempotencyKey)) {
      return;
    }
    if (
      typeof window !== "undefined" &&
      window.sessionStorage?.getItem(idempotencyKey)
    ) {
      completedEventFailureReportedKeysRef.current.add(idempotencyKey);
      return;
    }

    completedEventFailureReportedKeysRef.current.add(idempotencyKey);
    try {
      if (typeof window !== "undefined") {
        window.sessionStorage?.setItem(idempotencyKey, "1");
      }
    } catch {
      // sessionStorage is a best-effort duplicate guard only.
    }

    const failurePayload = buildContractEventFailureReportPayload({
      eventType,
      appId,
      collectionPath:
        eventResult?.collectionPath || getContractEventCollectionPath(documentId),
      docId: eventResult?.docId,
      contractId,
      draftId,
      currentStep: 5,
      error: eventResult?.error || { message: "contract event log failed" },
    });

    await reportError(
      "CONTRACT_COMPLETED_EVENT_FAILED",
      failurePayload.message,
      5,
      failurePayload
    );
  };

  const markContractScrolled90 = () => {
    setContractScrolled(true);
    if (!contractScrolledEventLoggedRef.current) {
      contractScrolledEventLoggedRef.current = true;
      queueContractEvent("CONTRACT_SCROLLED_90", { step: 2 });
    }
  };

  const queueDraftCreatedEvent = () => {
    if (draftCreatedEventQueuedRef.current) return;
    draftCreatedEventQueuedRef.current = true;
    const createdDetail = {
      bizType,
      hasInvite: Boolean(activeInvite?.inviteId || activeInvite?.id),
    };
    queueContractEvent("DRAFT_CREATED", createdDetail);
    queueContractEvent("CONTRACT_CREATED", createdDetail);
  };

  const formatAdminUpdatedAt = (value) => {
    if (!value) return "수정 이력 없음";
    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime())
      ? value
      : parsed.toLocaleString("ko-KR");
  };

  const handleAdminWriteError = (error, action = "admin write") => {
    console.error(`${action} failed`, sanitizeErrorForLog(error));
    setToastMessage(
      getFirestoreErrorToastMessage(
        error,
        "저장하지 못했습니다. 잠시 후 다시 시도해 주세요."
      )
    );
  };

  const handleSaveValidationSettings = async () => {
    try {
      const normalizedSettings = normalizeValidationSettings(validationSettingsDraft);
      saveValidationSettings(normalizedSettings);
      setValidationSettings(normalizedSettings);
      setValidationSettingsDraft(normalizedSettings);
      await setDoc(
        doc(db, "artifacts", appId, "config", "validation_settings"),
        {
          ...normalizedSettings,
          updatedAt: new Date().toISOString(),
          updatedBy: currentManager?.name || "admin",
        }
      );
      setToastMessage("검증 설정이 전체 서비스 설정으로 저장되었습니다.");
    } catch (e) {
      console.error("validation settings save failed", sanitizeErrorForLog(e));
      setToastMessage("검증 설정을 저장하지 못했습니다.");
    }
  };

  const requestContractAppStatus = async ({
    includeInternal = false,
    silent = false,
  } = {}) => {
    if (!silent) {
      setContractAppStatusLoading(true);
      setContractAppStatusError("");
    }
    try {
      const response = await fetch("/api/admin-login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          mode: "getAppStatus",
          appId,
          password: includeInternal
            ? adminSessionPasswordRef.current || adminPassword
            : "",
          includeInternal,
        }),
      });
      const result = await response.json().catch(() => null);
      if (!response.ok || !result?.ok) {
        throw new Error(result?.message || "APP_STATUS_LOAD_FAILED");
      }
      const nextStatus = buildContractAppStatus(result.appStatus || {});
      setContractAppStatus(nextStatus);
      setContractAppStatusLoaded(true);
      if (includeInternal) {
        setContractAppStatusDraft(nextStatus);
      }
      return nextStatus;
    } catch (error) {
      console.warn("[CNFOOD] app status load failed", sanitizeErrorForLog(error));
      if (!silent) {
        setContractAppStatusError(
          "전자계약 운영 상태 확인이 지연되고 있습니다. 기본 정상 운영 상태로 표시합니다."
        );
      }
      return null;
    } finally {
      setContractAppStatusLoaded(true);
      if (!silent) setContractAppStatusLoading(false);
    }
  };

  useEffect(() => {
    void requestContractAppStatus({ silent: true });
  }, []);

  const handleApplyContractAppStatusPreset = (status: ContractAppStatusCode) => {
    setContractAppStatusDraft((prev) =>
      buildContractAppStatus({
        ...getContractAppStatusPreset(status),
        reason: prev.reason,
        updatedBy: currentManager?.name || "본사",
      })
    );
  };

  const handleSaveContractAppStatus = async () => {
    const password = adminSessionPasswordRef.current || adminPassword;
    if (!password) {
      setToastMessage("관리자 비밀번호 확인이 필요합니다.");
      return;
    }
    const draft = buildContractAppStatus(contractAppStatusDraft);
    if (
      ["START_PAUSED", "FULL_PAUSED", "ADMIN_TEST_ONLY"].includes(draft.status) &&
      !String(draft.reason || "").trim()
    ) {
      setContractAppStatusError("일시중단 또는 테스트 모드는 변경 사유를 입력해 주세요.");
      return;
    }
    setContractAppStatusSaving(true);
    setContractAppStatusError("");
    try {
      const response = await fetch("/api/admin-login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          mode: "updateAppStatus",
          appId,
          password,
          status: draft.status,
          title: draft.title,
          message: draft.message,
          supportPhone: draft.supportPhone,
          expectedResumeAt: draft.expectedResumeAt,
          reason: draft.reason,
          allowInProgressSubmit: draft.allowInProgressSubmit,
          showBanner: draft.showBanner,
          updatedBy: currentManager?.name || "본사",
        }),
      });
      const result = await response.json().catch(() => null);
      if (!response.ok || !result?.ok) {
        throw new Error(result?.message || "APP_STATUS_SAVE_FAILED");
      }
      const nextStatus = buildContractAppStatus(result.appStatus || draft);
      setContractAppStatus(nextStatus);
      setContractAppStatusDraft(nextStatus);
      setToastMessage("전자계약 운영 상태가 저장되었습니다.");
    } catch (error) {
      const message =
        error?.message || "전자계약 운영 상태를 저장하지 못했습니다.";
      setContractAppStatusError(message);
      setToastMessage(message);
    } finally {
      setContractAppStatusSaving(false);
    }
  };

  const ensureContractAppStatusAllows = async (
    action: ContractAppStatusAction,
    { refresh = false } = {}
  ) => {
    const latest = refresh
      ? await requestContractAppStatus({ silent: true })
      : null;
    const statusForGate = latest || contractAppStatus;
    const gate = canProceedCurrentContract(statusForGate, step, {
      action,
      isAdmin: adminAccessMode === "ADMIN" && Boolean(currentManager?.name),
      statusLoaded: Boolean(latest || contractAppStatusLoaded),
    });
    if (!gate.allowed) {
      setToastMessage(gate.message);
      if (action === "KCP" || action === "SMS") {
        setOtpError(gate.message);
      }
      return false;
    }
    if (refresh && !latest) {
      setToastMessage("운영 상태 확인이 지연되고 있습니다. 현재 화면 기준으로 계속 진행합니다.");
    }
    return true;
  };

  const syncContractTemplateDraft = (template: Partial<ContractTemplate> | null) => {
    const fallback = buildNewContractTemplate({});
    const nextTemplate = template?.clauses?.length ? template : fallback;
    setContractTemplateDraft({
      versionId:
        nextTemplate.source === "DEFAULT" || nextTemplate.status === "FALLBACK"
          ? nextTemplate.versionId || CONTRACT_DOCUMENT_VERSION
          : "",
      title: nextTemplate.title || DEFAULT_CONTRACT_TEMPLATE_TITLE,
      clauses: buildContractClausesSnapshot(nextTemplate),
      changeReason: "",
    });
  };

  const loadApprovedDefaultContractTemplateDraft = () => {
    const fallback = buildNewContractTemplate({});
    setContractTemplateDraft({
      versionId: fallback.versionId,
      title: fallback.title,
      clauses: buildContractClausesSnapshot(fallback),
      changeReason: "",
    });
    setContractTemplateError("");
    setToastMessage("승인본 V2 기본 조항을 편집 화면에 불러왔습니다.");
  };

  const loadActiveContractTemplate = async ({ silent = false } = {}) => {
    setContractTemplateLoading(true);
    setContractTemplateError("");
    try {
      const response = await fetch(
        `/api/admin-contract-template?${new URLSearchParams({
          mode: "getActive",
          appId,
        }).toString()}`
      );
      const result = await response.json().catch(() => ({
        ok: false,
        message: "계약서 조항을 불러오지 못했습니다.",
      }));
      if (!response.ok || !result?.ok) {
        throw new Error(result?.message || "contract template load failed");
      }
      const template = result.template
        ? {
            ...result.template,
            source: result.source || "FIRESTORE",
            clauses: buildContractClausesSnapshot(result.template),
          }
        : buildNewContractTemplate({});
      setActiveContractTemplate(template);
      syncContractTemplateDraft(template);
      return template;
    } catch (error) {
      console.error("[CNFOOD] contract template load failed", sanitizeErrorForLog(error));
      const fallback = buildNewContractTemplate({});
      setActiveContractTemplate(fallback);
      syncContractTemplateDraft(fallback);
      setContractTemplateError("계약서 조항을 불러오지 못해 기본 조항을 사용합니다.");
      if (!silent) {
        setToastMessage("계약서 조항을 불러오지 못해 기본 조항을 사용합니다.");
      }
      return fallback;
    } finally {
      setContractTemplateLoading(false);
    }
  };

  const updateContractTemplateClause = (index, patch) => {
    setContractTemplateDraft((prev) => ({
      ...prev,
      clauses: prev.clauses.map((clause, clauseIndex) =>
        clauseIndex === index ? { ...clause, ...patch } : clause
      ),
    }));
  };

  const addContractTemplateClause = () => {
    setContractTemplateDraft((prev) => ({
      ...prev,
      clauses: [
        ...prev.clauses,
        {
          id: `clause_${prev.clauses.length + 1}`,
          title: `제${prev.clauses.length + 1}조`,
          body: "",
        },
      ],
    }));
  };

  const handlePublishContractTemplate = async () => {
    if (contractTemplateSaving) return;
    if (!isHeadquarters()) {
      setContractTemplateError("본사 관리자만 계약서 조항을 발행할 수 있습니다.");
      return;
    }
    const title = String(contractTemplateDraft.title || "").trim();
    const clauses = normalizeContractTemplateClauses(contractTemplateDraft.clauses);
    const changeReason = String(contractTemplateDraft.changeReason || "").trim();
    if (!title) {
      setContractTemplateError("계약서 제목을 입력해 주세요.");
      return;
    }
    if (clauses.length < 1) {
      setContractTemplateError("계약서 조항을 1개 이상 입력해 주세요.");
      return;
    }
    if (!changeReason) {
      setContractTemplateError("조항 변경 사유를 입력해 주세요.");
      return;
    }
    setContractTemplateSaving(true);
    setContractTemplateError("");
    try {
      const response = await fetch("/api/admin-contract-template", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          mode: "publish",
          appId,
          password: adminSessionPasswordRef.current || adminPassword,
          title,
          clauses,
          changeReason,
          updatedBy: currentManager?.name || "본사",
          versionId: contractTemplateDraft.versionId || undefined,
        }),
      });
      const result = await response.json().catch(() => ({
        ok: false,
        message: "계약서 조항을 발행하지 못했습니다.",
      }));
      if (!response.ok || !result?.ok) {
        throw new Error(result?.message || "contract template publish failed");
      }
      const template = {
        ...(result.template || {}),
        versionId: result.activeVersion || result.nextVersion,
        source: "FIRESTORE",
        clauses: buildContractClausesSnapshot(result.template),
      };
      setActiveContractTemplate(template);
      syncContractTemplateDraft(template);
      setToastMessage("계약서 조항 새 버전이 발행되었습니다. 새 계약부터 적용됩니다.");
    } catch (error) {
      console.error("[CNFOOD] contract template publish failed", sanitizeErrorForLog(error));
      const message =
        error?.message || "계약서 조항을 발행하지 못했습니다. 다시 시도해 주세요.";
      setContractTemplateError(message);
      setToastMessage(message);
    } finally {
      setContractTemplateSaving(false);
    }
  };

  const callLegacyContractsApi = async (mode, payload = {}) => {
    const response = await fetch("/api/legacy-contracts", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        mode: "legacy-contracts",
        legacyMode: mode,
        appId,
        password: adminSessionPasswordRef.current || adminPassword,
        createdBy: currentManager?.name || "본사",
        updatedBy: currentManager?.name || "본사",
        uploadedBy: currentManager?.name || "본사",
        ...payload,
      }),
    });
    const result = await response.json().catch(() => ({
      ok: false,
      message: "기존 계약 관리 요청을 처리하지 못했습니다.",
    }));
    if (!response.ok || !result?.ok) {
      const error = new Error(result?.message || "legacy contracts API failed");
      error.code = result?.code;
      throw error;
    }
    return result;
  };

  const loadLegacyContracts = async () => {
    if (!isHeadquarters()) {
      setLegacyContractsError("본사 관리자만 기존 계약 자료를 조회할 수 있습니다.");
      return;
    }
    setLegacyContractsLoading(true);
    setLegacyContractsError("");
    try {
      const result = await callLegacyContractsApi("list", { limit: 500 });
      setLegacyContracts(Array.isArray(result.items) ? result.items : []);
    } catch (error) {
      console.error("[CNFOOD] legacy contracts load failed", sanitizeErrorForLog(error));
      const message =
        error?.code === "permission-denied"
          ? "기존 계약 자료 조회 권한이 없습니다."
          : error?.code === "failed-precondition"
          ? "기존 계약 자료 조회 인덱스 설정이 필요합니다."
          : error?.message || "기존 계약 자료를 불러오지 못했습니다.";
      setLegacyContractsError(message);
      setToastMessage(message);
    } finally {
      setLegacyContractsLoading(false);
    }
  };

  const downloadLegacyExcelTemplate = async () => {
    try {
      const response = await fetch("/api/legacy-contracts", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          mode: "legacy-contracts",
          legacyMode: "downloadTemplate",
          appId,
          password: adminSessionPasswordRef.current || adminPassword,
        }),
      });
      if (!response.ok) {
        throw new Error("template download failed");
      }
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = "cnfood_legacy_contract_template.xlsx";
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("[CNFOOD] legacy template download failed", sanitizeErrorForLog(error));
      setToastMessage("기존 계약 엑셀 양식을 내려받지 못했습니다.");
    }
  };

  const previewLegacyExcelRows = async (rows) => {
    setLegacyContractsError("");
    try {
      const result = await callLegacyContractsApi("importPreview", {
        rows,
        batchId: createStableId("legacy_batch"),
      });
      setLegacyImportRows(rows);
      setLegacyImportPreview(result);
    } catch (error) {
      console.error("[CNFOOD] legacy import preview failed", sanitizeErrorForLog(error));
      const message = error?.message || "엑셀 미리보기 생성에 실패했습니다.";
      setLegacyContractsError(message);
      setToastMessage(message);
    }
  };

  const handleLegacyExcelFileChange = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;
    setLegacyContractsLoading(true);
    try {
      const XLSX = await import("xlsx");
      const buffer = await file.arrayBuffer();
      const workbook = XLSX.read(buffer, { type: "array" });
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const rows = XLSX.utils.sheet_to_json(worksheet, { defval: "" });
      await previewLegacyExcelRows(rows);
    } catch (error) {
      console.error("[CNFOOD] legacy excel parse failed", sanitizeErrorForLog(error));
      setToastMessage("엑셀 파일을 읽지 못했습니다. 양식을 확인해 주세요.");
    } finally {
      setLegacyContractsLoading(false);
    }
  };

  const downloadSafeContractRowsAsXlsx = async (
    rows = [],
    fileNamePrefix = "cnfood_contract"
  ) => {
    const exportRows = buildSafeContractExportRows(rows);
    if (exportRows.length === 0) {
      setToastMessage("다운로드할 계약 데이터가 없습니다.");
      return;
    }
    try {
      const XLSX = await import("xlsx");
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(exportRows);
      XLSX.utils.book_append_sheet(workbook, worksheet, "contracts");
      const today = new Date().toISOString().slice(0, 10).replace(/-/g, "");
      XLSX.writeFile(workbook, `${fileNamePrefix}_${today}.xlsx`);
    } catch (error) {
      console.error("[CNFOOD] contract export failed", sanitizeErrorForLog(error));
      setToastMessage("엑셀 다운로드를 생성하지 못했습니다.");
    }
  };

  const updateLegacyPreviewRow = (index, patch) => {
    const nextRows = legacyImportRows.map((row, rowIndex) =>
      rowIndex === index ? { ...row, ...patch } : row
    );
    void previewLegacyExcelRows(nextRows);
  };

  const removeLegacyPreviewRow = (index) => {
    const nextRows = legacyImportRows.filter((_, rowIndex) => rowIndex !== index);
    void previewLegacyExcelRows(nextRows);
  };

  const applyLegacyImport = async () => {
    if (!legacyImportRows.length || legacyImportApplying) return;
    setLegacyImportApplying(true);
    setLegacyContractsError("");
    try {
      const result = await callLegacyContractsApi("importApply", {
        rows: legacyImportRows,
        batchId: legacyImportPreview?.batchId || createStableId("legacy_batch"),
      });
      setToastMessage(`기존 계약 ${result.importedCount || 0}건을 등록했습니다.`);
      setLegacyImportPreview(null);
      setLegacyImportRows([]);
      await loadLegacyContracts();
    } catch (error) {
      console.error("[CNFOOD] legacy import apply failed", sanitizeErrorForLog(error));
      const message = error?.message || "기존 계약 등록에 실패했습니다.";
      setLegacyContractsError(message);
      setToastMessage(message);
    } finally {
      setLegacyImportApplying(false);
    }
  };

  const callVendorMasterApi = async (mode, payload = {}) => {
    const response = await fetch("/api/vendor-master", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        mode: "vendor-master",
        vendorMode: mode,
        appId,
        password: adminSessionPasswordRef.current || adminPassword,
        createdBy: currentManager?.name || "본사",
        updatedBy: currentManager?.name || "본사",
        ...payload,
      }),
    });
    const result = await response.json().catch(() => ({
      ok: false,
      message: "거래처 관리 요청을 처리하지 못했습니다.",
    }));
    if (!response.ok || (!result?.ok && result?.status !== "PARTIAL_FAILED")) {
      const error = new Error(result?.message || "vendor master API failed");
      error.code = result?.code;
      error.duplicateFields = Array.isArray(result?.duplicateFields)
        ? result.duplicateFields
        : [];
      throw error;
    }
    return result;
  };

  const callCompanyBranchesApi = async (mode, payload = {}) => {
    const response = await fetch("/api/company-branches", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        mode: "company-branches",
        companyBranchMode: mode,
        appId,
        password: adminSessionPasswordRef.current || adminPassword,
        createdBy: currentManager?.name || "본사",
        updatedBy: currentManager?.name || "본사",
        ...payload,
      }),
    });
    const result = await response.json().catch(() => ({
      ok: false,
      message: "사업장 관리 요청을 처리하지 못했습니다.",
    }));
    if (!response.ok || !result?.ok) {
      const error = new Error(result?.message || "company branches API failed");
      error.code = result?.code;
      throw error;
    }
    return result;
  };

  const callPaymentRequestsApi = async (
    paymentMode,
    payload = {},
    { signal }: { signal?: AbortSignal } = {}
  ) => {
    const response = await fetch("/api/payment-requests", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      signal,
      body: JSON.stringify({
        mode: "payment-requests",
        paymentMode,
        appId,
        password: adminSessionPasswordRef.current || adminPassword,
        ...(salesPaymentActorCodeRef.current
          ? { salesRepCode: salesPaymentActorCodeRef.current }
          : {}),
        createdBy: currentManager?.name || "결제 담당",
        ...payload,
      }),
    });
    const result = await response.json().catch(() => ({
      ok: false,
      message: "결제관리 요청을 처리하지 못했습니다.",
    }));
    if (!response.ok || !result?.ok) {
      const error = new Error(result?.message || "payment requests API failed");
      error.code = result?.code;
      error.fieldErrors = result?.errors || {};
      throw error;
    }
    return result;
  };

  const loadErpBridge = async () => {
    setErpBridgeLoading(true);
    setErpBridgeError("");
    try {
      const result = await callPaymentRequestsApi("listErpBridge");
      setErpBridgeSummary(result);
      return result;
    } catch (error) {
      const message = error?.message || "ERP 연계 현황을 불러오지 못했습니다.";
      setErpBridgeError(message);
      throw error;
    } finally {
      setErpBridgeLoading(false);
    }
  };

  const createErpBridgeBatch = async (erpEventIds: string[]) => {
    const result = await callPaymentRequestsApi("createErpCardBatch", {
      erpEventIds,
    });
    return result;
  };

  const loadErpCardConfiguration = async () => {
    setErpCardConfigurationLoading(true);
    setErpCardConfigurationError("");
    try {
      const result = await callPaymentRequestsApi("listErpCardConfiguration");
      setErpCardConfiguration(result);
      return result;
    } catch (error) {
      const message = error?.message || "ERP 카드사 설정을 불러오지 못했습니다.";
      setErpCardConfigurationError(message);
      throw error;
    } finally {
      setErpCardConfigurationLoading(false);
    }
  };

  const mutateErpCardMapping = async (paymentMode, payload, successMessage) => {
    setErpCardConfigurationSaving(true);
    setErpCardConfigurationError("");
    try {
      const result = await callPaymentRequestsApi(paymentMode, payload);
      await loadErpCardConfiguration();
      setToastMessage(successMessage);
      return result;
    } catch (error) {
      const message = error?.message || "ERP 카드사 매핑을 변경하지 못했습니다.";
      setErpCardConfigurationError(message);
      setToastMessage(message);
      throw error;
    } finally {
      setErpCardConfigurationSaving(false);
    }
  };

  const createErpCardMapping = async (mapping) =>
    mutateErpCardMapping(
      "createErpCardMapping",
      { mapping },
      `${mapping.sourceCardName} → ${mapping.targetErpCardName} 매핑을 등록했습니다.`
    );

  const updateErpCardMapping = async (mappingId, patch) =>
    mutateErpCardMapping(
      "updateErpCardMapping",
      { mappingId, patch },
      "ERP 카드사 매핑을 수정했습니다."
    );

  const deleteErpCardMapping = async (mappingId) =>
    mutateErpCardMapping(
      "deleteErpCardMapping",
      { mappingId },
      "ERP 카드사 매핑을 삭제했습니다."
    );

  const toggleErpCardMapping = async (mappingId, enabled) =>
    mutateErpCardMapping(
      "toggleErpCardMapping",
      { mappingId, enabled },
      `ERP 카드사 매핑을 ${enabled ? "활성" : "비활성"}화했습니다.`
    );

  const clearSensitivePaymentCardInput = () => {
    setSensitiveCardInput(createEmptySensitiveCardInput());
  };

  const preparePaymentQueueItem = (request) => {
    if (!request || request.requestType !== "KEYIN" || !request.batchId) return;
    const queueVendor = paymentVendorOptions.find(
      (vendor) => vendor.vendorId === request.vendorId
    );
    setPaymentRequestForm({
      ...createEmptyPaymentRequestForm(),
      requestType: "KEYIN",
      amount: String(Number(request.amount) || ""),
      itemName: request.itemName || "",
      customerName: request.customerName || "",
      vendorId: request.vendorId || "",
      memo: request.memo || "",
    });
    const queueVendorLabel = queueVendor
      ? buildPaymentVendorLookupLabel(queueVendor)
      : request.vendorBusinessName || request.customerName || "";
    invalidatePaymentDirectoryRequest();
    paymentVendorSearchRef.current = queueVendorLabel;
    setPaymentVendorSearchComposing(false);
    setPaymentVendorSearch(queueVendorLabel);
    setPaymentVendorLookupOpen(false);
    setActivePaymentQueueItemId(request.paymentRequestId || request.id || "");
    clearSensitivePaymentCardInput();
    setPaymentRequestsError("");
  };

  const clearActivePaymentQueueItem = () => {
    invalidatePaymentDirectoryRequest();
    paymentVendorSearchRef.current = "";
    setPaymentVendorSearchComposing(false);
    resetPaymentDirectoryForSearchInput();
    setActivePaymentQueueItemId("");
    setPaymentRequestForm({
      ...createEmptyPaymentRequestForm(),
      requestType: "KEYIN",
    });
    setPaymentVendorSearch("");
    setPaymentVendorLookupOpen(false);
    clearSensitivePaymentCardInput();
  };

  const handleDownloadPaymentBatchTemplate = async () => {
    try {
      const XLSX = await import("xlsx");
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.aoa_to_sheet([
        PAYMENT_BATCH_TEMPLATE_HEADERS,
        ["ORD-202607-001", "예시 고객", 33000, "7월 식자재 대금", ""],
      ]);
      worksheet["!cols"] = [
        { wch: 22 },
        { wch: 16 },
        { wch: 14 },
        { wch: 32 },
        { wch: 36 },
      ];
      const guideSheet = XLSX.utils.json_to_sheet([
        {
          구분: "허용 열",
          내용: PAYMENT_BATCH_TEMPLATE_HEADERS.join(", "),
        },
        {
          구분: "입력 금지",
          내용: "카드번호, 유효기간, CVC, 카드 비밀번호, 주민등록번호, 휴대폰번호",
        },
        {
          구분: "처리 단위",
          내용: `파일당 최대 ${PAYMENT_BATCH_MAX_SIZE}건`,
        },
      ]);
      guideSheet["!cols"] = [{ wch: 18 }, { wch: 80 }];
      XLSX.utils.book_append_sheet(workbook, worksheet, "KEYIN_QUEUE");
      XLSX.utils.book_append_sheet(workbook, guideSheet, "README");
      XLSX.writeFile(workbook, "cnfood_keyin_batch_template.xlsx");
    } catch (error) {
      const message = "키인결제 엑셀 양식을 만들지 못했습니다.";
      setPaymentRequestsError(message);
      setToastMessage(message);
    }
  };

  const handlePaymentBatchFileChange = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;
    setPaymentRequestsError("");
    try {
      const XLSX = await import("xlsx");
      const buffer = await file.arrayBuffer();
      const workbook = XLSX.read(buffer, { type: "array" });
      const firstSheetName = workbook.SheetNames[0];
      if (!firstSheetName) throw new Error("엑셀 시트를 찾지 못했습니다.");
      const rows = XLSX.utils.sheet_to_json(workbook.Sheets[firstSheetName], {
        defval: "",
      });
      const preview = buildPaymentBatchImportPreview(rows);
      setPaymentBatchImportFileName(file.name);
      setPaymentBatchImportPreview(preview);
      setPaymentRequestForm((prev) => ({ ...prev, requestType: "KEYIN" }));
      setActivePaymentQueueItemId("");
      clearSensitivePaymentCardInput();
      if (!preview.canImport) {
        setPaymentRequestsError(
          preview.errors[0]?.message || "엑셀 업로드 내용을 확인해 주세요."
        );
      }
    } catch (error) {
      const message = error?.message || "엑셀 파일을 읽지 못했습니다.";
      setPaymentBatchImportFileName(file.name);
      setPaymentBatchImportPreview(null);
      setPaymentRequestsError(message);
      setToastMessage(message);
    }
  };

  const handleImportPaymentBatch = async () => {
    if (paymentBatchImportSaving || !paymentBatchImportPreview?.canImport) return;
    setPaymentBatchImportSaving(true);
    setPaymentRequestsError("");
    try {
      const result = await callPaymentRequestsApi("createBatch", {
        rows: paymentBatchImportPreview.rows,
      });
      const items = Array.isArray(result.items) ? result.items : [];
      setPaymentRequests((prev) => [
        ...items,
        ...prev.filter(
          (existing) =>
            !items.some(
              (item) => item.paymentRequestId === existing.paymentRequestId
            )
        ),
      ]);
      setPaymentBatchImportPreview(null);
      setPaymentBatchImportFileName("");
      if (items[0]) preparePaymentQueueItem(items[0]);
      setToastMessage(result.message || `${items.length}건을 대기열에 등록했습니다.`);
    } catch (error) {
      const message = error?.message || "키인결제 대기열을 등록하지 못했습니다.";
      setPaymentRequestsError(message);
      setToastMessage(message);
    } finally {
      setPaymentBatchImportSaving(false);
    }
  };

  const handleExportPaymentHistory = async () => {
    const exportRows = buildPaymentHistoryExportRows(filteredPaymentRequests);
    const erpRows = buildPaymentErpExportRows(filteredPaymentRequests);
    if (exportRows.length === 0) {
      const message = "내보낼 결제관리 내역이 없습니다.";
      setPaymentRequestsError(message);
      setToastMessage(message);
      return;
    }
    try {
      const XLSX = await import("xlsx");
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(exportRows);
      worksheet["!cols"] = Object.keys(exportRows[0]).map((key) => ({
        wch: Math.min(Math.max(String(key).length + 4, 12), 40),
      }));
      XLSX.utils.book_append_sheet(workbook, worksheet, "PAYMENT_HISTORY");
      if (erpRows.length > 0) {
        const erpWorksheet = XLSX.utils.json_to_sheet(erpRows);
        erpWorksheet["!cols"] = Object.keys(erpRows[0]).map((key) => ({
          wch: Math.min(Math.max(String(key).length + 4, 12), 40),
        }));
        XLSX.utils.book_append_sheet(workbook, erpWorksheet, "ERP_UPLOAD_PREP");
      }
      XLSX.writeFile(
        workbook,
        `cnfood_payment_history_${paymentHistoryFilters.dateFrom}_${paymentHistoryFilters.dateTo}.xlsx`
      );
      setToastMessage(`${exportRows.length}건의 결제관리 내역을 저장했습니다.`);
    } catch (error) {
      const message = "결제관리 내역 엑셀을 만들지 못했습니다.";
      setPaymentRequestsError(message);
      setToastMessage(message);
    }
  };

  const handleExportKeyinPaymentHistory = async () => {
    const keyinRequests = filteredPaymentRequests.filter(
      (request) => ["KEYIN", "AUTOPAY"].includes(request.requestType)
    );
    const exportRows = buildPaymentHistoryExportRows(keyinRequests);
    const erpRows = buildPaymentErpExportRows(keyinRequests);
    if (exportRows.length === 0) {
      const message = "선택한 기간에 내보낼 키인결제 내역이 없습니다.";
      setPaymentRequestsError(message);
      setToastMessage(message);
      return;
    }
    try {
      const XLSX = await import("xlsx");
      const workbook = XLSX.utils.book_new();
      const historySheet = XLSX.utils.json_to_sheet(exportRows);
      historySheet["!cols"] = Object.keys(exportRows[0]).map((key) => ({
        wch: Math.min(Math.max(String(key).length + 4, 12), 40),
      }));
      XLSX.utils.book_append_sheet(workbook, historySheet, "KEYIN_PAYMENT_HISTORY");
      if (erpRows.length > 0) {
        const erpSheet = XLSX.utils.json_to_sheet(erpRows);
        erpSheet["!cols"] = Object.keys(erpRows[0]).map((key) => ({
          wch: Math.min(Math.max(String(key).length + 4, 12), 40),
        }));
        XLSX.utils.book_append_sheet(workbook, erpSheet, "KEYIN_ERP_UPLOAD_PREP");
      }
      XLSX.writeFile(
        workbook,
        `cnfood_keyin_history_${paymentHistoryFilters.dateFrom}_${paymentHistoryFilters.dateTo}.xlsx`
      );
      setToastMessage(`${exportRows.length}건의 키인결제 내역을 저장했습니다.`);
    } catch (error) {
      const message = "키인결제 내역 엑셀을 만들지 못했습니다.";
      setPaymentRequestsError(message);
      setToastMessage(message);
    }
  };

  const applyPaymentDirectoryResult = (
    result = {},
    { append = false, query = "" } = {}
  ) => {
    const vendors = Array.isArray(result.vendors) ? result.vendors : [];
    const branches = Array.isArray(result.companyBranches) ? result.companyBranches : [];
    setPaymentDirectoryState((previous) =>
      buildPaymentDirectoryState(previous, result, { append, query })
    );
    setPaymentDirectoryWarning(getPaymentDirectoryDiagnosticMessage(result.scopeDiagnostics));
    setVendorMasters(
      vendors.map((vendor) => ({
        ...vendor,
        companyBranchPgProfile: {
          status: vendor.companyBranchPgStatus || "NOT_APPLIED",
          siteCdMasked: vendor.linkSiteCdMasked || vendor.keyinSiteCdMasked || "",
          buyLinkEnabled: vendor.linkPaymentEnabled === true,
          keyinEnabled: vendor.keyinPaymentEnabled === true,
          autopayEnabled: vendor.autopayPaymentEnabled === true,
        },
      }))
    );
    setCompanyBranches(branches);
    if (result.linkPayment && typeof result.linkPayment === "object") {
      setPaymentLinkConfig(result.linkPayment);
    }
    if (result.standardPayment && typeof result.standardPayment === "object") {
      setStandardPaymentConfig(result.standardPayment);
    }
    if (result.keyinPayment && typeof result.keyinPayment === "object") {
      setKeyinPaymentConfig(result.keyinPayment);
    }
    if (result.autopay && typeof result.autopay === "object") {
      const methods = Array.isArray(result.autopay.methods) ? result.autopay.methods : [];
      if (result.autopay.config && typeof result.autopay.config === "object") {
        setAutopayConfig(result.autopay.config);
      }
      setAutopayRegistrations(
        Array.isArray(result.autopay.registrations) ? result.autopay.registrations : []
      );
      setAutopayMethods(methods);
      setSelectedAutopayMethodId((current) =>
        methods.some(
          (method) =>
            method.billingMethodId === current && isAutopayMethodReadyForCharge(method)
        )
          ? current
          : ""
      );
    }
  };

  const invalidatePaymentDirectoryRequest = () => {
    paymentDirectoryRequestIdRef.current += 1;
    paymentDirectoryLatestRequestRef.current = {
      requestId: paymentDirectoryRequestIdRef.current,
      query: "",
      cursor: "",
    };
    paymentDirectoryAbortControllerRef.current?.abort();
    paymentDirectoryAbortControllerRef.current = null;
    setPaymentDirectoryLoading(false);
  };

  const resetPaymentDirectoryForSearchInput = () => {
    setPaymentDirectoryState((previous) =>
      createPaymentDirectoryState(previous.pagination.collectionTotalCount)
    );
  };

  const loadPaymentDirectory = async ({
    bypassAccess = false,
    vendorQuery = paymentVendorSearch,
    cursor = "",
    append = false,
    requestType = paymentRequestForm.requestType,
  } = {}) => {
    if (
      !bypassAccess &&
      !isHeadquarters() &&
      !["PAYMENT", "SALES_PAYMENT"].includes(adminAccessMode)
    ) {
      setPaymentDirectoryError("결제 거래처 조회 권한이 필요합니다.");
      return [];
    }
    const normalizedQuery = normalizePaymentVendorRequestQuery(vendorQuery);
    const normalizedCursor = String(cursor || "").trim();
    paymentDirectoryAbortControllerRef.current?.abort();
    const abortController = new AbortController();
    paymentDirectoryAbortControllerRef.current = abortController;
    const requestId = paymentDirectoryRequestIdRef.current + 1;
    paymentDirectoryRequestIdRef.current = requestId;
    const requestContext: PaymentDirectoryRequestContext = {
      requestId,
      query: normalizedQuery,
      cursor: normalizedCursor,
      requestType,
    };
    paymentDirectoryLatestRequestRef.current = requestContext;
    setPaymentDirectoryLoading(true);
    setPaymentDirectoryError("");
    setPaymentDirectoryWarning("");
    try {
      const result = await callPaymentRequestsApi(
        "listDirectory",
        buildPaymentDirectoryListRequestPayload({
          vendorQuery: normalizedQuery,
          cursor: normalizedCursor,
          requestType,
        }),
        { signal: abortController.signal }
      );
      const latestRequest = paymentDirectoryLatestRequestRef.current;
      if (
        !shouldApplyPaymentDirectoryResponse({
          requestId,
          latestRequestId: latestRequest.requestId,
          requestQuery: normalizedQuery,
          latestRequestQuery: latestRequest.query,
          currentInputQuery: paymentVendorSearchRef.current,
          requestCursor: normalizedCursor,
          latestRequestCursor: latestRequest.cursor,
          requestType,
          latestRequestType: latestRequest.requestType,
          currentRequestType: paymentDirectoryCurrentTypeRef.current,
        })
      ) {
        return [];
      }
      applyPaymentDirectoryResult(result, {
        append,
        query: normalizedQuery,
      });
      setPaymentDirectoryLoaded(true);
      return Array.isArray(result.vendors) ? result.vendors : [];
    } catch (error) {
      if (
        abortController.signal.aborted ||
        error?.name === "AbortError" ||
        requestId !== paymentDirectoryRequestIdRef.current
      ) {
        return [];
      }
      const message = getPaymentDirectoryErrorMessage(error);
      setPaymentDirectoryError(message);
      setToastMessage(message);
      return [];
    } finally {
      if (
        requestId === paymentDirectoryRequestIdRef.current &&
        paymentDirectoryAbortControllerRef.current === abortController
      ) {
        paymentDirectoryAbortControllerRef.current = null;
        setPaymentDirectoryLoading(false);
      }
    }
  };

  useEffect(() => {
    const previousType = paymentDirectoryRequestTypeRef.current;
    paymentDirectoryRequestTypeRef.current = paymentRequestForm.requestType;
    if (previousType === paymentRequestForm.requestType) return;
    if (paymentVendorSearchTimerRef.current !== null) {
      window.clearTimeout(paymentVendorSearchTimerRef.current);
      paymentVendorSearchTimerRef.current = null;
    }
    invalidatePaymentDirectoryRequest();
    resetPaymentDirectoryForSearchInput();
    if (
      !isHeadquarters() &&
      !["PAYMENT", "SALES_PAYMENT"].includes(adminAccessMode)
    ) return;
    const clearInactiveVendor =
      paymentRequestForm.requestType !== "BUYLINK" && selectedPaymentVendor?.status === "INACTIVE";
    if (clearInactiveVendor) {
      setPaymentRequestForm((previous) => ({
        ...previous, vendorId: "", customerName: "", buyerPhone: "", buyerEmail: "",
      }));
      paymentVendorSearchRef.current = "";
      setPaymentVendorSearch("");
      setSelectedAutopayMethodId("");
    }
    setPaymentVendorLookupOpen(false);
    void loadPaymentDirectory({
      vendorQuery: clearInactiveVendor ? "" : paymentVendorSearch,
      requestType: paymentRequestForm.requestType,
    });
  }, [paymentRequestForm.requestType]);

  useEffect(() => {
    if (paymentVendorSearchTimerRef.current !== null) {
      window.clearTimeout(paymentVendorSearchTimerRef.current);
      paymentVendorSearchTimerRef.current = null;
    }
    const query = paymentVendorSearch.trim();
    const selectedLabel = selectedPaymentVendor
      ? buildPaymentVendorLookupLabel(selectedPaymentVendor)
      : "";
    if (
      activePaymentQueueItem ||
      !shouldSchedulePaymentVendorCanonicalSearch(
        query,
        paymentVendorSearchComposing
      ) ||
      (paymentRequestForm.vendorId && query === selectedLabel) ||
      paymentDirectoryPagination.query === query
    ) {
      return undefined;
    }
    paymentVendorSearchTimerRef.current = window.setTimeout(() => {
      paymentVendorSearchTimerRef.current = null;
      setPaymentVendorLookupOpen(true);
      setPaymentVendorActiveIndex(0);
      void loadPaymentDirectory({
        bypassAccess: true,
        vendorQuery: query,
        cursor: "",
        append: false,
      });
    }, 250);
    return () => {
      if (paymentVendorSearchTimerRef.current !== null) {
        window.clearTimeout(paymentVendorSearchTimerRef.current);
        paymentVendorSearchTimerRef.current = null;
      }
    };
  }, [
    activePaymentQueueItemId,
    adminAccessMode,
    paymentDirectoryPagination.query,
    paymentRequestForm.vendorId,
    paymentRequestForm.requestType,
    paymentVendorSearch,
    paymentVendorSearchComposing,
  ]);

  useEffect(
    () => () => {
      paymentDirectoryAbortControllerRef.current?.abort();
      paymentDirectoryAbortControllerRef.current = null;
    },
    []
  );

  const loadPaymentRequests = async ({
    bypassAccess = false,
    dateFrom = paymentHistoryFilters.dateFrom,
    dateTo = paymentHistoryFilters.dateTo,
  } = {}) => {
    if (
      !bypassAccess &&
      !isHeadquarters() &&
      !["PAYMENT", "SALES_PAYMENT"].includes(adminAccessMode)
    ) {
      setPaymentRequestsError("결제관리 권한이 필요합니다.");
      return [];
    }
    const requestId = paymentRequestsLoadRequestIdRef.current + 1;
    paymentRequestsLoadRequestIdRef.current = requestId;
    setPaymentRequestsLoading(true);
    setPaymentRequestsError("");
    try {
      const result = await callPaymentRequestsApi("list", {
        limit: 5000,
        dateFrom,
        dateTo,
      });
      const items = Array.isArray(result.items) ? result.items : [];
      if (requestId !== paymentRequestsLoadRequestIdRef.current) return items;
      setPaymentRequests(items);
      setPaymentRequestsMeta({
        loaded: true,
        truncated: result.truncated === true,
        total: Number(result.total) || items.length,
        dateFrom,
        dateTo,
      });
      if (result.linkPayment && typeof result.linkPayment === "object") {
        setPaymentLinkConfig(result.linkPayment);
      }
      if (result.standardPayment && typeof result.standardPayment === "object") {
        setStandardPaymentConfig(result.standardPayment);
      }
      if (result.keyinPayment && typeof result.keyinPayment === "object") {
        setKeyinPaymentConfig(result.keyinPayment);
      }
      return items;
    } catch (error) {
      if (requestId !== paymentRequestsLoadRequestIdRef.current) return [];
      const message = error?.message || "결제 요청을 불러오지 못했습니다.";
      dashboardPaymentLoadKeyRef.current = "";
      setPaymentRequests([]);
      setPaymentRequestsMeta({
        loaded: true,
        truncated: false,
        total: 0,
        dateFrom,
        dateTo,
      });
      setPaymentRequestsError(message);
      setToastMessage(message);
      return [];
    } finally {
      if (requestId === paymentRequestsLoadRequestIdRef.current) {
        setPaymentRequestsLoading(false);
      }
    }
  };

  const handleCreatePaymentRequestDraft = async () => {
    if (paymentRequestSaving) return;
    setPaymentRequestSaving(true);
    setPaymentRequestsError("");
    try {
      if (paymentRequestForm.requestType === "AUTOPAY") {
        if (autopayAction === "REGISTER") {
          const result = await callPaymentRequestsApi(
            "createAutopayRegistration",
            {
              profileId: paymentRequestForm.autopayProfileId,
              identityType: paymentRequestForm.identityType,
              amount: paymentRequestForm.amount,
              itemName: paymentRequestForm.itemName,
              customerName: paymentRequestForm.customerName,
              vendorId: paymentRequestForm.vendorId,
            }
          );
          if (result.registration) {
            setAutopayRegistrations((prev) => [
              result.registration,
              ...prev.filter(
                (item) =>
                  item.registrationId !== result.registration.registrationId
              ),
            ]);
          }
          if (result.config) setAutopayConfig(result.config);
          setPaymentRequestForm((prev) => ({
            ...createEmptyPaymentRequestForm(),
            requestType: "AUTOPAY",
            autopayProfileId: prev.autopayProfileId || "CNFOOD_AUTOPAY",
            identityType: prev.identityType || "BUSINESS",
          }));
          invalidatePaymentDirectoryRequest();
          paymentVendorSearchRef.current = "";
          resetPaymentDirectoryForSearchInput();
          setPaymentVendorSearch("");
          setToastMessage(
            result.message || "등록카드 신청 링크를 만들었습니다."
          );
          return;
        }

        const chargeFingerprint = JSON.stringify([
          selectedAutopayMethodId,
          String(paymentRequestForm.amount || ""),
          paymentRequestForm.itemName.trim(),
          paymentRequestForm.customerName.trim(),
          paymentRequestForm.vendorId,
          paymentRequestForm.memo.trim(),
        ]);
        const idempotencyKey =
          autopayChargeAttempt.fingerprint === chargeFingerprint &&
          autopayChargeAttempt.key
            ? autopayChargeAttempt.key
            : typeof window !== "undefined" && window.crypto?.randomUUID
            ? window.crypto.randomUUID().replace(/-/g, "")
            : `${Date.now()}_${Math.random()
                .toString(36)
                .slice(2)}_${Math.random().toString(36).slice(2)}`;
        if (autopayChargeAttempt.key !== idempotencyKey) {
          setAutopayChargeAttempt({
            fingerprint: chargeFingerprint,
            key: idempotencyKey,
          });
        }
        const result = await callPaymentRequestsApi("chargeAutopay", {
          billingMethodId: selectedAutopayMethodId,
          vendorId: paymentRequestForm.vendorId,
          amount: paymentRequestForm.amount,
          itemName: paymentRequestForm.itemName,
          customerName: paymentRequestForm.customerName,
          reason: paymentRequestForm.memo,
          confirmation: autopayConfirmation,
          idempotencyKey,
          mediaType: /Android|iPhone|iPad|iPod|Mobile/i.test(
            typeof navigator !== "undefined" ? navigator.userAgent : ""
          )
            ? "MC02"
            : "MC01",
        });
        if (result.request) {
          setPaymentRequests((prev) => [
            result.request,
            ...prev.filter(
              (item) =>
                item.paymentRequestId !== result.request.paymentRequestId
            ),
          ]);
        }
        if (result.method) {
          setAutopayMethods((prev) =>
            prev.map((method) =>
              method.billingMethodId === result.method.billingMethodId
                ? result.method
                : method
            )
          );
          if (!isAutopayMethodReadyForCharge(result.method)) {
            setSelectedAutopayMethodId("");
          }
        }
        setPaymentRequestForm((prev) => ({
          ...createEmptyPaymentRequestForm(),
          requestType: "AUTOPAY",
          autopayProfileId: prev.autopayProfileId || "CNFOOD_AUTOPAY",
          identityType: prev.identityType || "BUSINESS",
        }));
        invalidatePaymentDirectoryRequest();
        paymentVendorSearchRef.current = "";
        resetPaymentDirectoryForSearchInput();
        setPaymentVendorSearch("");
        setAutopayConfirmation("");
        setAutopayChargeAttempt({ fingerprint: "", key: "" });
        setToastMessage(result.message || "등록카드 결제를 처리했습니다.");
        return;
      }

      const isQueuePreflight =
        paymentRequestForm.requestType === "KEYIN" && Boolean(activePaymentQueueItem);
      const isDirectKeyinExecution =
        paymentRequestForm.requestType === "KEYIN" &&
        !isQueuePreflight &&
        selectedKeyinProfileStatus?.executionEnabled;
      const keyinFingerprint = isDirectKeyinExecution
        ? JSON.stringify([
            paymentRequestForm.vendorId,
            paymentRequestForm.keyinProfileId,
            String(paymentRequestForm.amount || ""),
            paymentRequestForm.itemName.trim(),
            sensitiveCardInput.cardNumber.replace(/\D/g, "").slice(-4),
          ])
        : "";
      const keyinIdempotencyKey = isDirectKeyinExecution
        ? keyinExecutionAttempt.fingerprint === keyinFingerprint &&
          keyinExecutionAttempt.key
          ? keyinExecutionAttempt.key
          : typeof window !== "undefined" && window.crypto?.randomUUID
          ? window.crypto.randomUUID().replace(/-/g, "")
          : `${Date.now()}_${Math.random()
              .toString(36)
              .slice(2)}_${Math.random().toString(36).slice(2)}`
        : "";
      if (
        isDirectKeyinExecution &&
        keyinExecutionAttempt.key !== keyinIdempotencyKey
      ) {
        setKeyinExecutionAttempt({
          fingerprint: keyinFingerprint,
          key: keyinIdempotencyKey,
        });
      }
      const paymentMode =
        paymentRequestForm.requestType === "STANDARD"
          ? selectedPaymentLinkProfileStatus?.executionEnabled
            ? "createStandard"
            : "createDraft"
          : paymentRequestForm.requestType === "BUYLINK"
          ? selectedPaymentLinkProfileStatus?.executionEnabled
            ? "createLink"
            : "createDraft"
          : isQueuePreflight
          ? "preflightQueueItem"
          : isDirectKeyinExecution
          ? "executeKeyin"
          : "createDraft";
      const result = await callPaymentRequestsApi(
        paymentMode,
        {
        ...(isQueuePreflight
          ? { paymentRequestId: activePaymentQueueItem.paymentRequestId }
          : {}),
        requestType: paymentRequestForm.requestType,
        vendorId: paymentRequestForm.vendorId,
        paymentProfileId:
          paymentRequestForm.requestType === "KEYIN"
            ? paymentRequestForm.keyinProfileId
            : paymentRequestForm.paymentProfileId,
        amount: paymentRequestForm.amount,
        itemName: paymentRequestForm.itemName,
        customerName: paymentRequestForm.customerName,
        memo: paymentRequestForm.memo,
        ...(paymentRequestForm.requestType === "BUYLINK"
          ? {
              buyerPhone: paymentRequestForm.buyerPhone,
              buyerEmail: paymentRequestForm.buyerEmail,
            }
          : {}),
        ...(paymentRequestForm.requestType === "KEYIN"
          ? {
              cardNumber: sensitiveCardInput.cardNumber.replace(/\D/g, ""),
              cardExpiry: sensitiveCardInput.cardExpiry,
              cardTaxNo: sensitiveCardInput.cardTaxNo.replace(/\D/g, ""),
              cardPassword: sensitiveCardInput.cardPassword.replace(/\D/g, ""),
              quota: paymentRequestForm.quota,
              ...(isDirectKeyinExecution
                ? {
                    confirmation: paymentRequestForm.keyinConfirmation,
                    idempotencyKey: keyinIdempotencyKey,
                  }
                : {}),
            }
          : {}),
        }
      );
      if (result.request) {
        setPaymentRequests((prev) => [
          result.request,
          ...prev.filter(
            (item) => item.paymentRequestId !== result.request.paymentRequestId
          ),
        ]);
      }
      if (result.linkPayment && typeof result.linkPayment === "object") {
        setPaymentLinkConfig(result.linkPayment);
      }
      if (result.standardPayment && typeof result.standardPayment === "object") {
        setStandardPaymentConfig(result.standardPayment);
      }
      if (result.keyinPayment && typeof result.keyinPayment === "object") {
        setKeyinPaymentConfig(result.keyinPayment);
      }
      if (
        isSalesPaymentMode &&
        result.request?.requestType === "BUYLINK" &&
        result.request?.paymentUrl
      ) {
        setPaymentCopyPreview(buildPaymentCopyPreview(result.request, "MESSAGE"));
      }
      if (isQueuePreflight && result.request) {
        const nextQueueItem = paymentRequests
          .map((request) =>
            request.paymentRequestId === result.request.paymentRequestId
              ? result.request
              : request
          )
          .filter(
            (request) =>
              request.batchId === activePaymentQueueItem.batchId &&
              request.status === "QUEUED" &&
              Number(request.batchSequence) > Number(activePaymentQueueItem.batchSequence)
          )
          .sort((a, b) => Number(a.batchSequence) - Number(b.batchSequence))[0];
        if (nextQueueItem) {
          preparePaymentQueueItem(nextQueueItem);
          setToastMessage(
            `${activePaymentQueueItem.batchSequence}번 검증 완료. ${nextQueueItem.batchSequence}번을 준비했습니다.`
          );
        } else {
          clearActivePaymentQueueItem();
          setToastMessage("현재 배치의 카드 입력 검증을 마쳤습니다. 실제 승인은 실행하지 않았습니다.");
        }
        return;
      }
      setPaymentRequestForm((prev) => ({
        ...createEmptyPaymentRequestForm(),
        requestType: prev.requestType,
        paymentProfileId: prev.paymentProfileId || "CNFOOD_LINK",
      }));
      invalidatePaymentDirectoryRequest();
      paymentVendorSearchRef.current = "";
      resetPaymentDirectoryForSearchInput();
      setPaymentVendorSearch("");
      if (isDirectKeyinExecution) {
        setKeyinExecutionAttempt({ fingerprint: "", key: "" });
      }
      setToastMessage(result.message || "결제 요청 초안을 만들었습니다.");
    } catch (error) {
      const fieldErrors = error?.fieldErrors || {};
      const message =
        fieldErrors.cardNumber ||
        fieldErrors.cardExpiry ||
        fieldErrors.cardTaxNo ||
        fieldErrors.cardPassword ||
        fieldErrors.buyerPhone ||
        fieldErrors.buyerEmail ||
        fieldErrors.vendorId ||
        fieldErrors.paymentProfileId ||
        fieldErrors.amount ||
        fieldErrors.itemName ||
        error?.message ||
        "결제 요청 초안을 만들지 못했습니다.";
      setPaymentRequestsError(message);
      setToastMessage(message);
    } finally {
      clearSensitivePaymentCardInput();
      setPaymentRequestSaving(false);
    }
  };

  const handleVerifyAutopayMethod = async () => {
    if (autopayVerifySaving || !autopayVerifyMethodId) return;
    setAutopayVerifySaving(true);
    setPaymentRequestsError("");
    try {
      const result = await callPaymentRequestsApi("verifyAutopayMethod", {
        billingMethodId: autopayVerifyMethodId,
        cardLabel: autopayVerifyForm.cardLabel,
        cardLast4: autopayVerifyForm.cardLast4,
        reason: autopayVerifyForm.reason,
        confirmation: autopayVerifyForm.confirmation,
      });
      if (result.method) {
        setAutopayMethods((prev) =>
          prev.map((method) =>
            method.billingMethodId === result.method.billingMethodId
              ? result.method
              : method
          )
        );
      }
      setAutopayVerifyMethodId("");
      setAutopayVerifyForm({
        cardLabel: "",
        cardLast4: "",
        reason: "",
        confirmation: "",
      });
      setToastMessage(result.message || "등록카드 확인을 기록했습니다.");
    } catch (error) {
      const message = error?.message || "등록카드를 확인하지 못했습니다.";
      setPaymentRequestsError(message);
      setToastMessage(message);
    } finally {
      setAutopayVerifySaving(false);
    }
  };

  const handleDeleteAutopayMethod = async () => {
    if (autopayDeleteSaving || !autopayDeleteMethodId) return;
    setAutopayDeleteSaving(true);
    setPaymentRequestsError("");
    try {
      const result = await callPaymentRequestsApi("deleteAutopayMethod", {
        billingMethodId: autopayDeleteMethodId,
        reason: autopayDeleteReason,
        confirmation: autopayDeleteConfirmation,
      });
      if (result.method) {
        setAutopayMethods((prev) =>
          prev.map((method) =>
            method.billingMethodId === result.method.billingMethodId
              ? result.method
              : method
          )
        );
        if (selectedAutopayMethodId === result.method.billingMethodId) {
          setSelectedAutopayMethodId("");
        }
      }
      setAutopayDeleteMethodId("");
      setAutopayDeleteReason("");
      setAutopayDeleteConfirmation("");
      setToastMessage(result.message || "등록카드를 삭제했습니다.");
    } catch (error) {
      const message = error?.message || "등록카드를 삭제하지 못했습니다.";
      setPaymentRequestsError(message);
      setToastMessage(message);
    } finally {
      setAutopayDeleteSaving(false);
    }
  };

  const handleSetPrimaryAutopayMethod = async (method) => {
    const billingMethodId = method?.billingMethodId || "";
    if (!billingMethodId || autopayPrimarySavingId) return;
    setAutopayPrimarySavingId(billingMethodId);
    setPaymentRequestsError("");
    try {
      const result = await callPaymentRequestsApi("setPrimaryAutopayMethod", {
        billingMethodId,
        confirmation: "메인 카드 지정",
      });
      if (Array.isArray(result.methods)) {
        const updates = new Map(
          result.methods.map((item) => [item.billingMethodId, item])
        );
        setAutopayMethods((prev) =>
          prev.map((item) => updates.get(item.billingMethodId) || item)
        );
      }
      setSelectedAutopayMethodId(billingMethodId);
      setToastMessage(result.message || "거래처 메인 카드를 지정했습니다.");
    } catch (error) {
      const message = error?.message || "메인 카드를 지정하지 못했습니다.";
      setPaymentRequestsError(message);
      setToastMessage(message);
    } finally {
      setAutopayPrimarySavingId("");
    }
  };

  const updatePaymentRequestInList = (request) => {
    if (!request?.paymentRequestId) return;
    setPaymentRequests((prev) => [
      request,
      ...prev.filter(
        (item) => item.paymentRequestId !== request.paymentRequestId
      ),
    ]);
  };

  const handleSavePaymentDepositManagement = async (
    paymentRequestId,
    values
  ) => {
    if (!paymentRequestId || paymentDepositSavingId) return null;
    setPaymentDepositSavingId(paymentRequestId);
    setPaymentRequestsError("");
    try {
      const result = await callPaymentRequestsApi("updateDepositManagement", {
        paymentRequestId,
        erpRegistered: values.erpRegistered === true,
        note: values.note,
      });
      updatePaymentRequestInList(result.request);
      setToastMessage(result.message || "입금관리 정보를 저장했습니다.");
      return result.request;
    } catch (error) {
      const message =
        error?.message || "입금관리 정보를 저장하지 못했습니다.";
      setPaymentRequestsError(message);
      setToastMessage(message);
      throw error;
    } finally {
      setPaymentDepositSavingId("");
    }
  };

  const handleExcludePaymentFromErp = async (
    paymentRequestId,
    { reclassifyLegacy = false } = {}
  ) => {
    if (!paymentRequestId || paymentDepositSavingId) return null;
    setPaymentDepositSavingId(paymentRequestId);
    setPaymentRequestsError("");
    try {
      const result = await callPaymentRequestsApi(
        reclassifyLegacy
          ? "reclassifyLegacyPaymentAsTest"
          : "excludePaymentFromErp",
        { paymentRequestId }
      );
      updatePaymentRequestInList(result.request);
      setToastMessage(
        result.message || "선택한 결제를 테스트/ERP 제외로 기록했습니다."
      );
      return result.request;
    } catch (error) {
      const message =
        error?.message || "테스트/ERP 제외를 완료하지 못했습니다.";
      setPaymentRequestsError(message);
      setToastMessage(message);
      throw error;
    } finally {
      setPaymentDepositSavingId("");
    }
  };

  const selectPaymentVendorForRequest = (vendor) => {
    if (!vendor?.vendorId) return;
    const lookupLabel = buildPaymentVendorLookupLabel(vendor);
    if (paymentVendorSearchTimerRef.current !== null) {
      window.clearTimeout(paymentVendorSearchTimerRef.current);
      paymentVendorSearchTimerRef.current = null;
    }
    invalidatePaymentDirectoryRequest();
    paymentVendorSearchRef.current = lookupLabel;
    setPaymentVendorSearchComposing(false);
    setPaymentRequestForm((prev) =>
      applyPaymentVendorToRequestForm(prev, vendor)
    );
    setPaymentVendorSearch(lookupLabel);
    const vendorMethods = autopayMethods
      .filter(
        (method) =>
          String(method.vendorId || "") === String(vendor.vendorId) &&
          isAutopayMethodReadyForCharge(method)
      )
      .sort((a, b) => {
        if (a.isPrimary !== b.isPrimary) return a.isPrimary ? -1 : 1;
        return String(b.createdAt || "").localeCompare(String(a.createdAt || ""));
      });
    setSelectedAutopayMethodId(vendorMethods[0]?.billingMethodId || "");
    setPaymentVendorLookupOpen(false);
    setPaymentVendorActiveIndex(0);
  };

  const openVendorAutopayRegistration = (vendor) => {
    const directoryVendor = paymentVendorOptions.find(
      (item) => item.vendorId === (vendor?.vendorId || vendor?.id)
    );
    if (!directoryVendor) {
      setToastMessage("결제 거래처 정보를 다시 불러온 후 시도해 주세요.");
      void loadPaymentDirectory();
      return;
    }
    setPaymentRequestForm({
      ...createEmptyPaymentRequestForm(),
      requestType: "AUTOPAY",
      vendorId: directoryVendor.vendorId,
      customerName: directoryVendor.businessName || "",
      autopayProfileId: directoryVendor.autopayProfileId || "CNFOOD_AUTOPAY",
    });
    const lookupLabel = buildPaymentVendorLookupLabel(directoryVendor);
    invalidatePaymentDirectoryRequest();
    paymentVendorSearchRef.current = lookupLabel;
    setPaymentVendorSearchComposing(false);
    setPaymentVendorSearch(lookupLabel);
    setPaymentVendorLookupOpen(false);
    setAutopayAction("REGISTER");
    clearSensitivePaymentCardInput();
    setAdminTab("PAYMENT_MANAGEMENT");
  };

  const openVendorAutopayManagement = (vendor) => {
    const directoryVendor = paymentVendorOptions.find(
      (item) => item.vendorId === (vendor?.vendorId || vendor?.id)
    );
    if (directoryVendor) {
      selectPaymentVendorForRequest(directoryVendor);
    }
    setPaymentRequestForm((prev) => ({ ...prev, requestType: "AUTOPAY" }));
    setAutopayAction("CHARGE");
    setAdminTab("PAYMENT_MANAGEMENT");
  };

  const handleInquirePaymentRequest = async (request) => {
    const paymentRequestId = request?.paymentRequestId || request?.id || "";
    if (!paymentRequestId || paymentOperationSavingId) return;
    setPaymentOperationSavingId(`inquiry:${paymentRequestId}`);
    setPaymentOperationErrors((prev) => ({ ...prev, [paymentRequestId]: "" }));
    try {
      const result = await callPaymentRequestsApi("inquirePayment", {
        paymentRequestId,
      });
      updatePaymentRequestInList(result.request);
      setToastMessage(result.message || "KCP 거래 상태를 조회했습니다.");
    } catch (error) {
      const message = error?.message || "KCP 거래 상태를 조회하지 못했습니다.";
      setPaymentOperationErrors((prev) => ({
        ...prev,
        [paymentRequestId]: message,
      }));
      setToastMessage(message);
    } finally {
      setPaymentOperationSavingId("");
    }
  };

  const handleReconcileBuylinkPayment = async (request) => {
    const paymentRequestId = request?.paymentRequestId || request?.id || "";
    if (!paymentRequestId || paymentOperationSavingId) return;
    setPaymentOperationSavingId(`reconcile:${paymentRequestId}`);
    setPaymentOperationErrors((prev) => ({ ...prev, [paymentRequestId]: "" }));
    setPaymentOperationNotices((prev) => ({ ...prev, [paymentRequestId]: "" }));
    try {
      const result = await callPaymentRequestsApi("reconcileBuylinkPayment", {
        paymentRequestId,
      });
      updatePaymentRequestInList(result.request);
      const message =
        result.message || "KCP 승인결과를 반영했습니다.";
      if (result.reconciliation?.pending === true) {
        setPaymentOperationNotices((prev) => ({
          ...prev,
          [paymentRequestId]: message,
        }));
      }
      setToastMessage(message);
    } catch (error) {
      const message =
        error?.message || "KCP BUYLINK 승인결과를 확인하지 못했습니다.";
      setPaymentOperationErrors((prev) => ({
        ...prev,
        [paymentRequestId]: message,
      }));
      setToastMessage(message);
    } finally {
      setPaymentOperationSavingId("");
    }
  };

  const openPaymentCopyPreview = (request, kind) => {
    const preview = buildPaymentCopyPreview(request, kind);
    if (!preview.text) {
      setToastMessage("복사할 내용을 확인할 수 없습니다.");
      return;
    }
    setPaymentCopyPreview(preview);
  };

  const openPaymentOperatorStatusPreview = (request) => {
    setPaymentCopyPreview({
      kind: "STATUS",
      title: "담당자 전달용 결제 상태",
      text: buildPaymentOperatorStatusMessage(request),
    });
  };

  const openPaymentOperationsSummaryPreview = () => {
    setPaymentCopyPreview({
      kind: "SUMMARY",
      title: "담당자 전달용 결제 운영 현황",
      text: buildPaymentOperationsSummaryMessage(
        filteredPaymentRequests,
        paymentHistoryFilters
      ),
    });
  };

  const openPaymentCancellation = (request, cancellationType = "FULL") => {
    const paymentRequestId = request?.paymentRequestId || request?.id || "";
    if (!paymentRequestId) return;
    setPaymentOperationTargetId(paymentRequestId);
    setPaymentCancellationForm({
      cancellationType: cancellationType === "PARTIAL" ? "PARTIAL" : "FULL",
      amount: "",
      taxAmount: "",
      vatAmount: "",
      freeAmount: "",
      reason: "",
      confirmation: "",
    });
    setPaymentCancellationAttempt({ fingerprint: "", key: "" });
    setPaymentOperationErrors((prev) => ({ ...prev, [paymentRequestId]: "" }));
  };

  const closePaymentCancellation = () => {
    if (paymentOperationSavingId) return;
    setPaymentOperationTargetId("");
    setPaymentCancellationForm({
      cancellationType: "FULL",
      amount: "",
      taxAmount: "",
      vatAmount: "",
      freeAmount: "",
      reason: "",
      confirmation: "",
    });
    setPaymentCancellationAttempt({ fingerprint: "", key: "" });
  };

  const handleCancelPaymentRequest = async (request) => {
    const paymentRequestId = request?.paymentRequestId || request?.id || "";
    if (!paymentRequestId || paymentOperationSavingId) return;
    const fingerprint = JSON.stringify([
      paymentRequestId,
      paymentCancellationForm.cancellationType,
      String(paymentCancellationForm.amount || ""),
      String(paymentCancellationForm.taxAmount || ""),
      String(paymentCancellationForm.vatAmount || ""),
      String(paymentCancellationForm.freeAmount || ""),
      paymentCancellationForm.reason.trim(),
    ]);
    const idempotencyKey =
      paymentCancellationAttempt.fingerprint === fingerprint &&
      paymentCancellationAttempt.key
        ? paymentCancellationAttempt.key
        : typeof window !== "undefined" && window.crypto?.randomUUID
        ? window.crypto.randomUUID().replace(/-/g, "")
        : `${Date.now()}_${Math.random()
            .toString(36)
            .slice(2)}_${Math.random().toString(36).slice(2)}`;
    if (paymentCancellationAttempt.key !== idempotencyKey) {
      setPaymentCancellationAttempt({ fingerprint, key: idempotencyKey });
    }
    setPaymentOperationSavingId(`cancel:${paymentRequestId}`);
    setPaymentOperationErrors((prev) => ({ ...prev, [paymentRequestId]: "" }));
    try {
      const result = await callPaymentRequestsApi("cancelPayment", {
        paymentRequestId,
        cancellationType: paymentCancellationForm.cancellationType,
        amount: paymentCancellationForm.amount,
        taxAmount: paymentCancellationForm.taxAmount,
        vatAmount: paymentCancellationForm.vatAmount,
        freeAmount: paymentCancellationForm.freeAmount,
        reason: paymentCancellationForm.reason,
        confirmation: paymentCancellationForm.confirmation,
        idempotencyKey,
      });
      updatePaymentRequestInList(result.request);
      setPaymentOperationTargetId("");
      setPaymentCancellationForm({
        cancellationType: "FULL",
        amount: "",
        taxAmount: "",
        vatAmount: "",
        freeAmount: "",
        reason: "",
        confirmation: "",
      });
      setPaymentCancellationAttempt({ fingerprint: "", key: "" });
      setToastMessage(result.message || "KCP 취소를 처리했습니다.");
    } catch (error) {
      const message = error?.message || "KCP 취소를 처리하지 못했습니다.";
      setPaymentOperationErrors((prev) => ({
        ...prev,
        [paymentRequestId]: message,
      }));
      setToastMessage(message);
    } finally {
      setPaymentOperationSavingId("");
    }
  };

  const loadCompanyBranches = async () => {
    if (!isHeadquarters()) {
      setCompanyBranchesError("본사 관리자만 우리회사 사업장을 조회할 수 있습니다.");
      return [];
    }
    setCompanyBranchesLoading(true);
    setCompanyBranchesError("");
    try {
      const result = await callCompanyBranchesApi("list", { limit: 200 });
      const items = Array.isArray(result.items) ? result.items : [];
      setCompanyBranches(items);
      return items;
    } catch (error) {
      console.error("[CNFOOD] company branches load failed", sanitizeErrorForLog(error));
      const message = error?.message || "우리회사 사업장을 불러오지 못했습니다.";
      setCompanyBranchesError(message);
      setToastMessage(message);
      return [];
    } finally {
      setCompanyBranchesLoading(false);
    }
  };

  const loadVendorMasters = async ({
    cursor = "",
    cursorStack = [],
  } = {}) => {
    if (!isHeadquarters()) {
      setVendorMastersError("본사 관리자만 거래처 마스터를 조회할 수 있습니다.");
      return;
    }
    setVendorMastersLoading(true);
    setVendorMastersError("");
    setVendorMastersWarning("");
    try {
      if (companyBranches.length === 0) {
        await loadCompanyBranches();
      }
      const result = await callVendorMasterApi("list", {
        pageSize: 100,
        cursor,
        keyword: vendorMasterFilters.keyword,
        businessNumber: vendorMasterFilters.businessNumber,
        status: vendorMasterFilters.status,
        companyBranchId: vendorMasterFilters.companyBranchId,
      });
      setVendorMasters(Array.isArray(result.items) ? result.items : []);
      setVendorMasterPagination({
        cursor,
        nextCursor: result.nextCursor || "",
        cursorStack,
        returnedCount: Number(result.returnedCount || 0),
        totalCount: Number(result.totalCount || 0),
        collectionTotalCount: Number(result.collectionTotalCount || 0),
        pageSize: Number(result.pageSize || 100),
        hasMore: result.hasMore === true,
      });
      if (result?.truncated === true) {
        setVendorMastersWarning(
          "거래처 전체 페이지를 확인하지 못했습니다. 관리자에게 조회 상태를 확인해 주세요."
        );
      }
      if (legacyContracts.length === 0) {
        void loadLegacyContracts();
      }
    } catch (error) {
      console.error("[CNFOOD] vendor masters load failed", sanitizeErrorForLog(error));
      const message = getVendorMasterApiErrorMessage(
        error,
        "거래처 마스터를 불러오지 못했습니다."
      );
      setVendorMastersError(message);
      setToastMessage(message);
    } finally {
      setVendorMastersLoading(false);
    }
  };

  const loadNextVendorMasterPage = () => {
    if (!vendorMasterPagination.hasMore || !vendorMasterPagination.nextCursor) return;
    void loadVendorMasters({
      cursor: vendorMasterPagination.nextCursor,
      cursorStack: [
        ...vendorMasterPagination.cursorStack,
        vendorMasterPagination.cursor,
      ],
    });
  };

  const loadPreviousVendorMasterPage = () => {
    if (vendorMasterPagination.cursorStack.length === 0) return;
    const nextStack = vendorMasterPagination.cursorStack.slice(0, -1);
    void loadVendorMasters({
      cursor:
        vendorMasterPagination.cursorStack[
          vendorMasterPagination.cursorStack.length - 1
        ] || "",
      cursorStack: nextStack,
    });
  };

  const loadVendorReview = async () => {
    if (!isHeadquarters() || vendorReviewLoading) return;
    setVendorReviewLoading(true);
    setVendorReviewError("");
    try {
      const result = await callVendorMasterApi("review");
      setVendorReviewData(result);
    } catch (error) {
      const message = getVendorMasterApiErrorMessage(
        error,
        "미등록 거래처 검토자료를 불러오지 못했습니다."
      );
      setVendorReviewError(message);
      setToastMessage(message);
    } finally {
      setVendorReviewLoading(false);
    }
  };

  const callDbBackupApi = async (backupMode, payload = {}) => {
    const response = await fetch("/api/db-backup", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        mode: "db-backup",
        backupMode,
        appId,
        password: adminSessionPasswordRef.current || adminPassword,
        createdBy: currentManager?.name || "관리자",
        restoredBy: currentManager?.name || "관리자",
        ...payload,
      }),
    });
    const result = await response.json().catch(() => ({
      ok: false,
      message: "DB 백업/복원 요청을 처리하지 못했습니다.",
    }));
    if (!response.ok || !result?.ok) {
      const error = new Error(result?.message || "DB_BACKUP_API_FAILED");
      error.code = result?.code;
      throw error;
    }
    return result;
  };

  const loadDbBackups = async () => {
    if (!isHeadquarters()) {
      setDbBackupError("본사 관리자만 DB 백업/복원을 사용할 수 있습니다.");
      return;
    }
    setDbBackupLoading(true);
    setDbBackupError("");
    try {
      const result = await callDbBackupApi("list", { limit: 30 });
      const items = Array.isArray(result.items) ? result.items : [];
      setDbBackups(items);
      if (!dbRestoreSelectedBackupId && items[0]?.backupId) {
        setDbRestoreSelectedBackupId(items[0].backupId);
      }
    } catch (error) {
      console.error("[CNFOOD] DB backup list failed", sanitizeErrorForLog(error));
      const message = error?.message || "DB 백업 목록을 불러오지 못했습니다.";
      setDbBackupError(message);
      setToastMessage(message);
    } finally {
      setDbBackupLoading(false);
    }
  };

  const toggleDbBackupDatasetKey = (
    key: string,
    selectedKeys: string[],
    setSelectedKeys: (keys: string[]) => void
  ) => {
    setSelectedKeys(
      selectedKeys.includes(key)
        ? selectedKeys.filter((item) => item !== key)
        : [...selectedKeys, key]
    );
  };

  const handleCreateDbBackup = async () => {
    if (!isHeadquarters()) {
      setToastMessage("본사 관리자만 DB 백업을 실행할 수 있습니다.");
      return;
    }
    if (!String(dbBackupSummary || "").trim()) {
      setDbBackupError("백업 요약 설명을 입력해 주세요.");
      setToastMessage("백업 요약 설명을 입력해 주세요.");
      return;
    }
    const datasetKeys =
      dbBackupScope === "FULL" ? DEFAULT_DB_BACKUP_DATASET_KEYS : dbBackupSelectedDatasetKeys;
    if (datasetKeys.length === 0) {
      setDbBackupError("부분 백업할 데이터 묶음을 선택해 주세요.");
      setToastMessage("부분 백업할 데이터 묶음을 선택해 주세요.");
      return;
    }
    setDbBackupCreating(true);
    setDbBackupError("");
    try {
      const result = await callDbBackupApi("create", {
        scope: dbBackupScope,
        datasetKeys,
        summary: dbBackupSummary,
        description: dbBackupDescription,
      });
      setToastMessage("DB 백업이 완료되었습니다.");
      setDbBackupSummary("");
      setDbBackupDescription("");
      setDbRestoreSelectedBackupId(result.backup?.backupId || "");
      await loadDbBackups();
    } catch (error) {
      console.error("[CNFOOD] DB backup create failed", sanitizeErrorForLog(error));
      const message =
        error?.code === "BACKUP_TOO_LARGE"
          ? "백업 대상이 너무 많습니다. 부분 백업으로 나누어 실행해 주세요."
          : error?.message || "DB 백업을 실행하지 못했습니다.";
      setDbBackupError(message);
      setToastMessage(message);
    } finally {
      setDbBackupCreating(false);
    }
  };

  const handlePreviewDbRestore = async () => {
    if (!dbRestoreSelectedBackupId) {
      setDbBackupError("복원할 백업을 선택해 주세요.");
      return;
    }
    const datasetKeys =
      dbRestoreScope === "FULL" ? DEFAULT_DB_BACKUP_DATASET_KEYS : dbRestoreSelectedDatasetKeys;
    if (datasetKeys.length === 0) {
      setDbBackupError("복원할 데이터 묶음을 선택해 주세요.");
      return;
    }
    setDbRestoreLoading(true);
    setDbBackupError("");
    try {
      const result = await callDbBackupApi("previewRestore", {
        backupId: dbRestoreSelectedBackupId,
        restoreScope: dbRestoreScope,
        datasetKeys,
      });
      setDbRestorePreview(result);
    } catch (error) {
      console.error("[CNFOOD] DB restore preview failed", sanitizeErrorForLog(error));
      const message = error?.message || "복원 미리보기를 생성하지 못했습니다.";
      setDbBackupError(message);
      setToastMessage(message);
    } finally {
      setDbRestoreLoading(false);
    }
  };

  const handleApplyDbRestore = async () => {
    if (!dbRestoreSelectedBackupId) {
      setDbBackupError("복원할 백업을 선택해 주세요.");
      return;
    }
    if (dbRestoreConfirmText.trim() !== "복원 실행") {
      setDbBackupError('복원하려면 확인 문구에 "복원 실행"을 입력해 주세요.');
      return;
    }
    if (!dbRestoreReason.trim()) {
      setDbBackupError("복원 사유를 입력해 주세요.");
      return;
    }
    const datasetKeys =
      dbRestoreScope === "FULL" ? DEFAULT_DB_BACKUP_DATASET_KEYS : dbRestoreSelectedDatasetKeys;
    setDbRestoreApplying(true);
    setDbBackupError("");
    try {
      const result = await callDbBackupApi("restore", {
        backupId: dbRestoreSelectedBackupId,
        restoreScope: dbRestoreScope,
        datasetKeys,
        confirmationText: dbRestoreConfirmText,
        reason: dbRestoreReason,
      });
      setToastMessage(`DB 복원이 완료되었습니다. ${result.restoredCount || 0}개 문서를 복원했습니다.`);
      setDbRestoreConfirmText("");
      setDbRestoreReason("");
      setDbRestorePreview(null);
      await loadDbBackups();
    } catch (error) {
      console.error("[CNFOOD] DB restore failed", sanitizeErrorForLog(error));
      const message = error?.message || "DB 복원을 실행하지 못했습니다.";
      setDbBackupError(message);
      setToastMessage(message);
    } finally {
      setDbRestoreApplying(false);
    }
  };

  const downloadVendorExcelTemplate = async () => {
    try {
      const response = await fetch("/api/vendor-master", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          mode: "vendor-master",
          vendorMode: "downloadTemplate",
          appId,
          password: adminSessionPasswordRef.current || adminPassword,
        }),
      });
      if (!response.ok) throw new Error("vendor template download failed");
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = "cnfood_vendor_master_template.xlsx";
      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("[CNFOOD] vendor template download failed", sanitizeErrorForLog(error));
      setToastMessage("거래처 엑셀 양식을 내려받지 못했습니다.");
    }
  };

  const previewVendorExcelRows = async (rows) => {
    setVendorMastersError("");
    try {
      if (companyBranches.length === 0) {
        await loadCompanyBranches();
      }
      const result = await callVendorMasterApi("importPreview", {
        rows,
        batchId: createStableId("vendor_batch"),
      });
      setVendorImportRows(rows);
      setVendorImportPreview(result);
      setVendorImportResult(null);
    } catch (error) {
      console.error("[CNFOOD] vendor import preview failed", sanitizeErrorForLog(error));
      const message = getVendorMasterApiErrorMessage(
        error,
        "거래처 엑셀 미리보기를 생성하지 못했습니다."
      );
      setVendorMastersError(message);
      setToastMessage(message);
    }
  };

  const handleVendorExcelFileChange = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!file) return;
    setVendorMastersLoading(true);
    try {
      const XLSX = await import("xlsx");
      const buffer = await file.arrayBuffer();
      const workbook = XLSX.read(buffer, { type: "array" });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(worksheet, { defval: "", raw: false });
      await previewVendorExcelRows(buildSafeVendorWorkbookImportRows(rows));
    } catch (error) {
      console.error("[CNFOOD] vendor excel parse failed", sanitizeErrorForLog(error));
      setToastMessage("거래처 엑셀 파일을 읽지 못했습니다. 양식을 확인해 주세요.");
    } finally {
      setVendorMastersLoading(false);
    }
  };

  const removeVendorPreviewRow = (index) => {
    const nextRows = vendorImportRows.filter((_, rowIndex) => rowIndex !== index);
    void previewVendorExcelRows(nextRows);
  };

  const openCompanyBranchModal = (branch = null) => {
    const baseBranch = branch
      ? normalizeCompanyBranchRow(branch, {
          updatedBy: currentManager?.name || "본사",
        }).branch
      : normalizeCompanyBranchRow(
          {
            branchName: "",
            corporationName: "",
            active: true,
            pgProfile: { provider: "KCP", status: "NOT_APPLIED" },
          },
          { updatedBy: currentManager?.name || "본사" }
        ).branch;
    setCompanyBranchForm(baseBranch);
    setCompanyBranchSaveReason("");
    setCompanyBranchModalOpen(true);
  };

  const closeCompanyBranchModal = () => {
    if (companyBranchSaving) return;
    setCompanyBranchModalOpen(false);
    setCompanyBranchSaveReason("");
  };

  const updateCompanyBranchForm = (patch = {}) => {
    setCompanyBranchForm((prev) => ({
      ...prev,
      ...patch,
      pgProfile: {
        ...(prev.pgProfile || {}),
        ...(patch.pgProfile || {}),
      },
    }));
  };

  const saveCompanyBranch = async () => {
    if (companyBranchSaving) return;
    const reason = String(companyBranchSaveReason || companyBranchForm.memo || "").trim();
    if (!reason) {
      setCompanyBranchesError("사업장 저장 사유 또는 메모를 입력해 주세요.");
      return;
    }
    const normalized = normalizeCompanyBranchRow(companyBranchForm, {
      updatedBy: currentManager?.name || "본사",
    });
    if (!normalized.ok) {
      setCompanyBranchesError(normalized.errors.join(" "));
      return;
    }
    setCompanyBranchSaving(true);
    setCompanyBranchesError("");
    try {
      const result = await callCompanyBranchesApi("saveCompanyBranch", {
        branch: normalized.branch,
        reason,
      });
      const savedBranch = result.branch || normalized.branch;
      setCompanyBranches((prev) => {
        const next = savedBranch.isDefault
          ? prev.map((branch) => ({ ...branch, isDefault: false }))
          : [...prev];
        const exists = next.some(
          (branch) => (branch.branchId || branch.id) === savedBranch.branchId
        );
        if (exists) {
          return next.map((branch) =>
            (branch.branchId || branch.id) === savedBranch.branchId ? savedBranch : branch
          );
        }
        return [savedBranch, ...next];
      });
      setCompanyBranchModalOpen(false);
      setCompanyBranchSaveReason("");
      setToastMessage("우리회사 사업장이 저장되었습니다.");
    } catch (error) {
      console.error("[CNFOOD] company branch save failed", sanitizeErrorForLog(error));
      const message = error?.message || "사업장 저장에 실패했습니다.";
      setCompanyBranchesError(message);
      setToastMessage(message);
    } finally {
      setCompanyBranchSaving(false);
    }
  };

  const archiveCompanyBranch = async (branch) => {
    const branchId = branch?.branchId || branch?.id;
    if (!branchId || companyBranchSaving) return;
    setCompanyBranchSaving(true);
    setCompanyBranchesError("");
    try {
      const result = await callCompanyBranchesApi("archiveCompanyBranch", {
        branchId,
        reason: "관리자 화면 비활성 처리",
      });
      const savedBranch = result.branch || { ...branch, active: false, isDefault: false };
      setCompanyBranches((prev) =>
        prev.map((item) =>
          (item.branchId || item.id) === branchId ? savedBranch : item
        )
      );
      setToastMessage("사업장을 비활성 처리했습니다.");
    } catch (error) {
      console.error("[CNFOOD] company branch archive failed", sanitizeErrorForLog(error));
      const message = error?.message || "사업장 비활성 처리에 실패했습니다.";
      setCompanyBranchesError(message);
      setToastMessage(message);
    } finally {
      setCompanyBranchSaving(false);
    }
  };

  const applyVendorImport = async () => {
    if (!vendorImportRows.length || vendorImportApplying || !vendorImportPreview) return;
    if (Number(vendorImportPreview.readyCount || 0) < 1) {
      setVendorMastersError("적용 가능한 거래처 행이 없습니다.");
      return;
    }
    if (!String(vendorImportReason || "").trim()) {
      setVendorMastersError("Excel 적용 사유를 입력해 주세요.");
      return;
    }
    setVendorImportApplying(true);
    setVendorMastersError("");
    try {
      const expectedUpdatedAtByVendorId = Object.fromEntries(
        vendorImportPreview.rows
          .filter((row) => row.existingVendor?.vendorId && row.expectedUpdatedAt)
          .map((row) => [row.existingVendor.vendorId, row.expectedUpdatedAt])
      );
      const result = await callVendorMasterApi("importApply", {
        rows: vendorImportRows,
        batchId: vendorImportPreview.batchId || createStableId("vendor_batch"),
        reason: vendorImportReason.trim(),
        expectedUpdatedAtByVendorId,
      });
      setVendorImportResult(result);
      setToastMessage(result.message || `거래처 신규 ${result.createdCount || 0}건 / 기존 업데이트 ${result.updatedCount || 0}건을 적용했습니다.`);
      await loadVendorMasters();
    } catch (error) {
      console.error("[CNFOOD] vendor import apply failed", sanitizeErrorForLog(error));
      const message = getVendorMasterApiErrorMessage(
        error,
        "거래처 등록에 실패했습니다."
      );
      setVendorMastersError(message);
      setToastMessage(message);
    } finally {
      setVendorImportApplying(false);
    }
  };

  const openVendorMasterModal = (vendor = null) => {
    const defaultBranch = resolveDefaultCompanyBranch(companyBranches);
    const baseVendor = vendor
      ? normalizeVendorMasterRow(vendor, {
          updatedBy: currentManager?.name || "본사",
          source: vendor.source || "MANUAL",
          companyBranches,
        }).vendor
      : normalizeVendorMasterRow(
          {
            status: "ACTIVE",
            companyBranchId: defaultBranch?.branchId || defaultBranch?.id || "",
            companyBranchName: defaultBranch?.branchName || "",
            companyBranchIds: defaultBranch ? [defaultBranch.branchId || defaultBranch.id] : [],
            siteIds: defaultBranch ? [defaultBranch.branchId || defaultBranch.id] : [],
          },
          {
            updatedBy: currentManager?.name || "본사",
            source: "MANUAL",
            companyBranches,
          }
        ).vendor;
    if (vendor) {
      const vendorId = getCanonicalVendorMasterId(vendor);
      if (!vendorId) {
        const message = "수정할 거래처 식별자를 확인할 수 없습니다. 목록을 새로 불러와 주세요.";
        setVendorMastersError(message);
        setToastMessage(message);
        return;
      }
      setVendorMasterEditorState(
        editVendorMasterEditorState({
          ...baseVendor,
          id: vendorId,
          vendorId,
          updatedAt: vendor.updatedAt || "",
        })
      );
    } else {
      setVendorMasterEditorState(createVendorMasterEditorState(baseVendor));
    }
    setVendorMasterSaveReason("");
    setVendorMastersError("");
  };

  const closeVendorMasterModal = () => {
    if (vendorMasterSaving) return;
    setVendorMasterEditorState(null);
    setVendorMasterSaveReason("");
  };

  const updateVendorMasterForm = (patch = {}) => {
    setVendorMasterEditorState((prev) =>
      prev ? updateVendorMasterEditorState(prev, patch) : prev
    );
  };

  const updateVendorMasterBranchSelection = (branchId, checked) => {
    const currentIds = normalizeVendorMasterBranchIds(vendorMasterForm);
    const nextIds = checked
      ? Array.from(new Set([...currentIds, branchId]))
      : currentIds.filter((id) => id !== branchId);
    const snapshots = buildVendorMasterBranchSnapshots({
      branchIds: nextIds,
      companyBranches,
      existingSnapshots: vendorMasterForm?.companyBranchSnapshots || [],
    });
    updateVendorMasterForm({
      companyBranchIds: nextIds,
      siteIds: nextIds,
      companyBranchId: snapshots[0]?.id || nextIds[0] || "",
      companyBranchName: snapshots.map((snapshot) => snapshot.branchName).join(", "),
      companyBranchSnapshot: snapshots[0] || null,
      companyBranchSnapshots: snapshots,
    });
  };

  const saveVendorMaster = async () => {
    if (vendorMasterSaving || !vendorMasterEditorState) return;
    const reason = String(vendorMasterSaveReason || vendorMasterForm.memo || "").trim();
    if (!reason) {
      setVendorMastersError("거래처 저장 사유 또는 메모를 입력해 주세요.");
      return;
    }
    const editorRequest = getVendorMasterEditorRequest(vendorMasterEditorState);
    const vendorForSave = { ...vendorMasterForm };
    const normalized = normalizeVendorMasterRow(vendorForSave, {
      updatedBy: currentManager?.name || "본사",
      source: vendorMasterForm.source || "MANUAL",
      companyBranches,
      requireCompanyBranch: true,
    });
    if (!normalized.ok) {
      setVendorMastersError(normalized.errors.join(" "));
      return;
    }
    setVendorMasterSaving(true);
    setVendorMastersError("");
    try {
      const result = await callVendorMasterApi(editorRequest.mode, {
        vendorId: editorRequest.vendorId,
        expectedUpdatedAt: editorRequest.expectedUpdatedAt,
        vendor: normalized.vendor,
        reason,
      });
      const savedVendor = result.vendor || normalized.vendor;
      const savedDisplayVendor =
        buildVendorMasterDisplayRows({
          vendors: [savedVendor],
          electronicContracts: contractList,
          legacyContracts,
          companyBranches,
        })[0] || savedVendor;
      setVendorMasters((prev) => {
        const exists = prev.some(
          (vendor) => (vendor.vendorId || vendor.id) === savedVendor.vendorId
        );
        if (exists) {
          return prev.map((vendor) =>
            (vendor.vendorId || vendor.id) === savedVendor.vendorId ? savedVendor : vendor
          );
        }
        return [savedVendor, ...prev];
      });
      setSelectedVendorMaster(savedDisplayVendor);
      setVendorMasterEditorState(null);
      setVendorMasterSaveReason("");
      await loadVendorMasters({
        cursor: vendorMasterPagination.cursor,
        cursorStack: vendorMasterPagination.cursorStack,
      });
      setToastMessage(
        editorRequest.mode === "updateVendor"
          ? "거래처 정보가 수정되었습니다. 문자링크 결제 거래처 검색에도 반영됩니다."
          : "거래처가 등록되었습니다. 문자링크 결제 거래처 검색에서 바로 사용할 수 있습니다."
      );
    } catch (error) {
      console.error("[CNFOOD] vendor save failed", sanitizeErrorForLog(error));
      const message = getVendorMasterApiErrorMessage(
        error,
        "거래처 마스터 저장에 실패했습니다."
      );
      setVendorMastersError(message);
      setToastMessage(message);
    } finally {
      setVendorMasterSaving(false);
    }
  };

  const changeVendorLifecycle = async (mode, reason, confirmationText = "") => {
    const vendorId = getVendorMasterId(selectedVendorMaster || {});
    if (!vendorId || vendorLifecycleSaving) return;
    setVendorLifecycleSaving(true);
    setVendorMastersError("");
    try {
      const result = await callVendorMasterApi(mode, {
        vendorId,
        reason,
        confirmationText,
      });
      const savedVendor = result.vendor;
      setVendorMasters((prev) =>
        prev.map((vendor) =>
          getVendorMasterId(vendor) === vendorId ? savedVendor : vendor
        )
      );
      const displayVendor =
        buildVendorMasterDisplayRows({
          vendors: [savedVendor],
          electronicContracts: contractList,
          legacyContracts,
          companyBranches,
        })[0] || savedVendor;
      setSelectedVendorMaster(displayVendor);
      await loadVendorMasters({
        cursor: vendorMasterPagination.cursor,
        cursorStack: vendorMasterPagination.cursorStack,
      });
      setToastMessage(
        mode === "restoreVendor" ? "거래처를 복원했습니다." : "거래처를 삭제 처리했습니다."
      );
    } catch (error) {
      console.error("[CNFOOD] vendor lifecycle failed", sanitizeErrorForLog(error));
      const message = getVendorMasterApiErrorMessage(
        error,
        "거래처 상태 변경에 실패했습니다."
      );
      setVendorMastersError(message);
      setToastMessage(message);
    } finally {
      setVendorLifecycleSaving(false);
    }
  };

  const getVendorMasterId = (vendor = {}) =>
    pickSalesLookupString(vendor.vendorId, vendor.id);

  const toggleVendorMasterSelection = (vendorId = "", checked = false) => {
    const normalizedId = pickSalesLookupString(vendorId);
    if (!normalizedId) return;
    setVendorMasterBulkConfirmOpen(false);
    setVendorMasterSelectedIds((prev) =>
      checked
        ? Array.from(new Set([...prev, normalizedId]))
        : prev.filter((id) => id !== normalizedId)
    );
  };

  const toggleAllFilteredVendorMasters = (checked = false) => {
    setVendorMasterBulkConfirmOpen(false);
    setVendorMasterSelectedIds(
      checked
        ? vendorMasterFilteredRows
            .map((vendor) => getVendorMasterId(vendor))
            .filter(Boolean)
        : []
    );
  };

  const requestVendorMasterBulkBranchChange = () => {
    const targetBranch = companyBranches.find(
      (branch) =>
        pickSalesLookupString(branch.branchId, branch.id) ===
        vendorMasterBulkBranchId
    );
    if (vendorMasterSelectedIds.length === 0) {
      setVendorMastersError("사업장을 변경할 거래처를 선택해 주세요.");
      return;
    }
    if (!targetBranch || targetBranch.active === false) {
      setVendorMastersError("변경할 활성 사업장을 선택해 주세요.");
      return;
    }
    if (!String(vendorMasterBulkReason || "").trim()) {
      setVendorMastersError("일괄 변경 사유를 입력해 주세요.");
      return;
    }
    setVendorMastersError("");
    setVendorMasterBulkConfirmOpen(true);
  };

  const saveVendorMasterBulkBranchChange = async () => {
    if (vendorMasterBulkSaving) return;
    const targetBranch = companyBranches.find(
      (branch) =>
        pickSalesLookupString(branch.branchId, branch.id) ===
        vendorMasterBulkBranchId
    );
    if (!targetBranch || vendorMasterSelectedIds.length === 0) return;
    setVendorMasterBulkSaving(true);
    setVendorMastersError("");
    try {
      const result = await callVendorMasterApi("bulkAssignCompanyBranch", {
        vendorIds: vendorMasterSelectedIds,
        companyBranchId: vendorMasterBulkBranchId,
        reason: String(vendorMasterBulkReason || "").trim(),
      });
      const branchPatch = result.branchPatch || {};
      const changedIds = new Set(result.vendorIds || vendorMasterSelectedIds);
      setVendorMasters((prev) =>
        prev.map((vendor) =>
          changedIds.has(getVendorMasterId(vendor))
            ? { ...vendor, ...branchPatch }
            : vendor
        )
      );
      setSelectedVendorMaster((prev) =>
        prev && changedIds.has(getVendorMasterId(prev))
          ? { ...prev, ...branchPatch }
          : prev
      );
      setVendorMasterSelectedIds([]);
      setVendorMasterBulkBranchId("");
      setVendorMasterBulkReason("");
      setVendorMasterBulkConfirmOpen(false);
      await loadVendorMasters({
        cursor: vendorMasterPagination.cursor,
        cursorStack: vendorMasterPagination.cursorStack,
      });
      const successMessage = `거래처 ${
        result.updatedCount || changedIds.size
      }건의 담당사업장을 변경했습니다.`;
      setToastMessage(
        result.auditLogged === false
          ? `${successMessage} 감사 로그 저장은 실패했으므로 관리자 확인이 필요합니다.`
          : successMessage
      );
      if (result.auditLogged === false) {
        setVendorMastersError(
          "담당사업장 변경은 완료됐지만 감사 로그 저장에 실패했습니다. 같은 변경을 다시 실행하지 말고 관리자에게 확인해 주세요."
        );
      }
    } catch (error) {
      console.error(
        "[CNFOOD] vendor bulk branch change failed",
        sanitizeErrorForLog(error)
      );
      const message = getVendorMasterApiErrorMessage(
        error,
        "거래처 담당사업장 일괄 변경에 실패했습니다."
      );
      setVendorMastersError(message);
      setToastMessage(message);
    } finally {
      setVendorMasterBulkSaving(false);
    }
  };

  const downloadVendorMasterRowsAsXlsx = async (rows = vendorMasterFilteredRows) => {
    const exportRows = buildSafeVendorMasterExportRows(rows);
    if (exportRows.length === 0) {
      setToastMessage("다운로드할 거래처 데이터가 없습니다.");
      return;
    }
    try {
      const XLSX = await import("xlsx");
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(exportRows);
      XLSX.utils.book_append_sheet(workbook, worksheet, "vendors");
      const today = new Date().toISOString().slice(0, 10).replace(/-/g, "");
      XLSX.writeFile(workbook, `cnfood_vendor_master_${today}.xlsx`);
    } catch (error) {
      console.error("[CNFOOD] vendor export failed", sanitizeErrorForLog(error));
      setToastMessage("거래처 엑셀 다운로드를 생성하지 못했습니다.");
    }
  };

  const openLegacyContractDetail = async (legacyRow) => {
    const legacyId = legacyRow?.legacyId || legacyRow?.documentId;
    if (!legacyId) return;
    setLegacyContractsLoading(true);
    setLegacyContractsError("");
    try {
      const result = await callLegacyContractsApi("detail", { legacyId });
      setSelectedLegacyContract({
        ...(result.contract || legacyRow),
        legacyId,
        id: result.contract?.id || legacyRow.documentId,
      });
      setLegacyDocuments(
        (Array.isArray(result.documents) ? result.documents : []).filter(
          (document) => !document.deletedAt
        )
      );
      setLegacyHistory(Array.isArray(result.history) ? result.history : []);
    } catch (error) {
      console.error("[CNFOOD] legacy detail load failed", sanitizeErrorForLog(error));
      const message = error?.message || "기존 계약 상세를 불러오지 못했습니다.";
      setLegacyContractsError(message);
      setToastMessage(message);
    } finally {
      setLegacyContractsLoading(false);
    }
  };

  const uploadLegacyDocuments = async (event) => {
    const files = Array.from(event.target.files || []);
    event.target.value = "";
    if (!selectedLegacyContract || files.length === 0) return;
    const legacyId = selectedLegacyContract.legacyId || selectedLegacyContract.id;
    setLegacyDocumentUploading(true);
    try {
      for (const file of files) {
        const allowed = [
          "image/jpeg",
          "image/png",
          "image/webp",
          "application/pdf",
        ].includes(file.type);
        if (!allowed) {
          setToastMessage("JPG, PNG, WEBP, PDF 파일만 등록할 수 있습니다.");
          continue;
        }
        const datePart = new Date().toISOString().slice(0, 10).replace(/-/g, "");
        const safeName = file.name.replace(/[^\w.\-가-힣]/g, "_");
        const path = `legacyContracts/${legacyId}/documents/${datePart}/${createStableId(
          "legacy_file"
        )}_${safeName}`;
        const ref = storageRef(storage, path);
        await uploadBytes(ref, file, { contentType: file.type });
        const fileUrl = await getDownloadURL(ref);
        await callLegacyContractsApi("uploadDocumentMetadata", {
          legacyId,
          documentType: legacyDocumentDraft.documentType,
          title: legacyDocumentDraft.title || file.name,
          description: legacyDocumentDraft.description,
          fileName: file.name,
          fileUrl,
          storagePath: path,
          mimeType: file.type,
          sizeBytes: file.size,
        });
      }
      setToastMessage("기존 계약 문서를 등록했습니다.");
      await openLegacyContractDetail({ legacyId });
    } catch (error) {
      console.error("[CNFOOD] legacy document upload failed", sanitizeErrorForLog(error));
      const message =
        error?.code === "storage/unauthorized"
          ? "Firebase Storage 업로드 권한이 없습니다. Storage rules 설정이 필요합니다."
          : error?.message || "문서 업로드에 실패했습니다.";
      setToastMessage(message);
    } finally {
      setLegacyDocumentUploading(false);
    }
  };

  const addLegacyHistory = async () => {
    if (!selectedLegacyContract || legacyHistorySaving) return;
    if (!legacyHistoryDraft.title.trim() || !legacyHistoryDraft.body.trim()) {
      setToastMessage("히스토리 제목과 내용을 입력해 주세요.");
      return;
    }
    setLegacyHistorySaving(true);
    try {
      const legacyId = selectedLegacyContract.legacyId || selectedLegacyContract.id;
      await callLegacyContractsApi("addHistory", {
        legacyId,
        ...legacyHistoryDraft,
      });
      setLegacyHistoryDraft({ type: "NOTE", title: "", body: "" });
      setToastMessage("기존 거래처 히스토리를 추가했습니다.");
      await openLegacyContractDetail({ legacyId });
    } catch (error) {
      console.error("[CNFOOD] legacy history add failed", sanitizeErrorForLog(error));
      setToastMessage(error?.message || "히스토리 추가에 실패했습니다.");
    } finally {
      setLegacyHistorySaving(false);
    }
  };

  const softDeleteLegacyDocument = async (documentId) => {
    if (!selectedLegacyContract || !documentId) return;
    try {
      const legacyId = selectedLegacyContract.legacyId || selectedLegacyContract.id;
      await callLegacyContractsApi("softDeleteDocument", {
        legacyId,
        documentId,
        deletedBy: currentManager?.name || "본사",
      });
      setLegacyDocuments((prev) =>
        prev.filter((document) => (document.id || document.documentId) !== documentId)
      );
      setToastMessage("문서가 숨김 처리되었습니다.");
    } catch (error) {
      console.error("[CNFOOD] legacy document soft delete failed", sanitizeErrorForLog(error));
      setToastMessage(error?.message || "문서 숨김 처리에 실패했습니다.");
    }
  };

  const loadNotificationSettings = async ({ silent = false } = {}) => {
    setNotificationSettingsLoading(true);
    try {
      const snap = await getDoc(
        doc(db, "artifacts", appId, "config", NOTIFICATION_SETTINGS_DOC_ID)
      );
      const emails = snap.exists()
        ? normalizeNotificationEmails(snap.data()?.notificationEmails || [])
        : [];
      setNotificationEmails(emails);
      if (!snap.exists()) {
        console.info("[CNFOOD] notification settings empty");
      }
      return emails;
    } catch (error) {
      console.error("[CNFOOD] notification settings load failed", sanitizeErrorForLog(error));
      setNotificationEmails([]);
      if (!silent) {
        setToastMessage(
          getFirestoreErrorToastMessage(
            error,
            "알림 이메일 설정을 불러오지 못했습니다."
          )
        );
      }
      return [];
    } finally {
      setNotificationSettingsLoading(false);
    }
  };

  const saveNotificationSettings = async (
    nextEmails,
    successMessage = "알림 이메일 설정이 저장되었습니다."
  ) => {
    setNotificationSettingsSaving(true);
    try {
      const emails = normalizeNotificationEmails(nextEmails);
      await setDoc(
        doc(db, "artifacts", appId, "config", NOTIFICATION_SETTINGS_DOC_ID),
        buildNotificationSettingsPayload(
          emails,
          currentManager?.name || "admin"
        )
      );
      setNotificationEmails(emails);
      setToastMessage(
        emails.length > 0
          ? successMessage
          : "알림 이메일이 비어 있어 계약 완료 알림이 발송되지 않습니다."
      );
      return true;
    } catch (error) {
      handleAdminWriteError(error, "saveNotificationSettings");
      return false;
    } finally {
      setNotificationSettingsSaving(false);
    }
  };

  const handleAddNotificationEmail = async () => {
    if (notificationSettingsSaving) return;
    const normalized = String(notificationEmailDraft || "").trim().toLowerCase();
    if (!isValidNotificationEmail(normalized)) {
      setToastMessage("이메일 형식을 확인해 주세요.");
      return;
    }
    if (notificationEmails.includes(normalized)) {
      setToastMessage("이미 등록된 이메일입니다.");
      return;
    }
    const saved = await saveNotificationSettings(
      [...notificationEmails, normalized],
      "알림 이메일이 저장되었습니다."
    );
    if (saved) {
      setNotificationEmailDraft("");
    }
  };

  const handleRemoveNotificationEmail = (email) => {
    setNotificationEmails((prev) => prev.filter((item) => item !== email));
  };

  const handleSaveNotificationSettings = async () => {
    if (notificationSettingsSaving) return;
    await saveNotificationSettings(notificationEmails);
  };

  const loadSalesReps = async ({ silent = false } = {}) => {
    setSalesRepsLoading(true);
    try {
      const snap = await getDoc(
        doc(db, "artifacts", appId, "config", SALES_REPS_CONFIG_DOC_ID)
      );
      const firestoreItems = snap.exists()
        ? normalizeSalesRepItems(snap.data()?.items || [])
        : [];
      const localItems = loadSalesRepsFromLocalStorage();
      const items = firestoreItems.length > 0 ? firestoreItems : localItems;
      if (firestoreItems.length > 0) {
        saveSalesRepsToLocalStorage(firestoreItems);
      }
      setSalesReps(items);
      setSalesRepStorageSource(
        getSalesRepStorageSource({ firestoreItems, localItems })
      );
      return items;
    } catch (error) {
      console.error("[CNFOOD] sales reps load failed", sanitizeErrorForLog(error));
      const localItems = loadSalesRepsFromLocalStorage();
      setSalesReps(localItems);
      setSalesRepStorageSource(
        getSalesRepStorageSource({ firestoreItems: [], localItems })
      );
      if (!silent)
        setToastMessage(
          getFirestoreErrorToastMessage(error, "영업사원 목록을 불러오지 못했습니다.")
        );
      return localItems;
    } finally {
      setSalesRepsLoading(false);
    }
  };

  const saveSalesReps = async (
    items,
    { successMessage = "영업사원 설정이 저장되었습니다." } = {}
  ) => {
    setSalesRepsSaving(true);
    const normalized = normalizeSalesRepItems(items);
    try {
      const result = await persistSalesRepsWithFallback(normalized, {
        successMessage,
        saveToFirestore: async (nextItems) =>
          setDoc(
            doc(db, "artifacts", appId, "config", SALES_REPS_CONFIG_DOC_ID),
            {
              items: nextItems,
              updatedAt: new Date().toISOString(),
              updatedBy: currentManager?.name || "admin",
            },
            { merge: true }
          ),
        saveToFallback: saveSalesRepsToLocalStorage,
      });

      if (!result.ok) {
        throw result;
      }

      if (result.storage === "localStorage" && result.error) {
        console.error(
          "[CNFOOD] sales reps Firestore save failed",
          sanitizeErrorForLog(result.error)
        );
      }
      setSalesReps(result.items);
      setSalesRepStorageSource(
        getSalesRepStorageSource({ storageMode: result.storage, items: result.items })
      );
      setToastMessage(result.toastMessage);
      return result;
    } catch (error) {
      const originalError = error?.error || error;
      if (error?.fallbackError) {
        console.error(
          "[CNFOOD] sales reps local fallback save failed",
          sanitizeErrorForLog(error.fallbackError)
        );
      }
      handleAdminWriteError(originalError, "saveSalesReps");
      return {
        ok: false,
        items: salesReps,
        storage: "failed",
        error: originalError,
      };
    } finally {
      setSalesRepsSaving(false);
    }
  };

  const resetSalesRepDraft = () => {
    setSalesRepDraft({
      id: "",
      name: "",
      part: "",
      phone: "",
      email: "",
      active: true,
    });
  };

  const handleSaveSalesRepDraft = async () => {
    if (isSavingSalesManager || salesRepsSaving) return;
    setIsSavingSalesManager(true);
    try {
      const isUpdating = getMatchingSalesRepIndex(salesReps, salesRepDraft) >= 0;
      const nextItems = addOrUpdateSalesRepItem(salesReps, salesRepDraft);
      const result = await saveSalesReps(nextItems, {
        successMessage: isUpdating
          ? "기존 영업사원 정보가 수정되었습니다."
          : "영업사원이 등록되었습니다.",
      });
      if (result.ok) {
        setSalesReps(result.items);
        resetSalesRepDraft();
      }
    } catch (error) {
      console.error("[CNFOOD] sales rep validation failed", sanitizeErrorForLog(error));
      setToastMessage(error?.message || "영업사원 정보를 확인해 주세요.");
    } finally {
      setIsSavingSalesManager(false);
    }
  };

  const handleSaveSalesRepBulk = async () => {
    if (isSavingSalesManagersBulk || salesRepsSaving) return;

    const parsed = parseSalesManagersBulkInput(salesRepBulkText);
    if (!salesRepBulkText.trim() || parsed.items.length === 0) {
      setToastMessage(
        parsed.errors[0] || "일괄 등록할 영업사원 정보를 입력해 주세요."
      );
      return;
    }
    if (parsed.errors.length > 0) {
      setToastMessage(parsed.errors[0]);
      return;
    }

    setIsSavingSalesManagersBulk(true);
    try {
      const nextItems = upsertSalesRepItems(salesReps, parsed.items);
      const result = await saveSalesReps(nextItems, {
        successMessage: `영업사원 ${parsed.items.length}건이 일괄 등록/수정되었습니다.`,
      });
      if (result.ok) {
        setSalesReps(result.items);
        setSalesRepBulkText("");
      }
    } catch (error) {
      console.error("[CNFOOD] sales rep bulk save failed", sanitizeErrorForLog(error));
      setToastMessage(error?.message || "영업사원 일괄 등록 정보를 확인해 주세요.");
    } finally {
      setIsSavingSalesManagersBulk(false);
    }
  };

  const handleEditSalesRep = (rep) => {
    setSalesRepDraft({ ...rep });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleToggleSalesRepActive = async (rep) => {
    const nextItems = salesReps.map((item) =>
      item.id === rep.id
        ? {
            ...item,
            active: !item.active,
            isActive: !item.active,
            updatedAt: new Date().toISOString(),
          }
        : item
    );
    await saveSalesReps(nextItems, {
      successMessage: rep.active
        ? "영업사원이 비활성화되었습니다."
        : "영업사원이 활성화되었습니다.",
    });
  };

  const handleCreateInvite = async () => {
    if (inviteCreating) return;

    const showInviteCreateFailure = (message) => {
      setInviteCreateErrorMessage(message);
      setToastMessage(message);
    };

    setInviteCreateErrorMessage("");
    setInviteResult(null);

    const ownerSelection = getInviteOwnerSelection(inviteDraft);
    const selectedRep =
      ownerSelection.ownerType === "SALES_REP"
        ? getActiveSalesReps(salesReps).find(
            (rep) => rep.id === ownerSelection.salesRepId
          )
        : null;
    if (!String(inviteDraft.customerName || "").trim()) {
      showInviteCreateFailure("거래처명을 입력해 주세요.");
      return;
    }
    const normalizedBusinessNumber = normalizeBusinessNumber(
      inviteDraft.businessNumber || ""
    );
    if (normalizedBusinessNumber && !/^\d{10}$/.test(normalizedBusinessNumber)) {
      showInviteCreateFailure("사업자번호는 숫자 10자리로 입력해 주세요.");
      return;
    }
    if (
      ownerSelection.ownerType === "SALES_REP" &&
      salesRepStorageSource === "LOCAL_STORAGE_FALLBACK"
    ) {
      showInviteCreateFailure(SALES_REPS_LOCAL_INVITE_BLOCK_MESSAGE);
      return;
    }
    if (ownerSelection.ownerType === "SALES_REP" && !selectedRep) {
      showInviteCreateFailure(INVITE_SALES_REP_NOT_FOUND_MESSAGE);
      return;
    }
    const inviteAdminPassword = resolveInviteAdminPassword(
      adminPassword,
      adminSessionPasswordRef.current
    );
    if (!inviteAdminPassword) {
      showInviteCreateFailure(INVITE_LINK_ADMIN_PASSWORD_REQUIRED_TOAST);
      return;
    }

    setInviteCreating(true);
    setToastMessage(INVITE_LINK_CREATING_TOAST);
    try {
      const response = await fetch("/api/create-contract-invite", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          password: inviteAdminPassword,
          appId,
          draft: {
            ...inviteDraft,
            businessNumber: normalizedBusinessNumber,
            ownerType: ownerSelection.ownerType,
            salesRepId: ownerSelection.salesRepId,
            ownerLabel:
              ownerSelection.ownerType === "HQ"
                ? INVITE_OWNER_HQ_LABEL
                : getInviteOwnerLabel({
                    ownerType: "SALES_REP",
                    salesRepId: selectedRep?.id,
                    salesRepDepartmentPart: getSalesRepPart(selectedRep),
                    salesRepName: selectedRep?.name,
                  }),
          },
          salesRep: selectedRep,
          baseUrl: `${window.location.origin}${window.location.pathname}`,
        }),
      });
      let jsonParseFailed = false;
      const result = await response.json().catch(() => {
        jsonParseFailed = true;
        return null;
      });

      if (!response.ok || !result?.ok) {
        const userMessage = getInviteCreateApiFailureMessage({
          status: response.status,
          result,
          jsonParseFailed,
        });
        const error = Object.assign(new Error(userMessage), {
          code: result?.code || (response.status === 401 ? "permission-denied" : ""),
          userMessage,
        });
        throw error;
      }

      const inviteDoc = result.invite;
      const token = result.token;
      const inviteUrl =
        result.inviteUrl ||
        buildInviteUrl(`${window.location.origin}${window.location.pathname}`, token);
      setInviteResult({
        invite: inviteDoc,
        token,
        inviteUrl,
        smsMessage: buildInviteSmsMessage({ invite: inviteDoc, inviteUrl }),
      });
      setInviteDraft({
        customerName: "",
        businessType: "individual",
        businessNumber: "",
        ownerValue: inviteDraft.ownerValue || INVITE_OWNER_HQ_VALUE,
        salesRepId: ownerSelection.salesRepId || "",
        expiresDays: inviteDraft.expiresDays || String(DEFAULT_INVITE_EXPIRES_DAYS),
        memo: "",
      });
      setInviteCreateErrorMessage("");
      setToastMessage("초대 링크가 생성되었습니다.");
    } catch (error) {
      console.error("[CNFOOD] invite create failed", sanitizeErrorForLog(error));
      showInviteCreateFailure(
        error?.userMessage || getInviteCreateErrorToastMessage(error)
      );
    } finally {
      setInviteCreating(false);
    }
  };

  const copyTextToClipboard = async (text) => {
    try {
      if (!navigator.clipboard) throw new Error("clipboard unavailable");
      await navigator.clipboard.writeText(text);
      setToastMessage("복사되었습니다.");
      return true;
    } catch (error) {
      console.error("[CNFOOD] clipboard copy failed", sanitizeErrorForLog(error));
      setToastMessage("복사에 실패했습니다. 링크를 직접 선택해 복사해 주세요.");
      return false;
    }
  };

  const confirmPaymentCopyPreview = async () => {
    if (!paymentCopyPreview?.text) return;
    const copied = await copyTextToClipboard(paymentCopyPreview.text);
    if (copied) setPaymentCopyPreview(null);
  };

  const handleAddPostCompletionCoRepresentative = async () => {
    if (!selectedContract) return;
    const documentId =
      selectedContract.documentId ||
      selectedContract.id ||
      selectedContract.firestoreId ||
      "";
    if (!documentId) {
      setToastMessage("계약 문서 ID를 확인할 수 없습니다.");
      return;
    }
    const passwordForRequest = adminSessionPasswordRef.current || adminPassword || "";
    if (!passwordForRequest) {
      setToastMessage("관리자 인증 후 공동대표를 추가할 수 있습니다.");
      return;
    }
    const name = String(
      adminPostCompletionCoRepresentativeForm.name || ""
    ).trim();
    const phone = normalizePhoneDigits(
      adminPostCompletionCoRepresentativeForm.phone || ""
    );
    const reason = String(
      adminPostCompletionCoRepresentativeForm.reason || ""
    ).trim();
    if (!name) {
      setToastMessage("추가할 공동대표 성명을 입력해 주세요.");
      return;
    }
    if (!isValidPhoneNumberFormat(phone)) {
      setToastMessage("공동대표 휴대폰번호를 확인해 주세요.");
      return;
    }
    if (!reason) {
      setToastMessage("사후 추가/정정 사유를 입력해 주세요.");
      return;
    }
    setAdminPostCompletionCoRepresentativeLoading(true);
    try {
      const origin =
        typeof window !== "undefined"
          ? `${window.location.origin}${window.location.pathname}`
          : "https://cn-food-contract.vercel.app/";
      const response = await fetch("/api/admin-login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          mode: "addPostCompletionCoRepInvite",
          appId,
          password: passwordForRequest,
          documentId,
          name,
          phone,
          reason,
          updatedBy: currentManager?.name || "본사",
          origin,
        }),
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok || result?.ok !== true) {
        throw new Error(
          result?.message || "공동대표를 추가하고 인증 링크를 발급하지 못했습니다."
        );
      }
      const inviteUrl =
        result.inviteUrl ||
        buildCorepInviteUrl({
          token: result.token,
          origin,
        });
      if (!inviteUrl) {
        throw new Error("공동대표 인증 링크 token을 확인할 수 없습니다.");
      }
      const coRepresentativeId = result.coRepresentative?.id || "";
      const patch = result.patch || {};
      const applyPostCompletionPatch = (contract) =>
        contract
          ? {
              ...contract,
              ...patch,
            }
          : contract;
      setSelectedContract((prev) => applyPostCompletionPatch(prev));
      setContractList((prev) =>
        prev.map((contract) =>
          (contract.id || contract.documentId || contract.firestoreId) === documentId
            ? applyPostCompletionPatch(contract)
            : contract
        )
      );
      if (coRepresentativeId) {
        setAdminCoRepresentativeInviteLinks((prev) => ({
          ...prev,
          [coRepresentativeId]: inviteUrl,
        }));
        setAdminCoRepresentativeInviteReasons((prev) => ({
          ...prev,
          [coRepresentativeId]: "",
        }));
      }
      setAdminPostCompletionCoRepresentativeForm({
        name: "",
        phone: "",
        reason: "",
      });
      await copyTextToClipboard(inviteUrl);
      setToastMessage("공동대표를 추가하고 본인인증/서명 링크를 발급했습니다.");
    } catch (error) {
      console.error(
        "[CNFOOD] post-completion corep add failed",
        sanitizeErrorForLog(error)
      );
      setToastMessage(
        error?.message || "공동대표 추가 링크를 발급하지 못했습니다."
      );
    } finally {
      setAdminPostCompletionCoRepresentativeLoading(false);
    }
  };

  const handleIssueAdminCoRepresentativeInvite = async (representative = {}) => {
    if (!selectedContract || !representative?.id) return;
    const documentId =
      selectedContract.documentId ||
      selectedContract.id ||
      selectedContract.firestoreId ||
      "";
    if (!documentId) {
      setToastMessage("계약 문서 ID를 확인할 수 없습니다.");
      return;
    }
    const passwordForRequest = adminSessionPasswordRef.current || adminPassword || "";
    if (!passwordForRequest) {
      setToastMessage("관리자 인증 후 공동계약인 링크를 발급할 수 있습니다.");
      return;
    }
    const reason = String(
      adminCoRepresentativeInviteReasons[representative.id] || ""
    ).trim();
    if (!reason) {
      setToastMessage("공동계약인 링크 재발급 사유를 입력해 주세요.");
      return;
    }
    setAdminCoRepresentativeInviteLoadingId(representative.id);
    try {
      const origin =
        typeof window !== "undefined"
          ? `${window.location.origin}${window.location.pathname}`
          : "https://cn-food-contract.vercel.app/";
      const response = await fetch("/api/admin-login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          mode: "issueCoRepInvite",
          appId,
          password: passwordForRequest,
          documentId,
          coRepresentativeId: representative.id,
          reason,
          updatedBy: currentManager?.name || "본사",
          origin,
        }),
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok || result?.ok !== true) {
        throw new Error(result?.message || "공동계약인 링크를 발급하지 못했습니다.");
      }
      const inviteUrl =
        result.inviteUrl ||
        buildCorepInviteUrl({
          token: result.token,
          origin,
        });
      if (!inviteUrl) {
        throw new Error("공동계약인 링크 원본 token을 확인할 수 없습니다. 다시 재발급해 주세요.");
      }
      setAdminCoRepresentativeInviteLinks((prev) => ({
        ...prev,
        [representative.id]: inviteUrl,
      }));
      setSelectedContract((prev) => {
        if (!prev?.coRepresentatives) return prev;
        return {
          ...prev,
          coRepresentatives: prev.coRepresentatives.map((item) =>
            item.id === representative.id
              ? {
                  ...item,
                  inviteStatus: result.coRepresentative?.inviteStatus || "READY",
                  inviteTokenHash: result.tokenHash || item.inviteTokenHash || "",
                  inviteReissuedAt:
                    result.coRepresentative?.inviteReissuedAt ||
                    item.inviteReissuedAt ||
                    "",
                  inviteReissueReason: reason,
                }
              : item
          ),
          coRepresentativeInviteTokenHashes: [
            ...new Set([
              ...(prev.coRepresentativeInviteTokenHashes || []),
              result.tokenHash,
            ].filter(Boolean)),
          ],
        };
      });
      setContractList((prev) =>
        prev.map((contract) =>
          (contract.id || contract.documentId) === documentId &&
          Array.isArray(contract.coRepresentatives)
            ? {
                ...contract,
                coRepresentatives: contract.coRepresentatives.map((item) =>
                  item.id === representative.id
                    ? {
                        ...item,
                        inviteStatus:
                          result.coRepresentative?.inviteStatus || "READY",
                        inviteTokenHash:
                          result.tokenHash || item.inviteTokenHash || "",
                        inviteReissuedAt:
                          result.coRepresentative?.inviteReissuedAt ||
                          item.inviteReissuedAt ||
                          "",
                        inviteReissueReason: reason,
                      }
                    : item
                ),
                coRepresentativeInviteTokenHashes: [
                  ...new Set([
                    ...(contract.coRepresentativeInviteTokenHashes || []),
                    result.tokenHash,
                  ].filter(Boolean)),
                ],
              }
            : contract
        )
      );
      setAdminCoRepresentativeInviteReasons((prev) => ({
        ...prev,
        [representative.id]: "",
      }));
      await copyTextToClipboard(inviteUrl);
      setToastMessage("공동계약인 인증 링크가 발급되어 복사되었습니다.");
    } catch (error) {
      console.error("[CNFOOD] corep invite issue failed", sanitizeErrorForLog(error));
      setToastMessage(error?.message || "공동계약인 링크를 발급하지 못했습니다.");
    } finally {
      setAdminCoRepresentativeInviteLoadingId("");
    }
  };

  const handleIssueAdminCoRepresentativeSignatureInvite = async (
    representative = {}
  ) => {
    if (!selectedContract || !representative?.id) return;
    const documentId =
      selectedContract.documentId ||
      selectedContract.id ||
      selectedContract.firestoreId ||
      "";
    if (!documentId) {
      setToastMessage("계약 문서 ID를 확인할 수 없습니다.");
      return;
    }
    const passwordForRequest = adminSessionPasswordRef.current || adminPassword || "";
    if (!passwordForRequest) {
      setToastMessage("관리자 인증 후 공동계약인 서명 링크를 발급할 수 있습니다.");
      return;
    }
    const reason = String(
      adminCoRepresentativeInviteReasons[representative.id] || ""
    ).trim();
    if (!reason) {
      setToastMessage("공동계약인 서명 링크 발급 사유를 입력해 주세요.");
      return;
    }
    setAdminCoRepresentativeInviteLoadingId(`${representative.id}:signature`);
    try {
      const origin =
        typeof window !== "undefined"
          ? `${window.location.origin}${window.location.pathname}`
          : "https://cn-food-contract.vercel.app/";
      const response = await fetch("/api/admin-login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          mode: "issueCoRepSignatureOnlyInvite",
          appId,
          password: passwordForRequest,
          documentId,
          coRepresentativeId: representative.id,
          reason,
          updatedBy: currentManager?.name || "본사",
          origin,
        }),
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok || result?.ok !== true) {
        throw new Error(
          result?.message || "공동계약인 서명 링크를 발급하지 못했습니다."
        );
      }
      const inviteUrl =
        result.inviteUrl ||
        buildCorepSignatureOnlyInviteUrl({
          token: result.token,
          origin,
        });
      if (!inviteUrl) {
        throw new Error("공동계약인 서명 링크 token을 확인할 수 없습니다. 다시 발급해 주세요.");
      }
      setAdminCoRepresentativeSignatureLinks((prev) => ({
        ...prev,
        [representative.id]: inviteUrl,
      }));
      const applySignatureLinkState = (contract) =>
        contract && Array.isArray(contract.coRepresentatives)
          ? {
              ...contract,
              coRepresentatives: contract.coRepresentatives.map((item) =>
                item.id === representative.id
                  ? {
                      ...item,
                      signatureOnlyInviteStatus:
                        result.coRepresentative?.signatureOnlyInviteStatus ||
                        "READY",
                      signatureOnlyInviteTokenHash:
                        result.tokenHash ||
                        item.signatureOnlyInviteTokenHash ||
                        "",
                      signatureOnlyInviteCreatedAt:
                        result.coRepresentative?.signatureOnlyInviteCreatedAt ||
                        item.signatureOnlyInviteCreatedAt ||
                        "",
                      signatureOnlyInviteReason: reason,
                    }
                  : item
              ),
              coRepresentativeInviteTokenHashes: [
                ...new Set([
                  ...(contract.coRepresentativeInviteTokenHashes || []),
                  result.tokenHash,
                ].filter(Boolean)),
              ],
            }
          : contract;
      setSelectedContract((prev) => applySignatureLinkState(prev));
      setContractList((prev) =>
        prev.map((contract) =>
          (contract.id || contract.documentId) === documentId
            ? applySignatureLinkState(contract)
            : contract
        )
      );
      setAdminCoRepresentativeInviteReasons((prev) => ({
        ...prev,
        [representative.id]: "",
      }));
      await copyTextToClipboard(inviteUrl);
      setToastMessage("공동계약인 서명 링크가 발급되어 복사되었습니다.");
    } catch (error) {
      console.error(
        "[CNFOOD] corep signature invite issue failed",
        sanitizeErrorForLog(error)
      );
      setToastMessage(error?.message || "공동계약인 서명 링크를 발급하지 못했습니다.");
    } finally {
      setAdminCoRepresentativeInviteLoadingId("");
    }
  };

  const clearRecaptchaVerifier = () => {
    try {
      if (recaptchaVerifierRef.current) {
        recaptchaVerifierRef.current.clear();
      }
    } catch (error) {
      console.error("recaptcha clear failed", sanitizeErrorForLog(error));
    } finally {
      recaptchaVerifierRef.current = null;
      recaptchaWidgetIdRef.current = null;
      const container =
        typeof document !== "undefined"
          ? document.getElementById("recaptcha-container")
          : null;
      if (container) container.innerHTML = "";
    }
  };

  const resetPhoneAuthState = (clearVerifier = false) => {
    setOtpSent(false);
    setOtpCode("");
    setOtpError("");
    setPhoneVerified(false);
    setPhoneVerifiedAt(null);
    confirmationResultRef.current = null;
    if (clearVerifier) {
      setKcpFallbackReason(null);
      setSmsFallbackSelected(false);
      setKcpIdentityStatus("");
      setKcpSessionId("");
      setKcpVerifiedName("");
      setKcpPhoneMasked("");
      setKcpRepresentativeMatchStatus("PENDING_KCP");
      setKcpIdentityEvidence(null);
      clearRecaptchaVerifier();
    }
  };

  const resetStrictIdentityState = (
    clearVerifier = true,
    {
      clearBusinessVerification = true,
      explicitIdentityEdit = false,
      force = false,
      reason = "resetStrictIdentityState",
    } = {}
  ) => {
    if (
      shouldSuppressKcpVerifiedReset({
        graceUntil: kcpVerifiedGraceUntilRef.current,
        explicitIdentityEdit,
        force,
      })
    ) {
      traceKcpReturnLifecycle({
        source: reason,
        previousSyncState: kcpReturnSyncStateRef.current,
        nextSyncState: kcpReturnSyncStateRef.current,
        resetSuppressedByGrace: true,
      });
      return false;
    }
    resetPhoneAuthState(clearVerifier);
    setRepresentativeIdentityVerification(null);
    if (clearBusinessVerification) setBusinessVerification(null);
    setLockedIdentityFields(null);
    setKcpRepresentativeMatchStatus("PENDING_KCP");
    setKcpIdentityEvidence(null);
    return true;
  };

  const handleRetryRepresentativeIdentity = () => {
    resetStrictIdentityState(true, {
      clearBusinessVerification: false,
      explicitIdentityEdit: true,
      reason: "retry-representative-identity",
    });
    setToastMessage("본인확인 상태를 초기화했습니다. 대표자 정보를 수정한 뒤 다시 인증해 주세요.");
  };

  useEffect(() => {
    if (!isRepresentativeIdentityMatched(representativeIdentityVerification)) return;
    const mismatch = getLockedIdentityFieldMismatch({
      formData,
      lockedIdentityFields,
    });
    if (!mismatch) return;
    const resetApplied = resetStrictIdentityState(true, {
      explicitIdentityEdit:
        Date.now() - lastIdentityFieldUserEditAtRef.current < 1500,
      reason: `locked-identity-mismatch:${mismatch}`,
    });
    if (resetApplied) {
      setToastMessage("대표자 본인확인 이후 입력값이 변경되어 인증 상태를 초기화했습니다.");
    }
  }, [
    formData.agentBizNo,
    formData.agentRep,
    formData.representativeBirthDate,
    formData.principalRepSsnFront,
    formData.principalRepSsnBack,
    formData.agentContact,
    formData.openingDate,
    lockedIdentityFields,
    representativeIdentityVerification,
  ]);

  const getOrCreateRecaptchaVerifier = async () => {
    if (recaptchaVerifierRef.current) {
      console.info("[CNFOOD] recaptcha verifier ready");
      return recaptchaVerifierRef.current;
    }

    const container =
      typeof document !== "undefined"
        ? document.getElementById("recaptcha-container")
        : null;

    if (!container) {
      throw new Error("recaptcha container not found");
    }

    container.innerHTML = "";
    const verifier = new RecaptchaVerifier(auth, "recaptcha-container", {
      size: "invisible",
    });
    recaptchaVerifierRef.current = verifier;

    try {
      recaptchaWidgetIdRef.current = await verifier.render();
      console.info("[CNFOOD] recaptcha verifier ready");
      return verifier;
      } catch (error) {
        console.error("recaptcha render failed", sanitizeErrorForLog(error));
        clearRecaptchaVerifier();
        throw error;
      }
  };

  const resetDetailRejectState = () => {
    setShowRejectInput(false);
    setRejectReason("");
  };

  const resolveManagerByCode = (code, source = managersConfig) =>
    source.find((manager) => manager.code === code) ||
    MANAGER_CONFIG_DEFAULT.find((manager) => manager.code === code) ||
    null;

  const getManagerTargetMeta = (target = managerTarget) => {
    const headquartersManager = resolveManagerByCode("default");

    if (target === "default") {
      return {
        label: "본사 관리자 조회",
        description: "관리자 비밀번호 입력 후 전체 계약을 조회합니다.",
        requiresPassword: true,
        actionLabel: "관리자 로그인",
        manager: headquartersManager,
      };
    }

    if (target === "field_print") {
      return {
        label: "계약서 출력 및 다운로드",
        description: "본사 관리자 비밀번호 입력 후 빈 계약서를 출력하거나 PDF로 저장합니다.",
        requiresPassword: true,
        actionLabel: "계약서 출력 열기",
        manager: headquartersManager,
      };
    }

    if (target === "sales_lookup") {
      return {
        label: "영업 조회 로그인",
        description: "거래처 계약 작성 여부를 기본정보로만 조회합니다.",
        requiresPassword: true,
        actionLabel: "조회 화면 들어가기",
        manager: SALES_LOOKUP_MANAGER,
      };
    }

    if (target === "payment") {
      return {
        label: "결제관리 전용",
        description: "문자링크, 키인 대기열, 등록카드 결제 화면만 관리합니다.",
        requiresPassword: true,
        actionLabel: "결제관리 들어가기",
        manager: PAYMENT_MANAGER,
      };
    }

    if (target === "sales_payment") {
      return {
        label: "영업 문자링크 요청",
        description: "영업사원 코드와 개인 비밀번호로 로그인해 본인 담당 거래처의 문자링크만 생성합니다.",
        requiresPassword: true,
        actionLabel: "문자링크 요청 들어가기",
        manager: SALES_PAYMENT_MANAGER,
      };
    }

    if (target === "debug") {
      return {
        label: "개발자 디버그",
        description: "개발자 비밀번호 입력 후 에러 로그 화면으로 이동합니다.",
        requiresPassword: true,
        actionLabel: "디버그 진입",
        manager: headquartersManager,
      };
    }

    return {
      label: "선택 안 됨",
      description: "본사 관리자 조회, 계약서 출력 및 다운로드 또는 개발자 디버그 중 하나를 먼저 선택해 주세요.",
      requiresPassword: false,
      actionLabel: "모드 선택 필요",
      manager: null,
    };
  };

  const getResolvedManagerTargetMeta = (target = managerTarget) => {
    const headquartersManager = resolveManagerByCode("default");

    if (target === "default") {
      return {
        matchedMode: "headquarters",
        label: "본사 관리자 조회",
        description: "관리자 비밀번호 입력 후 전체 계약을 조회합니다.",
        requiresPassword: true,
        actionLabel: "관리자 로그인",
        nextTab: "LIST",
        appliedFilter: "ALL",
        manager: headquartersManager,
      };
    }

    if (target === "field_print") {
      return {
        matchedMode: "field_print",
        label: "계약서 출력 및 다운로드",
        description: "본사 관리자 비밀번호 입력 후 빈 계약서를 출력하거나 PDF로 저장합니다.",
        requiresPassword: true,
        actionLabel: "계약서 출력 열기",
        nextTab: "LIST",
        appliedFilter: "NONE",
        manager: headquartersManager,
      };
    }

    if (target === "sales_lookup") {
      return {
        matchedMode: "sales_lookup",
        label: "영업 조회 로그인",
        description: "거래처 계약 작성 여부를 기본정보로만 조회합니다.",
        requiresPassword: true,
        actionLabel: "조회 화면 들어가기",
        nextTab: "SALES_SEARCH",
        appliedFilter: "SALES_LOOKUP",
        manager: SALES_LOOKUP_MANAGER,
      };
    }

    if (target === "payment") {
      return {
        matchedMode: "payment",
        label: "결제관리 전용",
        description: "문자링크, 키인 대기열, 등록카드 결제 화면만 관리합니다.",
        requiresPassword: true,
        actionLabel: "결제관리 들어가기",
        nextTab: "PAYMENT_MANAGEMENT",
        appliedFilter: "PAYMENT_ONLY",
        manager: PAYMENT_MANAGER,
      };
    }

    if (target === "sales_payment") {
      return {
        matchedMode: "sales_payment",
        label: "영업 문자링크 요청",
        description: "영업사원 코드와 개인 비밀번호로 로그인해 본인 담당 거래처의 문자링크만 생성합니다.",
        requiresPassword: true,
        actionLabel: "문자링크 요청 들어가기",
        nextTab: "PAYMENT_MANAGEMENT",
        appliedFilter: "SALES_PAYMENT_ONLY",
        manager: SALES_PAYMENT_MANAGER,
      };
    }

    if (target === "debug") {
      return {
        matchedMode: "debug",
        label: "개발자 디버그",
        description: "개발자 비밀번호 입력 후 에러 로그 화면으로 이동합니다.",
        requiresPassword: true,
        actionLabel: "디버그 진입",
        nextTab: "DEBUG",
        appliedFilter: "ERROR_REPORTS",
        manager: headquartersManager,
      };
    }

    return {
      matchedMode: null,
      label: "선택 필요",
      description: "본사 관리자 조회, 계약서 출력 및 다운로드 또는 개발자 디버그 중 하나를 먼저 선택해 주세요.",
      requiresPassword: false,
      actionLabel: "모드 선택 필요",
      nextTab: null,
      appliedFilter: null,
      manager: null,
    };
  };

  const getInitialManagerTarget = (mCode, list) => {
    return getInitialManagerTargetFromUrl(
      mCode,
      typeof window !== "undefined" ? window.location.pathname : ""
    );
  };

  const isIgnoredExternalRuntimeEvent = (event) => {
    const messageParts = [
      event?.message,
      event?.filename,
      event?.reason?.message,
      typeof event?.reason === "string" ? event.reason : "",
      event?.reason?.stack,
      event?.error?.message,
      event?.error?.stack,
    ].filter(Boolean);
    const mergedMessage = messageParts.join(" ");

    return /chrome-extension:\/\/|moz-extension:\/\/|MetaMask|Failed to connect to MetaMask/i.test(
      mergedMessage
    );
  };

  const suppressExternalRuntimeEvent = (event, label) => {
    if (!isIgnoredExternalRuntimeEvent(event)) return false;
    console.warn(`${label} ignored from browser extension`, event);
    event.preventDefault?.();
    event.stopImmediatePropagation?.();
    return true;
  };

  // [신규] 전역 에러 핸들링 (App 마운트 시 실행)
  useEffect(() => {
    const handleGlobalError = (event) => {
      if (suppressExternalRuntimeEvent(event, "global error")) return;
      if (isAdminViewMode(viewMode)) return;
      const detail = normalizeRuntimeError(event, {
        source: event?.filename,
        lineno: event?.lineno,
        colno: event?.colno,
      });
      const fingerprint = createRuntimeLogFingerprint({
        eventType: "JS_ERROR",
        message: detail?.message || event?.message || "",
        source: detail?.source || event?.filename || "",
        lineno: detail?.lineno || event?.lineno || "",
        colno: detail?.colno || event?.colno || "",
        viewMode,
        adminTab,
        step,
        draftId: contractDraftId,
        contractId: editModeId,
      });
      const lastSeenAt = runtimeLogFingerprintRef.current.get(fingerprint) || 0;
      if (lastSeenAt && Date.now() - lastSeenAt < 10 * 60 * 1000) return;
      runtimeLogFingerprintRef.current.set(fingerprint, Date.now());
      reportError("JS_ERROR", detail?.message || "runtime error", step, {
        ...detail,
        fingerprint,
        severity: "MEDIUM",
        viewMode,
        adminTab,
        draftId: contractDraftId,
        contractId: editModeId,
      });
    };
    const handlePromiseRejection = (event) => {
      if (suppressExternalRuntimeEvent(event, "promise rejection")) return;
      if (isAdminViewMode(viewMode)) return;
      const detail = normalizeRuntimeError(event.reason || event);
      const fingerprint = createRuntimeLogFingerprint({
        eventType: "PROMISE_REJECTION",
        message: detail?.message || "",
        viewMode,
        adminTab,
        step,
        draftId: contractDraftId,
        contractId: editModeId,
      });
      const lastSeenAt = runtimeLogFingerprintRef.current.get(fingerprint) || 0;
      if (lastSeenAt && Date.now() - lastSeenAt < 10 * 60 * 1000) return;
      runtimeLogFingerprintRef.current.set(fingerprint, Date.now());
      reportError("PROMISE_REJECTION", detail?.message || "promise rejection", step, {
        ...detail,
        fingerprint,
        severity: "MEDIUM",
        viewMode,
        adminTab,
        draftId: contractDraftId,
        contractId: editModeId,
      });
    };

    window.addEventListener("error", handleGlobalError, true);
    window.addEventListener("unhandledrejection", handlePromiseRejection, true);

    return () => {
      window.removeEventListener("error", handleGlobalError, true);
      window.removeEventListener("unhandledrejection", handlePromiseRejection, true);
    };
  }, [step, viewMode, adminTab, contractDraftId, editModeId]); // step이 바뀔 때마다 갱신하여 현재 step 기록

  useEffect(() => {
    return () => {
      if (legalEvidenceDownloadUrlRef.current) {
        URL.revokeObjectURL(legalEvidenceDownloadUrlRef.current);
        legalEvidenceDownloadUrlRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    void loadActiveContractTemplate({ silent: true });
  }, []);

  useEffect(() => {
    const loadScript = (id, src) => {
      if (!document.getElementById(id)) {
        const s = document.createElement("script");
        s.id = id;
        s.src = src;
        s.async = true;
        document.head.appendChild(s);
      }
    };
    loadScript(
      "daum-postcode",
      "//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js"
    );
    loadScript(
      "jspdf-cdn",
      "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js"
    );

    let disposed = false;
    const initAuth = async () => {
      try {
        if (typeof window !== "undefined" && window["__initial_auth_token"])
          await signInWithCustomToken(auth, window["__initial_auth_token"]);
        else await signInAnonymously(auth);
        return true;
      } catch (e) {
        console.error("[CNFOOD] auth init failed", sanitizeErrorForLog(e));
        return false;
      }
    };
    const unsubscribe = onAuthStateChanged(auth, (u) => setUser(u));

    const probeKcpIdentityProvider = async () => {
      try {
        const response = await fetch("/api/kcp/identity/status?probe=1");
        const result = await response.json().catch(() => null);
        setKcpAvailable(Boolean(response.ok && result?.kcpAvailable));
      } catch {
        setKcpAvailable(false);
      }
    };
    probeKcpIdentityProvider();

    // ── 검증 설정을 Firestore에서 동적 로드 (관리자 설정이 모든 기기에 반영) ──
    const loadServerValidationSettings = async () => {
      try {
        const snap = await getDoc(
          doc(db, "artifacts", appId, "config", "validation_settings")
        );
        if (!snap.exists()) {
          const defaultSettings = getDefaultValidationSettings();
          setValidationSettings(defaultSettings);
          setValidationSettingsDraft(defaultSettings);
          saveValidationSettings(defaultSettings);
          return;
        }
        const data = snap.data() || {};
        const serverSettings = normalizeValidationSettings(data);
        setValidationSettings(serverSettings);
        setValidationSettingsDraft(serverSettings);
        saveValidationSettings(serverSettings);
      } catch (e) {
        console.warn("[CNFOOD] validation settings server load failed", sanitizeErrorForLog(e));
      }
    };
    // ── 담당자 설정을 Firestore에서 동적 로드 ──
    // Firestore 콘솔에서 수정하면 코드 배포 없이 즉시 반영됨
    // 경로: artifacts/cnfood-final-v48/config/managers
    const loadManagers = async () => {
      try {
        const snap = await getDoc(
          doc(db, "artifacts", appId, "config", "managers")
        );
        if (snap.exists() && snap.data().list?.length > 0) {
          const list = snap.data().list;
          setManagersConfig(list);
          return list;
        }
        return MANAGER_CONFIG_DEFAULT;
      } catch (e) {
        console.error("managers config load failed, using defaults", sanitizeErrorForLog(e));
        return MANAGER_CONFIG_DEFAULT;
      }
    };

    const params = new URLSearchParams(window.location.search);
    const mCode = params.get("m");
    const loadId = params.get("id");
    const inviteToken = params.get("invite");
    const kcpSessionParam = params.get("kcpSessionId");
    const kcpResultParam = params.get("kcpResult");
    const kcpDraftParam = params.get("draftId");
    const kcpReasonParam = params.get("reason");
    const kcpSubjectTypeParam = params.get("subjectType");

    const applyManagerConfig = (list) => {
      if (disposed) return;
      const initialTarget = getInitialManagerTarget(mCode, list);
      setManagerTarget(initialTarget);

      if (!mCode && !initialTarget) {
        setCurrentManager({ name: "미지정", email: "" });
        return;
      }

      if (initialTarget) {
        const headquartersManager = resolveManagerByCode("default", list) || list[0];
        setCurrentManager(headquartersManager);
        setShowIntroPage(false);
        setViewMode("ADMIN_LOGIN");
        return;
      }

      setCurrentManager({ name: "미지정", email: "" });
      setShowIntroPage(false);
      setViewMode("ADMIN_LOGIN");
    };

    const bootstrapAuthenticatedConfig = async () => {
      const authenticated = await initAuth();
      if (disposed) return;
      if (!authenticated) {
        applyManagerConfig(MANAGER_CONFIG_DEFAULT);
        return;
      }
      await loadServerValidationSettings();
      if (disposed) return;
      applyManagerConfig(await loadManagers());
    };
    void bootstrapAuthenticatedConfig();

    const loadInvite = async (token) => {
      if (!token) return;
      try {
        const response = await fetch(
          `/api/contract-invite?${new URLSearchParams({ token, appId }).toString()}`
        );
        const result = await response.json().catch(() => ({
          ok: false,
          message: "초대 링크를 불러오지 못했습니다.",
        }));

        if (!response.ok || !result?.ok) {
          setInviteLoadMessage(
            result?.message || "초대 링크를 불러오지 못했습니다."
          );
          return;
        }

        const openedInvite = { ...(result.invite || {}), token };
        setActiveInvite(openedInvite);
        setInviteLoadMessage(result.message || "");
        if (result.message) return;

        setFormData((prev) => ({
          ...prev,
          agentName: prev.agentName || openedInvite.customerName || "",
          agentBizNo: prev.agentBizNo || openedInvite.businessNumber || "",
          agentContact:
            prev.agentContact ||
            formatPhoneNumberForDisplay(
              openedInvite.customerPhone || openedInvite.contactPhone || ""
            ) ||
            "",
        }));
        setBizType(
          openedInvite.businessType === "corporate" ? "CORPORATE" : "INDIVIDUAL"
        );
      } catch (error) {
        console.error("[CNFOOD] invite load failed", sanitizeErrorForLog(error));
        setInviteLoadMessage("초대 링크를 불러오지 못했습니다.");
        reportError("INVITE_LOAD_FAILED", error?.message || "invite load failed", 0);
      }
    };

    if (!isCorepInviteRoute) {
      loadInvite(inviteToken);
    }
    if (!isCorepInviteRoute && (kcpSessionParam || kcpResultParam)) {
      void handleKcpReturnPayload({
        result: kcpResultParam || "",
        kcpSessionId: kcpSessionParam || "",
        draftId: kcpDraftParam || "",
        reason: kcpReasonParam || "",
        subjectType: kcpSubjectTypeParam || "",
      });
    }

    if (loadId) {
      setShowIntroPage(false);
      setLoading(true);
      setEditModeId(loadId);
      getDoc(
        doc(db, "artifacts", appId, "public", "data", "contracts", loadId)
      ).then((docSnap) => {
        if (docSnap.exists()) {
          const data = docSnap.data();
          setFormData((prev) => ({ ...prev, ...data }));
          setPhoneVerified(
            (data.verificationMethod === "sms_otp" ||
              data.verificationMethod === "kcp_mobile_identity") &&
              data.phoneVerified === true &&
              Boolean(data.phoneVerifiedAt)
          );
          setPhoneVerifiedAt(data.phoneVerifiedAt || null);
          setContractReviewedAt(data.contractReviewedAt || null);
          setSignatureCompletedAt(data.signatureCompletedAt || null);
          setHasContractAuthority(data.hasContractAuthority === true);
          setRepresentativePersonalGuaranteeAgreed(
            data.representativePersonalGuarantee?.agreed === true
          );
          setContractAgreed(data.hasReadAndAgreedContract === true);
          if (data.bizType) setBizType(data.bizType);
          if (data.contractDate) {
            const parts = data.contractDate.split("-");
            setSelYear(parseInt(parts[0]));
            setSelMonth(parseInt(parts[1]));
            setSelDay(parseInt(parts[2]));
          }
          if (data.auditTrail) auditLogsRef.current = data.auditTrail;
          if (isCompletedOrLockedContract(data)) {
            setLastSubmittedContractData(data);
            setToastMessage("이미 완료된 계약입니다.");
            generateContractImage(
              data.signature,
              data.contractId,
              "CUSTOMER",
              data,
              data.signature2
            ).then((img) => {
              if (img) setFinalContractImage(img);
            });
            goToStep(5);
            setLoading(false);
            return;
          }
          setToastMessage(
            "기존 정보를 불러왔습니다. 수정 후 다시 서명해주세요."
          );
        }
        setLoading(false);
      });
    }

    createLog("문서 열람", "계약서 최초 접속").then((log) =>
      auditLogsRef.current.push(log)
    );

    return () => {
      disposed = true;
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (viewMode === "LIST") {
      setValidationSettingsDraft(validationSettings);
    }
  }, [viewMode, validationSettings]);

  useEffect(() => {
    if (viewMode === "LIST") {
      loadNotificationSettings({ silent: true });
      loadSalesReps({ silent: true });
    }
  }, [viewMode]);

  useEffect(() => {
    if (viewMode === "LIST" && adminTab === "SETTINGS") {
      void requestContractAppStatus({ includeInternal: true, silent: true });
    }
  }, [viewMode, adminTab]);

  useEffect(() => {
    if (adminTab !== "PAYMENT_MANAGEMENT") {
      setSensitiveCardInput(createEmptySensitiveCardInput());
      setActivePaymentQueueItemId("");
    }
  }, [adminTab]);

  useEffect(() => {
    const handleOffline = () => {
      setToastMessage("오프라인 상태입니다. 네트워크 연결 후 다시 시도해 주세요.");
      offlineStartedAtRef.current = Date.now();
      if (offlineLogTimerRef.current) {
        window.clearTimeout(offlineLogTimerRef.current);
      }
      offlineLogTimerRef.current = window.setTimeout(() => {
        const startedAt = offlineStartedAtRef.current || Date.now();
        const offlineDurationMs = Date.now() - startedAt;
        const visibilityState =
          typeof document !== "undefined" ? document.visibilityState : "visible";
        const wasCriticalActionInProgress =
          loading || isSubmittingFinal || kcpLoading || userErrorReportSaving;
        const decision = shouldPersistNetworkOfflineLog({
          viewMode,
          adminTab,
          step,
          draftId: contractDraftId,
          contractId: editModeId,
          visibilityState,
          offlineDurationMs,
          wasCriticalActionInProgress,
          seenFingerprints: runtimeLogFingerprintRef.current,
        });
        if (!decision.persist) return;
        reportError("NETWORK_OFFLINE", "browser went offline", step, {
          eventType: "NETWORK_OFFLINE",
          severity: decision.severity,
          viewMode,
          adminTab,
          draftId: contractDraftId,
          contractId: editModeId,
          visibilityState,
          isAdminView: isAdminViewMode(viewMode),
          wasCriticalActionInProgress,
          offlineDurationMs,
          fingerprint: decision.fingerprint,
          userAgent: typeof navigator !== "undefined" ? navigator.userAgent : "",
          screen:
            typeof window !== "undefined"
              ? `${window.innerWidth}x${window.innerHeight}`
              : "",
          createdAt: new Date().toISOString(),
        });
      }, 3000);
    };
    const handleOnline = () => {
      if (offlineLogTimerRef.current) {
        window.clearTimeout(offlineLogTimerRef.current);
        offlineLogTimerRef.current = null;
      }
      offlineStartedAtRef.current = null;
      setToastMessage("네트워크가 복구되었습니다.");
    };
    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);
    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
      if (offlineLogTimerRef.current) {
        window.clearTimeout(offlineLogTimerRef.current);
        offlineLogTimerRef.current = null;
      }
    };
  }, [
    step,
    viewMode,
    adminTab,
    contractDraftId,
    editModeId,
    loading,
    isSubmittingFinal,
    kcpLoading,
    userErrorReportSaving,
    isCorepInviteRoute,
  ]);

  useEffect(() => {
    return () => {
      clearRecaptchaVerifier();
    };
  }, []);

  // 주소 검색 실행
  // 서명 캔버스 초기화: step 3 진입 시 흰 배경 강제 적용 (iOS/Android 블랙스크린 방지)
  useEffect(() => {
    if (step !== 3) return;
    const initCanvas = (canvas: HTMLCanvasElement | null) => {
      if (!canvas) return;
      const ctx = canvas.getContext("2d", { willReadFrequently: true });
      if (!ctx) return;
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
    };
    // DOM 렌더 완료 후 실행
    const timer = setTimeout(() => {
      initCanvas(canvasRef.current);
      initCanvas(canvasRef2.current);
    }, 50);
    return () => clearTimeout(timer);
  }, [step]);

  useEffect(() => {
    if (showAddressModal && postcodeContainerRef.current) {
      let cancelled = false;
      let postcodeLoadAttempts = 0;
      const runPostcode = () => {
        if (cancelled) return;
        if (window.daum && window.daum.Postcode) {
          postcodeContainerRef.current.innerHTML = "";
          new window.daum.Postcode({
            oncomplete: function (data) {
              let fullAddr = data.address;
              let extraAddr = "";
              if (data.addressType === "R") {
                if (data.bname !== "") extraAddr += data.bname;
                if (data.buildingName !== "")
                  extraAddr +=
                    extraAddr !== ""
                      ? `, ${data.buildingName}`
                      : data.buildingName;
                fullAddr += extraAddr !== "" ? ` (${extraAddr})` : "";
              }
              const finalAddress = `[${data.zonecode}] ${fullAddr}`;
              if (addressTarget === "corp") {
                setFormData((prev) => ({ ...prev, corpRepAddress: finalAddress }));
                setErrors((prev) => ({ ...prev, corpRepAddress: "" }));
              } else if (addressTarget === "coRep" && coRepAddressTargetId) {
                setCoRepresentatives((prev) =>
                  prev.map((item) => {
                    if (item.id !== coRepAddressTargetId) return item;
                    if (isCoRepresentativeIdentityMatched(item)) return item;
                    const shouldResetIdentity =
                      item.identityVerification || item.kcpStatus === "MATCHED";
                    return {
                      ...item,
                      homeAddress: finalAddress,
                      ...(shouldResetIdentity
                        ? {
                            kcpSessionId: "",
                            kcpStatus: "PENDING",
                            identityStatus: "PENDING",
                            identityVerification: null,
                            delegatedSignatureConsent: {
                              ...item.delegatedSignatureConsent,
                              agreed: false,
                              agreedAt: null,
                              principalSignerName: "",
                            },
                            signatureStatus: "PENDING",
                            signedAt: null,
                          }
                        : {}),
                    };
                  })
                );
                setActiveCoRepHelpKey(`${coRepAddressTargetId}:homeAddressDetail`);
              } else {
                setFormData((prev) => ({ ...prev, agentAddress: finalAddress }));
                setErrors((prev) => ({ ...prev, agentAddress: "" }));
              }
              setShowAddressModal(false);
              if (addressTarget === "coRep") {
                setCoRepAddressTargetId("");
              } else {
                setTimeout(() => {
                  if (detailAddrRef.current) detailAddrRef.current.focus();
                }, 100);
              }
            },
            width: "100%",
            height: "100%",
            animation: false,
          }).embed(postcodeContainerRef.current);
        } else {
          postcodeLoadAttempts += 1;
          if (postcodeLoadAttempts >= 30) {
            const message =
              "주소검색 창이 열리지 않았습니다. 브라우저 팝업 차단을 확인하거나 주소를 직접 입력해 주세요.";
            setToastMessage(message);
            openErrorHelpModal(ERROR_HELP_GUIDES.ADDRESS_SEARCH_FAILED, {
              errorCode: "DAUM_POSTCODE_LOAD_FAILED",
            });
            return;
          }
          setTimeout(runPostcode, 100);
        }
      };
      runPostcode();
      return () => {
        cancelled = true;
      };
    }
  }, [showAddressModal, addressTarget, coRepAddressTargetId]);

  useEffect(() => {
    if (step !== 2) return;

    const checkContractScrollGate = () => {
      const container = contractPreviewRef.current;
      if (!container) return;

      const isScrollable = container.scrollHeight > container.clientHeight + 4;

      if (!isScrollable) {
        markContractScrolled90();
        return;
      }

      if (contractScrolled) return;

      const reachedBottom =
        container.scrollTop + container.clientHeight >= container.scrollHeight * 0.9;

      if (reachedBottom) {
        markContractScrolled90();
      }
    };

    const timer = window.setTimeout(checkContractScrollGate, 0);
    window.addEventListener("resize", checkContractScrollGate);

    return () => {
      window.clearTimeout(timer);
      window.removeEventListener("resize", checkContractScrollGate);
    };
  }, [step, contractScrolled]);

  /* ================= 핸들러 ================= */
  // [신규] 에러 리포트 가져오기
  const switchToAdminListView = (list = []) => {
    setContractList(list);
    setCurrentPage(1);
    setPendingConfirm(null);
    resetDetailRejectState();
    console.info("[CNFOOD] fetchAndShowList switching to LIST");
    setViewMode("LIST");
    setAdminTab(getDefaultAdminTabForViewport());
  };

  const switchToDebugView = (logs = []) => {
    setErrorReports(logs);
    console.info("[CNFOOD] fetchErrorReports switching to DEBUG");
    setViewMode("DEBUG");
  };

  const fetchErrorReports = async () => {
    setLoadingContext("debug");
    setLoading(true);
    try {
      const q = query(
        collection(db, "artifacts", appId, "error_reports"),
        orderBy("timestamp", "desc"),
        limit(50)
      );
      const querySnapshot = await getDocs(q);
      const logs = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...sanitizeLogDetail(doc.data()),
      }));
      switchToDebugView(logs);
    } catch (e) {
      console.error("[CNFOOD] fetchErrorReports failed", {
        path: "artifacts/cnfood-final-v48/error_reports",
        error: sanitizeErrorForLog(e),
      });
      setToastMessage(
        getFirestoreErrorToastMessage(e, "에러 로그를 불러오지 못했습니다.")
      );
      setErrorReports([]);
      setViewMode("DEBUG");
    } finally {
      setLoading(false);
      setLoadingContext(null);
      setAdminPassword("");
    }
  };

  const openConfirmPanel = ({
    scope,
    title,
    message,
    confirmLabel = "확인",
    cancelLabel = "취소",
    tone = "warning",
    scrollToTop = false,
    onConfirm,
  }) => {
    setPendingConfirm({
      scope,
      title,
      message,
      confirmLabel,
      cancelLabel,
      tone,
      onConfirm,
    });
    const scrollOptions = getPendingConfirmScrollOptions({
      scope,
      scrollToTop,
    });
    if (
      scrollOptions &&
      typeof window !== "undefined" &&
      typeof window.scrollTo === "function"
    ) {
      const scrollToConfirmPanel = () => {
        try {
          window.scrollTo(scrollOptions);
        } catch {
          window.scrollTo(0, 0);
        }
      };
      if (typeof window.requestAnimationFrame === "function") {
        window.requestAnimationFrame(scrollToConfirmPanel);
      } else {
        window.setTimeout(scrollToConfirmPanel, 0);
      }
    }
  };

  const closeConfirmPanel = () => {
    if (confirmLoading) return;
    setPendingConfirm(null);
  };

  const handlePendingConfirm = async () => {
    if (!pendingConfirm?.onConfirm || confirmLoading) return;
    setConfirmLoading(true);
    try {
      await pendingConfirm.onConfirm();
    } finally {
      setConfirmLoading(false);
      setPendingConfirm(null);
    }
  };

  const renderPendingConfirmPanel = (scope) => {
    if (!pendingConfirm || pendingConfirm.scope !== scope) return null;
    return (
      <ConfirmPanel
        title={pendingConfirm.title}
        message={pendingConfirm.message}
        confirmLabel={pendingConfirm.confirmLabel}
        cancelLabel={pendingConfirm.cancelLabel}
        tone={pendingConfirm.tone}
        busy={confirmLoading}
        onConfirm={handlePendingConfirm}
        onCancel={closeConfirmPanel}
      />
    );
  };

  const handleNextStepFromInfo = async () => {
    const issues = validateStep0RequiredFields({
      formData,
      bizType,
      isSameDayDeposit,
      manualAddressMode,
      validationSettings,
    });
    const newErrors = issues.reduce((acc, issue) => {
      acc[issue.fieldId] = issue.message;
      return acc;
    }, {});
    setErrors(newErrors);
    if (issues.length > 0) {
      focusValidationIssue(issues[0]);
      return;
    }
    setActiveValidationIssue(null);
    const ntsMode = getNtsBusinessVerificationMode(validationSettings);

    if (!shouldRunNtsBusinessVerification(validationSettings)) {
      const disabledBusinessVerification = buildNtsDisabledBusinessVerification({
        formData,
      });
      setBusinessVerification(disabledBusinessVerification);
      setCoRepresentativeNtsInfo(null);
      setToastMessage(
        "현재 국세청 사업자 진위확인은 관리자 설정에 따라 사용하지 않습니다."
      );
      queueDraftCreatedEvent();
      goToStep(1);
      return;
    }

    setLoading(true);
    try {
      const result = await verifyBusinessWithNts({ formData });
      const nextBusinessVerification = result.businessVerification;
      setBusinessVerification(nextBusinessVerification);
      if (nextBusinessVerification?.statusCheck?.attempted) {
        const ntsCoRepresentativeInfo =
          deriveCoRepresentativeInfoFromNtsBusinessStatus({
            data: [
              {
                businessStatus:
                  nextBusinessVerification.statusCheck.businessStatus,
                taxType: nextBusinessVerification.statusCheck.taxType,
              },
            ],
          });
        setCoRepresentativeNtsInfo(ntsCoRepresentativeInfo);
        if (shouldShowCoRepresentativeGuidance(ntsCoRepresentativeInfo)) {
          setToastMessage(CO_REPRESENTATIVE_NOTICE_TEXT);
        }
      }
      if (!result.ok) {
        if (ntsMode === "MANUAL_REVIEW") {
          const manualReviewBusinessVerification =
            buildNtsManualReviewBusinessVerification({
              formData,
              sourceVerification: nextBusinessVerification,
            });
          setBusinessVerification(manualReviewBusinessVerification);
          setToastMessage(
            "사업자 정보가 국세청 정보와 바로 일치하지 않습니다. 본사 확인 필요 상태로 계속 진행합니다."
          );
          queueDraftCreatedEvent();
          goToStep(1);
          return;
        }
        const message =
          nextBusinessVerification?.status === "FAILED"
            ? "국세청 확인이 일시적으로 지연됩니다. 본사 확인이 필요할 수 있습니다."
            : "사업자번호, 대표자명 또는 개업일자가 국세청 등록정보와 일치하지 않습니다.";
        setToastMessage(message);
        openErrorHelpModal(ERROR_HELP_GUIDES.NTS_VERIFICATION_FAILED, {
          message,
          errorCode: nextBusinessVerification?.status || "NTS_MISMATCH",
        });
        setErrors((prev) => ({
          ...prev,
          agentBizNo: message,
          agentRep: message,
          openingDate: message,
        }));
        focusValidationIssue(createValidationIssue("openingDate", message));
        return;
      }
      setToastMessage("국세청 사업자 진위확인이 완료되었습니다.");
      queueDraftCreatedEvent();
      goToStep(1);
    } catch (e) {
      console.error("[CNFOOD] biz check failed", sanitizeErrorForLog(e));
      reportError("BIZ_CHECK_ERROR", e.message, 0); // [신규] 에러 로깅
      const message = "국세청 확인이 일시적으로 지연됩니다. 본사 확인이 필요할 수 있습니다.";
      if (ntsMode === "MANUAL_REVIEW") {
        const manualReviewBusinessVerification =
          buildNtsManualReviewBusinessVerification({
            formData,
            message,
          });
        setBusinessVerification(manualReviewBusinessVerification);
        setToastMessage(
          "국세청 확인이 지연되어 본사 확인 필요 상태로 계속 진행합니다."
        );
        queueDraftCreatedEvent();
        goToStep(1);
        return;
      }
      setBusinessVerification({
        provider: "NTS",
        checkedAt: new Date().toISOString(),
        status: "FAILED",
        businessNumber: normalizeBusinessNumber(formData.agentBizNo || ""),
        representativeName: String(formData.agentRep || "").trim(),
        openingDate: formatOpeningDateForNts(formData.openingDate || ""),
        validationCheck: {
          attempted: true,
          valid: null,
          message,
          rawStatusCode: "",
        },
        statusCheck: {
          attempted: false,
          businessStatus: "",
          taxType: "",
          closedDate: "",
        },
      });
      setToastMessage(message);
      openErrorHelpModal(ERROR_HELP_GUIDES.NTS_VERIFICATION_FAILED, {
        message,
        errorCode: "NTS_FAILED",
      });
    } finally {
      setLoading(false);
    }
  };

  const enableSmsFallbackAfterKcpFailure = (
    reason: KcpFallbackReason,
    toastMessage = "KCP 본인확인을 시작하지 못했습니다. 문자 인증으로 계속 진행해 주세요.",
    detailCode = reason
  ) => {
    const phoneMasked = maskPhoneNumber(getOtpPhoneNumberFromForm(formData));
    clearActiveKcpReturnNavigationIntent();
    clearKcpVerifiedNavigationRetry();
    setPrincipalKcpReturnSyncState(KCP_RETURN_SYNC_STATES.FAILED, {
      source: "kcp-fallback",
      force: true,
    });
    setPrincipalKcpLaunchUiState(KCP_LAUNCH_UI_STATES.FAILED);
    setKcpFallbackReason(reason);
    setSmsFallbackSelected(false);
    setKcpIdentityStatus("FAILED");
    setKcpRepresentativeMatchStatus("PENDING_KCP");
    setKcpIdentityEvidence(null);
    setPhoneVerified(false);
    setPhoneVerifiedAt(null);
    setOtpSent(false);
    setOtpCode("");
    confirmationResultRef.current = null;
    setOtpError(
      `통신사 본인확인을 완료하지 못했습니다. 다시 시도하거나 문자 인증으로 계속 진행할 수 있습니다. (오류코드: ${detailCode})`
    );
    setToastMessage(toastMessage);
    openErrorHelpModal(
      reason === "KCP_TIMEOUT"
        ? ERROR_HELP_GUIDES.KCP_TIMEOUT
        : ERROR_HELP_GUIDES.KCP_POPUP_BLOCKED,
      {
        message:
          reason === "KCP_TIMEOUT"
            ? ERROR_HELP_GUIDES.KCP_TIMEOUT.message
            : toastMessage,
        errorCode: detailCode,
      }
    );
    queueContractEvent(
      reason === "KCP_TIMEOUT"
        ? "KCP_IDENTITY_TIMEOUT"
        : "KCP_IDENTITY_START_FAILED",
      {
        reason,
        provider: "KCP",
        phoneMasked,
      }
    );
  };

  const handleSelectSmsFallback = () => {
    const reason = kcpFallbackReason || "KCP_UNKNOWN_ERROR";
    const phoneMasked = maskPhoneNumber(getOtpPhoneNumberFromForm(formData));
    setSmsFallbackSelected(true);
    setOtpError("");
    setOtpSent(false);
    setOtpCode("");
    confirmationResultRef.current = null;
    setToastMessage("문자 인증으로 계속 진행합니다. 인증번호를 발송해 주세요.");
    queueContractEvent("SMS_FALLBACK_ENABLED", {
      reason,
      provider: "FIREBASE_SMS",
      phoneMasked,
    });
  };

  const applyKcpVerifiedIdentityResult = (result = {}) => {
    if (result.subjectType === "CO_REP") {
      return applyCoRepresentativeKcpResult(result);
    }
    const verifiedAt = result.verifiedAt || new Date().toISOString();
    const previousVerifiedStatus = lastVerifiedPrincipalKcpRef.current;
    const previousRepresentativeIdentity =
      previousVerifiedStatus?.representativeIdentityVerification || null;
    let nextRepresentativeIdentity =
      result.representativeIdentityVerification ||
      buildRepresentativeIdentityVerification({
        input: {
          representativeName: formData.agentRep,
          birthDate: formData.representativeBirthDate,
          principalRepSsnFront: formData.principalRepSsnFront || formData.ssnFront,
          principalRepSsnBack: formData.principalRepSsnBack || formData.ssnBack,
          phone: formData.agentContact,
          businessNumber: formData.agentBizNo,
        },
        kcp: {
          verifiedName: result.verifiedName,
          phoneMasked: result.phoneMasked,
        },
        verifiedAt,
      });
    if (
      !isRepresentativeIdentityMatched(nextRepresentativeIdentity) &&
      isRepresentativeIdentityMatched(previousRepresentativeIdentity) &&
      isSameKcpSession(
        result.sessionId || kcpSessionId,
        previousVerifiedStatus?.sessionId || ""
      )
    ) {
      nextRepresentativeIdentity = previousRepresentativeIdentity;
      queueContractEvent("KCP_LOOP_GUARD_TRIGGERED", {
        reason: "VERIFIED_DOWNGRADE_BLOCKED",
        sessionId: result.sessionId || kcpSessionId || null,
      });
    }
    setRepresentativeIdentityVerification(nextRepresentativeIdentity);
    setKcpRepresentativeMatchStatus(
      nextRepresentativeIdentity.status || result.representativeMatchStatus || "PENDING"
    );
    setKcpIdentityEvidence({
      ...result,
      representativeIdentityVerification: nextRepresentativeIdentity,
    });
    setKcpFallbackReason(null);
    setSmsFallbackSelected(false);

    if (isRepresentativeIdentityMatched(nextRepresentativeIdentity)) {
      kcpVerifiedGraceUntilRef.current = Date.now() + KCP_VERIFIED_GRACE_MS;
      setPrincipalKcpLaunchUiState(KCP_LAUNCH_UI_STATES.VERIFIED);
      lastVerifiedPrincipalKcpRef.current = {
        ...(result || {}),
        status: "VERIFIED",
        sessionId: result.sessionId || kcpSessionId || "",
        representativeIdentityVerification: nextRepresentativeIdentity,
        verifiedAt,
      };
      if (result.sessionId || kcpSessionId) {
        saveKcpSessionPointer({
          draftId: contractDraftId,
          kcpSessionId: result.sessionId || kcpSessionId,
          updatedAt: verifiedAt,
        });
      }
      setPhoneVerified(true);
      setPhoneVerifiedAt((prev) => prev || verifiedAt);
      setLockedIdentityFields(
        buildLockedIdentityFieldsSnapshot({
          formData: formDataRef.current,
          lockedAt: verifiedAt,
        })
      );
      queueContractEvent("PHONE_OTP_VERIFIED", {
        method: "kcp_mobile_identity",
        phoneMasked: result.phoneMasked || maskPhoneNumber(formDataRef.current.agentContact),
      });
      setToastMessage("대표자 본인확인이 완료되었습니다.");
      setOtpError("");
      return true;
    }

    if (result.status === "VERIFIED" && !result.representativeIdentityVerification) {
      setOtpError(KCP_STATUS_REFRESH_MESSAGE);
      setToastMessage(KCP_STATUS_REFRESH_MESSAGE);
      queueContractEvent("KCP_STATUS_REHYDRATED", {
        status: "STALE",
        reason: "MISSING_REPRESENTATIVE_IDENTITY_SNAPSHOT",
        sessionId: result.sessionId || kcpSessionId || null,
      });
      return false;
    }

    setPhoneVerified(false);
    setPhoneVerifiedAt(null);
    setLockedIdentityFields(null);
    const message = getRepresentativeIdentityMismatchMessage(
      nextRepresentativeIdentity.mismatchReason
    );
    setOtpError(`대표자 본인 확인 불일치: ${message}`);
    setToastMessage(message);
    openErrorHelpModal(ERROR_HELP_GUIDES.KCP_IDENTITY_MISMATCH, {
      message,
      errorCode: nextRepresentativeIdentity.mismatchReason || "KCP_IDENTITY_MISMATCH",
    });
    return false;
  };

  const applyCoRepresentativeKcpResult = (result = {}) => {
    const coRepresentativeId =
      result.coRepresentativeId ||
      result.representativeIdentityVerification?.coRepresentativeId ||
      "";
    const verifiedAt = result.verifiedAt || new Date().toISOString();
    let matched = false;
    setCoRepresentatives((prev) =>
      prev.map((item) => {
        if (item.id !== coRepresentativeId) return item;
        const verification =
          result.representativeIdentityVerification ||
          buildCoRepresentativeIdentityVerification({
            input: {
              id: item.id,
              name: item.name,
              ssnFront: item.ssnFront || item.birthDate,
              ssnBack: item.ssnBack,
              phone: item.phone,
              businessNumber: formData.agentBizNo,
            },
            kcp: {
              verifiedName: result.verifiedName,
              phoneMasked: result.phoneMasked,
              ciHash: result.ciHash,
              diHash: result.diHash,
              ciHmac: result.ciHmac,
              diHmac: result.diHmac,
              hasCi: result.hasCi,
              hasDi: result.hasDi,
            },
            coRepresentativeId: item.id,
            verifiedAt,
          });
        matched = isRepresentativeIdentityMatched(verification);
        return {
          ...item,
          kcpSessionId: result.sessionId || item.kcpSessionId || "",
          kcpStatus: verification.status || "PENDING",
          identityStatus: matched ? "VERIFIED" : "MISMATCHED",
          identityVerification: verification,
          ntsStatus: item.ntsStatus || "NTS_NOT_SUPPORTED_OR_MANUAL_REVIEW",
        };
      })
    );
    setKcpIdentityEvidence((prev) => ({
      ...(prev || {}),
      lastCoRepresentativeSessionId: result.sessionId || "",
    }));
    if (matched) {
      setToastMessage("공동계약인 본인확인이 완료되었습니다. 선택한 서명 방식을 완료해 주세요.");
      setOtpError("");
      return true;
    }
    const message = getRepresentativeIdentityMismatchMessage(
      result.representativeIdentityVerification?.mismatchReason
    );
    setToastMessage(`공동계약인 본인확인 불일치: ${message}`);
    setOtpError(`공동계약인 본인확인 불일치: ${message}`);
    openErrorHelpModal(ERROR_HELP_GUIDES.CO_REPRESENTATIVE_KCP_REQUIRED, {
      message: `공동계약인 본인확인 불일치: ${message}`,
      errorCode:
        result.representativeIdentityVerification?.mismatchReason ||
        "CO_REPRESENTATIVE_KCP_MISMATCH",
    });
    return false;
  };

  const canUseStoredKcpReturnState = () =>
    Boolean(
      kcpReturnNavigationIntentActive ||
        loadKcpReturnNavigationIntent() ||
        kcpReturnSyncStateRef.current === KCP_RETURN_SYNC_STATES.CHECKING_STATUS
    );

  const loadKcpDraftRestoreStateForReturn = (draftId = "") => {
    const strictState = loadKcpDraftRestoreState(draftId || contractDraftId);
    if (strictState) return strictState;
    return canUseStoredKcpReturnState() ? loadKcpDraftRestoreState("") : null;
  };

  const loadKcpSessionPointerForReturn = (draftId = "") => {
    const strictPointer = loadKcpSessionPointer(draftId || contractDraftId);
    if (strictPointer) return strictPointer;
    return canUseStoredKcpReturnState() ? loadKcpSessionPointer("") : null;
  };

  const loadKcpIdentityStatus = async (
    sessionId = "",
    draftId = "",
    { source = "manual", preserveVerified = true } = {}
  ) => {
    const pointer = loadKcpSessionPointerForReturn(draftId || contractDraftId);
    const effectiveSessionId = sessionId || pointer?.kcpSessionId || "";
    const effectiveDraftId = draftId || pointer?.draftId || contractDraftId || "";
    if (!effectiveSessionId && !effectiveDraftId) return null;
    try {
      const params = new URLSearchParams({ appId });
      if (effectiveSessionId) params.set("sessionId", effectiveSessionId);
      if (effectiveDraftId) params.set("draftId", effectiveDraftId);
      const response = await fetch(
        `/api/kcp/identity/status?${params.toString()}`
      );
      const result = await response.json().catch(() => null);
      if (!response.ok || !result?.ok) {
        const readiness = resolveKcpIdentityReadiness({
          kcpStatus: kcpIdentityStatus,
          representativeIdentityVerification,
          phoneVerified,
          kcpSessionId: effectiveSessionId,
          latestStatusResponse: result,
          previousVerifiedStatus: preserveVerified
            ? lastVerifiedPrincipalKcpRef.current
            : null,
        });
        if (!readiness.canProceed && result?.status) setKcpIdentityStatus(result.status);
        if (readiness.requiresStatusRefresh) {
          setOtpError(KCP_STATUS_RECHECK_MESSAGE);
        }
        return result || {
          ok: false,
          code: "KCP_STATUS_FAILED",
          draftId: effectiveDraftId,
        };
      }

      if (result.subjectType === "CO_REP") {
        if (result.status === "VERIFIED") {
          applyCoRepresentativeKcpResult(result);
        }
        return result;
      }

      const readiness = resolveKcpIdentityReadiness({
        kcpStatus: kcpIdentityStatus,
        representativeIdentityVerification,
        phoneVerified,
        kcpSessionId: effectiveSessionId,
        latestStatusResponse: result,
        previousVerifiedStatus: preserveVerified
          ? lastVerifiedPrincipalKcpRef.current
          : null,
      });
      if (
        readiness.canProceed &&
        (readiness.source === "PREVIOUS_VERIFIED" ||
          readiness.reason === "VERIFIED_DOWNGRADE_BLOCKED") &&
        result.status !== "VERIFIED"
      ) {
        setKcpIdentityStatus("VERIFIED");
        setRepresentativeIdentityVerification(
          readiness.representativeIdentityVerification
        );
        setKcpRepresentativeMatchStatus("MATCHED");
        setPhoneVerified(true);
        setPhoneVerifiedAt((prev) => prev || new Date().toISOString());
        queueContractEvent("KCP_LOOP_GUARD_TRIGGERED", {
          source,
          status: result.status || null,
          sessionId: effectiveSessionId || null,
        });
        return {
          ...result,
          status: "VERIFIED",
          representativeIdentityVerification:
            readiness.representativeIdentityVerification,
          restoredFromPreviousVerified: true,
        };
      }

      setKcpIdentityStatus(result.status || "");
      setKcpVerifiedName(result.verifiedName || "");
      setKcpPhoneMasked(result.phoneMasked || "");
      setKcpRepresentativeMatchStatus(
        result.representativeMatchStatus || "NOT_AVAILABLE"
      );

      if (result.status === "VERIFIED") {
        const applied = applyKcpVerifiedIdentityResult(result);
        if (applied) {
          queueContractEvent("KCP_STATUS_REHYDRATED", {
            source,
            sessionId: result.sessionId || effectiveSessionId || null,
          });
        }
      } else if (result.status === "FAILED") {
        setKcpIdentityStatus("FAILED");
        setKcpIdentityEvidence(null);
        return result;
      }
      return result;
    } catch (error) {
      console.error("[CNFOOD] KCP status failed", sanitizeErrorForLog(error));
      return {
        ok: false,
        code: "KCP_STATUS_FAILED",
        draftId: effectiveDraftId,
      };
    }
  };

  const getKcpIdentityStatusLookupTarget = () => {
    const restoreState = loadKcpDraftRestoreStateForReturn(contractDraftId);
    const pointer = loadKcpSessionPointerForReturn(contractDraftId);
    return {
      sessionId:
        kcpSessionId ||
        restoreState?.kcpSessionId ||
        pointer?.kcpSessionId ||
        "",
      draftId:
        restoreState?.draftId ||
        pointer?.draftId ||
        contractDraftId ||
        "",
    };
  };

  const refreshKcpIdentityStatus = async ({
    source = "manual",
    force = false,
  } = {}) => {
    const target = getKcpIdentityStatusLookupTarget();
    if (!target.sessionId && !target.draftId) return null;
    const now = Date.now();
    if (!force && kcpStatusSyncInFlightRef.current) {
      return kcpStatusSyncInFlightRef.current;
    }
    if (!force && now - kcpStatusSyncLastRunRef.current < 1500) {
      return null;
    }
    kcpStatusSyncLastRunRef.current = now;
    const requestSeq = kcpStatusSyncSeqRef.current + 1;
    kcpStatusSyncSeqRef.current = requestSeq;
    const syncPromise = loadKcpIdentityStatus(target.sessionId, target.draftId, {
      source,
      preserveVerified: true,
    }).then((result) => {
      if (requestSeq !== kcpStatusSyncSeqRef.current) return result;
      if (result?.sessionId && result.sessionId !== kcpSessionId) {
        setKcpSessionId(result.sessionId);
      }
      if (result?.status === "VERIFIED") {
        const statusDraftState = normalizeKcpDraftRestoreState(result?.draft);
        const readiness = resolveKcpIdentityReadiness({
          kcpStatus: result.status,
          representativeIdentityVerification:
            result.representativeIdentityVerification ||
            representativeIdentityVerification,
          phoneVerified,
          kcpSessionId: result.sessionId || target.sessionId,
          latestStatusResponse: result,
          previousVerifiedStatus: lastVerifiedPrincipalKcpRef.current,
        });
        if (
          shouldClearKcpReturnCheckingAfterVerifiedStatus({
            kcpReturnSyncState: kcpReturnSyncStateRef.current,
            status: result.status,
            canProceed: readiness.canProceed,
          })
        ) {
          setPrincipalKcpReturnSyncState(KCP_RETURN_SYNC_STATES.VERIFIED, {
            source,
            targetStep: getPostKcpVerifiedTargetStep({
              step0Issues: getKcpReturnStep0Issues(statusDraftState),
              representativeMatched: isRepresentativeIdentityMatched(
                readiness.representativeIdentityVerification ||
                  result.representativeIdentityVerification
              ),
              hasResidentRegistrationEvidence:
                hasResidentRegistrationEvidence(statusDraftState),
              agreementsComplete: Boolean(
                (statusDraftState?.agreements || agreements)?.privacy &&
                  (statusDraftState?.agreements || agreements)?.credit &&
                  (statusDraftState?.agreements || agreements)?.collection
              ),
            }),
          });
          clearActiveKcpReturnNavigationIntent();
          clearKcpVerifiedNavigationRetry();
          setPrincipalKcpLaunchUiState(KCP_LAUNCH_UI_STATES.VERIFIED, {
            source,
          });
          setOtpError("");
          navigateAfterPrincipalKcpVerified(statusDraftState, {
            representativeMatched: true,
          });
        }
        queueContractEvent("KCP_STATUS_REHYDRATED", {
          source,
          sessionId: result.sessionId || target.sessionId || null,
        });
      } else if (result?.ok === false) {
        setOtpError(KCP_STATUS_RECHECK_MESSAGE);
      }
      return result;
    });
    kcpStatusSyncInFlightRef.current = syncPromise;
    try {
      return await syncPromise;
    } finally {
      if (kcpStatusSyncInFlightRef.current === syncPromise) {
        kcpStatusSyncInFlightRef.current = null;
      }
    }
  };

  const recheckPrincipalKcpBeforeBlocking = async (source = "submit") => {
    const target = getKcpIdentityStatusLookupTarget();
    const hasKcpAttemptSignal = Boolean(
      target.sessionId ||
        kcpIdentityStatus ||
        kcpIdentityEvidence ||
        representativeIdentityVerification ||
        phoneVerified
    );
    if (!hasKcpAttemptSignal) {
      return {
        ok: false,
        pending: false,
        message: REPRESENTATIVE_KCP_REQUIRED_MESSAGE,
      };
    }
    const result = await refreshKcpIdentityStatus({ source, force: true });
    const readiness = resolveKcpIdentityReadiness({
      kcpStatus: result?.status || kcpIdentityStatus,
      representativeIdentityVerification:
        result?.representativeIdentityVerification ||
        representativeIdentityVerification,
      phoneVerified,
      kcpSessionId: result?.sessionId || target.sessionId,
      latestStatusResponse: result,
      previousVerifiedStatus: lastVerifiedPrincipalKcpRef.current,
    });
    if (readiness.canProceed) {
      return {
        ok: true,
        pending: false,
        kcpIdentityStatus: "VERIFIED",
        representativeIdentityVerification:
          readiness.representativeIdentityVerification ||
          result?.representativeIdentityVerification ||
          representativeIdentityVerification,
      };
    }
    if (readiness.requiresStatusRefresh || result?.ok === false) {
      queueContractEvent("KCP_SUBMIT_RECHECK_FAILED", {
        source,
        status: result?.status || null,
        code: result?.code || readiness.reason || null,
        sessionId: result?.sessionId || target.sessionId || null,
      });
      return {
        ok: false,
        pending: true,
        message: KCP_STATUS_RECHECK_MESSAGE,
      };
    }
    return {
      ok: false,
      pending: false,
      message:
        readiness.status === "MISMATCHED"
          ? getRepresentativeIdentityMismatchMessage(
              readiness.representativeIdentityVerification?.mismatchReason ||
                result?.representativeIdentityVerification?.mismatchReason
            )
          : REPRESENTATIVE_KCP_REQUIRED_MESSAGE,
    };
  };

  const hasResidentRegistrationEvidence = (
    draftState: KcpDraftRestoreState | null = null
  ) => {
    const evidenceBizType = draftState?.bizType || bizType;
    const evidenceFormData = (draftState?.formData || formData) as Record<string, unknown>;
    const getEvidenceField = (key: string) => {
      const value = evidenceFormData[key];
      return typeof value === "string" ? value : "";
    };
    const evidenceRestoredSsnDraft =
      draftState?.restoredSsnDraft || restoredSsnDraft || null;
    const legacyGuarantorSsnRequired =
      shouldRequireLegacyGuarantorSsnInPrimaryStep(evidenceBizType);
    const principalRawValid = isValidResidentRegistrationInput(
      evidenceBizType,
      getEvidenceField("principalRepSsnFront") || getEvidenceField("ssnFront"),
      getEvidenceField("principalRepSsnBack") || getEvidenceField("ssnBack")
    );
    const principalRestored = Boolean(evidenceRestoredSsnDraft?.principalRepSsnEncrypted);
    const guarantorRawValid =
      !legacyGuarantorSsnRequired ||
      isValidResidentRegistrationInput(
        evidenceBizType,
        getEvidenceField("guarantorSsnFront"),
        getEvidenceField("guarantorSsnBack")
      );
    const guarantorRestored =
      !legacyGuarantorSsnRequired ||
      Boolean(evidenceRestoredSsnDraft?.guarantorSsnEncrypted);
    return (principalRawValid || principalRestored) && (guarantorRawValid || guarantorRestored);
  };

  const canAdvanceAfterKcpReturn = (
    draftState: KcpDraftRestoreState | null = null
  ) => {
    const evidenceAgreements = draftState?.agreements || agreements;
    return (
      Boolean(
        evidenceAgreements.privacy &&
          evidenceAgreements.credit &&
          evidenceAgreements.collection
      ) && hasResidentRegistrationEvidence(draftState)
    );
  };

  const getKcpReturnStep0Issues = (
    draftState: KcpDraftRestoreState | null = null
  ) =>
    validateStep0RequiredFields({
      formData: draftState?.formData || formData,
      bizType: draftState?.bizType || bizType,
      isSameDayDeposit:
        typeof draftState?.isSameDayDeposit === "boolean"
          ? draftState.isSameDayDeposit
          : isSameDayDeposit,
      manualAddressMode:
        typeof draftState?.manualAddressMode === "boolean"
          ? draftState.manualAddressMode
          : manualAddressMode,
      validationSettings,
    });

  const restoreKcpReturnNavigationDuringChecking = (
    draftState: KcpDraftRestoreState | null = null,
    { clearOnInvalid = false } = {}
  ) => {
    const step0Issues = getKcpReturnStep0Issues(draftState);
    if (step0Issues.length > 0) {
      if (clearOnInvalid) {
        clearActiveKcpReturnNavigationIntent();
        clearKcpVerifiedNavigationRetry();
        goToStep(0, { allowDuringKcpReturnSync: true });
        setErrors((prev) => ({
          ...prev,
          [step0Issues[0].fieldId]: step0Issues[0].message,
        }));
        focusValidationIssue(step0Issues[0]);
      }
      return false;
    }
    activateKcpReturnNavigationIntent(1);
    showIntroPageRef.current = false;
    setShowIntroPage(false);
    setViewMode("FORM");
    setPrincipalKcpReturnSyncState(KCP_RETURN_SYNC_STATES.CHECKING_STATUS, {
      source: "return-navigation-restore",
      targetStep: 1,
    });
    setPrincipalKcpLaunchUiState(KCP_LAUNCH_UI_STATES.RETURN_CHECKING, {
      source: "return-navigation-restore",
    });
    console.info("[kcp-identity] restore return navigation intent");
    console.info("[kcp-identity] return sync checking, keep user away from step0");
    goToStep(1, { allowDuringKcpReturnSync: true });
    focusStep1SsnInputAfterKcp();
    scheduleKcpVerifiedStep1Recovery();
    return true;
  };

  const navigateAfterPrincipalKcpVerified = (
    draftState: KcpDraftRestoreState | null = null,
    { representativeMatched = true } = {}
  ) => {
    if (postKcpNavigationAppliedRef.current) {
      traceKcpReturnLifecycle({
        source: "post-kcp-navigation",
        previousSyncState: kcpReturnSyncStateRef.current,
        nextSyncState: kcpReturnSyncStateRef.current,
        duplicateSkipped: true,
      });
      return;
    }
    postKcpNavigationAppliedRef.current = true;
    kcpVerifiedNavigationPendingRef.current = true;
    showIntroPageRef.current = false;
    setShowIntroPage(false);
    setViewMode("FORM");
    console.info("[kcp-identity] verified return navigation");
    const step0Issues = getKcpReturnStep0Issues(draftState);
    const postKcpTargetStep = getPostKcpVerifiedTargetStep({
      step0Issues,
      representativeMatched,
      hasResidentRegistrationEvidence: hasResidentRegistrationEvidence(draftState),
      agreementsComplete: Boolean(
        (draftState?.agreements || agreements)?.privacy &&
          (draftState?.agreements || agreements)?.credit &&
          (draftState?.agreements || agreements)?.collection
      ),
    });

    if (postKcpTargetStep === 0) {
      clearActiveKcpReturnNavigationIntent();
      clearKcpVerifiedNavigationRetry();
      goToStep(0, { allowDuringKcpReturnSync: true });
      setErrors((prev) => ({
        ...prev,
        [step0Issues[0].fieldId]: step0Issues[0].message,
      }));
      focusValidationIssue(step0Issues[0]);
      return;
    }

    if (postKcpTargetStep === 2) {
      clearActiveKcpReturnNavigationIntent();
      clearKcpVerifiedNavigationRetry();
      goToStep(2, { allowDuringKcpReturnSync: true });
      return;
    }

    goToStep(1, { allowDuringKcpReturnSync: true });
    console.info("[kcp-identity] return to step1 after verification");
    focusStep1SsnInputAfterKcp();
    scheduleKcpVerifiedStep1Recovery();
  };

  const completePrincipalKcpVerifiedStatus = ({
    source = "unknown",
    statusResult = null,
    draftState = null,
    sessionId = "",
    clearDraft = false,
  }: {
    source?: string;
    statusResult?: any;
    draftState?: KcpDraftRestoreState | null;
    sessionId?: string;
    clearDraft?: boolean;
  } = {}) => {
    const effectiveDraftState =
      normalizeKcpDraftRestoreState(statusResult?.draft) || draftState || null;
    const readiness = resolveKcpIdentityReadiness({
      kcpStatus: statusResult?.status || "VERIFIED",
      representativeIdentityVerification:
        statusResult?.representativeIdentityVerification ||
        representativeIdentityVerification,
      phoneVerified,
      kcpSessionId: statusResult?.sessionId || sessionId || kcpSessionId,
      latestStatusResponse: statusResult,
      previousVerifiedStatus: lastVerifiedPrincipalKcpRef.current,
    });
    if (
      !shouldCompleteKcpVerifiedStatusImmediately({
        status: statusResult?.status || "VERIFIED",
        canProceed: readiness.canProceed,
        subjectType: statusResult?.subjectType || "",
      })
    ) {
      return false;
    }
    const representativeVerification =
      readiness.representativeIdentityVerification ||
      statusResult?.representativeIdentityVerification;
    setPrincipalKcpReturnSyncState(KCP_RETURN_SYNC_STATES.VERIFIED, {
      source,
      targetStep: getPostKcpVerifiedTargetStep({
        step0Issues: getKcpReturnStep0Issues(effectiveDraftState),
        representativeMatched: isRepresentativeIdentityMatched(
          representativeVerification
        ),
        hasResidentRegistrationEvidence:
          hasResidentRegistrationEvidence(effectiveDraftState),
        agreementsComplete: Boolean(
          (effectiveDraftState?.agreements || agreements)?.privacy &&
            (effectiveDraftState?.agreements || agreements)?.credit &&
            (effectiveDraftState?.agreements || agreements)?.collection
        ),
      }),
    });
    clearActiveKcpReturnNavigationIntent();
    clearKcpVerifiedNavigationRetry();
    setPrincipalKcpLaunchUiState(KCP_LAUNCH_UI_STATES.VERIFIED, {
      source,
    });
    setOtpError("");
    if (clearDraft) clearKcpDraftRestoreState();
    navigateAfterPrincipalKcpVerified(effectiveDraftState, {
      representativeMatched: isRepresentativeIdentityMatched(
        representativeVerification
      ),
    });
    return true;
  };

  const runPrincipalKcpReturnFlow = async ({
    source = "return-payload",
    result = "",
    kcpSessionId: nextSessionId = "",
    draftId = "",
    reason = "",
    subjectType = "",
  }: {
    source?: string;
    result?: string;
    kcpSessionId?: string;
    draftId?: string;
    reason?: string;
    subjectType?: string;
  }) => {
    const corepContext = loadCorepKcpReturnContext();
    if (
      isCorepInviteRoute ||
      subjectType === "CO_REP" ||
      (corepContext &&
        (!nextSessionId || nextSessionId === corepContext.kcpSessionId))
    ) {
      return;
    }
    activateKcpReturnNavigationIntent(1);
    setShowIntroPage(false);
    setViewMode("FORM");
    setKcpLoading(false);
    setOtpError("");
    setPrincipalKcpLaunchUiState(KCP_LAUNCH_UI_STATES.RETURN_CHECKING, {
      withFallbackTimer: true,
    });
    setPrincipalKcpReturnSyncState(KCP_RETURN_SYNC_STATES.CHECKING_STATUS, {
      source,
      targetStep: 1,
    });

    let effectiveDraftState =
      loadKcpDraftRestoreStateForReturn(draftId || contractDraftId) || null;
    if (effectiveDraftState) {
      applyKcpDraftRestoreState(effectiveDraftState);
      restoreKcpReturnNavigationDuringChecking(effectiveDraftState, {
        clearOnInvalid: true,
      });
    } else {
      restoreKcpReturnNavigationDuringChecking(null);
    }

    setOtpError(KCP_RETURN_SYNC_CHECKING_MESSAGE);
    setToastMessage(KCP_RETURN_SYNC_CHECKING_MESSAGE);
    let status = null;
    for (const delayMs of KCP_STATUS_RETURN_POLL_DELAYS_MS) {
      await waitForKcpStatusPollDelay(delayMs);
      status = await loadKcpIdentityStatus(
        nextSessionId,
        draftId || effectiveDraftState?.draftId || contractDraftId,
        { source, preserveVerified: true }
      );
      const statusCode = String(status?.status || "").toUpperCase();
      if (
        statusCode === "VERIFIED" ||
        ["FAILED", "CANCELLED", "EXPIRED"].includes(statusCode)
      ) {
        break;
      }
    }
    const serverDraftState = normalizeKcpDraftRestoreState(status?.draft);
    if (!effectiveDraftState && serverDraftState) {
      effectiveDraftState = serverDraftState;
      applyKcpDraftRestoreState(serverDraftState);
      restoreKcpReturnNavigationDuringChecking(serverDraftState, {
        clearOnInvalid: true,
      });
    }

    const resolvedSessionId =
      status?.sessionId || nextSessionId || effectiveDraftState?.kcpSessionId || "";
    if (resolvedSessionId) setKcpSessionId(resolvedSessionId);

    if (status?.status === "VERIFIED") {
      setPrincipalKcpReturnSyncState(KCP_RETURN_SYNC_STATES.VERIFIED, {
        source,
        targetStep: getPostKcpVerifiedTargetStep({
          step0Issues: getKcpReturnStep0Issues(effectiveDraftState),
          representativeMatched: isRepresentativeIdentityMatched(
            status.representativeIdentityVerification
          ),
          hasResidentRegistrationEvidence:
            hasResidentRegistrationEvidence(effectiveDraftState),
          agreementsComplete: Boolean(
            (effectiveDraftState?.agreements || agreements)?.privacy &&
              (effectiveDraftState?.agreements || agreements)?.credit &&
              (effectiveDraftState?.agreements || agreements)?.collection
          ),
        }),
      });
      clearKcpDraftRestoreState();
      navigateAfterPrincipalKcpVerified(effectiveDraftState, {
        representativeMatched: isRepresentativeIdentityMatched(
          status.representativeIdentityVerification
        ),
      });
      if (typeof window !== "undefined") {
        window.history.replaceState({}, "", window.location.pathname);
      }
      return { status: "VERIFIED", finalized: true };
    }

    const statusCode = String(status?.status || "").toUpperCase();
    const statusErrorCode = String(status?.code || "").toUpperCase();
    if (
      shouldKeepKcpReturnChecking({
        status: statusCode,
        code: statusErrorCode,
        reason,
      }) &&
      (resolvedSessionId || nextSessionId || effectiveDraftState?.kcpSessionId)
    ) {
      setPrincipalKcpReturnSyncState(KCP_RETURN_SYNC_STATES.CHECKING_STATUS, {
        source,
        targetStep: 1,
      });
      setPrincipalKcpLaunchUiState(KCP_LAUNCH_UI_STATES.RETURN_CHECKING, {
        withFallbackTimer: true,
      });
      setKcpIdentityStatus(statusCode || "VERIFYING");
      setOtpError(KCP_RETURN_SYNC_CHECKING_MESSAGE);
      setToastMessage(KCP_RETURN_SYNC_CHECKING_MESSAGE);
      return {
        status: statusCode || "VERIFYING",
        code: statusErrorCode || "KCP_STATUS_PENDING",
        pending: true,
        finalized: false,
      };
    }

    if (
      status?.code !== "KCP_SESSION_NOT_FOUND" &&
      (status?.ok === false ||
        ["REGISTERED", "RETURNED", "VERIFYING", "PENDING"].includes(
          String(status?.status || "")
        ))
    ) {
      clearActiveKcpReturnNavigationIntent();
      setOtpError(KCP_STATUS_RECHECK_MESSAGE);
      setToastMessage(KCP_STATUS_RECHECK_MESSAGE);
      setPrincipalKcpReturnSyncState(KCP_RETURN_SYNC_STATES.FAILED, {
        source,
        force: true,
      });
      setPrincipalKcpLaunchUiState(KCP_LAUNCH_UI_STATES.FAILED);
      queueContractEvent("KCP_SUBMIT_RECHECK_FAILED", {
        source,
        status: status?.status || null,
        code: status?.code || null,
        sessionId: resolvedSessionId || null,
      });
      if (typeof window !== "undefined") {
        window.history.replaceState({}, "", window.location.pathname);
      }
      return {
        status: status?.status || "",
        code: status?.code || "",
        timedOut: true,
        finalized: true,
      };
    }

    if (effectiveDraftState && status?.draft) {
      clearKcpDraftRestoreState();
    }

    if (!status && (nextSessionId || effectiveDraftState?.kcpSessionId)) {
      clearActiveKcpReturnNavigationIntent();
      setPrincipalKcpReturnSyncState(KCP_RETURN_SYNC_STATES.FAILED, {
        source,
        force: true,
      });
      setPrincipalKcpLaunchUiState(KCP_LAUNCH_UI_STATES.FAILED);
      setOtpError(KCP_STATUS_RECHECK_MESSAGE);
      setToastMessage(KCP_STATUS_RECHECK_MESSAGE);
      queueContractEvent("KCP_SUBMIT_RECHECK_FAILED", {
        source,
        status: null,
        code: reason || "KCP_STATUS_EMPTY",
        sessionId: nextSessionId || effectiveDraftState?.kcpSessionId || null,
      });
      if (typeof window !== "undefined") {
        window.history.replaceState({}, "", window.location.pathname);
      }
      return {
        status: status?.status || "",
        code: reason || "KCP_STATUS_EMPTY",
        timedOut: true,
        finalized: true,
      };
    }

    clearActiveKcpReturnNavigationIntent();
    setPrincipalKcpReturnSyncState(KCP_RETURN_SYNC_STATES.FAILED, {
      source,
      force: true,
    });
    setPrincipalKcpLaunchUiState(KCP_LAUNCH_UI_STATES.FAILED);
    enableSmsFallbackAfterKcpFailure(
      reason === "KCP_TIMEOUT" ? "KCP_TIMEOUT" : "KCP_USER_CANCELLED",
      status?.code === "KCP_SESSION_NOT_FOUND"
        ? "KCP 본인확인 결과를 연결하지 못했습니다. 입력하신 정보는 복원되었으며, 문자 인증으로 계속 진행할 수 있습니다."
        : "KCP 본인확인이 완료되지 않아 문자 인증으로 계속 진행해 주세요.",
      status?.code || reason || "KCP_RETURN_FAILED"
    );
    goToStep(1);
    if (typeof window !== "undefined") {
      window.history.replaceState({}, "", window.location.pathname);
    }
    return {
      status: status?.status || "",
      code: status?.code || reason || "KCP_RETURN_FAILED",
      timedOut: true,
      finalized: true,
    };
  };

  const processPrincipalKcpReturnOnce = async ({
    source = "unknown",
    result = "",
    kcpSessionId: nextSessionId = "",
    draftId = "",
    reason = "",
    subjectType = "",
  }: {
    source?: string;
    result?: string;
    kcpSessionId?: string;
    draftId?: string;
    reason?: string;
    subjectType?: string;
  }) => {
    const corepContext = loadCorepKcpReturnContext();
    if (
      isCorepInviteRoute ||
      subjectType === "CO_REP" ||
      (corepContext &&
        (!nextSessionId || nextSessionId === corepContext.kcpSessionId))
    ) {
      return null;
    }
    const intent = loadKcpReturnNavigationIntent();
    const processKey = buildKcpReturnProcessKey({
      result,
      kcpSessionId: nextSessionId || getKcpIdentityStatusLookupTarget().sessionId,
      draftId: draftId || contractDraftId,
      targetStep: intent?.targetStep || 1,
      intent,
    });
    if (kcpReturnProcessingRef.current) {
      traceKcpReturnLifecycle({
        source,
        previousSyncState: kcpReturnSyncStateRef.current,
        nextSyncState: kcpReturnSyncStateRef.current,
        duplicateSkipped: true,
      });
      return null;
    }
    if (kcpReturnProcessedKeyRef.current === processKey) {
      traceKcpReturnLifecycle({
        source,
        previousSyncState: kcpReturnSyncStateRef.current,
        nextSyncState: kcpReturnSyncStateRef.current,
        duplicateSkipped: true,
      });
      return null;
    }

    kcpReturnProcessingRef.current = true;
    postKcpNavigationAppliedRef.current = false;
    try {
      const flowResult = await runPrincipalKcpReturnFlow({
        source,
        result,
        kcpSessionId: nextSessionId,
        draftId,
        reason,
        subjectType,
      });
      if (
        shouldFinalizeKcpReturnProcessKey({
          status: flowResult?.status || "",
          code: flowResult?.code || "",
          timedOut: flowResult?.timedOut === true,
        })
      ) {
        kcpReturnProcessedKeyRef.current = processKey;
      }
      return flowResult;
    } finally {
      kcpReturnProcessingRef.current = false;
    }
  };

  const handleKcpReturnPayload = async (payload = {}) =>
    processPrincipalKcpReturnOnce({
      ...payload,
      source: "return-payload",
    });

  useEffect(() => {
    if (
      isCorepInviteRoute ||
      !kcpReturnNavigationIntentActive ||
      kcpReturnSyncState !== KCP_RETURN_SYNC_STATES.CHECKING_STATUS ||
      step !== 0
    ) {
      return;
    }
    const restoreState =
      loadKcpDraftRestoreStateForReturn(contractDraftId) || null;
    restoreKcpReturnNavigationDuringChecking(restoreState);
  }, [
    isCorepInviteRoute,
    kcpReturnNavigationIntentActive,
    kcpReturnSyncState,
    step,
  ]);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (!isAllowedKcpMessageOrigin(event.origin)) return;
      const data = event.data || {};
      if (data?.type !== "CNFOOD_KCP_RESULT") return;
      if (isCorepInviteRoute) return;
      if (data.subjectType === "CO_REP") return;
      const corepContext = loadCorepKcpReturnContext();
      if (
        corepContext &&
        (!data.kcpSessionId || data.kcpSessionId === corepContext.kcpSessionId)
      ) {
        return;
      }
      void handleKcpReturnPayload({
        result: data.result,
        kcpSessionId: data.kcpSessionId,
        draftId: data.draftId,
        reason: data.reason,
        subjectType: data.subjectType,
      });
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [formData, agreements, restoredSsnDraft, bizType, isCorepInviteRoute]);

  useEffect(() => {
    const syncOnResume = ({ source = "pageshow" } = {}) => {
      if (isCorepInviteRoute || loadCorepKcpReturnContext()) return;
      const target = getKcpIdentityStatusLookupTarget();
      if (!target.sessionId) return;
      const pendingLikeStatus = [
        "",
        "REGISTERED",
        "RETURNED",
        "VERIFYING",
        "PENDING",
      ].includes(String(kcpIdentityStatus || ""));
      if (
        pendingLikeStatus ||
        !isRepresentativeIdentityMatched(representativeIdentityVerification)
      ) {
        setOtpError(KCP_RETURN_SYNC_CHECKING_MESSAGE);
        const restoreState =
          loadKcpDraftRestoreStateForReturn(target.draftId || contractDraftId) || null;
        if (loadKcpReturnNavigationIntent()) {
          restoreKcpReturnNavigationDuringChecking(restoreState);
        }
        void processPrincipalKcpReturnOnce({
          source,
          kcpSessionId: target.sessionId,
          draftId: target.draftId || contractDraftId,
        });
      }
    };
    const syncOnPageShow = () => syncOnResume({ source: "pageshow" });
    const syncOnFocus = () => syncOnResume({ source: "focus" });
    const syncOnVisibility = () => {
      if (document.visibilityState === "visible") {
        syncOnResume({ source: "visibilitychange" });
      }
    };
    window.addEventListener("pageshow", syncOnPageShow);
    window.addEventListener("focus", syncOnFocus);
    document.addEventListener("visibilitychange", syncOnVisibility);
    return () => {
      window.removeEventListener("pageshow", syncOnPageShow);
      window.removeEventListener("focus", syncOnFocus);
      document.removeEventListener("visibilitychange", syncOnVisibility);
    };
  }, [
    kcpSessionId,
    kcpIdentityStatus,
    representativeIdentityVerification,
    isCorepInviteRoute,
  ]);

  useEffect(() => {
    return () => {
      if (kcpPopupPollRef.current) {
        window.clearInterval(kcpPopupPollRef.current);
      }
      clearKcpVerifiedNavigationRetry();
      clearKcpLaunchFallbackTimer();
      clearKcpLaunchTimeout();
    };
  }, []);

  const shouldOpenKcpPopup = () => {
    return typeof window !== "undefined" && typeof navigator !== "undefined";
  };

  const openKcpPopupWindow = () => {
    if (!shouldOpenKcpPopup()) return null;
    try {
      if (kcpPopupRef.current && !kcpPopupRef.current.closed) {
        return kcpPopupRef.current;
      }
    } catch {
      kcpPopupRef.current = null;
    }
    const width = 430;
    const height = 640;
    const left = Math.max(0, Math.round((window.screen.width - width) / 2));
    const top = Math.max(0, Math.round((window.screen.height - height) / 2));
    const popup = window.open(
      "",
      KCP_IDENTITY_POPUP_NAME,
      `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`
    );
    if (popup) {
      kcpPopupRef.current = popup;
      try {
        popup.document.open();
        popup.document.write(buildKcpPopupWaitingHtml());
        popup.document.close();
      } catch {
        // Cross-origin navigation can make the popup document unavailable.
      }
    }
    return popup;
  };

  const closeKcpPopupWindow = () => {
    try {
      if (kcpPopupRef.current && !kcpPopupRef.current.closed) {
        kcpPopupRef.current.close();
      }
    } catch {
      // Ignore popup close failures.
    }
    kcpPopupRef.current = null;
  };

  const writeKcpPopupFailurePage = (options = {}) => {
    try {
      if (!kcpPopupRef.current || kcpPopupRef.current.closed) return false;
      kcpPopupRef.current.document.open();
      kcpPopupRef.current.document.write(buildKcpPopupFailureHtml(options));
      kcpPopupRef.current.document.close();
      return true;
    } catch {
      return false;
    }
  };

  const fetchKcpIdentityStatusSnapshot = async (sessionId = "") => {
    if (!sessionId) return null;
    try {
      const response = await fetch(
        `/api/kcp/identity/status?${new URLSearchParams({
          sessionId,
          appId,
        }).toString()}`
      );
      const result = await response.json().catch(() => null);
      if (!response.ok || !result?.ok) return null;
      return result;
    } catch (error) {
      console.error("[CNFOOD] KCP popup status polling failed", sanitizeErrorForLog(error));
      return null;
    }
  };

  const startKcpPopupClosedPolling = (sessionId = "") => {
    if (!sessionId || !kcpPopupRef.current) return;
    if (kcpPopupPollRef.current) {
      window.clearInterval(kcpPopupPollRef.current);
    }
    const startedAt = Date.now();
    kcpPopupPollRef.current = window.setInterval(async () => {
      const popupClosed = !kcpPopupRef.current || kcpPopupRef.current.closed;
      const timedOut = Date.now() - startedAt >= KCP_POPUP_RESULT_MAX_WAIT_MS;
      if (!popupClosed && !timedOut) return;
      const elapsedMs = Date.now() - startedAt;
      const snapshot = await fetchKcpIdentityStatusSnapshot(sessionId);
      const readiness = resolveKcpIdentityReadiness({
        kcpStatus: kcpIdentityStatus,
        representativeIdentityVerification,
        phoneVerified,
        kcpSessionId: sessionId,
        latestStatusResponse: snapshot,
        previousVerifiedStatus: lastVerifiedPrincipalKcpRef.current,
      });
      const effectiveSnapshot =
        readiness.canProceed && snapshot?.status !== "VERIFIED"
          ? {
              ...(snapshot || {}),
              status: "VERIFIED",
              representativeIdentityVerification:
                readiness.representativeIdentityVerification,
            }
          : snapshot;
      const decision = getKcpPopupCloseStatusDecision({
        status: effectiveSnapshot?.status || "",
        elapsedMs,
      });
      const isCoRepresentativeSession = effectiveSnapshot?.subjectType === "CO_REP";
      if (effectiveSnapshot?.status && !isCoRepresentativeSession) {
        setKcpIdentityStatus(effectiveSnapshot.status);
        setKcpVerifiedName(effectiveSnapshot.verifiedName || "");
        setKcpPhoneMasked(effectiveSnapshot.phoneMasked || "");
        setKcpRepresentativeMatchStatus(
          effectiveSnapshot.representativeMatchStatus || "NOT_AVAILABLE"
        );
        if (effectiveSnapshot.representativeIdentityVerification) {
          setRepresentativeIdentityVerification(
            effectiveSnapshot.representativeIdentityVerification
          );
        }
      }
      if (decision === "PENDING") {
        setKcpIdentityStatus("VERIFYING");
        setOtpError("본인확인 결과를 확인 중입니다. 잠시만 기다려 주세요.");
        return;
      }
      if (decision === "VERIFIED") {
        if (kcpPopupPollRef.current) {
          window.clearInterval(kcpPopupPollRef.current);
          kcpPopupPollRef.current = null;
        }
        if (isCoRepresentativeSession) {
          applyCoRepresentativeKcpResult(effectiveSnapshot || {});
          return;
        }
        if (
          completePrincipalKcpVerifiedStatus({
            source: "popup",
            statusResult: effectiveSnapshot,
            sessionId,
          })
        ) {
          return;
        }
        void processPrincipalKcpReturnOnce({
          source: "popup",
          result: effectiveSnapshot?.status || "VERIFIED",
          kcpSessionId: effectiveSnapshot?.sessionId || sessionId,
          draftId: effectiveSnapshot?.draftId || contractDraftId,
        });
        return;
      }
      if (decision === "FALLBACK" || decision === "TIMEOUT") {
        if (
          decision === "TIMEOUT" &&
          shouldKeepKcpReturnChecking({
            status: effectiveSnapshot?.status || "",
            code: effectiveSnapshot?.code || "",
            reason: "KCP_TIMEOUT",
          })
        ) {
          void processPrincipalKcpReturnOnce({
            source: "popup",
            result: effectiveSnapshot?.status || "PENDING",
            kcpSessionId: effectiveSnapshot?.sessionId || sessionId,
            draftId: effectiveSnapshot?.draftId || contractDraftId,
            reason: "KCP_TIMEOUT",
            subjectType: effectiveSnapshot?.subjectType || "",
          });
          return;
        }
        if (kcpPopupPollRef.current) {
          window.clearInterval(kcpPopupPollRef.current);
          kcpPopupPollRef.current = null;
        }
        void processPrincipalKcpReturnOnce({
          source: "popup",
          result: effectiveSnapshot?.status || decision,
          kcpSessionId: effectiveSnapshot?.sessionId || sessionId,
          draftId: effectiveSnapshot?.draftId || contractDraftId,
          reason: decision === "TIMEOUT" ? "KCP_TIMEOUT" : "KCP_USER_CANCELLED",
          subjectType: effectiveSnapshot?.subjectType || "",
        });
        return;
      }
    }, KCP_POPUP_RESULT_POLL_INTERVAL_MS);
  };

  const handleStartKcpIdentity = async ({
    subjectType = "PRINCIPAL",
    coRepresentativeId = "",
  }: {
    subjectType?: "PRINCIPAL" | "CO_REP";
    coRepresentativeId?: string;
  } = {}) => {
    const isCoRepresentativeSubject = subjectType === "CO_REP";
    const coRepresentativeSubject = isCoRepresentativeSubject
      ? coRepresentatives.find((item) => item.id === coRepresentativeId) || null
      : null;
    const subjectName = isCoRepresentativeSubject
      ? String(coRepresentativeSubject?.name || "").trim()
      : String(formData.agentRep || "").trim();
    const subjectBirthDate = isCoRepresentativeSubject
      ? String(
          coRepresentativeSubject?.ssnFront ||
            coRepresentativeSubject?.birthDate ||
            ""
        ).trim()
      : String(
          formData.principalRepSsnFront ||
            formData.ssnFront ||
            formData.representativeBirthDate ||
            ""
        ).trim();
    const subjectPhone = isCoRepresentativeSubject
      ? String(coRepresentativeSubject?.phone || "")
      : getOtpPhoneNumberFromForm(formData);
    if (isCoRepresentativeSubject && !coRepresentativeSubject) {
      const message = "공동계약인 정보를 먼저 입력해 주세요.";
      setToastMessage(message);
      return;
    }
    if (
      isCoRepresentativeSubject &&
      (!subjectName ||
        !normalizeBirthDateForMatch(subjectBirthDate) ||
        String(coRepresentativeSubject?.ssnBack || "").replace(/[^0-9]/g, "").length !== 7 ||
        !isValidKcpMobilePhoneNumber(subjectPhone) ||
        !String(coRepresentativeSubject?.homeAddress || "").trim())
    ) {
      const message =
        "공동계약인 성명, 주민번호, 휴대폰번호, 자택주소를 먼저 입력해 주세요.";
      setToastMessage(message);
      setOtpError(message);
      return;
    }
    if (
      !subjectName ||
      !normalizeBirthDateForMatch(subjectBirthDate || "") ||
      !isValidBizNumberFormat(formData.agentBizNo || "") ||
      !formatOpeningDateForNts(formData.openingDate || "")
    ) {
      const message =
        "사업자등록증 기준 대표자명, 생년월일, 사업자번호, 개업일자를 먼저 입력해 주세요.";
      setOtpError(message);
      setToastMessage(message);
      goToStep(0);
      return;
    }
    const otpPhoneNumber = subjectPhone;
    if (!isValidKcpMobilePhoneNumber(otpPhoneNumber)) {
      const message =
        "휴대폰 번호 형식을 확인해 주세요. 대표자 본인 명의 휴대폰 번호를 입력해 주세요.";
      setOtpError(message);
      setErrors((prev) => ({ ...prev, agentContact: message }));
      focusValidationIssue(createValidationIssue("agentContact", message));
      return;
    }

    if (!isCoRepresentativeSubject) {
      kcpReturnProcessedKeyRef.current = "";
      postKcpNavigationAppliedRef.current = false;
      kcpVerifiedGraceUntilRef.current = 0;
      setPrincipalKcpLaunchUiState(KCP_LAUNCH_UI_STATES.PREPARING, {
        withFallbackTimer: true,
      });
    }

    const requiresSynchronousKcpPopup = shouldOpenKcpPopup();
    let popup: Window | null = null;
    let submitKcpInCurrentWindow = false;
    popup = openKcpPopupWindow();
    if (!isCoRepresentativeSubject) {
      setPrincipalKcpLaunchUiState(KCP_LAUNCH_UI_STATES.OPENING, {
        withFallbackTimer: true,
      });
    }
    if (requiresSynchronousKcpPopup && !popup) {
      if (isCoRepresentativeSubject) {
        const message = ERROR_HELP_GUIDES.KCP_POPUP_BLOCKED.title;
        clearActiveKcpReturnNavigationIntent();
        clearKcpVerifiedNavigationRetry();
        setPrincipalKcpReturnSyncState(KCP_RETURN_SYNC_STATES.FAILED, {
          source: "popup-blocked",
          force: true,
        });
        updateCoRepresentativeDraft(coRepresentativeId, {
          kcpStatus: "FAILED",
          identityStatus: "FAILED",
        });
        setActiveCoRepresentativeKcpId("");
        setOtpError(message);
        setToastMessage(message);
        openErrorHelpModal(ERROR_HELP_GUIDES.KCP_POPUP_BLOCKED, {
          errorCode: "KCP_START_FAILED",
        });
        return;
      }
      submitKcpInCurrentWindow = true;
    }

    if (!isCoRepresentativeSubject) {
      clearActiveKcpReturnNavigationIntent();
      clearKcpVerifiedNavigationRetry();
    }
    setOtpError("");
    setKcpFallbackReason(null);
    setSmsFallbackSelected(false);
    if (isCoRepresentativeSubject) {
      setActiveCoRepresentativeKcpId(coRepresentativeId);
      updateCoRepresentativeDraft(coRepresentativeId, {
        kcpStatus: "VERIFYING",
        identityStatus: "PENDING",
      });
    } else {
      setActiveCoRepresentativeKcpId("");
    }
    const markCoRepresentativeKcpStartFailed = () => {
      if (!isCoRepresentativeSubject) return;
      updateCoRepresentativeDraft(coRepresentativeId, {
        kcpStatus: "FAILED",
        identityStatus: "FAILED",
      });
    };
    let draftRestoreStateForStart: KcpDraftRestoreState | null = null;
    if (!(await ensureContractAppStatusAllows("KCP", { refresh: true }))) {
      closeKcpPopupWindow();
      markCoRepresentativeKcpStartFailed();
      setActiveCoRepresentativeKcpId("");
      if (!isCoRepresentativeSubject) {
        setPrincipalKcpLaunchUiState(KCP_LAUNCH_UI_STATES.IDLE);
      }
      return;
    }
    try {
      draftRestoreStateForStart = await persistKcpDraftRestoreBeforeStart("");
    } catch (draftError) {
      writeKcpPopupFailurePage();
      console.error("[CNFOOD] KCP draft save failed", sanitizeErrorForLog(draftError));
      markCoRepresentativeKcpStartFailed();
      setActiveCoRepresentativeKcpId("");
      if (!isCoRepresentativeSubject) {
        setPrincipalKcpLaunchUiState(KCP_LAUNCH_UI_STATES.FAILED);
      }
      setToastMessage("작성 정보를 임시 저장하지 못했습니다. 다시 시도해 주세요.");
      return;
    }
    const expectsPopup = shouldOpenKcpPopup() && !submitKcpInCurrentWindow;
    if (!submitKcpInCurrentWindow && (!popup || popup.closed)) {
      popup = openKcpPopupWindow();
    }
    if (expectsPopup && !popup) {
      if (!isCoRepresentativeSubject) {
        submitKcpInCurrentWindow = true;
      } else {
        markCoRepresentativeKcpStartFailed();
        setActiveCoRepresentativeKcpId("");
        const message =
          "본인확인 창이 열리지 않았습니다. 팝업 허용 후 다시 시도해 주세요.";
        setOtpError(message);
        setToastMessage(message);
        openErrorHelpModal(ERROR_HELP_GUIDES.KCP_POPUP_BLOCKED, {
          errorCode: "KCP_OPEN_FAILED",
        });
        return;
      }
    }
    queueContractEvent("KCP_IDENTITY_START_REQUESTED", {
      provider: "KCP",
      phoneMasked: maskPhoneNumber(otpPhoneNumber),
    });
    setKcpLoading(true);
    const controller =
      typeof AbortController !== "undefined" ? new AbortController() : null;
    const timeoutId = controller
      ? window.setTimeout(() => controller.abort(), KCP_START_TIMEOUT_MS)
      : null;
    try {
      const response = await fetch("/api/kcp/identity/start", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        signal: controller?.signal,
        body: JSON.stringify({
          appId,
          contractDraftId,
          inviteToken: activeInvite?.token || "",
          subjectType,
          coRepresentativeId: isCoRepresentativeSubject ? coRepresentativeId : "",
          customerName: formData.agentName,
          phone: otpPhoneNumber,
          representativeName: subjectName,
          representativeBirthDate: subjectBirthDate,
          representativePhone: otpPhoneNumber,
          businessNumber: formData.agentBizNo,
          openingDate: formData.openingDate,
          returnPath: "/",
          draftRestoreState: draftRestoreStateForStart,
        }),
      });
      const result = await response.json().catch(() => null);
      if (!response.ok || !result?.ok) {
        writeKcpPopupFailurePage();
        markCoRepresentativeKcpStartFailed();
        if (result?.code === "KCP_DRAFT_SAVE_FAILED") {
          const message =
            result?.message ||
            "작성 정보를 임시 저장하지 못했습니다. 다시 시도해 주세요.";
          setOtpError(message);
          setToastMessage(message);
          return;
        }
        if (response.status === 400) {
          const message =
            result?.message ||
            "본인확인 요청 정보를 확인해 주세요. 입력값을 다시 확인한 뒤 시도해 주세요.";
          setOtpError(message);
          setToastMessage(message);
          if (result?.code === "KCP_PHONE_INVALID") {
            setErrors((prev) => ({ ...prev, agentContact: message }));
            focusValidationIssue(createValidationIssue("agentContact", message));
          }
          return;
        }
        const reason = getKcpFallbackReasonFromStartFailure({ result });
        enableSmsFallbackAfterKcpFailure(
          reason,
          reason === "KCP_TIMEOUT"
            ? "KCP 본인확인 응답이 지연되어 문자 인증으로 전환했습니다."
            : "KCP 본인확인을 시작하지 못했습니다. 문자 인증으로 계속 진행해 주세요.",
          result?.code || reason
        );
        return;
      }
      if (!result.callUrl) {
        writeKcpPopupFailurePage();
        markCoRepresentativeKcpStartFailed();
        const callUrlMissingResult = { code: "KCP_CALL_URL_MISSING" };
        const reason = getKcpFallbackReasonFromStartFailure({
          result: callUrlMissingResult,
        });
        enableSmsFallbackAfterKcpFailure(
          reason,
          "KCP 본인확인을 시작하지 못했습니다. 문자 인증으로 계속 진행해 주세요.",
          callUrlMissingResult.code
        );
        return;
      }
      if (!result.regCertKey) {
        writeKcpPopupFailurePage();
        markCoRepresentativeKcpStartFailed();
        const regCertKeyMissingResult = { code: "KCP_REG_CERT_KEY_MISSING" };
        const reason = getKcpFallbackReasonFromStartFailure({
          result: regCertKeyMissingResult,
        });
        enableSmsFallbackAfterKcpFailure(
          reason,
          "KCP 본인확인을 시작하지 못했습니다. 문자 인증으로 계속 진행해 주세요.",
          regCertKeyMissingResult.code
        );
        return;
      }
      setKcpSessionId(result.sessionId || "");
      if (isCoRepresentativeSubject) {
        updateCoRepresentativeDraft(coRepresentativeId, {
          kcpSessionId: result.sessionId || "",
          kcpStatus: "REGISTERED",
          identityStatus: "PENDING",
        });
      } else {
        activateKcpReturnNavigationIntent(1);
      }
      await persistKcpDraftRestoreBeforeStart(result.sessionId || "");
      setKcpIdentityStatus("REGISTERED");
      setToastMessage("통신사 본인확인을 진행 중입니다. 인증창에서 완료해 주세요.");
      if (!isCoRepresentativeSubject) {
        setPrincipalKcpLaunchUiState(KCP_LAUNCH_UI_STATES.OPENING, {
          withFallbackTimer: true,
        });
      }
      if (typeof window !== "undefined") {
        try {
          const usePopup = !submitKcpInCurrentWindow && Boolean(popup && !popup.closed);
          submitKcpIdentityForm({
            callUrl: result.callUrl,
            regCertKey: result.regCertKey,
            pageSubmitYn: result.pageSubmitYn || "Y",
            target: usePopup ? KCP_IDENTITY_POPUP_NAME : "_self",
            popup: usePopup ? popup : null,
            popupName: usePopup ? KCP_IDENTITY_POPUP_NAME : "",
          });
          if (usePopup) {
            if (!isCoRepresentativeSubject) {
              setPrincipalKcpLaunchUiState(KCP_LAUNCH_UI_STATES.WAITING_RETURN, {
                withFallbackTimer: true,
              });
            }
            setKcpLoading(false);
            startKcpPopupClosedPolling(result.sessionId || "");
          }
        } catch (openError) {
          writeKcpPopupFailurePage();
          markCoRepresentativeKcpStartFailed();
          if (!isCoRepresentativeSubject) {
            clearActiveKcpReturnNavigationIntent();
          }
          console.error("[CNFOOD] KCP page open failed", sanitizeErrorForLog(openError));
          const openFailedResult = { code: "KCP_FORM_SUBMIT_FAILED" };
          const reason = getKcpFallbackReasonFromStartFailure({
            result: openFailedResult,
          });
          enableSmsFallbackAfterKcpFailure(
            reason,
            "KCP 본인확인을 시작하지 못했습니다. 문자 인증으로 계속 진행해 주세요.",
            openFailedResult.code
          );
        }
      }
    } catch (error) {
      writeKcpPopupFailurePage();
      markCoRepresentativeKcpStartFailed();
      if (!isCoRepresentativeSubject) {
        clearActiveKcpReturnNavigationIntent();
      }
      console.error("[CNFOOD] KCP start failed", sanitizeErrorForLog(error));
      const errorName =
        typeof error === "object" && error !== null && "name" in error
          ? String((error as { name?: unknown }).name || "")
          : "";
      const reason = getKcpFallbackReasonFromStartFailure({ errorName });
      enableSmsFallbackAfterKcpFailure(
        reason,
        reason === "KCP_TIMEOUT"
          ? "KCP 본인확인 응답이 지연되어 문자 인증으로 전환했습니다."
          : "KCP 본인확인을 시작하지 못했습니다. 문자 인증으로 계속 진행해 주세요.",
        reason
      );
    } finally {
      if (timeoutId) window.clearTimeout(timeoutId);
      setKcpLoading(false);
      if (isCoRepresentativeSubject) {
        setActiveCoRepresentativeKcpId("");
      }
    }
  };

  const getRepresentativeIdentityRequestLink = () =>
    buildCoRepresentativeRequestLink({
      activeInvite,
      inviteToken: activeInvite?.token || "",
      origin:
        typeof window !== "undefined"
          ? `${window.location.origin}${window.location.pathname}`
          : "https://cn-food-contract.vercel.app",
      currentHref:
        typeof window !== "undefined" ? window.location.href : "",
    });

  const handleCopyRepresentativeIdentityRequestLink = async () => {
    const requestLink = getRepresentativeIdentityRequestLink();
    if (!requestLink) {
      setToastMessage("대표자 인증 요청 링크를 만들 수 없습니다. 초대 링크를 먼저 확인해 주세요.");
      return;
    }
    await copyTextToClipboard(requestLink);
    setToastMessage("대표자 인증 요청 링크를 복사했습니다. 발송 완료로 표시하지 않습니다.");
  };

  const handleOpenRepresentativeIdentitySmsDraft = () => {
    const phone = getOtpPhoneNumberFromForm(formData);
    if (!isValidPhoneNumberFormat(phone)) {
      const message = "대표자 휴대폰번호를 입력한 뒤 문자 작성을 열어 주세요.";
      setOtpError(message);
      setToastMessage(message);
      return;
    }
    const requestLink = getRepresentativeIdentityRequestLink();
    if (!requestLink) {
      setToastMessage("대표자 인증 요청 링크를 만들 수 없습니다. 초대 링크를 먼저 확인해 주세요.");
      return;
    }
    const message = buildRepresentativeIdentityRequestMessage({ requestLink });
    setToastMessage("문자 앱 초안을 열었습니다. 발송 완료로 표시하지 않습니다.");
    window.location.href = buildSmsHref(phone, message);
  };

  const handleRefreshRepresentativeIdentityStatus = async () => {
    const target = getKcpIdentityStatusLookupTarget();
    if (!target.sessionId) {
      setToastMessage("대표자 본인확인 요청 전 상태입니다.");
      return;
    }
    const result = await refreshKcpIdentityStatus({
      source: "manual_refresh",
      force: true,
    });
    const workflowStatus = getRepresentativeKcpWorkflowStatus(
      result?.representativeIdentityVerification ||
        representativeIdentityVerification
    );
    setToastMessage(`대표자 인증 상태 새로고침: ${workflowStatus}`);
  };

  const applyRepresentativeIdentityTestSimulation = () => {
    if (!identityTestModeAllowed) {
      setToastMessage("테스트 모드는 관리자 인증 후 ENABLE_IDENTITY_TEST_MODE=true일 때만 사용할 수 있습니다.");
      return;
    }
    const verifiedAt = new Date().toISOString();
    const simulated = buildRepresentativeIdentityTestSimulation({
      formData,
      verifiedAt,
    });
    setRepresentativeIdentityVerification(simulated);
    setKcpRepresentativeMatchStatus(REPRESENTATIVE_KCP_PENDING_STATUS);
    setKcpIdentityEvidence({
      provider: IDENTITY_TEST_SIMULATION_PROVIDER,
      method: "TEST_SIMULATION",
      status: IDENTITY_TEST_SIMULATION_STATUS,
      isTestMode: true,
      verifiedAt,
      hasCi: false,
      hasDi: false,
      warning: IDENTITY_TEST_SIMULATION_WARNING,
    });
    setPhoneVerified(true);
    setPhoneVerifiedAt(verifiedAt);
    setLockedIdentityFields(
      buildLockedIdentityFieldsSnapshot({
        formData,
        lockedAt: verifiedAt,
      })
    );
    setOtpError("");
    setToastMessage(IDENTITY_TEST_MODE_NOTICE);
  };

  const applyCoRepresentativeIdentityTestSimulation = (coRepresentativeId = "") => {
    if (!identityTestModeAllowed) {
      setToastMessage("테스트 모드는 관리자 인증 후 ENABLE_IDENTITY_TEST_MODE=true일 때만 사용할 수 있습니다.");
      return;
    }
    const verifiedAt = new Date().toISOString();
    setCoRepresentatives((prev) =>
      prev.map((item) => {
        if (item.id !== coRepresentativeId) return item;
        return {
          ...item,
          kcpStatus: IDENTITY_TEST_SIMULATION_STATUS,
          identityStatus: IDENTITY_TEST_SIMULATION_STATUS,
          identityVerification: buildCoRepresentativeIdentityTestSimulation({
            representative: item,
            businessNumber: formData.agentBizNo,
            verifiedAt,
          }),
        };
      })
    );
    setToastMessage(IDENTITY_TEST_MODE_NOTICE);
  };

  const isCoRepresentativeIdentityReadyForSigning = (representative = {}) =>
    isCoRepresentativeIdentityMatched(representative) ||
    (identityTestModeAllowed &&
      isIdentityTestSimulation(representative.identityVerification));

  const buildIdentityTestPreviewContract = () => {
    const now = new Date().toISOString();
    const primarySignatureImage =
      canvasRef.current ? canvasRef.current.toDataURL("image/png") : formData.signature;
    const guaranteeSignatureImage =
      canvasRef2.current ? canvasRef2.current.toDataURL("image/png") : formData.signature2;
    const simulatedIdentity =
      representativeIdentityVerification && isIdentityTestSimulation(representativeIdentityVerification)
        ? representativeIdentityVerification
        : buildRepresentativeIdentityTestSimulation({ formData, verifiedAt: now });
    return {
      ...formData,
      contractId: formData.contractId || `TEST-${contractDraftId.slice(-8)}`,
      contractStatus: IDENTITY_TEST_CONTRACT_STATUS,
      status: "test_draft",
      isIdentityTestMode: true,
      isTestMode: true,
      bizType,
      signature: primarySignatureImage || null,
      signature2: guaranteeSignatureImage || null,
      representativeIdentityVerification: simulatedIdentity,
      identityVerification: {
        provider: IDENTITY_TEST_SIMULATION_PROVIDER,
        method: "TEST_SIMULATION",
        status: IDENTITY_TEST_SIMULATION_STATUS,
        isTestMode: true,
        representativeMatchStatus: REPRESENTATIVE_KCP_PENDING_STATUS,
        hasCi: false,
        hasDi: false,
        verifiedAt: now,
        warning: IDENTITY_TEST_SIMULATION_WARNING,
      },
      businessVerification,
      lockedIdentityFields,
      coRepresentatives,
      auditTrail: auditLogsRef.current,
    };
  };

  const handleGenerateIdentityTestPdf = async () => {
    if (!identityTestModeAllowed) {
      setToastMessage("테스트 PDF는 관리자 테스트 모드에서만 생성할 수 있습니다.");
      return;
    }
    setToastMessage("테스트 PDF 생성 중입니다. 실제 계약 저장이나 KCP 인증은 수행하지 않습니다.");
    await handleDownloadPDF(buildIdentityTestPreviewContract(), "TEST");
  };

  // ── 휴대폰 번호 확인 ──
  // KCP 환경변수가 서버에 준비되면 KCP를 우선 사용하고, 없으면 Firebase SMS OTP를 유지한다.
  const handleSendOTP = async () => {
    if (!validationSettings.enablePhoneVerification) return;
    setOtpError("");
    if (!(await ensureContractAppStatusAllows("SMS", { refresh: true }))) {
      return;
    }
    const otpPhoneNumber = getOtpPhoneNumberFromForm(formData);

    if (!isValidPhoneNumberFormat(otpPhoneNumber)) {
      const message = "휴대폰 번호를 입력해 주세요. 본인확인을 받을 번호입니다.";
      setOtpError(message);
      setErrors((prev) => ({ ...prev, agentContact: message }));
      focusValidationIssue(createValidationIssue("agentContact", message));
      return;
    }
    setOtpLoading(true);
    try {
      // Firebase Console에 등록한 테스트 번호도 동일하게 실제 Phone Auth 경로를 탄다.
      const e164 = toFirebaseKoreanPhoneNumber(otpPhoneNumber);
      console.info("[CNFOOD] OTP send start", {
        phoneMasked: maskPhoneNumber(otpPhoneNumber),
        host:
          typeof window !== "undefined" ? window.location.hostname : "unknown",
      });
      const verifier = await getOrCreateRecaptchaVerifier();
      const result = await signInWithPhoneNumber(
        auth,
        e164,
        verifier
      );
      console.info("[CNFOOD] OTP send success");
      confirmationResultRef.current = result;
      setOtpSent(true);
      setPhoneVerified(false); // 재발송 시 이전 인증 무효화
      setPhoneVerifiedAt(null);
      setOtpCooldown(60);
      // 60초 카운트다운
      const cd = setInterval(() => {
        setOtpCooldown((prev) => {
          if (prev <= 1) { clearInterval(cd); return 0; }
          return prev - 1;
        });
      }, 1000);
      setToastMessage("인증번호가 발송되었습니다.");
    } catch (e) {
      console.error("[CNFOOD] OTP send failed", sanitizeErrorForLog(e));
      const message = getPhoneAuthErrorMessage(e);
      confirmationResultRef.current = null;
      setOtpSent(false);
      clearRecaptchaVerifier();
      setOtpError(message);
      setToastMessage(message);
    } finally {
      setOtpLoading(false);
    }
  };

  const handleVerifyOTP = async () => {
    if (!validationSettings.enablePhoneVerification) return;
    setOtpError("");
    if (!otpCode || otpCode.length < 6) {
      setOtpError("6자리 인증번호를 입력해주세요.");
      return;
    }
    setOtpLoading(true);
    try {
      await confirmationResultRef.current.confirm(otpCode);
      const verifiedAt = new Date().toISOString();
      setPhoneVerified(true);
      setPhoneVerifiedAt(verifiedAt);
      const log = await createLog(
        "휴대폰 번호 확인",
        `휴대폰 번호 확인 완료: ${maskPhoneNumber(formData.agentContact)}`
      );
      auditLogsRef.current.push(log);
      queueContractEvent("PHONE_OTP_VERIFIED", {
        method: "sms_otp",
        phoneMasked: maskPhoneNumber(formData.agentContact),
      });
      queueContractEvent("SMS_PHONE_VERIFIED", {
        method: kcpFallbackReason ? "sms_fallback" : "sms_otp",
        provider: "FIREBASE_SMS",
        kcpFallbackReason: kcpFallbackReason || null,
        phoneMasked: maskPhoneNumber(formData.agentContact),
      });
      setToastMessage("휴대폰 번호 확인이 완료되었습니다.");
    } catch (e) {
      setOtpError("인증번호가 올바르지 않습니다. 다시 확인해주세요.");
    } finally {
      setOtpLoading(false);
    }
  };

  const handleNextStepFromSSN = async () => {
    const currentStep1PhoneVerified =
      phoneVerified ||
      isPrincipalKcpVerifiedWithoutMismatch({
        kcpIdentityStatus,
        representativeIdentityVerification,
        kcpIdentityEvidence,
      });
    const issues = validateStep1RequiredFields({
      settings: validationSettings,
      phone: formData.agentContact,
      phoneVerified: currentStep1PhoneVerified,
      bizType,
      ssnFront: formData.ssnFront,
      ssnBack: formData.ssnBack,
      principalRepSsnFront: formData.principalRepSsnFront,
      principalRepSsnBack: formData.principalRepSsnBack,
      guarantorSsnFront: formData.guarantorSsnFront,
      guarantorSsnBack: formData.guarantorSsnBack,
      agreements,
      restoredSsnDraft,
    });
    if (issues.length > 0) {
      const first = issues[0];
      if (first.fieldId === "agentContact") {
        setOtpError(first.message);
        setErrors((prev) => ({ ...prev, agentContact: first.message }));
      }
      focusValidationIssue(first);
      return;
    }
    setActiveValidationIssue(null);
    if (!validationSettings.enablePhoneVerification) {
      setPhoneVerified(false);
      setPhoneVerifiedAt(null);
    }
    const coRepresentativeContactValidation = validatePrimaryCoRepresentativeContacts({
      declared: coRepresentativeDeclared,
      representatives: coRepresentatives,
    });
    if (!coRepresentativeContactValidation.ok) {
      setToastMessage(coRepresentativeContactValidation.message);
      setErrors((prev) => ({
        ...prev,
        agentRep: coRepresentativeContactValidation.message,
      }));
      goToStep(coRepresentativeContactValidation.step ?? 0);
      return;
    }
    const coRepresentativeRecordsForReview = buildPrimaryCoRepresentativeRecords({
      declared: coRepresentativeDeclared,
      representatives: coRepresentatives,
      businessNumber: formData.agentBizNo,
      inviteToken: activeInvite?.token || "",
    });
    let strictValidation = validateStrictRepresentativeIdentity({
      kcpIdentityStatus,
      representativeIdentityVerification,
      businessVerification,
      coRepresentativesRequired: false,
      coRepresentatives: coRepresentativeRecordsForReview,
    });
    if (
      !strictValidation.ok &&
      strictValidation.step !== 0 &&
      !isIdentityTestSimulation(representativeIdentityVerification)
    ) {
      const recheck = await recheckPrincipalKcpBeforeBlocking("step1_next");
      if (recheck.ok) {
        strictValidation = validateStrictRepresentativeIdentity({
          kcpIdentityStatus: recheck.kcpIdentityStatus,
          representativeIdentityVerification:
            recheck.representativeIdentityVerification,
          businessVerification,
          coRepresentativesRequired: false,
          coRepresentatives: coRepresentativeRecordsForReview,
        });
      } else if (recheck.pending) {
        setToastMessage(recheck.message);
        setOtpError(recheck.message);
        return;
      }
    }
    if (
      identityTestModeAllowed &&
      representativeIdentitySimulationActive &&
      !strictValidation.ok
    ) {
      setToastMessage("테스트 모드 미리보기로 이동합니다. 실제 제출은 KCP 본인확인 전까지 차단됩니다.");
      setContractScrolled(false);
      setContractAgreed(false);
      contractScrolledEventLoggedRef.current = false;
      goToStep(2);
      return;
    }
    if (!strictValidation.ok) {
      setToastMessage(strictValidation.message);
      if (strictValidation.step === 0) {
        setErrors((prev) => ({
          ...prev,
          agentRep: strictValidation.message,
          agentBizNo: strictValidation.message,
          openingDate: strictValidation.message,
        }));
      } else {
        setOtpError(strictValidation.message);
      }
      goToStep(strictValidation.step ?? 1);
      return;
    }
    const phoneAuthLogNote = validationSettings.enablePhoneVerification
      ? "휴대폰 번호 확인"
      : "휴대폰 번호 확인 생략(관리자 설정)";
    const log = await createLog(
      "휴대폰 번호 확인",
      isCorporateContract(bizType)
        ? `${phoneAuthLogNote} + 본 대표/공동계약인 주민번호 검증`
        : `${phoneAuthLogNote} + 본 대표 주민번호 검증`
    );
    auditLogsRef.current.push(log);
    setContractScrolled(false);
    setContractAgreed(false);
    contractScrolledEventLoggedRef.current = false;
    goToStep(2);
  };

  // [수정] 서명 단계 진입 시 블랙 스크린 방지 로직
  const handleGoToSignature = async () => {
    if (!contractScrolled) {
      setToastMessage("계약서를 끝까지 확인해 주세요.");
      contractPreviewRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      return;
    }

    const missingConsent = getFirstMissingRequiredConsent([
      {
        key: "contract-agreement",
        checked: contractAgreed,
        message: "계약서 내용 확인 및 동의에 체크해 주세요.",
      },
    ]);
    if (missingConsent) {
      focusRequiredConsent(missingConsent.key, missingConsent.message || "");
      return;
    }

    setTransitioning(true); // 로딩 화면 표시
    try {
      // 브라우저가 UI를 렌더링할 시간을 주기 위해 지연
      await new Promise((resolve) => setTimeout(resolve, 300));
      if (!contractReviewedAt) {
        setContractReviewedAt(new Date().toISOString());
      }
      queueContractEvent("CONTRACT_AGREED", { step: 2 });
      queueContractEvent("CONTRACT_VIEWED", { step: 2 });
      const nowEvidence = new Date().toISOString();
      setStepEvidence((prev) => ({
        ...prev,
        businessInfo: prev.businessInfo || {
          completed: true,
          completedAt: nowEvidence,
          businessNumber: formData.agentBizNo || "",
          representativeName: formData.agentRep || "",
          openingDate: formData.openingDate || "",
          phoneMasked: maskPhoneNumber(formData.agentContact || ""),
          source: "STEP_0_VALIDATED",
        },
        identity: prev.identity || (isRepresentativeIdentityMatched(representativeIdentityVerification)
          ? {
              completed: true,
              completedAt: nowEvidence,
              provider: "KCP",
              status: "MATCHED",
              kcpSessionId: kcpSessionId || "",
              hasCi: Boolean(kcpIdentityEvidence?.hasCi),
              hasDi: Boolean(kcpIdentityEvidence?.hasDi),
              nameMatched: Boolean((representativeIdentityVerification as any)?.checks?.nameMatched),
              birthDateMatched: Boolean((representativeIdentityVerification as any)?.checks?.birthDateMatched),
              phoneMatched: Boolean((representativeIdentityVerification as any)?.checks?.phoneMatched),
              ssnEvidencePresent: Boolean(restoredSsnDraft?.principalRepSsnEncrypted || (lockedIdentityFields as any)?.ssnMasked),
              source: "KCP_STATUS_VERIFIED" as StepEvidenceSource,
            }
          : null),
        contractReview: {
          completed: true,
          completedAt: nowEvidence,
          scrollCompleted: contractScrolled,
          source: "STEP_2_REVIEWED",
        },
      }));
      goToStep(3);
    } catch (e) {
      console.error("[CNFOOD] step transition failed", sanitizeErrorForLog(e));
      reportError("STEP_TRANSITION_ERROR", e.message, 2);
      setToastMessage("서명 화면으로 이동하지 못했습니다. 다시 시도해주세요.");
    } finally {
      setTransitioning(false);
    }
  };

  // code === "default" 인 담당자가 본사(전체 조회 권한)
  const isHeadquarters = (manager = currentManager) =>
    managersConfig.find((m) => m.code === "default")?.name === manager?.name ||
    manager?.code === "default";

  const isSalesLookupMode = adminAccessMode === "SALES_LOOKUP";
  const isPaymentOnlyMode = adminAccessMode === "PAYMENT";
  const isSalesPaymentMode = adminAccessMode === "SALES_PAYMENT";
  const canUseFieldPrint =
    (adminAccessMode === "ADMIN" || adminAccessMode === "FIELD_PRINT") &&
    Boolean(currentManager?.name) &&
    isHeadquarters();

  const closeFieldPrintDialog = () => {
    setFieldPrintPreviewOpen(false);
    setFieldPrintDialogOpen(false);
    if (adminAccessMode === "FIELD_PRINT") {
      adminSessionPasswordRef.current = "";
      setAdminPassword("");
      setCurrentManager({ name: "미지정", email: "" });
      setAdminAccessMode("ADMIN");
      setViewMode("FORM");
    }
  };

  const openFieldPrintDialog = () => {
    if (!canUseFieldPrint) {
      setToastMessage("본사 관리자 잠금 해제 후 계약서 출력 기능을 사용할 수 있습니다.");
      return;
    }
    setFieldPrintPreviewOpen(false);
    setFieldPrintDialogOpen(true);
    if (companyBranches.length === 0 && !companyBranchesLoading) {
      void loadCompanyBranches();
    }
  };

  const printFieldContract = async () => {
    const pages = await prepareFieldPrintContractPages();
    if (pages.length === 0) return;
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => window.setTimeout(() => window.print(), 0));
    });
  };
  const showPaymentRequestPanel =
    (isSalesPaymentMode || paymentWorkspaceRoute !== "OPERATIONS") &&
    paymentManagementSection === "OPERATIONS";
  const showPaymentOperationsPanel =
    !isSalesPaymentMode &&
    paymentWorkspaceRoute !== "SALES_REQUEST" &&
    paymentManagementSection === "OPERATIONS";
  const showPaymentDepositPanel =
    !isSalesPaymentMode &&
    paymentWorkspaceRoute !== "SALES_REQUEST" &&
    paymentManagementSection === "DEPOSITS";
  const showErpBridgePanel =
    !isSalesPaymentMode &&
    paymentWorkspaceRoute !== "SALES_REQUEST" &&
    paymentManagementSection === "ERP_BRIDGE";
  useEffect(() => {
    if (isSalesPaymentMode && paymentManagementSection !== "OPERATIONS") {
      setPaymentManagementSection("OPERATIONS");
    }
  }, [isSalesPaymentMode, paymentManagementSection]);
  useEffect(() => {
    if (
      viewMode !== "LIST" ||
      adminTab !== "STATS" ||
      !isHeadquarters() ||
      isSalesLookupMode ||
      isPaymentOnlyMode ||
      isSalesPaymentMode
    ) {
      return;
    }
    const loadKey = `${currentManager?.code || "unknown"}:${dashboardPaymentRange.dateFrom}:${dashboardPaymentRange.dateTo}`;
    if (dashboardPaymentLoadKeyRef.current === loadKey) return;
    dashboardPaymentLoadKeyRef.current = loadKey;
    void loadPaymentRequests({
      dateFrom: dashboardPaymentRange.dateFrom,
      dateTo: dashboardPaymentRange.dateTo,
    });
  }, [
    viewMode,
    adminTab,
    dashboardPaymentRange.dateFrom,
    dashboardPaymentRange.dateTo,
    currentManager?.code,
  ]);
  useEffect(() => {
    if (
      viewMode !== "LIST" ||
      adminTab !== "PAYMENT_MANAGEMENT" ||
      !showPaymentOperationsPanel
    ) {
      return undefined;
    }
    const intervalId = window.setInterval(() => {
      if (
        document.visibilityState === "visible" &&
        !paymentRequestsLoading &&
        !paymentOperationSavingId
      ) {
        void loadPaymentRequests();
      }
    }, 60000);
    return () => window.clearInterval(intervalId);
  }, [
    viewMode,
    adminTab,
    showPaymentOperationsPanel,
    paymentRequestsLoading,
    paymentOperationSavingId,
    paymentHistoryFilters.dateFrom,
    paymentHistoryFilters.dateTo,
  ]);
  const canUseAdminContractStart =
    adminAccessMode === "ADMIN" &&
    Boolean(currentManager?.name) &&
    !isSalesLookupMode;
  const adminContractStartBypassActive =
    adminContractStartMode && canUseAdminContractStart;

  const getAdminContractStartLink = () => {
    const fallbackUrl = "https://cn-food-contract.vercel.app/";
    if (typeof window === "undefined") return fallbackUrl;
    try {
      const url = new URL(
        `${window.location.origin}${window.location.pathname}`
      );
      const managerCode = String(currentManager?.code || "").trim();
      if (managerCode) {
        url.searchParams.set("m", managerCode);
      }
      return url.toString();
    } catch {
      return fallbackUrl;
    }
  };

  const buildAdminContractStartSmsMessage = (link: string) =>
    [
      "[씨엔푸드 전자계약 작성 요청]",
      "아래 링크에서 대표자 본인인증 후 전자계약서 작성을 완료해 주세요.",
      "본인인증, 동의, 전자서명은 대표자 또는 계약 권한이 있는 분이 직접 진행해 주셔야 합니다.",
      link,
    ].join("\n");

  const getAdminKcpReturnNavigationStatus = () => {
    const emptyStatus = {
      active: false,
      exists: false,
      targetStep: "-",
      createdAt: "-",
      expired: false,
    };
    if (typeof window === "undefined") return emptyStatus;
    try {
      const raw = window.sessionStorage?.getItem(KCP_RETURN_NAVIGATION_KEY);
      if (!raw) return emptyStatus;
      const parsed = JSON.parse(raw || "{}");
      const createdAtMs = Number(parsed?.createdAt || 0);
      const expired =
        !createdAtMs || Date.now() - createdAtMs > KCP_RETURN_NAVIGATION_TTL_MS;
      return {
        active: parsed?.pending === true && !expired,
        exists: true,
        targetStep: parsed?.targetStep ? String(parsed.targetStep) : "-",
        createdAt: createdAtMs
          ? new Date(createdAtMs).toLocaleString("ko-KR")
          : "-",
        expired,
      };
    } catch {
      return {
        ...emptyStatus,
        exists: true,
        expired: true,
      };
    }
  };

  const handleClearAdminKcpReturnNavigation = () => {
    clearKcpReturnNavigationIntent();
    clearActiveKcpReturnNavigationIntent();
    clearKcpVerifiedNavigationRetry();
    setPrincipalKcpReturnSyncState(KCP_RETURN_SYNC_STATES.IDLE, {
      source: "admin-clear-return-navigation",
      force: true,
    });
    setOtpError("");
    setToastMessage("KCP 복귀 상태를 초기화했습니다.");
  };

  const updateSalesContractSearchForm = (patch = {}) => {
    setSalesContractSearchForm((prev) => ({ ...prev, ...patch }));
    setSalesContractSearchError("");
  };

  const getSalesContractSearchFilterSummary = (
    form = salesContractSearchForm
  ) => {
    const periodLabel =
      form.dateFrom || form.dateTo
        ? `${form.dateFrom || "처음"} ~ ${form.dateTo || "오늘"}`
        : "전체 기간";
    const statusLabel =
      SALES_CONTRACT_STATUS_OPTIONS.find((option) => option.value === form.status)
        ?.label || "전체";
    return { periodLabel, statusLabel };
  };

  const loadSalesContractSearch = async ({
    manager = currentManager,
    form = salesContractSearchForm,
    reload = false,
  } = {}) => {
    if (!manager?.code) {
      setSalesContractSearchError("담당자 정보를 확인할 수 없습니다.");
      return null;
    }
    setSalesContractSearchLoading(true);
    setSalesContractSearchError("");
    try {
      const nextForm = {
        ...getEmptySalesLookupFilters(),
        ...form,
      };
      setSalesContractSearchForm(nextForm);
      // Sales lookup uses the already loaded admin contractList source.
      /*
        ok: false,
        message: "계약 현황을 조회하지 못했습니다.",
      */
      if (reload || contractList.length === 0) {
        const headquartersManager =
          resolveManagerByCode("default") ||
          managersConfig.find((item) => item.code === "default") ||
          currentManager;
        await fetchAndShowList(headquartersManager);
      }
      setCurrentPage(1);
      setViewMode("LIST");
      setAdminTab("SALES_SEARCH");
      return { ok: true };
    } catch (error) {
      const message =
        error?.message || "계약 현황 검색 중 오류가 발생했습니다.";
      console.error("[CNFOOD] sales contract search failed", sanitizeErrorForLog(error));
      setSalesContractSearchError(message);
      setToastMessage(message);
      return null;
    } finally {
      setSalesContractSearchLoading(false);
      setLoading(false);
      setLoadingContext(null);
      setAdminPassword("");
    }
  };

  const clearSalesContractSearchDateRange = async () => {
    const fullPeriodDateValue = "";
    const nextForm = {
      ...salesContractSearchForm,
      dateFrom: fullPeriodDateValue,
      dateTo: fullPeriodDateValue,
    };
    setSalesContractSearchForm(nextForm);
    setCurrentPage(1);
  };

  const resetSalesContractSearchFilters = () => {
    setSalesContractSearchForm(getEmptySalesLookupFilters());
    setSalesContractSearchError("");
    setCurrentPage(1);
  };

  const getAssignableSalesManagers = () =>
    managersConfig.filter(
      (manager) => manager?.code && manager.code !== "default" && manager.name
    );

  const openSalesAssignmentModal = (contract) => {
    if (isSalesLookupMode) {
      // sales lookup mode cannot open assignment controls
      setToastMessage("영업 조회 모드에서는 담당자 지정/변경을 할 수 없습니다.");
      return;
    }
    if (!isHeadquarters()) {
      setToastMessage("본사/미수팀 관리자만 담당영업사원을 지정할 수 있습니다.");
      return;
    }
    setSalesAssignmentModal(contract);
    const currentAssignmentName = String(
      contract?.managerName ||
        contract?.salesAssignment?.salesRepName ||
        contract?.salesAssignment?.salesManagerName ||
        contract?.assignmentStatusLabel ||
        ""
    ).trim();
    const currentPartName = String(
      contract?.partName ||
        contract?.salesPart ||
        contract?.salesAssignment?.partName ||
        contract?.salesRepDepartmentPart ||
        ""
    ).trim();
    setSalesAssignmentDraft({
      nextSalesRepCode: "",
      nextSalesRepName:
        currentAssignmentName && currentAssignmentName !== "담당자 미지정"
          ? currentAssignmentName
          : "",
      nextPartName: currentPartName,
      reason: "",
      syncVendorMaster: false,
    });
    setSalesAssignmentError("");
  };

  const closeSalesAssignmentModal = () => {
    if (salesAssignmentSaving) return;
    setSalesAssignmentModal(null);
    setSalesAssignmentDraft({
      nextSalesRepCode: "",
      nextSalesRepName: "",
      nextPartName: "",
      reason: "",
      syncVendorMaster: false,
    });
    setSalesAssignmentError("");
  };

  const handleSaveSalesAssignment = async () => {
    if (!salesAssignmentModal) return;
    if (isSalesLookupMode) {
      // sales lookup mode cannot open assignment controls
      setSalesAssignmentError("영업 조회 모드에서는 담당자 지정/변경을 할 수 없습니다.");
      return;
    }
    const nextSalesRepName = String(
      salesAssignmentDraft.nextSalesRepName || ""
    ).trim();
    const nextPartName = String(salesAssignmentDraft.nextPartName || "").trim();
    const reason = String(salesAssignmentDraft.reason || "").trim();
    if (!nextSalesRepName) {
      setSalesAssignmentError("새 담당영업사원명을 입력해 주세요.");
      return;
    }
    if (!reason) {
      setSalesAssignmentError("담당자 지정 사유를 입력해 주세요.");
      return;
    }

    setSalesAssignmentSaving(true);
    setSalesAssignmentError("");
    try {
      const response = await fetch("/api/admin-sales-assignment", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          mode: "admin-sales-assignment",
          appId,
          password: adminSessionPasswordRef.current || adminPassword,
          documentId: salesAssignmentModal.documentId,
          contractId: salesAssignmentModal.contractId,
          accessMode: isSalesLookupMode ? "SALES_LOOKUP" : "ADMIN",
          nextSalesRepCode: "",
          nextSalesRepName,
          nextPartName,
          reason,
          syncVendorMaster: salesAssignmentDraft.syncVendorMaster === true,
          updatedBy: currentManager?.name || "본사",
        }),
      });
      const result = await response.json().catch(() => ({
        ok: false,
        message: "담당영업사원을 저장하지 못했습니다.",
      }));
      if (!response.ok || !result?.ok) {
        if (result?.code === "permission-denied") {
          throw new Error("담당자 지정 권한을 확인해 주세요.");
        }
        if (result?.code === "failed-precondition") {
          throw new Error("담당자 지정 저장 조건을 확인해 주세요.");
        }
        throw new Error(result?.message || "담당영업사원을 저장하지 못했습니다.");
      }

      const assignedAt = result.assignedAt || new Date().toISOString();
      setContractList((prev) =>
        prev.map((item) =>
          (item.id || item.documentId) === salesAssignmentModal.documentId
            ? {
                ...item,
                managerCode: "",
                managerName: nextSalesRepName,
                partName: nextPartName,
                salesPart: nextPartName,
                salesAssignment: {
                  salesRepCode: "",
                  salesRepName: nextSalesRepName,
                  salesManagerName: nextSalesRepName,
                  partName: nextPartName,
                  assignedAt,
                  assignedBy: currentManager?.name || "본사",
                  reason,
                  source: "ADMIN_SEARCH_ASSIGNMENT",
                },
                isUnassigned: false,
                assignmentStatusLabel: nextSalesRepName,
                updatedAt: assignedAt,
              }
            : item
        )
      );
      setSelectedContract((prev) => {
        if (!prev) return prev;
        const prevDocumentId = prev.id || prev.documentId;
        if (prevDocumentId !== salesAssignmentModal.documentId) return prev;
        return {
          ...prev,
          managerCode: "",
          managerName: nextSalesRepName,
          partName: nextPartName,
          salesPart: nextPartName,
          salesAssignment: {
            salesRepCode: "",
            salesRepName: nextSalesRepName,
            salesManagerName: nextSalesRepName,
            partName: nextPartName,
            assignedAt,
            assignedBy: currentManager?.name || "본사",
            reason,
            source: "ADMIN_SEARCH_ASSIGNMENT",
          },
          isUnassigned: false,
          assignmentStatusLabel: nextSalesRepName,
          updatedAt: assignedAt,
        };
      });
      if (result.vendorSync?.ok) {
        setVendorMasters((prev) =>
          prev.map((vendor) =>
            (vendor.vendorId || vendor.id) === result.vendorSync.vendorId
              ? {
                  ...vendor,
                  partName: result.vendorSync.partName,
                  salesManagerName: result.vendorSync.salesManagerName,
                  updatedAt: result.vendorSync.updatedAt,
                }
              : vendor
          )
        );
        setSelectedVendorMaster((prev) =>
          prev && (prev.vendorId || prev.id) === result.vendorSync.vendorId
            ? {
                ...prev,
                partName: result.vendorSync.partName,
                salesManagerName: result.vendorSync.salesManagerName,
                updatedAt: result.vendorSync.updatedAt,
              }
            : prev
        );
      }
      setToastMessage("담당영업사원이 저장되었습니다.");
      setSalesAssignmentModal(null);
      setSalesAssignmentDraft({
        nextSalesRepCode: "",
        nextSalesRepName: "",
        nextPartName: "",
        reason: "",
        syncVendorMaster: false,
      });
      setSalesAssignmentError("");
    } catch (error) {
      const message =
        error?.message || "담당영업사원 저장 중 오류가 발생했습니다.";
      console.error("[CNFOOD] sales assignment update failed", sanitizeErrorForLog(error));
      setSalesAssignmentError(message);
      setToastMessage(message);
    } finally {
      setSalesAssignmentSaving(false);
      setAdminPassword("");
    }
  };

  const renderSalesAssignmentModal = () => {
    if (!salesAssignmentModal || isSalesLookupMode || !isHeadquarters()) return null;
    return (
      <div className="fixed inset-0 z-50 flex items-end justify-center bg-slate-950/50 p-3 sm:items-center">
        <div className="max-h-[92vh] w-full max-w-2xl overflow-y-auto rounded-3xl bg-white p-5 shadow-2xl">
          <div className="flex items-start justify-between gap-3">
            <div>
              <p className="text-xs font-black uppercase tracking-[0.18em] text-blue-600">
                Sales Assignment
              </p>
              <h3 className="mt-1 text-xl font-black text-slate-950">
                담당영업사원/파트 수정
              </h3>
              <p className="mt-2 text-sm font-bold leading-6 text-slate-500 break-keep">
                계약 원본과 증빙 해시는 변경하지 않고 운영용 담당 메타데이터만 저장합니다.
              </p>
            </div>
            <button
              type="button"
              onClick={closeSalesAssignmentModal}
              disabled={salesAssignmentSaving}
              className="rounded-full bg-slate-100 px-3 py-2 text-sm font-black text-slate-600 disabled:opacity-50"
            >
              닫기
            </button>
          </div>

          <div className="mt-4 grid grid-cols-1 gap-3 rounded-2xl border border-slate-200 bg-slate-50 p-4 text-sm font-bold text-slate-700 sm:grid-cols-2">
            <div>
              <span className="text-slate-400">상호명</span>
              <p className="mt-1 break-keep text-slate-950">
                {salesAssignmentModal.businessName || "상호명 미수집"}
              </p>
            </div>
            <div>
              <span className="text-slate-400">사업자번호</span>
              <p className="mt-1 text-slate-950">
                {salesAssignmentModal.businessNumber || "사업자번호 미수집"}
              </p>
            </div>
            <div>
              <span className="text-slate-400">현재 담당</span>
              <p className="mt-1 text-slate-950">
                {salesAssignmentModal.assignmentStatusLabel || salesAssignmentModal.managerName || "미지정"}
              </p>
            </div>
            <div>
              <span className="text-slate-400">현재 파트</span>
              <p className="mt-1 text-slate-950">
                {salesAssignmentModal.partName || salesAssignmentModal.salesPart || "미지정"}
              </p>
            </div>
          </div>

          <div className="mt-4 space-y-3">
            <label className="block">
              <span className="mb-1 block text-sm font-black text-slate-700">
                담당영업사원
              </span>
              <input
                type="text"
                value={salesAssignmentDraft.nextSalesRepName}
                onChange={(event) =>
                  setSalesAssignmentDraft((prev) => ({
                    ...prev,
                    nextSalesRepCode: "",
                    nextSalesRepName: event.target.value,
                  }))
                }
                className="min-h-[52px] w-full rounded-2xl border border-slate-200 px-3 text-base font-bold outline-none focus:border-blue-500"
                placeholder="담당자명 또는 영업팀명"
              />
            </label>
            <label className="block">
              <span className="mb-1 block text-sm font-black text-slate-700">
                파트
              </span>
              <p className="mb-2 text-xs font-bold leading-5 text-slate-500 break-keep">
                해당 파트 이름 또는 영업팀 분들의 관리명을 입력하시면 됩니다.
                예: 4영훈은옥 / 11파트 / 영업1팀
              </p>
              <input
                type="text"
                value={salesAssignmentDraft.nextPartName}
                onChange={(event) =>
                  setSalesAssignmentDraft((prev) => ({
                    ...prev,
                    nextPartName: event.target.value,
                  }))
                }
                className="min-h-[52px] w-full rounded-2xl border border-slate-200 px-3 text-base font-bold outline-none focus:border-blue-500"
                placeholder="파트명"
              />
            </label>
            <label className="flex items-start gap-3 rounded-2xl border border-slate-200 bg-slate-50 p-3" aria-label="same business-number vendor master">
              <input
                type="checkbox"
                checked={salesAssignmentDraft.syncVendorMaster === true}
                onChange={(event) =>
                  setSalesAssignmentDraft((prev) => ({
                    ...prev,
                    syncVendorMaster: event.target.checked,
                  }))
                }
                className="mt-1 h-5 w-5 rounded border-slate-300 text-blue-700"
              />
              <span className="text-sm font-bold leading-6 text-slate-600">
                같은 사업자번호의 거래처 마스터에도 반영합니다. 연결된 거래처가 없으면 계약 담당 정보만 저장됩니다.
              </span>
            </label>
            <label className="block">
              <span className="mb-1 block text-sm font-black text-slate-700">
                수정 사유
              </span>
              <textarea
                value={salesAssignmentDraft.reason}
                onChange={(event) =>
                  setSalesAssignmentDraft((prev) => ({
                    ...prev,
                    reason: event.target.value,
                  }))
                }
                className="min-h-[96px] w-full rounded-2xl border border-slate-200 px-3 py-3 text-base font-bold leading-7 outline-none focus:border-blue-500"
                placeholder="운영 담당 변경 사유를 입력해 주세요."
              />
            </label>
            {salesAssignmentError && (
              <div className="rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-base font-bold leading-7 text-red-700 break-keep">
                {salesAssignmentError}
              </div>
            )}
            <div className="flex flex-col gap-2 sm:flex-row sm:justify-end">
              <button
                type="button"
                onClick={closeSalesAssignmentModal}
                disabled={salesAssignmentSaving}
                className="min-h-[48px] rounded-2xl border border-slate-200 px-4 py-3 text-base font-black text-slate-600 disabled:opacity-50"
              >
                취소
              </button>
              <button
                type="button"
                onClick={handleSaveSalesAssignment}
                disabled={salesAssignmentSaving}
                className="inline-flex min-h-[48px] items-center justify-center gap-2 rounded-2xl bg-blue-700 px-4 py-3 text-base font-black text-white shadow-sm disabled:bg-slate-300"
              >
                {salesAssignmentSaving && <Loader2 className="h-5 w-5 animate-spin" />}
                저장
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const verifyAdminCredentials = async (
    mode: "admin" | "debug" | "sales_lookup" | "sales_payment" | "payment",
    password: string,
    options: { salesRepCode?: string } = {}
  ) => {
    const response = await fetch("/api/admin-login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        mode,
        password,
        ...(mode === "sales_payment"
          ? { salesRepCode: options.salesRepCode || "" }
          : {}),
      }),
    });
    const result = await response.json().catch(() => ({
      ok: false,
      message: "비밀번호를 확인하지 못했습니다.",
    }));

    if (!response.ok && !result?.message) {
      return {
        ok: false,
        message: "비밀번호를 확인하지 못했습니다.",
      };
    }

    return result;
  };

  const loadSalesPaymentLoginOptions = async () => {
    const password = adminPassword.trim();
    if (!password) {
      setSalesPaymentLoginOptions([]);
      setSalesPaymentCode("");
      setSalesPaymentManagerSearch("");
      setSalesPaymentManagerListOpen(false);
      setSalesPaymentLoginOptionsError("공통 비밀번호를 먼저 입력해 주세요.");
      return;
    }

    setSalesPaymentLoginOptionsLoading(true);
    setSalesPaymentLoginOptionsError("");
    try {
      const response = await fetch("/api/admin-login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          mode: "sales-payment-users",
          password,
        }),
      });
      const result = await response.json().catch(() => ({}));
      const users = Array.isArray(result?.users)
        ? result.users
            .map((user) => ({
              code: String(user?.code || "").trim().slice(0, 40),
              name: String(user?.name || "").trim().slice(0, 80),
            }))
            .filter((user) => user.code && user.name)
        : [];
      if (!response.ok || !result?.ok || users.length === 0) {
        setSalesPaymentLoginOptions([]);
        setSalesPaymentCode("");
        setSalesPaymentManagerSearch("");
        setSalesPaymentManagerListOpen(false);
        setSalesPaymentLoginOptionsError(
          result?.message || "담당자 목록을 불러오지 못했습니다."
        );
        return;
      }
      setSalesPaymentLoginOptions(users);
      const selectedOption = getSalesPaymentLoginOptionByCode(users, salesPaymentCode);
      if (!selectedOption) {
        setSalesPaymentCode("");
        setSalesPaymentManagerSearch("");
      } else {
        setSalesPaymentManagerSearch(selectedOption.name);
      }
      setSalesPaymentManagerListOpen(false);
    } catch (error) {
      console.error("[CNFOOD] sales payment login options load failed", {
        error: sanitizeErrorForLog(error),
      });
      setSalesPaymentLoginOptions([]);
      setSalesPaymentCode("");
      setSalesPaymentManagerSearch("");
      setSalesPaymentManagerListOpen(false);
      setSalesPaymentLoginOptionsError(
        "담당자 목록을 불러오지 못했습니다. 잠시 후 다시 시도해 주세요."
      );
    } finally {
      setSalesPaymentLoginOptionsLoading(false);
    }
  };

  const handleSalesPaymentManagerSelect = (
    option: SalesPaymentLoginOption
  ): void => {
    const selection = getSalesPaymentManagerSelection(option);
    setSalesPaymentCode(selection.salesPaymentCode);
    setSalesPaymentManagerSearch(selection.managerSearch);
    setSalesPaymentManagerListOpen(selection.isListOpen);
    setSalesPaymentLoginOptionsError("");

    requestAnimationFrame(() => {
      salesPaymentManagerInputRef.current?.blur();
      salesPaymentEnterButtonRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    });
  };

  const handleLockClick = () => {
    setPendingConfirm(null);
    setFieldPrintPreviewOpen(false);
    setFieldPrintDialogOpen(false);
    setAdminPassword("");
    adminSessionPasswordRef.current = "";
    salesPaymentActorCodeRef.current = "";
    setSalesPaymentCode("");
    setSalesPaymentManagerSearch("");
    setSalesPaymentManagerListOpen(false);
    setSalesPaymentLoginOptions([]);
    setSalesPaymentLoginOptionsError("");
    setAdminTestModeAuthorized(false);
    setAdminContractStartMode(false);
    setAdminAccessMode("ADMIN");
    setViewMode("ADMIN_LOGIN");
  };

  const handleStartFromIntro = async ({ adminTestMode = false } = {}) => {
    const adminTestStart = Boolean(adminTestMode && canUseAdminContractStart);
    if (!contractAppStatusLoaded && !adminTestStart) {
      setToastMessage(APP_STATUS_LOADING_MESSAGE);
    }
    submitContractInFlightRef.current = false;
    pendingSavedDocumentIdRef.current = null;
    pendingSubmittedContractRef.current = null;
    clearActiveKcpReturnNavigationIntent();
    clearKcpVerifiedNavigationRetry();
    const latest = await requestContractAppStatus({ silent: true });
    const gate = canStartNewContract(latest || contractAppStatus, {
      isAdmin:
        (adminAccessMode === "ADMIN" && Boolean(currentManager?.name)) ||
        adminTestStart,
      statusLoaded: true,
      bypassPause: adminTestStart,
    });
    if (!gate.allowed) {
      setToastMessage(gate.message);
      return;
    }
    showIntroPageRef.current = false;
    setAdminContractStartMode(adminTestStart);
    setCompletionReceipt(null);
    setCompletionReceiptError("");
    setSavedContractDocumentId("");
    setSubmitState("IDLE");
    setShowIntroPage(false);
    setStepEvidence({ businessInfo: null, identity: null, contractReview: null, signature: null });
    goToStep(0, adminTestStart ? { allowDuringKcpReturnSync: true } : {});
    if (adminTestStart) {
      setToastMessage("관리자 테스트 모드로 계약 작성을 시작합니다.");
    }
  };

  const handleStartAdminContractTest = () => {
    if (!canUseAdminContractStart) {
      setToastMessage("관리자 인증 후 사용할 수 있습니다.");
      return;
    }
    void handleStartFromIntro({ adminTestMode: true });
  };

  // [수정] 관리자 로그인 및 디버그 모드 진입
  const handleAdminLogin = async () => {
    await handleAdminAccessSubmit();
  };

  const handleAdminLoginLegacy = async () => {
    await handleAdminAccessSubmit();
  };

  const handleAdminAccessSubmitLegacy = async () => {
    await handleAdminAccessSubmit();
  };

  const handleAdminLoginSubmit = async () => {
    await handleAdminAccessSubmit();
  };

  const handleAdminAccessSubmitLegacyCurrent = async () => {
    await handleAdminAccessSubmit();
  };

  const handleAdminAccessSubmit = async () => {
    const selectedAdminMode =
      managerTarget && managerTarget !== "none" ? managerTarget : null;
    const targetMeta = getResolvedManagerTargetMeta(selectedAdminMode);
    const targetManager = targetMeta.manager;
    const trimmedPassword = adminPassword.trim();

    if (!selectedAdminMode) {
      setToastMessage("모드를 먼저 선택해 주세요.");
      return;
    }

    if (!targetManager) {
      setToastMessage("선택한 담당자 정보를 찾지 못했습니다.");
      return;
    }

    if (!trimmedPassword) {
      setToastMessage("비밀번호를 입력해 주세요.");
      return;
    }

    if (
      selectedAdminMode === "sales_payment" &&
      !getSalesPaymentLoginOptionByCode(salesPaymentLoginOptions, salesPaymentCode)
    ) {
      setToastMessage("담당자를 목록에서 선택해 주세요.");
      return;
    }

    setLoading(true);
    setLoadingContext("login");
    try {
      const loginMode = getAdminLoginVerificationMode(selectedAdminMode);
      const authResult = await verifyAdminCredentials(loginMode, trimmedPassword, {
        salesRepCode: salesPaymentCode.trim(),
      });

      if (!authResult?.ok) {
        adminSessionPasswordRef.current = "";
        salesPaymentActorCodeRef.current = "";
        setToastMessage(authResult?.message || "비밀번호가 올바르지 않습니다.");
        return;
      }

      if (selectedAdminMode === "debug") {
        setAdminAccessMode("ADMIN");
        adminSessionPasswordRef.current = "";
        setAdminTestModeAuthorized(true);
        setCurrentManager(targetManager);
        setErrorReports([]);
        await fetchErrorReports();
        return;
      }

      adminSessionPasswordRef.current = trimmedPassword;
      salesPaymentActorCodeRef.current = "";
      setAdminTestModeAuthorized(selectedAdminMode === "default");
      setCurrentManager(targetManager);
      setContractList([]);
      setCurrentPage(1);
      setPendingConfirm(null);
      resetDetailRejectState();
      if (selectedAdminMode === "sales_lookup") {
        const salesLookupForm = getEmptySalesLookupFilters();
        setAdminAccessMode("SALES_LOOKUP");
        setSalesContractSearchForm(salesLookupForm);
        setAdminTab("SALES_SEARCH");
        await loadSalesContractSearch({
          manager: targetManager,
          form: salesLookupForm,
          reload: true,
        });
        return;
      }
      if (selectedAdminMode === "payment") {
        setAdminAccessMode("PAYMENT");
        setAdminTab("PAYMENT_MANAGEMENT");
        setViewMode("LIST");
        await loadPaymentDirectory({ bypassAccess: true });
        void loadPaymentRequests({ bypassAccess: true });
        return;
      }
      if (selectedAdminMode === "sales_payment") {
        const actor = authResult?.actor || {};
        const authenticatedManager = {
          code: String(actor.code || salesPaymentCode).trim(),
          name: String(actor.name || "영업사원").trim(),
          email: "",
        };
        salesPaymentActorCodeRef.current = authenticatedManager.code;
        setAdminAccessMode("SALES_PAYMENT");
        setCurrentManager(authenticatedManager);
        setPaymentRequestForm({
          ...createEmptyPaymentRequestForm(),
          requestType: "BUYLINK",
          paymentProfileId: "CNFOOD_LINK",
        });
        setAdminTab("PAYMENT_MANAGEMENT");
        setViewMode("LIST");
        await loadPaymentDirectory({ bypassAccess: true });
        return;
      }
      if (selectedAdminMode === "field_print") {
        setAdminAccessMode("FIELD_PRINT");
        setAdminTab("LIST");
        setViewMode("LIST");
        setFieldPrintPreviewOpen(false);
        setFieldPrintDialogOpen(true);
        return;
      }
      setAdminAccessMode("ADMIN");
      if (!isHeadquarters(targetManager)) {
        setAdminTab("SALES_SEARCH");
        await loadSalesContractSearch({
          manager: targetManager,
          form: getEmptySalesLookupFilters(),
          reload: true,
        });
        return;
      }
      setAdminTab(getDefaultAdminTabForViewport());
      await fetchAndShowList(targetManager);
    } catch (error) {
      console.error("[CNFOOD] admin login failed", {
        managerTarget: selectedAdminMode,
        targetName: targetManager?.name || null,
        error: sanitizeErrorForLog(error),
      });
      setToastMessage(
        "관리자 접속 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요."
      );
    } finally {
      setLoading(false);
      setLoadingContext(null);
    }
  };

  const fetchAndShowList = async (managerOverride = currentManager) => {
    const effectiveManager = resolveContractsLoadManager(
      managerOverride,
      currentManager
    );
    console.info("[CNFOOD] fetchAndShowList start", {
      managerName: effectiveManager?.name || null,
    });
    setLoadingContext("list");
    setLoading(true);
    try {
      const contractsRef = collection(
        db,
        "artifacts",
        appId,
        "public",
        "data",
        "contracts"
      );
      let querySnapshot;
      let usedFallback = false;

      try {
        const orderedQuery = query(contractsRef, orderBy("submittedAt", "desc"));
        querySnapshot = await getDocs(orderedQuery);
      } catch (e) {
        const code = e?.code || "";

        if (code === "permission-denied") {
          console.error("[CNFOOD] contracts list permission denied", {
            code,
            manager: effectiveManager?.name || "unknown",
            isHeadquarters: isHeadquarters(effectiveManager),
            path: "artifacts/cnfood-final-v48/public/data/contracts",
            error: e,
          });
          setToastMessage("목록 조회 권한이 없습니다. Firestore 규칙을 확인해 주세요.");
          return;
        }

        if (code === "failed-precondition") {
          console.warn("[CNFOOD] contracts list failed-precondition, retrying without orderBy", {
            code,
            manager: effectiveManager?.name || "unknown",
            path: "artifacts/cnfood-final-v48/public/data/contracts",
            error: e,
          });
          usedFallback = true;

          try {
            querySnapshot = await getDocs(query(contractsRef));
          } catch (fallbackError) {
            const fallbackCode = fallbackError?.code || "";
            console.error("[CNFOOD] contracts list fallback failed", {
              code: fallbackCode,
              manager: effectiveManager?.name || "unknown",
              isHeadquarters: isHeadquarters(effectiveManager),
              path: "artifacts/cnfood-final-v48/public/data/contracts",
              error: fallbackError,
            });

            if (fallbackCode === "permission-denied") {
              setToastMessage("목록 조회 권한이 없습니다. Firestore 규칙을 확인해 주세요.");
            } else {
              setToastMessage("목록을 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.");
            }
            return;
          }
        } else {
          console.error("[CNFOOD] contracts list load failed", {
            code,
            manager: effectiveManager?.name || "unknown",
            isHeadquarters: isHeadquarters(effectiveManager),
            path: "artifacts/cnfood-final-v48/public/data/contracts",
            error: e,
          });
          setToastMessage("목록을 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.");
          return;
        }
      }

      const rawList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      const rawCount = rawList.length;
      const rawManagerNameSamples = Array.from(
        new Set(
          rawList
            .map((item) =>
              typeof item.managerName === "string" ? item.managerName.trim() : ""
            )
            .filter(Boolean)
        )
      ).slice(0, 5);
      let list = rawList;
      if (!isHeadquarters(effectiveManager)) {
        list = list.filter((item) => item.managerName === effectiveManager?.name);
      }
      const filteredCount = list.length;

      console.info("[CNFOOD] list fetched", {
        appId,
        path: "artifacts/cnfood-final-v48/public/data/contracts",
        manager: effectiveManager?.name || "unknown",
        isHeadquarters: isHeadquarters(effectiveManager),
        rawCount,
        filteredCount,
        usedFallback,
      });

      if (!isHeadquarters(effectiveManager) && rawCount > 0 && filteredCount === 0) {
        console.warn("[CNFOOD] manager filter produced empty result", {
          manager: effectiveManager?.name || "unknown",
          rawCount,
          filteredCount,
          rawManagerNameSamples,
        });
      }

      if (usedFallback) {
        list.sort((a, b) => {
          const aSubmittedAt =
            typeof a.submittedAt === "string" ? a.submittedAt : "";
          const bSubmittedAt =
            typeof b.submittedAt === "string" ? b.submittedAt : "";

          if (!aSubmittedAt && !bSubmittedAt) return 0;
          if (!aSubmittedAt) return 1;
          if (!bSubmittedAt) return -1;
          return bSubmittedAt.localeCompare(aSubmittedAt);
        });
        setToastMessage("인덱스 설정이 없어 기본 정렬로 불러왔습니다.");
      }

      if (rawCount === 0) {
        console.info("[CNFOOD] contracts dataset empty", {
          appId,
          path: "artifacts/cnfood-final-v48/public/data/contracts",
          manager: effectiveManager?.name || "unknown",
          isHeadquarters: isHeadquarters(effectiveManager),
        });
        setToastMessage("등록된 계약 데이터가 없습니다.");
      } else if (!isHeadquarters(effectiveManager) && filteredCount === 0) {
        setToastMessage("해당 담당자의 계약 데이터가 없습니다.");
      }

      setContractList(list);
      setCurrentPage(1);
      setPendingConfirm(null);
      resetDetailRejectState();
      console.info("[CNFOOD] fetchAndShowList switching to LIST");
      setViewMode("LIST");
    } catch (e) {
      console.error("[CNFOOD] contracts list unexpected failure", {
        manager: effectiveManager?.name || "unknown",
        isHeadquarters: isHeadquarters(effectiveManager),
        path: "artifacts/cnfood-final-v48/public/data/contracts",
        error: e,
      });
      setToastMessage("목록을 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.");
    } finally {
      setLoading(false);
      setLoadingContext(null);
      setAdminPassword("");
    }
  };

  const handleContractClick = async (contract) => {
    if (!isHeadquarters()) {
      setToastMessage("영업사원 화면에서는 기본 계약 현황만 확인할 수 있습니다.");
      return;
    }
    resetDetailRejectState();
    setRevealedSsn(null);
    setRevealedCoRepresentativeSsns({});
    setLoading(true);
    try {
      const resultImg = await generateContractImage(
        contract.signature,
        contract.contractId,
        "HQ",
        contract,
        contract.signature2
      );
      setSelectedContract({ ...contract, resultImg });
      setAdminMemoDraft(contract.adminMemo || "");
      setAdminContractDateDraft(
        getContractDisplayDateValue(contract) || contract.contractDate || ""
      );
      setAdminContractDateUpdateReason("");
      const logsRef = collection(db, "artifacts", appId, "admin_logs");
      const q = query(logsRef, orderBy("timestamp", "desc"));
      const logSnap = await getDocs(q);
      const adminActionLogs = logSnap.docs
        .map((d) => d.data())
        .filter((l) => l.contractId === contract.contractId);
      setAdminLogs(adminActionLogs);
      logAdminAction("상세 조회", contract.contractId, currentManager.name);
      logContractEvent(contract.id, {
        type: "ADMIN_VIEWED",
        contractId: contract.contractId,
        actorType: "ADMIN",
        managerCode: currentManager?.code || "default",
        detail: {
          managerName: currentManager?.name || "본사",
        },
      });
      setPendingConfirm(null);
      setViewMode("DETAIL");
    } catch (e) {
      console.error("[CNFOOD] contract detail failed", sanitizeErrorForLog(e));
      setToastMessage(
        getFirestoreErrorToastMessage(
          e,
          "계약 상세 정보를 불러오는 중 오류가 발생했습니다."
        )
      );
    } finally {
      setLoading(false);
    }
  };

  const saveAdminMemo = async () => {
    if (!selectedContract) return;
    setMemoSaving(true);
    try {
      const updatedAt = new Date().toISOString();
      const docRef = getContractDocumentRef(selectedContract.id);
      await updateDoc(docRef, {
        adminMemo: adminMemoDraft,
        updatedAt,
      });
      setSelectedContract((prev) =>
        prev
          ? {
              ...prev,
              adminMemo: adminMemoDraft,
              updatedAt,
            }
          : prev
      );
      setContractList((prev) =>
        prev.map((contract) =>
          contract.id === selectedContract.id
            ? {
                ...contract,
                adminMemo: adminMemoDraft,
                updatedAt,
              }
            : contract
        )
      );
      setToastMessage("메모를 저장했습니다.");
    } catch (e) {
      handleAdminWriteError(e, "saveAdminMemo");
    } finally {
      setMemoSaving(false);
    }
  };

  const saveAdminContractDate = async () => {
    if (!selectedContract || adminContractDateSaving) return;
    const nextAdminContractDate = String(adminContractDateDraft || "").trim();
    if (!isValidDateOnlyString(nextAdminContractDate)) {
      setToastMessage("계약서 표시 계약일을 YYYY-MM-DD 형식으로 선택해 주세요.");
      return;
    }

    const documentId = selectedContract.id || selectedContract.documentId;
    if (!documentId) {
      setToastMessage("계약일을 저장할 계약 문서 ID를 확인할 수 없습니다.");
      return;
    }

    const reason = String(adminContractDateUpdateReason || "").trim();
    const updatedBy = currentManager?.name || currentManager?.code || "관리자";
    const beforeAdminContractDate = String(
      selectedContract.adminContractDate || ""
    ).trim();
    const updatedAt = new Date().toISOString();
    const localPatch = {
      adminContractDate: nextAdminContractDate,
      adminContractDateUpdatedAt: updatedAt,
      adminContractDateUpdatedBy: updatedBy,
      adminContractDateUpdateReason: reason,
    };

    setAdminContractDateSaving(true);
    try {
      await updateDoc(getContractDocumentRef(documentId), {
        adminContractDate: nextAdminContractDate,
        adminContractDateUpdatedAt: serverTimestamp(),
        adminContractDateUpdatedBy: updatedBy,
        adminContractDateUpdateReason: reason,
      });
      await logContractEvent(documentId, {
        type: "UPDATE_ADMIN_CONTRACT_DATE",
        contractId: selectedContract.contractId,
        actorType: "ADMIN",
        managerCode: currentManager?.code || "default",
        detail: {
          contractId: selectedContract.contractId || null,
          beforeAdminContractDate: beforeAdminContractDate || null,
          afterAdminContractDate: nextAdminContractDate,
          reason: reason || null,
          updatedBy,
        },
      });
      await logAdminAction(
        "UPDATE_ADMIN_CONTRACT_DATE",
        selectedContract.contractId,
        updatedBy,
        `${beforeAdminContractDate || "none"} -> ${nextAdminContractDate}${
          reason ? ` / ${reason}` : ""
        }`
      );
      setSelectedContract((prev) =>
        prev
          ? {
              ...prev,
              ...localPatch,
            }
          : prev
      );
      setContractList((prev) =>
        prev.map((contract) =>
          (contract.id || contract.documentId) === documentId
            ? {
                ...contract,
                ...localPatch,
              }
            : contract
        )
      );
      setAdminContractDateUpdateReason("");
      setToastMessage("계약서 표시 계약일이 저장되었습니다.");
    } catch (error) {
      console.error("admin contract date save failed", sanitizeErrorForLog(error));
      const code = error?.code || "";
      if (code === "permission-denied") {
        setToastMessage("계약일 수정 권한이 없습니다. 관리자 권한을 확인해 주세요.");
      } else if (code === "failed-precondition") {
        setToastMessage(
          "계약일 수정 조건을 확인할 수 없습니다. 잠시 후 다시 시도해 주세요."
        );
      } else {
        setToastMessage("계약일 저장 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.");
      }
    } finally {
      setAdminContractDateSaving(false);
    }
  };

  const openBusinessNameCorrectionModal = () => {
    if (!selectedContract) return;
    const correction = getBusinessNameCorrection(selectedContract);
    setBusinessNameCorrectionDraft({
      correctedName:
        trimBusinessNameCorrectionText(correction?.correctedName) ||
        getBusinessNameCorrectionOriginalName(selectedContract),
      reason: trimBusinessNameCorrectionText(correction?.reason),
      source:
        trimBusinessNameCorrectionText(correction?.source) ||
        "BUSINESS_REGISTRATION_CONFIRMED",
    });
    setBusinessNameCorrectionError("");
    setShowBusinessNameCorrectionModal(true);
  };

  const closeBusinessNameCorrectionModal = () => {
    if (businessNameCorrectionSaving) return;
    setShowBusinessNameCorrectionModal(false);
    setBusinessNameCorrectionError("");
  };

  const saveBusinessNameCorrection = async () => {
    if (!selectedContract || businessNameCorrectionSaving) return;
    const correctedAt = new Date().toISOString();
    const result = buildBusinessNameCorrectionPatch({
      contract: selectedContract,
      correctedName: businessNameCorrectionDraft.correctedName,
      reason: businessNameCorrectionDraft.reason,
      source: businessNameCorrectionDraft.source,
      correctedBy: currentManager?.name || currentManager?.code || "관리자",
      correctedAt,
    });

    if (!result.ok) {
      setBusinessNameCorrectionError(result.message);
      setToastMessage(result.message);
      return;
    }

    setBusinessNameCorrectionSaving(true);
    try {
      const docRef = getContractDocumentRef(selectedContract.id);
      await updateDoc(docRef, result.patch);
      await logContractEvent(selectedContract.id, {
        type: "BUSINESS_NAME_CORRECTED",
        contractId: selectedContract.contractId,
        actorType: "ADMIN",
        managerCode: currentManager?.code || "default",
        detail: {
          originalName: result.patch.businessNameCorrection.originalName,
          correctedName: result.patch.businessNameCorrection.correctedName,
          reason: result.patch.businessNameCorrection.reason,
          source: result.patch.businessNameCorrection.source,
          correctedBy: result.patch.businessNameCorrection.correctedBy,
          businessNumber: result.patch.businessNameCorrection.businessNumber,
          affectsContractParty: false,
        },
      });
      await logAdminAction(
        "사업자 정보 정정",
        selectedContract.contractId,
        currentManager?.name || "관리자",
        `${result.patch.businessNameCorrection.originalName} → ${result.patch.businessNameCorrection.correctedName} / ${result.patch.businessNameCorrection.reason}`
      );

      setSelectedContract((prev) =>
        prev
          ? {
              ...prev,
              businessNameCorrection: result.patch.businessNameCorrection,
            }
          : prev
      );
      setContractList((prev) =>
        prev.map((contract) =>
          contract.id === selectedContract.id
            ? {
                ...contract,
                businessNameCorrection: result.patch.businessNameCorrection,
              }
            : contract
        )
      );
      setShowBusinessNameCorrectionModal(false);
      setBusinessNameCorrectionError("");
      setToastMessage("사업자 정보 정정 이력을 저장했습니다.");
    } catch (error) {
      console.error("business name correction failed", sanitizeErrorForLog(error));
      setBusinessNameCorrectionError(
        getFirestoreErrorToastMessage(
          error,
          "사업자 정보 정정 저장 중 오류가 발생했습니다."
        )
      );
      setToastMessage(
        getFirestoreErrorToastMessage(
          error,
          "사업자 정보 정정 저장 중 오류가 발생했습니다."
        )
      );
    } finally {
      setBusinessNameCorrectionSaving(false);
    }
  };

  const revealSelectedContractSsn = async () => {
    if (!selectedContract || ssnRevealLoading) return;
    setSsnRevealLoading(true);
    try {
      const reason = ssnRevealReason.trim();
      if (!reason) {
        setToastMessage("주민번호 열람 사유를 입력해 주세요.");
        return;
      }
      const passwordForApi = adminSessionPasswordRef.current || adminPassword;
      if (!passwordForApi) {
        setToastMessage("관리자 비밀번호 확인이 필요합니다.");
        return;
      }
      const response = await fetch("/api/reveal-ssn", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          mode: "reveal-ssn",
          appId,
          documentId: selectedContract.id,
          contractId: selectedContract.contractId,
          password: passwordForApi,
          reason,
          subjectType: "PRINCIPAL",
          revealedBy: currentManager?.name || "본사",
        }),
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok || !payload?.ok) {
        throw new Error(payload?.message || payload?.code || "SSN_REVEAL_FAILED");
      }
      setRevealedSsn(payload.residentNumber || null);
      setToastMessage("주민번호 열람 이력이 서버 관리자 로그에 기록되었습니다.");
      return;
      const hasInspectableSsn = Boolean(
        selectedContract.principalRepSsnEncrypted ||
          selectedContract.principalRepSsnMasked ||
          selectedContract.guarantorSsnEncrypted ||
          selectedContract.guarantorSsnMasked ||
          selectedContract.ssnEncrypted ||
          selectedContract.ssnMasked ||
          selectedContract.ssnFront
      );
      if (!hasInspectableSsn) {
        setToastMessage("확인 가능한 주민번호 마스킹 정보가 없습니다.");
        return;
      }

      const principalSsnCipherText = getPrincipalRepSsnCipherText(selectedContract);
      let nextRevealedSsn: string | null = null;

      if (principalSsnCipherText) {
        const decryptedSsn = await decryptText(principalSsnCipherText);
        nextRevealedSsn = formatDecryptedResidentRegistrationNumber(decryptedSsn);
      } else {
        nextRevealedSsn = getLegacyPlainSsnDisplayValue(selectedContract);
      }

      if (!nextRevealedSsn) {
        setToastMessage("암호화된 주민번호 원본을 확인할 수 없습니다.");
        return;
      }

      const requestMeta = await fetchRequestMeta();
      const accessRecord = buildSsnAccessRecord({
        managerName: currentManager?.name,
        managerEmail: currentManager?.email,
        ip: requestMeta.ip,
        userAgent: requestMeta.userAgent,
      });
      const nextMemo = appendSsnAccessMemoLine(adminMemoDraft, accessRecord);
      const previousLogs = Array.isArray(selectedContract.ssnAccessLogs)
        ? selectedContract.ssnAccessLogs
        : [];
      const nextSsnAccessLogs = [...previousLogs, accessRecord];
      const updatedAt = new Date().toISOString();
      const docRef = doc(
        db,
        "artifacts",
        appId,
        "public",
        "data",
        "contracts",
        selectedContract.id
      );

      await updateDoc(docRef, {
        adminMemo: nextMemo,
        ssnAccessLogs: nextSsnAccessLogs,
        lastSsnAccess: accessRecord,
        updatedAt,
      });
      await logAdminAction(
        "주민번호 확인",
        selectedContract.contractId,
        currentManager?.name,
        formatSsnAccessMemoLine(accessRecord)
      );

      const nextContract = {
        ...selectedContract,
        adminMemo: nextMemo,
        ssnAccessLogs: nextSsnAccessLogs,
        lastSsnAccess: accessRecord,
        updatedAt,
      };
      setRevealedSsn(nextRevealedSsn);
      setAdminMemoDraft(nextMemo);
      setSelectedContract(nextContract);
      setContractList((prev) =>
        prev.map((contract) =>
          contract.id === selectedContract.id ? nextContract : contract
        )
      );
      setToastMessage("주민번호 확인 이력이 기록되었고 열람이 허용되었습니다.");
    } catch (error) {
      console.error("reveal SSN failed", sanitizeErrorForLog(error));
      setToastMessage("주민번호 확인 중 오류가 발생했습니다.");
    } finally {
      setSsnRevealLoading(false);
    }
  };

  const handleRevealSsnClick = () => {
    if (revealedSsn) {
      setRevealedSsn(null);
      return;
    }

    openConfirmPanel({
      scope: "DETAIL",
      title: "주민번호 확인",
      message:
        "미수관리 목적의 주민번호 확인 이력이 관리자 메모와 관리항목에 기록됩니다. 계속하시겠습니까?",
      confirmLabel: "확인 기록 후 열람",
      tone: "warning",
      scrollToTop: true,
      onConfirm: revealSelectedContractSsn,
    });
  };

  const handleRevealCoRepresentativeSsnClick = async (representative = {}) => {
    if (!selectedContract || coRepresentativeSsnRevealLoadingId) return;
    const subjectId = getCoRepresentativeOutputMatchId(representative);
    if (!subjectId) {
      setToastMessage("공동계약인 ID를 확인할 수 없습니다.");
      return;
    }
    if (revealedCoRepresentativeSsns[subjectId]) {
      setRevealedCoRepresentativeSsns((prev) => {
        const next = { ...prev };
        delete next[subjectId];
        return next;
      });
      return;
    }
    const reason = ssnRevealReason.trim();
    if (!reason) {
      setToastMessage("주민번호 열람 사유를 입력해 주세요.");
      return;
    }
    const passwordForApi = adminSessionPasswordRef.current || adminPassword;
    if (!passwordForApi) {
      setToastMessage("관리자 비밀번호 확인이 필요합니다.");
      return;
    }
    setCoRepresentativeSsnRevealLoadingId(subjectId);
    try {
      const response = await fetch("/api/reveal-ssn", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          mode: "reveal-ssn",
          appId,
          documentId: selectedContract.id,
          contractId: selectedContract.contractId,
          password: passwordForApi,
          reason,
          subjectType: "CO_REP",
          subjectId,
          revealedBy: currentManager?.name || "본사",
        }),
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok || !payload?.ok) {
        throw new Error(payload?.message || payload?.code || "SSN_REVEAL_FAILED");
      }
      const residentNumber = formatDecryptedResidentRegistrationNumber(
        payload.residentNumber || ""
      );
      if (!residentNumber) {
        throw new Error("SSN_REVEAL_INVALID_FORMAT");
      }
      setRevealedCoRepresentativeSsns((prev) => ({
        ...prev,
        [subjectId]: residentNumber,
      }));
      setToastMessage("공동계약인 주민번호 열람 이력을 기록했습니다.");
    } catch (error) {
      console.error("reveal co-representative SSN failed", sanitizeErrorForLog(error));
      setToastMessage("공동계약인 주민번호 확인 중 오류가 발생했습니다.");
    } finally {
      setCoRepresentativeSsnRevealLoadingId("");
    }
  };

  const updateContractStatus = async (status, reason = "", skipConfirm = false) => {
    if (!selectedContract) return;
    const actionLabel =
      status === "confirmed" ? "확정" : status === "completed" ? "복구" : "반려";
    const actionLogLabel =
      status === "confirmed" ? "계약 확정" : status === "completed" ? "계약 복구" : "계약 반려";
    if (!skipConfirm) {
      openConfirmPanel({
        scope: "DETAIL",
        title: `계약 ${actionLabel} 확인`,
        message: `정말 이 계약을 ${actionLabel} 처리하시겠습니까?`,
        confirmLabel: actionLabel,
        tone: status === "rejected" ? "danger" : "warning",
        onConfirm: async () => {
          await updateContractStatus(status, reason, true);
        },
      });
      return;
    }
    setLoading(true);
    try {
      const updatedAt = new Date().toISOString();
      const docRef = getContractDocumentRef(selectedContract.id);
      await updateDoc(docRef, {
        status,
        rejectReason: reason,
        updatedAt,
      });
      logContractEvent(selectedContract.id, {
        type: "ADMIN_STATUS_CHANGED",
        contractId: selectedContract.contractId,
        actorType: "ADMIN",
        managerCode: currentManager?.code || "default",
        detail: {
          status,
          reason: reason || null,
        },
      });
      const logSaved = await logAdminAction(
        actionLogLabel,
        selectedContract.contractId,
        currentManager.name,
        reason
      );
      setToastMessage("처리가 완료되었습니다.");
      if (!logSaved) {
        console.error("admin log write failed after status update", {
          contractId: selectedContract.contractId,
          status,
        });
        setToastMessage("처리는 완료되었지만 관리자 로그 기록에 실패했습니다.");
      }
      setSelectedContract((prev) => ({
        ...prev,
        status,
        rejectReason: reason,
        updatedAt,
      }));
      resetDetailRejectState();
      fetchAndShowList();
    } catch (e) {
      handleAdminWriteError(e, "updateContractStatus");
      return;
    } finally {
      setLoading(false);
    }
  };

  const deleteContract = async (skipConfirm = false) => {
    if (!selectedContract) return;
    if (!skipConfirm) {
      openConfirmPanel({
        scope: "DETAIL",
        title: "계약 영구 삭제 확인",
        message: "정말 이 계약을 영구 삭제하시겠습니까?",
        confirmLabel: "영구 삭제",
        tone: "danger",
        onConfirm: async () => {
          await deleteContract(true);
        },
      });
      return;
    }
    setLoading(true);
    try {
      throw new Error("CLIENT_HARD_DELETE_DISABLED");
      setToastMessage("계약이 삭제되었습니다.");
      setPendingConfirm(null);
      resetDetailRejectState();
      setViewMode("LIST");
      fetchAndShowList();
    } catch (e) {
      handleAdminWriteError(e, "deleteContract");
      return;
    } finally {
      setLoading(false);
    }
  };

  const softDeleteContract = async (skipConfirm = false) => {
    if (!selectedContract) return;
    if (!skipConfirm) {
      openConfirmPanel({
        scope: "DETAIL",
        title: "계약 삭제 확인",
        message: "이 계약을 휴지통으로 이동하시겠습니까?",
        confirmLabel: "삭제",
        tone: "danger",
        onConfirm: async () => {
          await softDeleteContract(true);
        },
      });
      return;
    }
    setLoading(true);
    try {
      const updatedAt = new Date().toISOString();
      const docRef = doc(
        db,
        "artifacts",
        appId,
        "public",
        "data",
        "contracts",
        selectedContract.id
      );
      await updateDoc(docRef, {
        status: "deleted",
        updatedAt,
      });
      const logSaved = await logAdminAction(
        "휴지통 이동",
        selectedContract.contractId,
        currentManager.name
      );
      setToastMessage("계약이 휴지통으로 이동되었습니다.");
      setPendingConfirm(null);
      resetDetailRejectState();
      setViewMode("LIST");
      fetchAndShowList();
      if (!logSaved) {
        console.error("admin log write failed after soft delete", {
          contractId: selectedContract.contractId,
        });
        setToastMessage("처리는 완료되었지만 관리자 로그 기록에 실패했습니다.");
      }
    } catch (e) {
      handleAdminWriteError(e, "softDeleteContract");
      return;
    } finally {
      setLoading(false);
    }
  };

  const handleAdminDownload = async () => {
    if (!selectedContract) return;
    handleDownloadPDF(
      buildAdminContractOutputData(selectedContract, {
        revealedPrincipalResidentNumber: revealedSsn,
        revealedCoRepresentativeResidentNumbers: revealedCoRepresentativeSsns,
      }),
      "HQ"
    );
  };

  const revokeLegalEvidenceDownloadUrl = () => {
    if (legalEvidenceDownloadUrlRef.current) {
      URL.revokeObjectURL(legalEvidenceDownloadUrlRef.current);
      legalEvidenceDownloadUrlRef.current = null;
    }
  };

  const openLegalEvidenceModal = () => {
    if (!selectedContract) return;
    revokeLegalEvidenceDownloadUrl();
    setLegalEvidenceReason("");
    setLegalEvidenceFormat("json");
    setLegalEvidenceIncludeContractPdf(false);
    setLegalEvidenceError("");
    setLegalEvidenceDownload(null);
    setShowLegalEvidenceModal(true);
  };

  const closeLegalEvidenceModal = () => {
    setShowLegalEvidenceModal(false);
    setLegalEvidenceError("");
  };

  const getLegalEvidenceFileName = (response, fallback) => {
    const disposition = response.headers.get("content-disposition") || "";
    const match = disposition.match(/filename="?([^";]+)"?/i);
    return match?.[1] || fallback;
  };

  const generateLegalEvidencePackage = async () => {
    if (!selectedContract || legalEvidenceGenerating) return;
    const reason = legalEvidenceReason.trim();
    if (!reason) {
      const message = "증빙자료 생성 목적 또는 열람 사유를 입력해 주세요.";
      setLegalEvidenceError(message);
      setToastMessage(message);
      return;
    }
    const passwordForApi = adminSessionPasswordRef.current || adminPassword;
    if (!passwordForApi) {
      const message = "법적 증빙자료 생성을 위해 관리자 비밀번호 확인이 필요합니다.";
      setLegalEvidenceError(message);
      setToastMessage(message);
      return;
    }

    setLegalEvidenceGenerating(true);
    setLegalEvidenceError("");
    revokeLegalEvidenceDownloadUrl();
    setLegalEvidenceDownload(null);

    try {
      const response = await fetch("/api/contract-evidence-package", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          documentId: selectedContract.id,
          contractId: selectedContract.contractId,
          password: passwordForApi,
          reason,
          format: legalEvidenceFormat,
          includeContractPdf: legalEvidenceIncludeContractPdf,
          includeSensitiveIdentity: false,
          generatedBy: currentManager?.name || "본사",
        }),
      });

      if (!response.ok) {
        let errorPayload = {};
        try {
          errorPayload = await response.json();
        } catch {
          errorPayload = {};
        }
        const message =
          errorPayload.message ||
          "법적 증빙자료를 생성하지 못했습니다. 잠시 후 다시 시도해 주세요.";
        setLegalEvidenceError(
          errorPayload.code ? `${message} (오류코드: ${errorPayload.code})` : message
        );
        setToastMessage(message);
        return;
      }

      const contentType = response.headers.get("content-type") || "";
      const timestamp = new Date().toISOString().replace(/[^0-9]/g, "").slice(0, 14);
      const fallbackName = `CNF-${selectedContract.contractId || selectedContract.id || "contract"}_legal-evidence_${timestamp}.${legalEvidenceFormat}`;
      const fileName = getLegalEvidenceFileName(response, fallbackName);
      const blob =
        legalEvidenceFormat === "html" || contentType.includes("text/html")
          ? await response.blob()
          : new Blob([JSON.stringify(await response.json(), null, 2)], {
              type: "application/json;charset=utf-8",
            });
      const url = URL.createObjectURL(blob);
      legalEvidenceDownloadUrlRef.current = url;
      setLegalEvidenceDownload({
        url,
        fileName,
        contentType: blob.type || contentType,
      });
      setToastMessage("법적 증빙자료가 생성되었습니다.");
    } catch {
      const message = "법적 증빙자료 생성 중 오류가 발생했습니다.";
      setLegalEvidenceError(message);
      setToastMessage(message);
    } finally {
      setLegalEvidenceGenerating(false);
    }
  };

  const resetTrashPurgeState = () => {
    setTrashPurgeDryRun(null);
    setTrashPurgeResult(null);
    setTrashPurgeReason("");
    setTrashPurgeConfirmText("");
    setTrashPurgeError("");
  };

  const requestTrashPurgeDryRun = async () => {
    const passwordForApi = adminSessionPasswordRef.current || adminPassword;
    if (!passwordForApi) {
      const message = "휴지통 비우기는 본사 관리자 비밀번호 확인 후 사용할 수 있습니다.";
      setTrashPurgeError(message);
      setToastMessage(message);
      return null;
    }

    setTrashPurgeLoading(true);
    setTrashPurgeError("");
    try {
      const response = await fetch("/api/admin-empty-trash", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          mode: "dry-run",
          password: passwordForApi,
          limit: 100,
          requestedBy: currentManager?.name || "본사",
        }),
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok || !payload?.ok) {
        throw new Error(payload?.message || "휴지통 대상 확인에 실패했습니다.");
      }
      setTrashPurgeDryRun(payload);
      return payload;
    } catch (error) {
      const message =
        error?.message || "휴지통 대상 확인 중 오류가 발생했습니다.";
      setTrashPurgeError(message);
      setToastMessage(message);
      return null;
    } finally {
      setTrashPurgeLoading(false);
    }
  };

  const openTrashPurgeModal = async () => {
    if (!isHeadquarters()) {
      setToastMessage("휴지통 비우기는 본사 관리자만 사용할 수 있습니다.");
      return;
    }
    resetTrashPurgeState();
    setShowTrashPurgeModal(true);
    await requestTrashPurgeDryRun();
  };

  const closeTrashPurgeModal = () => {
    if (trashPurgeApplying) return;
    setShowTrashPurgeModal(false);
    setTrashPurgeError("");
  };

  const applyTrashPurge = async () => {
    if (trashPurgeApplying) return;
    const reason = trashPurgeReason.trim();
    if (!reason) {
      const message = "휴지통 영구삭제 사유를 입력해 주세요.";
      setTrashPurgeError(message);
      setToastMessage(message);
      return;
    }
    if (trashPurgeConfirmText !== "휴지통 영구삭제") {
      const message = "확인 문구 '휴지통 영구삭제'를 정확히 입력해 주세요.";
      setTrashPurgeError(message);
      setToastMessage(message);
      return;
    }
    const passwordForApi = adminSessionPasswordRef.current || adminPassword;
    if (!passwordForApi) {
      const message = "본사 관리자 비밀번호 확인이 필요합니다.";
      setTrashPurgeError(message);
      setToastMessage(message);
      return;
    }

    setTrashPurgeApplying(true);
    setTrashPurgeError("");
    try {
      const response = await fetch("/api/admin-empty-trash", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          mode: "apply",
          password: passwordForApi,
          confirmText: trashPurgeConfirmText,
          reason,
          limit: 100,
          requestedBy: currentManager?.name || "본사",
        }),
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(payload?.message || "휴지통 영구삭제에 실패했습니다.");
      }
      setTrashPurgeResult(payload);
      const summaryMessage = `휴지통 영구삭제 결과: 삭제 ${payload.deletedCount || 0}건, 제외 ${payload.skippedCount || 0}건, 실패 ${payload.failedCount || 0}건`;
      setToastMessage(summaryMessage);
      if (!payload?.ok) {
        setTrashPurgeError(summaryMessage);
      }
      await fetchAndShowList();
      await requestTrashPurgeDryRun();
    } catch (error) {
      const message =
        error?.message || "휴지통 영구삭제 중 오류가 발생했습니다.";
      setTrashPurgeError(message);
      setToastMessage(message);
    } finally {
      setTrashPurgeApplying(false);
    }
  };

  const confirmSavedContractReceipt = async ({
    savedDocumentId = "",
    contractId = "",
    fallbackContractData = {},
    source = "submit",
  } = {}) => {
    if (!savedDocumentId) {
      throw new Error("saved contract document id is missing");
    }

    setSubmitState("CONFIRMING_RECEIPT");
    setCompletionReceiptError("");

    const savedSnap = await getDoc(getContractDocumentRef(savedDocumentId));
    if (!savedSnap.exists()) {
      throw new Error("saved contract document was not found during receipt confirmation");
    }

    const savedContract = {
      ...fallbackContractData,
      id: savedSnap.id,
      documentId: savedSnap.id,
      ...savedSnap.data(),
    };
    const receiptConfirmedAt =
      savedContract.receiptConfirmedAt || new Date().toISOString();
    let eventCreated = savedContract.receiptEventCreated === true;

    if (savedContract.receiptConfirmed !== true) {
      const manager = getReceiptManagerDisplay(savedContract);
      const receiptEventResult = await logContractEventWithResult(savedDocumentId, {
        type: "CONTRACT_RECEIPT_CONFIRMED",
        contractId: contractId || savedContract.contractId,
        createdAt: receiptConfirmedAt,
        actorType: "SYSTEM",
        managerCode: currentManager?.code || null,
        detail: {
          status: savedContract.status || null,
          contractStatus: savedContract.contractStatus || null,
          managerName: manager.managerName,
          source,
        },
      });
      eventCreated = receiptEventResult?.ok !== false;

      const receiptManager = buildSalesReceiptMetadata({
        contract: savedContract,
        manager: currentManager,
        submittedAt:
          savedContract.submittedAt ||
          savedContract.completedAt ||
          receiptConfirmedAt,
      });
      const receiptPatch = sanitizeFirestoreValue({
        receiptConfirmed: true,
        receiptConfirmedAt,
        receiptStatus: "CONFIRMED",
        receiptEventCreated: eventCreated,
        salesReceipt: {
          ...receiptManager,
          ...(savedContract.salesReceipt || {}),
          confirmedAt: receiptConfirmedAt,
          visibleToSalesLookup: true,
        },
      });

      try {
        await updateDoc(getContractDocumentRef(savedDocumentId), receiptPatch);
        Object.assign(savedContract, receiptPatch);
      } catch (receiptPatchError) {
        console.error(
          "[CNFOOD] receipt confirmation patch failed",
          sanitizeErrorForLog(receiptPatchError)
        );
        reportError(
          "CONTRACT_RECEIPT_CONFIRM_FAILED",
          receiptPatchError?.message || "receipt confirmation patch failed",
          5,
          {
            documentId: savedDocumentId,
            contractId: contractId || savedContract.contractId || null,
            phase: "receipt_patch",
          }
        );
      }
    }

    const receipt = buildCompletionReceiptFromContract(savedContract, {
      confirmed: true,
      eventCreated,
      receiptConfirmedAt,
    });
    setSavedContractDocumentId(savedDocumentId);
    setCompletionReceipt(receipt);
    setCompletionReceiptError("");
    setLastSubmittedContractData((prev) => ({
      ...(prev || {}),
      ...savedContract,
      documentId: savedDocumentId,
      receiptConfirmed: true,
      receiptConfirmedAt,
      receiptStatus: "CONFIRMED",
      receiptEventCreated: eventCreated,
    }));
    return receipt;
  };

  const handleCompletionReceiptFailure = async ({
    savedDocumentId = "",
    contractId = "",
    contractData = {},
    error,
  } = {}) => {
    const message =
      "계약 제출은 처리되었을 수 있으나, 현재 접수 확인 정보를 불러오지 못했습니다.";
    const pendingReceipt = buildPendingCompletionReceipt({
      contract: {
        ...contractData,
        documentId: savedDocumentId || contractData.documentId,
        contractId: contractId || contractData.contractId,
      },
      documentId: savedDocumentId,
      message,
    });
    setSavedContractDocumentId(savedDocumentId);
    setCompletionReceipt(pendingReceipt);
    setCompletionReceiptError(message);
    setSubmitState("FAILED");
    reportError(
      "CONTRACT_RECEIPT_CONFIRM_FAILED",
      error?.message || "receipt confirmation failed",
      5,
      {
        documentId: savedDocumentId,
        contractId: contractId || contractData.contractId || null,
        phase: "receipt_readback",
      }
    );
    goToStep(5, {
      completionReceipt: pendingReceipt,
      savedContractId: savedDocumentId,
      lastSubmittedContractData: contractData,
    });
    return pendingReceipt;
  };

  const handleRefreshCompletionReceipt = async () => {
    const documentId =
      completionReceipt?.documentId ||
      savedContractDocumentId ||
      lastSubmittedContractData?.documentId ||
      lastSubmittedContractData?.id ||
      "";
    if (!documentId) {
      setCompletionReceiptError("접수 정보를 확인할 계약 문서를 찾지 못했습니다.");
      setToastMessage("접수 정보를 확인할 계약 문서를 찾지 못했습니다.");
      return;
    }
    setCompletionReceiptChecking(true);
    try {
      const receipt = await confirmSavedContractReceipt({
        savedDocumentId: documentId,
        contractId:
          completionReceipt?.contractId ||
          lastSubmittedContractData?.contractId ||
          formData.contractId ||
          "",
        fallbackContractData: lastSubmittedContractData || formData || {},
        source: "manual_recheck",
      });
      await logContractEventWithResult(documentId, {
        type: "CONTRACT_RECEIPT_RECHECKED",
        contractId: receipt.contractId || "",
        createdAt: new Date().toISOString(),
        actorType: "CUSTOMER",
        managerCode: currentManager?.code || null,
        detail: { receiptConfirmed: true },
      });
      setSubmitState("CONFIRMED");
      setToastMessage("접수 정보가 확인되었습니다.");
    } catch (error) {
      console.error("[CNFOOD] receipt recheck failed", sanitizeErrorForLog(error));
      setCompletionReceiptError(
        "접수 확인 정보를 아직 불러오지 못했습니다. 잠시 후 다시 시도해 주세요."
      );
      reportError(
        "CONTRACT_RECEIPT_CONFIRM_FAILED",
        error?.message || "receipt recheck failed",
        5,
        { documentId, phase: "manual_recheck" }
      );
    } finally {
      setCompletionReceiptChecking(false);
    }
  };

  const handleReturnToIntroAfterCompletion = () => {
    if (typeof window !== "undefined") {
      window.location.assign(window.location.pathname);
    }
  };

  const submitContract = async () => {
    if (submitContractInFlightRef.current) {
      console.info("[contract-submit] blocked duplicate submit");
      setToastMessage("계약서 저장이 진행 중입니다. 잠시만 기다려 주세요.");
      return;
    }
    if (
      isSubmittingFinal ||
      loading ||
      imageGenerating ||
      ["SAVING", "CONFIRMING_RECEIPT", "CONFIRMED"].includes(submitState)
    ) {
      setToastMessage("계약서 저장이 진행 중입니다. 잠시만 기다려 주세요.");
      return;
    }
    submitContractInFlightRef.current = true;
    console.info("[contract-submit] start");
    let shouldReleaseSubmitLock = true;

    try {
    if (
      isSubmittingFinal ||
      ["SAVING", "CONFIRMING_RECEIPT", "CONFIRMED"].includes(submitState)
    ) {
      setToastMessage("계약 제출 또는 접수 확인이 진행 중입니다.");
      return;
    }
    if (savedContractDocumentId || completionReceipt?.confirmed) {
      setToastMessage("이미 접수된 계약입니다.");
      goToStep(5, {
        completionReceipt,
        savedContractId: savedContractDocumentId,
      });
      shouldReleaseSubmitLock = false;
      console.info("[contract-submit] success", { savedDocumentId: savedContractDocumentId });
      return;
    }
    if (isCompletedOrLockedContract(formData) || isCompletedOrLockedContract(lastSubmittedContractData || {})) {
      const completedContract = lastSubmittedContractData || formData;
      const existingReceipt = buildCompletionReceiptFromContract(completedContract, {
        confirmed: hasContractReceiptConfirmation(completedContract),
      });
      setCompletionReceipt(existingReceipt);
      setSavedContractDocumentId(existingReceipt.documentId || "");
      setToastMessage("이미 완료된 계약입니다.");
      goToStep(5, {
        completionReceipt: existingReceipt,
        savedContractId: existingReceipt.documentId,
        lastSubmittedContractData: completedContract,
      });
      shouldReleaseSubmitLock = false;
      return;
    }
    if (!(await ensureContractAppStatusAllows("SUBMIT", { refresh: true }))) {
      return;
    }
    if (!isSigned) {
      setToastMessage("서명을 입력해 주세요.");
      return;
    }
    if (isCorporateContract(bizType) && !signature2) {
      setToastMessage("대표자 개인 서명을 입력해 주세요.");
      return;
    }
    if (!hasContractAuthority) {
      focusRequiredConsent(
        "contract-authority",
        "계약 체결 권한 확인에 동의해 주세요."
      );
      return;
    }
    const coRepresentativeContactValidation = validatePrimaryCoRepresentativeContacts({
      declared: coRepresentativeDeclared,
      representatives: coRepresentatives,
    });
    if (!coRepresentativeContactValidation.ok) {
      setToastMessage(coRepresentativeContactValidation.message);
      setErrors((prev) => ({
        ...prev,
        agentRep: coRepresentativeContactValidation.message,
      }));
      goToStep(coRepresentativeContactValidation.step ?? 0);
      return;
    }
    let coRepresentativeRecordsForSubmit = buildPrimaryCoRepresentativeRecords({
      declared: coRepresentativeDeclared,
      representatives: coRepresentatives,
      businessNumber: formData.agentBizNo,
      inviteToken: activeInvite?.token || "",
    });
    if (
      representativeIdentitySimulationActive ||
      coRepresentativeRecordsForSubmit.some((item) =>
        isIdentityTestSimulation(item.identityVerification)
      )
    ) {
      setToastMessage(REPRESENTATIVE_KCP_REQUIRED_MESSAGE);
      setOtpError(REPRESENTATIVE_KCP_REQUIRED_MESSAGE);
      goToStep(1);
      return;
    }
    const hasPendingCoRepresentativeSignatures =
      coRepresentativeDeclared &&
      buildCoRepresentativeWorkflow({
        required: coRepresentativeDeclared,
        representatives: coRepresentativeRecordsForSubmit,
      }).status !== CO_REP_WORKFLOW_STATUS.COMPLETED;
    const strictCombinedReadiness = resolveVerifiedContractReadiness({
      formData,
      kcpStatus: kcpIdentityStatus,
      representativeIdentityVerification,
      phoneVerified,
      kcpSessionId,
      latestBusinessVerification: businessVerification,
      savedDraft: {
        businessVerification: lastValidBusinessVerificationRef.current,
      },
      previousVerifiedStatus: lastVerifiedPrincipalKcpRef.current,
      userAgent:
        typeof navigator !== "undefined" ? navigator.userAgent || "" : "",
    });
    const strictBusinessReadiness = strictCombinedReadiness.businessReadiness;
    const strictBusinessVerification =
      strictCombinedReadiness.hydratedBusinessVerification ||
      strictBusinessReadiness.businessVerification ||
      businessVerification;
    if (
      strictBusinessReadiness.ready &&
      strictBusinessVerification &&
      strictBusinessVerification !== businessVerification
    ) {
      setBusinessVerification(strictBusinessVerification);
    }
    let strictKcpIdentityStatus = strictCombinedReadiness.kcpReady
      ? "VERIFIED"
      : kcpIdentityStatus;
    let strictRepresentativeIdentityVerification =
      strictCombinedReadiness.hydratedIdentityVerification ||
      representativeIdentityVerification;
    let strictValidation = validateStrictRepresentativeIdentity({
      kcpIdentityStatus: strictKcpIdentityStatus,
      representativeIdentityVerification: strictRepresentativeIdentityVerification,
      businessVerification: strictBusinessVerification,
      coRepresentativesRequired: false,
      coRepresentatives: coRepresentativeRecordsForSubmit,
    });
    if (
      !strictValidation.ok &&
      strictValidation.step !== 0 &&
      !isIdentityTestSimulation(strictRepresentativeIdentityVerification)
    ) {
      const recheck = await recheckPrincipalKcpBeforeBlocking("submit");
      if (recheck.ok) {
        strictKcpIdentityStatus = recheck.kcpIdentityStatus;
        strictRepresentativeIdentityVerification =
          recheck.representativeIdentityVerification;
        strictValidation = validateStrictRepresentativeIdentity({
          kcpIdentityStatus: strictKcpIdentityStatus,
          representativeIdentityVerification:
            strictRepresentativeIdentityVerification,
          businessVerification: strictBusinessVerification,
          coRepresentativesRequired: false,
          coRepresentatives: coRepresentativeRecordsForSubmit,
        });
      } else if (recheck.pending) {
        setToastMessage(recheck.message);
        setOtpError(recheck.message);
        return;
      }
    }
    // Check evidence first – if step evidence confirms identity is complete,
    // override stale local state failures (handles KCP mobile redirect case).
    const evidenceCheck = validateFinalSubmissionEvidence({
      stepEvidence,
      kcpIdentityStatus: strictKcpIdentityStatus,
      representativeIdentityVerification: strictRepresentativeIdentityVerification,
      restoredSsnDraft,
      lockedIdentityFields,
    });
    if (
      shouldUseFinalSubmissionEvidenceOverride({
        strictValidation,
        evidenceCheck,
      })
    ) {
      // Evidence confirms identity is complete – override the validation failure
      strictValidation = { ok: true, step: null, message: "" };
    }
    if (!strictValidation.ok && !evidenceCheck.ok) {
      setToastMessage(strictValidation.message || evidenceCheck.message || "본인확인 증빙이 확인되지 않습니다.");
      if (strictValidation.step === 0) {
        goToStep(0);
      } else {
        setOtpError(strictValidation.message || evidenceCheck.message || "");
        goToStep((evidenceCheck as any).targetStep ?? 1);
      }
      return;
    }
    // Save signature evidence now that we know validation passed
    const nowSubmitEvidence = new Date().toISOString();
    setStepEvidence((prev) => ({
      ...prev,
      signature: {
        completed: true,
        completedAt: nowSubmitEvidence,
        primarySignatureValid: isSigned,
        personalGuaranteeSignatureValid: !isCorporateContract(bizType) || Boolean(signature2),
        source: "STEP_3_SIGNED",
      },
    }));
    if (loading || imageGenerating) return;
    if (typeof navigator !== "undefined" && navigator.onLine === false) {
      setToastMessage("오프라인 상태입니다. 네트워크 연결 후 다시 제출해 주세요.");
      reportError("OFFLINE_SUBMIT", "submit attempted while offline", 3);
      return;
    }
    setIsSubmittingFinal(true);
    setLoading(true);
    setImageGenerating(true);
    setSubmitState("VALIDATING");
    setCompletionReceiptError("");
    let submitUndefinedPaths: string[] = [];
    let submitSanitizedUndefinedPaths: string[] = [];
    let submitIdentityVerificationSummary: unknown = null;
    try {
      let submitAuthError = null;
      try {
        const activeAuthUser = await ensureFirebaseAnonymousAuth(auth);
        if (activeAuthUser && !user) {
          setUser(activeAuthUser);
        }
      } catch (authError) {
        submitAuthError = authError;
        console.warn(
          "[CNFOOD] final submit browser auth unavailable; using server submit fallback",
          sanitizeErrorForLog(authError)
        );
      }
      const contractId = editModeId
        ? formData.contractId
        : `CNF-${new Date().getTime().toString().slice(-6)}`;
      if (editModeId) {
        const existingSnap = await getDoc(getContractDocumentRef(editModeId));
        if (existingSnap.exists() && isCompletedOrLockedContract(existingSnap.data())) {
          const existingData = {
            id: existingSnap.id,
            ...existingSnap.data(),
          };
          setLastSubmittedContractData({
            ...existingData,
          });
          const existingReceipt = buildCompletionReceiptFromContract(existingData, {
            confirmed: hasContractReceiptConfirmation(existingData),
          });
          setSavedContractDocumentId(existingSnap.id);
          setCompletionReceipt(existingReceipt);
          generateContractImage(
            existingData.signature,
            existingData.contractId,
            "CUSTOMER",
            existingData,
            existingData.signature2
          ).then((img) => {
            if (img) setFinalContractImage(img);
          });
          setSubmitState("CONFIRMED");
          setToastMessage("이미 완료된 계약입니다.");
          goToStep(5, {
            completionReceipt: existingReceipt,
            savedContractId: existingSnap.id,
            lastSubmittedContractData: existingData,
          });
          shouldReleaseSubmitLock = false;
          console.info("[contract-submit] success", { savedDocumentId: existingSnap.id });
          return;
        }
      }

      let signatureData = null;
      if (canvasRef.current)
        signatureData = getCanvasDataURLWithWhiteBackground(canvasRef.current);
      else if (formData.signature) signatureData = formData.signature;

      let signatureData2 = null;
      if (isCorporateContract(bizType)) {
        if (canvasRef2.current)
          signatureData2 = getCanvasDataURLWithWhiteBackground(canvasRef2.current);
        else if (formData.signature2) signatureData2 = formData.signature2;
      }

      const primarySignatureValidation = validateSignatureQualityMetrics(
        canvasRef.current ? getCanvasSignatureMetrics(canvasRef.current) : {}
      );
      if (
        !signatureData ||
        !primarySignatureValidation.valid
      ) {
        setToastMessage(
          getSignatureQualityErrorMessage(primarySignatureValidation.reason)
        );
        setSubmitState("IDLE");
        return;
      }

      let secondarySignatureValidation = validateSignatureQualityMetrics();
      if (isCorporateContract(bizType)) {
        if (!representativePersonalGuaranteeAgreed) {
          focusRequiredConsent(
            "representative-personal-guarantee",
            "대표자 공동계약 확인 동의에 체크해 주세요."
          );
          setSubmitState("IDLE");
          return;
        }
        secondarySignatureValidation = validateSignatureQualityMetrics(
          canvasRef2.current ? getCanvasSignatureMetrics(canvasRef2.current) : {}
        );
        if (
          !signatureData2 ||
          !secondarySignatureValidation.valid
        ) {
          setToastMessage(
            `대표자 공동계약 확인 ${getSignatureQualityErrorMessage(
              secondarySignatureValidation.reason
            )}`
          );
          setSubmitState("IDLE");
          return;
        }
      }

      // 주민번호는 역할별로 분리해 암호화 저장하고 평문 앞/뒤자리는 Firestore에 저장하지 않음.
      // 기존 ssnEncrypted는 하위호환을 위해 본 대표 주민번호(principalRep)로 유지한다.
      const principalRepSsnFront =
        formData.principalRepSsnFront || formData.ssnFront;
      const principalRepSsnBack =
        formData.principalRepSsnBack || formData.ssnBack;
      const guarantorSsnFront = formData.guarantorSsnFront;
      const guarantorSsnBack = formData.guarantorSsnBack;

      let principalRepSsnEncrypted: string | null =
        restoredSsnDraft?.principalRepSsnEncrypted || null;
      const restoredPrincipalSsnMasked =
        restoredSsnDraft?.principalRepSsnMasked || null;
      if (principalRepSsnFront && principalRepSsnBack) {
        principalRepSsnEncrypted = await encryptText(
          `${principalRepSsnFront}|${principalRepSsnBack}`
        );
      }
      const principalRepSsnSecurityEvidence =
        principalRepSsnFront && principalRepSsnBack
          ? await buildResidentNumberSecurityEvidence({
              ssnFront: principalRepSsnFront,
              ssnBack: principalRepSsnBack,
              encryptedValue: principalRepSsnEncrypted,
            })
          : null;
      let guarantorSsnEncrypted: string | null =
        restoredSsnDraft?.guarantorSsnEncrypted || null;
      const restoredGuarantorSsnMasked =
        restoredSsnDraft?.guarantorSsnMasked || null;
      if (
        isCorporateContract(bizType) &&
        guarantorSsnFront &&
        guarantorSsnBack
      ) {
        guarantorSsnEncrypted = await encryptText(
          `${guarantorSsnFront}|${guarantorSsnBack}`
        );
      }
      const guarantorSsnSecurityEvidence =
        isCorporateContract(bizType) && guarantorSsnFront && guarantorSsnBack
          ? await buildResidentNumberSecurityEvidence({
              ssnFront: guarantorSsnFront,
              ssnBack: guarantorSsnBack,
              encryptedValue: guarantorSsnEncrypted,
            })
          : null;
      const ssnPersistenceFields = buildSsnPersistenceFields(
        bizType,
        principalRepSsnEncrypted,
        principalRepSsnFront,
        guarantorSsnEncrypted,
        guarantorSsnFront,
        principalRepSsnSecurityEvidence?.ssnHash || null,
        principalRepSsnSecurityEvidence?.ssnHmac || null,
        guarantorSsnSecurityEvidence?.ssnHash || null,
        guarantorSsnSecurityEvidence?.ssnHmac || null
      );
      if (
        principalRepSsnEncrypted &&
        !principalRepSsnFront &&
        restoredPrincipalSsnMasked
      ) {
        ssnPersistenceFields.ssnMasked = restoredPrincipalSsnMasked;
        ssnPersistenceFields.principalRepSsnMasked = restoredPrincipalSsnMasked;
      }
      if (
        isCorporateContract(bizType) &&
        guarantorSsnEncrypted &&
        !guarantorSsnFront &&
        restoredGuarantorSsnMasked
      ) {
          ssnPersistenceFields.guarantorSsnMasked = restoredGuarantorSsnMasked;
      }
      const submittedAt = new Date().toISOString();
      coRepresentativeRecordsForSubmit =
        await buildSecureCoRepresentativeEvidenceRecords({
          declared: coRepresentativeDeclared,
          representatives: coRepresentatives,
          businessNumber: formData.agentBizNo,
          inviteToken: activeInvite?.token || "",
          principalSignerName: formData.agentRep,
          encryptValue: encryptText,
        });
      const coRepresentativeInviteBundle =
        await buildCoRepresentativeInviteLinkRecords({
          representatives: coRepresentativeRecordsForSubmit,
          origin:
            typeof window !== "undefined"
              ? `${window.location.origin}${window.location.pathname}`
              : "https://cn-food-contract.vercel.app/",
          now: submittedAt,
        });
      coRepresentativeRecordsForSubmit =
        coRepresentativeInviteBundle.records || coRepresentativeRecordsForSubmit;
      const coRepresentativeInviteLinksForSubmit =
        coRepresentativeInviteBundle.links || [];
      const coRepresentativeInviteTokenHashesForSubmit =
        coRepresentativeInviteBundle.tokenHashes || [];
      const principalRepHomeAddress = isCorporateContract(bizType)
        ? [formData.corpRepAddress, formData.corpRepAddressDetail]
            .filter(Boolean)
            .join(" ")
            .replace(/\s+/g, " ")
            .trim()
        : "";
      const principalRepHomeAddressEncrypted = principalRepHomeAddress
        ? await encryptText(principalRepHomeAddress)
        : null;
      const principalRepHomeAddressMasked = principalRepHomeAddress
        ? maskHomeAddressForEvidence(principalRepHomeAddress)
        : null;

      const completedAt = submittedAt;
      const requestMeta = await fetchRequestMeta();
      const submittedUserAgent =
        requestMeta.userAgent ||
        (typeof navigator !== "undefined" ? navigator.userAgent : null);
      const finalSignatureCompletedAt = signatureCompletedAt || submittedAt;
      const finalContractReviewedAt = contractReviewedAt || submittedAt;
      const primarySignatureHash =
        signatureHash || (await createSha256Hash(signatureData));
      const secondarySignatureHash =
        isCorporateContract(bizType) && signatureData2
          ? signature2Hash || (await createSha256Hash(signatureData2))
          : null;
      const primarySignatureData: SignatureData = {
        imageDataUrl: signatureData,
        imageHash: primarySignatureHash,
        signedAt: finalSignatureCompletedAt,
        canvasWidth: canvasRef.current?.width || 0,
        canvasHeight: canvasRef.current?.height || 0,
      };
      const representativePersonalGuarantee = {
        required: isCorporateContract(bizType),
        agreed: isCorporateContract(bizType)
          ? representativePersonalGuaranteeAgreed
          : false,
        agreedAt:
          isCorporateContract(bizType) && representativePersonalGuaranteeAgreed
            ? submittedAt
            : null,
        consentTextVersion: REPRESENTATIVE_PERSONAL_GUARANTEE_CONSENT_VERSION,
        consentText: REPRESENTATIVE_PERSONAL_GUARANTEE_CONSENT_TEXT,
        signerName: formData.corpRepName || formData.agentRep || "",
        signerSsnMasked:
          ssnPersistenceFields.principalRepSsnMasked ||
          ssnPersistenceFields.ssnMasked ||
          null,
        signerPhoneMasked: maskPhoneNumber(formData.agentContact || ""),
        signerAddressMasked: principalRepHomeAddressMasked,
        signatureRole: "REPRESENTATIVE_PERSONAL_GUARANTEE",
        signatureValidation: secondarySignatureValidation,
        signedAt: isCorporateContract(bizType) ? finalSignatureCompletedAt : null,
      };
      const signatureEvidence = buildSignatureEvidence({
        bizType,
        signerName: formData.corpRepName || formData.agentRep || "",
        coRepresentativesRequired: coRepresentativeDeclared,
        primaryHash: primarySignatureHash,
        primaryValidation: primarySignatureValidation,
        primarySignedAt: finalSignatureCompletedAt,
        representativePersonalGuaranteeRequired: isCorporateContract(bizType),
        representativePersonalGuaranteeAgreed:
          representativePersonalGuarantee.agreed,
        representativePersonalGuaranteeAgreedAt:
          representativePersonalGuarantee.agreedAt || "",
        representativePersonalGuaranteeHash: secondarySignatureHash || "",
        representativePersonalGuaranteeValidation: secondarySignatureValidation,
        representativePersonalGuaranteeSignedAt: isCorporateContract(bizType)
          ? finalSignatureCompletedAt
          : "",
        signerSsnMasked:
          representativePersonalGuarantee.signerSsnMasked || "",
        signerPhoneMasked:
          representativePersonalGuarantee.signerPhoneMasked || "",
        signerAddressMasked:
          representativePersonalGuarantee.signerAddressMasked || "",
      });
      const phoneEvidence = buildPhoneVerificationEvidence({
        phoneVerificationEnabled: validationSettings.enablePhoneVerification,
        phoneVerified:
          phoneVerified ||
          isRepresentativeIdentityMatched(
            strictRepresentativeIdentityVerification
          ),
        phoneVerifiedAt:
          phoneVerifiedAt ||
          strictRepresentativeIdentityVerification?.verifiedAt ||
          null,
        phoneNumber: formData.agentContact,
        identityProvider,
      });
      const identitySummary = buildIdentityVerificationSummary({
        phoneEvidence,
        identityProvider,
        phoneNumber: formData.agentContact,
        kcpFallbackReason,
        kcpIdentityStatus: strictKcpIdentityStatus,
        representativeVerificationStatus:
          strictRepresentativeIdentityVerification?.status ||
          getRepresentativeVerificationStatus(),
      });
      if (!signatureCompletedAt) {
        setSignatureCompletedAt(finalSignatureCompletedAt);
      }
      if (!contractReviewedAt) {
        setContractReviewedAt(finalContractReviewedAt);
      }
      queueContractEvent("CONTRACT_AUTHORITY_CONFIRMED", {
        hasContractAuthority: true,
      });
      queueContractEvent("FINAL_CONFIRMED", {
        step: 3,
        hasReadAndAgreedContract: true,
        hasContractAuthority: true,
      });
      const inviteMetadata = buildContractInviteMetadata(activeInvite);
      const salesReceipt = buildSalesReceiptMetadata({
        contract: formData,
        inviteMetadata,
        manager: currentManager,
        submittedAt,
      });
      const finalCoRepresentativeInfo = resolveCoRepresentativeInfo({
        userDeclared: coRepresentativeDeclared,
        ntsInfo: coRepresentativeNtsInfo,
        now: submittedAt,
      });
      const finalLockedIdentityFields =
        lockedIdentityFields ||
        buildLockedIdentityFieldsSnapshot({
          formData,
          lockedAt:
            strictRepresentativeIdentityVerification?.verifiedAt ||
            phoneVerifiedAt ||
            submittedAt,
        });
      const identityVerification = buildContractIdentityVerificationSnapshot({
        identitySummary,
        kcpEvidence:
          identitySummary.identityVerificationProvider === "KCP"
            ? {
                ...(kcpIdentityEvidence || {}),
                sessionId:
                  (kcpIdentityEvidence && kcpIdentityEvidence.sessionId) ||
                  kcpSessionId,
                status:
                  (kcpIdentityEvidence && kcpIdentityEvidence.status) ||
                  strictKcpIdentityStatus,
                verifiedName:
                  (kcpIdentityEvidence && kcpIdentityEvidence.verifiedName) ||
                  kcpVerifiedName,
                phoneMasked:
                  (kcpIdentityEvidence && kcpIdentityEvidence.phoneMasked) ||
                  kcpPhoneMasked,
                representativeMatchStatus:
                  (kcpIdentityEvidence &&
                    kcpIdentityEvidence.representativeMatchStatus) ||
                  strictRepresentativeIdentityVerification?.status ||
                  kcpRepresentativeMatchStatus,
                representativeIdentityVerification:
                  strictRepresentativeIdentityVerification,
              }
            : {},
      });
      const signerIpHash = requestMeta.ip
        ? await createSha256Hash(String(requestMeta.ip))
        : null;
      const consentSnapshot = {
        hasReadAndAgreedContract: true,
        hasContractAuthority: true,
        hasCreditCheckConsent: agreements.credit === true,
        creditCheckCompany: CREDIT_CHECK_COMPANY,
        creditCheckConsentAt: agreements.credit ? submittedAt : null,
        contractReviewedAt: finalContractReviewedAt,
        signedAt: finalSignatureCompletedAt,
        completedAt,
        evidenceVersion: EVIDENCE_VERSION,
      };
      const finalContractDate = `${selYear}-${String(selMonth).padStart(2, "0")}-${String(
        selDay
      ).padStart(2, "0")}`;
      const finalTemplateSnapshotFields = buildContractTemplateSnapshotFields(
        buildNewContractTemplate({}),
        {
          ...formData,
          bizType,
          contractDate: finalContractDate,
        }
      );
      const coRepresentativeSignatureImages = coRepresentatives
        .filter(
          (item) =>
            getCoRepresentativeSignatureMode(item) ===
              CO_REPRESENTATIVE_SIGNATURE_MODE_DIRECT &&
            item.signatureImageDataUrl
        )
        .map((item) => ({
          id: item.id,
          signatureImageDataUrl: item.signatureImageDataUrl,
          signatureHash:
            item.signatureHash || item.signatureEvidence?.signatureHash || null,
        }));
      const coRepresentativeWorkflowForSubmit = buildCoRepresentativeWorkflow({
        required: coRepresentativeDeclared,
        representatives: coRepresentativeRecordsForSubmit,
        updatedAt: submittedAt,
      });
      const matchedVendorForBranch = vendorMasters.find(
        (vendor) =>
          normalizeBusinessNumber(vendor.businessNumber || vendor.businessNumberNormalized) ===
          normalizeBusinessNumber(formData.agentBizNo || "")
      );
      const selectedCompanyBranch =
        resolveCompanyBranchSelection({
          companyBranches,
          companyBranchId:
            activeInvite?.companyBranchId || matchedVendorForBranch?.companyBranchId || "",
          companyBranchName:
            activeInvite?.companyBranchName || matchedVendorForBranch?.companyBranchName || "",
          allowDefault: true,
        }).branch || null;
      const contractCompanyBranch = buildContractCompanyBranchSnapshot({
        branch:
          selectedCompanyBranch ||
          matchedVendorForBranch?.companyBranchSnapshot ||
          null,
      });

      const baseContractData: any = {
        ...formData,
        ...finalTemplateSnapshotFields,
        contractId,
        signature: signatureData,
        signature2: signatureData2,
        corpRepAddress: isCorporateContract(bizType)
          ? principalRepHomeAddressMasked
          : formData.corpRepAddress,
        corpRepAddressDetail: isCorporateContract(bizType)
          ? null
          : formData.corpRepAddressDetail,
        principalRepHomeAddressEncrypted,
        principalRepHomeAddressMasked,
        representativeHomeAddressEncrypted: principalRepHomeAddressEncrypted,
        representativeHomeAddressMasked: principalRepHomeAddressMasked,
        contractDate: finalContractDate,
        submittedAt,
        submittedIp: requestMeta.ip || null,
        submittedUserAgent,
        signedAt: finalSignatureCompletedAt,
        signerIpHash,
        userAgent: submittedUserAgent,
        consentSnapshot,
        evidenceVersion: EVIDENCE_VERSION,
        documentVersion: getContractDocumentVersionForSubmission(
          bizType,
          formData,
          Boolean(editModeId)
        ),
        companyBranchId: contractCompanyBranch.id || "",
        companyBranchName: contractCompanyBranch.branchName || "",
        contractCompanyBranch,
        contractReviewedAt: finalContractReviewedAt,
        signatureCompletedAt: finalSignatureCompletedAt,
        status: hasPendingCoRepresentativeSignatures
          ? "pending_co_rep_verification"
          : "completed",
        contractStatus: hasPendingCoRepresentativeSignatures
          ? (CO_REP_CONTRACT_STATUS_PENDING as ContractStatus)
          : ("COMPLETED" as ContractStatus),
        isLocked: true,
        lockedAt: completedAt,
        completedAt,
        hasReadAndAgreedContract: true,
        hasContractAuthority: true,
        hasCreditCheckConsent: agreements.credit === true,
        creditCheckCompany: CREDIT_CHECK_COMPANY,
        creditCheckConsentAt: agreements.credit ? submittedAt : null,
        representativeVerificationStatus:
          identitySummary.representativeVerificationStatus,
        representativeIdentityVerification: strictRepresentativeIdentityVerification,
        businessVerification: strictBusinessVerification,
        lockedIdentityFields: finalLockedIdentityFields,
        identityEvidenceVersion: "rep-corep-strict-v1",
        phoneVerificationStatus: phoneEvidence.phoneVerified
          ? "VERIFIED"
          : phoneEvidence.phoneVerificationSkipped
          ? "BYPASSED"
          : "UNVERIFIED",
        identityVerificationMethod: identitySummary.identityVerificationMethod,
        identityVerificationProvider: identitySummary.identityVerificationProvider,
        identityProvider: identitySummary.identityVerificationProvider,
        identityVerificationStatus: identitySummary.identityVerificationStatus,
        identityVerification,
        kcpAttempted: identitySummary.kcpAttempted,
        kcpAttemptStatus: identitySummary.kcpAttemptStatus,
        kcpFallbackReason: identitySummary.kcpFallbackReason || null,
        kcpIdentitySessionId: kcpSessionId || null,
        kcpIdentityStatus: strictKcpIdentityStatus || null,
        kcpVerifiedPhoneMasked: kcpPhoneMasked || null,
        kcpRepresentativeMatchStatus:
          identitySummary.identityVerificationProvider === "KCP"
            ? strictRepresentativeIdentityVerification?.status ||
              kcpRepresentativeMatchStatus
            : null,
        coRepresentativeInfo: finalCoRepresentativeInfo,
        coRepresentatives: coRepresentativeRecordsForSubmit,
        coRepresentativeWorkflow: coRepresentativeWorkflowForSubmit,
        coRepresentativeInviteTokenHashes:
          coRepresentativeInviteTokenHashesForSubmit,
        coRepresentativeSignatureImages,
        coRepresentativeDeclared,
        coRepresentativeSignatureStatus: coRepresentativeDeclared
          ? hasPendingCoRepresentativeSignatures
            ? CO_REP_CONTRACT_STATUS_PENDING
            : "VERIFIED_AND_SIGNED_OR_CONSENTED"
          : "NOT_REQUIRED",
        coRepresentativeCheckStatus: finalCoRepresentativeInfo.status,
        representativePersonalGuarantee,
        signatureEvidence,
        signatureHash: primarySignatureHash,
        signature2Hash: secondarySignatureHash,
        signatureData: primarySignatureData,
        managerName: currentManager.name,
        managerEmail: currentManager.email,
        salesReceipt: {
          ...salesReceipt,
          visibleToSalesLookup: false,
        },
        receiptConfirmed: false,
        receiptConfirmedAt: null,
        receiptStatus: "PENDING_CONFIRMATION",
        receiptEventCreated: false,
        bizType,
        inviteId: inviteMetadata.inviteId,
        ownerType: inviteMetadata.ownerType,
        ownerLabel: inviteMetadata.ownerLabel,
        salesRepId: inviteMetadata.salesRepId,
        salesPart: inviteMetadata.salesPart,
        salesRepDepartmentPart: inviteMetadata.salesRepDepartmentPart,
        salesRepName: inviteMetadata.salesRepName,
        salesRepPhone: inviteMetadata.salesRepPhone,
        salesRepEmail: inviteMetadata.salesRepEmail,
        salesRepPhoneMasked: inviteMetadata.salesRepPhoneMasked,
        invitationSnapshot: inviteMetadata.invitationSnapshot,
        // 암호화 처리
        ssnFront: ssnPersistenceFields.ssnFront,
        ssnBack: ssnPersistenceFields.ssnBack,        // 평문 저장 금지
        principalRepSsnFront: ssnPersistenceFields.principalRepSsnFront,
        principalRepSsnBack: ssnPersistenceFields.principalRepSsnBack,
        guarantorSsnFront: ssnPersistenceFields.guarantorSsnFront,
        guarantorSsnBack: ssnPersistenceFields.guarantorSsnBack,
        ssnEncrypted: ssnPersistenceFields.ssnEncrypted,         // legacy: 본 대표 AES-256-GCM 암호화 값
        ssnMasked: ssnPersistenceFields.ssnMasked,    // legacy: 본 대표 출력용 마스킹 값
        principalRepSsnEncrypted: ssnPersistenceFields.principalRepSsnEncrypted,
        principalRepSsnMasked: ssnPersistenceFields.principalRepSsnMasked,
        principalRepSsnHash: ssnPersistenceFields.principalRepSsnHash || null,
        principalRepSsnHmac: ssnPersistenceFields.principalRepSsnHmac || null,
        guarantorSsnEncrypted: ssnPersistenceFields.guarantorSsnEncrypted,
        guarantorSsnMasked: ssnPersistenceFields.guarantorSsnMasked,
        guarantorSsnHash: ssnPersistenceFields.guarantorSsnHash || null,
        guarantorSsnHmac: ssnPersistenceFields.guarantorSsnHmac || null,
        ...phoneEvidence,
        verifiedPhone: phoneEvidence.phoneMasked,
      };

      const finalSnapshot = await createContractFinalSnapshot({
        contractData: baseContractData,
        signatureImageDataUrl: signatureData,
        signedAt: finalSignatureCompletedAt,
        completedAt,
      });
      const rawContractData: any = {
        ...baseContractData,
        finalSnapshot,
        contractHash: finalSnapshot.contractHash,
      };

      const finalLog = await createLog("계약 체결", "최종 서명 완료 및 저장");
      auditLogsRef.current.push(finalLog);
      rawContractData.auditTrail = auditLogsRef.current;
      submitUndefinedPaths = findUndefinedPaths(rawContractData);
      submitIdentityVerificationSummary = sanitizeLogDetail({
        provider: rawContractData.identityVerification?.provider || null,
        method: rawContractData.identityVerification?.method || null,
        status: rawContractData.identityVerification?.status || null,
        hasSessionId: Boolean(rawContractData.identityVerification?.sessionId),
        hasOrderId: Boolean(rawContractData.identityVerification?.orderId),
        hasCi: Boolean(rawContractData.identityVerification?.hasCi),
        hasDi: Boolean(rawContractData.identityVerification?.hasDi),
      });
      let contractData = sanitizeFirestoreValue(rawContractData) as any;
      const pendingSavedDocumentId = editModeId
        ? null
        : pendingSavedDocumentIdRef.current;
      if (
        pendingSavedDocumentId &&
        pendingSubmittedContractRef.current?.documentId === pendingSavedDocumentId
      ) {
        contractData = {
          ...contractData,
          ...pendingSubmittedContractRef.current,
          documentId: pendingSavedDocumentId,
        };
      }
      submitSanitizedUndefinedPaths = findUndefinedPaths(contractData);
      if (submitSanitizedUndefinedPaths.length > 0) {
        throw new Error(
          `Contract payload still contains undefined fields: ${submitSanitizedUndefinedPaths.join(
            ", "
          )}`
        );
      }

      let savedDocumentId = editModeId || pendingSavedDocumentId || null;
      let serverSubmitResult = null;
      setSubmitState("SAVING");
      if (editModeId) {
        if (submitAuthError) throw submitAuthError;
        await setDoc(
          getContractDocumentRef(editModeId),
          contractData
        );
        logAdminAction("계약 수정", contractId, currentManager.name);
      } else if (pendingSavedDocumentId && submitAuthError) {
        serverSubmitResult = await submitContractViaServer({
          contractData,
          documentId: pendingSavedDocumentId,
        });
        savedDocumentId = serverSubmitResult.savedDocumentId;
        contractData = {
          ...contractData,
          ...(serverSubmitResult.contractData || {}),
          documentId: savedDocumentId,
        };
      } else if (pendingSavedDocumentId) {
        savedDocumentId = pendingSavedDocumentId;
      } else {
        try {
          if (submitAuthError) throw submitAuthError;
          const savedDocRef = await addDoc(getContractsCollectionRef(), contractData);
          savedDocumentId = savedDocRef.id;
        } catch (saveError) {
          if (!isPermissionDeniedError(saveError)) {
            throw saveError;
          }
          serverSubmitResult = await submitContractViaServer({ contractData });
          savedDocumentId = serverSubmitResult.savedDocumentId;
          contractData = {
            ...contractData,
            ...(serverSubmitResult.contractData || {}),
            documentId: savedDocumentId,
          };
        }
        pendingSavedDocumentIdRef.current = savedDocumentId;
      }
      contractData.documentId = savedDocumentId;
      if (!editModeId) {
        pendingSubmittedContractRef.current = contractData;
      }
      setLastSubmittedContractData(contractData);

      let receipt = null;
      if (serverSubmitResult) {
        const receiptConfirmedAt =
          serverSubmitResult.receiptConfirmedAt ||
          contractData.receiptConfirmedAt ||
          new Date().toISOString();
        receipt = buildCompletionReceiptFromContract(contractData, {
          confirmed: true,
          eventCreated: true,
          receiptConfirmedAt,
        });
        setSavedContractDocumentId(savedDocumentId);
        setCompletionReceipt(receipt);
        setCompletionReceiptError("");
      } else {
        await flushQueuedContractEvents(savedDocumentId, contractId);
        const completedEventResult = await logContractEventWithResult(savedDocumentId, {
          type: "CONTRACT_COMPLETED",
          contractId,
          createdAt: completedAt,
          actorType: "CUSTOMER",
          managerCode: currentManager?.code || null,
          detail: {
            status: hasPendingCoRepresentativeSignatures
              ? "PENDING_CO_REP_SIGNATURE"
              : "COMPLETED",
            isLocked: true,
            contractHash: finalSnapshot.contractHash,
            signatureHash: primarySignatureHash,
          },
        });
        const completedAliasEventResult = await logContractEventWithResult(savedDocumentId, {
          type: "COMPLETED",
          contractId,
          createdAt: completedAt,
          actorType: "CUSTOMER",
          managerCode: currentManager?.code || null,
          detail: {
            status: hasPendingCoRepresentativeSignatures
              ? "PENDING_CO_REP_SIGNATURE"
              : "COMPLETED",
            isLocked: true,
            contractHash: finalSnapshot.contractHash,
            signatureHash: primarySignatureHash,
          },
        });
        const failedCompletionEventResult =
          completedEventResult?.ok === false
            ? completedEventResult
            : completedAliasEventResult?.ok === false
              ? completedAliasEventResult
              : null;
        if (failedCompletionEventResult) {
          await reportCompletedEventLogFailureOnce({
            contractId,
            documentId: savedDocumentId,
            draftId: contractDraftId,
            eventType: failedCompletionEventResult.eventType || "CONTRACT_COMPLETED",
            eventResult: failedCompletionEventResult,
          });
        }

        try {
          receipt = await confirmSavedContractReceipt({
            savedDocumentId,
            contractId,
            fallbackContractData: contractData,
            source: "submit",
          });
        } catch (receiptError) {
          console.error(
            "[CNFOOD] receipt confirmation failed",
            sanitizeErrorForLog(receiptError)
          );
          await handleCompletionReceiptFailure({
            savedDocumentId,
            contractId,
            contractData,
            error: receiptError,
          });
          return;
        }
      }

      if (activeInvite?.id || activeInvite?.inviteId) {
        try {
          const submittedAtForInvite = new Date().toISOString();
          const inviteDocumentId = activeInvite.id || activeInvite.inviteId;
          const response = await fetch("/api/contract-invite", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              action: "submitted",
              appId,
              inviteId: inviteDocumentId,
              contractId,
            }),
          });
          const result = await response.json().catch(() => ({ ok: false }));
          if (!response.ok || !result?.ok) {
            throw new Error(result?.message || "invite submitted update failed");
          }
          setActiveInvite((prev) =>
            prev
              ? {
                  ...prev,
                  status: result.status || "USED",
                  submittedAt: result.submittedAt || submittedAtForInvite,
                  usedAt: result.usedAt || result.submittedAt || submittedAtForInvite,
                  contractId,
                }
              : prev
          );
        } catch (inviteUpdateError) {
          console.error(
            "[CNFOOD] invite submitted update failed",
            sanitizeErrorForLog(inviteUpdateError)
          );
          reportError(
            "INVITE_SUBMIT_UPDATE_FAILED",
            inviteUpdateError?.message || "invite submitted update failed",
            5,
            { inviteId: activeInvite?.inviteId || activeInvite?.id, contractId }
          );
        }
      }

      if (CONTRACT_COMPLETION_EMAIL_NOTIFICATION_ENABLED) {
        const notificationPayload = buildContractCompletedNotificationPayload({
          contractId,
          documentId: savedDocumentId,
          appId,
        });
        void notifyContractCompleted(notificationPayload)
          .then((result) => {
            if (result?.skipped) {
              return;
            }
            console.info("[CNFOOD] notification email sent", result);
            logAdminAction(
              "notification_sent",
              contractId,
              currentManager.name,
              `recipients=${(result?.recipients || []).length}`
            );
          })
          .catch((error) => {
            console.error("[CNFOOD] notification email failed", sanitizeErrorForLog(error));
            reportError("NOTIFICATION_FAILED", error?.message || "notify failed", 5, {
              contractId,
              documentId: savedDocumentId,
              status: error?.status || null,
            });
            logAdminAction(
              "notification_failed",
              contractId,
              currentManager.name,
              error?.message || "notify failed"
            );
          });
      }

      try {
        const finalImg = await generateContractImage(
          signatureData,
          contractId,
          "CUSTOMER",
          contractData,
          signatureData2
        );
        setFinalContractImage(finalImg);
      } catch (imageError) {
        console.error(
          "[CNFOOD] completion image generation failed",
          sanitizeErrorForLog(imageError)
        );
        reportError(
          "CONTRACT_COMPLETION_IMAGE_FAILED",
          imageError?.message || "completion image generation failed",
          5,
          { contractId, documentId: savedDocumentId }
        );
      }
      setCoRepresentativeInviteLinks(coRepresentativeInviteLinksForSubmit);
      shouldReleaseSubmitLock = false;
      console.info("[contract-submit] success", {
        savedDocumentId,
      });
      setSubmitState("CONFIRMED");
      goToStep(5, {
        completionReceipt: receipt,
        savedContractId: savedDocumentId,
        lastSubmittedContractData: contractData,
      });
    } catch (error) {
      console.error("[CNFOOD] submit failed", sanitizeErrorForLog(error));
      reportError("SUBMIT_ERROR", error?.message || "submit failed", 3, {
        code: error?.code || null,
        message: error?.message || "submit failed",
        rawUndefinedPaths: submitUndefinedPaths,
        sanitizedUndefinedPaths: submitSanitizedUndefinedPaths,
        identityVerification: submitIdentityVerificationSummary,
        step,
      });
      setToastMessage(
        getFirestoreErrorToastMessage(
          error,
          "계약 저장 중 오류가 발생했습니다. 다시 시도해 주세요."
        )
      );
      setSubmitState("FAILED");
    } finally {
      setLoading(false);
      setImageGenerating(false);
      setIsSubmittingFinal(false);
    }
  } finally {
    setLoading(false);
    setImageGenerating(false);
    if (shouldReleaseSubmitLock) {
      submitContractInFlightRef.current = false;
      setIsSubmittingFinal(false);
    }
  }
};

  /* 입력 핸들러 */
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (
      STRICT_IDENTITY_FIELD_NAMES.has(name) &&
      isRepresentativeIdentityMatched(representativeIdentityVerification)
    ) {
      setToastMessage("본인확인 완료로 수정할 수 없습니다. 수정하려면 본인확인 다시하기를 눌러 주세요.");
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (STRICT_IDENTITY_FIELD_NAMES.has(name)) {
      setRepresentativeIdentityVerification(null);
      setLockedIdentityFields(null);
      setPhoneVerified(false);
      setPhoneVerifiedAt(null);
    }
    if (BUSINESS_VERIFICATION_INPUT_FIELD_NAMES.has(name)) {
      setBusinessVerification(null);
    }
    if (value) setErrors((prev) => ({ ...prev, [name]: "" }));
    if (value && activeValidationIssue?.fieldId === name) {
      setActiveValidationIssue(null);
    }
  };
  const handleDepositDayChange = (e) => {
    let val = e.target.value.replace(/[^0-9]/g, "");
    if (val && parseInt(val) > 31) val = "31";
    setFormData((prev) => ({ ...prev, depositDay: val }));
    if (val) setErrors((prev) => ({ ...prev, depositDay: "" }));
    if (val && activeValidationIssue?.fieldId === "depositDay") {
      setActiveValidationIssue(null);
    }
  };
  const handleSameDayCheck = (e) => {
    setIsSameDayDeposit(e.target.checked);
    if (e.target.checked) {
      setFormData((prev) => ({ ...prev, depositDay: "" }));
      setErrors((prev) => ({ ...prev, depositDay: "" }));
    }
  };
  const handleBizNoChange = (e) => {
    if (isRepresentativeIdentityMatched(representativeIdentityVerification)) {
      setToastMessage("본인확인 완료로 수정할 수 없습니다. 수정하려면 본인확인 다시하기를 눌러 주세요.");
      return;
    }
    const value = e.target.value.replace(/[^0-9]/g, "");
    let formatted = value;
    if (value.length > 3 && value.length <= 5)
      formatted = `${value.slice(0, 3)}-${value.slice(3)}`;
    else if (value.length > 5)
      formatted = `${value.slice(0, 3)}-${value.slice(3, 5)}-${value.slice(
        5,
        10
      )}`;
    setFormData((prev) => ({ ...prev, agentBizNo: formatted }));
    setCoRepresentativeNtsInfo(null);
    setBusinessVerification(null);
    setRepresentativeIdentityVerification(null);
    setLockedIdentityFields(null);
    setPhoneVerified(false);
    setPhoneVerifiedAt(null);
    if (value) setErrors((prev) => ({ ...prev, agentBizNo: "" }));
    if (value && activeValidationIssue?.fieldId === "agentBizNo") {
      setActiveValidationIssue(null);
    }
  };
  const handlePhoneChange = (e) => {
    if (isRepresentativeIdentityMatched(representativeIdentityVerification)) {
      setToastMessage("본인확인 완료로 수정할 수 없습니다. 수정하려면 본인확인 다시하기를 눌러 주세요.");
      return;
    }
    const value = e.target.value.replace(/[^0-9]/g, "");
    let formatted = value;
    if (value.length > 3 && value.length <= 7)
      formatted = `${value.slice(0, 3)}-${value.slice(3)}`;
    else if (value.length > 7)
      formatted = `${value.slice(0, 3)}-${value.slice(3, 7)}-${value.slice(
        7,
        11
      )}`;
    setFormData((prev) => ({ ...prev, agentContact: formatted }));
    if (value) setErrors((prev) => ({ ...prev, agentContact: "" }));
    if (value && activeValidationIssue?.fieldId === "agentContact") {
      setActiveValidationIssue(null);
    }
    if (shouldResetIdentityForPhoneChange(formData.agentContact, formatted)) {
      resetPhoneAuthState(true);
    }
  };
  const handleSSNChange = (e) => {
    const { name, value } = e.target;
    const isMatched = isRepresentativeIdentityMatched(representativeIdentityVerification);
    // Only block SSN input when encrypted backup already exists from before KCP redirect.
    // When no backup exists (user did KCP without entering SSN first), allow entry so
    // the user can fill the SSN field before proceeding to the next step.
    const hasPrincipalSsnEvidence = Boolean(restoredSsnDraft?.principalRepSsnEncrypted);
    if (
      STRICT_IDENTITY_FIELD_NAMES.has(name) &&
      isMatched &&
      hasPrincipalSsnEvidence
    ) {
      setToastMessage("본인확인 완료로 수정할 수 없습니다. 수정하려면 본인확인 다시하기를 눌러 주세요.");
      return;
    }
    const onlyNums = sanitizeNumericInput(
      value,
      /Back$/i.test(String(name || "")) ? 7 : 6
    );
    if (STRICT_IDENTITY_FIELD_NAMES.has(name) && isMatched) {
      lastIdentityFieldUserEditAtRef.current = Date.now();
    }
    setFormData((prev) => ({
      ...prev,
      [name]: onlyNums,
      ...(name === "principalRepSsnFront" ? { ssnFront: onlyNums } : {}),
      ...(name === "principalRepSsnBack" ? { ssnBack: onlyNums } : {}),
      ...(name === "ssnFront" ? { principalRepSsnFront: onlyNums } : {}),
      ...(name === "ssnBack" ? { principalRepSsnBack: onlyNums } : {}),
    }));
    // When identity is already matched (post-KCP), skip the explicit state reset here.
    // The mismatch effect handles KCP invalidation when the entered SSN conflicts
    // with the locked birth-date snapshot.
    if (STRICT_IDENTITY_FIELD_NAMES.has(name) && !isMatched) {
      setRepresentativeIdentityVerification(null);
      setLockedIdentityFields(null);
      setPhoneVerified(false);
      setPhoneVerifiedAt(null);
    }
    if (onlyNums) setErrors((prev) => ({ ...prev, ssn: "" }));
    if (onlyNums && activeValidationIssue?.fieldId === name) {
      setActiveValidationIssue(null);
    }
  };

  const getCanvasDataURLWithWhiteBackground = (
    canvas: HTMLCanvasElement
  ): string => {
    const offscreen = document.createElement("canvas");
    offscreen.width = canvas.width;
    offscreen.height = canvas.height;
    const offCtx = offscreen.getContext("2d")!;
    offCtx.fillStyle = "#ffffff";
    offCtx.fillRect(0, 0, offscreen.width, offscreen.height);
    offCtx.drawImage(canvas, 0, 0);
    return offscreen.toDataURL("image/png");
  };

  const prepareSignatureCanvas = (
    canvas: HTMLCanvasElement | null,
    imageDataUrl = ""
  ) => {
    if (!canvas) return;
    const ctx = canvas.getContext("2d", { willReadFrequently: true });
    if (!ctx) return;
    if (canvas.dataset.cnfoodSignatureReady === "true") return;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    canvas.dataset.cnfoodSignatureReady = "true";
    if (imageDataUrl) {
      const image = new Image();
      image.onload = () => {
        ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
      };
      image.src = imageDataUrl;
    }
  };

  const setCoRepresentativeSignatureCanvasRef = (
    coRepresentativeId: string,
    canvas: HTMLCanvasElement | null,
    imageDataUrl = ""
  ) => {
    if (!coRepresentativeId) return;
    coRepresentativeSignatureCanvasRefs.current[coRepresentativeId] = canvas;
    prepareSignatureCanvas(canvas, imageDataUrl);
  };

  const clearSignature = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d", { willReadFrequently: true });
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    // 투명 배경이 모바일에서 검은색으로 보이는 문제 방지
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    setIsSigned(false);
    setSignatureCompletedAt(null);
    setSignatureStrokeCount(0);
    setSignatureHash(null);
    signatureStrokeCountRef.current = 0;
  };
  const clearSignature2 = () => {
    const canvas = canvasRef2.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d", { willReadFrequently: true });
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    setSignature2(null);
    setSignatureCompletedAt(null);
    setSignature2StrokeCount(0);
    setSignature2Hash(null);
    signature2StrokeCountRef.current = 0;
  };
  const clearCoRepresentativeSignature = (coRepresentativeId: string) => {
    const canvas = coRepresentativeSignatureCanvasRefs.current[coRepresentativeId];
    if (canvas) {
      const ctx = canvas.getContext("2d", { willReadFrequently: true });
      ctx?.clearRect(0, 0, canvas.width, canvas.height);
      if (ctx) {
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
      }
      canvas.dataset.cnfoodSignatureReady = "true";
    }
    setCoRepresentatives((prev) =>
      prev.map((item) =>
        item.id === coRepresentativeId
          ? {
              ...item,
              signatureEvidence: null,
              signatureHash: "",
              signatureImageDataUrl: "",
              signatureStatus: "PENDING",
              signedAt: null,
            }
          : item
      )
    );
  };
  const getCoordinates = (e, canvas) => {
    const rect = canvas.getBoundingClientRect();
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;
    let clientX = e.clientX;
    let clientY = e.clientY;
    if (e.touches && e.touches.length > 0) {
      clientX = e.touches[0].clientX;
      clientY = e.touches[0].clientY;
    }
    return {
      x: (clientX - rect.left) * scaleX,
      y: (clientY - rect.top) * scaleY,
    };
  };
  const handleStartDraw = (e, canvasRefParam) => {
    if (e.cancelable) e.preventDefault();
    if (e.type === "touchstart") document.body.style.overflow = "hidden";
    const canvas = canvasRefParam.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const { x, y } = getCoordinates(e, canvas);
    ctx.lineWidth = 5;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#000";
    ctx.beginPath();
    ctx.moveTo(x, y);
    canvas.isDrawing = true;
  };
  const handleMoveDraw = (e, canvasRefParam, isSecond = false) => {
    const canvas = canvasRefParam.current;
    if (!canvas || !canvas.isDrawing) return;
    if (e.cancelable) e.preventDefault();
    const ctx = canvas.getContext("2d");
    const { x, y } = getCoordinates(e, canvas);
    ctx.lineTo(x, y);
    ctx.stroke();
    if (isSecond) {
      signature2StrokeCountRef.current += 1;
      setSignature2StrokeCount(signature2StrokeCountRef.current);
      setSignature2(true);
    } else {
      signatureStrokeCountRef.current += 1;
      setSignatureStrokeCount(signatureStrokeCountRef.current);
      setIsSigned(true);
    }
  };
  const handleEndDraw = async (canvasRefParam) => {
    const canvas = canvasRefParam.current;
    if (canvas) {
      const hadDrawing = Boolean(canvas.isDrawing);
      canvas.isDrawing = false;
      if (hadDrawing) {
        const signedAt = new Date().toISOString();
        const isSecondSignature = canvasRefParam === canvasRef2;
        const strokeCount = isSecondSignature
          ? signature2StrokeCountRef.current
          : signatureStrokeCountRef.current;
        const signatureMetrics = getCanvasSignatureMetrics(canvas);
        const signatureValidation =
          validateSignatureQualityMetrics(signatureMetrics);
        if (signatureValidation.valid) {
          try {
            const imageDataUrl = getCanvasDataURLWithWhiteBackground(canvas);
            const imageHash = await createSha256Hash(imageDataUrl);
            if (isSecondSignature) setSignature2Hash(imageHash);
            else setSignatureHash(imageHash);
            setSignatureCompletedAt(signedAt);
            queueContractEvent("SIGNATURE_CREATED", {
              signatureSlot: isSecondSignature ? "representative" : "primary",
              strokeCount,
              signatureValidation,
              imageHash,
            });
            if (!isSecondSignature) {
              queueContractEvent("SIGNED", {
                signatureSlot: "primary",
                strokeCount,
                signatureValidation,
                imageHash,
              });
            }
          } catch (error) {
            console.error("[CNFOOD] signature hash failed", sanitizeErrorForLog(error));
          }
        }
        const log = await createLog("서명 입력", "자필 서명 데이터 생성");
        auditLogsRef.current.push(log);
      }
    }
    document.body.style.overflow = "auto";
  };

  /* ================= 계약서 생성 ================= */
  const handleCoRepresentativeSignatureStart = (
    event,
    coRepresentativeId: string
  ) => {
    const target = coRepresentatives.find((item) => item.id === coRepresentativeId);
    if (
      !target ||
      getCoRepresentativeSignatureMode(target) !==
        CO_REPRESENTATIVE_SIGNATURE_MODE_DIRECT ||
      !isCoRepresentativeIdentityReadyForSigning(target)
    ) {
      setToastMessage("공동계약인 본인확인 완료 후 직접서명할 수 있습니다.");
      return;
    }
    const canvas = coRepresentativeSignatureCanvasRefs.current[coRepresentativeId];
    if (!canvas) return;
    if (event.cancelable) event.preventDefault();
    if (event.type === "touchstart") document.body.style.overflow = "hidden";
    const ctx = canvas.getContext("2d", { willReadFrequently: true });
    if (!ctx) return;
    const { x, y } = getCoordinates(event, canvas);
    ctx.lineWidth = 5;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#000";
    ctx.beginPath();
    ctx.moveTo(x, y);
    (canvas as any).isDrawing = true;
  };

  const handleCoRepresentativeSignatureMove = (
    event,
    coRepresentativeId: string
  ) => {
    const canvas = coRepresentativeSignatureCanvasRefs.current[coRepresentativeId];
    if (!canvas || !(canvas as any).isDrawing) return;
    if (event.cancelable) event.preventDefault();
    const ctx = canvas.getContext("2d", { willReadFrequently: true });
    if (!ctx) return;
    const { x, y } = getCoordinates(event, canvas);
    ctx.lineTo(x, y);
    ctx.stroke();
  };

  const handleCoRepresentativeSignatureEnd = async (
    coRepresentativeId: string
  ) => {
    const canvas = coRepresentativeSignatureCanvasRefs.current[coRepresentativeId];
    if (!canvas) {
      document.body.style.overflow = "auto";
      return;
    }
    const hadDrawing = Boolean((canvas as any).isDrawing);
    (canvas as any).isDrawing = false;
    document.body.style.overflow = "auto";
    if (!hadDrawing) return;

    const target = coRepresentatives.find((item) => item.id === coRepresentativeId);
    if (!target) return;
    const signatureMetrics = getCanvasSignatureMetrics(canvas);
    const signatureValidation = validateSignatureQualityMetrics(signatureMetrics);
    const signedAt = new Date().toISOString();
    if (!signatureValidation.valid) {
      setCoRepresentatives((prev) =>
        prev.map((item) =>
          item.id === coRepresentativeId
            ? {
                ...item,
                signatureEvidence: {
                  role: "CO_REPRESENTATIVE_DIRECT",
                  label: CO_REPRESENTATIVE_DIRECT_SIGNATURE_LABEL,
                  signerName: item.name || "",
                  valid: false,
                  validation: signatureValidation,
                  signatureHash: null,
                  signedAt: null,
                },
                signatureHash: "",
                signatureStatus: "PENDING",
                signedAt: null,
              }
            : item
        )
      );
      setToastMessage(getSignatureQualityErrorMessage(signatureValidation.reason));
      return;
    }

    try {
      const imageDataUrl = getCanvasDataURLWithWhiteBackground(canvas);
      const imageHash = await createSha256Hash(imageDataUrl);
      setCoRepresentatives((prev) =>
        prev.map((item) =>
          item.id === coRepresentativeId
            ? {
                ...item,
                signatureMode: CO_REPRESENTATIVE_SIGNATURE_MODE_DIRECT,
                signatureImageDataUrl: imageDataUrl,
                signatureHash: imageHash,
                signatureEvidence: {
                  role: "CO_REPRESENTATIVE_DIRECT",
                  label: CO_REPRESENTATIVE_DIRECT_SIGNATURE_LABEL,
                  signerName: item.name || target.name || "",
                  valid: true,
                  validation: signatureValidation,
                  signatureHash: imageHash,
                  signedAt,
                },
                signatureStatus: "SIGNED_DIRECTLY",
                signedAt,
              }
            : item
        )
      );
      queueContractEvent("SIGNATURE_CREATED", {
        signatureSlot: "co_representative",
        coRepresentativeId,
        signatureValidation,
        imageHash,
      });
    } catch (error) {
      console.error(
        "[CNFOOD] co-representative signature hash failed",
        sanitizeErrorForLog(error)
      );
      setToastMessage("공동계약인 서명 저장 중 오류가 발생했습니다. 다시 서명해 주세요.");
    }
  };

  const generateContractImagePages = (
    signUrl,
    cId,
    type = "CUSTOMER",
    dataOverride = null,
    signUrl2 = null
  ) => {
    const dataToUse = dataOverride || formData;
    const fieldPrintModel = dataToUse.fieldPrintModel || null;
    const isFieldPrintDocument = Boolean(fieldPrintModel);
    const outputBusinessName =
      dataToUse.adminOutputBusinessName ||
      getAdminDisplayBusinessName(dataToUse) ||
      dataToUse.agentName ||
      "";
    const outputPrincipalResidentNumber =
      getContractOutputPrincipalResidentNumberDisplay(dataToUse);
    const outputPhoneNumber = getContractOutputPhoneDisplay(dataToUse);
    const currentBizType = dataToUse.bizType || bizType;
    const useCorporatePrintR2 = shouldUseCorporateContractPrintR2(
      { ...dataToUse, bizType: currentBizType }
    );
    let year = selYear,
      month = selMonth,
      day = selDay;
    const displayDateParts = getContractDisplayDateParts(dataToUse);
    if (displayDateParts) {
      year = displayDateParts.year;
      month = displayDateParts.month;
      day = displayDateParts.day;
    }
    return new Promise((resolve) => {
      const cvs = contractCanvasRef.current;
      if (!cvs) {
        resolve([]);
        return;
      }
      const ctx = cvs.getContext("2d");
      if (!ctx) {
        resolve([]);
        return;
      }
      const width = 1240;
      const height = 1754;
      const pages = [];
      const resetContractPage = () => {
        cvs.width = width;
        cvs.height = height;
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, width, height);
        ctx.strokeStyle = "#000";
        ctx.lineWidth = 2;
        ctx.strokeRect(40, 40, width - 80, height - 80);
      };
      const pushContractPage = () => {
        pages.push(cvs.toDataURL("image/jpeg", 0.7));
      };
      const drawImageAsync = (url, x, y, w, h) => {
        return new Promise((res) => {
          if (!url) {
            res();
            return;
          }
          const img = new Image();
          img.src = url;
          img.crossOrigin = "anonymous";
          img.onload = () => {
            ctx.drawImage(img, x, y, w, h);
            res();
          };
          img.onerror = () => {
            if (url.includes("logo")) {
              ctx.fillStyle = "#000";
              ctx.font = "bold 20px serif";
              ctx.fillText("SEA&FOOD", x, y + 20);
            } else if (url.includes("seal")) {
              ctx.strokeStyle = "red";
              ctx.lineWidth = 2;
              ctx.beginPath();
              ctx.arc(x + w / 2, y + h / 2, w / 2, 0, 2 * Math.PI);
              ctx.stroke();
              ctx.fillStyle = "red";
              ctx.font = "bold 16px serif";
              ctx.textAlign = "center";
              ctx.fillText("(인)", x + w / 2, y + h / 2 + 6);
              ctx.fillStyle = "#000";
              ctx.textAlign = "left";
            }
            res();
          };
        });
      };
      const drawText = (
        text,
        x,
        y,
        font = "16px sans-serif",
        align = "left",
        color = "#000"
      ) => {
        ctx.fillStyle = color;
        ctx.font = font;
        ctx.textAlign = align;
        ctx.fillText(text, x, y);
      };
      const drawWrappedText = (
        text,
        x,
        y,
        maxWidth,
        lineHeight,
        font = "16px sans-serif"
      ) => {
        ctx.font = font;
        ctx.fillStyle = "#000";
        ctx.textAlign = "left";
        let words = text.split("");
        let line = "";
        let currentY = y;
        for (let n = 0; n < words.length; n++) {
          let testLine = line + words[n];
          if (ctx.measureText(testLine).width > maxWidth && n > 0) {
            ctx.fillText(line, x, currentY);
            line = words[n];
            currentY += lineHeight;
          } else {
            line = testLine;
          }
        }
        ctx.fillText(line, x, currentY);
        return currentY + lineHeight;
      };
      const drawPdfField = ({
        label,
        value,
        x,
        y,
        labelWidth = 90,
        valueWidth = 300,
        lineHeight = 20,
        fontSize = 14,
        minFontSize = 11,
        gap = 8,
      }) => {
        drawText(label, x, y, `bold ${fontSize}px serif`);
        const valueBox = drawWrappedTextInBox(ctx, {
          text: value || "",
          x: x + labelWidth,
          y,
          width: valueWidth,
          lineHeight,
          fontSize,
          minFontSize,
          fontFamily: "serif",
        });
        return getNextYAfterBox(valueBox, gap);
      };
      const drawCursiveSignatureFallback = ({
        text = "",
        x,
        y,
        width: boxWidth,
        height: boxHeight,
      }) => {
        const fallbackName = useCorporatePrintR2 ? "서명자" : "공동계약인";
        const fallbackText = String(text || fallbackName).trim() || fallbackName;
        ctx.save();
        ctx.fillStyle = "#111827";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        let fontSize = 34;
        const fontFamily =
          '"Brush Script MT", "Segoe Script", "Nanum Pen Script", cursive, serif';
        do {
          ctx.font = `italic ${fontSize}px ${fontFamily}`;
          if (ctx.measureText(fallbackText).width <= boxWidth - 22) break;
          fontSize -= 2;
        } while (fontSize > 18);
        ctx.fillText(fallbackText, x + boxWidth / 2, y + boxHeight / 2 + 3);
        ctx.restore();
      };
      const drawContractHeader = async (sectionTitle = "") => {
        resetContractPage();
        await drawImageAsync(LOGO_URL, 60, 60, 100, 60);
        if (isIdentityTestModeContract(dataToUse)) {
          ctx.fillStyle = "#b91c1c";
          ctx.fillRect(40, 40, width - 80, 34);
          drawText(
            TEST_MODE_PDF_NOTICE,
            width / 2,
            64,
            "bold 20px sans-serif",
            "center",
            "#fff"
          );
        }
        drawText(
          "통 합  공 급  계 약 서",
          cvs.width / 2,
          110,
          "bold 50px serif",
          "center"
        );
        ctx.fillStyle = "#000";
        ctx.fillRect(cvs.width - 240, 60, 180, 40);
        drawText(
          type === "HQ" ? "[본사보관용]" : "[고객보관용]",
          cvs.width - 150,
          88,
          "bold 22px serif",
          "center",
          "#fff"
        );
        ctx.strokeStyle = "#000";
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.moveTo(40, 140);
        ctx.lineTo(cvs.width - 40, 140);
        ctx.stroke();
        if (sectionTitle) {
          drawText(sectionTitle, 70, 220, "bold 24px sans-serif");
          ctx.strokeStyle = "#d1d5db";
          ctx.lineWidth = 1;
          ctx.beginPath();
          ctx.moveTo(70, 242);
          ctx.lineTo(cvs.width - 70, 242);
          ctx.stroke();
        }
      };
      const drawSignatureSection = async (startY) => {
        if (isFieldPrintDocument) {
          const suppliers = Array.isArray(fieldPrintModel.suppliers)
            ? fieldPrintModel.suppliers
            : DEFAULT_FIELD_PRINT_SUPPLIERS;
          const buyer = fieldPrintModel.buyer;
          const footerY = Math.max(startY, CONTRACT_SIGNATURE_PDF_LAYOUT.contentStartY);
          const lineHeight = 28;
          const drawBlankField = (label, x, y, rightX, labelWidth = 160) => {
            drawText(`${label} :`, x, y, "bold 16px serif");
            ctx.beginPath();
            ctx.moveTo(x + labelWidth, y + 4);
            ctx.lineTo(rightX, y + 4);
            ctx.stroke();
          };
          const leftX = 60;
          const rightX = 640;
          const rightRightX = 1180;
          const topBoxY = footerY;

          drawText("【 공급자 】", leftX, topBoxY + 32, "bold 18px serif");
          let supplierY = topBoxY + 62;
          for (const [supplierIndex, supplier] of suppliers.entries()) {
            const rows = [
              ...(supplier.includePhone ? [["대 표 번 호", supplier.mainPhone]] : []),
              ["주        소", supplier.businessAddress],
              ["사업자등록번호", supplier.businessNumber],
              ["상        호", supplier.companyName],
              ["대   표   자", `${supplier.representativeName}  (인)`],
            ];
            const supplierStartY = supplierY;
            rows.forEach(([label, value]) => {
              drawText(`${label} : ${value}`, leftX, supplierY, "16px serif");
              supplierY += lineHeight;
            });
            await drawImageAsync(
              supplier.sealUrl || SEAL_URL_2,
              470,
              supplierStartY + 6,
              60,
              60
            );
            if (supplierIndex < suppliers.length - 1) {
              supplierY += 12;
            }
          }

          drawText("【 공급받는자 】", rightX, topBoxY + 32, "bold 18px serif");
          drawText(`【 ${buyer.businessHeading} 】`, rightX, topBoxY + 62, "bold 16px serif");
          let buyerY = topBoxY + 90;
          buyer.businessFields.forEach((field) => {
            drawBlankField(field, rightX, buyerY, rightRightX);
            buyerY += lineHeight;
          });

          const topBoxHeight = Math.max(250, supplierY - topBoxY + 24, buyerY - topBoxY + 24);
          ctx.strokeRect(40, topBoxY, 560, topBoxHeight);
          ctx.strokeRect(640, topBoxY, 560, topBoxHeight);

          let personY = topBoxY + topBoxHeight + 34;
          const personBlockHeight = 176;
          for (const person of buyer.people) {
            if (personY + personBlockHeight > 1680) {
              pushContractPage();
              await drawContractHeader("계약 확인 및 서명 계속");
              personY = CONTRACT_SIGNATURE_PDF_LAYOUT.contentStartY;
            }
            ctx.strokeRect(40, personY, 1160, personBlockHeight);
            drawText(`【 ${person.heading} 】`, 60, personY + 30, "bold 18px serif");
            let fieldY = personY + 60;
            person.fields.forEach((field) => {
              drawBlankField(field, 60, fieldY, 1180, 180);
              fieldY += 22;
            });
            personY += personBlockHeight + 12;
          }
          return personY;
        }
        let y = Math.max(startY, CONTRACT_SIGNATURE_PDF_LAYOUT.contentStartY);
        const signatureBottomY = 1680;
        const ensureSignatureSpace = async (requiredHeight = 140) => {
          if (y + requiredHeight <= signatureBottomY) return;
          pushContractPage();
          await drawContractHeader("계약 확인 및 서명 계속");
          y = CONTRACT_SIGNATURE_PDF_LAYOUT.contentStartY;
        };
        ctx.fillStyle = "#f3f4f6";
        const creditBoxY = y;
        const creditLines = buildCreditCheckConsentLines().filter(
          (line) => line && !line.startsWith("[")
        );
        const creditTextStartY = creditBoxY + 48;
        let measuredCreditTextY = creditTextStartY;
        const creditLineHeight = 16;
        creditLines.forEach((line) => {
          const measured = splitTextToFitBox({
            ctx,
            text: line,
            width: 1080,
            lineHeight: creditLineHeight,
            fontSize: 12,
            minFontSize: 12,
            fontFamily: "sans-serif",
          });
          measuredCreditTextY += measured.height;
        });
        const creditBoxH = Math.max(155, measuredCreditTextY - creditBoxY + 18);
        ctx.fillRect(40, creditBoxY, 1160, creditBoxH);
        ctx.strokeRect(40, creditBoxY, 1160, creditBoxH);
        ctx.fillStyle = "#000";
        drawText(
          "- 신용정보 조회 및 활용 동의 -",
          60,
          creditBoxY + 25,
          "bold 14px sans-serif"
        );
        let creditTextY = creditTextStartY;
        creditLines.forEach((line) => {
          creditTextY = drawWrappedText(
            line,
            60,
            creditTextY,
            1080,
            creditLineHeight,
            "12px sans-serif"
          );
        });
        y = Math.max(creditBoxY + creditBoxH + 10, creditTextY + 10);

        const shouldRenderLegacyBlock = shouldRenderLegacyCorporateSignatureBlock({
          contract: dataToUse,
          signUrl2,
        });

        const coRepresentativePdfRows = buildCorporateCoRepresentativePdfRows(
          dataToUse,
          {
            outputPrincipalResidentNumber,
            outputPhoneNumber,
            signUrl2,
          }
        );
        const getCoContractorSourceRow = (item) => {
          const rows = Array.isArray(dataToUse.coRepresentatives)
            ? dataToUse.coRepresentatives
            : [];
          const id = getCoRepresentativeOutputMatchId(item);
          const name = normalizeRepresentativeNameForMatch(item?.name || "");
          return (
            (id &&
              rows.find(
                (sourceItem) =>
                  getCoRepresentativeOutputMatchId(sourceItem) === id
              )) ||
            (name &&
              rows.find(
                (sourceItem) =>
                  normalizeRepresentativeNameForMatch(sourceItem?.name || "") === name
              )) ||
            item
          );
        };
        const getCoContractorIdentityLabel = (item) => {
          const identity = item.identityVerification || {};
          const identityComplete =
            identity.subjectType === "CO_REP" &&
            identity.coRepresentativeId === item.id &&
            (identity.status === "MATCHED" || identity.status === "VERIFIED") &&
            identity.hasCi === true &&
            identity.hasDi === true;
          if (identityComplete) return "KCP 본인확인 완료";
          if (item.kcpStatus === "REGISTERED" || item.kcpStatus === "PENDING") {
            return "본인확인 대기";
          }
          return item.kcpStatus || "본인확인 미완료";
        };
        const measureCoContractorBlockHeight = (item) => {
          const sourceItem = getCoContractorSourceRow(item);
          const hasSignatureImage = Boolean(
            getContractOutputCoRepresentativeSignatureImage(dataToUse, item) ||
              getContractOutputCoRepresentativeSignatureImage(dataToUse, sourceItem)
          );
          if (useCorporatePrintR2) {
            const values = [
              item.name || "미수집",
              getContractOutputCoRepresentativeResidentNumberDisplay(sourceItem) ||
                getContractOutputCoRepresentativeResidentNumberDisplay(item) || "미수집",
              getContractOutputCoRepresentativePhoneDisplay(sourceItem) || "미수집",
              item.homeAddressMasked || "미수집",
              getCoContractorIdentityLabel(item),
            ];
            const fieldBottomY = values.reduce((bottom, text) => bottom +
              splitTextToFitBox({ ctx, text, width: 390, lineHeight: 20,
                fontSize: 13, minFontSize: 11, fontFamily: "serif" }).height + 8, 30);
            return getCoContractorPdfBlockLayout({
              blockY: 0, fieldBottomY, hasSignatureImage,
            }).blockHeight;
          }
          return hasSignatureImage ? 286 : 256;
        };
        const renderCoContractorBlock = async (item, index, startY) => {
          const sourceItem = getCoContractorSourceRow(item);
          const blockY = startY;
          if (!useCorporatePrintR2) {
            drawText(`공동계약인 ${index + 1}`, 670, blockY + 30, "bold 16px serif");
          }
          let fieldY = blockY + (useCorporatePrintR2 ? 30 : 58);
          fieldY = drawPdfField({
            label: "성명:",
            value: item.name || "미수집",
            x: 670,
            y: fieldY,
            labelWidth: 85,
            valueWidth: 390,
            lineHeight: 20,
            fontSize: 13,
          });
          fieldY = drawPdfField({
            label: "주민번호:",
            value:
              getContractOutputCoRepresentativeResidentNumberDisplay(sourceItem) ||
              getContractOutputCoRepresentativeResidentNumberDisplay(item) ||
              "미수집",
            x: 670,
            y: fieldY,
            labelWidth: 85,
            valueWidth: 390,
            lineHeight: 20,
            fontSize: 13,
          });
          fieldY = drawPdfField({
            label: "휴대폰:",
            value:
              getContractOutputCoRepresentativePhoneDisplay(sourceItem) ||
              "미수집",
            x: 670,
            y: fieldY,
            labelWidth: 85,
            valueWidth: 390,
            lineHeight: 20,
            fontSize: 13,
          });
          fieldY = drawPdfField({
            label: "자택주소:",
            value: item.homeAddressMasked || "미수집",
            x: 670,
            y: fieldY,
            labelWidth: 85,
            valueWidth: 390,
            lineHeight: 20,
            fontSize: 13,
          });
          fieldY = drawPdfField({
            label: "본인확인:",
            value: getCoContractorIdentityLabel(item),
            x: 670,
            y: fieldY,
            labelWidth: 85,
            valueWidth: 390,
            lineHeight: 20,
            fontSize: 13,
          });

          const signatureDisplay = getContractOutputCoRepresentativeSignatureDisplay(
            dataToUse,
            sourceItem || item
          );
          const signatureLayout = getCoContractorPdfBlockLayout({
            blockY,
            fieldBottomY: fieldY,
            hasSignatureImage: Boolean(signatureDisplay.imageDataUrl),
          });
          const { blockHeight, signatureRowY } = signatureLayout;
          drawText(useCorporatePrintR2 ? "서명:" : "공동계약인 서명:",
            670, signatureRowY + 28, "bold 13px serif");
          if (signatureDisplay.completed && signatureDisplay.imageDataUrl) {
            ctx.strokeStyle = "#94a3b8";
            ctx.strokeRect(805, signatureRowY, 160, 68);
            await drawImageAsync(
              signatureDisplay.imageDataUrl,
              813,
              signatureRowY + 8,
              144,
              52
            );
            drawText(
              `서명일시: ${signatureDisplay.signedAt || "미수집"}`,
              980,
              signatureRowY + 28,
              "11px serif"
            );
          } else if (signatureDisplay.completed) {
            ctx.strokeStyle = "#94a3b8";
            ctx.strokeRect(805, signatureRowY, 160, 68);
            drawCursiveSignatureFallback({
              text: signatureDisplay.signerName || item.name ||
                (useCorporatePrintR2 ? "서명자" : "공동계약인"),
              x: 805,
              y: signatureRowY,
              width: 160,
              height: 68,
            });
            drawText("전자서명 완료", 980, signatureRowY + 22, "11px serif");
            drawText(
              `서명일시: ${signatureDisplay.signedAt || "미수집"}`,
              980,
              signatureRowY + 50,
              "11px serif"
            );
          } else {
            drawText("서명 미완료", 805, signatureRowY + 28, "13px serif");
          }
          ctx.strokeStyle = "#0f172a";
          ctx.strokeRect(650, blockY, 540, blockHeight);
          return blockY + blockHeight + 18;
        };
        const estimatedRecipientBlockHeight =
          340 +
          (shouldRenderLegacyBlock ? 230 : 0) +
          (useCorporatePrintR2 ? coRepresentativePdfRows.slice(0, 1) : coRepresentativePdfRows).reduce(
            (total, item) => total + measureCoContractorBlockHeight(item) + 18,
            0
          );
        await ensureSignatureSpace(estimatedRecipientBlockHeight);
        const footerY = y;
        let recipientPageTopY = footerY;
        let boxH = 320;
        drawText("【 공급자 】", 60, footerY + 30, "bold 18px serif");
        let fy = footerY + 60;
        const flh = 28;
        const supplierSnapshotForPdf =
          dataToUse.finalSnapshot?.supplierInfoSnapshot ||
          dataToUse.supplierInfoSnapshot ||
          null;
        const branchSnapshotForPdf =
          dataToUse.finalSnapshot?.contractCompanyBranch ||
          dataToUse.contractCompanyBranch ||
          null;
        if (branchSnapshotForPdf?.id) {
          drawText(
            `대 표 번 호 : ${supplierSnapshotForPdf?.mainPhone || "1522-8639"}`,
            60,
            fy,
            "16px serif"
          );
          fy += flh;
          drawText(
            `주        소 : ${
              branchSnapshotForPdf.address ||
              supplierSnapshotForPdf?.businessAddress ||
              CNFOOD_BUSINESS_PROFILE.businessAddress
            }`,
            60,
            fy,
            "16px serif"
          );
          fy += flh;
          drawText(
            `사업자등록번호 : ${
              branchSnapshotForPdf.businessNumber ||
              supplierSnapshotForPdf?.businessNumber ||
              CNFOOD_BUSINESS_PROFILE.businessNumber
            }`,
            60,
            fy,
            "16px serif"
          );
          fy += flh;
          drawText(
            `상        호 : ${
              branchSnapshotForPdf.corporationName ||
              branchSnapshotForPdf.branchName ||
              supplierSnapshotForPdf?.companyName ||
              CNFOOD_BUSINESS_PROFILE.companyName
            }`,
            60,
            fy,
            "16px serif"
          );
          fy += flh;
          drawText(
            `대   표   자 : ${
              branchSnapshotForPdf.representativeName ||
              supplierSnapshotForPdf?.representativeName ||
              CNFOOD_BUSINESS_PROFILE.representativeName
            }  (인)`,
            60,
            fy,
            "16px serif"
          );
          await drawImageAsync(SEAL_URL_2, 400, fy - 35, 60, 60);
        } else {
          drawText(`대 표 번 호 : 1522-8639`, 60, fy, "16px serif");
          fy += flh;
          drawText(
            `주        소 : 경기도 화성시 송산면 송산포도로 575`,
            60,
            fy,
            "16px serif"
          );
          fy += flh;
          drawText(`사업자등록번호 : 627-85-01397`, 60, fy, "16px serif");
          fy += flh;
          drawText(
            `상        호 : 주식회사 씨엔푸드 화성지점`,
            60,
            fy,
            "16px serif"
          );
          fy += flh;
          drawText(`대   표   자 : 유 인 식  (인)`, 60, fy, "16px serif");
          await drawImageAsync(SEAL_URL_1, 400, fy - 35, 60, 60);
          fy += flh + 10;
          drawText(
            `주        소 : 경기도 화성시 송산면 송산포도로 575`,
            60,
            fy,
            "16px serif"
          );
          fy += flh;
          drawText(`사업자등록번호 : 343-88-00695`, 60, fy, "16px serif");
          fy += flh;
          drawText(
            `상        호 : 농업회사법인 주식회사 씨엔푸드`,
            60,
            fy,
            "16px serif"
          );
          fy += flh;
          drawText(`대   표   자 : 유 인 식  (인)`, 60, fy, "16px serif");
          await drawImageAsync(SEAL_URL_2, 400, fy - 35, 60, 60);
        }
        const leftEndY = fy + flh;
        let recipientPageLeftEndY = leftEndY;

        drawText("【 공급받는자 】", 660, footerY + 30, "bold 18px serif");
        fy = footerY + 60;
        const addr = `${dataToUse.agentAddress} ${
          dataToUse.agentAddressDetail || ""
        }`;
        fy = drawPdfField({
          label: "주        소 :",
          value: addr,
          x: 660,
          y: fy,
          labelWidth: 95,
          valueWidth: 410,
          lineHeight: 22,
          fontSize: 16,
        });
        fy = drawPdfField({
          label: "사업자등록번호 :",
          value: dataToUse.agentBizNo,
          x: 660,
          y: fy,
          labelWidth: 130,
          valueWidth: 375,
          lineHeight: 22,
          fontSize: 16,
        });
        fy = drawPdfField({
          label: "상        호 :",
          value: outputBusinessName,
          x: 660,
          y: fy,
          labelWidth: 95,
          valueWidth: 410,
          lineHeight: 22,
          fontSize: 16,
        });
        fy = drawPdfField({
          label: "본 대표 주민번호 :",
          value: outputPrincipalResidentNumber,
          x: 660,
          y: fy,
          labelWidth: 145,
          valueWidth: 360,
          lineHeight: 22,
          fontSize: 16,
        });

        fy += 14;
        const pdfPrimarySignatureDescriptor = getPrimarySignatureRoleDescriptor({
          bizType: dataToUse.bizType,
          coRepresentativesRequired:
            dataToUse.coRepresentativeDeclared === true ||
            (Array.isArray(dataToUse.coRepresentatives) &&
              dataToUse.coRepresentatives.length > 0),
        });
        const signerSignatureText = `${dataToUse.agentRep}  (인)`;
        setPdfFont(ctx, 16, "serif");
        const signerLayout = getRepresentativeSignatureRowLayout({
          x: 660,
          y: fy,
          width: 520,
          labelWidth: 145,
          nameTextWidth: ctx.measureText(signerSignatureText).width,
          signatureWidth: 112,
          signatureHeight: 56,
          rowPaddingTop: 8,
          rowPaddingBottom: 14,
        });
        drawText(`${pdfPrimarySignatureDescriptor.label} :`, 660, fy, "bold 16px serif");
        const signerNameBox = drawWrappedTextInBox(ctx, {
          text: signerSignatureText,
          x: signerLayout.nameValueBox.x,
          y: fy,
          width: signerLayout.nameValueBox.width,
          lineHeight: 22,
          fontSize: 16,
          minFontSize: 12,
          fontFamily: "serif",
        });
        await drawSignatureInBox(ctx, signUrl, signerLayout.signatureBox);
        fy = Math.max(signerLayout.nextY, getNextYAfterBox(signerNameBox, 10));

        fy = drawPdfField({
          label: "전화번호 :",
          value: outputPhoneNumber,
          x: 660,
          y: fy,
          labelWidth: 95,
          valueWidth: 410,
          lineHeight: 22,
          fontSize: 16,
        });
        drawText(`(대표자번호)`, 660, fy, "16px serif");
        fy += flh;

        if (shouldRenderLegacyBlock) {
          const jointY = fy;
          const personalGuarantee = dataToUse.representativePersonalGuarantee || {};
          const repInfo =
            personalGuarantee.signerAddressMasked ||
            dataToUse.principalRepHomeAddressMasked ||
            `${dataToUse.corpRepAddress || ""} ${
              dataToUse.corpRepAddressDetail || ""
            }`;
          const repSSN =
            dataToUse.adminOutputPrincipalResidentNumber
              ? outputPrincipalResidentNumber
              : personalGuarantee.signerSsnMasked ||
                getPrincipalRepSsnDisplayValue(dataToUse);
          const repName =
            personalGuarantee.signerName ||
            `${dataToUse.corpRepName || dataToUse.agentRep || ""}`;

          if (useCorporatePrintR2) {
            drawText("서명", 670, jointY + 35, "bold 16px serif");
          } else {
            drawText("< 공동계약인 확인 >", 670, jointY + 35, "bold 16px serif");
          }
          drawText(
            useCorporatePrintR2
              ? "본인확인 및 전자서명 진행 상태를 확인합니다."
              : "공동계약인 확인 및 전자서명 진행 상태를 확인합니다.",
            670,
            jointY + 58,
            "12px serif"
          );

          let jointFieldY = jointY + 82;
          jointFieldY = drawPdfField({
            label: "주소:",
            value: repInfo,
            x: 670,
            y: jointFieldY,
            labelWidth: 80,
            valueWidth: 390,
            lineHeight: 18,
            fontSize: 14,
          });
          jointFieldY = drawPdfField({
            label: useCorporatePrintR2 ? "주민번호:" : "공동계약인 주민번호:",
            value: repSSN,
            x: 670,
            y: jointFieldY,
            labelWidth: 150,
            valueWidth: 320,
            lineHeight: 18,
            fontSize: 14,
          });
          jointFieldY = drawPdfField({
            label: useCorporatePrintR2 ? "본인확인:" : "공동계약인 확인:",
            value: personalGuarantee.agreed
              ? `동의 (${formatEvidenceDate(personalGuarantee.agreedAt, "시각 미수집")})`
              : "미확인",
            x: 670,
            y: jointFieldY,
            labelWidth: 150,
            valueWidth: 320,
            lineHeight: 18,
            fontSize: 14,
          });
          jointFieldY += 10;
          const guarantorSignatureText = `${repName} (인)`;
          setPdfFont(ctx, 14, "serif");
          const guarantorSignatureLayout = getRepresentativeSignatureRowLayout({
            x: 670,
            y: jointFieldY,
            width: 500,
            labelWidth: 70,
            nameTextWidth: ctx.measureText(guarantorSignatureText).width,
            signatureWidth: 110,
            signatureHeight: 54,
            rowPaddingTop: 8,
            rowPaddingBottom: 14,
          });
          drawText("성명:", 670, jointFieldY, "bold 14px serif");
          const guarantorNameBox = drawWrappedTextInBox(ctx, {
            text: guarantorSignatureText,
            x: guarantorSignatureLayout.nameValueBox.x,
            y: jointFieldY,
            width: guarantorSignatureLayout.nameValueBox.width,
            lineHeight: 18,
            fontSize: 14,
            minFontSize: 11,
            fontFamily: "serif",
          });
          await drawSignatureInBox(
            ctx,
            signUrl2,
            guarantorSignatureLayout.signatureBox
          );
          jointFieldY = Math.max(
            guarantorSignatureLayout.nextY,
            getNextYAfterBox(guarantorNameBox, 10)
          );

          const jointBoxH = Math.max(140, jointFieldY - jointY + 18);
          ctx.strokeRect(650, jointY, 540, jointBoxH);
          fy = jointY + jointBoxH + 18;
        }

        for (const [index, item] of coRepresentativePdfRows.entries()) {
          if (useCorporatePrintR2 &&
              fy + measureCoContractorBlockHeight(item) + 38 > signatureBottomY) {
            boxH = Math.max(320, recipientPageLeftEndY - recipientPageTopY + 20,
              fy - recipientPageTopY + 20);
            ctx.strokeRect(40, recipientPageTopY, 560, boxH);
            ctx.strokeRect(640, recipientPageTopY, 560, boxH);
            pushContractPage();
            await drawContractHeader("계약 확인 및 서명 계속");
            recipientPageTopY = CONTRACT_SIGNATURE_PDF_LAYOUT.contentStartY;
            recipientPageLeftEndY = recipientPageTopY;
            fy = recipientPageTopY + 30;
          }
          fy = await renderCoContractorBlock(item, index, fy);
        }

        boxH = Math.max(320, recipientPageLeftEndY - recipientPageTopY + 20,
          fy - recipientPageTopY + 20);
        ctx.strokeRect(40, recipientPageTopY, 560, boxH);
        ctx.strokeRect(640, recipientPageTopY, 560, boxH);
        return recipientPageTopY + boxH;
      };
      (async () => {
        try {
          await drawContractHeader();
          let y = 180;
          const lh = 28;
          y = drawWrappedText(
            `주식회사 씨엔푸드, 농업회사법인 주식회사 씨엔푸드 대표자 유인식 (이하 "공급자"라 칭함)과`,
            70,
            y,
            1080,
            lh,
            "bold 18px sans-serif"
          );
          y = drawWrappedText(
            `${
              outputBusinessName || "______"
            } (이하 "공급받는자"라 칭함)간에 발생하는 거래를 약정하는`,
            70,
            y,
            1080,
            lh,
            "bold 18px sans-serif"
          );
          drawText(
            `계약을 아래와 같이 체결한다.`,
            70,
            y,
            "bold 18px sans-serif"
          );
          y += lh + 15;
          let depositText = "____일";
          if (dataToUse.depositDay) depositText = `${dataToUse.depositDay}일`;
          else if (isSameDayDeposit) depositText = "당일";
          else depositText = "당일";
          const paymentConditionText = getCorporateContractDepositOutputText({
            bizType: currentBizType,
            depositDay: dataToUse.depositDay,
            legacyDepositText: depositText,
            enabled: useCorporatePrintR2,
            sameDayDeposit: isSameDayDeposit,
            completedContract: isCompletedContractLike(dataToUse),
          });
          const pdfClauseSource = resolveContractClauseSource({
            contract: dataToUse,
            activeTemplate: isCompletedContractLike(dataToUse)
              ? null
              : activeContractTemplate,
            contractData: dataToUse,
          });

          y += 10;
          const partyBoxY = y;
          ctx.fillStyle = "#f8fafc";
          ctx.fillRect(60, partyBoxY, 1120, 120);
          ctx.strokeStyle = "#cbd5e1";
          ctx.strokeRect(60, partyBoxY, 1120, 120);
          ctx.fillStyle = "#000";
          drawText(
            isFieldPrintDocument
              ? "계약 적용일: 20____년 ____월 ____일 / 입금 예정일: ____일"
              : `계약 적용일: ${year}년 ${month}월 ${day}일 / ${paymentConditionText}`,
            80,
            partyBoxY + 34,
            "bold 18px sans-serif"
          );
          drawText(
            isFieldPrintDocument
              ? "공급받는자: ____________________ / 대표자: __________"
              : `공급받는자: ${outputBusinessName || "미입력"} / 대표자: ${
                  dataToUse.agentRep || dataToUse.corpRepName || "미입력"
                }`,
            80,
            partyBoxY + 66,
            "17px sans-serif"
          );
          drawWrappedText(
            isFieldPrintDocument
              ? "사업자번호: ____________________ / 주소: ________________________________"
              : `사업자번호: ${dataToUse.agentBizNo || "미입력"} / 주소: ${
                  dataToUse.agentAddress || "미입력"
                } ${dataToUse.agentAddressDetail || ""}`,
            80,
            partyBoxY + 98,
            1040,
            22,
            "16px sans-serif"
          );
          y = partyBoxY + 150;
          drawText("계약 주요 조항", 70, y, "bold 24px sans-serif");
          ctx.strokeStyle = "#d1d5db";
          ctx.lineWidth = 1;
          ctx.beginPath();
          ctx.moveTo(70, y + 20);
          ctx.lineTo(cvs.width - 70, y + 20);
          ctx.stroke();
          const firstClauseStartY = y + 52;

          const clauseRenderPages = buildContractClauseRenderPages({
            ctx,
            clauses: pdfClauseSource.clauses,
            firstContentStartY: firstClauseStartY,
          });
          for (let pageIndex = 0; pageIndex < clauseRenderPages.length; pageIndex += 1) {
            const clausePage = clauseRenderPages[pageIndex];
            if (pageIndex > 0) {
              await drawContractHeader("계약 주요 조항 계속");
            }
            let clauseY = clausePage.startY;
            clausePage.items.forEach((item) => {
              if (item.kind !== "gap") {
                drawText(
                  item.text,
                  CONTRACT_CLAUSE_PDF_PAGE_LAYOUT.contentX,
                  clauseY,
                  item.font
                );
              }
              clauseY += item.height;
            });
            const isLastClausePage = pageIndex === clauseRenderPages.length - 1;
            if (isLastClausePage) {
              const signatureStartY = clausePage.endY + 30;
              if (isFieldPrintDocument) {
                // A blank field print has a structured buyer/signature form; keep it on
                // its own A4 page instead of sharing a variable-height terms page.
                pushContractPage();
                await drawContractHeader("계약 확인 및 서명");
                await drawSignatureSection(CONTRACT_SIGNATURE_PDF_LAYOUT.contentStartY);
                pushContractPage();
              } else if (
                signatureStartY + CONTRACT_SIGNATURE_PDF_LAYOUT.minimumHeight <=
                CONTRACT_CLAUSE_PDF_PAGE_LAYOUT.bottomY
              ) {
                drawText("계약 확인 및 서명", 70, signatureStartY, "bold 24px sans-serif");
                ctx.strokeStyle = "#d1d5db";
                ctx.lineWidth = 1;
                ctx.beginPath();
                ctx.moveTo(70, signatureStartY + 20);
                ctx.lineTo(cvs.width - 70, signatureStartY + 20);
                ctx.stroke();
                await drawSignatureSection(signatureStartY + 50);
                pushContractPage();
              } else {
                pushContractPage();
                await drawContractHeader("계약 확인 및 서명");
                await drawSignatureSection(CONTRACT_SIGNATURE_PDF_LAYOUT.contentStartY);
                pushContractPage();
              }
            } else {
              pushContractPage();
            }
          }
          resolve(pages);
        } catch (e) {
          console.error("[CNFOOD] contract image generation failed", sanitizeErrorForLog(e));
          resolve([]);
        }
      })();
    });
  };

  const prepareFieldPrintContractPages = async (): Promise<string[]> => {
    if (fieldPrintPreparing) return [];
    const supplierMode = resolveFieldPrintSupplierMode({
      selectedBranchId: fieldPrintCompanyBranchId,
      branch: fieldPrintCompanyBranch,
    });
    const fieldPrintModel = buildPrintableFieldContractModel({
      outputType: fieldPrintContractType,
      clauses: fieldPrintClauses,
      branch: supplierMode === "EXPLICIT_BRANCH" ? fieldPrintCompanyBranch : null,
      supplierMode,
    });

    setFieldPrintPreparing(true);
    try {
      const pages = await generateContractImagePages(
        "",
        "FIELD_PRINT",
        "FIELD_PRINT",
        {
          fieldPrintModel,
          contractClausesSnapshot: fieldPrintModel.clauses,
        }
      );
      if (!Array.isArray(pages) || pages.length === 0) {
        setToastMessage("빈 계약서 출력용 문서를 생성하지 못했습니다. 다시 시도해 주세요.");
        return [];
      }
      setFieldPrintPages(pages);
      setFieldPrintPreviewOpen(true);
      return pages;
    } catch (error) {
      console.error("[CNFOOD] field-print contract generation failed", sanitizeErrorForLog(error));
      setToastMessage("빈 계약서 출력용 문서를 생성하지 못했습니다. 다시 시도해 주세요.");
      return [];
    } finally {
      setFieldPrintPreparing(false);
    }
  };

  const previewFieldContract = async () => {
    await prepareFieldPrintContractPages();
  };

  const generateContractImage = async (
    signUrl,
    cId,
    type = "CUSTOMER",
    dataOverride = null,
    signUrl2 = null
  ) => {
    const pages = await generateContractImagePages(
      signUrl,
      cId,
      type,
      dataOverride,
      signUrl2
    );
    return pages[0] || null;
  };

  const generateAuditTrailPages = async (contractData) => {
    const cvs = auditCanvasRef.current;
    if (!cvs) return [];
    const ctx = cvs.getContext("2d");
    const width = 1240;
    const height = 1754;
    cvs.width = width;
    cvs.height = height;

    const logs = contractData.auditTrail || [];
    const pages = [];

    if (logs.length === 0) return [];

    const drawWrappedText = (
      text,
      x,
      y,
      maxWidth,
      lineHeight,
      fontSize = "16px"
    ) => {
      ctx.font = `${fontSize} sans-serif`;
      let line = "";
      let testY = y;

      for (let n = 0; n < text.length; n++) {
        const testLine = line + text[n];
        const metrics = ctx.measureText(testLine);
        if (metrics.width > maxWidth && n > 0) {
          ctx.fillText(line, x, testY);
          line = text[n];
          testY += lineHeight;
        } else {
          line = testLine;
        }
      }
      ctx.fillText(line, x, testY);
      return testY + lineHeight;
    };

    const drawHeader = () => {
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, width, height);

      ctx.fillStyle = "#333";
      ctx.fillRect(0, 0, 1240, 150);
      ctx.fillStyle = "#fff";
      ctx.font = "bold 40px sans-serif";
      ctx.textAlign = "center";
      ctx.fillText("감사 추적 인증서 (Audit Trail)", 620, 90);

      ctx.fillStyle = "#000";
      ctx.textAlign = "left";
      let headerY = 250;
      ctx.font = "bold 20px sans-serif";
      ctx.fillStyle = "#555";
      ctx.fillText("문서 번호", 100, headerY);
      ctx.font = "20px sans-serif";
      ctx.fillStyle = "#000";
      ctx.fillText(contractData.contractId, 300, headerY);

      ctx.font = "bold 20px sans-serif";
      ctx.fillStyle = "#555";
      ctx.fillText("상호명", 700, headerY);
      ctx.font = "20px sans-serif";
      ctx.fillStyle = "#000";
      ctx.fillText(contractData.agentName, 900, headerY);

      headerY += 50;
      ctx.fillStyle = "#eee";
      ctx.fillRect(100, headerY, 1040, 60);
      ctx.fillStyle = "#000";
      ctx.font = "bold 20px sans-serif";
      ctx.fillText("일시", 120, headerY + 38);
      ctx.fillText("활동 (Action)", 400, headerY + 38);
      ctx.fillText("IP / 기기 정보", 800, headerY + 38);

      return headerY + 80;
    };

    let currentY = drawHeader();
    const pageLimitY = 1600;

    for (let i = 0; i < logs.length; i++) {
      const log = logs[i];

      if (currentY > pageLimitY - 150) {
        ctx.fillStyle = "#333";
        ctx.textAlign = "center";
        ctx.font = "16px sans-serif";
        ctx.fillText("- 이어짐 -", 620, 1650);
        pages.push(cvs.toDataURL("image/jpeg", 0.7));
        currentY = drawHeader();
      }

      ctx.fillStyle = "#000";
      ctx.textAlign = "left";

      ctx.font = "18px sans-serif";
      ctx.fillText(
        new Date(log.timestamp).toLocaleString("ko-KR"),
        120,
        currentY
      );

      ctx.font = "bold 18px sans-serif";
      ctx.fillText(log.action, 400, currentY);

      ctx.font = "16px sans-serif";
      ctx.fillText(`IP: ${log.ip}`, 800, currentY);

      let contentY = currentY + 25;
      if (log.device) {
        ctx.fillStyle = "#666";
        contentY = drawWrappedText(log.device, 800, contentY, 340, 20, "14px");
      }

      if (log.note) {
        ctx.fillStyle = "#888";
        const noteY = drawWrappedText(
          `- ${log.note}`,
          400,
          currentY + 25,
          350,
          20,
          "italic 14px"
        );
        contentY = Math.max(contentY, noteY);
      } else {
        contentY = Math.max(contentY, currentY + 40);
      }

      const nextY = contentY + 15;
      ctx.strokeStyle = "#eee";
      ctx.lineWidth = 1;
      ctx.beginPath();
      ctx.moveTo(100, nextY);
      ctx.lineTo(1140, nextY);
      ctx.stroke();

      currentY = nextY + 20;
    }

    ctx.fillStyle = "#333";
    ctx.textAlign = "center";
    ctx.font = "16px sans-serif";
    ctx.fillText(
      "본 문서는 CN FOOD 전자계약 시스템을 통해 생성되었으며, 위변조 방지 기술이 적용되어 있습니다.",
      620,
      1650
    );
    pages.push(cvs.toDataURL("image/jpeg", 0.7));

    return pages;
  };

  const generateEvidencePages = async (contractData) => {
    const cvs = auditCanvasRef.current;
    if (!cvs) return [];

    const ctx = cvs.getContext("2d");
    const width = 1240;
    const height = 1754;
    const pages = [];
    const bottomMargin = 190;
    const usableBottom = height - bottomMargin;
    const valueMaxWidth = 730;
    const valueLineHeight = 22;
    const maxLinesPerRowChunk = 42;
    let currentY = 350;

    const drawEvidenceFooter = () => {
      ctx.fillStyle = "#6b7280";
      ctx.textAlign = "center";
      ctx.font = "15px sans-serif";
      ctx.fillText(
        "값이 없는 항목은 미수집 또는 해당 없음으로 표시됩니다.",
        620,
        1620
      );
      ctx.fillText("CN FOOD 전자계약 시스템", 620, 1660);
    };

    const startEvidencePage = ({ continuation = false } = {}) => {
      cvs.width = width;
      cvs.height = height;

      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, width, height);

      ctx.fillStyle = "#1f2937";
      ctx.fillRect(0, 0, width, 150);
      if (isIdentityTestModeContract(contractData)) {
        ctx.fillStyle = "#b91c1c";
        ctx.fillRect(0, 150, width, 42);
        ctx.fillStyle = "#fff";
        ctx.textAlign = "center";
        ctx.font = "bold 20px sans-serif";
        ctx.fillText(TEST_MODE_PDF_NOTICE, 620, 178);
      }
      ctx.fillStyle = "#fff";
      ctx.textAlign = "center";
      ctx.font = "bold 42px sans-serif";
      ctx.fillText(
        continuation ? "전자계약 증적 정보 (계속)" : "전자계약 증적 정보",
        620,
        92
      );

      ctx.textAlign = "left";
      ctx.fillStyle = "#111827";
      ctx.font = "bold 22px sans-serif";
      ctx.fillText("서명사실 확인", 100, 235);
      ctx.fillStyle = "#4b5563";
      ctx.font = "16px sans-serif";
      if (continuation) {
        drawWrappedCanvasText(
          ctx,
          "이전 페이지에서 이어지는 전자계약 증적 정보입니다.",
          100,
          270,
          1040,
          26,
          "16px sans-serif"
        );
      } else {
        drawWrappedCanvasText(
          ctx,
          "본 페이지는 전자계약 진행 과정에서 수집된 확인·열람·서명·제출 정보를 표시합니다.",
          100,
          270,
          1040,
          26,
          "16px sans-serif"
        );
      }
      currentY = continuation ? 330 : 350;
    };

    const finishEvidencePage = () => {
      drawEvidenceFooter();
      pages.push(cvs.toDataURL("image/jpeg", 0.7));
    };

    const ensurePdfSpace = (neededHeight) => {
      if (currentY - 30 + neededHeight > usableBottom) {
        finishEvidencePage();
        startEvidencePage({ continuation: true });
      }
    };

    const drawEvidenceRow = (row, valueLines, chunkIndex = 0) => {
      const rowHeight = Math.max(58, valueLines.length * valueLineHeight + 38);
      ensurePdfSpace(rowHeight);
      const safeRowTop = currentY - 30;

      ctx.fillStyle = "#f8fafc";
      ctx.fillRect(100, safeRowTop, 1040, rowHeight);
      ctx.strokeStyle = "#e5e7eb";
      ctx.lineWidth = 1;
      ctx.strokeRect(100, safeRowTop, 1040, rowHeight);

      ctx.fillStyle = "#6b7280";
      ctx.font = "bold 17px sans-serif";
      ctx.fillText(chunkIndex > 0 ? `${row.label} (계속)` : row.label, 130, currentY);

      ctx.fillStyle = "#111827";
      const valueEndY = drawCanvasTextLines(
        ctx,
        valueLines,
        380,
        currentY,
        valueLineHeight,
        "17px sans-serif"
      );

      currentY = Math.max(safeRowTop + rowHeight + 20, valueEndY + 28);
    };

    startEvidencePage();

    getContractEvidenceRows(contractData).forEach((row) => {
      const valueLines = wrapCanvasTextLines({
        ctx,
        text: row.value,
        maxWidth: valueMaxWidth,
        font: "17px sans-serif",
      });
      for (
        let startIndex = 0, chunkIndex = 0;
        startIndex < valueLines.length;
        startIndex += maxLinesPerRowChunk, chunkIndex += 1
      ) {
        drawEvidenceRow(
          row,
          valueLines.slice(startIndex, startIndex + maxLinesPerRowChunk),
          chunkIndex
        );
      }
    });

    finishEvidencePage();
    return pages;
  };

  const handleDownloadPDF = async (
    targetContract = null,
    type = "CUSTOMER"
  ) => {
    let contractToUse = targetContract
      ? { ...targetContract }
      : lastSubmittedContractData
      ? { ...lastSubmittedContractData }
      : { ...formData };

    if (!targetContract && !lastSubmittedContractData) {
      contractToUse.auditTrail = auditLogsRef.current;
      contractToUse.bizType = bizType;

      if (!contractToUse.signature && canvasRef.current) {
        contractToUse.signature = canvasRef.current.toDataURL("image/png");
      }
      if (
        isCorporateContract(bizType) &&
        !contractToUse.signature2 &&
        canvasRef2.current
      ) {
        contractToUse.signature2 = canvasRef2.current.toDataURL("image/png");
      }
    }

    setLoading(true);
    try {
      if (!window.jspdf) {
        setToastMessage("PDF 모듈을 불러오는 중입니다. 잠시 후 다시 시도해주세요.");
        openErrorHelpModal(ERROR_HELP_GUIDES.PDF_DOWNLOAD_FAILED, {
          message: "PDF 모듈을 불러오는 중입니다. 잠시 후 다시 시도해 주세요.",
          errorCode: "PDF_MODULE_LOADING",
        });
        return;
      }
      const { jsPDF } = window.jspdf;
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = 210;
      const pdfHeight = 297;

      const contractPages = await generateContractImagePages(
        contractToUse.signature,
        contractToUse.contractId || "TEMP_ID",
        type,
        contractToUse,
        contractToUse.signature2
      );
      if (contractPages.length > 0) {
        contractPages.forEach((contractPage, index) => {
          if (index > 0) pdf.addPage();
          pdf.addImage(contractPage, "JPEG", 0, 0, pdfWidth, pdfHeight);
        });
      } else {
        setToastMessage("계약서 이미지를 생성하지 못했습니다.");
        openErrorHelpModal(ERROR_HELP_GUIDES.PDF_DOWNLOAD_FAILED, {
          message: "계약서 이미지를 생성하지 못했습니다.",
          errorCode: "PDF_CONTRACT_IMAGE_FAILED",
        });
        return;
      }

      const auditPages = await generateAuditTrailPages(contractToUse);
      auditPages.forEach((pageImg) => {
        pdf.addPage();
        pdf.addImage(pageImg, "JPEG", 0, 0, pdfWidth, pdfHeight);
      });

      const evidencePages = await generateEvidencePages(contractToUse);
      evidencePages.forEach((evidencePage) => {
        pdf.addPage();
        pdf.addImage(evidencePage, "JPEG", 0, 0, pdfWidth, pdfHeight);
      });

      const fileName = `${contractToUse.agentName || "계약서"}_${type}.pdf`;
      const pdfArrayBuffer = pdf.output("arraybuffer");
      const pdfHash = await createSha256HashFromArrayBuffer(pdfArrayBuffer);
      const pdfGeneratedAt = new Date().toISOString();
      const contractDocumentId =
        contractToUse.documentId || contractToUse.id || editModeId || null;
      if (
        contractDocumentId &&
        !shouldPreserveExistingCorporatePdfEvidence(
          { ...contractToUse, bizType: contractToUse.bizType || bizType },
          true
        )
      ) {
        await setDoc(
          getContractDocumentRef(contractDocumentId),
          {
            pdfHash,
            pdfGeneratedAt,
            pdfType: type,
          },
          { merge: true }
        );
      }
      pdf.save(fileName);

      if (type === "HQ")
        logAdminAction(
          "PDF 다운로드",
          contractToUse.contractId,
          currentManager.name
        );
    } catch (e) {
      console.error("[PDF 로그] 에러 발생:", sanitizeErrorForLog(e));
      setToastMessage("PDF 생성 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.");
      openErrorHelpModal(ERROR_HELP_GUIDES.PDF_DOWNLOAD_FAILED, {
        errorCode: "PDF_GENERATION_FAILED",
      });
    } finally {
      setLoading(false);
    }
  };

  /* ================= 화면 렌더링 ================= */
  const otpPhoneNumber = getOtpPhoneNumberFromForm(formData);
  const isCorporateBiz = isCorporateContract(bizType);
  const identityTestModeAllowed =
    canShowIdentityTestModeForDevice({
      adminAuthorized: adminTestModeAuthorized,
      deviceTokenAuthorized: identityTestDeviceAuthorized,
    });
  const representativeIdentitySimulationActive = isIdentityTestSimulation(
    representativeIdentityVerification
  );
  const representativeKcpWorkflowStatus = getRepresentativeKcpWorkflowStatus(
    representativeIdentityVerification
  );
  const verificationMode = resolveVerificationMode({
    phoneVerificationEnabled: validationSettings.enablePhoneVerification,
    kcpAvailable,
    kcpFallbackReason,
    kcpSessionStatus: kcpIdentityStatus,
    smsFallbackSelected,
  });
  const identityProvider: IdentityProvider =
    verificationMode === "SMS_ONLY" ||
    verificationMode === "SMS_FALLBACK_SELECTED"
      ? "FIREBASE_SMS"
      : "KCP";
  const showKcpIdentityControls =
    validationSettings.enablePhoneVerification &&
    (verificationMode === "KCP_PRIMARY" || verificationMode === "KCP_FAILED");
  const showSmsIdentityControls =
    validationSettings.enablePhoneVerification &&
    (verificationMode === "SMS_ONLY" ||
      verificationMode === "SMS_FALLBACK_SELECTED");
  const showSmsFallbackChoice =
    validationSettings.enablePhoneVerification &&
    verificationMode === "KCP_FAILED";
  const coRepresentativeInfo = resolveCoRepresentativeInfo({
    userDeclared: coRepresentativeDeclared,
    ntsInfo: coRepresentativeNtsInfo,
    now: coRepresentativeNtsInfo?.detectedAt || "",
  });
  const showCoRepresentativeGuidance =
    shouldShowCoRepresentativeGuidance(coRepresentativeInfo);
  const completedContractForCoRepresentativeSms =
    lastSubmittedContractData || {
      ...formData,
      coRepresentativeInfo,
      coRepresentativeDeclared,
    };
  const showCoRepresentativeSmsRequest =
    step === 5 &&
    shouldShowCoRepresentativeSmsRequest(completedContractForCoRepresentativeSms);
  const coRepresentativeRequestLink = buildCoRepresentativeRequestLink({
    activeInvite:
      completedContractForCoRepresentativeSms?.activeInvite || activeInvite,
    inviteToken:
      activeInvite?.token ||
      completedContractForCoRepresentativeSms?.inviteToken ||
      "",
    origin:
      typeof window !== "undefined"
        ? `${window.location.origin}${window.location.pathname}`
        : "",
    currentHref:
      typeof window !== "undefined" ? window.location.href : "",
  });
  const representativeIdentityRequestLink = getRepresentativeIdentityRequestLink();
  const updateCoRepresentativeDraft = (id = "", patch = {}) => {
    setCoRepresentatives((prev) =>
      prev.map((item) => {
        if (item.id !== id) return item;
        const touchesLockedField = Object.keys(patch || {}).some((key) =>
          CO_REPRESENTATIVE_LOCKED_FIELD_NAMES.has(key)
        );
        if (touchesLockedField && isCoRepresentativeIdentityMatched(item)) {
          setToastMessage("공동계약인 본인확인 완료로 수정할 수 없습니다. 수정하려면 공동계약인 본인확인을 다시 진행해 주세요.");
          return item;
        }
        const shouldResetIdentity =
          touchesLockedField &&
          (item.identityVerification || item.kcpStatus === "MATCHED");
        return {
          ...item,
          ...patch,
          ...(shouldResetIdentity
            ? {
                kcpSessionId: "",
                kcpStatus: "PENDING",
                identityStatus: "PENDING",
                identityVerification: null,
                delegatedSignatureConsent: {
                  ...item.delegatedSignatureConsent,
                  agreed: false,
                  agreedAt: null,
                  principalSignerName: "",
                },
                signatureEvidence: null,
                signatureHash: "",
                signatureImageDataUrl: "",
                signatureStatus: "PENDING",
                signedAt: null,
              }
            : {}),
        };
      })
    );
  };
  const updateCoRepresentativeSignatureMode = (id = "", mode = "") => {
    const nextMode =
      mode === CO_REPRESENTATIVE_SIGNATURE_MODE_DELEGATED
        ? CO_REPRESENTATIVE_SIGNATURE_MODE_DELEGATED
        : CO_REPRESENTATIVE_SIGNATURE_MODE_DIRECT;
    if (nextMode === CO_REPRESENTATIVE_SIGNATURE_MODE_DELEGATED) {
      clearCoRepresentativeSignature(id);
    }
    setCoRepresentatives((prev) =>
      prev.map((item) => {
        if (item.id !== id) return item;
        const delegatedConsent = {
          ...item.delegatedSignatureConsent,
          agreed:
            nextMode === CO_REPRESENTATIVE_SIGNATURE_MODE_DELEGATED
              ? item.delegatedSignatureConsent?.agreed === true
              : false,
          agreedAt:
            nextMode === CO_REPRESENTATIVE_SIGNATURE_MODE_DELEGATED
              ? item.delegatedSignatureConsent?.agreedAt || null
              : null,
          principalSignerName:
            nextMode === CO_REPRESENTATIVE_SIGNATURE_MODE_DELEGATED
              ? item.delegatedSignatureConsent?.principalSignerName || ""
              : "",
        };
        const directEvidence =
          nextMode === CO_REPRESENTATIVE_SIGNATURE_MODE_DIRECT
            ? sanitizeCoRepresentativeDirectSignatureEvidence(item)
            : null;
        return {
          ...item,
          signatureMode: nextMode,
          delegatedSignatureConsent: delegatedConsent,
          ...(nextMode === CO_REPRESENTATIVE_SIGNATURE_MODE_DIRECT
            ? {
                signatureEvidence: directEvidence,
                signatureHash: directEvidence?.signatureHash || item.signatureHash || "",
                signatureStatus: directEvidence?.valid ? "SIGNED_DIRECTLY" : "PENDING",
                signedAt: directEvidence?.signedAt || item.signedAt || null,
              }
            : {
                signatureEvidence: null,
                signatureHash: "",
                signatureImageDataUrl: "",
                signatureStatus: delegatedConsent.agreed
                  ? "DELEGATED_BY_PRINCIPAL"
                  : "PENDING",
                signedAt: delegatedConsent.agreedAt || null,
              }),
        };
      })
    );
  };
  const openCoRepresentativeAddressSearch = ({
    coRepresentativeId = "",
  }: {
    coRepresentativeId?: string;
  } = {}) => {
    const target = coRepresentatives.find((item) => item.id === coRepresentativeId);
    if (!target) return;
    if (isCoRepresentativeIdentityMatched(target)) {
      setToastMessage(
        "공동계약인 본인확인 완료로 주소를 수정할 수 없습니다. 수정하려면 공동계약인 본인확인을 다시 진행해 주세요."
      );
      return;
    }
    setAddressTarget("coRep");
    setCoRepAddressTargetId(coRepresentativeId);
    setActiveCoRepHelpKey(`${coRepresentativeId}:homeAddress`);
    setShowAddressModal(true);
  };
  const addCoRepresentativeDraft = () => {
    setCoRepresentatives((prev) => [
      ...getPrimaryCoRepresentativeDisplayRows({
        declared: true,
        representatives: prev,
      }),
      createCoRepresentativeDraft(),
    ]);
  };
  const handleCoRepresentativeDeclaredChange = (checked: boolean) => {
    setCoRepresentativeDeclared(checked);
    if (!checked) return;
    setCoRepresentatives((prev) =>
      prev.length > 0
        ? prev
        : normalizePrimaryCoRepresentativeUiRows({
            declared: true,
            representatives: prev,
          })
    );
  };
  const removeCoRepresentativeDraft = (id = "") => {
    const target = coRepresentatives.find((item) => item.id === id);
    if (!target) return;
    if (isCoRepresentativeIdentityMatched(target)) {
      setToastMessage("본인확인 완료된 공동계약인은 인증 초기화 후 삭제할 수 있습니다.");
      return;
    }
    setCoRepresentatives((prev) => {
      const next = prev.filter((item) => item.id !== id);
      return next.length > 0 ? next : [createCoRepresentativeDraft()];
    });
  };
  const handleOpenCoRepresentativeSmsDraft = () => {
    const digits = normalizePhoneDigits(coRepresentativeSmsPhone);
    if (!isValidPhoneNumberFormat(digits)) {
      const message = "공동계약인 휴대폰 번호를 올바르게 입력해 주세요.";
      setCoRepresentativeSmsError(message);
      setToastMessage(message);
      return;
    }
    if (!coRepresentativeRequestLink) {
      const message =
        "계약 요청 링크를 만들 수 없습니다. 관리자에게 초대 링크 생성을 요청해 주세요.";
      setCoRepresentativeSmsError(message);
      setToastMessage(message);
      return;
    }
    const smsMessage = buildCoRepresentativeSmsMessage({
      businessName:
        completedContractForCoRepresentativeSms?.agentName ||
        completedContractForCoRepresentativeSms?.companyName ||
        formData.agentName,
      representativeName:
        completedContractForCoRepresentativeSms?.coRepresentativeName ||
        completedContractForCoRepresentativeSms?.agentRep ||
        formData.agentRep ||
        "공동계약인",
      requestLink: coRepresentativeRequestLink,
    });
    const href = buildSmsHref(digits, smsMessage);
    setCoRepresentativeSmsError("");
    setToastMessage("문자 앱이 열리면 내용을 확인한 뒤 직접 발송해 주세요.");
    window.location.href = href;
  };
  const identityCopy = getIdentityProviderCopy(identityProvider);
  const identityLoading = identityProvider === "KCP" ? kcpLoading : otpLoading;
  const representativeIdentityMatched = isRepresentativeIdentityMatched(
    representativeIdentityVerification
  );
  const identityFieldsLocked =
    representativeIdentityMatched ||
    (identityTestModeAllowed && representativeIdentitySimulationActive);
  const principalKcpVerifiedWithoutMismatch =
    isPrincipalKcpVerifiedWithoutMismatch({
      kcpIdentityStatus,
      representativeIdentityVerification,
      kcpIdentityEvidence,
    });
  const effectiveStep1PhoneVerified =
    phoneVerified || principalKcpVerifiedWithoutMismatch;
  const phoneVerificationSatisfied =
    canProceedPhoneVerificationStep(
      validationSettings,
      otpPhoneNumber,
      effectiveStep1PhoneVerified
    ) &&
    (identityProvider !== "KCP" ||
      representativeIdentityMatched ||
      principalKcpVerifiedWithoutMismatch ||
      (identityTestModeAllowed && representativeIdentitySimulationActive));
  const identityActionGate = canProceedCurrentContract(contractAppStatus, step, {
    action: "KCP",
    isAdmin:
      (adminAccessMode === "ADMIN" && Boolean(currentManager?.name)) ||
      adminContractStartBypassActive,
    statusLoaded: contractAppStatusLoaded,
    bypassPause: adminContractStartBypassActive,
  });
  const finalSubmitActionGate = canProceedCurrentContract(contractAppStatus, step, {
    action: "SUBMIT",
    isAdmin:
      (adminAccessMode === "ADMIN" && Boolean(currentManager?.name)) ||
      adminContractStartBypassActive,
    statusLoaded: contractAppStatusLoaded,
    bypassPause: adminContractStartBypassActive,
  });
  const step1CanProceed = canProceedStep1ToContractReview({
    settings: validationSettings,
    phone: otpPhoneNumber,
    phoneVerified: effectiveStep1PhoneVerified,
    bizType,
    ssnFront: formData.ssnFront,
    ssnBack: formData.ssnBack,
    principalRepSsnFront: formData.principalRepSsnFront,
    principalRepSsnBack: formData.principalRepSsnBack,
    guarantorSsnFront: formData.guarantorSsnFront,
    guarantorSsnBack: formData.guarantorSsnBack,
    agreements,
  });
  const step1BlockedIssue = validateStep1RequiredFields({
    settings: validationSettings,
    phone: otpPhoneNumber,
    phoneVerified: effectiveStep1PhoneVerified,
    bizType,
    ssnFront: formData.ssnFront,
    ssnBack: formData.ssnBack,
    principalRepSsnFront: formData.principalRepSsnFront,
    principalRepSsnBack: formData.principalRepSsnBack,
    guarantorSsnFront: formData.guarantorSsnFront,
    guarantorSsnBack: formData.guarantorSsnBack,
    agreements,
    restoredSsnDraft,
  })[0];
  const step1BlockedReason =
    kcpReturnSyncState === KCP_RETURN_SYNC_STATES.CHECKING_STATUS
      ? KCP_RETURN_SYNC_CHECKING_MESSAGE
      : step1BlockedIssue?.fieldId === "agentContact" &&
        validationSettings.enablePhoneVerification &&
        isValidPhoneNumberFormat(otpPhoneNumber || "") &&
        !effectiveStep1PhoneVerified
      ? "본인인증을 완료해 주세요."
      : step1BlockedIssue?.message || "";
  const step0Ready =
    validateStep0RequiredFields({
      formData,
      bizType,
      isSameDayDeposit,
      manualAddressMode,
      validationSettings,
    }).length === 0 && !loading;
  const step2Ready = contractScrolled && contractAgreed && !transitioning;
  const finalSubmitLockedByReceipt =
    Boolean(savedContractDocumentId) ||
    completionReceipt?.confirmed === true ||
    ["SAVING", "CONFIRMING_RECEIPT", "CONFIRMED"].includes(submitState);
  const finalSubmitReady =
    isSigned &&
    (!isCorporateContract(bizType) || Boolean(signature2)) &&
    (!isCorporateContract(bizType) || representativePersonalGuaranteeAgreed) &&
    hasContractAuthority &&
    !loading &&
    !imageGenerating &&
    !isSubmittingFinal &&
    !finalSubmitLockedByReceipt &&
    finalSubmitActionGate.allowed;
  const step1NextAction = getNextActionState({
    enabled:
      step1CanProceed &&
      kcpReturnSyncState !== KCP_RETURN_SYNC_STATES.CHECKING_STATUS,
    reason: step1BlockedReason,
  });
  const shouldShowStep1KcpCheckingCard =
    validationSettings.enablePhoneVerification &&
    identityProvider === "KCP" &&
    (kcpReturnSyncState === KCP_RETURN_SYNC_STATES.CHECKING_STATUS ||
      kcpLaunchUiState === KCP_LAUNCH_UI_STATES.RETURN_CHECKING);
  const shouldShowStep1ReauthenticationWarning =
    validationSettings.enablePhoneVerification &&
    identityProvider === "KCP" &&
    shouldShowKcpReauthenticationWarning({
      phoneVerificationSatisfied,
      checking: shouldShowStep1KcpCheckingCard,
      kcpIdentityStatus,
      representativeIdentityVerification,
      kcpIdentityEvidence,
    });
  const shouldShowKcpReturnCheckingStep0Shield =
    viewMode === "FORM" &&
    !showIntroPage &&
    step === 0 &&
    kcpReturnNavigationIntentActive &&
    kcpReturnSyncState === KCP_RETURN_SYNC_STATES.CHECKING_STATUS;
  const step2NextAction = getNextActionState({
    enabled: step2Ready,
    reason: !contractScrolled
      ? "CONTRACT_SCROLL_REQUIRED"
      : !contractAgreed
      ? "CONTRACT_AGREEMENT_REQUIRED"
      : "",
  });
  const finalSubmitAction = getNextActionState({
    enabled: finalSubmitReady,
    reason: finalSubmitLockedByReceipt
      ? "COMPLETION_RECEIPT_LOCKED"
      : !finalSubmitActionGate.allowed
      ? "SUBMIT_BLOCKED_BY_APP_STATUS"
      : "",
  });
  const step0ReadyPulse = useButtonActivationPulse(step === 0 && step0Ready);
  const step1ReadyPulse = useButtonActivationPulse(
    step === 1 && step1NextAction.enabled
  );
  const step2ReadyPulse = useButtonActivationPulse(
    step === 2 && step2NextAction.enabled
  );
  const finalSubmitReadyPulse = useButtonActivationPulse(
    step === 3 && finalSubmitAction.enabled
  );
  const renderIdentityTestModePanel = (scope = "customer") => {
    if (!identityTestModeAllowed) return null;
    return (
      <div className="rounded-2xl border-2 border-red-200 bg-red-50 px-4 py-4 text-red-950 shadow-sm">
        <div className="flex flex-wrap items-center gap-2">
          <span className="rounded-full bg-red-700 px-3 py-1 text-xs font-black uppercase tracking-[0.16em] text-white">
            TEST MODE
          </span>
          <span className="text-sm font-black">
            {IDENTITY_TEST_MODE_NOTICE}
          </span>
        </div>
        <p className="mt-2 text-sm font-bold leading-6 break-keep">
          TEST_SIMULATION은 실제 KCP/PASS 인증, CI/DI 증빙, 운영 VERIFIED로 저장되지 않습니다.
          실제 제출은 대표자 본인 명의 휴대폰 KCP 인증 전까지 차단됩니다.
        </p>
        <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-3">
          <button
            type="button"
            onClick={applyRepresentativeIdentityTestSimulation}
            className="min-h-[48px] rounded-2xl bg-red-700 px-3 py-2 text-sm font-black text-white active:scale-95"
          >
            테스트 인증 시뮬레이션
          </button>
          <button
            type="button"
            onClick={() => {
              setToastMessage("테스트 계약으로 미리보기합니다. 실제 저장은 수행하지 않습니다.");
              goToStep(2);
            }}
            className="min-h-[48px] rounded-2xl border border-red-200 bg-white px-3 py-2 text-sm font-black text-red-700 active:scale-95"
          >
            테스트 계약으로 미리보기
          </button>
          <button
            type="button"
            onClick={handleGenerateIdentityTestPdf}
            className="min-h-[48px] rounded-2xl border border-red-200 bg-white px-3 py-2 text-sm font-black text-red-700 active:scale-95"
          >
            테스트 PDF 생성
          </button>
        </div>
        <div className="mt-2 grid grid-cols-1 gap-2 sm:grid-cols-3">
          <button
            type="button"
            onClick={handleCopyRepresentativeIdentityRequestLink}
            className="min-h-[48px] rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-black text-slate-700 active:scale-95"
          >
            대표자 인증 요청 링크 복사
          </button>
          <button
            type="button"
            onClick={handleOpenRepresentativeIdentitySmsDraft}
            className="min-h-[48px] rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-black text-slate-700 active:scale-95"
          >
            대표자 인증 요청 문자 작성
          </button>
          <button
            type="button"
            onClick={handleRefreshRepresentativeIdentityStatus}
            className="min-h-[48px] rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-black text-slate-700 active:scale-95"
          >
            인증 상태 새로고침
          </button>
        </div>
        <div className="mt-3 rounded-2xl bg-white/80 px-3 py-3 text-xs font-bold leading-5 text-red-900">
          <p>인증 대기 상태: {representativeKcpWorkflowStatus}</p>
          <p>요청 링크: {representativeIdentityRequestLink || "초대 링크 확인 필요"}</p>
          {scope === "admin" && (
            <p>관리자 화면에서는 대표자에게 링크/문자 초안을 전달하고 상태를 새로고침할 수 있습니다.</p>
          )}
        </div>
      </div>
    );
  };
  const primarySignatureDescriptor = getPrimarySignatureRoleDescriptor({
    bizType,
    coRepresentativesRequired: coRepresentativeDeclared,
  });
  const primarySignatureSignerName =
    normalizeRepresentativeNameForMatch(formData.corpRepName || formData.agentRep || "") ||
    "대표자";
  const representativePersonalGuaranteeRequired =
    isCorporateContract(bizType);
  const previewContractDate = `${selYear}-${String(selMonth).padStart(2, "0")}-${String(
    selDay
  ).padStart(2, "0")}`;
  const contractTemplateSnapshotFields = buildContractTemplateSnapshotFields(
    buildNewContractTemplate({}),
    {
      ...formData,
      bizType,
      contractDate: previewContractDate,
    }
  );
  const fieldPrintCompanyBranch = resolveCompanyBranchSelection({
    companyBranches,
    companyBranchId: fieldPrintCompanyBranchId,
    allowDefault: true,
  }).branch;
  // Step 2 and the field-print document receive this same resolved clause array.
  const fieldPrintClauses = contractTemplateSnapshotFields.contractClausesSnapshot;
  const kcpLaunchUiOverlayVisible =
    identityProvider === "KCP" &&
    !isCorepInviteRoute &&
    shouldShowKcpLaunchOverlay(kcpLaunchUiState, { kcpReturnSyncState });
  const renderKcpLaunchUiOverlay = () => {
    if (!kcpLaunchUiOverlayVisible) return null;
    const isReturnChecking =
      kcpLaunchUiState === KCP_LAUNCH_UI_STATES.RETURN_CHECKING;
    const isLaunchRecoveryState = shouldShowKcpLaunchRecoveryState(
      kcpLaunchUiState,
      kcpLaunchFallbackVisible
    );
    const handleRetryKcpLaunch = () => {
      closeKcpPopupWindow();
      clearActiveKcpReturnNavigationIntent();
      clearKcpVerifiedNavigationRetry();
      clearKcpLaunchTimeout();
      clearKcpLaunchFallbackTimer();
      setKcpLaunchFallbackVisible(false);
      setKcpLoading(false);
      setPrincipalKcpLaunchUiState(KCP_LAUNCH_UI_STATES.IDLE, {
        source: "launch-retry",
      });
      void handleStartKcpIdentity();
    };
    return (
      <div
        className="fixed inset-0 z-[10000] flex items-center justify-center bg-slate-950/70 px-4 backdrop-blur-sm"
        role={isLaunchRecoveryState ? "alert" : "status"}
        aria-live="assertive"
      >
        <div className="w-full max-w-sm rounded-2xl border border-sky-100 bg-white px-6 py-7 text-center shadow-2xl">
          <div
            className={`mx-auto flex h-16 w-16 items-center justify-center rounded-full ${
              isLaunchRecoveryState
                ? "bg-red-50 text-red-600"
                : "bg-sky-50 text-sky-600"
            }`}
          >
            {isLaunchRecoveryState ? (
              <AlertTriangle className="h-9 w-9" />
            ) : (
              <Loader2 className="h-9 w-9 animate-spin" />
            )}
          </div>
          <h3 className="mt-5 text-2xl font-black leading-tight text-slate-950 break-keep">
            {isLaunchRecoveryState
              ? "본인인증 화면이 열리지 않았습니다"
              : isReturnChecking
              ? "본인인증 결과를 확인 중입니다"
              : "본인인증 화면으로 이동 중입니다"}
          </h3>
          <div className="mt-4 space-y-2 text-base font-bold leading-7 text-slate-700 break-keep">
            {isLaunchRecoveryState ? (
              <>
                <p>브라우저가 인증창을 차단했거나 네트워크가 지연되었습니다.</p>
                <p>아래 버튼을 눌러 본인인증을 다시 시도해 주세요.</p>
                <p className="font-black text-red-700">
                  반복되면 새 탭으로 다시 접속하거나 팝업 차단을 확인해 주세요.
                </p>
              </>
            ) : (
              <>
                <p>잠시만 기다려 주세요.</p>
                <p>본인인증 창이 열리면 인증을 완료해 주세요.</p>
                <p className="font-black text-red-700">
                  뒤로가기나 새로고침을 누르지 마세요.
                </p>
              </>
            )}
          </div>
          {isLaunchRecoveryState && (
            <div className="mt-5 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-4">
              <p className="text-base font-black leading-7 text-amber-900 break-keep">
                본인인증 화면이 열리지 않았습니다. 다시 시도해 주세요.
              </p>
              <button
                type="button"
                onClick={handleRetryKcpLaunch}
                className="mt-3 min-h-[52px] w-full rounded-2xl bg-slate-900 px-4 py-3 text-base font-black text-white active:scale-95"
              >
                본인인증 다시 시도
              </button>
            </div>
          )}
        </div>
      </div>
    );
  };
  const globalLoadingMessage = getGlobalLoadingMessage(
    loading,
    transitioning,
    loadingContext,
    kcpReturnSyncState
  );
  const renderGlobalLoadingOverlay = () => (
    <>
      {renderKcpLaunchUiOverlay()}
      {kcpLaunchUiOverlayVisible ? null : (
        <GlobalLoadingOverlay message={globalLoadingMessage} />
      )}
    </>
  );
  const renderUserErrorReportControls = () => {
    if (
      !isCustomerIssueReportVisible({
        viewMode,
        step,
        showIntroPage,
      })
    ) {
      return null;
    }
    return (
    <>
      <button
        type="button"
        onClick={handleOpenUserErrorReport}
        data-html2canvas-ignore="true"
        className="fixed bottom-4 right-4 z-40 inline-flex min-h-[48px] items-center gap-2 rounded-full bg-slate-900 px-4 py-3 text-sm font-black text-white shadow-xl active:scale-95"
      >
        <Bug className="h-4 w-4" /> 오류신고
      </button>
      {showUserErrorReport && (
        <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/45 p-4 sm:items-center" data-html2canvas-ignore="true">
          <div className="w-full max-w-md rounded-[1.5rem] bg-white p-5 shadow-2xl">
            <div className="mb-3 flex items-start justify-between gap-3">
              <div>
                <h3 className="text-xl font-black text-slate-900">오류신고</h3>
                <p className="mt-1 text-base font-bold leading-relaxed text-slate-600">
                  어떤 부분에서 막혔는지 적어 주세요. 화면 정보와 오류 내용은 민감정보를 가린 뒤 함께 전달됩니다.
                </p>
              </div>
              <button
                type="button"
                onClick={() => {
                  setShowUserErrorReport(false);
                  setPendingUserErrorReportSnapshot(null);
                }}
                className="rounded-full bg-slate-100 p-2 text-slate-500"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
            <div className="mb-3 rounded-2xl bg-slate-50 p-3 text-sm font-bold leading-relaxed text-slate-700">
              <p>현재 화면: {viewMode}</p>
              <p>현재 단계: {step}</p>
              {getCurrentVisibleErrorMessage() && (
                <p className="break-words text-red-600">
                  감지된 메시지: {sanitizeLogText(getCurrentVisibleErrorMessage())}
                </p>
              )}
              {pendingUserErrorReportSnapshot?.captureError ? (
                <p className="break-words text-amber-700">
                  화면 캡처 실패:{" "}
                  {sanitizeLogText(pendingUserErrorReportSnapshot.captureError)}
                </p>
              ) : (
                <p>현재 화면 캡처가 준비되었습니다.</p>
              )}
            </div>
            <textarea
              value={userErrorReportMessage}
              onChange={(event) => setUserErrorReportMessage(event.target.value)}
              className="min-h-[140px] w-full rounded-2xl border border-slate-200 bg-slate-50 p-4 text-lg font-bold leading-relaxed outline-none focus:border-red-500"
              placeholder="예: 사업자등록번호를 입력했는데 다음 단계로 넘어가지 않습니다. 어떤 화면에서 문제가 생겼는지 함께 적어주세요."
            />
            <div className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-2">
              <button
                type="button"
                onClick={() => {
                  setShowUserErrorReport(false);
                  setPendingUserErrorReportSnapshot(null);
                }}
                className="min-h-[52px] rounded-2xl border border-slate-200 font-black text-slate-600"
                disabled={userErrorReportSaving}
              >
                닫기
              </button>
              <button
                type="button"
                onClick={handleSubmitUserErrorReport}
                className="min-h-[52px] rounded-2xl bg-red-600 font-black text-white disabled:opacity-60"
                disabled={userErrorReportSaving}
              >
                {userErrorReportSaving ? "접수 중..." : "오류신고 보내기"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
    );
  };

  const renderErrorHelpModal = () => (
    <ErrorHelpModal
      {...(errorHelpModal || {})}
      onClose={closeErrorHelpModal}
      onOpenReport={() => {
        closeErrorHelpModal();
        void handleOpenUserErrorReport();
      }}
    />
  );
  if (isCorepInviteRoute) {
    return (
      <CorepInviteFlow
        token={corepInviteTokenForRoute}
        tokenHash={corepInviteTokenHashForRoute}
        signatureOnly={corepSignatureOnlyForRoute}
        appId={appId}
      />
    );
  }

  // [신규] 관리자 디버그 모드 화면 (에러 로그 뷰어)
  if (viewMode === "DEBUG") {
    return (
      <div className="min-h-screen bg-slate-900 text-white p-4 font-mono text-sm">
        {renderGlobalLoadingOverlay()}
        {renderErrorHelpModal()}
        <div className="max-w-4xl mx-auto">
          <div className="flex justify-between items-center mb-6 border-b border-slate-700 pb-4">
            <div>
              <h2 className="text-xl font-bold flex items-center gap-2 text-red-400">
                <Bug className="w-6 h-6" /> 시스템 에러 로그 (Debug Mode)
              </h2>
              <p className="text-slate-400 text-xs mt-1">
                최근 발생한 50개의 에러를 표시합니다. (블랙 스크린/튕김 원인
                분석용)
              </p>
            </div>
            <button
              onClick={() => setViewMode("FORM")}
              className="p-2 bg-slate-800 rounded-lg hover:bg-slate-700"
            >
              <X className="w-5 h-5" />
            </button>
          </div>

          <AdminHelpBox className="mb-4 bg-slate-800 text-slate-200 border-slate-700">
            {ADMIN_OPERATION_HELP.DEBUG}
          </AdminHelpBox>

          <div className="space-y-4">
            {errorReports.length === 0 ? (
              <div className="text-center py-20 text-slate-500">
                수집된 에러 로그가 없습니다.
              </div>
            ) : (
              errorReports.map((err) => (
                <div
                  key={err.id}
                  className="bg-slate-800 rounded-lg p-4 border border-slate-700"
                >
                  <div className="flex justify-between items-start mb-2">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="font-bold text-red-400">
                        [{err.errorType}]
                      </span>
                      {err.reportKind === "USER_REPORT" && (
                        <span className="rounded-full bg-blue-500/20 px-2 py-0.5 text-[10px] font-black text-blue-200">
                          사용자 오류신고
                        </span>
                      )}
                      {err.status && (
                        <span className="rounded-full bg-slate-700 px-2 py-0.5 text-[10px] font-black text-slate-200">
                          {err.status}
                        </span>
                      )}
                    </div>
                    <span className="text-xs text-slate-400">
                      {new Date(err.timestamp).toLocaleString()}
                    </span>
                  </div>
                  <div className="bg-slate-900 p-2 rounded text-slate-200 mb-3 break-all max-w-full overflow-x-auto">
                    {sanitizeLogText(err.message)}
                  </div>
                  {err.extraData && (
                    <div className="mb-3 rounded bg-slate-950 p-2 text-xs text-slate-300 break-all max-w-full overflow-x-auto">
                      <p className="mb-1 font-bold text-slate-400">상세 정보</p>
                      <pre className="whitespace-pre-wrap">
                        {sanitizeLogText(
                          JSON.stringify(err.extraData, null, 2)
                        )}
                      </pre>
                    </div>
                  )}
                  {err.reportKind === "USER_REPORT" && (
                    <div className="mb-3 grid grid-cols-1 gap-3 rounded-lg border border-slate-700 bg-slate-900/60 p-3 text-xs text-slate-200 sm:grid-cols-[1fr_160px]">
                      <div className="space-y-2">
                        <p>
                          <span className="font-bold text-slate-400">사용자 설명: </span>
                          {sanitizeLogText(err.userMessage || "미작성")}
                        </p>
                        <p>
                          <span className="font-bold text-slate-400">감지 메시지: </span>
                          {sanitizeLogText(err.visibleErrorMessage || "없음")}
                        </p>
                        <p>
                          <span className="font-bold text-slate-400">화면/단계: </span>
                          {err.page || "N/A"} / Step {err.step ?? "N/A"}
                        </p>
                        {err.contractDraftId && (
                          <p className="break-all">
                            <span className="font-bold text-slate-400">Draft: </span>
                            {sanitizeLogText(err.contractDraftId)}
                          </p>
                        )}
                        {err.captureError && (
                          <p className="break-words text-amber-300">
                            <span className="font-bold text-slate-400">캡처 오류: </span>
                            {sanitizeLogText(err.captureError)}
                          </p>
                        )}
                      </div>
                      {isValidScreenshotDataUrl(err.screenshotDataUrl) && (
                        <img
                          src={err.screenshotDataUrl}
                          alt="마스킹된 오류신고 화면 요약"
                          className="max-h-40 w-full rounded-lg border border-slate-700 object-cover"
                        />
                      )}
                    </div>
                  )}
                  <div className="grid grid-cols-1 gap-4 text-xs text-slate-400 sm:grid-cols-2">
                    <div>
                      <p className="font-bold text-slate-300 mb-1 flex items-center gap-1">
                        <Smartphone className="w-3 h-3" /> 디바이스 정보
                      </p>
                      <div className="pl-2 border-l border-slate-700">
                        <p>Platform: {err.deviceInfo?.platform || "N/A"}</p>
                        <p>Browser: {err.deviceInfo?.userAgent}</p>
                        <p>
                          Screen: {err.deviceInfo?.screenWidth} x{" "}
                          {err.deviceInfo?.screenHeight}
                        </p>
                        <p>
                          iOS: {err.deviceInfo?.isIOS ? "Yes" : "No"} / Android:{" "}
                          {err.deviceInfo?.isAndroid ? "Yes" : "No"}
                        </p>
                      </div>
                    </div>
                    <div>
                      <p className="font-bold text-slate-300 mb-1">상태 정보</p>
                      <div className="pl-2 border-l border-slate-700">
                        <p>Step: {err.step}</p>
                        <p>IP: {err.ip}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    );
  }

  const renderTrashPurgeModal = () => {
    if (!showTrashPurgeModal) return null;
    const targets = Array.isArray(trashPurgeDryRun?.targets)
      ? trashPurgeDryRun.targets
      : [];
    const excluded = Array.isArray(trashPurgeDryRun?.excluded)
      ? trashPurgeDryRun.excluded
      : [];
    const result = trashPurgeResult || null;
    const canApplyTrashPurge =
      Boolean(trashPurgeDryRun?.targetCount) &&
      trashPurgeReason.trim().length > 0 &&
      trashPurgeConfirmText === "휴지통 영구삭제" &&
      !trashPurgeApplying &&
      !trashPurgeLoading;

    return (
      <div className="fixed inset-0 z-50 flex items-end justify-center bg-slate-900/60 p-3 sm:items-center">
        <div className="max-h-[92vh] w-full max-w-2xl overflow-y-auto rounded-3xl bg-white p-5 shadow-2xl">
          <div className="mb-4 flex items-start justify-between gap-3">
            <div>
              <p className="text-sm font-black uppercase tracking-[0.18em] text-red-600">
                irreversible admin action
              </p>
              <h3 className="mt-1 text-2xl font-black text-slate-950">
                휴지통 비우기
              </h3>
              <p className="mt-2 break-keep text-base font-semibold leading-7 text-slate-700">
                휴지통에 있는 계약만 서버에서 영구삭제합니다. 이 작업은 되돌릴 수 없습니다.
              </p>
            </div>
            <button
              type="button"
              onClick={closeTrashPurgeModal}
              disabled={trashPurgeApplying}
              className="rounded-full bg-slate-100 p-2 text-slate-500 disabled:opacity-50"
              aria-label="닫기"
            >
              <X className="h-5 w-5" />
            </button>
          </div>

          <div className="mb-4 rounded-2xl border border-red-200 bg-red-50 p-4 text-base font-bold leading-7 text-red-800">
            삭제 전 dry-run 결과를 먼저 확인합니다. 완료/정상 계약, KCP 세션, 관리자 로그,
            오류신고 로그는 삭제 대상이 아닙니다.
          </div>

          <div className="mb-4 grid grid-cols-1 gap-3 sm:grid-cols-3">
            <div className="rounded-2xl border border-slate-200 bg-slate-50 p-4">
              <p className="text-sm font-black text-slate-500">영구삭제 대상</p>
              <p className="mt-2 text-3xl font-black text-red-700">
                {trashPurgeLoading ? "..." : trashPurgeDryRun?.targetCount || 0}
              </p>
            </div>
            <div className="rounded-2xl border border-slate-200 bg-slate-50 p-4">
              <p className="text-sm font-black text-slate-500">삭제 제외</p>
              <p className="mt-2 text-3xl font-black text-slate-800">
                {trashPurgeLoading ? "..." : trashPurgeDryRun?.excludedCount || 0}
              </p>
            </div>
            <div className="rounded-2xl border border-slate-200 bg-slate-50 p-4">
              <p className="text-sm font-black text-slate-500">하위 이벤트</p>
              <p className="mt-2 text-3xl font-black text-slate-800">
                {trashPurgeLoading ? "..." : trashPurgeDryRun?.eventCount || 0}
              </p>
            </div>
          </div>

          <div className="mb-4 rounded-2xl border border-slate-200">
            <div className="flex items-center justify-between gap-3 border-b border-slate-100 px-4 py-3">
              <p className="text-base font-black text-slate-900">삭제 대상 계약</p>
              <button
                type="button"
                onClick={requestTrashPurgeDryRun}
                disabled={trashPurgeLoading || trashPurgeApplying}
                className="rounded-xl bg-slate-100 px-3 py-2 text-sm font-black text-slate-700 disabled:opacity-50"
              >
                {trashPurgeLoading ? "확인 중..." : "dry-run 다시 확인"}
              </button>
            </div>
            <div className="max-h-44 overflow-y-auto p-3">
              {targets.length === 0 ? (
                <p className="rounded-xl bg-slate-50 px-3 py-4 text-center text-sm font-bold text-slate-500">
                  현재 영구삭제 대상 계약이 없습니다.
                </p>
              ) : (
                <div className="space-y-2">
                  {targets.slice(0, 20).map((item) => (
                    <div
                      key={item.documentId}
                      className="rounded-xl bg-slate-50 px-3 py-2 text-sm font-bold text-slate-700"
                    >
                      <div className="min-w-0 break-all">
                        계약번호: {item.contractId || item.contractIdMasked || "미수집"}
                      </div>
                      <div className="min-w-0 break-all text-xs text-slate-500">
                        문서: {item.documentIdMasked || item.documentId} · events {item.eventCount || 0}건
                      </div>
                    </div>
                  ))}
                  {targets.length > 20 && (
                    <p className="text-xs font-bold text-slate-500">
                      외 {targets.length - 20}건은 서버 dry-run 결과에 포함되어 있습니다.
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>

          {excluded.length > 0 && (
            <div className="mb-4 rounded-2xl border border-amber-200 bg-amber-50 p-4">
              <p className="text-base font-black text-amber-900">삭제 제외 항목</p>
              <div className="mt-2 space-y-1 text-sm font-bold leading-6 text-amber-800">
                {excluded.slice(0, 5).map((item, index) => (
                  <p key={`${item.documentId || index}-${item.reason}`}>
                    {item.contractId || item.documentIdMasked || "문서"}: {item.reason}
                  </p>
                ))}
                {excluded.length > 5 && <p>외 {excluded.length - 5}건</p>}
              </div>
            </div>
          )}

          <label className="mb-4 block">
            <span className="mb-2 block text-base font-black text-slate-900">
              영구삭제 사유 <span className="text-red-600">필수</span>
            </span>
            <textarea
              value={trashPurgeReason}
              onChange={(event) => {
                setTrashPurgeReason(event.target.value);
                setTrashPurgeError("");
              }}
              rows={3}
              placeholder="예: 중복 테스트 계약 정리, 운영 휴지통 정기 정리"
              className="w-full rounded-2xl border border-slate-200 px-4 py-3 text-base font-semibold leading-7 outline-none focus:border-red-500 focus:ring-2 focus:ring-red-100"
            />
          </label>

          <label className="mb-4 block">
            <span className="mb-2 block text-base font-black text-slate-900">
              확인 문구 입력: <span className="text-red-600">휴지통 영구삭제</span>
            </span>
            <input
              value={trashPurgeConfirmText}
              onChange={(event) => {
                setTrashPurgeConfirmText(event.target.value);
                setTrashPurgeError("");
              }}
              placeholder="휴지통 영구삭제"
              className="min-h-[52px] w-full rounded-2xl border border-slate-200 px-4 text-base font-black outline-none focus:border-red-500 focus:ring-2 focus:ring-red-100"
            />
          </label>

          {trashPurgeError && (
            <div className="mb-4 rounded-2xl border border-red-200 bg-red-50 p-4 text-base font-bold leading-7 text-red-700">
              {trashPurgeError}
            </div>
          )}

          {result && (
            <div className="mb-4 rounded-2xl border border-emerald-200 bg-emerald-50 p-4 text-base font-bold leading-7 text-emerald-800">
              삭제 {result.deletedCount || 0}건, 제외 {result.skippedCount || 0}건,
              실패 {result.failedCount || 0}건으로 처리되었습니다.
            </div>
          )}

          <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
            <button
              type="button"
              onClick={closeTrashPurgeModal}
              disabled={trashPurgeApplying}
              className="min-h-[52px] rounded-2xl border border-slate-200 px-4 py-3 text-base font-black text-slate-700 disabled:opacity-50"
            >
              닫기
            </button>
            <button
              type="button"
              onClick={applyTrashPurge}
              disabled={!canApplyTrashPurge}
              className="min-h-[52px] rounded-2xl bg-red-700 px-4 py-3 text-base font-black text-white shadow-sm disabled:bg-slate-300 disabled:text-slate-500"
            >
              {trashPurgeApplying ? "영구삭제 중..." : "영구삭제 실행"}
            </button>
          </div>
        </div>
      </div>
    );
  };

  if (viewMode === "LIST") {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    let filtered = contractList;
    if (statusFilter !== "all") {
      filtered = filtered.filter((item) => {
        const itemStatus = getAdminContractStatusKey(item);
        if (statusFilter === "deleted") return itemStatus === "deleted";
        return itemStatus === statusFilter && itemStatus !== "deleted";
      });
    } else {
      filtered = filtered.filter(
        (item) => getAdminContractStatusKey(item) !== "deleted"
      );
    }
    if (searchTerm) {
      filtered = filtered.filter(
        (item) =>
          getAdminDisplayBusinessName(item).includes(searchTerm) ||
          getBusinessNameCorrectionOriginalName(item).includes(searchTerm) ||
          String(item.agentRep || "").includes(searchTerm) ||
          (item.agentContact && item.agentContact.includes(searchTerm))
      );
    }
    const currentItems = filtered.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(filtered.length / itemsPerPage);
    const visibleSalesReps = normalizeSalesRepItems(salesReps);
    const activeSalesRepOptions = getActiveSalesReps(salesReps);
    const showTrashPurgeControls =
      adminTab === "LIST" &&
      statusFilter === "deleted" &&
      isHeadquarters() &&
      !isSalesLookupMode;
    const showSalesAssignmentControls =
      adminTab === "SALES_SEARCH" && isHeadquarters() && !isSalesLookupMode;
    const visibleAdminPageTabs = getVisibleAdminPageTabs(
      isHeadquarters(),
      isSalesLookupMode,
      isPaymentOnlyMode,
      isSalesPaymentMode
    );
    const currentAdminPageTab =
      visibleAdminPageTabs.find((tab) => tab.value === adminTab) ||
      visibleAdminPageTabs[0];
    const loadedContractCount =
      adminTab === "PAYMENT_MANAGEMENT"
        ? isSalesPaymentMode
          ? paymentVendorOptions.length
          : paymentRequests.length
        : adminTab === "SALES_SEARCH"
        ? salesContractSearchTotal
        : contractList.length;
    const salesSearchFilterSummary = getSalesContractSearchFilterSummary();
    const isSalesSearchDateRangeActive = Boolean(
      salesContractSearchForm.dateFrom || salesContractSearchForm.dateTo
    );
    const isSalesSearchFilterActive =
      hasActiveSalesLookupFilters(salesContractSearchForm);
    const currentAdminHelpText = getAdminOperationHelpForTab(
      adminTab,
      statusFilter
    );
    const adminContractStartLink = getAdminContractStartLink();
    const adminContractStartSmsMessage =
      buildAdminContractStartSmsMessage(adminContractStartLink);
    const adminKcpReturnNavigationStatus =
      getAdminKcpReturnNavigationStatus();

    return (
      <div className="min-h-screen bg-slate-50 p-4 font-sans text-slate-800 lg:p-6">
        {renderGlobalLoadingOverlay()}
        {renderErrorHelpModal()}
        {renderTrashPurgeModal()}
        {fieldPrintDialogOpen && canUseFieldPrint && (
          <div className="cnfood-field-print-overlay fixed inset-0 z-[80] flex items-end justify-center bg-slate-950/60 p-3 backdrop-blur-sm sm:items-center">
            <div
              className="cnfood-field-print-dialog max-h-[94vh] w-full max-w-6xl overflow-y-auto rounded-3xl bg-white p-5 shadow-2xl sm:p-7"
              role="dialog"
              aria-modal="true"
              aria-labelledby="field-print-contract-title"
            >
              <div className="cnfood-field-print-controls flex flex-col gap-4 border-b border-slate-200 pb-5 sm:flex-row sm:items-start sm:justify-between">
                <div>
                  <p className="text-xs font-black uppercase tracking-[0.18em] text-blue-700">
                    Field Contract
                  </p>
                  <h2 id="field-print-contract-title" className="mt-1 text-xl font-black text-slate-950">
                    계약서 출력 / PDF 저장
                  </h2>
                  <p className="mt-2 text-sm font-bold leading-6 text-slate-600 break-keep">
                    거래처 정보와 서명란은 현장에서 직접 작성할 수 있도록 빈칸으로 출력됩니다.
                  </p>
                </div>
                <button
                  type="button"
                  onClick={closeFieldPrintDialog}
                  className="min-h-[44px] rounded-xl border border-slate-200 px-4 py-2 text-sm font-black text-slate-700"
                >
                  닫기
                </button>
              </div>
              <fieldset className="cnfood-field-print-controls mt-5">
                <legend className="text-sm font-black text-slate-900">계약서 유형을 선택하세요.</legend>
                <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2">
                  {FIELD_PRINT_OUTPUT_TYPE_OPTIONS.map((option) => (
                    <label
                      key={option.value}
                      className={`flex min-h-[52px] cursor-pointer items-center gap-3 rounded-2xl border px-4 py-3 text-sm font-black transition ${
                        fieldPrintContractType === option.value
                          ? "border-blue-500 bg-blue-50 text-blue-950"
                          : "border-slate-200 text-slate-700"
                      }`}
                    >
                      <input
                        type="radio"
                        name="field-print-contract-type"
                        value={option.value}
                        checked={fieldPrintContractType === option.value}
                        onChange={() => {
                          setFieldPrintContractType(option.value);
                          setFieldPrintPages([]);
                          setFieldPrintPreviewOpen(false);
                        }}
                      />
                      {option.label}
                    </label>
                  ))}
                </div>
              </fieldset>
              <label className="cnfood-field-print-controls mt-5 block">
                <span className="text-sm font-black text-slate-900">공급자 법인</span>
                <select
                  value={fieldPrintCompanyBranchId}
                  onChange={(event) => {
                    setFieldPrintCompanyBranchId(event.target.value);
                    setFieldPrintPages([]);
                    setFieldPrintPreviewOpen(false);
                  }}
                  disabled={companyBranchesLoading}
                  className="mt-2 min-h-[48px] w-full rounded-xl border border-slate-300 bg-white px-3 text-sm font-bold text-slate-800 disabled:opacity-60"
                >
                  <option value="">기본 계약서 - 씨엔푸드 2개 법인 모두</option>
                  {companyBranches
                    .filter((branch) => branch.active !== false)
                    .map((branch) => {
                      const branchId = getCompanyBranchStableId(branch);
                      return (
                        <option key={branchId || branch.branchName} value={branchId}>
                          {branch.corporationName || branch.branchName}
                          {branch.branchName && branch.corporationName
                            ? ` (${branch.branchName})`
                            : ""}
                        </option>
                      );
                    })}
                </select>
                {companyBranchesError && (
                  <p className="mt-2 text-xs font-bold leading-5 text-amber-800">{companyBranchesError}</p>
                )}
              </label>
              <p className="cnfood-field-print-help mt-4 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-xs font-bold leading-5 text-amber-950 break-keep">
                사람 정보는 현장에서 수기로 작성하는 빈칸입니다. 이 출력 기능은 개인정보를 저장하지 않습니다.
              </p>
              <div className="cnfood-field-print-controls mt-5 flex flex-col gap-2 sm:flex-row sm:justify-end">
                <button
                  type="button"
                  onClick={previewFieldContract}
                  disabled={fieldPrintPreparing}
                  className="min-h-[48px] rounded-xl border border-blue-200 bg-blue-50 px-5 py-3 text-sm font-black text-blue-800 disabled:opacity-60"
                >
                  {fieldPrintPreparing ? "문서 준비 중..." : "미리보기"}
                </button>
                <button
                  type="button"
                  onClick={printFieldContract}
                  disabled={fieldPrintPreparing}
                  className="min-h-[48px] rounded-xl bg-slate-900 px-5 py-3 text-sm font-black text-white disabled:opacity-60"
                >
                  인쇄 / PDF 저장
                </button>
              </div>
              <p className="cnfood-field-print-help mt-3 text-xs font-bold leading-5 text-slate-500">
                인쇄 화면에서 ‘PDF로 저장’을 선택하면 파일로 저장할 수 있습니다.
              </p>
              {fieldPrintPreviewOpen && (
                <div className="cnfood-field-print-preview-shell mt-7 overflow-x-auto rounded-2xl border border-slate-200 bg-slate-100 p-3 sm:p-6">
                  <PrintableFieldContract pages={fieldPrintPages} />
                </div>
              )}
            </div>
          </div>
        )}
        {companyBranchModalOpen && !isPaymentOnlyMode && (
          <div className="fixed inset-0 z-50 flex items-end justify-center bg-slate-950/50 p-3 sm:items-center">
            <div className="max-h-[92vh] w-full max-w-3xl overflow-y-auto rounded-3xl bg-white p-5 shadow-2xl">
              <div className="flex items-start justify-between gap-3">
                <div>
                  <p className="text-xs font-black uppercase tracking-[0.18em] text-blue-600">
                    Company Branch
                  </p>
                  <h3 className="mt-1 text-xl font-black text-slate-950">
                    우리회사 사업장 등록/수정
                  </h3>
                  <p className="mt-2 text-sm font-bold leading-6 text-slate-500 break-keep">
                    실제 KCP secret/cert/key는 저장하지 않습니다. 담당자 화면의 site_cd는 선택한 결제 프로필에서 전체 코드를 표시합니다.
                  </p>
                </div>
                <button
                  type="button"
                  onClick={closeCompanyBranchModal}
                  disabled={companyBranchSaving}
                  className="rounded-full bg-slate-100 px-3 py-2 text-sm font-black text-slate-600 disabled:opacity-50"
                >
                  닫기
                </button>
              </div>
              <div className="mt-4 grid grid-cols-1 gap-3 md:grid-cols-2">
                {[
                  ["사업장명", "branchName", "text"],
                  ["법인명", "corporationName", "text"],
                  ["사업자번호", "businessNumber", "text"],
                  ["대표자명", "representativeName", "text"],
                  ["주소", "address", "text"],
                  ["전화번호", "phone", "tel"],
                  ["이메일", "email", "email"],
                  ["KCP site_cd 예비 표시값", "siteCdMasked", "text"],
                  ["메모", "memo", "text"],
                ].map(([label, field, type]) => (
                  <label key={field} className="block">
                    <span className="mb-1 block text-sm font-black text-slate-700">
                      {label}
                    </span>
                    <input
                      type={type}
                      value={
                        field === "siteCdMasked"
                          ? companyBranchForm?.pgProfile?.siteCdMasked || ""
                          : companyBranchForm?.[field] || ""
                      }
                      onChange={(event) =>
                        field === "siteCdMasked"
                          ? updateCompanyBranchForm({
                              pgProfile: { siteCdMasked: event.target.value },
                            })
                          : updateCompanyBranchForm({ [field]: event.target.value })
                      }
                      className="min-h-[48px] w-full rounded-xl border border-slate-200 px-3 text-base font-bold outline-none focus:border-blue-500"
                    />
                  </label>
                ))}
                <label className="block">
                  <span className="mb-1 block text-sm font-black text-slate-700">
                    PG 상태
                  </span>
                  <select
                    value={companyBranchForm?.pgProfile?.status || "NOT_APPLIED"}
                    onChange={(event) =>
                      updateCompanyBranchForm({
                        pgProfile: { status: event.target.value },
                      })
                    }
                    className="min-h-[48px] w-full rounded-xl border border-slate-200 px-3 text-base font-bold outline-none focus:border-blue-500"
                  >
                    {COMPANY_BRANCH_PG_STATUS_OPTIONS.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </label>
                {[
                  ["문자링크 결제 프로필", "linkPaymentProfileId", LINK_PAYMENT_PROFILE_OPTIONS],
                  ["키인결제 프로필", "keyinPaymentProfileId", KEYIN_PAYMENT_PROFILE_OPTIONS],
                  ["등록카드 결제 프로필", "autopayProfileId", AUTOPAY_PROFILE_OPTIONS],
                ].map(([label, field, options]) => (
                  <label key={field} className="block">
                    <span className="mb-1 block text-sm font-black text-slate-700">
                      {label}
                    </span>
                    <select
                      value={companyBranchForm?.pgProfile?.[field] || ""}
                      onChange={(event) =>
                        updateCompanyBranchForm({
                          pgProfile: { [field]: event.target.value },
                        })
                      }
                      className="min-h-[48px] w-full rounded-xl border border-slate-200 px-3 text-base font-bold outline-none focus:border-blue-500"
                    >
                      <option value="">미연결</option>
                      {options.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                          {option.siteCd ? ` · ${option.siteCd}` : ""}
                        </option>
                      ))}
                    </select>
                  </label>
                ))}
                <div className="rounded-2xl border border-blue-100 bg-blue-50 p-3 text-sm font-bold leading-6 text-blue-900 md:col-span-2">
                  <p className="font-black">문자링크 결제 라우팅</p>
                  <p>
                    결제 법인:{" "}
                    {getCompanyBranchLinkPaymentDisplay(
                      companyBranchForm?.pgProfile
                    ).companyName || "미연결"}
                  </p>
                  <p>
                    KCP site_cd:{" "}
                    {getCompanyBranchLinkPaymentDisplay(
                      companyBranchForm?.pgProfile
                    ).siteCd || "미연결"}
                  </p>
                  <p className="mt-1 text-xs text-blue-700">
                    예비 표시값은 과거 데이터 호환용입니다. 실제 결제 라우팅은 위 결제 프로필을 기준으로 합니다.
                  </p>
                </div>
                <label className="block">
                  <span className="mb-1 block text-sm font-black text-slate-700">
                    저장 사유
                  </span>
                  <input
                    value={companyBranchSaveReason}
                    onChange={(event) => setCompanyBranchSaveReason(event.target.value)}
                    className="min-h-[48px] w-full rounded-xl border border-slate-200 px-3 text-base font-bold outline-none focus:border-blue-500"
                    placeholder="신규 등록 또는 수정 사유"
                  />
                </label>
              </div>
              <div className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-2">
                {[
                  ["기본 사업장", "isDefault"],
                  ["활성", "active"],
                  ["문자링크결제 가능", "buyLinkEnabled"],
                  ["키인결제 가능", "keyinEnabled"],
                  ["등록카드 결제 가능", "autopayEnabled"],
                  ["취소 가능", "cancelEnabled"],
                ].map(([label, field]) => (
                  <label
                    key={field}
                    className="flex items-center gap-3 rounded-2xl border border-slate-200 p-3 text-sm font-black text-slate-700"
                  >
                    <input
                      type="checkbox"
                      checked={
                        field === "isDefault"
                          ? companyBranchForm?.isDefault === true
                          : field === "active"
                          ? companyBranchForm?.active !== false
                          : companyBranchForm?.pgProfile?.[field] === true
                      }
                      onChange={(event) =>
                        field === "isDefault" || field === "active"
                          ? updateCompanyBranchForm({ [field]: event.target.checked })
                          : updateCompanyBranchForm({
                              pgProfile: { [field]: event.target.checked },
                            })
                      }
                    />
                    {label}
                  </label>
                ))}
              </div>
              {companyBranchesError && (
                <div className="mt-4 rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm font-bold leading-6 text-red-700">
                  {companyBranchesError}
                </div>
              )}
              <div className="mt-5 flex flex-col gap-2 sm:flex-row sm:justify-end">
                <button
                  type="button"
                  onClick={closeCompanyBranchModal}
                  disabled={companyBranchSaving}
                  className="min-h-[48px] rounded-2xl border border-slate-200 px-4 py-3 text-base font-black text-slate-600 disabled:opacity-50"
                >
                  취소
                </button>
                <button
                  type="button"
                  onClick={saveCompanyBranch}
                  disabled={companyBranchSaving}
                  className="inline-flex min-h-[48px] items-center justify-center gap-2 rounded-2xl bg-blue-700 px-4 py-3 text-base font-black text-white shadow-sm disabled:bg-slate-300"
                >
                  {companyBranchSaving && <Loader2 className="h-5 w-5 animate-spin" />}
                  저장
                </button>
              </div>
            </div>
          </div>
        )}
        <VendorMasterEditor
          open={Boolean(vendorMasterEditorState)}
          mode={vendorMasterEditorState?.mode || "create"}
          vendor={vendorMasterForm}
          branches={companyBranches}
          reason={vendorMasterSaveReason}
          saving={vendorMasterSaving}
          serverError={vendorMastersError}
          duplicateNameWarning={
            vendorMasterSimilarNames.length > 0
              ? `유사한 거래처명이 있습니다: ${vendorMasterSimilarNames
                  .map(
                    (vendor) =>
                      `[${normalizeVendorCode(vendor.vendorCode) || "코드 미연결"}] ${
                        vendor.businessName || "상호명 미수집"
                      }`
                  )
                  .join(", ")}. 동일 거래처인지 확인해 주세요.`
              : ""
          }
          onChange={updateVendorMasterForm}
          onBranchToggle={updateVendorMasterBranchSelection}
          onReasonChange={setVendorMasterSaveReason}
          onSave={saveVendorMaster}
          onClose={closeVendorMasterModal}
        />
        {renderSalesAssignmentModal()}
        {renderUserErrorReportControls()}
        <div
          style={{
            position: "absolute",
            width: 0,
            height: 0,
            overflow: "hidden",
          }}
        >
          <canvas ref={contractCanvasRef} />
          <canvas ref={auditCanvasRef} />
        </div>
        <div className="mx-auto min-h-[80vh] w-full max-w-[1400px] rounded-2xl bg-white p-4 shadow lg:p-6">
          <div className="mb-4 rounded-3xl border border-slate-700 bg-[#202A44] p-5 text-white shadow-lg">
            <div className="flex items-start justify-between gap-4">
              <div className="min-w-0">
                <p className="text-xs font-bold uppercase tracking-[0.2em] text-violet-200">
                  본사 운영 대시보드
                </p>
                <h3 className="text-2xl font-black mt-2 leading-tight">
                  {isSalesLookupMode
                    ? "영업 조회 화면"
                    : currentAdminPageTab?.label || "계약 관리"}
                </h3>
                <p className="mt-2 break-keep text-sm font-semibold leading-relaxed text-slate-200">
                  {isSalesLookupMode
                    ? "거래처 전자계약 작성 여부를 민감정보 없이 기본정보로만 확인합니다."
                    : currentAdminPageTab?.description ||
                      "현재 운영 상태를 확인하고 필요한 화면으로 이동합니다."}
                </p>
              </div>
              <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-violet-300/15">
                <ShieldCheck className="w-7 h-7" />
              </div>
            </div>
            <div className="grid grid-cols-1 gap-2 mt-5 sm:grid-cols-3">
              <div className="rounded-2xl bg-white/10 px-3 py-3 text-center">
                <div className="text-[11px] text-slate-300 mb-1">
                  {adminTab === "PAYMENT_MANAGEMENT"
                    ? isSalesPaymentMode
                      ? "담당 거래처"
                      : "결제 요청"
                    : "불러온 계약"}
                </div>
                <div className="text-xl font-black">
                  {loadedContractCount}
                </div>
              </div>
              <div className="rounded-2xl bg-white/10 px-3 py-3 text-center">
                <div className="text-[11px] text-slate-300 mb-1">관리자</div>
                <div className="text-sm font-black truncate">
                  {currentManager?.name}
                </div>
              </div>
              <button
                type="button"
                onClick={() =>
                  adminTab === "SALES_SEARCH"
                    ? loadSalesContractSearch({ reload: true })
                    : adminTab === "PAYMENT_MANAGEMENT"
                    ? isSalesPaymentMode
                      ? loadPaymentDirectory()
                      : showPaymentOperationsPanel
                      ? loadPaymentRequests()
                      : loadPaymentDirectory()
                    : adminTab === "LEGACY_ARCHIVE"
                    ? loadLegacyContracts()
                    : adminTab === "VENDOR_MASTER"
                    ? loadVendorMasters()
                    : adminTab === "COMPANY_BRANCHES"
                    ? loadCompanyBranches()
                    : adminTab === "DB_BACKUP"
                    ? loadDbBackups()
                    : fetchAndShowList()
                }
                className="min-h-[48px] rounded-2xl bg-white px-3 py-3 text-center text-slate-900 transition hover:bg-violet-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-300 focus-visible:ring-offset-2 focus-visible:ring-offset-[#202A44]"
              >
                <RefreshCcw className="w-4 h-4 mx-auto mb-1" />
                <div className="text-xs font-black">
                  {adminTab === "STATS" ? "계약 데이터 갱신" : "다시 불러오기"}
                </div>
              </button>
            </div>
          </div>
          <div className="flex flex-col gap-3 mb-4 sm:flex-row sm:items-center sm:justify-between">
            <h2 className="flex min-w-0 items-center gap-2 text-xl font-black text-slate-900">
              <List className="shrink-0" /> {isSalesLookupMode ? "거래처 계약 현황" : currentAdminPageTab?.label || "계약 관리"} (
              {currentManager?.name})
            </h2>
            <div className="flex items-center gap-2">
              {canUseFieldPrint && (
                <button
                  type="button"
                  onClick={openFieldPrintDialog}
                  className="inline-flex min-h-[44px] items-center justify-center rounded-xl bg-blue-700 px-4 py-2 text-sm font-black text-white shadow-sm transition hover:bg-blue-800"
                >
                  계약서 출력 / PDF 저장
                </button>
              )}
              <button
                type="button"
                aria-label="관리자 화면 닫기"
                onClick={() => {
                  setAdminContractStartMode(false);
                  setAdminAccessMode("ADMIN");
                  setViewMode("FORM");
                }}
                className="inline-flex min-h-[44px] min-w-[44px] shrink-0 items-center justify-center rounded-full bg-slate-100 p-2 text-slate-700 transition hover:bg-slate-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-600 focus-visible:ring-offset-2"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
          </div>
          <div
            className={`mb-5 grid grid-cols-2 gap-2 rounded-3xl border border-slate-200 bg-slate-100/80 p-2 ${isPaymentOnlyMode ? "lg:grid-cols-3" : "lg:grid-cols-4"}`}
            aria-label="관리자 업무 메뉴"
          >
            {visibleAdminPageTabs.map((tab) => (
              <button
                key={tab.value}
                type="button"
                aria-current={adminTab === tab.value ? "page" : undefined}
                className={`min-h-[60px] rounded-2xl border px-3 py-3 text-left transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-600 focus-visible:ring-offset-2 ${
                  adminTab === tab.value
                    ? "border-violet-200 bg-white text-violet-950 shadow-sm"
                    : "border-transparent bg-transparent text-slate-600 hover:border-slate-200 hover:bg-white/80"
                }`}
                onClick={() => {
                  setAdminTab(tab.value);
                  if (tab.value === "LEGACY_ARCHIVE" && legacyContracts.length === 0) {
                    void loadLegacyContracts();
                  }
                  if (tab.value === "SALES_SEARCH" && companyBranches.length === 0) {
                    void loadCompanyBranches();
                  }
                  if (
                    tab.value === "PAYMENT_MANAGEMENT" &&
                    showPaymentOperationsPanel &&
                    paymentRequests.length === 0
                  ) {
                    void loadPaymentRequests();
                  }
                  if (
                    ["PAYMENT_MANAGEMENT", "VENDOR_MASTER", "COMPANY_BRANCHES"].includes(
                      tab.value
                    ) &&
                    !paymentDirectoryLoaded
                  ) {
                    void loadPaymentDirectory();
                  }
                  if (tab.value === "VENDOR_MASTER" && vendorMasters.length === 0) {
                    if (!isPaymentOnlyMode) void loadVendorMasters();
                  }
                  if (tab.value === "COMPANY_BRANCHES" && companyBranches.length === 0) {
                    if (!isPaymentOnlyMode) void loadCompanyBranches();
                  }
                  if (tab.value === "DB_BACKUP" && dbBackups.length === 0) {
                    void loadDbBackups();
                  }
                }}
              >
                <span className="flex items-center gap-2 text-sm font-black">
                  <span
                    aria-hidden="true"
                    className={`h-2.5 w-2.5 shrink-0 rounded-full ${
                      adminTab === tab.value ? "bg-violet-600" : "bg-slate-300"
                    }`}
                  />
                  {tab.label}
                </span>
                <span className="mt-1 hidden text-xs font-semibold leading-4 text-slate-500 lg:block">
                  {tab.description}
                </span>
              </button>
            ))}
          </div>
          <AdminHelpBox className="mb-5">{currentAdminHelpText}</AdminHelpBox>
          {adminTab === "CONTRACT_START" ? (
            <div className="animate-in fade-in space-y-4">
              <div className="rounded-2xl border border-blue-100 bg-blue-50 p-5">
                <p className="text-xs font-black uppercase tracking-[0.18em] text-blue-600">
                  Contract Start
                </p>
                <h3 className="mt-2 text-xl font-black text-blue-950">
                  계약 시작하기
                </h3>
                <p className="mt-2 text-sm font-bold leading-6 text-blue-900 break-keep">
                  관리자 테스트 작성, 거래처 작성 링크 발급, KCP/PASS 본인확인 상태 점검
                </p>
                <div className="mt-4 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm font-bold leading-6 text-amber-900 break-keep">
                  영업사원 또는 관리자가 대표자 대신 본인인증, 동의 체크, 전자서명을 진행하면 계약 증빙력이 약해질 수 있습니다. 거래처 대표자 또는 계약 권한이 있는 당사자가 직접 진행해야 합니다.
                </div>
              </div>

              <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
                <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
                  <div className="flex items-start justify-between gap-3">
                    <div>
                      <p className="text-xs font-black uppercase tracking-[0.16em] text-slate-400">
                        Admin Test
                      </p>
                      <h4 className="mt-2 text-lg font-black text-slate-950">
                        관리자 테스트 작성 시작
                      </h4>
                    </div>
                    <span className="rounded-full bg-blue-100 px-3 py-1 text-[11px] font-black text-blue-700">
                      관리자 전용
                    </span>
                  </div>
                  <p className="mt-3 text-sm font-bold leading-6 text-slate-600 break-keep">
                    전체 작성 일시중단 상태에서도 관리자 테스트 모드로 실제 작성 플로우와 KCP/PASS 버튼을 점검합니다. 본인확인 완료 상태는 강제로 부여하지 않습니다.
                  </p>
                  <button
                    type="button"
                    onClick={handleStartAdminContractTest}
                    disabled={!canUseAdminContractStart || loading}
                    className="mt-4 inline-flex min-h-[48px] w-full items-center justify-center rounded-2xl bg-blue-700 px-4 py-3 text-sm font-black text-white shadow-sm disabled:bg-slate-300 disabled:text-slate-500"
                  >
                    관리자 테스트 작성 시작
                  </button>
                </div>

                <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
                  <p className="text-xs font-black uppercase tracking-[0.16em] text-slate-400">
                    Partner Link
                  </p>
                  <h4 className="mt-2 text-lg font-black text-slate-950">
                    거래처 작성 링크 발급
                  </h4>
                  <p className="mt-3 text-sm font-bold leading-6 text-slate-600 break-keep">
                    아래 링크를 거래처 대표자에게 전달해 주세요. 본인인증, 개인정보 동의, 전자서명은 대표자 또는 계약 권한이 있는 당사자가 직접 진행해야 합니다.
                  </p>
                  <div className="mt-4 rounded-2xl border border-slate-200 bg-slate-50 p-3 text-xs font-bold leading-5 text-slate-700 break-all">
                    {adminContractStartLink}
                  </div>
                  <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-1">
                    <button
                      type="button"
                      onClick={() => copyTextToClipboard(adminContractStartLink)}
                      className="min-h-[44px] rounded-xl border border-blue-200 bg-blue-50 px-3 py-2 text-sm font-black text-blue-700"
                    >
                      링크 복사
                    </button>
                    <button
                      type="button"
                      onClick={() =>
                        copyTextToClipboard(adminContractStartSmsMessage)
                      }
                      className="min-h-[44px] rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-sm font-black text-slate-700"
                    >
                      문자 안내문 복사
                    </button>
                  </div>
                </div>

                <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
                  <p className="text-xs font-black uppercase tracking-[0.16em] text-slate-400">
                    KCP/PASS
                  </p>
                  <h4 className="mt-2 text-lg font-black text-slate-950">
                    KCP/PASS 상태 점검
                  </h4>
                  <div className="mt-4 space-y-2 text-sm font-bold text-slate-700">
                    <div className="flex justify-between gap-3 rounded-xl bg-slate-50 px-3 py-2">
                      <span>Intent active</span>
                      <span className="font-black text-slate-950">
                        {adminKcpReturnNavigationStatus.active ? "YES" : "NO"}
                      </span>
                    </div>
                    <div className="flex justify-between gap-3 rounded-xl bg-slate-50 px-3 py-2">
                      <span>targetStep</span>
                      <span className="font-black text-slate-950">
                        {adminKcpReturnNavigationStatus.targetStep}
                      </span>
                    </div>
                    <div className="rounded-xl bg-slate-50 px-3 py-2">
                      <div className="text-slate-500">createdAt</div>
                      <div className="mt-1 font-black text-slate-950">
                        {adminKcpReturnNavigationStatus.createdAt}
                      </div>
                    </div>
                    <div className="flex justify-between gap-3 rounded-xl bg-slate-50 px-3 py-2">
                      <span>만료 여부</span>
                      <span className="font-black text-slate-950">
                        {adminKcpReturnNavigationStatus.expired ? "만료" : "정상"}
                      </span>
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={handleClearAdminKcpReturnNavigation}
                    className="mt-4 inline-flex min-h-[48px] w-full items-center justify-center rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm font-black text-slate-700"
                  >
                    KCP 복귀 상태 초기화
                  </button>
                </div>
              </div>
            </div>
          ) : adminTab === "DB_BACKUP" ? (
            <div className="animate-in fade-in space-y-4">
              <div className="rounded-2xl border border-indigo-100 bg-indigo-50 p-5">
                <p className="text-xs font-black uppercase tracking-[0.18em] text-indigo-600">
                  Database Backup
                </p>
                <h3 className="mt-2 text-xl font-black text-indigo-950">
                  DB 백업/복원
                </h3>
                <p className="mt-2 text-sm font-bold leading-6 text-indigo-900 break-keep">
                  권장 방식은 관리자 수동 백업입니다. 자동 백업은 복원 직전 안전 백업이나 서버
                  크론으로 분리하는 것이 안전하며, 관리자 화면에서 상시 자동 실행하면 비용과
                  개인정보 중복 보관 위험이 커집니다.
                </p>
                <div className="mt-4 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm font-bold leading-6 text-amber-900 break-keep">
                  복원은 선택한 백업 문서를 원래 경로에 되돌립니다. 현재 DB에만 있는 문서는
                  삭제하지 않습니다. 운영 복원 전에는 반드시 현재 상태를 먼저 백업해 주세요.
                </div>
              </div>

              {dbBackupError && (
                <div className="rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm font-black text-red-700">
                  {dbBackupError}
                </div>
              )}

              <div className="grid grid-cols-1 gap-4 xl:grid-cols-2">
                <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
                  <div className="flex items-start justify-between gap-3">
                    <div>
                      <p className="text-xs font-black uppercase tracking-[0.16em] text-slate-400">
                        Backup
                      </p>
                      <h4 className="mt-2 text-lg font-black text-slate-950">
                        현재 DB 상태 백업
                      </h4>
                    </div>
                    <span className="rounded-full bg-slate-100 px-3 py-1 text-[11px] font-black text-slate-600">
                      {new Date().toLocaleString("ko-KR")}
                    </span>
                  </div>
                  <label className="mt-4 block text-sm font-black text-slate-700">
                    백업 요약 설명
                  </label>
                  <input
                    value={dbBackupSummary}
                    onChange={(event) => setDbBackupSummary(event.target.value)}
                    placeholder="예: 거래처 관리 수정 전 전체 백업"
                    className="mt-2 w-full rounded-2xl border border-slate-200 px-4 py-3 text-sm font-bold outline-none focus:border-indigo-400"
                  />
                  <label className="mt-4 block text-sm font-black text-slate-700">
                    상세 메모
                  </label>
                  <textarea
                    value={dbBackupDescription}
                    onChange={(event) => setDbBackupDescription(event.target.value)}
                    placeholder="현재 데이터 상태나 작업 전후 상황을 적어 주세요."
                    className="mt-2 min-h-[92px] w-full rounded-2xl border border-slate-200 px-4 py-3 text-sm font-bold outline-none focus:border-indigo-400"
                  />
                  <div className="mt-4 grid grid-cols-2 gap-2">
                    {["FULL", "PARTIAL"].map((scope) => (
                      <button
                        key={scope}
                        type="button"
                        onClick={() => setDbBackupScope(scope as "FULL" | "PARTIAL")}
                        className={`rounded-2xl border px-3 py-3 text-sm font-black ${
                          dbBackupScope === scope
                            ? "border-indigo-500 bg-indigo-50 text-indigo-700"
                            : "border-slate-200 bg-white text-slate-600"
                        }`}
                      >
                        {scope === "FULL" ? "전체 백업" : "부분 백업"}
                      </button>
                    ))}
                  </div>
                  {dbBackupScope === "PARTIAL" && (
                    <div className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-2">
                      {DB_BACKUP_DATASET_OPTIONS.map((dataset) => (
                        <label
                          key={dataset.key}
                          className="flex gap-3 rounded-2xl border border-slate-200 bg-slate-50 p-3"
                        >
                          <input
                            type="checkbox"
                            checked={dbBackupSelectedDatasetKeys.includes(dataset.key)}
                            onChange={() =>
                              toggleDbBackupDatasetKey(
                                dataset.key,
                                dbBackupSelectedDatasetKeys,
                                setDbBackupSelectedDatasetKeys
                              )
                            }
                            className="mt-1"
                          />
                          <span>
                            <span className="block text-sm font-black text-slate-900">
                              {dataset.label}
                            </span>
                            <span className="mt-1 block text-[11px] font-bold text-slate-500">
                              {dataset.description}
                            </span>
                          </span>
                        </label>
                      ))}
                    </div>
                  )}
                  <button
                    type="button"
                    onClick={handleCreateDbBackup}
                    disabled={dbBackupCreating || dbBackupLoading}
                    className="mt-5 inline-flex min-h-[50px] w-full items-center justify-center gap-2 rounded-2xl bg-indigo-700 px-4 py-3 text-sm font-black text-white shadow-sm disabled:bg-slate-300 disabled:text-slate-500"
                  >
                    {dbBackupCreating && <Loader2 className="h-5 w-5 animate-spin" />}
                    DB 백업 실행
                  </button>
                </div>

                <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
                  <div className="flex items-start justify-between gap-3">
                    <div>
                      <p className="text-xs font-black uppercase tracking-[0.16em] text-slate-400">
                        Restore
                      </p>
                      <h4 className="mt-2 text-lg font-black text-slate-950">
                        백업에서 복원
                      </h4>
                    </div>
                    <button
                      type="button"
                      onClick={loadDbBackups}
                      disabled={dbBackupLoading}
                      className="rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-xs font-black text-slate-600 disabled:opacity-60"
                    >
                      목록 새로고침
                    </button>
                  </div>
                  <label className="mt-4 block text-sm font-black text-slate-700">
                    복원할 백업
                  </label>
                  <select
                    value={dbRestoreSelectedBackupId}
                    onChange={(event) => {
                      setDbRestoreSelectedBackupId(event.target.value);
                      setDbRestorePreview(null);
                    }}
                    className="mt-2 w-full rounded-2xl border border-slate-200 px-4 py-3 text-sm font-bold outline-none focus:border-indigo-400"
                  >
                    <option value="">백업을 선택해 주세요</option>
                    {dbBackups.map((backup) => (
                      <option key={backup.backupId || backup.id} value={backup.backupId || backup.id}>
                        {backup.createdAt || "-"} · {backup.summary || "설명 없음"} ·{" "}
                        {backup.itemCount || 0}건
                      </option>
                    ))}
                  </select>
                  <div className="mt-4 grid grid-cols-2 gap-2">
                    {["FULL", "PARTIAL"].map((scope) => (
                      <button
                        key={scope}
                        type="button"
                        onClick={() => setDbRestoreScope(scope as "FULL" | "PARTIAL")}
                        className={`rounded-2xl border px-3 py-3 text-sm font-black ${
                          dbRestoreScope === scope
                            ? "border-indigo-500 bg-indigo-50 text-indigo-700"
                            : "border-slate-200 bg-white text-slate-600"
                        }`}
                      >
                        {scope === "FULL" ? "전체 복원" : "부분 복원"}
                      </button>
                    ))}
                  </div>
                  {dbRestoreScope === "PARTIAL" && (
                    <div className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-2">
                      {DB_BACKUP_DATASET_OPTIONS.map((dataset) => (
                        <label
                          key={dataset.key}
                          className="flex gap-3 rounded-2xl border border-slate-200 bg-slate-50 p-3"
                        >
                          <input
                            type="checkbox"
                            checked={dbRestoreSelectedDatasetKeys.includes(dataset.key)}
                            onChange={() =>
                              toggleDbBackupDatasetKey(
                                dataset.key,
                                dbRestoreSelectedDatasetKeys,
                                setDbRestoreSelectedDatasetKeys
                              )
                            }
                            className="mt-1"
                          />
                          <span>
                            <span className="block text-sm font-black text-slate-900">
                              {dataset.label}
                            </span>
                            <span className="mt-1 block text-[11px] font-bold text-slate-500">
                              {dataset.description}
                            </span>
                          </span>
                        </label>
                      ))}
                    </div>
                  )}
                  <div className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-2">
                    <button
                      type="button"
                      onClick={handlePreviewDbRestore}
                      disabled={dbRestoreLoading || !dbRestoreSelectedBackupId}
                      className="min-h-[46px] rounded-2xl border border-indigo-200 bg-indigo-50 px-4 py-3 text-sm font-black text-indigo-700 disabled:bg-slate-100 disabled:text-slate-400"
                    >
                      {dbRestoreLoading ? "미리보기 중..." : "복원 미리보기"}
                    </button>
                    <div className="rounded-2xl bg-slate-50 px-4 py-3 text-sm font-black text-slate-700">
                      대상 문서: {dbRestorePreview?.itemCount ?? "-"}건
                    </div>
                  </div>
                  {dbRestorePreview?.datasetCounts && (
                    <div className="mt-3 rounded-2xl bg-slate-50 p-3 text-xs font-bold text-slate-600">
                      {Object.entries(dbRestorePreview.datasetCounts)
                        .map(([key, count]) => `${key}: ${count}`)
                        .join(" · ")}
                    </div>
                  )}
                  <label className="mt-4 block text-sm font-black text-slate-700">
                    복원 사유
                  </label>
                  <textarea
                    value={dbRestoreReason}
                    onChange={(event) => setDbRestoreReason(event.target.value)}
                    placeholder="예: 잘못 수정된 거래처 마스터를 백업 시점으로 복구"
                    className="mt-2 min-h-[74px] w-full rounded-2xl border border-slate-200 px-4 py-3 text-sm font-bold outline-none focus:border-indigo-400"
                  />
                  <label className="mt-4 block text-sm font-black text-slate-700">
                    확인 문구
                  </label>
                  <input
                    value={dbRestoreConfirmText}
                    onChange={(event) => setDbRestoreConfirmText(event.target.value)}
                    placeholder="복원 실행"
                    className="mt-2 w-full rounded-2xl border border-slate-200 px-4 py-3 text-sm font-bold outline-none focus:border-red-400"
                  />
                  <button
                    type="button"
                    onClick={handleApplyDbRestore}
                    disabled={dbRestoreApplying || !dbRestoreSelectedBackupId}
                    className="mt-5 inline-flex min-h-[50px] w-full items-center justify-center gap-2 rounded-2xl bg-red-700 px-4 py-3 text-sm font-black text-white shadow-sm disabled:bg-slate-300 disabled:text-slate-500"
                  >
                    {dbRestoreApplying && <Loader2 className="h-5 w-5 animate-spin" />}
                    선택 백업 복원
                  </button>
                </div>
              </div>

              <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
                <h4 className="text-lg font-black text-slate-950">최근 백업 목록</h4>
                <div className="mt-3 space-y-2">
                  {dbBackupLoading ? (
                    <div className="rounded-2xl bg-slate-50 p-4 text-sm font-black text-slate-500">
                      백업 목록을 불러오는 중입니다.
                    </div>
                  ) : dbBackups.length === 0 ? (
                    <div className="rounded-2xl bg-slate-50 p-4 text-sm font-black text-slate-500">
                      아직 생성된 백업이 없습니다.
                    </div>
                  ) : (
                    dbBackups.map((backup) => (
                      <button
                        key={backup.backupId || backup.id}
                        type="button"
                        onClick={() => {
                          setDbRestoreSelectedBackupId(backup.backupId || backup.id || "");
                          setDbRestorePreview(null);
                        }}
                        className="w-full rounded-2xl border border-slate-200 bg-slate-50 p-4 text-left hover:border-indigo-200 hover:bg-indigo-50"
                      >
                        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                          <div>
                            <p className="text-sm font-black text-slate-950">
                              {backup.summary || "설명 없음"}
                            </p>
                            <p className="mt-1 text-xs font-bold text-slate-500">
                              {backup.createdAt || "-"} · {backup.createdBy || "관리자"}
                            </p>
                          </div>
                          <span className="rounded-full bg-white px-3 py-1 text-xs font-black text-slate-700">
                            {backup.scope || "FULL"} · {backup.itemCount || 0}건
                          </span>
                        </div>
                      </button>
                    ))
                  )}
                </div>
              </div>
            </div>
          ) : adminTab === "SALES_SEARCH" ? (
            <div className="animate-in fade-in space-y-4">
              <div className="rounded-2xl border border-blue-100 bg-blue-50 p-5">
                <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
                  <div>
                    <p className="text-xs font-black uppercase tracking-[0.18em] text-blue-600">
                      Contract Status Search
                    </p>
                    <h3 className="mt-2 text-xl font-black text-blue-950">
                      거래처 계약 현황
                    </h3>
                    <p className="mt-2 text-sm font-bold leading-6 text-blue-900 break-keep">
                      {isHeadquarters()
                        ? "본사는 전체 계약의 기본 현황을 검색할 수 있습니다."
                        : "계약 작성 여부와 기본 정보를 민감정보 없이 확인할 수 있습니다."}
                    </p>
                    <div className="mt-3 flex flex-wrap gap-2 text-xs font-black text-blue-900">
                      <span className="rounded-full bg-white/80 px-3 py-1">
                        기간: {salesSearchFilterSummary.periodLabel}
                      </span>
                      <span className="rounded-full bg-white/80 px-3 py-1">
                        상태: {salesSearchFilterSummary.statusLabel}
                      </span>
                    </div>
                  </div>
                  <div className="rounded-2xl bg-white/80 px-4 py-3 text-center">
                    <p className="text-xs font-bold text-blue-500">조회 결과</p>
                    <p className="mt-1 text-2xl font-black text-blue-950">
                      {salesContractSearchResults.length}
                    </p>
                    <p className="mt-1 text-[11px] font-black leading-4 text-blue-700">
                      전체 {salesContractSearchTotal}건
                    </p>
                    {salesContractSearchMeta.hasMore && (
                      <p className="mt-1 text-[11px] font-black leading-4 text-amber-700">
                        일부만 표시 중: {salesContractSearchMeta.returned}/
                        {salesContractSearchTotal}건
                      </p>
                    )}
                    {isSalesSearchDateRangeActive && (
                      <button
                        type="button"
                        onClick={clearSalesContractSearchDateRange}
                        disabled={salesContractSearchLoading}
                        className="mt-2 rounded-full border border-blue-200 bg-white px-3 py-1.5 text-[11px] font-black text-blue-700 disabled:opacity-60"
                      >
                        전체 기간으로 보기
                      </button>
                    )}
                    {isSalesSearchFilterActive && (
                      <button
                        type="button"
                        onClick={resetSalesContractSearchFilters}
                        disabled={salesContractSearchLoading}
                        className="mt-2 rounded-full border border-slate-200 bg-white px-3 py-1.5 text-[11px] font-black text-slate-700 disabled:opacity-60"
                      >
                        필터 초기화
                      </button>
                    )}
                    <button
                      type="button"
                      onClick={() =>
                        downloadSafeContractRowsAsXlsx(
                          salesContractSearchResults,
                          "cnfood_contract_sales_lookup"
                        )
                      }
                      disabled={salesContractSearchLoading}
                      className="mt-2 inline-flex min-h-[36px] items-center justify-center gap-1 rounded-full border border-blue-200 bg-white px-3 py-1.5 text-[11px] font-black text-blue-700 disabled:opacity-60"
                    >
                      <Download className="h-3.5 w-3.5" />
                      엑셀 다운로드
                    </button>
                  </div>
                </div>
              </div>

              <div className="rounded-2xl border border-slate-200 bg-white p-4">
                <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
                  <label className="block">
                    <span className="mb-1 block text-sm font-black text-slate-700">
                      상호명
                    </span>
                    <input
                      value={salesContractSearchForm.keyword}
                      onChange={(event) =>
                        updateSalesContractSearchForm({ keyword: event.target.value })
                      }
                      className="min-h-[48px] w-full rounded-xl border border-slate-200 px-3 text-base font-bold outline-none focus:border-blue-500"
                      placeholder="예: 명가"
                    />
                  </label>
                  <label className="block">
                    <span className="mb-1 block text-sm font-black text-slate-700">
                      사업자번호
                    </span>
                    <input
                      value={salesContractSearchForm.businessNumber}
                      onChange={(event) =>
                        updateSalesContractSearchForm({
                          businessNumber: event.target.value,
                        })
                      }
                      inputMode="numeric"
                      className="min-h-[48px] w-full rounded-xl border border-slate-200 px-3 text-base font-bold outline-none focus:border-blue-500"
                      placeholder="790-18-01859"
                    />
                  </label>
                  <label className="block">
                    <span className="mb-1 block text-sm font-black text-slate-700">
                      대표자명
                    </span>
                    <input
                      value={salesContractSearchForm.representativeName}
                      onChange={(event) =>
                        updateSalesContractSearchForm({
                          representativeName: event.target.value,
                        })
                      }
                      className="min-h-[48px] w-full rounded-xl border border-slate-200 px-3 text-base font-bold outline-none focus:border-blue-500"
                      placeholder="대표자명"
                    />
                  </label>
                  <label className="block">
                    <span className="mb-1 block text-sm font-black text-slate-700">
                      주소
                    </span>
                    <input
                      value={salesContractSearchForm.addressKeyword}
                      onChange={(event) =>
                        updateSalesContractSearchForm({
                          addressKeyword: event.target.value,
                        })
                      }
                      className="min-h-[48px] w-full rounded-xl border border-slate-200 px-3 text-base font-bold outline-none focus:border-blue-500"
                      placeholder="사업장 주소"
                    />
                  </label>
                  <label className="block">
                    <span className="mb-1 block text-sm font-black text-slate-700">
                      시작일
                    </span>
                    <input
                      type="date"
                      value={salesContractSearchForm.dateFrom}
                      onChange={(event) =>
                        updateSalesContractSearchForm({ dateFrom: event.target.value })
                      }
                      className="min-h-[48px] w-full rounded-xl border border-slate-200 px-3 text-base font-bold outline-none focus:border-blue-500"
                    />
                  </label>
                  <label className="block">
                    <span className="mb-1 block text-sm font-black text-slate-700">
                      종료일
                    </span>
                    <input
                      type="date"
                      value={salesContractSearchForm.dateTo}
                      onChange={(event) =>
                        updateSalesContractSearchForm({ dateTo: event.target.value })
                      }
                      className="min-h-[48px] w-full rounded-xl border border-slate-200 px-3 text-base font-bold outline-none focus:border-blue-500"
                    />
                  </label>
                  <label className="block">
                    <span className="mb-1 block text-sm font-black text-slate-700">
                      계약 상태
                    </span>
                    <select
                      value={salesContractSearchForm.status}
                      onChange={(event) =>
                        updateSalesContractSearchForm({ status: event.target.value })
                      }
                      className="min-h-[48px] w-full rounded-xl border border-slate-200 px-3 text-base font-bold outline-none focus:border-blue-500"
                    >
                      {SALES_CONTRACT_STATUS_OPTIONS.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </label>
                  <label className="block">
                    <span className="mb-1 block text-sm font-black text-slate-700">
                      담당사업장
                    </span>
                    <select
                      value={salesContractSearchForm.companyBranchId}
                      onChange={(event) =>
                        updateSalesContractSearchForm({
                          companyBranchId: event.target.value,
                        })
                      }
                      className="min-h-[48px] w-full rounded-xl border border-slate-200 px-3 text-base font-bold outline-none focus:border-blue-500"
                    >
                      <option value="">전체 사업장</option>
                      {companyBranches.map((branch) => (
                        <option key={branch.branchId || branch.id} value={branch.branchId || branch.id}>
                          {branch.branchName}
                        </option>
                      ))}
                    </select>
                  </label>
                </div>
                <button
                  type="button"
                  onClick={() => loadSalesContractSearch()}
                  disabled={salesContractSearchLoading}
                  className="mt-4 flex min-h-[52px] w-full items-center justify-center gap-2 rounded-2xl bg-blue-700 px-4 py-3 text-base font-black text-white shadow-sm disabled:bg-slate-300"
                >
                  {salesContractSearchLoading ? (
                    <Loader2 className="h-5 w-5 animate-spin" />
                  ) : (
                    <Search className="h-5 w-5" />
                  )}
                  조회하기
                </button>
                {salesContractSearchError && (
                  <div className="mt-3 rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-base font-bold leading-7 text-red-700 break-keep">
                    {salesContractSearchError}
                  </div>
                )}
              </div>

              {salesContractSearchResults.length === 0 ? (
                <div className="rounded-2xl border border-dashed border-slate-200 bg-slate-50 px-5 py-8 text-center">
                  <FileText className="mx-auto mb-3 h-8 w-8 text-slate-300" />
                  <p className="font-black text-slate-700">
                    조회된 계약이 없습니다.
                  </p>
                  <p className="mt-2 text-sm font-bold leading-6 text-slate-500 break-keep">
                    상호명, 사업자번호, 대표자명 또는 기간을 다시 확인해 주세요.
                  </p>
                </div>
              ) : (
                <div className="grid grid-cols-1 gap-3 xl:grid-cols-2">
                  {salesContractSearchResults.map((contract) => (
                    <div
                      key={contract.documentId || contract.contractId}
                      className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm"
                    >
                      <div className="flex items-start justify-between gap-3">
                        <div className="min-w-0">
                          <p className="break-keep text-lg font-black text-slate-900">
                            {contract.businessName || "상호명 미수집"}
                          </p>
                          <p className="mt-1 text-sm font-bold text-slate-500">
                            {contract.businessNumber || "사업자번호 미수집"}
                          </p>
                          <p className="mt-2 break-words text-sm font-bold leading-6 text-slate-600">
                            주소: {contract.address || "주소 미입력"}
                          </p>
                        </div>
                        <div className="flex shrink-0 flex-col items-end gap-2">
                          <span className="rounded-full bg-blue-50 px-3 py-1 text-xs font-black text-blue-700">
                            {contract.statusLabel}
                          </span>
                          {contract.isUnassigned && (
                            <span className="rounded-full bg-amber-50 px-3 py-1 text-xs font-black text-amber-700">
                              담당자 미지정
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="mt-4 grid grid-cols-1 gap-2 text-sm font-bold text-slate-700 sm:grid-cols-2">
                        <div>
                          <span className="text-slate-400">대표자</span>
                          <p>{contract.representativeName || "미수집"}</p>
                        </div>
                        <div>
                          <span className="text-slate-400">담당 영업사원</span>
                          <p
                            className={
                              contract.isUnassigned ? "text-amber-700" : "text-slate-700"
                            }
                          >
                            {contract.assignmentStatusLabel ||
                              contract.managerName ||
                              "담당자 미지정"}
                          </p>
                          {contract.isUnassigned && !showSalesAssignmentControls && (
                            <p className="mt-1 text-xs font-black leading-5 text-amber-700 break-keep">
                              본사/미수팀 담당자 지정 필요
                            </p>
                          )}
                        </div>
                        <div>
                          <span className="text-slate-400">제출일자</span>
                          <p>{formatAdminUpdatedAt(contract.submittedAt)}</p>
                        </div>
                        <div>
                          <span className="text-slate-400">완료일자</span>
                          <p>{formatAdminUpdatedAt(contract.completedAt)}</p>
                        </div>
                        <div>
                          <span className="text-slate-400">연락처</span>
                          <p>{contract.contactPhone || "미수집"}</p>
                        </div>
                        <div>
                          <span className="text-slate-400">공동계약인</span>
                          <p>{contract.coRepresentativeDisplayStatus}</p>
                          {contract.coRepresentative && (
                            <p className="mt-1 text-xs font-black leading-5 text-amber-700 break-keep">
                              공동계약인 {contract.coRepresentativeCompletedCount}/
                              {contract.coRepresentativeTotalCount} 완료 ·{" "}
                              {contract.coRepresentativeNextAction}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="mt-3 flex flex-wrap gap-2">
                        {contract.confirmed && (
                          <span className="rounded-full bg-emerald-50 px-2 py-1 text-xs font-black text-emerald-700">
                            확정
                          </span>
                        )}
                        {contract.rejected && (
                          <span className="rounded-full bg-red-50 px-2 py-1 text-xs font-black text-red-700">
                            반려
                          </span>
                        )}
                        {contract.businessNameCorrected && (
                          <span className="rounded-full bg-amber-50 px-2 py-1 text-xs font-black text-amber-700">
                            상호명 정정됨
                          </span>
                        )}
                      </div>
                      {showSalesAssignmentControls && (
                        <button
                          type="button"
                          onClick={() => openSalesAssignmentModal(contract)}
                          className="mt-4 inline-flex min-h-[44px] w-full items-center justify-center rounded-2xl bg-slate-900 px-4 py-2 text-sm font-black text-white shadow-sm transition hover:bg-slate-800 sm:w-auto"
                        >
                          {contract.isUnassigned ? "담당자 지정" : "담당자 변경"}
                        </button>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ) : adminTab === "STATS" ? (
            <div className="animate-in fade-in">
              <AdminIntegratedDashboard
                contracts={contractList}
                payments={paymentRequests}
                paymentMeta={paymentRequestsMeta}
                paymentLoading={paymentRequestsLoading}
                paymentError={paymentRequestsError}
                onPaymentRangeChange={(range) => {
                  const nextRange = getDashboardPaymentLoadRange(range);
                  setDashboardPaymentRange((current) =>
                    current.dateFrom === nextRange.dateFrom &&
                    current.dateTo === nextRange.dateTo
                      ? current
                      : nextRange
                  );
                }}
                onReloadPayments={() =>
                  void loadPaymentRequests({
                    dateFrom: dashboardPaymentRange.dateFrom,
                    dateTo: dashboardPaymentRange.dateTo,
                  })
                }
                onOpenContractList={() => setAdminTab("LIST")}
                onOpenPaymentList={() => {
                  setAdminTab("PAYMENT_MANAGEMENT");
                  void loadPaymentRequests();
                }}
              />
            </div>
          ) : adminTab === "LEGACY_ARCHIVE" ? (
            <div className="animate-in fade-in space-y-4">
              <div className="rounded-2xl border border-amber-100 bg-amber-50 p-5">
                <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
                  <div>
                    <p className="text-xs font-black uppercase tracking-[0.18em] text-amber-700">
                      Legacy Manual Archive
                    </p>
                    <h3 className="mt-2 text-xl font-black text-amber-950">
                      기존 거래처 계약/증빙 관리
                    </h3>
                    <p className="mt-2 max-w-3xl break-keep text-sm font-bold leading-6 text-amber-900">
                      ERP/수기 계약 자료를 전자계약과 분리된 legacyContracts에 보관합니다.
                      기존계약은 본인확인, 전자서명, Hash 증빙이 없는 수기증빙 자료로 표시됩니다.
                    </p>
                  </div>
                  <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
                    <button
                      type="button"
                      onClick={downloadLegacyExcelTemplate}
                      className="rounded-2xl bg-white px-4 py-3 text-sm font-black text-amber-800 shadow-sm"
                    >
                      기존 계약 엑셀 양식 다운로드
                    </button>
                    <label className="flex cursor-pointer items-center justify-center rounded-2xl bg-amber-700 px-4 py-3 text-sm font-black text-white shadow-sm">
                      기존 계약 엑셀 업로드
                      <input
                        type="file"
                        accept=".xlsx,.xls"
                        onChange={handleLegacyExcelFileChange}
                        className="hidden"
                      />
                    </label>
                    <button
                      type="button"
                      onClick={loadLegacyContracts}
                      disabled={legacyContractsLoading}
                      className="rounded-2xl bg-slate-900 px-4 py-3 text-sm font-black text-white shadow-sm disabled:opacity-60"
                    >
                      {legacyContractsLoading ? "불러오는 중..." : "기존 계약 다시 불러오기"}
                    </button>
                  </div>
                </div>
                <div className="mt-4 grid grid-cols-1 gap-2 text-xs font-black text-amber-900 sm:grid-cols-4">
                  <span className="rounded-full bg-white/80 px-3 py-2">
                    기존계약 {legacyContractRows.length}건
                  </span>
                  <span className="rounded-full bg-white/80 px-3 py-2">
                    증빙수준: 수기증빙
                  </span>
                  <span className="rounded-full bg-white/80 px-3 py-2">
                    본인확인 없음
                  </span>
                  <span className="rounded-full bg-white/80 px-3 py-2">
                    전자서명/Hash 없음
                  </span>
                </div>
              </div>

              {legacyContractsError && (
                <div className="rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm font-bold leading-6 text-red-700">
                  {legacyContractsError}
                </div>
              )}

              {legacyImportPreview && (
                <div className="rounded-2xl border border-slate-200 bg-white p-4">
                  <div className="mb-3 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                    <div>
                      <h4 className="text-base font-black text-slate-900">
                        엑셀 업로드 미리보기
                      </h4>
                      <p className="mt-1 text-sm font-bold text-slate-500">
                        등록 가능 {legacyImportPreview.readyCount}건 / 중복 {legacyImportPreview.duplicateCount}건 / 오류 {legacyImportPreview.errorCount}건
                      </p>
                    </div>
                    <button
                      type="button"
                      onClick={applyLegacyImport}
                      disabled={
                        legacyImportApplying || legacyImportPreview.readyCount < 1
                      }
                      className="rounded-2xl bg-emerald-700 px-4 py-3 text-sm font-black text-white disabled:opacity-50"
                    >
                      {legacyImportApplying ? "등록 중..." : "최종 등록"}
                    </button>
                  </div>
                  <div className="max-h-[420px] space-y-2 overflow-y-auto">
                    {legacyImportPreview.rows.map((row, index) => (
                      <div
                        key={`${row.rowNumber}-${index}`}
                        className="rounded-2xl border border-slate-100 bg-slate-50 p-3"
                      >
                        <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
                          <span
                            className={`rounded-full px-2 py-1 text-[11px] font-black ${
                              row.status === "READY"
                                ? "bg-emerald-100 text-emerald-700"
                                : row.status === "DUPLICATE"
                                ? "bg-amber-100 text-amber-700"
                                : "bg-red-100 text-red-700"
                            }`}
                          >
                            {row.status}
                          </span>
                          <button
                            type="button"
                            onClick={() => removeLegacyPreviewRow(index)}
                            className="rounded-full bg-white px-3 py-1 text-xs font-black text-slate-600"
                          >
                            행 삭제
                          </button>
                        </div>
                        <div className="grid grid-cols-1 gap-2 md:grid-cols-3">
                          {LEGACY_CONTRACT_TEMPLATE_COLUMNS.map((column) => (
                            <label key={column} className="block">
                              <span className="mb-1 block text-[11px] font-black text-slate-500">
                                {column}
                              </span>
                              <input
                                value={legacyImportRows[index]?.[column] || ""}
                                onChange={(event) =>
                                  updateLegacyPreviewRow(index, {
                                    [column]: event.target.value,
                                  })
                                }
                                className="min-h-[38px] w-full rounded-xl border border-slate-200 bg-white px-3 text-sm font-bold"
                              />
                            </label>
                          ))}
                        </div>
                        {row.errors?.length > 0 && (
                          <p className="mt-2 text-xs font-bold leading-5 text-red-700">
                            {row.errors.join(" / ")}
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="grid grid-cols-1 gap-4 xl:grid-cols-[minmax(0,1fr)_420px]">
                <div className="rounded-2xl border border-slate-200 bg-white p-4">
                  <div className="mb-3 flex items-center justify-between">
                    <h4 className="text-base font-black text-slate-900">
                      기존 계약 목록
                    </h4>
                    <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-black text-slate-600">
                      {legacyContractRows.length}건
                    </span>
                  </div>
                  {legacyContractRows.length === 0 ? (
                    <div className="rounded-2xl border border-dashed border-slate-200 bg-slate-50 px-5 py-10 text-center">
                      <FileText className="mx-auto mb-3 h-8 w-8 text-slate-300" />
                      <p className="font-black text-slate-700">
                        등록된 기존 계약 자료가 없습니다.
                      </p>
                    </div>
                  ) : (
                    <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">
                      {legacyContractRows.map((contract) => (
                        <button
                          key={contract.legacyId}
                          type="button"
                          onClick={() => openLegacyContractDetail(contract)}
                          className="rounded-2xl border border-slate-200 p-4 text-left transition hover:bg-slate-50"
                        >
                          <div className="flex items-start justify-between gap-3">
                            <div className="min-w-0">
                              <p className="break-words text-lg font-black text-slate-900">
                                {contract.businessName}
                              </p>
                              <p className="mt-1 text-sm font-bold text-slate-500">
                                {contract.businessNumber || "사업자번호 미수집"} · {contract.representativeName}
                              </p>
                            </div>
                            <span className="shrink-0 rounded-full bg-amber-100 px-3 py-1 text-xs font-black text-amber-700">
                              기존계약
                            </span>
                          </div>
                          <p className="mt-2 break-words text-sm font-bold leading-6 text-slate-600">
                            주소: {contract.address}
                          </p>
                          <div className="mt-3 flex flex-wrap gap-2 text-xs font-black">
                            <span className="rounded-full bg-slate-100 px-2 py-1 text-slate-600">
                              {contract.contractStatusLabel}
                            </span>
                            <span className="rounded-full bg-slate-100 px-2 py-1 text-slate-600">
                              담당: {contract.salesRepName}
                            </span>
                            <span className="rounded-full bg-slate-100 px-2 py-1 text-slate-600">
                              문서 {contract.documentsCount}건
                            </span>
                          </div>
                        </button>
                      ))}
                    </div>
                  )}
                </div>

                <div className="rounded-2xl border border-slate-200 bg-white p-4">
                  {selectedLegacyContract ? (
                    <div className="space-y-4">
                      <div>
                        <h4 className="break-words text-lg font-black text-slate-900">
                          {selectedLegacyContract.businessName}
                        </h4>
                        <p className="mt-2 rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm font-bold leading-6 text-amber-900 break-keep">
                          기존 수기계약 자료입니다. 본인확인/전자서명/Hash 증빙은 포함되지 않습니다.
                        </p>
                      </div>
                      <div className="space-y-2 rounded-2xl bg-slate-50 p-4 text-sm font-bold text-slate-700">
                        {[
                          ["사업자번호", selectedLegacyContract.businessNumber],
                          ["대표자", selectedLegacyContract.representativeName],
                          ["연락처", selectedLegacyContract.phone],
                          ["주소", selectedLegacyContract.address],
                          ["담당사업장", selectedLegacyContract.companyBranchName],
                          ["담당자", selectedLegacyContract.salesRepName],
                          ["계약일자", selectedLegacyContract.contractDate],
                          ["상태", selectedLegacyContract.contractStatus],
                          ["메모", selectedLegacyContract.memo],
                        ].map(([label, value]) => (
                          <div key={label} className="flex justify-between gap-3 border-b border-slate-200 pb-2 last:border-b-0">
                            <span className="shrink-0 text-slate-400">{label}</span>
                            <span className="min-w-0 break-words text-right">
                              {value || "미수집"}
                            </span>
                          </div>
                        ))}
                      </div>

                      <div className="rounded-2xl border border-slate-200 p-3">
                        <h5 className="mb-2 text-sm font-black text-slate-900">
                          문서 등록
                        </h5>
                        <div className="grid grid-cols-1 gap-2">
                          <select
                            value={legacyDocumentDraft.documentType}
                            onChange={(event) =>
                              setLegacyDocumentDraft((prev) => ({
                                ...prev,
                                documentType: event.target.value,
                              }))
                            }
                            className="min-h-[44px] rounded-xl border border-slate-200 px-3 text-sm font-bold"
                          >
                            {LEGACY_DOCUMENT_TYPE_OPTIONS.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                          <input
                            value={legacyDocumentDraft.title}
                            onChange={(event) =>
                              setLegacyDocumentDraft((prev) => ({
                                ...prev,
                                title: event.target.value,
                              }))
                            }
                            placeholder="문서 제목"
                            className="min-h-[44px] rounded-xl border border-slate-200 px-3 text-sm font-bold"
                          />
                          <textarea
                            value={legacyDocumentDraft.description}
                            onChange={(event) =>
                              setLegacyDocumentDraft((prev) => ({
                                ...prev,
                                description: event.target.value,
                              }))
                            }
                            placeholder="문서 메모"
                            rows={2}
                            className="rounded-xl border border-slate-200 px-3 py-2 text-sm font-bold"
                          />
                          <label className="flex min-h-[48px] cursor-pointer items-center justify-center rounded-2xl bg-slate-900 px-4 py-3 text-sm font-black text-white">
                            {legacyDocumentUploading ? "업로드 중..." : "이미지/PDF 여러 장 업로드"}
                            <input
                              type="file"
                              multiple
                              accept="image/jpeg,image/png,image/webp,application/pdf"
                              onChange={uploadLegacyDocuments}
                              className="hidden"
                              disabled={legacyDocumentUploading}
                            />
                          </label>
                        </div>
                      </div>

                      <div className="rounded-2xl border border-slate-200 p-3">
                        <h5 className="mb-2 text-sm font-black text-slate-900">
                          등록 문서
                        </h5>
                        <div className="space-y-2">
                          {legacyDocuments.length === 0 ? (
                            <p className="text-sm font-bold text-slate-400">
                              등록된 문서가 없습니다.
                            </p>
                          ) : (
                            legacyDocuments.map((document) => (
                              <div
                                key={document.id || document.documentId || document.storagePath}
                                className="rounded-xl border border-slate-100 p-3"
                              >
                                {String(document.mimeType || "").startsWith("image/") ? (
                                  <a href={document.fileUrl} target="_blank" rel="noreferrer">
                                    <img
                                      src={document.fileUrl}
                                      alt={document.title || document.fileName}
                                      className="mb-2 max-h-36 w-full rounded-xl object-cover"
                                    />
                                  </a>
                                ) : (
                                  <a
                                    href={document.fileUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="mb-2 inline-flex rounded-full bg-slate-100 px-3 py-1 text-xs font-black text-slate-700"
                                  >
                                    PDF 열기
                                  </a>
                                )}
                                <p className="break-words text-sm font-black text-slate-900">
                                  {document.title || document.fileName}
                                </p>
                                <p className="mt-1 break-words text-xs font-bold text-slate-500">
                                  {document.description}
                                </p>
                                <button
                                  type="button"
                                  onClick={() =>
                                    softDeleteLegacyDocument(
                                      document.id || document.documentId
                                    )
                                  }
                                  className="mt-2 rounded-full bg-slate-100 px-3 py-1 text-xs font-black text-slate-600"
                                >
                                  숨김 처리
                                </button>
                              </div>
                            ))
                          )}
                        </div>
                      </div>

                      <div className="rounded-2xl border border-slate-200 p-3">
                        <h5 className="mb-2 text-sm font-black text-slate-900">
                          히스토리
                        </h5>
                        <div className="grid grid-cols-1 gap-2">
                          <select
                            value={legacyHistoryDraft.type}
                            onChange={(event) =>
                              setLegacyHistoryDraft((prev) => ({
                                ...prev,
                                type: event.target.value,
                              }))
                            }
                            className="min-h-[44px] rounded-xl border border-slate-200 px-3 text-sm font-bold"
                          >
                            {LEGACY_HISTORY_TYPE_OPTIONS.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                          <input
                            value={legacyHistoryDraft.title}
                            onChange={(event) =>
                              setLegacyHistoryDraft((prev) => ({
                                ...prev,
                                title: event.target.value,
                              }))
                            }
                            placeholder="제목"
                            className="min-h-[44px] rounded-xl border border-slate-200 px-3 text-sm font-bold"
                          />
                          <textarea
                            value={legacyHistoryDraft.body}
                            onChange={(event) =>
                              setLegacyHistoryDraft((prev) => ({
                                ...prev,
                                body: event.target.value,
                              }))
                            }
                            placeholder="내용"
                            rows={3}
                            className="rounded-xl border border-slate-200 px-3 py-2 text-sm font-bold"
                          />
                          <button
                            type="button"
                            onClick={addLegacyHistory}
                            disabled={legacyHistorySaving}
                            className="min-h-[44px] rounded-2xl bg-amber-700 px-4 py-2 text-sm font-black text-white disabled:opacity-60"
                          >
                            {legacyHistorySaving ? "저장 중..." : "히스토리 추가"}
                          </button>
                        </div>
                        <div className="mt-3 space-y-2">
                          {legacyHistory
                            .slice()
                            .reverse()
                            .map((history) => (
                              <div
                                key={history.id || history.historyId || history.createdAt}
                                className="rounded-xl bg-slate-50 p-3"
                              >
                                <div className="mb-1 flex justify-between gap-2">
                                  <span className="rounded-full bg-white px-2 py-1 text-[11px] font-black text-slate-600">
                                    {history.type || "NOTE"}
                                  </span>
                                  <span className="text-[11px] font-bold text-slate-400">
                                    {formatAdminUpdatedAt(history.createdAt)}
                                  </span>
                                </div>
                                <p className="break-words text-sm font-black text-slate-900">
                                  {history.title}
                                </p>
                                <p className="mt-1 break-words text-sm font-bold leading-6 text-slate-600">
                                  {history.body}
                                </p>
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="rounded-2xl border border-dashed border-slate-200 bg-slate-50 px-5 py-10 text-center">
                      <FileText className="mx-auto mb-3 h-8 w-8 text-slate-300" />
                      <p className="font-black text-slate-700">
                        기존 계약을 선택하면 문서와 히스토리를 관리할 수 있습니다.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : adminTab === "PAYMENT_MANAGEMENT" ? (
            <div className="animate-in fade-in space-y-4">
              <div className="border-y border-emerald-200 bg-emerald-50 px-5 py-5">
                <div className="flex flex-col gap-3 lg:flex-row lg:items-start lg:justify-between">
                  <div>
                    <p className="text-xs font-black uppercase text-emerald-700">
                      Payment Operations
                    </p>
                    <h3 className="mt-2 text-xl font-black text-emerald-950">
                      {isSalesPaymentMode
                        ? "문자링크 생성"
                        : paymentManagementSection === "ERP_BRIDGE"
                        ? "ERP 연계 현황"
                        : paymentManagementSection === "DEPOSITS"
                        ? "입금관리 현황"
                        : paymentWorkspaceRoute === "OPERATIONS"
                        ? "결제 현황"
                        : "결제관리"}
                    </h3>
                    <p className="mt-2 max-w-3xl text-sm font-bold leading-6 text-emerald-900 break-keep">
                      {isSalesPaymentMode
                        ? `${currentManager?.name || "영업사원"}님의 담당 거래처만 표시됩니다. 거래처·금액·결제내용을 확인해 KCP BUYLINK를 만들고, 미리보기에서 문자 문구를 확인한 뒤 직접 전달하세요.`
                        : paymentManagementSection === "ERP_BRIDGE"
                        ? "ERP 미반영 BUYLINK 승인건을 중복 없이 Batch로 예약하고 BIFF8 .xls·건수·금액·반영이력을 확인합니다. 현재는 DRY_RUN이며 실제 천년경영 가져오기는 차단되어 있습니다."
                        : paymentManagementSection === "DEPOSITS"
                        ? "승인 완료된 카드결제만 조회해 입금일·입금예정일·ERP 등록 여부·비고를 관리하고 Excel로 내려받습니다."
                        : paymentWorkspaceRoute === "OPERATIONS"
                        ? "영업사원이 만든 문자링크 요청과 결제 상태를 조회하고, 승인 동기화·거래조회·취소·엑셀 작업을 처리합니다."
                        : "거래처 마스터를 선택해 문자링크와 등록카드 기반 키인결제를 관리합니다. 연락처와 카드 원문은 결제요청·로그·응답에 저장하지 않습니다."}
                    </p>
                  </div>
                  <div className="flex flex-wrap items-center gap-2">
                    {showPaymentOperationsPanel && (
                      <>
                    <button
                      type="button"
                      onClick={() => void handleExportPaymentHistory()}
                      className="inline-flex min-h-[40px] items-center gap-2 rounded-lg border border-emerald-300 bg-white px-3 text-xs font-black text-emerald-900"
                    >
                      <Download className="h-4 w-4" /> 기간 전체 엑셀
                    </button>
                    <button
                      type="button"
                      onClick={() => void handleExportKeyinPaymentHistory()}
                      className="inline-flex min-h-[40px] items-center gap-2 rounded-lg border border-amber-300 bg-white px-3 text-xs font-black text-amber-900"
                    >
                      <Download className="h-4 w-4" /> 기간 키인 엑셀
                    </button>
                      </>
                    )}
                    <span className={`inline-flex w-fit items-center gap-2 rounded-full px-3 py-2 text-xs font-black text-white ${
                      (paymentRequestForm.requestType === "BUYLINK" &&
                        selectedPaymentLinkProfileStatus?.executionEnabled) ||
                      (paymentRequestForm.requestType === "KEYIN" &&
                        selectedKeyinProfileStatus?.executionEnabled) ||
                      (paymentRequestForm.requestType === "AUTOPAY" &&
                        autopayConfig.executionEnabled)
                        ? "bg-emerald-700"
                        : "bg-slate-900"
                    }`}>
                      {(paymentRequestForm.requestType === "BUYLINK" &&
                        selectedPaymentLinkProfileStatus?.executionEnabled) ||
                      (paymentRequestForm.requestType === "KEYIN" &&
                        selectedKeyinProfileStatus?.executionEnabled) ||
                      (paymentRequestForm.requestType === "AUTOPAY" &&
                        autopayConfig.executionEnabled) ? (
                        <ShieldCheck className="h-4 w-4" />
                      ) : (
                        <LockKeyhole className="h-4 w-4" />
                      )}
                      {paymentRequestForm.requestType === "BUYLINK" &&
                      selectedPaymentLinkProfileStatus?.executionEnabled
                        ? `링크 생성 가능 · ${paymentLinkConfig.environment === "production" ? "운영" : "테스트"}`
                        : paymentRequestForm.requestType === "KEYIN" &&
                          selectedKeyinProfileStatus?.executionEnabled
                        ? `키인결제 사용 가능 · ${keyinPaymentConfig.environment === "production" ? "운영" : "테스트"}`
                        : paymentRequestForm.requestType === "AUTOPAY" &&
                          autopayConfig.executionEnabled
                        ? `키인결제 사용 가능 · ${autopayConfig.environment === "production" ? "운영" : "테스트"}`
                        : "외부 실행 잠금"}
                    </span>
                  </div>
                </div>
              </div>

              {!isSalesPaymentMode &&
                paymentWorkspaceRoute !== "SALES_REQUEST" && (
                  <div className="grid grid-cols-1 gap-1 border border-slate-200 bg-slate-100 p-1 sm:grid-cols-3">
                    <button
                      type="button"
                      aria-pressed={paymentManagementSection === "OPERATIONS"}
                      onClick={() => {
                        setPaymentManagementSection("OPERATIONS");
                        void loadPaymentRequests({
                          dateFrom: paymentHistoryFilters.dateFrom,
                          dateTo: paymentHistoryFilters.dateTo,
                        });
                      }}
                      className={`min-h-[44px] px-3 text-sm font-black ${
                        paymentManagementSection === "OPERATIONS"
                          ? "bg-white text-slate-950 shadow-sm"
                          : "text-slate-500"
                      }`}
                    >
                      결제 요청·승인 현황
                    </button>
                    <button
                      type="button"
                      aria-pressed={paymentManagementSection === "DEPOSITS"}
                      onClick={() => setPaymentManagementSection("DEPOSITS")}
                      className={`min-h-[44px] px-3 text-sm font-black ${
                        paymentManagementSection === "DEPOSITS"
                          ? "bg-white text-emerald-800 shadow-sm"
                          : "text-slate-500"
                      }`}
                    >
                      입금관리 현황
                    </button>
                    <button
                      type="button"
                      aria-pressed={paymentManagementSection === "ERP_BRIDGE"}
                      onClick={() => setPaymentManagementSection("ERP_BRIDGE")}
                      className={`min-h-[44px] px-3 text-sm font-black ${
                        paymentManagementSection === "ERP_BRIDGE"
                          ? "bg-white text-blue-800 shadow-sm"
                          : "text-slate-500"
                      }`}
                    >
                      ERP Bridge
                    </button>
                  </div>
                )}

              {showPaymentRequestPanel && (
              <section
                aria-labelledby="payment-safety-guide-title"
                className="border-y border-blue-200 bg-blue-50 px-5 py-5"
              >
                <div className="flex items-start gap-3">
                  <Info className="mt-0.5 h-5 w-5 shrink-0 text-blue-700" />
                  <div className="min-w-0">
                    <h4
                      id="payment-safety-guide-title"
                      className="text-base font-black text-blue-950"
                    >
                      결제 전 반드시 확인
                    </h4>
                    <p className="mt-2 text-sm font-black leading-6 text-blue-950 break-keep">
                      전자계약 동의와 카드결제 승인은 별도입니다. 계약서 서명만으로
                      결제나 자동결제 동의를 받은 것으로 처리하지 마세요.
                    </p>
                    <p className="mt-1 text-sm font-bold leading-6 text-blue-900 break-keep">
                      회사 내부 승인과 KCP 가맹점 계약 범위에서만 사용하고, 처리 전
                      거래처·담당 사업장·결제 법인·금액·결제내용·고객 의사를 다시
                      확인하세요.
                    </p>
                  </div>
                </div>
                <div className="mt-4 grid grid-cols-1 gap-px overflow-hidden rounded-lg border border-blue-200 bg-blue-200 sm:grid-cols-3">
                  {[
                    [
                      "초안",
                      "KCP 승인이나 문자 발송 없이 내부 요청만 저장된 상태입니다.",
                    ],
                    [
                      "링크 준비",
                      "앱이 문자를 보내지 않습니다. 담당자가 수신자와 금액을 확인한 뒤 직접 전달합니다.",
                    ],
                    [
                      "승인 완료",
                      "KCP 성공 응답과 승인번호를 확인한 경우에만 실제 결제로 봅니다.",
                    ],
                  ].map(([title, description]) => (
                    <div key={title} className="min-h-[94px] bg-white px-4 py-3">
                      <p className="text-sm font-black text-slate-950">{title}</p>
                      <p className="mt-1 text-xs font-bold leading-5 text-slate-600 break-keep">
                        {description}
                      </p>
                    </div>
                  ))}
                </div>
              </section>
              )}

              {showPaymentRequestPanel && paymentRequestForm.requestType === "KEYIN" && (
                <section className="border-y border-slate-200 bg-white px-5 py-5">
                  <input
                    ref={paymentBatchFileInputRef}
                    type="file"
                    accept=".xlsx,.xls"
                    onChange={handlePaymentBatchFileChange}
                    className="hidden"
                  />
                  <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
                    <div>
                      <div className="flex items-center gap-2">
                        <FileSpreadsheet className="h-5 w-5 text-amber-700" />
                        <h4 className="text-base font-black text-slate-950">
                          키인결제 일괄 대기열
                        </h4>
                      </div>
                      <p className="mt-2 text-sm font-bold leading-6 text-slate-600 break-keep">
                        카드정보 없이 결제 대상만 등록합니다. 카드번호·유효기간·CVC·주민번호·휴대폰번호 열은 업로드가 차단됩니다.
                      </p>
                    </div>
                    <div className="flex flex-wrap gap-2">
                      <button
                        type="button"
                        onClick={() => void handleDownloadPaymentBatchTemplate()}
                        className="inline-flex min-h-[42px] items-center gap-2 rounded-lg border border-slate-200 px-3 text-sm font-black text-slate-700"
                      >
                        <Download className="h-4 w-4" /> 엑셀 양식
                      </button>
                      <button
                        type="button"
                        onClick={() => paymentBatchFileInputRef.current?.click()}
                        className="inline-flex min-h-[42px] items-center gap-2 rounded-lg bg-amber-600 px-3 text-sm font-black text-white"
                      >
                        <Upload className="h-4 w-4" /> 엑셀 선택
                      </button>
                    </div>
                  </div>

                  <div className="mt-4 grid grid-cols-2 gap-px overflow-hidden rounded-lg border border-slate-200 bg-slate-200 sm:grid-cols-4">
                    {[
                      ["대기", paymentRequests.filter((item) => item.status === "QUEUED").length],
                      [
                        "입력검증",
                        paymentRequests.filter((item) => item.status === "PREFLIGHT_VALIDATED")
                          .length,
                      ],
                      [
                        "승인",
                        paymentRequests.filter((item) => item.approvalStatus === "APPROVED")
                          .length,
                      ],
                      [
                        "오류",
                        paymentRequests.filter(
                          (item) => item.approvalStatus === "FAILED" || item.errorCode
                        ).length,
                      ],
                    ].map(([label, value]) => (
                      <div key={label} className="min-h-[72px] bg-white px-4 py-3">
                        <p className="text-xs font-black text-slate-400">{label}</p>
                        <p className="mt-1 text-xl font-black text-slate-950">{value}</p>
                      </div>
                    ))}
                  </div>

                  {paymentBatchImportPreview && (
                    <div className="mt-5 border-t border-slate-200 pt-5">
                      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                        <div>
                          <p className="text-sm font-black text-slate-950">
                            {paymentBatchImportFileName || "선택한 엑셀"}
                          </p>
                          <p className="mt-1 text-xs font-bold text-slate-500">
                            전체 {paymentBatchImportPreview.totalRows}건 · 정상 {paymentBatchImportPreview.rows.length}건 · 오류 {paymentBatchImportPreview.errors.length}건
                          </p>
                        </div>
                        <div className="flex gap-2">
                          <button
                            type="button"
                            onClick={() => {
                              setPaymentBatchImportPreview(null);
                              setPaymentBatchImportFileName("");
                              setPaymentRequestsError("");
                            }}
                            className="inline-flex min-h-[40px] items-center gap-2 rounded-lg border border-slate-200 px-3 text-xs font-black text-slate-600"
                          >
                            <X className="h-4 w-4" /> 닫기
                          </button>
                          <button
                            type="button"
                            onClick={() => void handleImportPaymentBatch()}
                            disabled={
                              paymentBatchImportSaving ||
                              !paymentBatchImportPreview.canImport
                            }
                            className="inline-flex min-h-[40px] items-center gap-2 rounded-lg bg-slate-900 px-3 text-xs font-black text-white disabled:bg-slate-300"
                          >
                            {paymentBatchImportSaving ? (
                              <Loader2 className="h-4 w-4 animate-spin" />
                            ) : (
                              <Upload className="h-4 w-4" />
                            )}
                            대기열 등록
                          </button>
                        </div>
                      </div>

                      {paymentBatchImportPreview.errors.length > 0 && (
                        <div className="mt-4 border border-red-200 bg-red-50 px-4 py-3">
                          {paymentBatchImportPreview.errors.slice(0, 5).map((error, index) => (
                            <p key={`${error.rowNumber}-${index}`} className="text-xs font-bold leading-5 text-red-700">
                              {error.rowNumber > 0 ? `${error.rowNumber}행: ` : ""}
                              {error.message}
                            </p>
                          ))}
                        </div>
                      )}

                      {paymentBatchImportPreview.previewRows.length > 0 && (
                        <div className="mt-4 overflow-x-auto">
                          <table className="min-w-[760px] w-full border-collapse text-left text-xs">
                            <thead>
                              <tr className="border-y border-slate-200 bg-slate-50 text-slate-500">
                                <th className="px-3 py-2 font-black">행</th>
                                <th className="px-3 py-2 font-black">외부요청번호</th>
                                <th className="px-3 py-2 font-black">고객명</th>
                                <th className="px-3 py-2 text-right font-black">결제금액</th>
                                <th className="px-3 py-2 font-black">결제내용</th>
                                <th className="px-3 py-2 font-black">검증</th>
                              </tr>
                            </thead>
                            <tbody>
                              {paymentBatchImportPreview.previewRows.slice(0, 10).map((row) => (
                                <tr key={row.rowNumber} className="border-b border-slate-100">
                                  <td className="px-3 py-2 font-bold text-slate-400">{row.rowNumber}</td>
                                  <td className="px-3 py-2 font-bold text-slate-700">{row.externalRequestId || "-"}</td>
                                  <td className="px-3 py-2 font-bold text-slate-700">{row.customerName || "-"}</td>
                                  <td className="px-3 py-2 text-right font-black text-slate-900">{(Number(row.amount) || 0).toLocaleString("ko-KR")}원</td>
                                  <td className="px-3 py-2 font-bold text-slate-700">{row.itemName || "-"}</td>
                                  <td className={`px-3 py-2 font-black ${row.valid ? "text-emerald-700" : "text-red-700"}`}>
                                    {row.valid ? "정상" : "오류"}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  )}
                </section>
              )}

              {paymentRequestForm.requestType === "AUTOPAY" && (
                <section className="border-y border-slate-200 bg-white px-5 py-5">
                  <div className="flex flex-col gap-3 lg:flex-row lg:items-start lg:justify-between">
                    <div>
                      <div className="flex items-center gap-2">
                        <Smartphone className="h-5 w-5 text-blue-700" />
                        <h4 className="text-base font-black text-slate-950">
                          KCP 등록카드 관리
                        </h4>
                      </div>
                      <p className="mt-2 max-w-3xl text-sm font-bold leading-6 text-slate-600 break-keep">
                        고객은 모바일 KCP 화면에서 카드를 직접 등록합니다. 거래처마다 여러 카드를 등록할 수 있으며, 담당자가 거래처와 마스킹 끝 4자리를 확인한 카드만 별도 결제에 사용할 수 있습니다.
                      </p>
                    </div>
                    <div className="grid min-w-[280px] grid-cols-3 gap-px overflow-hidden rounded-lg border border-slate-200 bg-slate-200">
                      {[
                        ["등록링크", autopayRegistrations.filter((item) => item.status === "LINK_READY").length],
                        ["확인 완료", verifiedAutopayMethods.length],
                        ["승인 완료", paymentRequests.filter((item) => item.requestType === "AUTOPAY" && item.approvalStatus === "APPROVED").length],
                      ].map(([label, value]) => (
                        <div key={label} className="bg-white px-3 py-3 text-center">
                          <p className="text-[11px] font-black text-slate-400">{label}</p>
                          <p className="mt-1 text-lg font-black text-slate-950">{value}</p>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="mt-5 grid grid-cols-1 gap-6 lg:grid-cols-2">
                    <div>
                      <div className="flex items-center justify-between gap-3 border-b border-slate-200 pb-2">
                        <h5 className="text-sm font-black text-slate-900">거래처별 등록카드</h5>
                        <span className="text-xs font-bold text-slate-400">
                          {autopayMethods.filter((item) => item.status !== "DELETED").length}개 · 카드번호 원문 미보관
                        </span>
                      </div>
                      {autopayMethodGroups.length === 0 ? (
                        <p className="py-5 text-sm font-bold text-slate-500">등록된 카드가 없습니다.</p>
                      ) : (
                        <div>
                          {autopayMethodGroups.slice(0, 20).map((group) => (
                            <div key={group.vendorId} className="border-b border-slate-200 py-4 last:border-b-0">
                              <div className="mb-2 flex items-center justify-between gap-3">
                                <div className="min-w-0">
                                  <p className="break-words text-sm font-black text-slate-950">
                                    {group.businessName}
                                  </p>
                                  <p className="mt-1 text-xs font-bold text-slate-500">
                                    {group.businessNumber || "사업자번호 미등록"}
                                  </p>
                                </div>
                                <span className="shrink-0 text-xs font-black text-blue-700">
                                  카드 {group.methods.length}개
                                </span>
                              </div>
                              <div className="border-l-2 border-slate-200 pl-3">
                                {group.methods.map((method) => (
                              <div key={method.billingMethodId} className="border-b border-slate-100 py-3">
                                <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                                  <div className="min-w-0">
                                    <p className="break-words text-sm font-black text-slate-900">
                                      {method.cardLabel || "카드 구분 미입력"} · {method.cardName || "카드사 확인 전"}
                                    </p>
                                    <p className="mt-1 text-xs font-bold text-slate-500">
                                      {method.cardNumberMasked || "끝 4자리 미확인"} · {method.companyName || method.profileId}
                                    </p>
                                    <div className="mt-2 flex flex-wrap gap-2">
                                    {method.isPrimary && (
                                      <span className="inline-flex min-h-[26px] items-center rounded-md bg-violet-100 px-2 text-[11px] font-black text-violet-800">
                                        메인 카드
                                      </span>
                                    )}
                                    <span
                                      className={`inline-flex min-h-[26px] items-center rounded-md px-2 text-[11px] font-black ${
                                        method.status === "REVIEW_REQUIRED" || method.providerApprovalMatched === false
                                          ? "bg-red-100 text-red-800"
                                          : method.verificationStatus === "KCP_APPROVAL_MATCHED"
                                          ? "bg-emerald-100 text-emerald-800"
                                          : method.operatorConfirmed
                                          ? "bg-blue-100 text-blue-800"
                                          : "bg-amber-100 text-amber-800"
                                      }`}
                                    >
                                      {method.status === "REVIEW_REQUIRED" || method.providerApprovalMatched === false
                                        ? "카드번호 불일치 · 사용 중지"
                                        : method.verificationStatus === "KCP_APPROVAL_MATCHED"
                                        ? "KCP 승인 카드 일치"
                                        : method.operatorConfirmed
                                        ? "담당자 확인 완료"
                                        : "담당자 확인 필요"}
                                    </span>
                                    </div>
                                  </div>
                                  <div className="flex shrink-0 flex-wrap gap-2">
                                    {method.status === "ACTIVE" && (
                                      <button
                                        type="button"
                                        onClick={() => {
                                          setAutopayVerifyMethodId(method.billingMethodId);
                                          setAutopayVerifyForm({
                                            cardLabel: method.cardLabel || "",
                                            cardLast4: String(method.cardNumberMasked || "").replace(/\D/g, "").slice(-4),
                                            reason: "",
                                            confirmation: "",
                                          });
                                        }}
                                        className="inline-flex min-h-[38px] items-center gap-2 rounded-lg border border-blue-200 bg-white px-3 text-xs font-black text-blue-800"
                                      >
                                        <ShieldCheck className="h-4 w-4" />
                                        {method.operatorConfirmed ? "확인 수정" : "카드 확인"}
                                      </button>
                                    )}
                                    {isAutopayMethodReadyForCharge(method) && (
                                      <button
                                        type="button"
                                        disabled={method.isPrimary || Boolean(autopayPrimarySavingId)}
                                        onClick={() => void handleSetPrimaryAutopayMethod(method)}
                                        className="inline-flex min-h-[38px] items-center gap-2 rounded-lg border border-violet-200 bg-white px-3 text-xs font-black text-violet-800 disabled:bg-violet-50 disabled:text-violet-400"
                                      >
                                        {autopayPrimarySavingId === method.billingMethodId && (
                                          <Loader2 className="h-4 w-4 animate-spin" />
                                        )}
                                        {method.isPrimary ? "메인 카드" : "메인 지정"}
                                      </button>
                                    )}
                                    <button
                                      type="button"
                                      disabled={!isAutopayMethodReadyForCharge(method)}
                                      onClick={() => {
                                        setAutopayAction("CHARGE");
                                        setSelectedAutopayMethodId(method.billingMethodId);
                                        setPaymentRequestForm((prev) => ({
                                          ...prev,
                                          requestType: "AUTOPAY",
                                          vendorId: method.vendorId || "",
                                          customerName: method.customerName || prev.customerName,
                                          itemName: method.itemName || prev.itemName,
                                        }));
                                        setAutopayConfirmation("");
                                      }}
                                      className="inline-flex min-h-[38px] items-center gap-2 rounded-lg bg-blue-700 px-3 text-xs font-black text-white disabled:bg-slate-300"
                                    >
                                      <CreditCard className="h-4 w-4" /> 결제 선택
                                    </button>
                                    {["ACTIVE", "REVIEW_REQUIRED", "DELETE_FAILED"].includes(method.status) && (
                                    <button
                                      type="button"
                                      title="등록카드 삭제"
                                      onClick={() => {
                                        setAutopayDeleteMethodId(method.billingMethodId);
                                        setAutopayDeleteReason("");
                                        setAutopayDeleteConfirmation("");
                                      }}
                                      className="inline-flex h-[38px] w-[38px] items-center justify-center rounded-lg border border-red-200 text-red-700"
                                    >
                                      <Trash2 className="h-4 w-4" />
                                    </button>
                                    )}
                                  </div>
                                </div>
                                {method.status === "REVIEW_REQUIRED" && (
                                  <p className="mt-3 border-l-4 border-red-500 bg-red-50 px-3 py-2 text-xs font-bold leading-5 text-red-800">
                                    담당자 확인값 {method.cardNumberMasked || "미확인"} / KCP 승인값 {method.providerCardNumberMasked || "미확인"}. 끝 4자리가 달라 이후 결제를 차단했습니다. 거래처 확인 후 삭제하고 다시 등록하세요.
                                  </p>
                                )}
                                {autopayVerifyMethodId === method.billingMethodId && (
                                  <div className="mt-3 border-l-4 border-blue-500 bg-blue-50 px-3 py-3">
                                    <p className="text-xs font-black leading-5 text-blue-950">
                                      거래처와 실제 카드의 끝 4자리를 별도 자료로 대조해 기록합니다. 전체 카드번호는 입력하지 마세요.
                                    </p>
                                    <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2">
                                      <input
                                        value={autopayVerifyForm.cardLabel}
                                        onChange={(event) =>
                                          setAutopayVerifyForm((prev) => ({
                                            ...prev,
                                            cardLabel: event.target.value.slice(0, 40),
                                          }))
                                        }
                                        placeholder="카드 구분명"
                                        autoComplete="off"
                                        className="min-h-[42px] rounded-lg border border-blue-200 bg-white px-3 text-sm font-bold outline-none focus:border-blue-600"
                                      />
                                      <input
                                        value={autopayVerifyForm.cardLast4}
                                        onChange={(event) =>
                                          setAutopayVerifyForm((prev) => ({
                                            ...prev,
                                            cardLast4: event.target.value.replace(/\D/g, "").slice(0, 4),
                                          }))
                                        }
                                        inputMode="numeric"
                                        placeholder="카드 끝 4자리"
                                        autoComplete="off"
                                        className="min-h-[42px] rounded-lg border border-blue-200 bg-white px-3 text-sm font-bold outline-none focus:border-blue-600"
                                      />
                                      <input
                                        value={autopayVerifyForm.reason}
                                        onChange={(event) =>
                                          setAutopayVerifyForm((prev) => ({
                                            ...prev,
                                            reason: event.target.value.slice(0, 300),
                                          }))
                                        }
                                        placeholder="확인 근거 5자 이상"
                                        autoComplete="off"
                                        className="min-h-[42px] rounded-lg border border-blue-200 bg-white px-3 text-sm font-bold outline-none focus:border-blue-600"
                                      />
                                      <input
                                        value={autopayVerifyForm.confirmation}
                                        onChange={(event) =>
                                          setAutopayVerifyForm((prev) => ({
                                            ...prev,
                                            confirmation: event.target.value.slice(0, 20),
                                          }))
                                        }
                                        placeholder="카드 확인 입력"
                                        autoComplete="off"
                                        className="min-h-[42px] rounded-lg border border-blue-200 bg-white px-3 text-sm font-bold outline-none focus:border-blue-600"
                                      />
                                    </div>
                                    <div className="mt-2 flex justify-end gap-2">
                                      <button
                                        type="button"
                                        onClick={() => setAutopayVerifyMethodId("")}
                                        className="min-h-[38px] rounded-lg border border-slate-200 bg-white px-3 text-xs font-black text-slate-600"
                                      >
                                        취소
                                      </button>
                                      <button
                                        type="button"
                                        disabled={
                                          autopayVerifySaving ||
                                          autopayVerifyForm.cardLabel.trim().length < 2 ||
                                          !/^\d{4}$/.test(autopayVerifyForm.cardLast4) ||
                                          autopayVerifyForm.reason.trim().length < 5 ||
                                          autopayVerifyForm.confirmation !== "카드 확인"
                                        }
                                        onClick={() => void handleVerifyAutopayMethod()}
                                        className="inline-flex min-h-[38px] items-center gap-2 rounded-lg bg-blue-700 px-3 text-xs font-black text-white disabled:bg-slate-300"
                                      >
                                        {autopayVerifySaving && <Loader2 className="h-4 w-4 animate-spin" />}
                                        확인 기록
                                      </button>
                                    </div>
                                  </div>
                                )}
                                {autopayDeleteMethodId === method.billingMethodId && (
                                  <div className="mt-3 border-l-4 border-red-400 bg-red-50 px-3 py-3">
                                    <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
                                      <input
                                        value={autopayDeleteReason}
                                        onChange={(event) => setAutopayDeleteReason(event.target.value.slice(0, 300))}
                                        placeholder="삭제 사유 5자 이상"
                                        autoComplete="off"
                                        className="min-h-[42px] rounded-lg border border-red-200 bg-white px-3 text-sm font-bold outline-none focus:border-red-500"
                                      />
                                      <input
                                        value={autopayDeleteConfirmation}
                                        onChange={(event) => setAutopayDeleteConfirmation(event.target.value.slice(0, 20))}
                                        placeholder="빌링키 삭제 입력"
                                        autoComplete="off"
                                        className="min-h-[42px] rounded-lg border border-red-200 bg-white px-3 text-sm font-bold outline-none focus:border-red-500"
                                      />
                                    </div>
                                    <div className="mt-2 flex justify-end gap-2">
                                      <button
                                        type="button"
                                        onClick={() => setAutopayDeleteMethodId("")}
                                        className="min-h-[38px] rounded-lg border border-slate-200 bg-white px-3 text-xs font-black text-slate-600"
                                      >
                                        취소
                                      </button>
                                      <button
                                        type="button"
                                        disabled={autopayDeleteSaving || autopayDeleteReason.trim().length < 5 || autopayDeleteConfirmation !== "빌링키 삭제"}
                                        onClick={() => void handleDeleteAutopayMethod()}
                                        className="inline-flex min-h-[38px] items-center gap-2 rounded-lg bg-red-700 px-3 text-xs font-black text-white disabled:bg-slate-300"
                                      >
                                        {autopayDeleteSaving && <Loader2 className="h-4 w-4 animate-spin" />}
                                        KCP 빌링키 삭제
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </div>
                                ))}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    <div>
                      <div className="flex items-center justify-between gap-3 border-b border-slate-200 pb-2">
                        <h5 className="text-sm font-black text-slate-900">최근 카드등록 링크</h5>
                        <span className="text-xs font-bold text-slate-400">7일 유효</span>
                      </div>
                      {autopayRegistrations.length === 0 ? (
                        <p className="py-5 text-sm font-bold text-slate-500">생성된 등록 링크가 없습니다.</p>
                      ) : (
                        <div>
                          {autopayRegistrations.slice(0, 10).map((registration) => (
                            <div key={registration.registrationId} className="border-b border-slate-100 py-3">
                              <div className="flex items-start justify-between gap-3">
                                <div className="min-w-0">
                                  <p className="break-words text-sm font-black text-slate-900">
                                    {registration.vendorBusinessName || registration.customerName || "거래처 미입력"} · {registration.cardLabel || "카드등록"}
                                  </p>
                                  <p className="mt-1 text-xs font-bold text-slate-500">
                                    {registration.cardNumberMasked || "끝 4자리 미확인"} · {registration.status} · 만료 {formatAdminUpdatedAt(registration.expiresAt)}
                                  </p>
                                </div>
                                {registration.registrationUrl && (
                                  <div className="flex shrink-0 gap-2">
                                    <button
                                      type="button"
                                      title="등록 링크 복사"
                                      onClick={() => copyTextToClipboard(registration.registrationUrl)}
                                      className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-blue-200 text-blue-700"
                                    >
                                      <ClipboardCheck className="h-4 w-4" />
                                    </button>
                                    <button
                                      type="button"
                                      title="문자 문구 복사"
                                      onClick={() => copyTextToClipboard(buildAutopayRegistrationMessage(registration))}
                                      className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-slate-200 text-slate-700"
                                    >
                                      <Smartphone className="h-4 w-4" />
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </section>
              )}

              <div
                className={`grid grid-cols-1 gap-5 ${
                  showPaymentRequestPanel && showPaymentOperationsPanel
                    ? "xl:grid-cols-[minmax(0,1.05fr)_minmax(320px,0.95fr)]"
                    : ""
                }`}
              >
                {showPaymentRequestPanel && (
                <form
                  onSubmit={(event) => {
                    event.preventDefault();
                    void handleCreatePaymentRequestDraft();
                  }}
                  className="border border-slate-200 bg-white p-5 shadow-sm"
                >
                  <div className="flex items-center gap-2">
                    <CreditCard className="h-5 w-5 text-emerald-700" />
                    <h4 className="text-lg font-black text-slate-950">
                      {activePaymentQueueItem ? "순차 입력" : "새 결제 요청"}
                    </h4>
                  </div>

                  {activePaymentQueueItem && (
                    <div className="mt-4 flex flex-col gap-3 border-l-4 border-amber-500 bg-amber-50 px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
                      <div>
                        <p className="text-sm font-black text-amber-950">
                          {activePaymentQueueItem.batchSequence}/{activePaymentQueueItem.batchTotal}번 · {activePaymentQueueItem.externalRequestId || activePaymentQueueItem.paymentRequestId}
                        </p>
                        <p className="mt-1 text-xs font-bold text-amber-800">
                          비민감 결제정보는 고정되며, 카드 입력값만 검증한 뒤 다음 건을 준비합니다.
                        </p>
                      </div>
                      <button
                        type="button"
                        onClick={clearActivePaymentQueueItem}
                        className="inline-flex min-h-[38px] items-center justify-center gap-2 rounded-lg border border-amber-300 bg-white px-3 text-xs font-black text-amber-900"
                      >
                        <X className="h-4 w-4" /> 순차 입력 닫기
                      </button>
                    </div>
                  )}

                  <div
                    className={`mt-5 grid rounded-lg bg-slate-100 p-1 ${
                      isSalesPaymentMode ? "grid-cols-1" : "grid-cols-2"
                    }`}
                  >
                    {(isSalesPaymentMode
                      ? PAYMENT_REQUEST_TYPE_OPTIONS.filter(
                          (option) => option.value === "BUYLINK"
                        )
                      : PAYMENT_REQUEST_TYPE_OPTIONS
                    ).map((option) => {
                      const selected = paymentRequestForm.requestType === option.value;
                      return (
                        <button
                          key={option.value}
                          type="button"
                          aria-pressed={selected}
                          onClick={() => {
                            setActivePaymentQueueItemId("");
                            setPaymentRequestForm((prev) => ({
                              ...prev,
                              requestType: option.value,
                              paymentProfileId:
                                ["STANDARD", "BUYLINK"].includes(option.value)
                                  ? prev.paymentProfileId || "CNFOOD_LINK"
                                  : prev.paymentProfileId,
                              autopayProfileId:
                                option.value === "AUTOPAY"
                                  ? prev.autopayProfileId || "CNFOOD_AUTOPAY"
                                  : prev.autopayProfileId,
                            }));
                            if (option.value === "AUTOPAY") {
                              setAutopayAction("REGISTER");
                              setAutopayConfirmation("");
                            }
                            if (option.value === "KEYIN") {
                              setKeyinExecutionAttempt({ fingerprint: "", key: "" });
                            }
                            clearSensitivePaymentCardInput();
                          }}
                          className={`min-h-[48px] rounded-md px-2 py-2 text-sm font-black transition-colors ${
                            selected
                              ? "bg-white text-slate-950 shadow-sm"
                              : "text-slate-500"
                          }`}
                        >
                          {option.label}
                        </button>
                      );
                    })}
                  </div>

                  <div
                    role="note"
                    className={`mt-4 border-l-4 px-4 py-3 ${
                      paymentRequestForm.requestType === "KEYIN"
                        ? "border-amber-500 bg-amber-50 text-amber-950"
                        : paymentRequestForm.requestType === "AUTOPAY"
                        ? "border-blue-500 bg-blue-50 text-blue-950"
                        : "border-emerald-500 bg-emerald-50 text-emerald-950"
                    }`}
                  >
                    <p className="text-sm font-black">
                      {paymentRequestForm.requestType === "KEYIN"
                        ? "키인결제 사용 전 확인"
                        : paymentRequestForm.requestType === "AUTOPAY"
                        ? autopayAction === "CHARGE"
                          ? "키인결제 실제 승인 전 확인"
                          : "거래처 카드등록 링크 사용 전 확인"
                        : paymentRequestForm.requestType === "STANDARD"
                        ? "KCP 표준결제 사용 전 확인"
                        : "KCP BUYLINK 사용 전 확인"}
                    </p>
                    <p className="mt-1 text-xs font-bold leading-5 break-keep">
                      {paymentRequestForm.requestType === "KEYIN"
                        ? selectedKeyinProfileStatus?.executionEnabled
                          ? "승인 버튼은 실제 KEY-IN 결제를 실행할 수 있습니다. 카드 소유자의 결제 의사와 회사의 KCP KEY-IN 사용 권한을 확인하고, 카드정보를 메모·엑셀·화면 캡처에 남기지 마세요."
                          : "실행 환경이 잠겨 있어 형식검증과 초안 저장만 합니다. 카드정보를 메모·엑셀·화면 캡처에 남기지 마세요."
                        : paymentRequestForm.requestType === "AUTOPAY"
                        ? autopayAction === "CHARGE"
                          ? "이 버튼은 선택한 등록카드로 실제 결제를 실행할 수 있습니다. 메인 카드 여부와 이번 거래처·금액·결제내용·승인 사유가 일치하는지 확인하고, 결과가 불명확하면 반복 승인하지 마세요."
                          : "카드등록은 결제가 아닙니다. 고객이 KCP 화면에서 직접 입력하므로 CNFOOD는 카드 원문이나 카드사진을 받지 않습니다. 다만 후속 청구 조건·대상·금액 또는 산정기준·해지 방법은 별도로 안내하고 동의 증빙을 보관하세요."
                        : paymentRequestForm.requestType === "STANDARD"
                        ? "고객이 링크에서 KCP 결제창을 열어 직접 카드 또는 제공되는 간편결제를 선택합니다. 거래처·결제 법인·금액·결제내용을 다시 확인하세요."
                        : "KCP BUYLINK URL만 생성하며 KCP 문자 자동발송은 사용하지 않습니다. 주문자 연락처는 링크 생성 순간에만 전송되고 CNFOOD에는 저장하지 않습니다."}
                    </p>
                  </div>

                  <div className="mt-5">
                    <label
                      htmlFor="payment-vendor-lookup"
                      className="mb-2 block text-sm font-black text-slate-700"
                    >
                      거래처{" "}
                      {activePaymentQueueItem ? (
                        <span className="font-bold text-slate-400">엑셀 대기열</span>
                      ) : (
                        <span className="text-red-600">*</span>
                      )}
                    </label>
                    <div
                      className="relative"
                      onBlur={(event) => {
                        if (!event.currentTarget.contains(event.relatedTarget as Node)) {
                          setPaymentVendorLookupOpen(false);
                        }
                      }}
                    >
                      <div className="relative">
                        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
                        <input
                          id="payment-vendor-lookup"
                          role="combobox"
                          aria-autocomplete="list"
                          aria-expanded={paymentVendorLookupOpen}
                          aria-controls="payment-vendor-options"
                          aria-activedescendant={
                            paymentVendorLookupOpen && filteredPaymentVendorOptions.length > 0
                              ? `payment-vendor-option-${paymentVendorActiveIndex}`
                              : undefined
                          }
                          value={paymentVendorSearch}
                          disabled={Boolean(activePaymentQueueItem)}
                          onCompositionStart={() => {
                            if (paymentVendorSearchTimerRef.current !== null) {
                              window.clearTimeout(paymentVendorSearchTimerRef.current);
                              paymentVendorSearchTimerRef.current = null;
                            }
                            setPaymentVendorSearchComposing(true);
                            invalidatePaymentDirectoryRequest();
                            setPaymentVendorLookupOpen(false);
                          }}
                          onCompositionEnd={(event) => {
                            const value = event.currentTarget.value;
                            paymentVendorSearchRef.current = value;
                            setPaymentVendorSearch(value);
                            setPaymentVendorSearchComposing(false);
                            invalidatePaymentDirectoryRequest();
                            resetPaymentDirectoryForSearchInput();
                            setPaymentVendorLookupOpen(
                              shouldLoadPaymentVendorCanonicalSearch(value)
                            );
                            setPaymentVendorActiveIndex(0);
                            if (!String(value || "").trim()) {
                              void loadPaymentDirectory({
                                bypassAccess: true,
                                vendorQuery: "",
                                cursor: "",
                                append: false,
                              });
                            }
                          }}
                          onFocus={(event) => {
                            setPaymentVendorLookupOpen(paymentDirectoryLoaded);
                            setPaymentVendorActiveIndex(0);
                            event.currentTarget.select();
                          }}
                          onChange={(event) => {
                            const value = event.target.value;
                            if (paymentVendorSearchTimerRef.current !== null) {
                              window.clearTimeout(paymentVendorSearchTimerRef.current);
                              paymentVendorSearchTimerRef.current = null;
                            }
                            const isComposing =
                              paymentVendorSearchComposing ||
                              event.nativeEvent.isComposing === true;
                            paymentVendorSearchRef.current = value;
                            invalidatePaymentDirectoryRequest();
                            resetPaymentDirectoryForSearchInput();
                            setPaymentDirectoryError("");
                            setPaymentVendorSearch(value);
                            setPaymentVendorLookupOpen(
                              !isComposing &&
                                shouldLoadPaymentVendorCanonicalSearch(value)
                            );
                            setPaymentVendorActiveIndex(0);
                            if (!isComposing && !String(value || "").trim()) {
                              void loadPaymentDirectory({
                                bypassAccess: true,
                                vendorQuery: "",
                                cursor: "",
                                append: false,
                              });
                            }
                            if (
                              selectedPaymentVendor &&
                              value !== buildPaymentVendorLookupLabel(selectedPaymentVendor)
                            ) {
                              setPaymentRequestForm((prev) => ({
                                ...prev,
                                vendorId: "",
                                customerName: "",
                                buyerPhone: "",
                                buyerEmail: "",
                              }));
                              setSelectedAutopayMethodId("");
                            }
                          }}
                          onKeyDown={(event) => {
                            if (
                              paymentVendorSearchComposing ||
                              event.nativeEvent.isComposing === true
                            ) {
                              return;
                            }
                            if (event.key === "Escape") {
                              setPaymentVendorLookupOpen(false);
                              return;
                            }
                            if (event.key === "ArrowDown") {
                              event.preventDefault();
                              setPaymentVendorLookupOpen(true);
                              setPaymentVendorActiveIndex((prev) =>
                                Math.min(
                                  prev + 1,
                                  Math.max(filteredPaymentVendorOptions.length - 1, 0)
                                )
                              );
                              return;
                            }
                            if (event.key === "ArrowUp") {
                              event.preventDefault();
                              setPaymentVendorActiveIndex((prev) => Math.max(prev - 1, 0));
                              return;
                            }
                            if (
                              event.key === "Enter" &&
                              paymentDirectoryPagination.query !== paymentVendorSearch.trim() &&
                              shouldLoadPaymentVendorCanonicalSearch(paymentVendorSearch)
                            ) {
                              event.preventDefault();
                              if (paymentVendorSearchTimerRef.current !== null) {
                                window.clearTimeout(paymentVendorSearchTimerRef.current);
                                paymentVendorSearchTimerRef.current = null;
                              }
                              setPaymentVendorLookupOpen(true);
                              void loadPaymentDirectory({
                                bypassAccess: true,
                                vendorQuery: paymentVendorSearch,
                                cursor: "",
                                append: false,
                              });
                              return;
                            }
                            if (
                              event.key === "Enter" &&
                              paymentVendorLookupOpen &&
                              filteredPaymentVendorOptions[paymentVendorActiveIndex]
                            ) {
                              event.preventDefault();
                              selectPaymentVendorForRequest(
                                filteredPaymentVendorOptions[paymentVendorActiveIndex]
                              );
                            }
                          }}
                          placeholder="업체코드·업체명·사업자번호 검색"
                          className="min-h-[50px] w-full rounded-xl border border-slate-200 pl-10 pr-12 text-sm font-bold outline-none focus:border-emerald-600 disabled:bg-slate-50 disabled:text-slate-600 sm:text-base"
                        />
                        {(paymentVendorSearch || paymentRequestForm.vendorId) &&
                          !activePaymentQueueItem && (
                            <button
                              type="button"
                              aria-label="거래처 검색 초기화"
                              onClick={() => {
                                if (paymentVendorSearchTimerRef.current !== null) {
                                  window.clearTimeout(paymentVendorSearchTimerRef.current);
                                  paymentVendorSearchTimerRef.current = null;
                                }
                                paymentVendorSearchRef.current = "";
                                setPaymentVendorSearchComposing(false);
                                invalidatePaymentDirectoryRequest();
                                resetPaymentDirectoryForSearchInput();
                                setPaymentVendorSearch("");
                                setPaymentVendorLookupOpen(false);
                                setPaymentVendorActiveIndex(0);
                                setPaymentRequestForm((prev) => ({
                                  ...prev,
                                  vendorId: "",
                                  customerName: "",
                                  buyerPhone: "",
                                  buyerEmail: "",
                                }));
                                setSelectedAutopayMethodId("");
                                void loadPaymentDirectory({
                                  bypassAccess: true,
                                  vendorQuery: "",
                                });
                              }}
                              className="absolute right-2 top-1/2 inline-flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full text-slate-400 hover:bg-slate-100 hover:text-slate-700"
                            >
                              <X className="h-4 w-4" />
                            </button>
                          )}
                      </div>

                      {paymentVendorLookupOpen && !activePaymentQueueItem && (
                        <div
                          id="payment-vendor-options"
                          role="listbox"
                          aria-label="결제 거래처 검색 결과"
                          className="absolute z-40 mt-2 max-h-80 w-full overflow-y-auto rounded-xl border border-slate-200 bg-white shadow-xl"
                        >
                          <div className="sticky top-0 hidden grid-cols-[90px_minmax(180px,1.4fr)_minmax(170px,1fr)_90px] gap-3 border-b border-slate-200 bg-slate-50 px-3 py-2 text-[11px] font-black text-slate-500 sm:grid">
                            <span>업체코드</span>
                            <span>업체명</span>
                            <span>법인·사업장 / 담당자</span>
                            <span>상태</span>
                          </div>
                          {paymentDirectorySearchPending ? (
                            <p className="px-4 py-6 text-center text-sm font-bold text-emerald-700">
                              거래처를 검색하는 중입니다.
                            </p>
                          ) : filteredPaymentVendorOptions.length === 0 ? (
                            <p className="px-4 py-6 text-center text-sm font-bold text-slate-500">
                              검색어와 일치하는 {paymentRequestForm.requestType === "BUYLINK" ? "수금 가능" : "활성"} 거래처가 없습니다.
                            </p>
                          ) : (
                            filteredPaymentVendorOptions.map((vendor, index) => (
                              <button
                                id={`payment-vendor-option-${index}`}
                                key={vendor.vendorId}
                                type="button"
                                role="option"
                                aria-selected={
                                  vendor.vendorId === paymentRequestForm.vendorId
                                }
                                onMouseDown={(event) => event.preventDefault()}
                                onMouseEnter={() => setPaymentVendorActiveIndex(index)}
                                onClick={() => selectPaymentVendorForRequest(vendor)}
                                className={`grid w-full grid-cols-[84px_minmax(0,1fr)] gap-x-3 gap-y-1 border-b border-slate-100 px-3 py-3 text-left last:border-b-0 sm:grid-cols-[90px_minmax(180px,1.4fr)_minmax(170px,1fr)_90px] ${
                                  index === paymentVendorActiveIndex ||
                                  vendor.vendorId === paymentRequestForm.vendorId
                                    ? "bg-emerald-50"
                                    : "bg-white hover:bg-slate-50"
                                }`}
                              >
                                <span className="font-mono text-xs font-black text-emerald-800">
                                  {normalizeVendorCode(vendor.vendorCode) || "미연결"}
                                </span>
                                <span className="truncate text-sm font-black text-slate-900">
                                  {vendor.businessName || "업체명 미입력"}
                                </span>
                                <span className="col-start-2 text-xs font-bold text-slate-500 sm:col-start-auto">
                                  <span className="sm:hidden">법인·사업장 / 담당자 · </span>
                                  {vendor.companyBranchName || vendor.partName || "사업장 미지정"}
                                  {" / "}
                                  {vendor.salesManagerName || "담당자 미배정"}
                                </span>
                                <span className="col-start-2 text-xs font-bold text-slate-500 sm:col-start-auto">
                                  <span className="sm:hidden">상태 · </span>
                                  {vendor.status === "INACTIVE" && paymentRequestForm.requestType === "BUYLINK"
                                    ? "거래안함"
                                    : getVendorMasterStatusLabel(vendor.status)}
                                </span>
                              </button>
                            ))
                          )}
                          <div className="sticky bottom-0 flex items-center justify-between gap-2 border-t border-slate-200 bg-white px-3 py-2 text-[11px] font-bold text-slate-500">
                            <span>{paymentDirectoryResultMessage}</span>
                            {paymentDirectoryCanLoadMore && (
                              <button
                                type="button"
                                onMouseDown={(event) => event.preventDefault()}
                                onClick={() =>
                                  void loadPaymentDirectory({
                                    bypassAccess: true,
                                    vendorQuery: paymentDirectoryPagination.query,
                                    cursor: paymentDirectoryPagination.nextCursor,
                                    append: true,
                                  })
                                }
                                className="rounded-lg bg-slate-900 px-3 py-1.5 text-white"
                              >
                                더보기
                              </button>
                              )}
                          </div>
                        </div>
                      )}
                    </div>
                    <p className="mt-2 text-xs font-bold leading-5 text-slate-500 break-keep">
                      상호명 2글자부터 전체 {paymentRequestForm.requestType === "BUYLINK" ? "수금 가능" : "활성"} 거래처를 자동 검색합니다. 6자리 거래처 코드와 사업자번호는 정확히 검색하며 최대 200건을 표시합니다.
                      {paymentRequestForm.requestType === "BUYLINK" && " 거래안함 거래처도 미수금 수금을 위해 선택할 수 있습니다."}
                    </p>
                    {paymentDirectoryLoading && (
                      <p className="mt-2 flex items-center text-xs font-black text-emerald-700">
                        <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                        {paymentVendorSearch.trim()
                          ? "거래처를 검색하는 중입니다."
                          : "거래처와 등록카드를 먼저 불러오는 중입니다."}
                      </p>
                    )}
                    {paymentDirectoryError && (
                      <p className="mt-2 text-xs font-bold leading-5 text-red-700">
                        {paymentDirectoryError}
                      </p>
                    )}
                    {paymentDirectoryWarning && (
                      <p className="mt-2 rounded-xl border border-amber-200 bg-amber-50 px-3 py-3 text-xs font-bold leading-5 text-amber-900">
                        {paymentDirectoryWarning}
                      </p>
                    )}
                    {isSalesPaymentMode &&
                      paymentDirectoryLoaded &&
                      !paymentDirectoryLoading &&
                      paymentVendorOptions.length === 0 && (
                        <p className="mt-2 rounded-xl border border-amber-200 bg-amber-50 px-3 py-3 text-xs font-bold leading-5 text-amber-900">
                          현재 로그인 계정에 배정된 수금 가능 거래처가 없습니다. 결제권자 담당자에게 ERP 거래처의 담당 영업사원명을 확인해 달라고 요청하세요.
                        </p>
                      )}
                    {selectedPaymentVendor && (
                      <span className={`mt-2 block text-xs font-bold leading-5 ${
                        selectedVendorPaymentMappingReady
                          ? "text-slate-500"
                          : "text-red-700"
                      }`}>
                        ERP 거래처코드: {normalizeVendorCode(selectedPaymentVendor.vendorCode) || "미연결"} · 담당자: {selectedPaymentVendor.salesManagerName || "미등록"} · 담당 사업장: {selectedPaymentVendor.companyBranchName || "미연결"} · 결제 법인:{" "}
                        {selectedPaymentVendor.paymentCompanyName || "프로필 미연결"}
                        {selectedPaymentVendor.status === "INACTIVE" && paymentRequestForm.requestType === "BUYLINK"
                          ? " · 거래안함 (미수금 수금 가능)"
                          : ""}
                        {!selectedVendorPaymentMappingReady
                          ? /^\d{6}$/.test(normalizeVendorCode(selectedPaymentVendor.vendorCode))
                            ? " · 우리회사 사업장 관리에서 결제 프로필을 연결해 주세요."
                            : " · 결제 전에 6자리 ERP 거래처코드를 연결해 주세요."
                          : !selectedVendorPaymentOperationReady
                          ? " · PG 실행은 비활성 상태이며 초안만 저장할 수 있습니다."
                          : ""}
                      </span>
                    )}
                  </div>

                  <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <label className="block">
                      <span className="mb-2 block text-sm font-black text-slate-700">
                        결제금액 <span className="text-red-600">*</span>
                      </span>
                      <input
                        value={paymentRequestForm.amount}
                        disabled={Boolean(activePaymentQueueItem)}
                        onChange={(event) =>
                          setPaymentRequestForm((prev) => ({
                            ...prev,
                            amount: event.target.value.replace(/[^0-9]/g, "").slice(0, 12),
                          }))
                        }
                        inputMode="numeric"
                        placeholder="예: 33000"
                        className="min-h-[48px] w-full rounded-xl border border-slate-200 px-3 text-base font-bold outline-none focus:border-emerald-600 disabled:bg-slate-50 disabled:text-slate-600"
                      />
                    </label>
                    <label className="block">
                      <span className="mb-2 block text-sm font-black text-slate-700">
                        고객명 <span className="font-bold text-slate-400">선택</span>
                      </span>
                      <input
                        value={paymentRequestForm.customerName}
                        disabled={Boolean(activePaymentQueueItem)}
                        onChange={(event) =>
                          setPaymentRequestForm((prev) => ({
                            ...prev,
                            customerName: event.target.value.slice(0, 50),
                          }))
                        }
                        autoComplete="off"
                        placeholder="입금자 또는 주문자명"
                        className="min-h-[48px] w-full rounded-xl border border-slate-200 px-3 text-base font-bold outline-none focus:border-emerald-600 disabled:bg-slate-50 disabled:text-slate-600"
                      />
                    </label>
                  </div>

                  <label className="mt-4 block">
                    <span className="mb-2 block text-sm font-black text-slate-700">
                      상품명·결제내용{" "}
                      <span className="font-bold text-slate-400">선택</span>
                    </span>
                    <input
                      value={paymentRequestForm.itemName}
                      disabled={Boolean(activePaymentQueueItem)}
                      onChange={(event) =>
                        setPaymentRequestForm((prev) => ({
                          ...prev,
                          itemName: event.target.value.slice(0, 100),
                        }))
                      }
                      placeholder={DEFAULT_PAYMENT_ITEM_NAME}
                      className="min-h-[48px] w-full rounded-xl border border-slate-200 px-3 text-base font-bold outline-none focus:border-emerald-600 disabled:bg-slate-50 disabled:text-slate-600"
                    />
                    <span className="mt-2 block text-xs font-bold text-slate-500">
                      비워 두어도 기본값인 ‘물품대금’으로 요청됩니다. 필요한 경우에만 내용을 바꿔 주세요.
                    </span>
                  </label>

                  {["STANDARD", "BUYLINK"].includes(paymentRequestForm.requestType) ? (
                    <div className="mt-4 space-y-4">
                    <label className="block">
                      <span className="mb-2 block text-sm font-black text-slate-700">
                        결제 법인 <span className="text-red-600">*</span>
                      </span>
                      <select
                        value={paymentRequestForm.paymentProfileId}
                        disabled={Boolean(selectedPaymentVendor?.linkPaymentProfileId)}
                        onChange={(event) =>
                          setPaymentRequestForm((prev) => ({
                            ...prev,
                            paymentProfileId: event.target.value,
                          }))
                        }
                        className="min-h-[48px] w-full rounded-xl border border-slate-200 px-3 text-sm font-bold outline-none focus:border-emerald-600 disabled:bg-slate-50 disabled:text-slate-600 sm:text-base"
                      >
                        {LINK_PAYMENT_PROFILE_OPTIONS.map((profile) => {
                          const config = ((paymentRequestForm.requestType === "STANDARD"
                            ? standardPaymentConfig
                            : paymentLinkConfig
                          )?.profiles || []).find(
                            (item) => item.id === profile.value
                          );
                          return (
                            <option key={profile.value} value={profile.value}>
                              {profile.label} · {profile.siteCd}
                              {config?.executionEnabled
                                ? " · 사용 가능"
                                : config?.configured
                                ? " · 실행 잠금"
                                : " · 설정 필요"}
                            </option>
                          );
                        })}
                      </select>
                    </label>
                    {paymentRequestForm.requestType === "BUYLINK" && (
                      <div>
                        <p className="mb-3 text-xs font-bold leading-5 text-emerald-800">
                          거래처 정보의 휴대폰 번호와 이메일을 자동으로 입력했습니다. 등록 정보가 없거나 틀린 경우에만 수정해 주세요.
                        </p>
                        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                        <label className="block">
                          <span className="mb-2 block text-sm font-black text-slate-700">
                            주문자 휴대폰 <span className="text-red-600">*</span>
                          </span>
                          <input
                            value={maskKoreanMobilePhone(
                              paymentRequestForm.buyerPhone
                            )}
                            onFocus={(event) => event.currentTarget.select()}
                            onClick={(event) => event.currentTarget.select()}
                            onChange={(event) =>
                              setPaymentRequestForm((prev) => ({
                                ...prev,
                                buyerPhone: event.target.value.replace(/\D/g, "").slice(0, 11),
                              }))
                            }
                            inputMode="tel"
                            autoComplete="off"
                            placeholder="01012345678"
                            className="min-h-[48px] w-full rounded-xl border border-slate-200 px-3 text-base font-bold outline-none focus:border-emerald-600"
                          />
                        </label>
                        <label className="block">
                          <span className="mb-2 block text-sm font-black text-slate-700">
                            주문자 이메일 <span className="text-red-600">*</span>
                          </span>
                          <input
                            type="email"
                            value={paymentRequestForm.buyerEmail}
                            onChange={(event) =>
                              setPaymentRequestForm((prev) => ({
                                ...prev,
                                buyerEmail: event.target.value.slice(0, 100),
                              }))
                            }
                            autoComplete="off"
                            placeholder="buyer@example.com"
                            className="min-h-[48px] w-full rounded-xl border border-slate-200 px-3 text-base font-bold outline-none focus:border-emerald-600"
                          />
                        </label>
                        </div>
                      </div>
                    )}
                    </div>
                  ) : paymentRequestForm.requestType === "KEYIN" ? (
                    <div className="mt-4 space-y-4 border-l-4 border-amber-400 bg-amber-50 px-4 py-4">
                      <div className="grid grid-cols-1 gap-1 text-xs font-bold text-amber-950 sm:grid-cols-2">
                        <span>담당 사업장: {selectedPaymentVendor?.companyBranchName || "미선택"}</span>
                        <span>
                          키인 법인:{" "}
                          {KEYIN_PAYMENT_PROFILE_OPTIONS.find(
                            (profile) => profile.value === paymentRequestForm.keyinProfileId
                          )?.label || "프로필 미연결"}
                        </span>
                      </div>
                      <div>
                        <p className="text-sm font-black text-amber-950">일회성 카드 입력</p>
                        <p className="mt-1 text-xs font-bold leading-5 text-amber-900 break-keep">
                          탭 이동, 성공, 실패 시 즉시 지웁니다. KCP 공식 KEY-IN 규격은 카드번호·유효기간·생년월일/사업자번호·카드 비밀번호 앞 2자리를 필수로 사용하며 CVC·전화번호·이메일은 받지 않습니다.
                        </p>
                      </div>
                      <label className="block">
                        <span className="mb-2 block text-sm font-black text-slate-700">
                          카드번호 <span className="text-red-600">*</span>
                        </span>
                        <input
                          value={sensitiveCardInput.cardNumber}
                          onChange={(event) =>
                            setSensitiveCardInput((prev) => ({
                              ...prev,
                              cardNumber: formatPaymentCardNumberInput(event.target.value),
                            }))
                          }
                          inputMode="numeric"
                          autoComplete="off"
                          placeholder="0000 0000 0000 0000"
                          className="min-h-[48px] w-full rounded-xl border border-amber-200 bg-white px-3 text-base font-bold outline-none focus:border-amber-600"
                        />
                      </label>
                      <div className="grid grid-cols-2 gap-3">
                        <label className="block">
                          <span className="mb-2 block text-sm font-black text-slate-700">
                            유효기간 <span className="text-red-600">*</span>
                          </span>
                          <input
                            value={sensitiveCardInput.cardExpiry}
                            onChange={(event) =>
                              setSensitiveCardInput((prev) => ({
                                ...prev,
                                cardExpiry: formatPaymentCardExpiryInput(event.target.value),
                              }))
                            }
                            inputMode="numeric"
                            autoComplete="off"
                            placeholder="MM/YY"
                            className="min-h-[48px] w-full rounded-xl border border-amber-200 bg-white px-3 text-base font-bold outline-none focus:border-amber-600"
                          />
                        </label>
                        <label className="block">
                          <span className="mb-2 block text-sm font-black text-slate-700">
                            생년월일/사업자번호 <span className="text-red-600">*</span>
                          </span>
                          <input
                            type="password"
                            value={sensitiveCardInput.cardTaxNo}
                            onChange={(event) =>
                              setSensitiveCardInput((prev) => ({
                                ...prev,
                                cardTaxNo: event.target.value.replace(/\D/g, "").slice(0, 10),
                              }))
                            }
                            inputMode="numeric"
                            autoComplete="off"
                            placeholder="6자리 또는 10자리"
                            className="min-h-[48px] w-full rounded-xl border border-amber-200 bg-white px-3 text-base font-bold outline-none focus:border-amber-600"
                          />
                        </label>
                      </div>
                      <div className="grid grid-cols-2 gap-3">
                        <label className="block">
                          <span className="mb-2 block text-sm font-black text-slate-700">
                            카드 비밀번호 앞 2자리 <span className="text-red-600">*</span>
                          </span>
                          <input
                            type="password"
                            value={sensitiveCardInput.cardPassword}
                            onChange={(event) =>
                              setSensitiveCardInput((prev) => ({
                                ...prev,
                                cardPassword: event.target.value.replace(/\D/g, "").slice(0, 2),
                              }))
                            }
                            inputMode="numeric"
                            autoComplete="off"
                            placeholder="2자리"
                            className="min-h-[48px] w-full rounded-xl border border-amber-200 bg-white px-3 text-base font-bold outline-none focus:border-amber-600"
                          />
                        </label>
                        <label className="block">
                          <span className="mb-2 block text-sm font-black text-slate-700">
                            할부개월
                          </span>
                          <select
                            value={paymentRequestForm.quota}
                            onChange={(event) =>
                              setPaymentRequestForm((prev) => ({
                                ...prev,
                                quota: event.target.value,
                              }))
                            }
                            className="min-h-[48px] w-full rounded-xl border border-amber-200 bg-white px-3 text-base font-bold outline-none focus:border-amber-600"
                          >
                            <option value="00">일시불</option>
                            {Array.from({ length: 11 }, (_, index) => String(index + 2).padStart(2, "0")).map((quota) => (
                              <option key={quota} value={quota}>{Number(quota)}개월</option>
                            ))}
                          </select>
                        </label>
                      </div>
                      {!activePaymentQueueItem && selectedKeyinProfileStatus?.executionEnabled && (
                        <>
                          <label className="block">
                            <span className="mb-2 block text-sm font-black text-slate-700">
                              승인 확인 문구 <span className="text-red-600">*</span>
                            </span>
                            <input
                              value={paymentRequestForm.keyinConfirmation}
                              onChange={(event) =>
                                setPaymentRequestForm((prev) => ({
                                  ...prev,
                                  keyinConfirmation: event.target.value.slice(0, 40),
                                }))
                              }
                              autoComplete="off"
                              placeholder="키인결제 승인 입력"
                              className="min-h-[48px] w-full rounded-xl border border-red-300 bg-white px-3 text-base font-bold outline-none focus:border-red-600"
                            />
                          </label>
                          <p className="text-xs font-bold leading-5 text-red-700 break-keep">
                            버튼을 누르면 실제 KCP KEY-IN 승인이 실행될 수 있습니다. 금액·고객·결제내용을 확인한 뒤 정확히 “키인결제 승인”을 입력하세요.
                          </p>
                        </>
                      )}
                    </div>
                  ) : (
                    <div className="mt-4 space-y-4 border-l-4 border-blue-500 bg-blue-50 px-4 py-4">
                      <div className="grid grid-cols-2 rounded-lg bg-blue-100 p-1">
                        {[
                          ["REGISTER", "카드등록 링크"],
                          ["CHARGE", "등록카드 승인"],
                        ].map(([value, label]) => (
                          <button
                            key={value}
                            type="button"
                            aria-pressed={autopayAction === value}
                            onClick={() => {
                              setAutopayAction(value);
                              setAutopayConfirmation("");
                              setPaymentRequestsError("");
                            }}
                            className={`min-h-[44px] rounded-md px-3 text-sm font-black ${
                              autopayAction === value
                                ? "bg-white text-blue-950 shadow-sm"
                                : "text-blue-700"
                            }`}
                          >
                            {label}
                          </button>
                        ))}
                      </div>

                      {autopayAction === "REGISTER" ? (
                        <>
                          <label className="block">
                            <span className="mb-2 block text-sm font-black text-slate-700">
                              결제 법인 <span className="text-red-600">*</span>
                            </span>
                            <select
                              value={paymentRequestForm.autopayProfileId}
                              disabled={Boolean(selectedPaymentVendor?.autopayProfileId)}
                              onChange={(event) =>
                                setPaymentRequestForm((prev) => ({
                                  ...prev,
                                  autopayProfileId: event.target.value,
                                }))
                              }
                              className="min-h-[48px] w-full rounded-lg border border-blue-200 bg-white px-3 text-sm font-bold outline-none focus:border-blue-600 disabled:bg-slate-50 disabled:text-slate-600 sm:text-base"
                            >
                              {AUTOPAY_PROFILE_OPTIONS.map((profile) => {
                                const config = (autopayConfig?.profiles || []).find(
                                  (item) => item.id === profile.value
                                );
                                return (
                                  <option key={profile.value} value={profile.value}>
                                    {profile.label}
                                    {config?.executionEnabled
                                      ? " · 사용 가능"
                                      : config?.configured
                                      ? " · 실행 잠금"
                                      : " · 설정 필요"}
                                  </option>
                                );
                              })}
                            </select>
                          </label>
                          <label className="block">
                            <span className="mb-2 block text-sm font-black text-slate-700">
                              카드 소유자 구분 <span className="text-red-600">*</span>
                            </span>
                            <select
                              value={paymentRequestForm.identityType}
                              onChange={(event) =>
                                setPaymentRequestForm((prev) => ({
                                  ...prev,
                                  identityType: event.target.value,
                                }))
                              }
                              className="min-h-[48px] w-full rounded-lg border border-blue-200 bg-white px-3 text-base font-bold outline-none focus:border-blue-600"
                            >
                              <option value="BUSINESS">법인·사업자 카드</option>
                              <option value="PERSONAL">개인 카드</option>
                            </select>
                          </label>
                          <div className="border border-blue-200 bg-white px-4 py-3 text-xs font-bold leading-5 text-blue-900 break-keep">
                            링크를 받은 거래처가 카드 구분명과 끝 4자리를 직접 입력하고 KCP 보안 화면에서 카드를 등록합니다. 카드사진·전체 카드번호·유효기간·비밀번호·CVC는 담당자가 받거나 입력하지 않습니다. 거래처별 복수 카드 등록과 메인 카드 지정이 가능합니다.
                          </div>
                        </>
                      ) : (
                        <>
                          <label className="block">
                            <span className="mb-2 block text-sm font-black text-slate-700">
                              등록카드 <span className="text-red-600">*</span>
                            </span>
                            <select
                              value={selectedAutopayMethodId}
                              onChange={(event) => {
                                const method = autopayMethods.find(
                                  (item) => item.billingMethodId === event.target.value
                                );
                                setSelectedAutopayMethodId(event.target.value);
                                setPaymentRequestForm((prev) => ({
                                  ...prev,
                                  vendorId: method?.vendorId || "",
                                  customerName:
                                    method?.customerName || prev.customerName,
                                }));
                              }}
                              className="min-h-[48px] w-full rounded-lg border border-blue-200 bg-white px-3 text-base font-bold outline-none focus:border-blue-600"
                            >
                              <option value="">등록카드 선택</option>
                              {selectedVendorChargeMethods.map((method) => (
                                  <option key={method.billingMethodId} value={method.billingMethodId}>
                                    {method.isPrimary ? "[메인] " : ""}{method.cardLabel || "카드 구분 미입력"} · {method.cardName || "카드사 확인 전"} · {method.cardNumberMasked || "끝 4자리 미확인"}
                                  </option>
                              ))}
                            </select>
                          </label>
                          {paymentRequestForm.vendorId && selectedVendorChargeMethods.length === 0 && (
                            <p className="text-xs font-black leading-5 text-amber-800">
                              이 거래처에는 담당자 확인이 완료된 등록카드가 없습니다. 카드등록 링크를 만든 뒤 거래처가 KCP 화면에서 직접 등록하도록 안내하세요.
                            </p>
                          )}
                          {selectedAutopayMethod && (
                            <p className="text-xs font-bold leading-5 text-blue-900">
                              {selectedAutopayMethod.isPrimary ? "메인 카드 · " : ""}{selectedAutopayMethod.vendorBusinessName || selectedAutopayMethod.customerName} · {selectedAutopayMethod.cardLabel || "카드 구분 미입력"} · {selectedAutopayMethod.cardName || "카드사 확인 전"} · {selectedAutopayMethod.cardNumberMasked || "끝 4자리 미확인"}
                            </p>
                          )}
                          <label className="block">
                            <span className="mb-2 block text-sm font-black text-slate-700">
                              승인 확인 문구 <span className="text-red-600">*</span>
                            </span>
                            <input
                              value={autopayConfirmation}
                              onChange={(event) => setAutopayConfirmation(event.target.value.slice(0, 40))}
                              autoComplete="off"
                              placeholder="등록카드 결제 입력"
                              className="min-h-[48px] w-full rounded-lg border border-blue-200 bg-white px-3 text-base font-bold outline-none focus:border-blue-600"
                            />
                          </label>
                          <p className="text-xs font-bold leading-5 text-red-700 break-keep">
                            승인 버튼을 누르면 실제 KCP 결제가 실행될 수 있습니다. 금액·고객·결제내용·사유를 확인한 후 정확히 “등록카드 결제”를 입력하세요.
                          </p>
                        </>
                      )}
                    </div>
                  )}

                  <label className="mt-4 block">
                    <span className="mb-2 block text-sm font-black text-slate-700">
                      {paymentRequestForm.requestType === "AUTOPAY" && autopayAction === "CHARGE"
                        ? "승인 사유"
                        : "메모"}{" "}
                      <span className="font-bold text-slate-400">
                        {paymentRequestForm.requestType === "AUTOPAY" && autopayAction === "CHARGE"
                          ? "5자 이상 필수"
                          : "선택"}
                      </span>
                    </span>
                    <textarea
                      value={paymentRequestForm.memo}
                      disabled={Boolean(activePaymentQueueItem)}
                      onChange={(event) =>
                        setPaymentRequestForm((prev) => ({
                          ...prev,
                          memo: event.target.value.slice(0, 300),
                        }))
                      }
                      rows={3}
                      placeholder={
                        paymentRequestForm.requestType === "AUTOPAY" && autopayAction === "CHARGE"
                          ? "예: 7월 납품대금 고객 승인"
                          : "내부 확인용 메모"
                      }
                      className="w-full rounded-xl border border-slate-200 px-3 py-3 text-base font-bold outline-none focus:border-emerald-600 disabled:bg-slate-50 disabled:text-slate-600"
                    />
                    <span className="mt-2 block text-xs font-bold leading-5 text-red-700 break-keep">
                      내부 메모에도 주민등록번호·생년월일·휴대폰번호·카드정보를 입력하지
                      마세요.
                    </span>
                  </label>

                  {paymentRequestsError && (
                    <div className="mt-4 border border-red-200 bg-red-50 px-4 py-3 text-sm font-bold leading-6 text-red-700">
                      {paymentRequestsError}
                    </div>
                  )}

                  <button
                    type="submit"
                    disabled={
                      paymentRequestSaving ||
                      (isSalesPaymentMode &&
                        (paymentRequestForm.requestType !== "BUYLINK" ||
                          !selectedPaymentLinkProfileStatus?.executionEnabled)) ||
                      (!activePaymentQueueItem &&
                        paymentRequestForm.requestType !== "AUTOPAY" &&
                        (!paymentRequestForm.vendorId ||
                          !selectedVendorPaymentMappingReady)) ||
                      (!activePaymentQueueItem &&
                        ["STANDARD", "BUYLINK"].includes(paymentRequestForm.requestType) &&
                        selectedPaymentLinkProfileStatus?.executionEnabled &&
                        !selectedVendorPaymentOperationReady) ||
                      (paymentRequestForm.requestType === "BUYLINK" &&
                        (!/^0\d{9,10}$/.test(paymentRequestForm.buyerPhone) ||
                          !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(paymentRequestForm.buyerEmail))) ||
                      (paymentRequestForm.requestType === "KEYIN" &&
                        (!/^\d{16}$/.test(sensitiveCardInput.cardNumber.replace(/\D/g, "")) ||
                          !/^\d{2}\/\d{2}$/.test(sensitiveCardInput.cardExpiry) ||
                          !/^\d{6}(?:\d{4})?$/.test(sensitiveCardInput.cardTaxNo) ||
                          !/^\d{2}$/.test(sensitiveCardInput.cardPassword) ||
                          (!activePaymentQueueItem &&
                            selectedKeyinProfileStatus?.executionEnabled &&
                            (!selectedVendorPaymentOperationReady ||
                              paymentRequestForm.keyinConfirmation !== "키인결제 승인")))) ||
                      (paymentRequestForm.requestType === "AUTOPAY" &&
                        (autopayAction === "REGISTER"
                          ? !paymentRequestForm.vendorId ||
                            !selectedVendorPaymentMappingReady ||
                            !selectedVendorPaymentOperationReady ||
                            !selectedAutopayProfileStatus?.executionEnabled
                          : !selectedAutopayMethodId ||
                            !isAutopayMethodReadyForCharge(selectedAutopayMethod || {}) ||
                            selectedAutopayMethod?.vendorId !== paymentRequestForm.vendorId ||
                            paymentRequestForm.memo.trim().length < 5 ||
                            autopayConfirmation !== "등록카드 결제"))
                    }
                    className="mt-5 inline-flex min-h-[52px] w-full items-center justify-center gap-2 rounded-2xl bg-emerald-700 px-4 py-3 text-base font-black text-white shadow-sm disabled:bg-slate-300"
                  >
                    {paymentRequestSaving ? (
                      <Loader2 className="h-5 w-5 animate-spin" />
                    ) : (
                      <ShieldCheck className="h-5 w-5" />
                    )}
                    {paymentRequestSaving
                      ? "안전하게 저장 중..."
                      : activePaymentQueueItem
                      ? "카드 입력 검증 후 다음 건"
                      : paymentRequestForm.requestType === "KEYIN"
                      ? activePaymentQueueItem
                        ? "카드 입력 검증 후 다음 건"
                        : selectedKeyinProfileStatus?.executionEnabled
                        ? "KCP KEY-IN 실제 승인"
                        : "키인결제 초안 저장"
                      : paymentRequestForm.requestType === "AUTOPAY" &&
                        autopayAction === "REGISTER"
                      ? "KCP 카드등록 링크 생성"
                      : paymentRequestForm.requestType === "AUTOPAY"
                      ? "등록카드 실제 승인"
                      : paymentRequestForm.requestType === "STANDARD"
                      ? selectedPaymentLinkProfileStatus?.executionEnabled
                        ? "KCP 표준결제 링크 생성"
                        : "표준결제 초안 저장"
                      : selectedPaymentLinkProfileStatus?.executionEnabled
                      ? "KCP BUYLINK 생성"
                      : "BUYLINK 초안 저장"}
                  </button>
                </form>
                )}

                {showPaymentOperationsPanel && (
                <section className="border border-slate-200 bg-white p-5 shadow-sm">
                  <div className="flex flex-wrap items-center justify-between gap-3">
                    <div>
                      <p className="text-xs font-black uppercase text-slate-400">Payment Operations</p>
                      <h4 className="mt-1 text-lg font-black text-slate-950">결제 요청·승인 운영 현황</h4>
                      <p className="mt-1 text-xs font-bold text-slate-500">
                        거래처 링크 대기부터 승인·취소·오류까지 한 화면에서 조회하고 전달합니다.
                      </p>
                    </div>
                    <div className="flex items-center gap-2">
                      <button
                        type="button"
                        onClick={openPaymentOperationsSummaryPreview}
                        disabled={filteredPaymentRequests.length === 0}
                        className="inline-flex min-h-[44px] items-center justify-center gap-2 border border-slate-300 bg-white px-3 text-xs font-black text-slate-800 disabled:opacity-50"
                      >
                        <ClipboardCheck className="h-4 w-4" /> 조회 요약 전달
                      </button>
                      <button
                        type="button"
                        onClick={() => void loadPaymentRequests()}
                        disabled={paymentRequestsLoading}
                        title="결제 요청 다시 불러오기"
                        className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-slate-200 text-slate-600 disabled:opacity-50"
                      >
                        <RefreshCcw className={`h-4 w-4 ${paymentRequestsLoading ? "animate-spin" : ""}`} />
                      </button>
                    </div>
                  </div>

                  <div className="mt-4 grid grid-cols-2 gap-2 sm:grid-cols-4">
                    {[
                      {
                        value: "ALL",
                        label: "전체",
                        badgeClassName: "bg-slate-900 text-white",
                        count: paymentOperationsSummary.totalCount,
                      },
                      ...PAYMENT_OPERATIONS_STATUS_OPTIONS.map((option) => ({
                        ...option,
                        count: paymentOperationsSummary.byStatus[option.value] || 0,
                      })),
                    ].map((option) => (
                      <button
                        key={option.value}
                        type="button"
                        aria-pressed={paymentHistoryFilters.status === option.value}
                        onClick={() =>
                          setPaymentHistoryFilters((prev) => ({
                            ...prev,
                            status: option.value,
                          }))
                        }
                        className={`min-h-[72px] border px-3 py-2 text-left transition ${
                          paymentHistoryFilters.status === option.value
                            ? "border-slate-950 ring-2 ring-slate-950/10"
                            : "border-slate-200 hover:border-slate-400"
                        }`}
                      >
                        <span
                          className={`inline-flex rounded-full px-2 py-1 text-[10px] font-black ${option.badgeClassName}`}
                        >
                          {option.shortLabel || option.label}
                        </span>
                        <strong className="mt-2 block text-lg font-black text-slate-950">
                          {option.count}건
                        </strong>
                      </button>
                    ))}
                  </div>

                  <div className="mt-4 grid grid-cols-1 gap-2 border-y border-slate-200 bg-slate-50 px-3 py-3 sm:grid-cols-[1fr_1fr_1fr_auto]">
                    <label className="block">
                      <span className="mb-1 block text-[11px] font-black text-slate-500">
                        조회 시작일
                      </span>
                      <input
                        type="date"
                        value={paymentHistoryFilters.dateFrom}
                        max={paymentHistoryFilters.dateTo}
                        onChange={(event) =>
                          setPaymentHistoryFilters((prev) => ({
                            ...prev,
                            dateFrom: event.target.value,
                          }))
                        }
                        className="min-h-[42px] w-full border border-slate-200 bg-white px-3 text-sm font-bold outline-none focus:border-emerald-600"
                      />
                    </label>
                    <label className="block">
                      <span className="mb-1 block text-[11px] font-black text-slate-500">
                        조회 종료일
                      </span>
                      <input
                        type="date"
                        value={paymentHistoryFilters.dateTo}
                        min={paymentHistoryFilters.dateFrom}
                        onChange={(event) =>
                          setPaymentHistoryFilters((prev) => ({
                            ...prev,
                            dateTo: event.target.value,
                          }))
                        }
                        className="min-h-[42px] w-full border border-slate-200 bg-white px-3 text-sm font-bold outline-none focus:border-emerald-600"
                      />
                    </label>
                    <label className="block">
                      <span className="mb-1 block text-[11px] font-black text-slate-500">
                        결제 유형
                      </span>
                      <select
                        value={paymentHistoryFilters.requestType}
                        onChange={(event) =>
                          setPaymentHistoryFilters((prev) => ({
                            ...prev,
                            requestType: event.target.value,
                          }))
                        }
                        className="min-h-[42px] w-full border border-slate-200 bg-white px-3 text-sm font-bold outline-none focus:border-emerald-600"
                      >
                        <option value="ALL">전체 결제</option>
                        <option value="KEYIN">키인결제</option>
                        <option value="STANDARD">표준결제</option>
                        <option value="BUYLINK">BUYLINK</option>
                        <option value="AUTOPAY">등록카드</option>
                      </select>
                    </label>
                    <button
                      type="button"
                      onClick={() => void loadPaymentRequests()}
                      disabled={
                        paymentRequestsLoading ||
                        !paymentHistoryFilters.dateFrom ||
                        !paymentHistoryFilters.dateTo ||
                        paymentHistoryFilters.dateFrom > paymentHistoryFilters.dateTo
                      }
                      className="min-h-[42px] self-end bg-slate-900 px-4 text-sm font-black text-white disabled:bg-slate-300"
                    >
                      기간 조회
                    </button>
                  </div>
                  <div className="grid grid-cols-1 gap-2 border-b border-slate-200 bg-slate-50 px-3 pb-3 sm:grid-cols-2 xl:grid-cols-4">
                    <label className="block sm:col-span-2">
                      <span className="mb-1 block text-[11px] font-black text-slate-500">
                        통합 검색
                      </span>
                      <div className="relative">
                        <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
                        <input
                          type="search"
                          value={paymentHistoryFilters.query}
                          onChange={(event) =>
                            setPaymentHistoryFilters((prev) => ({
                              ...prev,
                              query: event.target.value,
                            }))
                          }
                          placeholder="거래처명·ERP코드·사업자번호·품목·담당자·승인번호"
                          className="min-h-[42px] w-full border border-slate-200 bg-white pl-10 pr-3 text-sm font-bold outline-none focus:border-emerald-600"
                        />
                      </div>
                    </label>
                    <label className="block">
                      <span className="mb-1 block text-[11px] font-black text-slate-500">
                        결제 법인
                      </span>
                      <select
                        value={paymentHistoryFilters.paymentCompany}
                        onChange={(event) =>
                          setPaymentHistoryFilters((prev) => ({
                            ...prev,
                            paymentCompany: event.target.value,
                          }))
                        }
                        className="min-h-[42px] w-full border border-slate-200 bg-white px-3 text-sm font-bold outline-none focus:border-emerald-600"
                      >
                        <option value="ALL">전체 법인</option>
                        {paymentHistoryFilterOptions.paymentCompanies.map((companyName) => (
                          <option key={companyName} value={companyName}>
                            {companyName}
                          </option>
                        ))}
                      </select>
                    </label>
                    <label className="block">
                      <span className="mb-1 block text-[11px] font-black text-slate-500">
                        요청 담당자
                      </span>
                      <select
                        value={paymentHistoryFilters.createdBy}
                        onChange={(event) =>
                          setPaymentHistoryFilters((prev) => ({
                            ...prev,
                            createdBy: event.target.value,
                          }))
                        }
                        className="min-h-[42px] w-full border border-slate-200 bg-white px-3 text-sm font-bold outline-none focus:border-emerald-600"
                      >
                        <option value="ALL">전체 담당자</option>
                        {paymentHistoryFilterOptions.createdBy.map((createdBy) => (
                          <option key={createdBy} value={createdBy}>
                            {createdBy}
                          </option>
                        ))}
                      </select>
                    </label>
                    <label className="block">
                      <span className="mb-1 block text-[11px] font-black text-slate-500">
                        운영 환경
                      </span>
                      <select
                        value={paymentHistoryFilters.environment}
                        onChange={(event) =>
                          setPaymentHistoryFilters((prev) => ({
                            ...prev,
                            environment: event.target.value,
                          }))
                        }
                        className="min-h-[42px] w-full border border-slate-200 bg-white px-3 text-sm font-bold outline-none focus:border-emerald-600"
                      >
                        <option value="ALL">전체 환경</option>
                        <option value="live">운영</option>
                        <option value="test">Sandbox</option>
                      </select>
                    </label>
                    <label className="block">
                      <span className="mb-1 block text-[11px] font-black text-slate-500">
                        정렬
                      </span>
                      <select
                        value={paymentHistoryFilters.sort}
                        onChange={(event) =>
                          setPaymentHistoryFilters((prev) => ({
                            ...prev,
                            sort: event.target.value,
                          }))
                        }
                        className="min-h-[42px] w-full border border-slate-200 bg-white px-3 text-sm font-bold outline-none focus:border-emerald-600"
                      >
                        <option value="NEWEST">최신순</option>
                        <option value="OLDEST">오래된순</option>
                        <option value="AMOUNT_DESC">금액 높은순</option>
                        <option value="AMOUNT_ASC">금액 낮은순</option>
                      </select>
                    </label>
                    <button
                      type="button"
                      onClick={() => setPaymentHistoryFilters(getDefaultPaymentHistoryRange())}
                      className="min-h-[42px] self-end border border-slate-300 bg-white px-3 text-xs font-black text-slate-700"
                    >
                      필터 초기화
                    </button>
                  </div>
                  <div className="mt-3 flex flex-wrap items-center justify-between gap-2 text-xs font-bold text-slate-500">
                    <p>
                      조회 결과 {filteredPaymentRequests.length}건 · 승인잔액 {filteredPaymentOperationsSummary.remainingAmount.toLocaleString("ko-KR")}원 · 취소누계 {filteredPaymentOperationsSummary.cancelledAmount.toLocaleString("ko-KR")}원
                    </p>
                    {filteredPaymentRequests.length > 100 && (
                      <p className="text-amber-700">화면에는 최신 100건까지만 표시됩니다.</p>
                    )}
                  </div>

                  {paymentRequestsLoading ? (
                    <div className="flex min-h-[220px] items-center justify-center text-sm font-black text-slate-500">
                      <Loader2 className="mr-2 h-5 w-5 animate-spin" /> 불러오는 중...
                    </div>
                  ) : filteredPaymentRequests.length === 0 ? (
                    <div className="mt-5 border border-dashed border-slate-200 bg-slate-50 px-5 py-10 text-center">
                      <CreditCard className="mx-auto h-8 w-8 text-slate-300" />
                      <p className="mt-3 text-sm font-black text-slate-700">
                        {paymentRequests.length > 0
                          ? "선택한 조건에 맞는 결제 요청이 없습니다."
                          : "저장된 결제 요청이 없습니다."}
                      </p>
                      {paymentRequests.length > 0 && (
                        <button
                          type="button"
                          onClick={() =>
                            setPaymentHistoryFilters(getDefaultPaymentHistoryRange())
                          }
                          className="mt-4 min-h-[40px] border border-slate-300 bg-white px-4 text-xs font-black text-slate-700"
                        >
                          필터 초기화
                        </button>
                      )}
                    </div>
                  ) : (
                    <div className="mt-5 space-y-3">
                      {filteredPaymentRequests.slice(0, 100).map((request) => {
                        const operationsStatus = getPaymentOperationsStatus(request);
                        return (
                        <article
                          key={request.paymentRequestId || request.id}
                          className="border-b border-slate-200 pb-4 last:border-b-0"
                        >
                          <div className="flex items-start justify-between gap-3">
                            <div className="min-w-0">
                              <div className="flex flex-wrap items-center gap-2">
                                <span className={`rounded-full px-2 py-1 text-[11px] font-black ${
                                  request.requestType === "KEYIN"
                                    ? "bg-amber-100 text-amber-800"
                                    : request.requestType === "AUTOPAY"
                                    ? "bg-blue-100 text-blue-800"
                                    : "bg-emerald-100 text-emerald-800"
                                }`}>
                                  {request.requestType === "KEYIN"
                                    ? "키인결제"
                                    : request.requestType === "AUTOPAY"
                                    ? "등록카드"
                                    : request.requestType === "STANDARD"
                                    ? "표준결제"
                                    : "BUYLINK"}
                                </span>
                                <span className={`rounded-full px-2 py-1 text-[11px] font-black ${operationsStatus.badgeClassName}`}>
                                  {operationsStatus.label}
                                </span>
                                {normalizePaymentRuntimeEnvironment(request.environment) === "test" && (
                                  <span className="rounded-full bg-violet-100 px-2 py-1 text-[11px] font-black text-violet-800">
                                    Sandbox 테스트
                                  </span>
                                )}
                                {request.batchId && (
                                  <span className="rounded-full bg-blue-50 px-2 py-1 text-[11px] font-black text-blue-700">
                                    {request.batchSequence}/{request.batchTotal}번
                                  </span>
                                )}
                              </div>
                              <p className="mt-2 break-words text-sm font-black text-slate-950">
                                {request.itemName || "결제 내용 미입력"}
                              </p>
                              <p className="mt-1 text-xs font-bold leading-5 text-slate-500">
                                {request.vendorBusinessName ||
                                  request.customerName ||
                                  "거래처 미연결"}
                                {request.vendorBusinessNumber
                                  ? ` · ${request.vendorBusinessNumber}`
                                  : ""}
                              </p>
                              {request.paymentCompanyName && (
                                <p className="mt-1 text-[11px] font-bold text-slate-400">
                                  {request.paymentCompanyName} · {request.paymentSiteCd || request.paymentSiteCdMasked || "KCP"}
                                </p>
                              )}
                              {request.externalRequestId && (
                                <p className="mt-1 break-all text-[11px] font-bold text-slate-400">
                                  외부요청 {request.externalRequestId}
                                </p>
                              )}
                            </div>
                            <p className="shrink-0 text-right text-base font-black text-slate-950">
                              {(Number(request.amount) || 0).toLocaleString("ko-KR")}원
                            </p>
                          </div>
                          <div className="mt-3 flex flex-wrap items-center justify-between gap-2 text-[11px] font-bold text-slate-400">
                            <span>
                              요청자 {request.requestedByName || request.createdBy || "-"} · {formatAdminUpdatedAt(request.createdAt)}
                            </span>
                            <span>
                              승인 {request.approvalStatus || "NOT_REQUESTED"} · 외부 실행 {request.executionStatus === "LOCKED" ? "잠금" : request.executionStatus}
                            </span>
                          </div>
                          <div className="mt-2 border-l-4 border-slate-300 bg-slate-50 px-3 py-2 text-xs leading-5 text-slate-700">
                            <p className="font-black">{operationsStatus.description}</p>
                            <p className="font-bold text-slate-500">
                              다음 확인: {operationsStatus.nextAction}
                            </p>
                          </div>
                          {(request.approvalCode || request.transactionId) && (
                            <p className="mt-2 break-all bg-emerald-50 px-3 py-2 text-xs font-bold leading-5 text-emerald-800">
                              승인번호 {request.approvalCode || "-"} · 거래번호 {request.transactionId || "-"}
                            </p>
                          )}
                          {(request.errorCode || request.errorMessage) && (
                            <p className="mt-2 break-words bg-red-50 px-3 py-2 text-xs font-bold leading-5 text-red-700">
                              오류 {request.errorCode || "-"} · {request.errorMessage || "상세 내용 없음"}
                            </p>
                          )}
                          {(request.cancellationErrorCode || request.cancellationErrorMessage) && (
                            <p className="mt-2 break-words bg-red-50 px-3 py-2 text-xs font-bold leading-5 text-red-700">
                              취소 오류 {request.cancellationErrorCode || "-"} · {request.cancellationErrorMessage || "상세 내용 없음"}
                            </p>
                          )}
                          {getPaymentOperationEnvironmentBlockMessage(
                            request.environment,
                            paymentRuntimeEnvironmentByType[request.requestType]
                          ) && (
                            <p className="mt-2 break-keep border border-amber-200 bg-amber-50 px-3 py-2 text-xs font-black leading-5 text-amber-900">
                              {getPaymentOperationEnvironmentBlockMessage(
                                request.environment,
                                paymentRuntimeEnvironmentByType[request.requestType]
                              )}
                            </p>
                          )}
                          {paymentOperationNotices[
                            request.paymentRequestId || request.id || ""
                          ] && (
                            <p
                              role="status"
                              className="mt-2 break-keep border border-blue-200 bg-blue-50 px-3 py-2 text-xs font-black leading-5 text-blue-900"
                            >
                              {paymentOperationNotices[
                                request.paymentRequestId || request.id || ""
                              ]}
                            </p>
                          )}
                          {paymentOperationErrors[
                            request.paymentRequestId || request.id || ""
                          ] && (
                            <p
                              role="alert"
                              className="mt-2 break-words border border-red-200 bg-red-50 px-3 py-2 text-xs font-black leading-5 text-red-700"
                            >
                              {paymentOperationErrors[
                                request.paymentRequestId || request.id || ""
                              ]}
                            </p>
                          )}
                          {request.transactionId &&
                            ["STANDARD", "BUYLINK", "KEYIN", "AUTOPAY"].includes(request.requestType) && (
                              <div className="mt-3 border-t border-slate-100 pt-3">
                                {(request.lastInquiryAt || request.cancelledAmount > 0) && (
                                  <div className="mb-3 grid grid-cols-2 gap-2 bg-slate-50 px-3 py-2 text-[11px] font-bold leading-5 text-slate-600 sm:grid-cols-4 lg:grid-cols-7">
                                    <span>
                                      잔액 {(Number(request.remainingAmount) || 0).toLocaleString("ko-KR")}원
                                    </span>
                                    <span>
                                      취소 {(Number(request.cancelledAmount) || 0).toLocaleString("ko-KR")}원
                                    </span>
                                    <span>조회 {request.inquiryResponseCode || "-"}</span>
                                    <span>
                                      최종 거래상태 {getKcpTransactionStatusLabel(request.inquiryFinalStatusCode)}
                                    </span>
                                    <span>
                                      정산상태 {getKcpTransactionStatusLabel(request.inquiryShopStatus)}
                                    </span>
                                    <span>카드사 {request.approvalCardName || "-"}</span>
                                    <span>{request.lastInquiryAt ? formatAdminUpdatedAt(request.lastInquiryAt) : "미조회"}</span>
                                  </div>
                                )}
                                {getPaymentCancellationHistoryRows(request).length > 0 && (
                                  <div className="mb-3 border border-amber-200 bg-amber-50 px-3 py-3">
                                    <p className="text-xs font-black text-amber-950">
                                      KCP 취소 승인 내역
                                    </p>
                                    <div className="mt-2 border border-amber-100 bg-white px-3 py-2 text-[11px] font-bold leading-5 text-amber-950">
                                      <p className="font-black">
                                        {getPaymentCancellationTimingSummary(request).approvalToCancellation}
                                      </p>
                                      {getPaymentCancellationTimingSummary(request).cancellationElapsed && (
                                        <p>{getPaymentCancellationTimingSummary(request).cancellationElapsed}</p>
                                      )}
                                      <p className="text-slate-600">
                                        {getPaymentCancellationTimingSummary(request).issuerPostingGuidance}
                                      </p>
                                    </div>
                                    <div className="mt-2 space-y-2">
                                      {getPaymentCancellationHistoryRows(request).map((history) => (
                                        <div
                                          key={history.id}
                                          className="border border-amber-100 bg-white px-3 py-2 text-[11px] font-bold leading-5 text-slate-700"
                                        >
                                          <div className="flex flex-wrap items-center justify-between gap-2">
                                            <span className="font-black text-amber-900">
                                              {getKcpTransactionStatusLabel(history.kcpModType)} · 취소 {history.cancelledAmount.toLocaleString("ko-KR")}원 · 잔액 {history.remainingAmount.toLocaleString("ko-KR")}원
                                            </span>
                                            <span>
                                              결과 {history.responseCode || "-"} · {history.completedAt ? formatAdminUpdatedAt(history.completedAt) : "시각 미확인"}
                                            </span>
                                          </div>
                                          {history.reason && <p>사유 {history.reason}</p>}
                                          {history.partialCancellationSequence && (
                                            <p className="break-all text-slate-500">
                                              KCP 부분취소 일련번호 {history.partialCancellationSequence}
                                            </p>
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                )}
                                <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
                                  <button
                                    type="button"
                                    onClick={() => void handleInquirePaymentRequest(request)}
                                    disabled={
                                      Boolean(paymentOperationSavingId) ||
                                      Boolean(
                                        getPaymentOperationEnvironmentBlockMessage(
                                          request.environment,
                                          paymentRuntimeEnvironmentByType[request.requestType]
                                        )
                                      )
                                    }
                                    className="inline-flex min-h-[40px] items-center justify-center gap-2 border border-slate-300 bg-white px-3 text-xs font-black text-slate-800 disabled:opacity-50"
                                  >
                                    {paymentOperationSavingId === `inquiry:${request.paymentRequestId}` ? (
                                      <Loader2 className="h-4 w-4 animate-spin" />
                                    ) : (
                                      <Search className="h-4 w-4" />
                                    )}
                                    거래조회
                                  </button>
                                  {request.status !== "CANCELED" &&
                                    Number(request.remainingAmount ?? request.amount) > 0 && (
                                      <>
                                        <button
                                          type="button"
                                          onClick={() => openPaymentCancellation(request, "FULL")}
                                          disabled={
                                            Boolean(paymentOperationSavingId) ||
                                            Boolean(
                                              getPaymentOperationEnvironmentBlockMessage(
                                                request.environment,
                                                paymentRuntimeEnvironmentByType[request.requestType]
                                              )
                                            )
                                          }
                                          className="inline-flex min-h-[40px] items-center justify-center gap-2 border border-red-300 bg-red-50 px-3 text-xs font-black text-red-800 disabled:opacity-50"
                                        >
                                          <Undo2 className="h-4 w-4" /> 전액·잔액 취소
                                        </button>
                                        <button
                                          type="button"
                                          onClick={() => openPaymentCancellation(request, "PARTIAL")}
                                          disabled={
                                            Boolean(paymentOperationSavingId) ||
                                            Boolean(
                                              getPaymentOperationEnvironmentBlockMessage(
                                                request.environment,
                                                paymentRuntimeEnvironmentByType[request.requestType]
                                              )
                                            )
                                          }
                                          className="inline-flex min-h-[40px] items-center justify-center gap-2 border border-amber-300 bg-amber-50 px-3 text-xs font-black text-amber-900 disabled:opacity-50"
                                        >
                                          <Undo2 className="h-4 w-4" /> 부분취소
                                        </button>
                                      </>
                                    )}
                                </div>

                                {paymentOperationTargetId === request.paymentRequestId && (
                                  <div className="mt-3 border-t border-red-100 pt-3">
                                    <div className="grid grid-cols-2 gap-2" role="group" aria-label="취소 유형">
                                      {[
                                        ["FULL", "전액·잔액"],
                                        ["PARTIAL", "부분"],
                                      ].map(([value, label]) => (
                                        <button
                                          key={value}
                                          type="button"
                                          aria-pressed={paymentCancellationForm.cancellationType === value}
                                          onClick={() =>
                                            setPaymentCancellationForm((prev) => ({
                                              ...prev,
                                              cancellationType: value,
                                              amount: value === "FULL" ? "" : prev.amount,
                                              taxAmount: value === "FULL" ? "" : prev.taxAmount,
                                              vatAmount: value === "FULL" ? "" : prev.vatAmount,
                                              freeAmount: value === "FULL" ? "" : prev.freeAmount,
                                              confirmation: "",
                                            }))
                                          }
                                          className={`min-h-[40px] border px-3 text-xs font-black ${
                                            paymentCancellationForm.cancellationType === value
                                              ? "border-red-600 bg-red-600 text-white"
                                              : "border-slate-200 bg-white text-slate-700"
                                          }`}
                                        >
                                          {label} 취소
                                        </button>
                                      ))}
                                    </div>
                                    {paymentCancellationForm.cancellationType === "PARTIAL" && (
                                      <label className="mt-3 block">
                                        <span className="mb-1 block text-xs font-black text-slate-700">
                                          부분취소 금액
                                        </span>
                                        <input
                                          type="text"
                                          inputMode="numeric"
                                          value={paymentCancellationForm.amount}
                                          onChange={(event) =>
                                            setPaymentCancellationForm((prev) => ({
                                              ...prev,
                                              amount: event.target.value.replace(/\D/g, "").slice(0, 12),
                                            }))
                                          }
                                          placeholder="취소할 금액"
                                          className="min-h-[44px] w-full border border-slate-200 px-3 text-sm font-bold outline-none focus:border-red-600"
                                        />
                                      </label>
                                    )}
                                    {paymentCancellationForm.cancellationType === "PARTIAL" &&
                                      request.inquiryTaxFlag === "TG03" && (
                                        <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-3">
                                          {[
                                            ["taxAmount", "공급가액"],
                                            ["vatAmount", "부가세"],
                                            ["freeAmount", "비과세"],
                                          ].map(([field, label]) => (
                                            <label key={field} className="block">
                                              <span className="mb-1 block text-xs font-black text-slate-700">
                                                {label}
                                              </span>
                                              <input
                                                type="text"
                                                inputMode="numeric"
                                                value={(paymentCancellationForm as any)[field]}
                                                onChange={(event) =>
                                                  setPaymentCancellationForm((prev) => ({
                                                    ...prev,
                                                    [field]: event.target.value.replace(/\D/g, "").slice(0, 12),
                                                  }))
                                                }
                                                placeholder="0"
                                                className="min-h-[44px] w-full border border-amber-200 px-3 text-sm font-bold outline-none focus:border-amber-600"
                                              />
                                            </label>
                                          ))}
                                          <p className="text-xs font-bold leading-5 text-amber-800 sm:col-span-3">
                                            복합과세 거래입니다. 세 항목의 합계가 부분취소 금액과 정확히 같아야 합니다.
                                          </p>
                                        </div>
                                      )}
                                    <label className="mt-3 block">
                                      <span className="mb-1 block text-xs font-black text-slate-700">
                                        취소 사유
                                      </span>
                                      <input
                                        value={paymentCancellationForm.reason}
                                        onChange={(event) =>
                                          setPaymentCancellationForm((prev) => ({
                                            ...prev,
                                            reason: event.target.value.slice(0, 100),
                                          }))
                                        }
                                        placeholder="5자 이상 입력"
                                        className="min-h-[44px] w-full border border-slate-200 px-3 text-sm font-bold outline-none focus:border-red-600"
                                      />
                                    </label>
                                    <label className="mt-3 block">
                                      <span className="mb-1 block text-xs font-black text-slate-700">
                                        확인 문구
                                      </span>
                                      <input
                                        value={paymentCancellationForm.confirmation}
                                        onChange={(event) =>
                                          setPaymentCancellationForm((prev) => ({
                                            ...prev,
                                            confirmation: event.target.value.slice(0, 20),
                                          }))
                                        }
                                        autoComplete="off"
                                        placeholder={
                                          paymentCancellationForm.cancellationType === "PARTIAL"
                                            ? "부분취소 입력"
                                            : "전체취소 입력"
                                        }
                                        className="min-h-[44px] w-full border border-red-200 px-3 text-sm font-bold outline-none focus:border-red-600"
                                      />
                                    </label>
                                    <p className="mt-2 break-keep text-xs font-bold leading-5 text-red-700">
                                      KCP 거래를 먼저 조회한 뒤 현재 잔액을 기준으로 취소합니다. 부분취소 이력이 있는 거래의 잔액 취소는 KCP 규격에 따라 STPC로 처리됩니다.
                                    </p>
                                    <div className="mt-3 grid grid-cols-2 gap-2">
                                      <button
                                        type="button"
                                        onClick={closePaymentCancellation}
                                        disabled={Boolean(paymentOperationSavingId)}
                                        className="min-h-[42px] border border-slate-300 bg-white px-3 text-xs font-black text-slate-700 disabled:opacity-50"
                                      >
                                        닫기
                                      </button>
                                      <button
                                        type="button"
                                        onClick={() => void handleCancelPaymentRequest(request)}
                                        disabled={
                                          Boolean(paymentOperationSavingId) ||
                                          paymentCancellationForm.reason.trim().length < 5 ||
                                          paymentCancellationForm.confirmation !==
                                            (paymentCancellationForm.cancellationType === "PARTIAL"
                                              ? "부분취소"
                                              : "전체취소") ||
                                          (paymentCancellationForm.cancellationType === "PARTIAL" &&
                                            (!Number.isSafeInteger(Number(paymentCancellationForm.amount)) ||
                                              Number(paymentCancellationForm.amount) <= 0 ||
                                              Number(paymentCancellationForm.amount) >
                                                Number(request.remainingAmount ?? request.amount) ||
                                              (request.inquiryTaxFlag === "TG03" &&
                                                Number(paymentCancellationForm.taxAmount || 0) +
                                                  Number(paymentCancellationForm.vatAmount || 0) +
                                                  Number(paymentCancellationForm.freeAmount || 0) !==
                                                  Number(paymentCancellationForm.amount))))
                                        }
                                        className="inline-flex min-h-[42px] items-center justify-center gap-2 bg-red-700 px-3 text-xs font-black text-white disabled:bg-slate-300"
                                      >
                                        {paymentOperationSavingId === `cancel:${request.paymentRequestId}` ? (
                                          <Loader2 className="h-4 w-4 animate-spin" />
                                        ) : (
                                          <Undo2 className="h-4 w-4" />
                                        )}
                                        KCP 취소 실행
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </div>
                            )}
                          {request.requestType === "BUYLINK" &&
                            !request.transactionId &&
                            request.paymentUrl &&
                            (request.status === "LINK_READY" ||
                              request.approvalStatus === "WAITING_CUSTOMER") && (
                              <div className="mt-3 border-t border-blue-100 pt-3">
                                <button
                                  type="button"
                                  onClick={() =>
                                    void handleReconcileBuylinkPayment(request)
                                  }
                                  disabled={
                                    Boolean(paymentOperationSavingId) ||
                                    Boolean(
                                      getPaymentOperationEnvironmentBlockMessage(
                                        request.environment,
                                        paymentRuntimeEnvironmentByType[request.requestType]
                                      )
                                    )
                                  }
                                  className="inline-flex min-h-[40px] w-full items-center justify-center gap-2 border border-blue-300 bg-blue-50 px-3 text-xs font-black text-blue-900 disabled:opacity-50"
                                >
                                  {paymentOperationSavingId ===
                                  `reconcile:${request.paymentRequestId}` ? (
                                    <Loader2 className="h-4 w-4 animate-spin" />
                                  ) : (
                                    <RefreshCcw className="h-4 w-4" />
                                  )}
                                  승인결과 확인
                                </button>
                                <p className="mt-2 break-keep text-xs font-bold leading-5 text-blue-800">
                                  자동 승인 동기화가 지연될 때 다시 확인하는 복구 기능입니다.
                                  정상 결제는 Webhook 또는 서버 자동조회로 반영됩니다.
                                </p>
                              </div>
                            )}
                          <button
                            type="button"
                            onClick={() => openPaymentOperatorStatusPreview(request)}
                            className="mt-3 inline-flex min-h-[40px] w-full items-center justify-center gap-2 border border-slate-300 bg-slate-50 px-3 text-xs font-black text-slate-800"
                          >
                            <ClipboardCheck className="h-4 w-4" /> 담당자 상태 전달
                          </button>
                          {["STANDARD", "BUYLINK"].includes(request.requestType) && request.paymentUrl && (
                            <div className="mt-3 grid grid-cols-2 gap-2">
                              <button
                                type="button"
                                onClick={() => openPaymentCopyPreview(request, "LINK")}
                                className="inline-flex min-h-[40px] items-center justify-center gap-2 rounded-lg border border-emerald-300 bg-emerald-50 px-3 text-xs font-black text-emerald-900"
                              >
                                <ClipboardCheck className="h-4 w-4" /> 거래처 링크
                              </button>
                              <button
                                type="button"
                                onClick={() => openPaymentCopyPreview(request, "MESSAGE")}
                                className="inline-flex min-h-[40px] items-center justify-center gap-2 rounded-lg border border-slate-300 bg-white px-3 text-xs font-black text-slate-800"
                              >
                                <ClipboardCheck className="h-4 w-4" /> 거래처 안내
                              </button>
                            </div>
                          )}
                        </article>
                        );
                      })}
                    </div>
                  )}
                </section>
                )}
                {showPaymentDepositPanel && (
                  <PaymentDepositLedger
                    requests={paymentRequests}
                    loading={paymentRequestsLoading}
                    error={paymentRequestsError}
                    savingId={paymentDepositSavingId}
                    onReload={({ dateFrom, dateTo }) =>
                      loadPaymentRequests({ dateFrom, dateTo })
                    }
                    onSave={handleSavePaymentDepositManagement}
                    onExcludeFromErp={handleExcludePaymentFromErp}
                    canExcludeFromErp={adminTestModeAuthorized}
                    onNotify={setToastMessage}
                  />
                )}
                {showErpBridgePanel && (
                  <ErpBridgePanel
                    loading={erpBridgeLoading}
                    error={erpBridgeError}
                    summary={erpBridgeSummary}
                    onReload={loadErpBridge}
                    onCreateBatch={createErpBridgeBatch}
                    onNotify={setToastMessage}
                    cardRoutingConfiguration={erpCardConfiguration}
                    cardRoutingLoading={erpCardConfigurationLoading}
                    cardRoutingSaving={erpCardConfigurationSaving}
                    cardRoutingError={erpCardConfigurationError}
                    onReloadCardRouting={loadErpCardConfiguration}
                    onCreateCardMapping={createErpCardMapping}
                    onUpdateCardMapping={updateErpCardMapping}
                    onDeleteCardMapping={deleteErpCardMapping}
                    onToggleCardMapping={toggleErpCardMapping}
                    operationsSnapshot={
                      erpBridgeSummary?.operations || erpBridgeSummary?.operationsStatus || null
                    }
                  />
                )}
                {paymentCopyPreview && (
                  <div
                    className="fixed inset-0 z-[140] flex items-center justify-center bg-slate-950/60 p-4"
                    role="presentation"
                  >
                    <section
                      role="dialog"
                      aria-modal="true"
                      aria-labelledby="payment-copy-preview-title"
                      className="w-full max-w-xl rounded-2xl bg-white p-5 shadow-2xl"
                    >
                      <h4
                        id="payment-copy-preview-title"
                        className="text-lg font-black text-slate-950"
                      >
                        {paymentCopyPreview.title}
                      </h4>
                      <p className="mt-2 text-sm font-bold leading-6 text-slate-600">
                        아래 내용을 확인한 뒤 복사해 주세요.
                      </p>
                      <textarea
                        readOnly
                        value={paymentCopyPreview.text}
                        aria-label={paymentCopyPreview.title}
                        rows={
                          paymentCopyPreview.kind === "SUMMARY"
                            ? 12
                            : paymentCopyPreview.kind === "STATUS"
                            ? 10
                            : paymentCopyPreview.kind === "MESSAGE"
                            ? 7
                            : 4
                        }
                        className="mt-4 w-full resize-none rounded-xl border border-slate-200 bg-slate-50 px-3 py-3 text-sm font-bold leading-6 text-slate-800 outline-none"
                      />
                      <div className="mt-4 grid grid-cols-2 gap-2">
                        <button
                          type="button"
                          onClick={() => setPaymentCopyPreview(null)}
                          className="min-h-[44px] rounded-xl border border-slate-300 bg-white px-4 text-sm font-black text-slate-700"
                        >
                          닫기
                        </button>
                        <button
                          type="button"
                          onClick={() => void confirmPaymentCopyPreview()}
                          className="inline-flex min-h-[44px] items-center justify-center gap-2 rounded-xl bg-emerald-700 px-4 text-sm font-black text-white"
                        >
                          <ClipboardCheck className="h-4 w-4" /> 확인 후 복사
                        </button>
                      </div>
                    </section>
                  </div>
                )}
              </div>
            </div>
          ) : adminTab === "COMPANY_BRANCHES" ? (
            <div className="animate-in fade-in space-y-4">
              <div className="rounded-2xl border border-blue-100 bg-blue-50 p-5">
                <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
                  <div>
                    <p className="text-xs font-black uppercase tracking-[0.18em] text-blue-700">
                      Company Branches
                    </p>
                    <h3 className="mt-2 text-xl font-black text-blue-950">
                      우리회사 사업장 관리
                    </h3>
                    <p className="mt-2 max-w-3xl break-keep text-sm font-bold leading-6 text-blue-900">
                      화성법인, 인천법인 등 우리 회사 사업장을 등록하고 거래처·계약·결제 준비의 기준 사업장으로 사용합니다.
                      KCP secret/cert/key와 카드정보는 저장하지 않습니다.
                    </p>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {!isPaymentOnlyMode && (
                    <button
                      type="button"
                      onClick={() => openCompanyBranchModal()}
                      className="rounded-2xl bg-blue-700 px-4 py-3 text-sm font-black text-white shadow-sm"
                    >
                      사업장 등록
                    </button>
                    )}
                    <button
                      type="button"
                      onClick={() =>
                        isPaymentOnlyMode ? void loadPaymentDirectory() : void loadCompanyBranches()
                      }
                      disabled={companyBranchesLoading || paymentDirectoryLoading}
                      className="rounded-2xl bg-white px-4 py-3 text-sm font-black text-blue-800 shadow-sm disabled:opacity-60"
                    >
                      다시 불러오기
                    </button>
                  </div>
                </div>
                <div className="mt-4 grid grid-cols-2 gap-2 text-xs font-black text-blue-900 lg:grid-cols-4">
                  {[
                    ["등록 사업장", companyBranches.length],
                    ["활성 사업장", companyBranches.filter((branch) => branch.active !== false).length],
                    [
                      "PG 활성",
                      companyBranches.filter((branch) => branch.pgProfile?.status === "ACTIVE").length,
                    ],
                    [
                      "기본 사업장",
                      companyBranches.find((branch) => branch.isDefault)?.branchName || "미지정",
                    ],
                  ].map(([label, value]) => (
                    <span key={label} className="rounded-full bg-white/80 px-3 py-2">
                      {label}: {value}
                    </span>
                  ))}
                </div>
              </div>

              {(companyBranchesError || (isPaymentOnlyMode && paymentDirectoryError)) && (
                <div className="rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm font-bold leading-6 text-red-700">
                  {companyBranchesError || paymentDirectoryError}
                </div>
              )}

              {(companyBranchesLoading || (isPaymentOnlyMode && paymentDirectoryLoading)) ? (
                <div className="flex min-h-[180px] items-center justify-center rounded-2xl border border-slate-200 bg-white text-sm font-black text-slate-500">
                  <Loader2 className="mr-2 h-5 w-5 animate-spin" />
                  사업장 정보를 불러오는 중...
                </div>
              ) : companyBranches.length === 0 ? (
                <div className="rounded-2xl border border-dashed border-slate-200 bg-white px-5 py-10 text-center">
                  <Building2 className="mx-auto mb-3 h-8 w-8 text-slate-300" />
                  <p className="font-black text-slate-700">
                    등록된 우리회사 사업장이 없습니다.
                  </p>
                  <p className="mt-2 text-sm font-bold leading-6 text-slate-500 break-keep">
                    화성법인과 인천법인은 이름만 템플릿으로 제안됩니다. 실제 사업자번호와 주소는 관리자 등록값을 사용합니다.
                  </p>
                  {!isPaymentOnlyMode && (
                  <div className="mt-4 flex flex-wrap justify-center gap-2">
                    {COMPANY_BRANCH_SEED_TEMPLATE_NAMES.map((branchName) => (
                      <button
                        key={branchName}
                        type="button"
                        onClick={() =>
                          openCompanyBranchModal(
                            normalizeCompanyBranchRow({
                              branchName,
                              corporationName: "",
                              active: true,
                              isDefault: branchName === "화성법인",
                            }).branch
                          )
                        }
                        className="rounded-full bg-blue-50 px-4 py-2 text-sm font-black text-blue-700"
                      >
                        {branchName} 등록 시작
                      </button>
                    ))}
                  </div>
                  )}
                </div>
              ) : (
                <div className="grid grid-cols-1 gap-4 xl:grid-cols-[minmax(0,1fr)_360px]">
                  <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">
                    {companyBranches.map((branch) => {
                      const kpi = companyBranchKpis.find(
                        (item) => item.branchId === (branch.branchId || branch.id)
                      );
                      const pgStatusLabel =
                        COMPANY_BRANCH_PG_STATUS_OPTIONS.find(
                          (option) => option.value === branch.pgProfile?.status
                        )?.label || "미신청";
                      const linkPaymentDisplay =
                        getCompanyBranchLinkPaymentDisplay(branch.pgProfile);
                      return (
                        <div
                          key={branch.branchId || branch.id}
                          className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm"
                        >
                          <div className="flex items-start justify-between gap-3">
                            <div>
                              <p className="text-lg font-black text-slate-900">
                                {branch.branchName || "사업장명 미수집"}
                              </p>
                              <p className="mt-1 text-sm font-bold text-slate-500">
                                {branch.corporationName || "법인명 미수집"}
                              </p>
                            </div>
                            <div className="flex flex-col items-end gap-2">
                              {branch.isDefault && (
                                <span className="rounded-full bg-blue-50 px-3 py-1 text-xs font-black text-blue-700">
                                  기본
                                </span>
                              )}
                              <span className={`rounded-full px-3 py-1 text-xs font-black ${
                                branch.active === false
                                  ? "bg-slate-100 text-slate-500"
                                  : "bg-emerald-50 text-emerald-700"
                              }`}>
                                {branch.active === false ? "비활성" : "활성"}
                              </span>
                            </div>
                          </div>
                          <div className="mt-4 space-y-2 text-sm font-bold text-slate-700">
                            {[
                              ["사업자번호", branch.businessNumber],
                              ["대표자", branch.representativeName],
                              ["주소", branch.address],
                              ["전화번호", branch.phone],
                              ["PG 상태", pgStatusLabel],
                              ["KCP site_cd", linkPaymentDisplay.siteCd],
                              [
                                "문자링크 법인",
                                linkPaymentDisplay.companyName,
                              ],
                              [
                                "키인 법인",
                                KEYIN_PAYMENT_PROFILE_OPTIONS.find(
                                  (profile) =>
                                    profile.value === branch.pgProfile?.keyinPaymentProfileId
                                )?.label,
                              ],
                              [
                                "등록카드 법인",
                                AUTOPAY_PROFILE_OPTIONS.find(
                                  (profile) =>
                                    profile.value === branch.pgProfile?.autopayProfileId
                                )?.label,
                              ],
                            ].map(([label, value]) => (
                              <div key={label} className="flex justify-between gap-3">
                                <span className="shrink-0 text-slate-400">{label}</span>
                                <span className="min-w-0 break-words text-right">
                                  {value || "미수집"}
                                </span>
                              </div>
                            ))}
                          </div>
                          <div className="mt-3 flex flex-wrap gap-2 text-xs font-black">
                            <span className="rounded-full bg-slate-100 px-2 py-1 text-slate-600">
                              거래처 {kpi?.vendorCount || 0}
                            </span>
                            <span className="rounded-full bg-blue-50 px-2 py-1 text-blue-700">
                              전자계약 {kpi?.electronicContractCount || 0}
                            </span>
                            <span className="rounded-full bg-amber-50 px-2 py-1 text-amber-700">
                              수기계약 {kpi?.legacyContractCount || 0}
                            </span>
                            <span className="rounded-full bg-purple-50 px-2 py-1 text-purple-700">
                              공동계약인 대기 {kpi?.coRepPendingCount || 0}
                            </span>
                          </div>
                          {!isPaymentOnlyMode && (
                          <div className="mt-4 flex flex-wrap gap-2">
                            <button
                              type="button"
                              onClick={() => openCompanyBranchModal(branch)}
                              className="rounded-full bg-slate-900 px-3 py-2 text-xs font-black text-white"
                            >
                              수정
                            </button>
                            {branch.active !== false && (
                              <button
                                type="button"
                                onClick={() => archiveCompanyBranch(branch)}
                                disabled={companyBranchSaving}
                                className="rounded-full bg-slate-100 px-3 py-2 text-xs font-black text-slate-600 disabled:opacity-50"
                              >
                                비활성
                              </button>
                            )}
                          </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                  <div className="rounded-2xl border border-slate-200 bg-white p-4">
                    <h4 className="text-base font-black text-slate-900">
                      결제 준비 연결
                    </h4>
                    <p className="mt-2 text-sm font-bold leading-6 text-slate-500 break-keep">
                      거래처의 담당 사업장을 기준으로 문자링크결제, 키인결제, 취소 가능 여부를 표시합니다.
                      이번 PR에서는 실제 KCP 결제 API를 호출하지 않습니다.
                    </p>
                    <div className="mt-4 space-y-2">
                      {companyBranches.map((branch) => (
                        <div
                          key={`pg-${branch.branchId || branch.id}`}
                          className="rounded-2xl bg-slate-50 p-3 text-sm font-bold text-slate-700"
                        >
                          <p className="font-black text-slate-900">
                            {branch.branchName} KCP
                          </p>
                          <p className="mt-1">
                            상태:{" "}
                            {COMPANY_BRANCH_PG_STATUS_OPTIONS.find(
                              (option) => option.value === branch.pgProfile?.status
                            )?.label || "미신청"}
                          </p>
                          <p className="mt-1 text-xs text-slate-500">
                            문자링크 {branch.pgProfile?.buyLinkEnabled ? "가능" : "불가"} ·
                            키인결제 {branch.pgProfile?.keyinEnabled ? "가능" : "불가"} ·
                            등록카드 {branch.pgProfile?.autopayEnabled ? "가능" : "불가"} ·
                            취소 {branch.pgProfile?.cancelEnabled ? "가능" : "불가"}
                          </p>
                          <p className="mt-2 text-xs leading-5 text-slate-500">
                            링크 {branch.pgProfile?.linkSiteCdMasked || "미연결"} · 키인{" "}
                            {branch.pgProfile?.keyinSiteCdMasked || "미연결"}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : adminTab === "VENDOR_MASTER" ? (
            <div className="animate-in fade-in space-y-4">
              <div className="rounded-2xl border border-emerald-100 bg-emerald-50 p-5">
                <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
                  <div>
                    <p className="text-xs font-black uppercase tracking-[0.18em] text-emerald-700">
                      Vendor Master
                    </p>
                    <h3 className="mt-2 text-xl font-black text-emerald-950">
                      거래처 마스터
                    </h3>
                    <p className="mt-2 max-w-3xl break-keep text-sm font-bold leading-6 text-emerald-900">
                      ERP 6자리 거래처코드를 기본키로 저장하고 결제·엑셀 내역을 연결합니다. 사업자번호는 전자계약과 기존 수기계약을 찾는 보조값입니다.
                      기존 계약 원본과 Hash 증빙은 변경하지 않습니다.
                    </p>
                  </div>
                  {!isPaymentOnlyMode && (
                  <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-4">
                    <button
                      type="button"
                      onClick={() => openVendorMasterModal()}
                      className="rounded-2xl bg-emerald-700 px-4 py-3 text-sm font-black text-white shadow-sm"
                    >
                      신규 거래처 등록
                    </button>
                    <button
                      type="button"
                      onClick={downloadVendorExcelTemplate}
                      className="rounded-2xl bg-white px-4 py-3 text-sm font-black text-emerald-800 shadow-sm"
                    >
                      엑셀 양식 다운로드
                    </button>
                    <label className="flex cursor-pointer items-center justify-center rounded-2xl bg-slate-900 px-4 py-3 text-sm font-black text-white shadow-sm">
                      엑셀 업로드
                      <input
                        type="file"
                        accept=".xlsx,.xls"
                        onChange={handleVendorExcelFileChange}
                        className="hidden"
                      />
                    </label>
                    <button
                      type="button"
                      onClick={() => downloadVendorMasterRowsAsXlsx()}
                      className="rounded-2xl bg-white px-4 py-3 text-sm font-black text-slate-800 shadow-sm"
                    >
                      엑셀 다운로드
                    </button>
                  </div>
                  )}
                </div>
                <div className="mt-4 grid grid-cols-2 gap-2 text-xs font-black text-emerald-900 lg:grid-cols-6">
                  {[
                    [
                      "전체 거래처",
                      vendorMasterPagination.collectionTotalCount || vendorMasterKpis.total,
                    ],
                    ["전자계약 연결", vendorMasterKpis.electronicLinked],
                    ["수기계약 보유", vendorMasterKpis.legacyLinked],
                    ["공동계약인 대기", vendorMasterKpis.coRepPending],
                    ["본사 확인 필요", vendorMasterKpis.manualReviewRequired],
                    ["주의/법적관리", vendorMasterKpis.watchOrLegal],
                  ].map(([label, value]) => (
                    <span key={label} className="rounded-full bg-white/80 px-3 py-2">
                      {label}: {value}
                    </span>
                  ))}
                </div>
                <div className="mt-3 flex flex-wrap gap-2 text-xs font-black text-emerald-900">
                  {Object.entries(vendorMasterKpis.byCompanyBranch || {}).map(
                    ([branchName, count]) => (
                      <span key={branchName} className="rounded-full bg-white/80 px-3 py-2">
                        {branchName}: {count}개 거래처
                      </span>
                    )
                  )}
                </div>
              </div>

              <div className="grid grid-cols-1 gap-2 rounded-2xl border border-slate-200 bg-white p-2 sm:grid-cols-3">
                {[
                  ["REGISTERED", "등록 거래처"],
                  ["UNREGISTERED", "미등록 거래처 검토"],
                  ["DUPLICATES", "중복·충돌 검토"],
                ].map(([value, label]) => (
                  <button
                    key={value}
                    type="button"
                    onClick={() => {
                      setVendorMasterView(value as typeof vendorMasterView);
                      if (value !== "REGISTERED" && !vendorReviewData) {
                        void loadVendorReview();
                      }
                    }}
                    className={`min-h-[44px] rounded-xl px-4 text-sm font-black ${
                      vendorMasterView === value
                        ? "bg-emerald-700 text-white"
                        : "bg-slate-50 text-slate-700"
                    }`}
                  >
                    {label}
                  </button>
                ))}
              </div>

              {vendorMasterView === "REGISTERED" ? (
                <>

              {isPaymentOnlyMode && (
                <div className="rounded-2xl border border-blue-100 bg-blue-50 px-4 py-3 text-sm font-bold leading-6 text-blue-900 break-keep">
                  결제담당자는 ERP 거래처 기본정보, 담당사업장, 등록카드 상태를 조회하고 카드 등록·결제 화면으로 이동할 수 있습니다. 계약 원문, 민감 ERP 상세, 거래처·사업장 수정은 본사 관리자만 사용할 수 있습니다.
                </div>
              )}

              {(vendorMastersError || (isPaymentOnlyMode && paymentDirectoryError)) && (
                <div className="rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm font-bold leading-6 text-red-700">
                  {vendorMastersError || paymentDirectoryError}
                </div>
              )}
              {(vendorMastersWarning ||
                (isPaymentOnlyMode && paymentDirectoryWarning)) && (
                <div className="rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm font-bold leading-6 text-amber-900">
                  {vendorMastersWarning || paymentDirectoryWarning}
                </div>
              )}

              {!isPaymentOnlyMode && vendorImportPreview && (
                <VendorImportPanel
                  preview={vendorImportPreview}
                  reason={vendorImportReason}
                  applying={vendorImportApplying}
                  result={vendorImportResult}
                  onReasonChange={setVendorImportReason}
                  onApply={applyVendorImport}
                  onRemoveRow={removeVendorPreviewRow}
                />
              )}

              <div className="rounded-2xl border border-blue-100 bg-blue-50 p-4 text-sm font-bold leading-6 text-blue-950">
                <p className="font-black">사업장과 결제 법인 구분</p>
                <p className="mt-1">
                  ERP 관할사업장은 엑셀 원본 참고값이고, 담당사업장은 우리 시스템의 거래처 배정값입니다.
                  문자링크 결제 법인과 site_cd는 담당사업장에 연결된 KCP 결제 프로필에서 결정됩니다.
                </p>
                <p className="mt-1 text-xs text-blue-700">
                  담당사업장만 바꾸려면 거래처 수정 또는 아래 일괄 변경을 사용하고, 사업장명·법인명·KCP 프로필 자체가 잘못된 경우에는 우리회사 사업장 관리에서 먼저 수정해 주세요.
                </p>
              </div>

              <div className="rounded-2xl border border-slate-200 bg-white p-4">
                <div className="grid grid-cols-1 gap-3 md:grid-cols-6">
                  <input
                    value={vendorMasterFilters.keyword}
                    onChange={(event) =>
                      setVendorMasterFilters((prev) => ({
                        ...prev,
                        keyword: event.target.value,
                      }))
                    }
                    className="min-h-[44px] rounded-xl border border-slate-200 px-3 text-sm font-bold outline-none focus:border-emerald-500 md:col-span-2"
                    placeholder="거래처코드, 상호명, 대표자, 담당파트 검색"
                  />
                  <input
                    value={vendorMasterFilters.businessNumber}
                    onChange={(event) =>
                      setVendorMasterFilters((prev) => ({
                        ...prev,
                        businessNumber: event.target.value,
                      }))
                    }
                    className="min-h-[44px] rounded-xl border border-slate-200 px-3 text-sm font-bold outline-none focus:border-emerald-500"
                    placeholder="사업자번호"
                  />
                  <input
                    value={vendorMasterFilters.salesManagerName}
                    onChange={(event) =>
                      setVendorMasterFilters((prev) => ({
                        ...prev,
                        salesManagerName: event.target.value,
                      }))
                    }
                    className="min-h-[44px] rounded-xl border border-slate-200 px-3 text-sm font-bold outline-none focus:border-emerald-500"
                    placeholder="담당자"
                  />
                  <select
                    value={vendorMasterFilters.status}
                    onChange={(event) =>
                      setVendorMasterFilters((prev) => ({
                        ...prev,
                        status: event.target.value,
                      }))
                    }
                    className="min-h-[44px] rounded-xl border border-slate-200 px-3 text-sm font-bold outline-none focus:border-emerald-500"
                  >
                    {VENDOR_MASTER_STATUS_OPTIONS.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  <select
                    value={vendorMasterFilters.linkStatus}
                    onChange={(event) =>
                      setVendorMasterFilters((prev) => ({
                        ...prev,
                        linkStatus: event.target.value,
                      }))
                    }
                    className="min-h-[44px] rounded-xl border border-slate-200 px-3 text-sm font-bold outline-none focus:border-emerald-500"
                  >
                    {VENDOR_MASTER_LINK_FILTER_OPTIONS.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                  <select
                    value={vendorMasterFilters.companyBranchId}
                    onChange={(event) =>
                      setVendorMasterFilters((prev) => ({
                        ...prev,
                        companyBranchId: event.target.value,
                      }))
                    }
                    className="min-h-[44px] rounded-xl border border-slate-200 px-3 text-sm font-bold outline-none focus:border-emerald-500"
                  >
                    <option value="">전체 사업장</option>
                    {companyBranches.map((branch) => (
                      <option key={branch.branchId || branch.id} value={branch.branchId || branch.id}>
                        {branch.branchName}
                      </option>
                    ))}
                  </select>
                  <button
                    type="button"
                    onClick={() => void loadVendorMasters({ cursor: "", cursorStack: [] })}
                    disabled={vendorMastersLoading}
                    className="min-h-[44px] rounded-xl bg-emerald-700 px-4 text-sm font-black text-white disabled:bg-slate-300 md:col-span-2"
                  >
                    현재 조건으로 전체 거래처 검색
                  </button>
                </div>
              </div>

              {!isPaymentOnlyMode && (
                <div className="rounded-2xl border border-indigo-200 bg-indigo-50 p-4">
                  <div className="flex flex-col gap-3 lg:flex-row lg:items-end">
                    <label className="flex min-h-[44px] items-center gap-3 rounded-xl bg-white px-3 text-sm font-black text-slate-800">
                      <input
                        type="checkbox"
                        checked={allFilteredVendorMastersSelected}
                        onChange={(event) =>
                          toggleAllFilteredVendorMasters(event.target.checked)
                        }
                      />
                      현재 검색 결과 전체 선택
                    </label>
                    <label className="block min-w-0 flex-1">
                      <span className="mb-1 block text-xs font-black text-indigo-800">
                        변경할 담당사업장
                      </span>
                      <select
                        value={vendorMasterBulkBranchId}
                        onChange={(event) => {
                          setVendorMasterBulkBranchId(event.target.value);
                          setVendorMasterBulkConfirmOpen(false);
                        }}
                        className="min-h-[44px] w-full rounded-xl border border-indigo-200 bg-white px-3 text-sm font-bold outline-none focus:border-indigo-500"
                      >
                        <option value="">사업장 선택</option>
                        {companyBranches
                          .filter((branch) => branch.active !== false)
                          .map((branch) => {
                            const branchId = branch.branchId || branch.id;
                            const linkDisplay =
                              getCompanyBranchLinkPaymentDisplay(branch.pgProfile);
                            return (
                              <option key={branchId} value={branchId}>
                                {branch.branchName} · {linkDisplay.companyName || "결제 법인 미연결"} · {linkDisplay.siteCd || "site_cd 미연결"}
                              </option>
                            );
                          })}
                      </select>
                    </label>
                    <label className="block min-w-0 flex-1">
                      <span className="mb-1 block text-xs font-black text-indigo-800">
                        변경 사유
                      </span>
                      <input
                        value={vendorMasterBulkReason}
                        onChange={(event) => {
                          setVendorMasterBulkReason(event.target.value);
                          setVendorMasterBulkConfirmOpen(false);
                        }}
                        placeholder="예: 담당 파트 사업장 정정"
                        className="min-h-[44px] w-full rounded-xl border border-indigo-200 bg-white px-3 text-sm font-bold outline-none focus:border-indigo-500"
                      />
                    </label>
                    <button
                      type="button"
                      onClick={requestVendorMasterBulkBranchChange}
                      disabled={
                        vendorMasterBulkSaving ||
                        vendorMasterSelectedIds.length === 0
                      }
                      className="min-h-[44px] rounded-xl bg-indigo-700 px-4 text-sm font-black text-white disabled:bg-slate-300"
                    >
                      선택 {vendorMasterSelectedIds.length}건 변경 확인
                    </button>
                  </div>
                  <p className="mt-2 text-xs font-bold leading-5 text-indigo-700">
                    검색 결과 전체 선택은 화면에 보이는 100건이 아니라 현재 필터에 맞는 전체 거래처에 적용됩니다. ERP 관할사업장 원본은 변경하지 않습니다.
                  </p>
                  {vendorMasterBulkConfirmOpen && (
                    <div className="mt-3 rounded-xl border border-amber-200 bg-amber-50 p-3 text-sm font-bold text-amber-950">
                      <p>
                        선택한 {vendorMasterSelectedIds.length}건의 담당사업장을{" "}
                        {companyBranches.find(
                          (branch) =>
                            (branch.branchId || branch.id) ===
                            vendorMasterBulkBranchId
                        )?.branchName || "선택 사업장"}
                        (으)로 교체합니다. 기존 복수 사업장 배정도 이 사업장 1곳으로 교체됩니다.
                      </p>
                      <div className="mt-3 flex flex-wrap gap-2">
                        <button
                          type="button"
                          onClick={saveVendorMasterBulkBranchChange}
                          disabled={vendorMasterBulkSaving}
                          className="min-h-[40px] rounded-lg bg-red-600 px-4 text-sm font-black text-white disabled:bg-slate-300"
                        >
                          {vendorMasterBulkSaving ? "변경 중..." : "확인하고 일괄 변경"}
                        </button>
                        <button
                          type="button"
                          onClick={() => setVendorMasterBulkConfirmOpen(false)}
                          disabled={vendorMasterBulkSaving}
                          className="min-h-[40px] rounded-lg border border-amber-300 bg-white px-4 text-sm font-black text-amber-900"
                        >
                          취소
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              )}

              <div className="grid grid-cols-1 gap-4 xl:grid-cols-[minmax(0,1fr)_420px]">
                <div className="rounded-2xl border border-slate-200 bg-white p-4">
                  <div className="mb-3 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                    <h4 className="text-base font-black text-slate-900">
                      거래처 목록
                    </h4>
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-black text-slate-600">
                        현재 {vendorMasterFilteredRows.length}건 / 검색 전체 {vendorMasterPagination.totalCount}건 / canonical {vendorMasterPagination.collectionTotalCount}건
                      </span>
                      <button
                        type="button"
                        onClick={loadPreviousVendorMasterPage}
                        disabled={vendorMastersLoading || vendorMasterPagination.cursorStack.length === 0}
                        className="min-h-[36px] rounded-lg border border-slate-200 bg-white px-3 text-xs font-black text-slate-700 disabled:text-slate-300"
                      >
                        이전
                      </button>
                      <span className="text-xs font-black text-slate-500">
                        {vendorMasterPagination.cursorStack.length + 1}페이지
                      </span>
                      <button
                        type="button"
                        onClick={loadNextVendorMasterPage}
                        disabled={vendorMastersLoading || !vendorMasterPagination.hasMore}
                        className="min-h-[36px] rounded-lg bg-slate-900 px-3 text-xs font-black text-white disabled:bg-slate-300"
                      >
                        다음
                      </button>
                    </div>
                  </div>
                  {(vendorMastersLoading || (isPaymentOnlyMode && paymentDirectoryLoading)) ? (
                    <div className="flex min-h-[180px] items-center justify-center text-sm font-black text-slate-500">
                      <Loader2 className="mr-2 h-5 w-5 animate-spin" />
                      불러오는 중...
                    </div>
                  ) : vendorMasterFilteredRows.length === 0 ? (
                    <div className="rounded-2xl border border-dashed border-slate-200 bg-slate-50 px-5 py-10 text-center">
                      <Building2 className="mx-auto mb-3 h-8 w-8 text-slate-300" />
                      <p className="font-black text-slate-700">
                        거래처 마스터 데이터가 없습니다.
                      </p>
                    </div>
                  ) : (
                    <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">
                      {visibleVendorMasterRows.map((vendor) => {
                        const vendorId = getVendorMasterId(vendor);
                        return (
                        <div
                          key={vendorId}
                          className={`rounded-2xl border p-4 transition ${
                            vendorMasterSelectedIdSet.has(vendorId)
                              ? "border-indigo-400 bg-indigo-50"
                              : vendor.status === "DELETED"
                              ? "border-slate-200 bg-slate-100 opacity-60"
                              : "border-slate-200 bg-white hover:bg-slate-50"
                          }`}
                        >
                          {!isPaymentOnlyMode && (
                            <label className="mb-3 flex items-center gap-2 text-xs font-black text-indigo-800">
                              <input
                                type="checkbox"
                                checked={vendorMasterSelectedIdSet.has(vendorId)}
                                onChange={(event) =>
                                  toggleVendorMasterSelection(
                                    vendorId,
                                    event.target.checked
                                  )
                                }
                              />
                              일괄 변경 선택
                            </label>
                          )}
                          <button
                            type="button"
                            onClick={() => setSelectedVendorMaster(vendor)}
                            className="w-full text-left"
                          >
                          <div className="flex items-start justify-between gap-3">
                            <div className="min-w-0">
                              <p className="break-words text-lg font-black text-slate-900">
                                [{normalizeVendorCode(vendor.vendorCode) || "코드 미연결"}] {vendor.businessName || "상호명 미수집"}
                              </p>
                              <p className="mt-1 text-sm font-bold text-slate-500">
                                {vendor.businessNumber || "사업자번호 미수집"}
                              </p>
                            </div>
                            <span className="shrink-0 rounded-full bg-emerald-100 px-3 py-1 text-xs font-black text-emerald-700">
                              {vendor.statusLabel}
                            </span>
                          </div>
                          <div className="mt-3 flex flex-wrap gap-2 text-xs font-black">
                            <span className="rounded-full bg-slate-100 px-2 py-1 text-slate-600">
                              담당: {vendor.salesManagerName || "미지정"}
                            </span>
                            <span className="rounded-full bg-indigo-50 px-2 py-1 text-indigo-700">
                              사업장: {vendor.companyBranchName || "미지정"}
                            </span>
                            <span className="rounded-full bg-blue-50 px-2 py-1 text-blue-700">
                              전자 {vendor.electronicContractCount}건
                            </span>
                            <span className="rounded-full bg-amber-50 px-2 py-1 text-amber-700">
                              수기 {vendor.legacyContractCount}건
                            </span>
                            <span className="rounded-full bg-emerald-50 px-2 py-1 text-emerald-700">
                              결제: {vendor.paymentAllowed ? "준비 가능" : "미준비"}
                            </span>
                          </div>
                          </button>
                        </div>
                        );
                      })}
                    </div>
                  )}
                  <p className="mt-3 rounded-xl bg-emerald-50 px-3 py-2 text-xs font-bold leading-5 text-emerald-800">
                    서버가 전체 canonical vendors에서 조건을 적용한 뒤 페이지당 최대 {vendorMasterPagination.pageSize}건을 반환합니다. 다음 페이지에서도 현재 검색조건이 유지됩니다.
                  </p>
                </div>

                <div className="rounded-2xl border border-slate-200 bg-white p-4">
                  {selectedVendorMaster ? (
                    <div className="space-y-4">
                      <div className="flex items-start justify-between gap-3">
                        <div>
                          <h4 className="break-words text-lg font-black text-slate-900">
                            [{normalizeVendorCode(selectedVendorMaster.vendorCode) || "코드 미연결"}] {selectedVendorMaster.businessName}
                          </h4>
                          <p className="mt-1 text-sm font-bold text-slate-500">
                            {selectedVendorMaster.businessNumber || "사업자번호 미수집"}
                          </p>
                        </div>
                        {!isPaymentOnlyMode && (
                          <div className="flex flex-wrap justify-end gap-2">
                            {selectedVendorMaster.status !== "DELETED" && (
                              <button
                                type="button"
                                onClick={() => openVendorMasterModal(selectedVendorMaster)}
                                className="rounded-full bg-slate-900 px-3 py-2 text-xs font-black text-white"
                              >
                                수정
                              </button>
                            )}
                            <VendorLifecyclePanel
                              key={`${getVendorMasterId(selectedVendorMaster)}-${selectedVendorMaster.status}`}
                              vendor={selectedVendorMaster}
                              busy={vendorLifecycleSaving}
                              onSubmit={changeVendorLifecycle}
                            />
                          </div>
                        )}
                      </div>
                      <div className="space-y-2 rounded-2xl bg-slate-50 p-4 text-sm font-bold text-slate-700">
                        {[
                          ["ERP 거래처코드", normalizeVendorCode(selectedVendorMaster.vendorCode)],
                          ["ERP 사업장코드", selectedVendorMaster.erpSiteCode],
                          ["ERP 관할사업장 (원본)", selectedVendorMaster.erpSiteName],
                          ["담당사업장 (결제 라우팅)", selectedVendorMaster.companyBranchName],
                          ["담당영업사원", selectedVendorMaster.salesManagerName],
                          ["관리상태", selectedVendorMaster.statusLabel],
                          [
                            "결제 준비",
                            selectedVendorMaster.paymentAllowed ? "준비 가능" : "미준비",
                          ],
                        ].map(([label, value]) => (
                          <div key={label} className="flex justify-between gap-3 border-b border-slate-200 pb-2 last:border-b-0">
                            <span className="shrink-0 text-slate-400">{label}</span>
                            <span className="min-w-0 break-words text-right">
                              {value || "미수집"}
                            </span>
                          </div>
                        ))}
                      </div>
                      <div className="rounded-2xl border border-indigo-100 bg-indigo-50 p-3 text-xs font-bold leading-5 text-indigo-900">
                        ERP 관할사업장은 엑셀 원본이라 담당사업장을 수정해도 유지됩니다. 문자링크의 결제 법인은 담당사업장에 연결된 KCP 프로필을 따릅니다.
                      </div>

                      {!isPaymentOnlyMode && (
                      <details className="rounded-2xl border border-slate-200 bg-white p-4">
                        <summary className="cursor-pointer text-sm font-black text-slate-800">
                          ERP 전체 상세 데이터 보기 · 기본 숨김
                        </summary>
                        <p className="mt-2 text-xs font-bold leading-5 text-slate-500">
                          결제에 꼭 필요한 항목 외의 담당자·연락처·주소·정산·세금·메모 정보입니다. 관리자 화면에서만 표시됩니다.
                        </p>
                        <div className="mt-4 space-y-2 text-sm font-bold text-slate-700">
                          {[
                            ["대표자", selectedVendorMaster.representativeName],
                            ["통합 연락처", selectedVendorMaster.phone],
                            ["통합 주소", selectedVendorMaster.address],
                            ["파트", selectedVendorMaster.partName],
                            ["내부 메모", selectedVendorMaster.memo],
                            ...getVendorErpDetailDisplayRows(selectedVendorMaster).map(
                              ({ label, value }) => [label, value]
                            ),
                          ].map(([label, value]) => (
                            <div
                              key={label}
                              className="flex justify-between gap-3 border-b border-slate-100 pb-2 last:border-b-0"
                            >
                              <span className="shrink-0 text-slate-400">{label}</span>
                              <span className="min-w-0 break-words text-right">
                                {value || "미수집"}
                              </span>
                            </div>
                          ))}
                        </div>
                      </details>
                      )}

                      <div className="rounded-2xl border border-blue-100 bg-blue-50 p-4">
                        <h5 className="mb-2 text-sm font-black text-blue-950">
                          연결된 전자계약
                        </h5>
                        {selectedVendorMaster.electronicContracts?.length ? (
                          <div className="space-y-2">
                            {selectedVendorMaster.electronicContracts.slice(0, 5).map((contract) => (
                              <button
                                key={contract.id || contract.documentId || contract.contractId}
                                type="button"
                                onClick={() => handleContractClick(contract)}
                                className="w-full rounded-xl bg-white px-3 py-2 text-left text-xs font-bold text-blue-900"
                              >
                                {getAdminDisplayBusinessName(contract)} · {contract.contractId || contract.id}
                              </button>
                            ))}
                          </div>
                        ) : (
                          <p className="text-sm font-bold text-blue-800">
                            사업자번호 기준 전자계약 연결이 없습니다.
                          </p>
                        )}
                      </div>

                      <div className="rounded-2xl border border-amber-100 bg-amber-50 p-4">
                        <h5 className="mb-2 text-sm font-black text-amber-950">
                          연결된 수기계약
                        </h5>
                        {selectedVendorMaster.legacyContracts?.length ? (
                          <div className="space-y-2">
                            {selectedVendorMaster.legacyContracts.slice(0, 5).map((contract) => (
                              <button
                                key={contract.legacyId || contract.id || contract.documentId}
                                type="button"
                                onClick={() => openLegacyContractDetail(contract)}
                                className="w-full rounded-xl bg-white px-3 py-2 text-left text-xs font-bold text-amber-900"
                              >
                                {contract.businessName} · {contract.contractDate || "계약일 미수집"}
                              </button>
                            ))}
                          </div>
                        ) : (
                          <p className="text-sm font-bold text-amber-800">
                            사업자번호 기준 수기계약 연결이 없습니다.
                          </p>
                        )}
                      </div>

                      <div className="rounded-2xl border border-slate-200 p-4">
                        <div className="mb-3 flex items-center gap-2">
                          <CreditCard className="h-4 w-4 text-slate-500" />
                          <h5 className="text-sm font-black text-slate-900">
                            결제 준비
                          </h5>
                        </div>
                        <div className="mb-3 rounded-2xl bg-slate-50 px-3 py-3 text-xs font-bold leading-5 text-slate-600">
                          <p className="font-black text-slate-800">
                            {selectedVendorMaster.companyBranchName || "담당사업장 미지정"} KCP
                          </p>
                          <p>
                            PG 상태:{" "}
                            {COMPANY_BRANCH_PG_STATUS_OPTIONS.find(
                              (option) =>
                                option.value ===
                                (selectedVendorMaster.companyBranchPgProfile?.status ||
                                  "NOT_APPLIED")
                            )?.label || "미신청"}
                          </p>
                          <p>
                            site_cd:{" "}
                            {getCompanyBranchLinkPaymentDisplay(
                              selectedVendorMaster.companyBranchPgProfile
                            ).siteCd ||
                              "표시용 값 미등록"}
                          </p>
                          <p>
                            문자링크 결제 법인:{" "}
                            {getCompanyBranchLinkPaymentDisplay(
                              selectedVendorMaster.companyBranchPgProfile
                            ).companyName || "미연결"}
                          </p>
                        </div>
                        <div className="mb-3 rounded-2xl border border-slate-200 bg-white p-3">
                          <div className="mb-2 flex items-center justify-between gap-2">
                            <span className="text-xs font-black text-slate-700">거래처별 등록카드</span>
                            <span className="rounded-full bg-slate-100 px-2 py-1 text-[11px] font-black text-slate-600">
                              {selectedVendorAutopayMethods.length}장
                            </span>
                          </div>
                          {selectedVendorAutopayMethods.length === 0 ? (
                            <p className="text-xs font-bold leading-5 text-slate-500">
                              등록된 카드가 없습니다. 카드 등록 버튼에서 KCP 등록 화면을 열 수 있습니다.
                            </p>
                          ) : (
                            <div className="space-y-2">
                              {selectedVendorAutopayMethods.map((method) => (
                                <div
                                  key={method.billingMethodId}
                                  className="rounded-xl bg-slate-50 px-3 py-2 text-xs font-bold text-slate-700"
                                >
                                  <p className="font-black text-slate-900">
                                    {method.cardLabel || "카드 구분 미입력"} · {method.cardName || "카드사 확인 전"}
                                  </p>
                                  <p className="mt-1">
                                    {method.cardNumberMasked || "끝 4자리 미확인"} · {method.status || "상태 미확인"}
                                    {method.operatorConfirmed ? " · 담당자 확인 완료" : " · 담당자 확인 필요"}
                                  </p>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                        <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
                          <button
                            type="button"
                            onClick={() => openVendorAutopayRegistration(selectedVendorMaster)}
                            className="min-h-[48px] rounded-xl bg-emerald-700 px-3 py-3 text-sm font-black text-white"
                          >
                            이 거래처 카드 등록
                          </button>
                          <button
                            type="button"
                            onClick={() => openVendorAutopayManagement(selectedVendorMaster)}
                            className="min-h-[48px] rounded-xl bg-slate-900 px-3 py-3 text-sm font-black text-white"
                          >
                            결제관리 열기
                          </button>
                        </div>
                        <p className="mt-3 text-xs font-bold leading-5 text-slate-500 break-keep">
                          결제관리에서 이 거래처를 선택하면 ERP 거래처코드를 기본키로, 상호명·사업자번호·사업장 정보를 스냅샷으로 결제요청에 저장합니다.
                        </p>
                      </div>
                    </div>
                  ) : (
                    <div className="rounded-2xl border border-dashed border-slate-200 bg-slate-50 px-5 py-10 text-center">
                      <Building2 className="mx-auto mb-3 h-8 w-8 text-slate-300" />
                      <p className="font-black text-slate-700">
                        거래처를 선택하면 계약 연결과 결제 준비 정보를 확인할 수 있습니다.
                      </p>
                    </div>
                  )}
                </div>
              </div>
                </>
              ) : (
                <VendorMasterReviewPanel
                  view={vendorMasterView}
                  data={vendorReviewData}
                  loading={vendorReviewLoading}
                  error={vendorReviewError}
                  onLoad={loadVendorReview}
                />
              )}
            </div>
          ) : adminTab === "TEMPLATES" ? (
            <div className="animate-in fade-in space-y-4">
              <div className="rounded-2xl border border-indigo-100 bg-indigo-50 p-5">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <h3 className="text-lg font-black text-indigo-950">
                      계약서 조항 관리
                    </h3>
                    <p className="mt-2 text-sm font-bold leading-6 text-indigo-900 break-keep">
                      계약서 조항은 기존 문서를 수정하지 않고 새 버전으로 발행합니다.
                      새 계약부터 적용됩니다. 기존 완료 계약은 변경되지 않습니다.
                    </p>
                  </div>
                  <FileText className="h-6 w-6 shrink-0 text-indigo-700" />
                </div>
                <div className="mt-4 grid grid-cols-1 gap-2 rounded-2xl bg-white/80 p-3 text-xs font-bold text-indigo-900 sm:grid-cols-3">
                  <div>
                    <span className="block text-indigo-500">활성 버전</span>
                    <span className="mt-1 block break-all">
                      {activeContractTemplate?.versionId || CONTRACT_DOCUMENT_VERSION}
                    </span>
                  </div>
                  <div>
                    <span className="block text-indigo-500">적용 방식</span>
                    <span className="mt-1 block">
                      {activeContractTemplate?.source === "FIRESTORE"
                        ? "서버 활성 버전"
                        : "기본 조항 fallback"}
                    </span>
                  </div>
                  <div>
                    <span className="block text-indigo-500">관리 권한</span>
                    <span className="mt-1 block">본사 관리자 전용</span>
                  </div>
                </div>
              </div>

              <div className="rounded-2xl border border-slate-200 bg-white p-4">
                <div className="mb-3 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                  <div>
                    <p className="text-sm font-black text-slate-900">
                      조항 편집
                    </p>
                    <p className="mt-1 text-xs font-bold leading-5 text-slate-500">
                      HTML이 아닌 일반 텍스트로 입력해 주세요. 발행 사유는 필수입니다.
                    </p>
                  </div>
                  <div className="flex flex-col gap-2 sm:flex-row">
                    <button
                      type="button"
                      onClick={loadApprovedDefaultContractTemplateDraft}
                      className="rounded-xl border border-indigo-200 bg-indigo-50 px-3 py-2 text-xs font-black text-indigo-700"
                    >
                      승인본 V2 불러오기
                    </button>
                    <button
                      type="button"
                      onClick={() => loadActiveContractTemplate()}
                      disabled={contractTemplateLoading}
                      className="rounded-xl border border-slate-200 bg-slate-50 px-3 py-2 text-xs font-black text-slate-700 disabled:opacity-60"
                    >
                      {contractTemplateLoading ? "불러오는 중..." : "활성 조항 다시 불러오기"}
                    </button>
                  </div>
                </div>
                {contractTemplateDraft.versionId === CONTRACT_DOCUMENT_VERSION && (
                  <div className="mb-3 rounded-2xl border border-indigo-100 bg-indigo-50 px-4 py-3 text-sm font-bold leading-6 text-indigo-900 break-keep">
                    승인본 V2({CONTRACT_DOCUMENT_VERSION})는 새 버전으로 발행해야 새
                    계약부터 서버 활성 조항으로 적용됩니다. 기존 완료 계약은 변경되지
                    않습니다.
                  </div>
                )}
                <label className="block">
                  <span className="mb-1 block text-sm font-black text-slate-700">
                    계약서 제목
                  </span>
                  <input
                    value={contractTemplateDraft.title}
                    onChange={(e) =>
                      setContractTemplateDraft((prev) => ({
                        ...prev,
                        title: e.target.value,
                      }))
                    }
                    className="min-h-[48px] w-full rounded-xl border border-slate-200 px-3 py-2 text-base font-bold outline-none focus:border-indigo-400"
                  />
                </label>
                <div className="mt-4 space-y-3">
                  {contractTemplateDraft.clauses.map((clause, index) => (
                    <div
                      key={`${clause.id}-${index}`}
                      className="rounded-2xl border border-slate-200 bg-slate-50 p-3"
                    >
                      <div className="mb-2 flex items-center justify-between gap-2">
                        <span className="rounded-full bg-indigo-100 px-2 py-1 text-[11px] font-black text-indigo-700">
                          조항 {index + 1}
                        </span>
                      </div>
                      <input
                        value={clause.title}
                        onChange={(e) =>
                          updateContractTemplateClause(index, {
                            title: e.target.value,
                          })
                        }
                        className="mb-2 min-h-[44px] w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm font-black text-slate-900 outline-none focus:border-indigo-400"
                        placeholder="제1조 목적"
                      />
                      <textarea
                        value={clause.body}
                        onChange={(e) =>
                          updateContractTemplateClause(index, {
                            body: e.target.value,
                          })
                        }
                        rows={5}
                        className="w-full resize-y rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm font-bold leading-6 text-slate-700 outline-none focus:border-indigo-400"
                        placeholder="조항 본문을 입력해 주세요."
                      />
                    </div>
                  ))}
                </div>
                <button
                  type="button"
                  onClick={addContractTemplateClause}
                  className="mt-3 w-full rounded-xl border border-indigo-200 bg-indigo-50 px-3 py-3 text-sm font-black text-indigo-700"
                >
                  조항 추가
                </button>
                <label className="mt-4 block">
                  <span className="mb-1 block text-sm font-black text-slate-700">
                    변경 사유
                  </span>
                  <textarea
                    value={contractTemplateDraft.changeReason}
                    onChange={(e) =>
                      setContractTemplateDraft((prev) => ({
                        ...prev,
                        changeReason: e.target.value,
                      }))
                    }
                    rows={3}
                    className="w-full rounded-xl border border-slate-200 px-3 py-2 text-sm font-bold leading-6 text-slate-700 outline-none focus:border-indigo-400"
                    placeholder="예: 오탈자 및 조항 문구 정비"
                  />
                </label>
                {contractTemplateError && (
                  <div className="mt-3 rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm font-bold leading-6 text-red-700 break-keep">
                    {contractTemplateError}
                  </div>
                )}
                <button
                  type="button"
                  onClick={handlePublishContractTemplate}
                  disabled={contractTemplateSaving || !isHeadquarters()}
                  className="mt-4 w-full rounded-2xl bg-indigo-700 px-4 py-4 text-base font-black text-white disabled:opacity-50"
                >
                  {contractTemplateSaving ? "새 버전 발행 중..." : "새 버전 발행"}
                </button>
              </div>

              <div className="rounded-2xl border border-slate-200 bg-slate-50 p-4">
                <div className="mb-3 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                  <div>
                    <p className="text-sm font-black text-slate-900">
                      미리보기
                    </p>
                    <p className="mt-1 text-xs font-bold leading-5 text-slate-500">
                      실제 계약서 확인 화면과 같은 줄바꿈 기준으로 조항을 확인합니다.
                    </p>
                  </div>
                  <div className="grid grid-cols-2 rounded-xl bg-white p-1 text-xs font-black">
                    {(["mobile", "desktop"] as const).map((mode) => (
                      <button
                        key={mode}
                        type="button"
                        onClick={() => setContractTemplatePreviewMode(mode)}
                        className={`rounded-lg px-3 py-2 ${
                          contractTemplatePreviewMode === mode
                            ? "bg-slate-900 text-white"
                            : "text-slate-500"
                        }`}
                      >
                        {mode === "mobile" ? "모바일" : "PC"}
                      </button>
                    ))}
                  </div>
                </div>
                <div
                  className={`mx-auto rounded-2xl border border-slate-200 bg-white p-4 text-[15px] font-bold leading-7 text-slate-700 shadow-inner break-keep whitespace-pre-line [word-break:keep-all] ${
                    contractTemplatePreviewMode === "mobile"
                      ? "max-w-sm"
                      : "max-w-3xl"
                  }`}
                >
                  <h4 className="mb-4 text-center text-xl font-black text-slate-900 underline underline-offset-4">
                    {contractTemplateDraft.title || DEFAULT_CONTRACT_TEMPLATE_TITLE}
                  </h4>
                  {normalizeContractTemplateClauses(contractTemplateDraft.clauses).map(
                    (clause) => (
                      <section key={clause.id} className="mb-5">
                        <p className="mb-2 font-black text-slate-900">
                          {clause.title}
                        </p>
                        <p className="whitespace-pre-line break-words">
                          {clause.body}
                        </p>
                      </section>
                    )
                  )}
                </div>
              </div>
            </div>
          ) : adminTab === "SETTINGS" ? (
            <>
              <div className="mb-4 rounded-xl border border-indigo-100 bg-white p-4 shadow-sm space-y-4">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <p className="text-[11px] font-black uppercase tracking-wide text-indigo-600">
                      운영 안전장치
                    </p>
                    <h3 className="mt-1 text-base font-black text-slate-900">
                      전자계약 운영 상태
                    </h3>
                    <p className="mt-1 text-xs leading-relaxed text-slate-500 break-keep whitespace-normal [word-break:keep-all]">
                      실시간 배포나 장애 대응 중 전자계약 작성 가능 여부를 즉시 전환합니다. 상태 변경은 관리자 로그에 기록됩니다.
                    </p>
                  </div>
                  <ShieldCheck className="w-5 h-5 text-indigo-600 shrink-0" />
                </div>

                <div className="rounded-lg border border-slate-100 bg-slate-50 p-3 text-xs font-bold text-slate-700">
                  현재 상태:{" "}
                  <span className="text-indigo-700">
                    {getContractAppStatusDisplayName(contractAppStatus.status)}
                  </span>
                  {contractAppStatus.updatedAt ? (
                    <span className="ml-2 text-slate-400">
                      {formatAdminUpdatedAt(contractAppStatus.updatedAt)}
                    </span>
                  ) : null}
                </div>

                <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-5">
                  {(
                    [
                      ["OPEN", "전자계약 작성 가능"],
                      ["NOTICE_ONLY", "업데이트 안내만 표시"],
                      ["START_PAUSED", "신규 작성 일시중단"],
                      ["FULL_PAUSED", "전체 작성 일시중단"],
                      ["ADMIN_TEST_ONLY", "관리자 테스트 모드"],
                    ] as [ContractAppStatusCode, string][]
                  ).map(([status, label]) => (
                    <button
                      key={status}
                      type="button"
                      onClick={() => handleApplyContractAppStatusPreset(status)}
                      className={`min-h-[44px] rounded-lg border px-3 py-2 text-sm font-black transition-all ${
                        contractAppStatusDraft.status === status
                          ? "border-indigo-700 bg-indigo-700 text-white"
                          : "border-slate-200 bg-white text-slate-700 hover:border-indigo-200"
                      }`}
                    >
                      {label}
                    </button>
                  ))}
                </div>

                <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                  <label className="block text-xs font-black text-slate-700">
                    안내 제목
                    <input
                      value={contractAppStatusDraft.title}
                      onChange={(e) =>
                        setContractAppStatusDraft((prev) =>
                          buildContractAppStatus({
                            ...prev,
                            title: e.target.value,
                          })
                        )
                      }
                      className="mt-1 w-full rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-base font-bold outline-none focus:border-indigo-400"
                    />
                  </label>
                  <label className="block text-xs font-black text-slate-700">
                    문의 전화번호
                    <input
                      value={contractAppStatusDraft.supportPhone}
                      onChange={(e) =>
                        setContractAppStatusDraft((prev) =>
                          buildContractAppStatus({
                            ...prev,
                            supportPhone: e.target.value,
                          })
                        )
                      }
                      className="mt-1 w-full rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-base font-bold outline-none focus:border-indigo-400"
                    />
                  </label>
                  <label className="block text-xs font-black text-slate-700 sm:col-span-2">
                    안내 문구
                    <textarea
                      value={contractAppStatusDraft.message}
                      onChange={(e) =>
                        setContractAppStatusDraft((prev) =>
                          buildContractAppStatus({
                            ...prev,
                            message: e.target.value,
                          })
                        )
                      }
                      rows={3}
                      className="mt-1 w-full rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-base font-bold leading-relaxed outline-none focus:border-indigo-400 break-keep whitespace-normal [word-break:keep-all]"
                    />
                  </label>
                  <label className="block text-xs font-black text-slate-700">
                    예상 재개 시간
                    <input
                      value={contractAppStatusDraft.expectedResumeAt}
                      onChange={(e) =>
                        setContractAppStatusDraft((prev) =>
                          buildContractAppStatus({
                            ...prev,
                            expectedResumeAt: e.target.value,
                          })
                        )
                      }
                      placeholder="예: 2026-05-21 18:00"
                      className="mt-1 w-full rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-base font-bold outline-none focus:border-indigo-400"
                    />
                  </label>
                  <label className="block text-xs font-black text-slate-700">
                    변경 사유
                    <input
                      value={contractAppStatusDraft.reason}
                      onChange={(e) =>
                        setContractAppStatusDraft((prev) =>
                          buildContractAppStatus({
                            ...prev,
                            reason: e.target.value,
                          })
                        )
                      }
                      placeholder="일시중단/테스트 모드는 필수"
                      className="mt-1 w-full rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-base font-bold outline-none focus:border-indigo-400"
                    />
                  </label>
                </div>

                <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
                  <label className="flex items-start gap-2 rounded-lg border border-slate-100 bg-slate-50 p-3 text-sm font-bold text-slate-700">
                    <input
                      type="checkbox"
                      checked={contractAppStatusDraft.allowInProgressSubmit}
                      onChange={(e) =>
                        setContractAppStatusDraft((prev) =>
                          buildContractAppStatus({
                            ...prev,
                            allowInProgressSubmit: e.target.checked,
                          })
                        )
                      }
                      className="mt-1 h-4 w-4 accent-indigo-700"
                    />
                    START_PAUSED 상태에서 이미 작성 중인 계약의 최종 제출 허용
                  </label>
                  <label className="flex items-start gap-2 rounded-lg border border-slate-100 bg-slate-50 p-3 text-sm font-bold text-slate-700">
                    <input
                      type="checkbox"
                      checked={contractAppStatusDraft.showBanner}
                      onChange={(e) =>
                        setContractAppStatusDraft((prev) =>
                          buildContractAppStatus({
                            ...prev,
                            showBanner: e.target.checked,
                          })
                        )
                      }
                      className="mt-1 h-4 w-4 accent-indigo-700"
                    />
                    첫 화면 안내 배너 표시
                  </label>
                </div>

                <div className="rounded-xl border border-slate-100 bg-slate-50 p-3">
                  <p className="mb-2 text-xs font-black text-slate-600">
                    첫 화면 미리보기
                  </p>
                  <ContractAppStatusBanner
                    appStatus={{ ...contractAppStatusDraft, showBanner: true }}
                    compact
                  />
                </div>

                {contractAppStatusError ? (
                  <p className="rounded-lg border border-rose-100 bg-rose-50 px-3 py-2 text-sm font-bold text-rose-700 break-keep whitespace-normal [word-break:keep-all]">
                    {contractAppStatusError}
                  </p>
                ) : null}

                <div className="flex flex-col gap-2 sm:flex-row">
                  <button
                    type="button"
                    onClick={() =>
                      void requestContractAppStatus({
                        includeInternal: true,
                        silent: false,
                      })
                    }
                    disabled={contractAppStatusLoading || contractAppStatusSaving}
                    className="min-h-[44px] rounded-lg border border-slate-200 bg-white px-4 py-2.5 text-sm font-black text-slate-700 disabled:opacity-50"
                  >
                    {contractAppStatusLoading ? "불러오는 중..." : "운영 상태 새로고침"}
                  </button>
                  <button
                    type="button"
                    onClick={() => void handleSaveContractAppStatus()}
                    disabled={contractAppStatusSaving}
                    className="min-h-[44px] flex-1 rounded-lg bg-slate-900 px-4 py-2.5 text-sm font-black text-white disabled:opacity-50"
                  >
                    {contractAppStatusSaving ? "저장 중..." : "운영 상태 저장"}
                  </button>
                </div>
              </div>
              <div className="mb-4 rounded-xl border border-slate-200 bg-slate-50 p-4 space-y-3">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <h3 className="text-sm font-black text-slate-900">
                      검증 설정
                    </h3>
                    <p className="mt-1 text-[11px] leading-relaxed text-slate-500">
                      이 설정은 전체 전자계약 서비스에 적용됩니다. 테스트 목적으로 변경하면 모든 사용자에게 영향이 갑니다.
                    </p>
                  </div>
                  <ShieldCheck className="w-5 h-5 text-slate-500 shrink-0" />
                </div>
                <div className="grid grid-cols-1 gap-1 rounded-lg bg-white p-3 text-[11px] font-bold text-slate-600 border border-slate-100">
                  <p>
                    사업자번호 체크:{" "}
                    <span className={shouldRunNtsBusinessVerification(validationSettings) ? "text-emerald-600" : "text-rose-600"}>
                      {getNtsBusinessVerificationModeLabel(validationSettings)}
                    </span>
                  </p>
                  <p>
                    휴대폰 번호 확인:{" "}
                    <span className={validationSettings.enablePhoneVerification ? "text-emerald-600" : "text-rose-600"}>
                      {validationSettings.enablePhoneVerification ? "사용" : "사용 안 함"}
                    </span>
                  </p>
                </div>
                <div className="rounded-lg border border-slate-100 bg-white p-3">
                  <label className="text-sm font-bold text-slate-700">
                    국세청 사업자번호 체크 정책
                    <select
                      value={getNtsBusinessVerificationMode(validationSettingsDraft)}
                      onChange={(e) => {
                        const mode = e.target.value;
                        setValidationSettingsDraft((prev) => ({
                          ...prev,
                          enableBizNumberCheck: mode !== "DISABLED",
                          ntsBusinessVerification: {
                            ...(prev.ntsBusinessVerification || {}),
                            enabled: mode !== "DISABLED",
                            mode,
                          },
                        }));
                      }}
                      className="mt-2 w-full rounded-lg border border-slate-200 bg-white px-3 py-2.5 text-sm font-black text-slate-800 outline-none focus:border-slate-500"
                    >
                      <option value="MANUAL_REVIEW">본사 확인 허용 - 실패해도 진행</option>
                      <option value="REQUIRED">필수 검증 - 실패 시 차단</option>
                      <option value="DISABLED">사용 안 함 - API 미호출</option>
                    </select>
                  </label>
                  <p className="mt-2 text-[11px] font-bold leading-relaxed text-slate-500">
                    전체 사용자에게 적용됩니다. 운영 기본값은 본사 확인 허용입니다. KCP/PASS 대표자 본인확인은 별도로 필수 유지됩니다.
                  </p>
                </div>
                <label className="flex items-center gap-2 text-sm font-bold text-slate-700">
                  <input
                    type="checkbox"
                    checked={validationSettingsDraft.enablePhoneVerification}
                    onChange={(e) =>
                      setValidationSettingsDraft((prev) => ({
                        ...prev,
                        enablePhoneVerification: e.target.checked,
                      }))
                    }
                    className="h-4 w-4 accent-slate-900"
                  />
                  휴대폰 번호 확인 사용
                  <span className="text-[11px] font-bold text-rose-600">
                    전체 사용자에게 적용됩니다. 운영 중에는 반드시 사용해야 합니다.
                  </span>
                </label>
                <button
                  onClick={handleSaveValidationSettings}
                  className="w-full rounded-lg bg-slate-900 px-3 py-2.5 text-sm font-black text-white active:scale-95 transition-all"
                >
                  저장
                </button>
              </div>
              <div className="mb-4 rounded-xl border border-blue-100 bg-blue-50/50 p-4 space-y-3">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <h3 className="text-sm font-black text-slate-900">
                      본사 알림 이메일
                    </h3>
                    <p className="mt-1 text-[11px] leading-relaxed text-slate-500">
                      계약 제출 완료 시 아래 이메일로 알림을 발송합니다. 주민번호와 서명 이미지는 포함하지 않습니다.
                    </p>
                  </div>
                  <Mail className="w-5 h-5 text-blue-600 shrink-0" />
                </div>
                <div className="flex flex-col gap-2 sm:flex-row">
                  <input
                    type="email"
                    value={notificationEmailDraft}
                    onChange={(e) => setNotificationEmailDraft(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                        void handleAddNotificationEmail();
                      }
                    }}
                    placeholder="admin@cnfood.com"
                    className="min-w-0 w-full rounded-lg border border-blue-100 bg-white px-3 py-2.5 text-base outline-none focus:border-blue-400 sm:flex-1"
                  />
                  <button
                    type="button"
                    onClick={() => void handleAddNotificationEmail()}
                    disabled={notificationSettingsSaving}
                    className="w-full rounded-lg bg-blue-700 px-3 py-2.5 text-sm font-black text-white active:scale-95 transition-all disabled:opacity-50 sm:w-auto sm:shrink-0"
                  >
                    {notificationSettingsSaving ? "저장 중..." : "추가"}
                  </button>
                </div>
                <div className="rounded-lg border border-blue-100 bg-white p-3">
                  {notificationSettingsLoading ? (
                    <p className="flex items-center gap-2 text-xs font-bold text-slate-500">
                      <Loader2 className="h-3.5 w-3.5 animate-spin" />
                      알림 이메일 설정을 불러오는 중...
                    </p>
                  ) : notificationEmails.length > 0 ? (
                    <div className="flex flex-wrap gap-2">
                      {notificationEmails.map((email) => (
                        <span
                          key={email}
                          className="inline-flex max-w-full items-center gap-2 rounded-full bg-slate-100 px-3 py-1.5 text-xs font-bold text-slate-700"
                        >
                          <span className="truncate">{email}</span>
                          <button
                            type="button"
                            onClick={() => handleRemoveNotificationEmail(email)}
                            className="text-slate-400 hover:text-red-600"
                            aria-label={`${email} 삭제`}
                          >
                            <X className="h-3.5 w-3.5" />
                          </button>
                        </span>
                      ))}
                    </div>
                  ) : (
                    <p className="text-xs font-bold text-amber-700">
                      등록된 이메일이 없어 계약 완료 알림이 발송되지 않습니다.
                    </p>
                  )}
                </div>
                <button
                  type="button"
                  onClick={handleSaveNotificationSettings}
                  disabled={notificationSettingsSaving}
                  className="w-full rounded-lg bg-slate-900 px-3 py-2.5 text-sm font-black text-white active:scale-95 transition-all disabled:opacity-50"
                >
                  {notificationSettingsSaving ? (
                    <span className="inline-flex items-center gap-2">
                      <Loader2 className="h-4 w-4 animate-spin" />
                      저장 중...
                    </span>
                  ) : (
                    "알림 이메일 저장"
                  )}
                </button>
              </div>
              <div className="mb-4 rounded-xl border border-emerald-100 bg-emerald-50/50 p-4 space-y-4">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <h3 className="text-sm font-black text-slate-900">
                      영업사원 관리
                    </h3>
                    <p className="mt-1 text-[11px] leading-relaxed text-slate-500">
                      거래처 초대 링크에 표시될 담당 영업사원과 파트를 관리합니다.
                    </p>
                  </div>
                  <UserCheck className="w-5 h-5 text-emerald-600 shrink-0" />
                </div>
                <div className="grid grid-cols-1 gap-2">
                  <input
                    value={salesRepDraft.name}
                    onChange={(e) =>
                      setSalesRepDraft((prev) => ({ ...prev, name: e.target.value }))
                    }
                    placeholder="이름"
                    className="rounded-lg border border-emerald-100 bg-white px-3 py-2.5 text-base outline-none focus:border-emerald-400"
                  />
                  <input
                    value={salesRepDraft.part}
                    onChange={(e) =>
                      setSalesRepDraft((prev) => ({ ...prev, part: e.target.value }))
                    }
                    placeholder="부서/파트"
                    className="rounded-lg border border-emerald-100 bg-white px-3 py-2.5 text-base outline-none focus:border-emerald-400"
                  />
                  <input
                    value={salesRepDraft.phone}
                    onChange={(e) =>
                      setSalesRepDraft((prev) => ({ ...prev, phone: e.target.value }))
                    }
                    placeholder="연락처"
                    className="rounded-lg border border-emerald-100 bg-white px-3 py-2.5 text-base outline-none focus:border-emerald-400"
                  />
                  <input
                    type="email"
                    value={salesRepDraft.email}
                    onChange={(e) =>
                      setSalesRepDraft((prev) => ({ ...prev, email: e.target.value }))
                    }
                    placeholder="이메일(선택)"
                    className="rounded-lg border border-emerald-100 bg-white px-3 py-2.5 text-base outline-none focus:border-emerald-400"
                  />
                  <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
                    <button
                      type="button"
                      onClick={handleSaveSalesRepDraft}
                      disabled={isSavingSalesManager || salesRepsSaving}
                      className="rounded-lg bg-emerald-700 px-3 py-2.5 text-sm font-black text-white active:scale-95 transition-all disabled:opacity-50"
                    >
                      {isSavingSalesManager || salesRepsSaving
                        ? "저장 중..."
                        : salesRepDraft.id
                        ? "수정 저장"
                        : "추가"}
                    </button>
                    <button
                      type="button"
                      onClick={resetSalesRepDraft}
                      className="rounded-lg border border-emerald-200 bg-white px-3 py-2.5 text-sm font-black text-emerald-700 active:scale-95 transition-all"
                    >
                      입력 초기화
                    </button>
                  </div>
                </div>
                <div className="rounded-xl border border-emerald-100 bg-white p-3">
                  <div className="flex items-start justify-between gap-3">
                    <div>
                      <p className="text-xs font-black text-slate-800">
                        영업사원 일괄 등록
                      </p>
                      <p className="mt-1 text-[11px] leading-relaxed text-slate-500">
                        한 줄에 이름, 부서/파트, 연락처, 이메일 순서로 입력합니다.
                        이미 등록된 이름과 연락처는 기존 항목을 수정합니다.
                      </p>
                    </div>
                  </div>
                  <textarea
                    value={salesRepBulkText}
                    onChange={(e) => setSalesRepBulkText(e.target.value)}
                    placeholder={`박영훈, 기획영업팀/11파트, 01057148639, park.yh@seanfood.com\n김영업, 수도권영업팀, 01022223333, sales@seanfood.com`}
                    rows={5}
                    className="mt-3 w-full resize-y rounded-lg border border-emerald-100 bg-emerald-50/40 px-3 py-2.5 text-sm leading-6 outline-none focus:border-emerald-400"
                  />
                  <button
                    type="button"
                    onClick={handleSaveSalesRepBulk}
                    disabled={isSavingSalesManagersBulk || salesRepsSaving}
                    className="mt-2 w-full rounded-lg bg-emerald-900 px-3 py-2.5 text-sm font-black text-white active:scale-95 transition-all disabled:opacity-50"
                  >
                    {isSavingSalesManagersBulk || salesRepsSaving ? (
                      <span className="inline-flex items-center gap-2">
                        <Loader2 className="h-4 w-4 animate-spin" />
                        일괄 저장 중...
                      </span>
                    ) : (
                      "일괄 등록/수정"
                    )}
                  </button>
                </div>
                <div className="rounded-lg border border-emerald-100 bg-white p-3 space-y-2">
                  {salesRepStorageSource === "LOCAL_STORAGE_FALLBACK" && (
                    <p className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs font-bold leading-5 text-amber-800">
                      {SALES_REPS_LOCAL_STATUS_MESSAGE}
                    </p>
                  )}
                  {salesRepsLoading ? (
                    <p className="flex items-center gap-2 text-xs font-bold text-slate-500">
                      <Loader2 className="h-3.5 w-3.5 animate-spin" />
                      영업사원 목록을 불러오는 중...
                    </p>
                  ) : visibleSalesReps.length > 0 ? (
                    visibleSalesReps.map((rep) => (
                      <div
                        key={rep.id}
                        className="rounded-xl border border-slate-100 p-3 text-xs"
                      >
                        <div className="flex items-start justify-between gap-2">
                          <div className="min-w-0">
                            <p className="font-black text-slate-900">
                              {getSalesRepPart(rep)} · {rep.name}
                            </p>
                            <p className="mt-1 text-slate-500">{rep.phone}</p>
                            {rep.email && (
                              <p className="break-all text-slate-400">{rep.email}</p>
                            )}
                          </div>
                          <span
                            className={`rounded-full px-2 py-1 font-black ${
                              rep.active
                                ? "bg-emerald-50 text-emerald-700"
                                : "bg-slate-100 text-slate-500"
                            }`}
                          >
                            {rep.active ? "활성" : "비활성"}
                          </span>
                        </div>
                        <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2">
                          <button
                            type="button"
                            onClick={() => handleEditSalesRep(rep)}
                            className="rounded-lg bg-slate-100 px-3 py-2 font-black text-slate-700"
                          >
                            수정
                          </button>
                          <button
                            type="button"
                            onClick={() => handleToggleSalesRepActive(rep)}
                            className="rounded-lg bg-slate-900 px-3 py-2 font-black text-white"
                          >
                            {rep.active ? "비활성화" : "활성화"}
                          </button>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="text-xs font-bold text-amber-700">
                      등록된 영업사원이 없습니다.
                    </p>
                  )}
                </div>
              </div>
              <div className="mb-4 rounded-xl border border-cyan-100 bg-cyan-50/60 p-4 space-y-4">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <h3 className="text-sm font-black text-slate-900">
                      계약 초대 링크 생성
                    </h3>
                    <p className="mt-1 text-[11px] leading-relaxed text-slate-500">
                      링크에는 개인정보를 넣지 않고 초대 토큰만 포함합니다.
                    </p>
                  </div>
                  <FileText className="w-5 h-5 text-cyan-600 shrink-0" />
                </div>
                {salesRepStorageSource === "LOCAL_STORAGE_FALLBACK" && (
                  <p className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs font-bold leading-5 text-amber-800">
                    {SALES_REPS_LOCAL_INVITE_NOTICE_MESSAGE}
                  </p>
                )}
                <div className="grid grid-cols-1 gap-2">
                  <input
                    value={inviteDraft.customerName}
                    onChange={(e) =>
                      setInviteDraft((prev) => ({
                        ...prev,
                        customerName: e.target.value,
                      }))
                    }
                    placeholder="거래처명"
                    className="rounded-lg border border-cyan-100 bg-white px-3 py-2.5 text-base outline-none focus:border-cyan-400"
                  />
                  <select
                    value={inviteDraft.businessType}
                    onChange={(e) =>
                      setInviteDraft((prev) => ({
                        ...prev,
                        businessType: e.target.value,
                      }))
                    }
                    className="rounded-lg border border-cyan-100 bg-white px-3 py-2.5 text-base outline-none focus:border-cyan-400"
                  >
                    <option value="individual">개인</option>
                    <option value="corporate">법인</option>
                  </select>
                  <input
                    value={inviteDraft.businessNumber}
                    onChange={(e) =>
                      setInviteDraft((prev) => ({
                        ...prev,
                        businessNumber: e.target.value,
                      }))
                    }
                    placeholder="사업자번호(선택)"
                    className="rounded-lg border border-cyan-100 bg-white px-3 py-2.5 text-base outline-none focus:border-cyan-400"
                  />
                  <label className="block">
                    <span className="mb-1 block text-[11px] font-black text-slate-500">
                      관리 주체
                    </span>
                    <select
                      value={inviteDraft.ownerValue || INVITE_OWNER_HQ_VALUE}
                      onChange={(e) => {
                        const ownerSelection = parseInviteOwnerValue(e.target.value);
                        setInviteDraft((prev) => ({
                          ...prev,
                          ownerValue: ownerSelection.ownerValue,
                          salesRepId: ownerSelection.salesRepId || "",
                        }));
                      }}
                      className="w-full rounded-lg border border-cyan-100 bg-white px-3 py-2.5 text-base outline-none focus:border-cyan-400"
                    >
                      <option value={INVITE_OWNER_HQ_VALUE}>본사 직접 관리</option>
                      {activeSalesRepOptions.map((rep) => (
                        <option
                          key={rep.id}
                          value={`${INVITE_OWNER_SALES_REP_PREFIX}${rep.id}`}
                          disabled={
                            salesRepStorageSource === "LOCAL_STORAGE_FALLBACK"
                          }
                        >
                          {getSalesRepPart(rep)} - {rep.name}
                          {salesRepStorageSource === "LOCAL_STORAGE_FALLBACK"
                            ? " (서버 저장 필요)"
                            : ""}
                        </option>
                      ))}
                    </select>
                  </label>
                  <select
                    value={inviteDraft.expiresDays}
                    onChange={(e) =>
                      setInviteDraft((prev) => ({
                        ...prev,
                        expiresDays: e.target.value,
                      }))
                    }
                    className="rounded-lg border border-cyan-100 bg-white px-3 py-2.5 text-base outline-none focus:border-cyan-400"
                  >
                    <option value="7">7일</option>
                    <option value="14">14일</option>
                    <option value="30">30일</option>
                    <option value="60">60일</option>
                  </select>
                  <textarea
                    value={inviteDraft.memo}
                    onChange={(e) =>
                      setInviteDraft((prev) => ({ ...prev, memo: e.target.value }))
                    }
                    placeholder="메모(선택)"
                    rows={2}
                    className="rounded-lg border border-cyan-100 bg-white px-3 py-2.5 text-base outline-none focus:border-cyan-400"
                  />
                  <button
                    type="button"
                    onClick={handleCreateInvite}
                    disabled={inviteCreating}
                    className="rounded-lg bg-cyan-700 px-3 py-2.5 text-sm font-black text-white active:scale-95 transition-all disabled:opacity-50"
                  >
                    {inviteCreating ? "초대 링크 생성 중..." : "초대 링크 생성"}
                  </button>
                  {inviteCreateErrorMessage && (
                    <div className="rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-xs font-bold leading-5 text-rose-700">
                      {inviteCreateErrorMessage}
                    </div>
                  )}
                </div>
                {inviteResult && (
                  <div className="rounded-xl border border-cyan-100 bg-white p-3 space-y-3">
                    <div className="rounded-lg bg-cyan-50 px-3 py-2 text-xs font-bold text-cyan-800">
                      관리 주체: {getInviteOwnerLabel(inviteResult.invite)}
                    </div>
                    <div>
                      <p className="text-[11px] font-black text-slate-500">
                        초대 링크
                      </p>
                      <textarea
                        readOnly
                        value={inviteResult.inviteUrl}
                        rows={2}
                        className="mt-1 w-full max-w-full rounded-lg border border-slate-100 bg-slate-50 p-2 text-xs text-slate-700 break-all"
                      />
                    </div>
                    <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
                      <button
                        type="button"
                        onClick={() => copyTextToClipboard(inviteResult.inviteUrl)}
                        className="rounded-lg bg-slate-900 px-3 py-2 text-xs font-black text-white"
                      >
                        링크 복사
                      </button>
                      <button
                        type="button"
                        onClick={() => copyTextToClipboard(inviteResult.smsMessage)}
                        className="rounded-lg bg-blue-700 px-3 py-2 text-xs font-black text-white"
                      >
                        문자 문구 복사
                      </button>
                    </div>
                    <textarea
                      readOnly
                      value={inviteResult.smsMessage}
                      rows={7}
                      className="w-full max-w-full rounded-lg border border-slate-100 bg-slate-50 p-2 text-xs leading-5 text-slate-700 break-words"
                    />
                    <div className="rounded-xl border border-red-100 bg-red-50 p-3">
                      <div className="flex flex-wrap items-center gap-2">
                        <span className="rounded-full bg-red-700 px-2.5 py-1 text-[10px] font-black uppercase tracking-[0.14em] text-white">
                          PENDING_REPRESENTATIVE_KCP
                        </span>
                        <p className="text-xs font-black leading-5 text-red-900 break-keep">
                          대표자 본인확인 대기 상태에서는 대표자 본인 명의 휴대폰으로 직접 KCP 인증해야 합니다.
                        </p>
                      </div>
                      <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-3">
                        <button
                          type="button"
                          onClick={() => copyTextToClipboard(inviteResult.inviteUrl)}
                          className="rounded-lg border border-red-200 bg-white px-3 py-2 text-xs font-black text-red-700"
                        >
                          대표자 인증 요청 링크 복사
                        </button>
                        <button
                          type="button"
                          onClick={() => {
                            const message = buildRepresentativeIdentityRequestMessage({
                              requestLink: inviteResult.inviteUrl,
                            });
                            setToastMessage(
                              "대표자 인증 요청 문자 초안을 열었습니다. 발송 완료로 표시하지 않습니다."
                            );
                            window.location.href = buildSmsHref("", message);
                          }}
                          className="rounded-lg border border-red-200 bg-white px-3 py-2 text-xs font-black text-red-700"
                        >
                          대표자 인증 요청 문자 작성
                        </button>
                        <button
                          type="button"
                          onClick={() => {
                            setToastMessage("인증 상태를 새로고침합니다.");
                            void fetchAndShowList(currentManager);
                          }}
                          className="rounded-lg border border-red-200 bg-white px-3 py-2 text-xs font-black text-red-700"
                        >
                          인증 상태 새로고침
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </>
          ) : adminTab === "REPORTS" ? (
            <div className="animate-in fade-in space-y-4">
              <div className="rounded-2xl border border-slate-200 bg-slate-50 p-5">
                <div className="flex items-start justify-between gap-3">
                  <div>
                    <p className="text-sm font-black text-slate-900">
                      각종현황데이터
                    </p>
                    <p className="mt-1 text-xs font-bold leading-5 text-slate-500">
                      영업사원, 알림, 검증 설정처럼 계약서 목록과 분리해서 봐야 하는
                      운영 데이터를 모았습니다.
                    </p>
                  </div>
                  <BarChart3 className="h-5 w-5 shrink-0 text-slate-500" />
                </div>
              </div>
              <div className="grid grid-cols-1 gap-3 lg:grid-cols-4">
                <div className="rounded-2xl border border-emerald-100 bg-emerald-50 p-4">
                  <p className="text-xs font-black text-emerald-700">
                    활성 영업사원
                  </p>
                  <p className="mt-3 text-3xl font-black text-emerald-900">
                    {activeSalesRepOptions.length}
                  </p>
                  <p className="mt-2 text-xs font-bold text-emerald-700">
                    초대 링크 생성 선택지에 표시됩니다.
                  </p>
                </div>
                <div className="rounded-2xl border border-blue-100 bg-blue-50 p-4">
                  <p className="text-xs font-black text-blue-700">
                    알림 이메일
                  </p>
                  <p className="mt-3 text-3xl font-black text-blue-900">
                    {notificationEmails.length}
                  </p>
                  <p className="mt-2 text-xs font-bold text-blue-700">
                    계약 완료 알림 수신 대상입니다.
                  </p>
                </div>
                <div className="rounded-2xl border border-cyan-100 bg-cyan-50 p-4">
                  <p className="text-xs font-black text-cyan-700">
                    사업자번호 체크
                  </p>
                  <p className="mt-3 text-2xl font-black text-cyan-900">
                    {validationSettings.enableBizNumberCheck
                      ? "사용"
                      : "사용 안 함"}
                  </p>
                  <p className="mt-2 text-xs font-bold text-cyan-700">
                    국세청 사업자번호 검증 설정입니다.
                  </p>
                </div>
                <div className="rounded-2xl border border-amber-100 bg-amber-50 p-4">
                  <p className="text-xs font-black text-amber-700">
                    휴대폰 번호 확인
                  </p>
                  <p className="mt-3 text-2xl font-black text-amber-900">
                    {validationSettings.enablePhoneVerification
                      ? "사용"
                      : "사용 안 함"}
                  </p>
                  <p className="mt-2 text-xs font-bold text-amber-700">
                    SMS OTP 확인 설정입니다.
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">
                <button
                  type="button"
                  onClick={() => setAdminTab("SETTINGS")}
                  className="rounded-2xl border border-slate-200 p-4 text-left transition-colors hover:bg-slate-50"
                >
                  <p className="text-sm font-black text-slate-900">
                    설정 바로가기
                  </p>
                  <p className="mt-1 text-xs font-bold leading-5 text-slate-500">
                    영업사원 등록, 알림 이메일, 검증 설정, 초대 링크를 수정합니다.
                  </p>
                </button>
                <button
                  type="button"
                  onClick={() => setAdminTab("LIST")}
                  className="rounded-2xl border border-slate-200 p-4 text-left transition-colors hover:bg-slate-50"
                >
                  <p className="text-sm font-black text-slate-900">
                    계약서 데이터 바로가기
                  </p>
                  <p className="mt-1 text-xs font-bold leading-5 text-slate-500">
                    계약서 목록, 검색, 상세 조회는 별도 페이지에서 확인합니다.
                  </p>
                </button>
              </div>
            </div>
          ) : (
            <>
              <div className="mb-4 relative">
                <input
                  type="text"
                  placeholder="상호, 대표자, 전화번호 검색"
                  className="w-full p-3 pl-10 border rounded-xl bg-slate-50"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <Search className="w-5 h-5 text-slate-400 absolute left-3 top-3.5" />
              </div>
              <div className="flex gap-1 mb-4 overflow-x-auto pb-1">
                {["all", "completed", "confirmed", "rejected", "deleted"].map(
                  (status) => (
                    <button
                      key={status}
                      onClick={() => {
                        setStatusFilter(status);
                        setCurrentPage(1);
                      }}
                      className={`px-3 py-1.5 rounded-lg text-xs font-bold whitespace-nowrap ${
                        statusFilter === status
                          ? "bg-slate-800 text-white"
                          : "bg-slate-100 text-slate-500"
                      }`}
                    >
                      {status === "all" && "전체"}
                      {status === "completed" && "신규"}
                      {status === "confirmed" && "확정"}
                      {status === "rejected" && "반려"}
                      {status === "deleted" && "휴지통"}
                    </button>
                  )
                )}
              </div>
              <div className="mb-4 flex justify-end">
                <button
                  type="button"
                  onClick={() =>
                    downloadSafeContractRowsAsXlsx(
                      buildSalesLookupRows(filtered),
                      "cnfood_contract_admin"
                    )
                  }
                  className="inline-flex min-h-[44px] items-center justify-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-black text-slate-700"
                >
                  <Download className="h-4 w-4" />
                  현재 필터 엑셀 다운로드
                </button>
              </div>
              {showTrashPurgeControls && (
                <div className="mb-4 rounded-2xl border border-red-200 bg-red-50 p-4">
                  <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                    <div>
                      <p className="text-base font-black text-red-900">
                        휴지통 영구삭제 관리
                      </p>
                      <p className="mt-1 break-keep text-sm font-bold leading-6 text-red-800">
                        서버 dry-run으로 삭제 대상 계약을 먼저 확인한 뒤, 본사 관리자만 휴지통을 비울 수 있습니다.
                      </p>
                    </div>
                    <button
                      type="button"
                      onClick={openTrashPurgeModal}
                      className="min-h-[48px] rounded-2xl bg-red-700 px-4 py-3 text-base font-black text-white shadow-sm"
                    >
                      휴지통 비우기
                    </button>
                  </div>
                </div>
              )}
                <div className="grid grid-cols-1 gap-3 lg:grid-cols-2 xl:grid-cols-3">
                {currentItems.length === 0 ? (
                  <p className="text-center text-slate-400 py-10">
                    데이터가 없습니다.
                  </p>
                ) : (
                  currentItems.map((c) => (
                    <div
                      key={c.id}
                      onClick={() => handleContractClick(c)}
                      className="p-4 border rounded-xl hover:bg-slate-50 cursor-pointer transition-colors relative min-w-0"
                    >
                      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                        <span className="min-w-0 break-words text-lg font-bold">
                          {getAdminDisplayBusinessName(c)}
                        </span>
                        <div className="flex flex-wrap items-center gap-1 sm:flex-col sm:items-end">
                          <span className="text-xs text-slate-400">
                            {getContractDisplayDate(c, c.contractDate || "")}
                          </span>
                          {hasAdminContractDateOverride(c) && (
                            <span className="text-[10px] bg-blue-100 text-blue-700 px-1.5 py-0.5 rounded font-bold">
                              계약일 수정됨
                            </span>
                          )}
                          {getAdminContractStatusKey(c) === "completed" && (
                            <span className="text-[10px] bg-green-100 text-green-600 px-1.5 py-0.5 rounded font-bold">
                              신규
                            </span>
                          )}
                          {hasContractReceiptConfirmation(c) && (
                            <span className="text-[10px] bg-emerald-100 text-emerald-700 px-1.5 py-0.5 rounded font-bold">
                              접수 완료
                            </span>
                          )}
                          {(c.coRepresentativeWorkflow?.required ||
                            c.coRepresentativeDeclared === true ||
                            String(c.contractStatus || "").includes("CO_REP")) && (
                            <span className="text-[10px] bg-amber-100 text-amber-700 px-1.5 py-0.5 rounded font-bold">
                              {deriveContractDisplayStatus(c)}
                            </span>
                          )}
                          {getAdminContractStatusKey(c) === "confirmed" && (
                            <span className="text-[10px] bg-blue-100 text-blue-600 px-1.5 py-0.5 rounded font-bold">
                              확정
                            </span>
                          )}
                          {getAdminContractStatusKey(c) === "rejected" && (
                            <span className="text-[10px] bg-red-100 text-red-600 px-1.5 py-0.5 rounded font-bold">
                              반려
                            </span>
                          )}
                          {getAdminContractStatusKey(c) === "deleted" && (
                            <span className="text-[10px] bg-gray-200 text-gray-500 px-1.5 py-0.5 rounded font-bold">
                              삭제됨
                            </span>
                          )}
                        </div>
                      </div>
                      <p className="mt-2 break-words text-sm text-slate-500">
                        {c.agentRep} | {c.managerName}
                      </p>
                      <p className="mt-1 min-w-0 break-all text-sm font-bold text-slate-700">
                        연락처 {getAdminDisplayContact(c)}
                      </p>
                    </div>
                  ))
                )}
              </div>
              {filtered.length > 0 && (
                <div className="mt-6 flex flex-wrap items-center justify-center gap-2 border-t border-slate-100 pt-4">
                  <button
                    onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                    disabled={currentPage === 1}
                    className="p-2 rounded bg-gray-100 disabled:opacity-50"
                  >
                    <ChevronLeft className="w-4 h-4" />
                  </button>
                  <span className="px-2 py-1 text-sm font-bold flex items-center">
                    {currentPage} / {totalPages}
                  </span>
                  <button
                    onClick={() =>
                      setCurrentPage((p) => Math.min(totalPages, p + 1))
                    }
                    disabled={currentPage === totalPages}
                    className="p-2 rounded bg-gray-100 disabled:opacity-50"
                  >
                    <ChevronRight className="w-4 h-4" />
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    );
  }

  if (viewMode === "DETAIL" && selectedContract) {
    const selectedContractAdminOutputData =
      buildAdminContractOutputData(selectedContract);
    const selectedContractEvidenceRows = getAdminContractEvidenceRows(selectedContract);
    const legalEvidenceReadiness = getLegalEvidencePackageReadiness(selectedContract);
    const selectedBusinessNameCorrection =
      getBusinessNameCorrection(selectedContract);
    const selectedDisplayBusinessName =
      getAdminDisplayBusinessName(selectedContract);
    const selectedOriginalBusinessName =
      getBusinessNameCorrectionOriginalName(selectedContract);
    const canAuditSelectedSsn = Boolean(
      selectedContract.principalRepSsnEncrypted ||
        selectedContract.principalRepSsnMasked ||
        selectedContract.guarantorSsnEncrypted ||
        selectedContract.guarantorSsnMasked ||
        selectedContract.ssnEncrypted ||
        selectedContract.ssnMasked ||
        selectedContract.ssnFront
    );
    const ssnAccessLogs = Array.isArray(selectedContract.ssnAccessLogs)
      ? selectedContract.ssnAccessLogs
      : selectedContract.lastSsnAccess
      ? [selectedContract.lastSsnAccess]
      : [];
    const recentSsnAccessLogs = ssnAccessLogs.slice(-3).reverse();
    const selectedCompletionReceipt = buildCompletionReceiptFromContract(
      selectedContract,
      {
        confirmed: hasContractReceiptConfirmation(selectedContract),
        eventCreated: selectedContract.receiptEventCreated === true,
        receiptConfirmedAt: selectedContract.receiptConfirmedAt,
      }
    );
    const selectedContractStatusKey = String(
      selectedContract.status || ""
    ).toLowerCase();
    const selectedContractWorkflowStatus = String(
      selectedContract.contractStatus || ""
    ).toUpperCase();
    const canAddPostCompletionCoRepresentative =
      ["completed", "confirmed"].includes(selectedContractStatusKey) ||
      ["COMPLETED", "CONFIRMED"].includes(selectedContractWorkflowStatus);
    const showAdminCoRepresentativeManagement =
      hasAdminCoRepresentativeSignal(selectedContract) ||
      canAddPostCompletionCoRepresentative;

    return (
      <div className="min-h-screen overflow-x-hidden bg-slate-50 p-4 font-sans text-slate-800 flex flex-col items-center">
        {renderGlobalLoadingOverlay()}
        {renderErrorHelpModal()}
        {showBusinessNameCorrectionModal && (
          <div className="fixed inset-0 z-50 flex items-end justify-center bg-slate-900/50 p-3 sm:items-center">
            <div className="max-h-[92vh] w-full max-w-lg overflow-y-auto rounded-2xl bg-white p-5 shadow-2xl">
              <div className="mb-4 flex items-start justify-between gap-3">
                <div>
                  <h3 className="text-xl font-black text-slate-900">
                    사업자 정보 정정
                  </h3>
                  <p className="mt-1 break-keep text-sm font-bold leading-6 text-slate-600">
                    사업자등록증 등 확인 근거에 따라 상호명 표기만 정정합니다.
                    계약 원본, finalSnapshot, contractHash, signatureHash는 변경하지 않습니다.
                  </p>
                </div>
                <button
                  type="button"
                  onClick={closeBusinessNameCorrectionModal}
                  className="rounded-full bg-slate-100 p-2 text-slate-500"
                  aria-label="닫기"
                >
                  <X className="h-5 w-5" />
                </button>
              </div>

              <AdminHelpBox className="mb-4">
                {ADMIN_OPERATION_HELP.BUSINESS_CORRECTION}
              </AdminHelpBox>

              <div className="mb-4 rounded-2xl border border-slate-200 bg-slate-50 p-4 text-sm leading-6 text-slate-700">
                <div className="flex justify-between gap-3 border-b border-slate-200 pb-2">
                  <span className="font-black text-slate-500">고객 입력값</span>
                  <span className="min-w-0 break-words text-right font-bold">
                    {selectedOriginalBusinessName || "미수집"}
                  </span>
                </div>
                <div className="mt-2 flex justify-between gap-3">
                  <span className="font-black text-slate-500">사업자번호</span>
                  <span className="min-w-0 break-all text-right font-bold">
                    {selectedContract.agentBizNo || "미수집"}
                  </span>
                </div>
              </div>

              <label className="mb-4 block">
                <span className="mb-2 block text-base font-black text-slate-900">
                  관리자 정정 상호명 <span className="text-red-500">필수</span>
                </span>
                <input
                  value={businessNameCorrectionDraft.correctedName}
                  onChange={(event) => {
                    setBusinessNameCorrectionDraft((prev) => ({
                      ...prev,
                      correctedName: event.target.value,
                    }));
                    setBusinessNameCorrectionError("");
                  }}
                  className="min-h-[52px] w-full rounded-2xl border border-slate-200 px-4 py-3 text-base font-semibold outline-none focus:border-slate-700 focus:ring-2 focus:ring-slate-200"
                  placeholder="사업자등록증 기준 상호명을 입력해 주세요."
                />
              </label>

              <label className="mb-4 block">
                <span className="mb-2 block text-base font-black text-slate-900">
                  정정 사유 <span className="text-red-500">필수</span>
                </span>
                <select
                  value={businessNameCorrectionDraft.reason}
                  onChange={(event) => {
                    setBusinessNameCorrectionDraft((prev) => ({
                      ...prev,
                      reason: event.target.value,
                    }));
                    setBusinessNameCorrectionError("");
                  }}
                  className="min-h-[52px] w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-base font-semibold outline-none focus:border-slate-700 focus:ring-2 focus:ring-slate-200"
                >
                  <option value="">정정 사유를 선택해 주세요.</option>
                  {BUSINESS_NAME_CORRECTION_REASON_OPTIONS.map((reason) => (
                    <option key={reason} value={reason}>
                      {reason}
                    </option>
                  ))}
                </select>
              </label>

              <label className="mb-4 block">
                <span className="mb-2 block text-base font-black text-slate-900">
                  정정 근거 <span className="text-red-500">필수</span>
                </span>
                <select
                  value={businessNameCorrectionDraft.source}
                  onChange={(event) => {
                    setBusinessNameCorrectionDraft((prev) => ({
                      ...prev,
                      source: event.target.value,
                    }));
                    setBusinessNameCorrectionError("");
                  }}
                  className="min-h-[52px] w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-base font-semibold outline-none focus:border-slate-700 focus:ring-2 focus:ring-slate-200"
                >
                  {BUSINESS_NAME_CORRECTION_SOURCE_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </label>

              <div className="mb-4 rounded-2xl border border-amber-200 bg-amber-50 p-4 text-sm font-bold leading-6 text-amber-800">
                사업자번호나 대표자명이 달라지는 경우에는 단순 정정이 아니라 계약 재작성이 필요합니다.
                이 기능은 상호명 표기 오류 정정만 기록합니다.
              </div>

              {businessNameCorrectionError && (
                <div className="mb-4 rounded-2xl border border-red-200 bg-red-50 p-4 text-base font-bold leading-7 text-red-700">
                  {businessNameCorrectionError}
                </div>
              )}

              <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
                <button
                  type="button"
                  onClick={closeBusinessNameCorrectionModal}
                  disabled={businessNameCorrectionSaving}
                  className="min-h-[52px] rounded-2xl border border-slate-200 px-4 py-3 text-base font-black text-slate-700 disabled:opacity-60"
                >
                  취소
                </button>
                <button
                  type="button"
                  onClick={saveBusinessNameCorrection}
                  disabled={businessNameCorrectionSaving}
                  className="min-h-[52px] rounded-2xl bg-slate-900 px-4 py-3 text-base font-black text-white disabled:opacity-60"
                >
                  {businessNameCorrectionSaving ? "저장 중..." : "정정 이력 저장"}
                </button>
              </div>
            </div>
          </div>
        )}
        {showLegalEvidenceModal && (
          <div className="fixed inset-0 z-50 flex items-end justify-center bg-slate-900/50 p-3 sm:items-center">
            <div className="max-h-[92vh] w-full max-w-lg overflow-y-auto rounded-2xl bg-white p-5 shadow-2xl">
              <div className="mb-4 flex items-start justify-between gap-3">
                <div>
                  <h3 className="text-xl font-black text-slate-900">
                    법적 증빙자료 생성
                  </h3>
                  <p className="mt-1 break-keep text-sm leading-6 text-slate-600">
                    계약서, 본인확인, 서명, 제출 로그, Hash를 묶어 증빙자료를 생성합니다.
                  </p>
                  <p className="mt-2 break-keep rounded-2xl border border-amber-200 bg-amber-50 px-3 py-2 text-sm font-bold leading-6 text-amber-800">
                    출력용 문서는 브라우저 인쇄 또는 PDF 저장으로 사용할 수 있습니다.
                    구조화된 증빙 원본은 JSON manifest입니다.
                  </p>
                </div>
                <button
                  type="button"
                  onClick={closeLegalEvidenceModal}
                  className="rounded-full bg-slate-100 p-2 text-slate-500"
                  aria-label="닫기"
                >
                  <X className="h-5 w-5" />
                </button>
              </div>

              <AdminHelpBox className="mb-4">
                {ADMIN_OPERATION_HELP.LEGAL_EVIDENCE}
              </AdminHelpBox>

              <div className="mb-4 rounded-2xl border border-slate-200 bg-slate-50 p-4">
                <div className="mb-2 flex items-center justify-between">
                  <span className="text-sm font-black text-slate-700">증빙 적합도</span>
                  <span className="rounded-full bg-slate-900 px-3 py-1 text-sm font-black text-white">
                    {legalEvidenceReadiness.grade}등급
                  </span>
                </div>
                <div className="grid grid-cols-2 gap-2 text-sm">
                  {[
                    ["계약 Hash", legalEvidenceReadiness.contractHash],
                    ["서명 Hash", legalEvidenceReadiness.signatureHash],
                    ["완료 Snapshot", legalEvidenceReadiness.finalSnapshot],
                    ["KCP 상태", legalEvidenceReadiness.kcpStatus],
                    ["CI/DI 보관", legalEvidenceReadiness.ciDi],
                    ["sessionId", legalEvidenceReadiness.sessionId],
                    ["orderId", legalEvidenceReadiness.orderId],
                    ["대표자 검증", legalEvidenceReadiness.representativeMatchStatus],
                  ].map(([label, value]) => (
                    <div
                      key={label}
                      className="rounded-xl bg-white px-3 py-2 text-slate-700"
                    >
                      <div className="text-xs font-bold text-slate-400">{label}</div>
                      <div className="break-all font-black">{value}</div>
                    </div>
                  ))}
                </div>
              </div>

              <label className="mb-4 block">
                <span className="mb-2 block text-base font-black text-slate-900">
                  생성 목적 또는 열람 사유 <span className="text-red-500">필수</span>
                </span>
                <textarea
                  value={legalEvidenceReason}
                  onChange={(event) => {
                    setLegalEvidenceReason(event.target.value);
                    setLegalEvidenceError("");
                  }}
                  placeholder="예: 미수금 소송 자료 준비, 계약 부인 대응, 변호사 제출용"
                  className="min-h-[96px] w-full rounded-2xl border border-slate-200 px-4 py-3 text-base font-semibold leading-7 outline-none focus:border-slate-700 focus:ring-2 focus:ring-slate-200"
                />
              </label>

              <div className="mb-4 space-y-2">
                <p className="text-base font-black text-slate-900">생성 형식</p>
                <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
                  <button
                    type="button"
                    onClick={() => setLegalEvidenceFormat("html")}
                    className={`rounded-2xl border px-4 py-3 text-left text-base font-black ${
                      legalEvidenceFormat === "html"
                        ? "border-slate-900 bg-slate-900 text-white"
                        : "border-slate-200 bg-white text-slate-700"
                    }`}
                  >
                    출력용 증빙 문서
                    <span className="mt-1 block text-sm font-bold leading-6 opacity-80">
                      브라우저 인쇄 또는 PDF 저장으로 사용할 수 있습니다.
                    </span>
                  </button>
                  <button
                    type="button"
                    onClick={() => setLegalEvidenceFormat("json")}
                    className={`rounded-2xl border px-4 py-3 text-left text-base font-black ${
                      legalEvidenceFormat === "json"
                        ? "border-slate-900 bg-slate-900 text-white"
                        : "border-slate-200 bg-white text-slate-700"
                    }`}
                  >
                    증빙 JSON manifest
                  </button>
                </div>
              </div>

              <div className="mb-4 space-y-2 rounded-2xl border border-slate-200 p-4 text-sm leading-6">
                <p className="rounded-xl bg-slate-50 px-3 py-2 text-sm font-bold leading-6 text-slate-700">
                  한글이 깨지지 않도록 출력용 HTML 문서로 제공합니다. 공식 제출용 PDF가 필요하면 브라우저 인쇄에서 PDF 저장을 사용해 주세요. 구조화된 증빙 원본은 JSON manifest입니다.
                </p>
                <label className="flex items-start gap-3 font-bold text-slate-700">
                  <input type="checkbox" checked readOnly className="mt-1 h-5 w-5" />
                  해시 검증표 포함
                </label>
                <label className="flex items-start gap-3 font-bold text-slate-700">
                  <input
                    type="checkbox"
                    checked={false}
                    disabled
                    readOnly
                    className="mt-1 h-5 w-5"
                  />
                  계약서 출력본 포함은 후속 제공 예정입니다.
                </label>
                <label className="flex items-start gap-3 font-bold text-slate-400">
                  <input type="checkbox" disabled className="mt-1 h-5 w-5" />
                  민감 CI/DI 원문 export는 별도 승인 절차 전까지 비활성화되어 있습니다.
                </label>
              </div>

              {legalEvidenceError && (
                <div className="mb-4 rounded-2xl border border-red-200 bg-red-50 p-4 text-base font-bold leading-7 text-red-700">
                  {legalEvidenceError}
                </div>
              )}

              {legalEvidenceDownload && (
                <a
                  href={legalEvidenceDownload.url}
                  download={legalEvidenceDownload.fileName}
                  className="mb-4 flex min-h-[52px] items-center justify-center gap-2 rounded-2xl bg-emerald-600 px-4 py-3 text-base font-black text-white"
                >
                  <Download className="h-5 w-5" /> 증빙자료 다운로드
                </a>
              )}

              <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
                <button
                  type="button"
                  onClick={closeLegalEvidenceModal}
                  className="min-h-[52px] rounded-2xl border border-slate-200 px-4 py-3 text-base font-black text-slate-700"
                >
                  닫기
                </button>
                <button
                  type="button"
                  onClick={generateLegalEvidencePackage}
                  disabled={legalEvidenceGenerating}
                  className="min-h-[52px] rounded-2xl bg-slate-900 px-4 py-3 text-base font-black text-white disabled:opacity-60"
                >
                  {legalEvidenceGenerating ? "생성 중..." : "증빙자료 생성"}
                </button>
              </div>
            </div>
          </div>
        )}
        <div
          style={{
            position: "absolute",
            width: 0,
            height: 0,
            overflow: "hidden",
          }}
        >
          <canvas ref={contractCanvasRef} />
          <canvas ref={auditCanvasRef} />
        </div>
        {renderSalesAssignmentModal()}
        <div className={ADMIN_DETAIL_CARD_CLASS}>
          <button
            onClick={() => {
              setPendingConfirm(null);
              resetDetailRejectState();
              setViewMode("LIST");
            }}
            className="mb-4 flex items-center gap-1 text-slate-500 font-bold"
          >
            <ArrowLeft className="w-5 h-5" /> 목록으로
          </button>
          <AdminHelpBox className="mb-4">{ADMIN_OPERATION_HELP.DETAIL}</AdminHelpBox>
          <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
            <div className="min-w-0">
              <h2 className="break-words text-xl font-bold">
                {selectedDisplayBusinessName} 계약 정보
              </h2>
              {selectedBusinessNameCorrection && (
                <p className="mt-1 break-keep text-xs font-bold leading-5 text-amber-700">
                  고객 입력 상호명: {selectedOriginalBusinessName || "미수집"}
                </p>
              )}
            </div>
            <div className="flex flex-wrap items-center gap-2">
              <button
                type="button"
                onClick={openBusinessNameCorrectionModal}
                className="rounded-xl border border-amber-200 bg-amber-50 px-3 py-2 text-xs font-black text-amber-800 transition hover:bg-amber-100"
              >
                사업자 정보 정정
              </button>
            {selectedContract.status === "completed" && (
              <span className="bg-green-100 text-green-600 px-2 py-1 rounded text-xs font-bold">
                작성완료
              </span>
            )}
            {selectedContract.status === "confirmed" && (
              <span className="bg-blue-100 text-blue-600 px-2 py-1 rounded text-xs font-bold">
                확정됨
              </span>
            )}
            {selectedContract.status === "rejected" && (
              <span className="bg-red-100 text-red-600 px-2 py-1 rounded text-xs font-bold">
                반려됨
              </span>
            )}
            </div>
          </div>
          {selectedContract.status === "rejected" &&
            selectedContract.rejectReason && (
              <div className="bg-red-50 p-3 rounded-xl border border-red-100 text-red-700 text-sm mb-4">
                <span className="font-bold">반려 사유:</span>{" "}
                {selectedContract.rejectReason}
              </div>
            )}

          {renderPendingConfirmPanel("DETAIL") && (
            <div className="mb-4">{renderPendingConfirmPanel("DETAIL")}</div>
          )}

              {hasContractReceiptConfirmation(selectedContract) && (
                <div className="mb-4 rounded-xl border border-emerald-100 bg-emerald-50 p-4 text-sm">
              <p className="mb-3 flex items-center gap-1 font-bold text-emerald-900">
                <ClipboardCheck className="h-4 w-4" /> 접수 확인됨
              </p>
              <div className="space-y-2 text-xs text-slate-700">
                {[
                  ["계약번호", selectedCompletionReceipt.contractNumber || "미수집"],
                  ["접수일시", formatEvidenceDate(selectedCompletionReceipt.submittedAt)],
                  [
                    "접수 확인일시",
                    formatEvidenceDate(selectedCompletionReceipt.receiptConfirmedAt),
                  ],
                  [
                    "담당영업사원",
                    selectedCompletionReceipt.managerName ||
                      COMPLETION_RECEIPT_FALLBACK_MANAGER,
                  ],
                  ["상태", selectedCompletionReceipt.statusLabel || "접수 완료"],
                ].map(([label, value]) => (
                  <div key={label} className="flex justify-between gap-3">
                    <span className="font-bold text-slate-500">{label}</span>
                    <span className="min-w-0 break-words text-right font-bold">
                      {value}
                    </span>
                  </div>
                ))}
                  </div>
                </div>
              )}
              {showAdminCoRepresentativeManagement && (
                  <div className="mb-4 rounded-xl border border-amber-200 bg-amber-50 p-4 text-sm">
                    <p className="mb-3 flex items-center gap-1 font-bold text-amber-950">
                      <UserCheck className="h-4 w-4" /> 공동계약인 관리
                    </p>
                    <p className="mb-3 rounded-lg bg-white/80 px-3 py-2 text-xs font-bold leading-5 text-amber-900">
                      관리자 상세 화면에서는 공동계약인 휴대폰번호 원문이 저장된 경우 전체 번호를 표시합니다. 주민번호는 별도 열람 권한과 사유 기록이 있을 때만 확인합니다.
                    </p>
                    {canAddPostCompletionCoRepresentative && (
                      <div className="mb-3 rounded-xl border border-amber-100 bg-white p-3">
                        <div className="mb-3">
                          <p className="text-sm font-black text-slate-900">
                            사후 공동대표 추가
                          </p>
                          <p className="mt-1 text-xs font-bold leading-5 text-slate-600">
                            원계약 finalSnapshot과 contractHash는 보존하고 보완 이력으로 기록합니다.
                          </p>
                        </div>
                        <div className="grid grid-cols-1 gap-2 sm:grid-cols-3">
                          <label className="block">
                            <span className="mb-1 block text-xs font-black text-slate-600">
                              공동대표 성명
                            </span>
                            <input
                              type="text"
                              value={adminPostCompletionCoRepresentativeForm.name}
                              onChange={(event) =>
                                setAdminPostCompletionCoRepresentativeForm((prev) => ({
                                  ...prev,
                                  name: event.target.value,
                                }))
                              }
                              className="min-h-[40px] w-full rounded-xl border border-amber-200 px-3 text-sm font-bold outline-none focus:border-amber-500"
                              placeholder="예: 한동호"
                            />
                          </label>
                          <label className="block">
                            <span className="mb-1 block text-xs font-black text-slate-600">
                              휴대폰번호
                            </span>
                            <input
                              type="tel"
                              value={adminPostCompletionCoRepresentativeForm.phone}
                              onChange={(event) =>
                                setAdminPostCompletionCoRepresentativeForm((prev) => ({
                                  ...prev,
                                  phone: event.target.value,
                                }))
                              }
                              className="min-h-[40px] w-full rounded-xl border border-amber-200 px-3 text-sm font-bold outline-none focus:border-amber-500"
                              placeholder="010-0000-0000"
                            />
                          </label>
                          <label className="block">
                            <span className="mb-1 block text-xs font-black text-slate-600">
                              추가/정정 사유
                            </span>
                            <input
                              type="text"
                              value={adminPostCompletionCoRepresentativeForm.reason}
                              onChange={(event) =>
                                setAdminPostCompletionCoRepresentativeForm((prev) => ({
                                  ...prev,
                                  reason: event.target.value,
                                }))
                              }
                              className="min-h-[40px] w-full rounded-xl border border-amber-200 px-3 text-sm font-bold outline-none focus:border-amber-500"
                              placeholder="예: 공동대표 누락 사후 보완"
                            />
                          </label>
                        </div>
                        <button
                          type="button"
                          onClick={handleAddPostCompletionCoRepresentative}
                          disabled={
                            adminPostCompletionCoRepresentativeLoading ||
                            !String(
                              adminPostCompletionCoRepresentativeForm.name || ""
                            ).trim() ||
                            !String(
                              adminPostCompletionCoRepresentativeForm.phone || ""
                            ).trim() ||
                            !String(
                              adminPostCompletionCoRepresentativeForm.reason || ""
                            ).trim()
                          }
                          className="mt-3 min-h-[44px] w-full rounded-xl bg-slate-900 px-3 py-2 text-sm font-black text-white disabled:bg-slate-300"
                        >
                          {adminPostCompletionCoRepresentativeLoading
                            ? "링크 생성 중..."
                            : "공동대표 추가 및 링크 생성"}
                        </button>
                      </div>
                    )}
                    <div className="space-y-3">
                      {buildAdminCoRepresentativeRows(selectedContractAdminOutputData).map((representative, index) => {
                        const representativeId =
                          representative.id || `__co_rep_admin_row_${index + 1}__`;
                        const isAdminPlaceholder =
                          representative.adminPlaceholder === true ||
                          representative.adminContactOnly === true;
                        const issuedLink =
                          adminCoRepresentativeInviteLinks[representativeId] || "";
                        const issuedSignatureLink =
                          adminCoRepresentativeSignatureLinks[representativeId] || "";
                        const hasInviteTokenHash = Boolean(
                          representative.inviteTokenHash
                        );
                        const inviteReason =
                          adminCoRepresentativeInviteReasons[representativeId] || "";
                        const isCoRepresentativeCompleted =
                          representative.overallStatus === "COMPLETED" ||
                          representative.signatureStatus === "SIGNED" ||
                          Boolean(representative.completedAt);
                        const coRepresentativePhoneDisplay =
                          getAdminCoRepresentativePhoneDisplay(representative);
                        const coRepresentativeSsnRevealKey =
                          getCoRepresentativeOutputMatchId(representative);
                        const revealedCoRepresentativeSsn =
                          coRepresentativeSsnRevealKey
                            ? revealedCoRepresentativeSsns[
                                coRepresentativeSsnRevealKey
                              ] || ""
                            : "";
                        const coRepresentativeSsnDisplay =
                          revealedCoRepresentativeSsn ||
                          representative.ssnMasked ||
                          "미수집";
                        const actionStatus = getCoRepAdminActionStatus({
                          contract: selectedContract,
                          representative,
                          issuedLink,
                        });
                        const actionMeta = getCoRepAdminActionStatusMeta(actionStatus);
                        const statusBadgeClass =
                          actionMeta.tone === "emerald"
                            ? "bg-emerald-100 text-emerald-800"
                            : actionMeta.tone === "blue"
                            ? "bg-blue-100 text-blue-800"
                            : actionMeta.tone === "red"
                            ? "bg-red-100 text-red-800"
                            : "bg-amber-100 text-amber-900";
                        const inviteStatusLabel = issuedLink
                          ? "링크 준비됨"
                          : hasInviteTokenHash
                          ? "재발급 필요"
                          : "링크 없음";
                        const canCopyInviteLink = Boolean(issuedLink);
                        const canCopySignatureLink = Boolean(issuedSignatureLink);
                        const linkForMessage = issuedSignatureLink || issuedLink;
                        const smsMessage = buildCoRepresentativeSmsMessage({
                          requestLink: linkForMessage,
                        });
                        const rawSmsPhone = pickOutputRawPhone(
                          representative.adminOutputPhone,
                          representative.phone,
                          representative.verifiedPhone,
                          representative.identityVerification?.inputSnapshot?.phone,
                          representative.identityVerification?.verifiedPhone
                        );
                        const smsPhoneForDraft = isValidPhoneNumberFormat(rawSmsPhone || "")
                          ? rawSmsPhone
                          : "";
                        const canUseInviteActions =
                          !isAdminPlaceholder && Boolean(representative.id);
                        const canRequestSignatureOnly =
                          canUseInviteActions &&
                          (isCoRepresentativeVerifiedForAdmin(representative) ||
                            isCoRepresentativeSignedForAdmin(representative));
                        const authInviteButtonLabel =
                          hasInviteTokenHash || issuedLink
                            ? "재발급"
                            : "공동계약인 인증 링크 생성";
                        return (
                          <div
                            key={representativeId}
                            className="rounded-xl border border-amber-100 bg-white p-3"
                          >
                            <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
                              <div className="min-w-0">
                                <p className="break-words text-base font-black text-slate-900">
                                  {representative.name || "공동계약인"}
                                </p>
                                <p className="text-xs font-bold text-slate-600">
                                  <span className="text-slate-500">휴대폰번호: </span>
                                  <span className="text-slate-800">
                                    {coRepresentativePhoneDisplay}
                                  </span>
                                </p>
                                <p className="mt-1 text-xs font-bold text-amber-800">
                                  본인확인 {representative.verificationStatus || "PENDING"} / 서명 {representative.signatureStatus || "PENDING"}
                                </p>
                                <p className="mt-2 rounded-lg border border-slate-100 bg-slate-50 px-3 py-2 text-xs font-black leading-5 text-slate-700">
                                  {actionMeta.label}
                                  <span className="mt-1 block font-bold text-slate-500">
                                    {actionMeta.message}
                                  </span>
                                </p>
                                {actionStatus === CO_REP_ADMIN_ACTION_STATUS.SIGNED_MISSING_IMAGE && (
                                  <p className="mt-2 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-xs font-black leading-5 text-red-700">
                                    공동계약인 서명 완료 상태이나 출력 가능한 서명 이미지가 없습니다. 출력 전 확인이 필요합니다.
                                  </p>
                                )}
                                {!smsPhoneForDraft && (
                                  <p className="mt-2 rounded-lg border border-slate-100 bg-slate-50 px-3 py-2 text-xs font-bold leading-5 text-slate-600">
                                    휴대폰번호 원문이 없어 문자 발송은 제한됩니다. 링크 생성/복사는 가능 상태를 별도로 확인해 주세요.
                                  </p>
                                )}
                                {representative.adminContactOnly && (
                                  <p className="mt-2 rounded-lg border border-red-100 bg-red-50 px-3 py-2 text-xs font-bold leading-5 text-red-700">
                                    공동계약인 연락처 snapshot만 있고 계약 row가 없습니다. 링크 발급 전 공동계약인 저장 상태를 확인해 주세요.
                                  </p>
                                )}
                                {canAuditSelectedSsn && !isAdminPlaceholder && (
                                  <div className="mt-2 rounded-lg border border-amber-100 bg-amber-50 px-3 py-2">
                                    <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                                      <span className="text-xs font-black text-amber-900">
                                        공동계약인 주민번호
                                      </span>
                                      <span className="font-mono text-xs font-black text-slate-800">
                                        {coRepresentativeSsnDisplay}
                                      </span>
                                    </div>
                                    <button
                                      type="button"
                                      onClick={() =>
                                        handleRevealCoRepresentativeSsnClick(
                                          representative
                                        )
                                      }
                                      disabled={
                                        coRepresentativeSsnRevealLoadingId ===
                                        coRepresentativeSsnRevealKey
                                      }
                                      className="mt-2 min-h-[34px] rounded-lg border border-amber-200 bg-white px-2.5 py-1 text-xs font-black text-amber-800 disabled:opacity-60"
                                    >
                                      {coRepresentativeSsnRevealLoadingId ===
                                      coRepresentativeSsnRevealKey
                                        ? "확인 중..."
                                        : revealedCoRepresentativeSsn
                                        ? "주민번호 가리기"
                                        : "주민번호 확인"}
                                    </button>
                                  </div>
                                )}
                                <p className="mt-1 text-xs font-black text-slate-600">
                                  링크 상태: {inviteStatusLabel}
                                  {representative.inviteCreatedAt
                                    ? ` · 생성 ${formatEvidenceDate(representative.inviteCreatedAt)}`
                                    : ""}
                                  {representative.openedAt
                                    ? ` · 열람 ${formatEvidenceDate(representative.openedAt)}`
                                    : ""}
                                </p>
                              </div>
                              <span className={`rounded-full px-3 py-1 text-xs font-black ${statusBadgeClass}`}>
                                {actionMeta.label}
                              </span>
                            </div>
                            {issuedLink && (
                              <p className="mt-2 break-all rounded-lg bg-amber-50 px-3 py-2 text-xs font-bold leading-5 text-amber-900">
                                {issuedLink}
                              </p>
                            )}
                            {issuedSignatureLink && (
                              <p className="mt-2 break-all rounded-lg bg-blue-50 px-3 py-2 text-xs font-bold leading-5 text-blue-900">
                                서명 전용 링크: {issuedSignatureLink}
                              </p>
                            )}
                            {!canCopyInviteLink && (
                              <div className="mt-2 rounded-lg border border-amber-100 bg-amber-50 px-3 py-2 text-xs font-bold leading-5 text-amber-900">
                                {hasInviteTokenHash
                                  ? "기존 링크는 보안상 재표시할 수 없습니다. 필요 시 재발급하세요."
                                  : "공동계약인 링크가 없습니다. 인증 링크를 생성해 주세요."}
                              </div>
                            )}
                            <label className="mt-3 block">
                              <span className="mb-1 block text-xs font-black text-slate-600">
                                링크 생성/재발급 사유
                              </span>
                              <input
                                type="text"
                                value={inviteReason}
                                onChange={(event) =>
                                  setAdminCoRepresentativeInviteReasons((prev) => ({
                                    ...prev,
                                    [representativeId]: event.target.value,
                                  }))
                                }
                                className="min-h-[40px] w-full rounded-xl border border-amber-200 px-3 text-sm font-bold outline-none focus:border-amber-500 disabled:bg-slate-100 disabled:text-slate-400"
                                placeholder="예: 기존 데이터 token 누락으로 재발급"
                              />
                            </label>
                            {isCoRepresentativeCompleted && (
                              <p className="mt-2 text-xs font-bold text-slate-500">
                                완료된 공동계약인은 링크를 재발급할 수 없습니다.
                              </p>
                            )}
                            <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-4">
                              <button
                                type="button"
                                onClick={() =>
                                  handleIssueAdminCoRepresentativeInvite(representative)
                                }
                                disabled={
                                  adminCoRepresentativeInviteLoadingId ===
                                    representativeId ||
                                  !canUseInviteActions ||
                                  isCoRepresentativeCompleted ||
                                  !String(inviteReason || "").trim()
                                }
                                className="min-h-[44px] rounded-xl bg-amber-700 px-3 py-2 text-xs font-black text-white disabled:bg-slate-300"
                              >
                                {adminCoRepresentativeInviteLoadingId ===
                                representativeId
                                  ? "발급 중..."
                                  : authInviteButtonLabel}
                              </button>
                              <button
                                type="button"
                                onClick={() =>
                                  handleIssueAdminCoRepresentativeSignatureInvite(
                                    representative
                                  )
                                }
                                disabled={
                                  adminCoRepresentativeInviteLoadingId ===
                                    `${representativeId}:signature` ||
                                  !canRequestSignatureOnly ||
                                  !String(inviteReason || "").trim()
                                }
                                className="min-h-[44px] rounded-xl bg-blue-700 px-3 py-2 text-xs font-black text-white disabled:bg-slate-300"
                              >
                                {adminCoRepresentativeInviteLoadingId ===
                                `${representativeId}:signature`
                                  ? "발급 중..."
                                  : "서명만 다시 받기"}
                              </button>
                              <button
                                type="button"
                                onClick={() =>
                                  copyTextToClipboard(
                                    issuedSignatureLink || issuedLink
                                  )
                                }
                                disabled={!canCopyInviteLink && !canCopySignatureLink}
                                className="min-h-[44px] rounded-xl border border-amber-200 bg-white px-3 py-2 text-xs font-black text-amber-900 disabled:opacity-50"
                              >
                                링크 복사
                              </button>
                              <a
                                href={
                                  linkForMessage && smsPhoneForDraft
                                    ? buildSmsHref(
                                        smsPhoneForDraft,
                                        smsMessage
                                      )
                                    : undefined
                                }
                                className={`flex min-h-[44px] items-center justify-center rounded-xl px-3 py-2 text-xs font-black text-white ${
                                  linkForMessage && smsPhoneForDraft
                                    ? "bg-slate-900"
                                    : "pointer-events-none bg-slate-300"
                                }`}
                              >
                                문자 작성
                              </a>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}

              <div className="bg-slate-50 p-4 rounded-xl text-sm space-y-2 mb-4 border">
            <div className="flex justify-between border-b pb-2">
              <span className="text-slate-500 font-bold">계약일</span>
              <span className="text-right">
                {getContractDisplayDate(
                  selectedContract,
                  selectedContract.contractDate || "미수집"
                )}
                {hasAdminContractDateOverride(selectedContract) && (
                  <span className="ml-2 rounded-full bg-blue-100 px-2 py-0.5 text-[10px] font-black text-blue-700">
                    계약일 수정됨
                  </span>
                )}
              </span>
            </div>
            <div className="rounded-xl border border-blue-100 bg-white p-3 text-xs font-bold leading-5 text-slate-700">
              <div className="flex justify-between gap-3 border-b border-slate-100 pb-2">
                <span className="text-slate-500">원본 제출일</span>
                <span className="text-right">
                  {formatEvidenceDate(
                    selectedContract.submittedAt ||
                      selectedContract.createdAt ||
                      selectedContract.completedAt
                  )}
                </span>
              </div>
              <label className="mt-3 block">
                <span className="mb-1 block text-slate-500">
                  계약서 표시 계약일
                </span>
                <input
                  type="date"
                  value={adminContractDateDraft}
                  onChange={(event) =>
                    setAdminContractDateDraft(event.target.value)
                  }
                  className="min-h-[40px] w-full rounded-xl border border-blue-100 px-3 text-sm font-bold outline-none focus:border-blue-500"
                />
              </label>
              <label className="mt-3 block">
                <span className="mb-1 block text-slate-500">수정 사유</span>
                <input
                  type="text"
                  value={adminContractDateUpdateReason}
                  onChange={(event) =>
                    setAdminContractDateUpdateReason(event.target.value)
                  }
                  className="min-h-[40px] w-full rounded-xl border border-blue-100 px-3 text-sm font-bold outline-none focus:border-blue-500"
                  placeholder="예: 서류상 계약일 보정"
                />
              </label>
              {hasAdminContractDateOverride(selectedContract) && (
                <div className="mt-3 rounded-xl bg-blue-50 px-3 py-2 text-blue-800">
                  <p>
                    수정자:{" "}
                    {selectedContract.adminContractDateUpdatedBy || "관리자"}
                  </p>
                  <p>
                    수정일:{" "}
                    {formatEvidenceDate(
                      selectedContract.adminContractDateUpdatedAt,
                      "미수집"
                    )}
                  </p>
                  {selectedContract.adminContractDateUpdateReason && (
                    <p>
                      사유: {selectedContract.adminContractDateUpdateReason}
                    </p>
                  )}
                </div>
              )}
              <button
                type="button"
                onClick={saveAdminContractDate}
                disabled={
                  adminContractDateSaving ||
                  !isValidDateOnlyString(adminContractDateDraft)
                }
                className="mt-3 w-full rounded-xl bg-blue-700 px-4 py-3 text-sm font-black text-white disabled:bg-slate-300"
              >
                {adminContractDateSaving ? "저장 중..." : "계약일 저장"}
              </button>
            </div>
            <div className="flex justify-between border-b pb-2">
              <span className="text-slate-500 font-bold">상호</span>
              <span className="min-w-0 break-words text-right font-bold">
                {selectedDisplayBusinessName}
              </span>
            </div>
            {selectedBusinessNameCorrection && (
              <div className="rounded-xl border border-amber-100 bg-amber-50 p-3 text-xs font-bold leading-5 text-amber-900">
                <div className="flex justify-between gap-3">
                  <span className="text-amber-700">고객 입력값</span>
                  <span className="min-w-0 break-words text-right">
                    {selectedBusinessNameCorrection.originalName ||
                      selectedOriginalBusinessName ||
                      "미수집"}
                  </span>
                </div>
                <div className="mt-1 flex justify-between gap-3">
                  <span className="text-amber-700">정정 이력</span>
                  <span className="min-w-0 break-words text-right">
                    {selectedBusinessNameCorrection.reason || "미수집"} /{" "}
                    {getBusinessNameCorrectionSourceLabel(
                      selectedBusinessNameCorrection.source
                    )}{" "}
                    / {selectedBusinessNameCorrection.correctedBy || "관리자"} /{" "}
                    {formatAdminUpdatedAt(
                      selectedBusinessNameCorrection.correctedAt
                    )}
                  </span>
                </div>
              </div>
            )}
            <div className="flex justify-between border-b pb-2">
              <span className="text-slate-500 font-bold">대표자</span>
              <span>{selectedContract.agentRep}</span>
            </div>
            <div className="flex justify-between border-b pb-2">
              <span className="text-slate-500 font-bold">사업자번호</span>
              <span>{selectedContract.agentBizNo}</span>
            </div>
            <div className="flex justify-between border-b pb-2">
              <span className="text-slate-500 font-bold">연락처</span>
              <span className="min-w-0 break-all text-right">
                {getAdminDisplayContact(selectedContract)}
              </span>
            </div>
            <div className="flex justify-between border-b pb-2">
              <span className="text-slate-500 font-bold">주소</span>
              <span className="text-right break-keep w-1/2">
                {selectedContract.agentAddress}{" "}
                {selectedContract.agentAddressDetail}
              </span>
            </div>
            <div className="flex justify-between border-b pb-2">
              <span className="text-slate-500 font-bold">입금일</span>
              <span>
                {selectedContract.depositDay
                  ? selectedContract.depositDay + "일"
                  : "당일"}
              </span>
            </div>
            {canAuditSelectedSsn && (
              <>
                <div className="flex justify-between gap-3 border-b pb-2 items-center">
                  <span className="text-slate-500 font-bold">
                    본 대표 주민번호
                  </span>
                  <div className="flex flex-col items-end gap-2">
                    <span className="font-mono">
                      {revealedSsn ||
                        getPrincipalRepSsnDisplayValue(selectedContract)}
                    </span>
                    <textarea
                      value={ssnRevealReason}
                      onChange={(event) => setSsnRevealReason(event.target.value)}
                      rows={2}
                      placeholder="열람 사유 필수"
                      className="w-56 max-w-full rounded-lg border border-amber-200 bg-white px-2 py-1 text-xs font-semibold text-slate-700 outline-none focus:border-amber-500"
                    />
                    <button
                      type="button"
                      onClick={handleRevealSsnClick}
                      disabled={ssnRevealLoading}
                      className="rounded-lg border border-amber-200 bg-amber-50 px-2.5 py-1 text-xs font-bold text-amber-700 disabled:opacity-60"
                    >
                      {ssnRevealLoading
                        ? "확인 중..."
                        : revealedSsn
                        ? "주민번호 가리기"
                        : "주민번호 확인"}
                    </button>
                  </div>
                </div>
                {isCorporateContract(selectedContract.bizType) && (
                  <div className="flex justify-between gap-3 border-b pb-2 items-center">
                    <span className="text-slate-500 font-bold">
                      공동계약인 주민번호
                    </span>
                    <span className="font-mono text-right">
                      {getGuarantorSsnDisplayValue(selectedContract)}
                    </span>
                  </div>
                )}
              </>
            )}
            {recentSsnAccessLogs.length > 0 && (
              <div className="rounded-lg border border-amber-100 bg-amber-50 p-3 text-xs text-amber-900">
                <div className="mb-2 font-bold">주민번호 확인 이력</div>
                <div className="space-y-1">
                  {recentSsnAccessLogs.map((log, index) => (
                    <div key={`${log.accessedAt || "ssn-access"}-${index}`}>
                      {formatSsnAccessMemoLine(log)}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          {(selectedContract.inviteId ||
            selectedContract.salesRepName ||
            selectedContract.salesAssignment ||
            selectedContract.managerName ||
            selectedContract.partName ||
            selectedContract.ownerLabel) && (
            <div className="mb-4 rounded-xl border border-cyan-100 bg-cyan-50 p-4 text-sm">
              <p className="mb-3 flex items-center gap-1 font-bold text-cyan-900">
                <UserCheck className="w-4 h-4" /> 요청 관리 주체
              </p>
              <div className="space-y-2 text-xs text-slate-700">
                <div className="flex justify-between gap-3">
                  <span className="font-bold text-slate-500">관리 주체</span>
                  <span>{getInviteOwnerLabel(selectedContract)}</span>
                </div>
                <div className="flex justify-between gap-3">
                  <span className="font-bold text-slate-500">요청 부서</span>
                  <span>
                    {selectedContract.salesPart ||
                      selectedContract.salesRepDepartmentPart ||
                      "미수집"}
                  </span>
                </div>
                <div className="flex justify-between gap-3">
                  <span className="font-bold text-slate-500">담당자</span>
                  <span>{selectedContract.salesRepName || "미수집"}</span>
                </div>
                <div className="flex justify-between gap-3">
                  <span className="font-bold text-slate-500">연락처</span>
                  <span className="min-w-0 break-all text-right">
                    {selectedContract.salesRepPhone ||
                      selectedContract.salesRepPhoneMasked ||
                      "미수집"}
                  </span>
                </div>
                <div className="flex justify-between gap-3">
                  <span className="font-bold text-slate-500">초대 링크</span>
                  <span>{selectedContract.inviteId ? "사용" : "미사용"}</span>
                </div>
              </div>
              {isHeadquarters() && !isSalesLookupMode && (
                <button
                  type="button"
                  onClick={() =>
                    openSalesAssignmentModal({
                      ...buildSalesLookupRows([selectedContract])[0],
                      ...selectedContract,
                      documentId: selectedContract.id || selectedContract.documentId,
                    })
                  }
                  className="mt-3 inline-flex min-h-[40px] items-center justify-center rounded-xl bg-cyan-900 px-3 py-2 text-xs font-black text-white"
                >
                  담당/파트 수정
                </button>
              )}
            </div>
          )}

          {isKcpSmsFallbackContract(selectedContract) && (
            <div className="mb-4 rounded-xl border border-amber-200 bg-amber-50 p-4 text-xs font-bold leading-relaxed text-amber-800">
              KCP 본인확인 시작 실패 후 휴대폰 번호 문자 인증으로 진행된 계약입니다.
              문자 인증은 CI/DI 및 이름·생년월일 확인을 제공하지 않습니다.
            </div>
          )}

          <div className={ADMIN_EVIDENCE_SECTION_CLASS}>
            <p className="mb-3 flex items-center gap-1 text-sm font-bold text-slate-700">
              <ShieldCheck className="w-4 h-4" /> 전자계약 증적
            </p>
            <AdminHelpBox className="mb-3">
              {ADMIN_OPERATION_HELP.LEGAL_EVIDENCE}
            </AdminHelpBox>
            <div className={ADMIN_LEGAL_EVIDENCE_ACTION_CLASS}>
              <p className="break-keep text-sm font-bold leading-6 text-indigo-900">
                계약서, 본인확인, 서명, 제출 로그, Hash를 묶어 증빙자료를 생성합니다.
              </p>
              <button
                type="button"
                onClick={openLegalEvidenceModal}
                className="mt-3 flex min-h-[48px] w-full items-center justify-center gap-2 rounded-2xl bg-indigo-700 px-4 py-3 text-sm font-black text-white shadow-sm"
              >
                <FileText className="h-4 w-4" /> 법적 증빙자료 생성
              </button>
            </div>
            <div className="max-w-full overflow-hidden">
              {selectedContractEvidenceRows
                .filter((row) =>
                  [
                    "확인 방식",
                    "본 대표 주민번호",
                    "공동계약인 주민번호",
                    "주민번호 확인",
                    "본인확인 제공자",
                    "KCP 대체 사유",
                    "KCP 상태",
                    "CI/DI",
                    "계약 체결 권한",
                    "계약 Hash",
                    "서명 Hash",
                    "서명 역할",
                    "공동계약인 확인",
                    "완료 Snapshot",
                    "신용정보 동의",
                    "대표자 검증",
                    "공동계약인 안내",
                    "휴대폰 확인 시각",
                    "계약 열람 완료",
                    "전자서명 완료",
                    "제출 완료",
                    "상호 정정 이력",
                    "IP",
                    "User-Agent",
                  ].includes(row.label)
                )
                .map((row) => (
                  <div
                    key={row.label}
                    className={ADMIN_EVIDENCE_ROW_CLASS}
                  >
                    <span className={ADMIN_EVIDENCE_LABEL_CLASS}>
                      {row.label}
                    </span>
                    <span className={ADMIN_EVIDENCE_VALUE_CLASS}>
                      {row.value}
                    </span>
                  </div>
              ))}
            </div>
          </div>

          <div className="mb-4 max-w-full overflow-hidden rounded-xl border border-slate-200 bg-slate-50 p-4 print:bg-white">
            <div className="mb-3 flex items-center justify-between gap-3">
              <p className="flex items-center gap-1 text-sm font-bold text-slate-700">
                <FileText className="w-4 h-4" /> 완료본 보관 정보
              </p>
              <button
                type="button"
                onClick={() => window.print()}
                className="rounded-lg bg-slate-800 px-3 py-1.5 text-xs font-bold text-white"
              >
                출력
              </button>
            </div>
            {selectedContract.finalSnapshot ? (
              <div className="space-y-2 text-xs text-slate-700">
                <div className="flex justify-between gap-3 border-b border-slate-200 pb-2">
                  <span className="font-bold text-slate-500">계약번호</span>
                  <span>{selectedContract.contractId || "미수집"}</span>
                </div>
                <div className="flex justify-between gap-3 border-b border-slate-200 pb-2">
                  <span className="font-bold text-slate-500">완료일시</span>
                  <span>{formatEvidenceDate(selectedContract.finalSnapshot.completedAt)}</span>
                </div>
                <div className="flex justify-between gap-3 border-b border-slate-200 pb-2">
                  <span className="font-bold text-slate-500">계약 Hash</span>
                  <span className="min-w-0 break-all whitespace-normal text-right">
                    {selectedContract.finalSnapshot.contractHash}
                  </span>
                </div>
                <div className="flex justify-between gap-3 border-b border-slate-200 pb-2">
                  <span className="font-bold text-slate-500">서명 Hash</span>
                  <span className="min-w-0 break-all whitespace-normal text-right">
                    {selectedContract.finalSnapshot.signatureHash}
                  </span>
                </div>
                <div className="flex justify-between gap-3 border-b border-slate-200 pb-2">
                  <span className="font-bold text-slate-500">신용정보 동의</span>
                  <span className="text-right">
                    {selectedContract.finalSnapshot.hasCreditCheckConsent
                      ? `${selectedContract.finalSnapshot.creditCheckCompany || CREDIT_CHECK_COMPANY} 조회·활용 동의`
                      : "미확인"}
                  </span>
                </div>
                <div className="flex justify-between gap-3 border-b border-slate-200 pb-2">
                  <span className="font-bold text-slate-500">대표자 검증</span>
                  <span className="text-right">
                    {selectedContract.finalSnapshot.representativeVerificationStatus ||
                      getRepresentativeVerificationStatus()}
                  </span>
                </div>
                <div className="flex justify-between gap-3 border-b border-slate-200 pb-2">
                  <span className="font-bold text-slate-500">공동계약인 안내</span>
                  <span className="text-right">
                    {getCoRepresentativeDisplayValue(
                      selectedContract.finalSnapshot.coRepresentativeInfo
                    )}
                  </span>
                </div>
                <pre className="max-h-56 overflow-y-auto whitespace-pre-wrap rounded-lg bg-white p-3 text-[11px] leading-relaxed text-slate-700">
                  {selectedContract.finalSnapshot.contractTextSnapshot}
                </pre>
              </div>
            ) : (
              <p className="rounded-lg bg-white p-3 text-xs font-bold text-amber-700">
                완료 snapshot 없음. 과거 저장 문서이거나 이번 보강 이전 완료본입니다.
              </p>
            )}
          </div>

          <div className="mb-2 font-bold text-sm">서명 이미지</div>
          <div className="border rounded-xl p-4 flex justify-center bg-white mb-4">
            <img src={selectedContract.signature} alt="서명" className="h-20" />
          </div>
          {selectedContract.signature2 && (
            <div className="mb-4">
              <div className="mb-2 font-bold text-sm">
                대표자 공동계약 확인 서명
              </div>
              <div className="border rounded-xl p-4 flex justify-center bg-white">
                <img
                  src={selectedContract.signature2}
                  alt="제2서명"
                  className="h-20"
                />
              </div>
            </div>
          )}

          <div className="mb-4 rounded-xl border bg-slate-50 p-4">
            <div className="mb-2 flex items-center justify-between">
              <p className="text-sm font-bold text-slate-700">관리자 메모</p>
            </div>
            <textarea
              value={adminMemoDraft}
              onChange={(e) => setAdminMemoDraft(e.target.value)}
              rows={4}
              className="w-full rounded-xl border border-slate-200 bg-white p-3 text-sm text-slate-700 outline-none focus:border-slate-400"
              placeholder="관리자 메모를 입력해 주세요."
            />
            <button
              type="button"
              onClick={saveAdminMemo}
              disabled={memoSaving}
              className="mt-3 w-full rounded-xl bg-slate-800 px-4 py-3 text-sm font-bold text-white disabled:opacity-60"
            >
              {memoSaving ? "저장 중..." : "메모 저장"}
            </button>
            <p className="mt-2 text-xs text-slate-500">
              최종 수정: {formatAdminUpdatedAt(selectedContract.updatedAt)}
            </p>
          </div>

          <button
            onClick={() => handleAdminDownload()}
            className="w-full py-4 bg-slate-800 text-white rounded-xl font-bold flex justify-center items-center gap-2 shadow mb-4"
          >
            <Download /> [본사보관용 PDF] 다운로드
          </button>

          {selectedContract.auditTrail &&
            selectedContract.auditTrail.length > 0 && (
              <div className="mt-6 pt-4 border-t border-dashed">
                <p className="font-bold text-xs text-slate-400 mb-2 flex items-center gap-1">
                  <History className="w-3 h-3" /> 감사 로그 (Audit Trail)
                </p>
                <div className="space-y-2 max-h-40 overflow-y-auto bg-slate-50 p-2 rounded">
                  {selectedContract.auditTrail.map((log, i) => (
                    <div
                      key={i}
                      className="text-[10px] text-slate-500 bg-white p-2 rounded border shadow-sm"
                    >
                      <div className="flex justify-between font-bold text-slate-700">
                        <span>{log.action}</span>
                        <span>
                          {new Date(log.timestamp).toLocaleTimeString()}
                        </span>
                      </div>
                      <div className="mt-1">IP: {log.ip}</div>
                      <div className="truncate text-gray-400">{log.device}</div>
                      {log.note && (
                        <div className="mt-1 text-slate-400">{log.note}</div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}

          <div className="grid grid-cols-1 gap-2 mt-4 sm:grid-cols-3">
            <button
              onClick={() => updateContractStatus("confirmed")}
              className="py-3 bg-blue-100 text-blue-600 rounded-xl font-bold hover:bg-blue-200 transition-colors"
            >
              확정
            </button>
            <button
              onClick={() => setShowRejectInput(true)}
              className="py-3 bg-orange-100 text-orange-600 rounded-xl font-bold hover:bg-orange-200 transition-colors"
            >
              반려
            </button>
            {selectedContract.status === "deleted" ? (
              <button
                onClick={() => updateContractStatus("completed")}
                className="py-3 bg-gray-200 text-gray-700 rounded-xl font-bold"
              >
                복구
              </button>
            ) : (
              <button
                onClick={softDeleteContract}
                className="py-3 bg-red-100 text-red-600 rounded-xl font-bold hover:bg-red-200 transition-colors"
              >
                삭제
              </button>
            )}
          </div>

          {showRejectInput && (
            <div className="mt-4 p-4 border rounded-xl bg-orange-50 animate-in slide-in-from-top-2">
              <p className="text-sm font-bold text-orange-800 mb-2">
                반려 사유 입력
              </p>
              <input
                value={rejectReason}
                onChange={(e) => setRejectReason(e.target.value)}
                className="w-full p-2 border rounded-lg mb-2"
                placeholder="사유를 입력하세요"
              />
              <div className="flex gap-2">
                <button
                  onClick={() => updateContractStatus("rejected", rejectReason)}
                  className="flex-1 py-2 bg-orange-600 text-white rounded-lg font-bold"
                >
                  반려 처리
                </button>
                <button
                  onClick={() => setShowRejectInput(false)}
                  className="flex-1 py-2 bg-white border border-gray-300 rounded-lg text-gray-500"
                >
                  취소
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  if (viewMode === "ADMIN_LOGIN") {
    const selectedTargetMeta = getResolvedManagerTargetMeta(managerTarget);
    const adminSelectionOptions =
      paymentWorkspaceRoute === "SALES_REQUEST"
        ? ADMIN_ACCESS_OPTIONS.filter((option) => option.value === "sales_payment")
        : paymentWorkspaceRoute === "OPERATIONS"
        ? ADMIN_ACCESS_OPTIONS.filter((option) => option.value === "payment")
        : ADMIN_ACCESS_OPTIONS;
    const adminLoginButtonLabel = selectedTargetMeta.actionLabel;
    const selectedSalesPaymentManager = getSalesPaymentLoginOptionByCode(
      salesPaymentLoginOptions,
      salesPaymentCode
    );
    const filteredSalesPaymentManagers = filterSalesPaymentLoginOptions(
      salesPaymentLoginOptions,
      salesPaymentManagerSearch
    );

    return (
      <div
        className={SALES_PAYMENT_LOGIN_SCROLL_CONTAINER_CLASS}
        data-admin-login-scroll-container="true"
      >
        {renderGlobalLoadingOverlay()}
        <div className="my-2 w-full max-w-sm rounded-2xl bg-white p-6 shadow-2xl sm:my-0">
          <h3 className="text-lg font-bold mb-2">{selectedTargetMeta.label}</h3>
          <p className="text-sm text-slate-500 leading-relaxed mb-4">
            {selectedTargetMeta.description}
          </p>
          <div className="grid grid-cols-1 gap-2 mb-4 sm:grid-cols-2">
            {adminSelectionOptions.map((option) => {
              const isSelected = managerTarget === option.value;
              return (
                <button
                  key={option.value}
                  type="button"
                  onClick={() => {
                    setManagerTarget(option.value);
                    setAdminPassword("");
                    setSalesPaymentCode("");
                    setSalesPaymentManagerSearch("");
                    setSalesPaymentManagerListOpen(false);
                    setSalesPaymentLoginOptions([]);
                    setSalesPaymentLoginOptionsError("");
                  }}
                  className={`rounded-2xl border p-3 text-left transition-all ${
                    isSelected
                      ? "border-slate-900 bg-slate-900 text-white shadow-lg"
                      : "border-slate-200 bg-slate-50 text-slate-700"
                  }`}
                >
                  <div className="text-sm font-black">{option.label}</div>
                  <div
                    className={`text-[11px] mt-1 leading-relaxed ${
                      isSelected ? "text-slate-200" : "text-slate-500"
                    }`}
                  >
                    {option.description}
                  </div>
                </button>
              );
            })}
          </div>
          <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 mb-4">
            <div className="text-xs text-slate-500 mb-1">현재 선택</div>
            <div className="font-bold text-slate-900">{selectedTargetMeta.label}</div>
            <div className="text-xs text-slate-500 mt-1 leading-relaxed">
              {selectedTargetMeta.description}
            </div>
          </div>
          {managerTarget === "sales_payment" ? (
            <div className="mb-3 space-y-3">
              <input
                type="password"
                value={adminPassword}
                onChange={(event) => {
                  setAdminPassword(event.target.value);
                  setSalesPaymentCode("");
                  setSalesPaymentManagerSearch("");
                  setSalesPaymentManagerListOpen(false);
                  setSalesPaymentLoginOptions([]);
                  setSalesPaymentLoginOptionsError("");
                }}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    event.preventDefault();
                    void loadSalesPaymentLoginOptions();
                  }
                }}
                className="w-full p-3 border rounded-xl"
                placeholder="공통 비밀번호"
                autoComplete="current-password"
                disabled={loading || salesPaymentLoginOptionsLoading}
              />
              <button
                type="button"
                onClick={() => void loadSalesPaymentLoginOptions()}
                disabled={
                  loading || salesPaymentLoginOptionsLoading || !adminPassword.trim()
                }
                className="w-full rounded-xl border border-slate-300 bg-slate-50 px-3 py-3 text-sm font-black text-slate-800 disabled:opacity-50"
              >
                {salesPaymentLoginOptionsLoading
                  ? "담당자 목록 확인 중..."
                  : "담당자 목록 불러오기"}
              </button>
              {salesPaymentLoginOptions.length > 0 && (
                <>
                  <div ref={salesPaymentManagerPickerRef} className="relative">
                    <label
                      htmlFor="sales-payment-manager-search"
                      className="sr-only"
                    >
                      담당자명 검색·선택
                    </label>
                    <input
                      id="sales-payment-manager-search"
                      ref={salesPaymentManagerInputRef}
                      role="combobox"
                      aria-autocomplete="list"
                      aria-controls="sales-payment-login-listbox"
                      aria-expanded={salesPaymentManagerListOpen}
                      value={salesPaymentManagerSearch}
                      onChange={(event) => {
                        setSalesPaymentManagerSearch(event.target.value.slice(0, 80));
                        setSalesPaymentCode("");
                        setSalesPaymentManagerListOpen(true);
                      }}
                      onFocus={() => setSalesPaymentManagerListOpen(true)}
                      onKeyDown={(event) => {
                        if (event.key === "Escape") {
                          setSalesPaymentManagerListOpen(false);
                        }
                        if (
                          event.key === "Enter" &&
                          filteredSalesPaymentManagers.length === 1
                        ) {
                          event.preventDefault();
                          handleSalesPaymentManagerSelect(filteredSalesPaymentManagers[0]);
                        }
                      }}
                      autoComplete="off"
                      className="w-full rounded-xl border p-3"
                      placeholder="담당자명 검색·선택"
                      disabled={loading || salesPaymentLoginOptionsLoading}
                    />
                    {salesPaymentManagerListOpen && (
                      <div
                        id="sales-payment-login-listbox"
                        role="listbox"
                        aria-label="활성 담당자"
                        className={SALES_PAYMENT_LOGIN_LISTBOX_CLASS}
                        data-sales-payment-manager-listbox="true"
                      >
                        {filteredSalesPaymentManagers.length > 0 ? (
                          filteredSalesPaymentManagers.map((user) => (
                            <button
                              key={user.code}
                              type="button"
                              role="option"
                              aria-selected={salesPaymentCode === user.code}
                              onClick={() => handleSalesPaymentManagerSelect(user)}
                              className="flex w-full items-center justify-between gap-3 rounded-xl px-3 py-3 text-left text-sm hover:bg-slate-100 focus:bg-slate-100 focus:outline-none"
                            >
                              <span className="min-w-0 truncate font-bold text-slate-800">
                                {user.name}
                              </span>
                              <span className="shrink-0 text-xs text-slate-400">
                                {user.code}
                              </span>
                            </button>
                          ))
                        ) : (
                          <p className="px-3 py-4 text-center text-xs font-bold text-slate-500">
                            일치하는 담당자가 없습니다.
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                  {selectedSalesPaymentManager && (
                    <p
                      className="rounded-xl border border-emerald-200 bg-emerald-50 px-3 py-2 text-xs font-bold text-emerald-800"
                      data-selected-sales-payment-manager="true"
                    >
                      선택 담당자: {selectedSalesPaymentManager.name}
                    </p>
                  )}
                  <p className="text-xs font-bold text-slate-500">
                    활성 담당자 {salesPaymentLoginOptions.length}명 · 담당자명을 입력해
                    선택하세요.
                  </p>
                </>
              )}
              {salesPaymentLoginOptionsError && (
                <p className="rounded-xl border border-red-200 bg-red-50 px-3 py-2 text-xs font-bold text-red-700">
                  {salesPaymentLoginOptionsError}
                </p>
              )}
            </div>
          ) : (
            <input
              type="password"
              value={adminPassword}
              onChange={(event) => setAdminPassword(event.target.value)}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  event.preventDefault();
                  void handleAdminLoginSubmit();
                }
              }}
              className="w-full p-3 border rounded-xl mb-3"
              placeholder={
                managerTarget === "debug"
                  ? "개발자 비밀번호 입력"
                  : managerTarget === "sales_lookup"
                  ? "영업 조회 비밀번호"
                  : managerTarget === "payment"
                  ? "결제관리 비밀번호"
                  : "관리자 비밀번호 입력"
              }
              autoComplete="current-password"
              disabled={loading}
            />
          )}
          {!managerTarget && (
            <p className="text-xs text-amber-600 mb-4">
              모드를 먼저 선택해 주세요.
            </p>
          )}
          <div className={SALES_PAYMENT_LOGIN_ACTION_CLASS}>
            <button
              onClick={() => {
                setPendingConfirm(null);
                setAdminPassword("");
                adminSessionPasswordRef.current = "";
                salesPaymentActorCodeRef.current = "";
                setSalesPaymentCode("");
                setSalesPaymentManagerSearch("");
                setSalesPaymentManagerListOpen(false);
                setSalesPaymentLoginOptions([]);
                setSalesPaymentLoginOptionsError("");
                setAdminTestModeAuthorized(false);
                setAdminContractStartMode(false);
                setManagerTarget(null);
                setAdminAccessMode("ADMIN");
                setViewMode("FORM");
              }}
              disabled={loading || salesPaymentLoginOptionsLoading}
              className="flex-1 py-3 bg-slate-100 rounded-xl font-bold"
            >
              취소
            </button>
            <button
              ref={salesPaymentEnterButtonRef}
              type="button"
              onClick={() => {
                void handleAdminLoginSubmit();
              }}
              disabled={
                loading ||
                salesPaymentLoginOptionsLoading ||
                (managerTarget === "sales_payment" && !selectedSalesPaymentManager)
              }
              className="flex-1 break-keep rounded-xl bg-slate-900 py-3 text-sm font-bold leading-tight text-white disabled:opacity-50 sm:text-base"
            >
              {adminLoginButtonLabel}
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (shouldShowIntroScreen(viewMode, showIntroPage, step)) {
    return (
      <>
        {renderGlobalLoadingOverlay()}
        {renderErrorHelpModal()}
        {toastMessage && (
          <Toast message={toastMessage} onClose={() => setToastMessage(null)} />
        )}
        {renderUserErrorReportControls()}
        <ContractIntroPage
          onStart={handleStartFromIntro}
          onAdminAccess={handleLockClick}
          onOpenPrivacy={() => setShowPrivacyPolicy(true)}
          invite={activeInvite}
          inviteMessage={inviteLoadMessage}
          textSizeMode={textSizeMode}
          onTextSizeModeChange={handleTextSizeModeChange}
          appStatus={contractAppStatus}
          appStatusLoaded={contractAppStatusLoaded}
          isAdminSession={adminAccessMode === "ADMIN" && Boolean(currentManager?.name)}
          identityTestModeEnabled={identityTestModeAllowed}
        />
        {showPrivacyPolicy && (
          <PrivacyPolicyModal onClose={() => setShowPrivacyPolicy(false)} />
        )}
      </>
    );
  }

  // 기본 폼 화면
  return (
    <div
      ref={customerFlowCaptureRef}
      data-customer-contract-flow="true"
      className={`${getTextSizeModeClassName(
        textSizeMode
      )} min-h-screen bg-slate-100 flex flex-col items-center p-4 font-sans text-slate-800`}
      style={{ fontFamily: '"Noto Sans KR", sans-serif' }}
    >
      <style>{TEXT_SIZE_MODE_STYLE}</style>
      {renderGlobalLoadingOverlay()}
      {renderErrorHelpModal()}
      <div
        style={{
          position: "absolute",
          width: 0,
          height: 0,
          overflow: "hidden",
        }}
      >
        <canvas ref={contractCanvasRef} />
        <canvas ref={auditCanvasRef} />
      </div>

      {toastMessage && (
        <Toast message={toastMessage} onClose={() => setToastMessage(null)} />
      )}
      <ContractExitConfirmModal
        open={showContractExitConfirm}
        onContinue={handleContinueContractAfterBack}
        onExit={handleExitContractAfterBack}
      />
      {renderUserErrorReportControls()}
      <div className="w-full max-w-md bg-white p-5 rounded-2xl shadow-sm border border-slate-200 sticky top-2 z-20 mb-4">
        <div className="flex justify-between items-center mb-3">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 bg-red-600 rounded-lg flex items-center justify-center shadow-red-100">
              <Building2 className="text-white w-5 h-5" />
            </div>
            <div>
              <h1 className="text-base font-black text-slate-900">
                CN FOOD 전자계약
              </h1>
              <div className="flex flex-wrap items-center gap-1.5">
                <p className="text-xs font-bold tracking-wider text-slate-500">
                  Integrated Contract System
                </p>
                <span className="rounded bg-slate-100 px-1.5 py-0.5 text-xs font-bold text-slate-600">
                  관리 주체: {activeInvite ? getInviteOwnerLabel(activeInvite) : INVITE_OWNER_HQ_LABEL}
                </span>
              </div>
            </div>
          </div>
          {step === 0 && currentManager && (
            <button
              onClick={handleLockClick}
              className="p-2 text-slate-300 hover:text-slate-600"
            >
              <Lock className="w-4 h-4" />
            </button>
          )}
        </div>
        {shouldShowTextSizeSelector({
          viewMode,
          showIntroPage,
          step,
          isCorepInviteRoute,
        }) && (
          <TextSizeControls
            textSizeMode={textSizeMode}
            onTextSizeModeChange={handleTextSizeModeChange}
            compact
            className="mb-3"
          />
        )}
        {identityTestModeAllowed && (
          <div className="mb-3 rounded-2xl border border-red-200 bg-red-50 px-3 py-2 text-xs font-black text-red-800">
            TEST MODE · TEST_SIMULATION · 실제 KCP/PASS 인증 아님
          </div>
        )}
        {adminContractStartMode && (
          <div className="mb-3 rounded-2xl border border-blue-200 bg-blue-50 px-3 py-2 text-xs font-black text-blue-800">
            관리자 테스트 모드 · 일시중단 상태에서도 실제 KCP/PASS 흐름을 점검합니다.
          </div>
        )}
        {step < 5 && (
          <div className="h-1.5 bg-slate-100 rounded-full overflow-hidden">
            <div
              className="h-full bg-red-600 transition-all duration-500"
              style={{ width: `${((step + 1) / 4) * 100}%` }}
            ></div>
          </div>
        )}
      </div>

      <div className="w-full max-w-md bg-white rounded-[2rem] shadow-xl border border-white flex flex-col min-h-[600px]">
        <div className="p-6 flex-grow">
          {renderPendingConfirmPanel("FORM") && (
            <div className="mb-4">{renderPendingConfirmPanel("FORM")}</div>
          )}
          {step < 5 && shouldShowContractAppStatusBanner(contractAppStatus) && (
            <ContractAppStatusBanner
              appStatus={contractAppStatus}
              compact
              className="mb-4"
            />
          )}
          {shouldShowKcpReturnCheckingStep0Shield ? (
            <div className="space-y-5 animate-in slide-in-from-right-4">
              <div className="rounded-3xl border border-blue-100 bg-blue-50 px-5 py-6 text-center shadow-sm">
                <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-white text-blue-700 shadow-sm">
                  <Loader2 className="h-7 w-7 animate-spin" />
                </div>
                <h2 className="text-xl font-black leading-8 text-slate-950 break-keep">
                  본인확인 완료 상태를 확인 중입니다.
                </h2>
                <p className="mt-3 text-base font-bold leading-7 text-slate-700 break-keep">
                  잠시 후 주민번호 입력 단계로 이동합니다. 화면을 닫지 말고 기다려 주세요.
                </p>
              </div>
            </div>
          ) : step === 0 && (
            <div className="space-y-5 animate-in slide-in-from-right-4">
              <h2 className="text-2xl font-black leading-tight flex items-center gap-2 text-slate-900 break-keep">
                <UserCheck className="text-red-600" /> 공급받는자 정보
              </h2>
              <SectionHelp>
                사업자등록증 기준으로 대표자명과 개업일자를 입력해 주세요. 대표자 본인 명의 휴대폰으로 본인확인을 진행해야 합니다.
              </SectionHelp>
              <div className="flex gap-2 mb-4 p-1 bg-slate-100 rounded-2xl">
                <button
                  onClick={() => {
                    setBizType("INDIVIDUAL");
                    // 법인 전용 필드 초기화
                    setFormData((p) => ({
                      ...p,
                      corpRepName: "",
                      corpRepAddress: "",
                      corpRepAddressDetail: "",
                      ssnFront: "",
                      ssnBack: "",
                      principalRepSsnFront: "",
                      principalRepSsnBack: "",
                      guarantorSsnFront: "",
                      guarantorSsnBack: "",
                    }));
                    setErrors((p) => ({ ...p, corpRepName: "", corpRepAddress: "" }));
                    setManualCorpAddrMode(false);
                  }}
                  className={`min-h-[52px] flex-1 rounded-xl px-3 py-3 text-base font-bold transition-all ${
                    !isCorporateBiz
                      ? "bg-white text-red-600 shadow-sm"
                      : "text-slate-400"
                  }`}
                >
                  개인사업자
                </button>
                <button
                  onClick={() => {
                    setBizType("CORPORATE");
                    // 개인 전용 SSN 초기화
                    setFormData((p) => ({
                      ...p,
                      ssnFront: "",
                      ssnBack: "",
                      principalRepSsnFront: "",
                      principalRepSsnBack: "",
                      guarantorSsnFront: "",
                      guarantorSsnBack: "",
                    }));
                  }}
                  className={`min-h-[52px] flex-1 rounded-xl px-3 py-3 text-base font-bold transition-all ${
                    isCorporateBiz
                      ? "bg-white text-red-600 shadow-sm"
                      : "text-slate-400"
                  }`}
                >
                  법인사업자
                </button>
              </div>
              <FieldHelp step="1" prominent>
                계약 유형을 먼저 선택해 주세요. 개인사업자는 '개인사업자', 법인은 '법인사업자'를 선택하면 필요한 입력 항목이 자동으로 맞춰집니다. 공동계약인 또는 공동사업자 여부는 아래에서 별도로 확인합니다.
              </FieldHelp>
              <div className="space-y-4">
                <div>
                  <label className="text-base font-black text-slate-800 ml-1 mb-2 block break-keep">
                    계약 시작일
                  </label>
                  <div className="flex gap-2">
                    <select
                      value={selYear}
                      onChange={(e) => setSelYear(parseInt(e.target.value))}
                      className="min-h-[56px] min-w-0 flex-1 rounded-xl border px-3 py-3 text-lg font-bold"
                    >
                      {[2024, 2025, 2026, 2027].map((y) => (
                        <option key={y} value={y}>
                          {y}년
                        </option>
                      ))}
                    </select>
                    <select
                      value={selMonth}
                      onChange={(e) => setSelMonth(parseInt(e.target.value))}
                      className="min-h-[56px] min-w-0 flex-1 rounded-xl border px-3 py-3 text-lg font-bold"
                    >
                      {Array.from({ length: 12 }, (_, i) => i + 1).map((m) => (
                        <option key={m} value={m}>
                          {m}월
                        </option>
                      ))}
                    </select>
                    <select
                      value={selDay}
                      onChange={(e) => setSelDay(parseInt(e.target.value))}
                      className="min-h-[56px] min-w-0 flex-1 rounded-xl border px-3 py-3 text-lg font-bold"
                    >
                      {Array.from({ length: 31 }, (_, i) => i + 1).map((d) => (
                        <option key={d} value={d}>
                          {d}일
                        </option>
                      ))}
                    </select>
                  </div>
                  <FieldHelp step="2" prominent>
                    계약서에 표시될 계약 시작일입니다. 오늘 작성하더라도 실제 계약 적용일이 다르면 그 날짜를 선택해 주세요.
                  </FieldHelp>
                </div>
                <div>
                  <label className="text-base font-black text-slate-800 ml-1 mb-2 block break-keep">
                    상호명
                  </label>
                  <input
                    ref={agentNameInputRef}
                    name="agentName"
                    value={formData.agentName}
                    onChange={handleChange}
                    onFocus={() => setFocusedField("agentName")}
                    className={`w-full min-h-[56px] p-4 bg-slate-50 rounded-2xl border text-lg ${
                      errors.agentName
                        ? "border-red-500 bg-red-50"
                        : "border-slate-200"
                    } focus:border-red-500 outline-none font-semibold text-slate-900 transition-all`}
                    placeholder="사업자등록증 상호 입력"
                  />
                  {renderSeniorFieldHelp("agentName")}
                  {errors.agentName && (
                    <CustomerErrorMessage>{errors.agentName}</CustomerErrorMessage>
                  )}
                </div>
                <section className="cnfood-readable-text rounded-2xl border border-amber-200 bg-amber-50 px-4 py-4 text-amber-950 shadow-sm">
                  <div className="flex items-start gap-3">
                    <div className="mt-1 flex h-9 w-9 shrink-0 items-center justify-center rounded-2xl bg-white/80 text-amber-700">
                      <AlertTriangle className="h-5 w-5" />
                    </div>
                    <div className="min-w-0">
                      <h3 className="text-lg font-black leading-7 break-keep whitespace-normal [word-break:keep-all]">
                        대표자 본인확인이 필요합니다
                      </h3>
                      <div className="mt-2 space-y-2 text-base font-bold leading-7 break-keep whitespace-normal [word-break:keep-all]">
                        <p>
                          전자계약은 사업자등록증 기준 대표자 본인 명의의 휴대폰으로 인증해야 진행됩니다.
                        </p>
                        <p>
                          가족, 직원, 점장 등 대표자가 아닌 분의 휴대폰으로 인증하면 계약 진행이 제한될 수 있습니다.
                        </p>
                        <p>
                          사업자번호, 대표자명, 생년월일, 휴대폰번호를 정확히 입력해 주세요.
                        </p>
                        <p>
                          본인확인 완료 후에는 주요 정보가 잠기며, 수정하려면 본인확인을 다시 진행해야 합니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </section>
                <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                  <div>
                    <div className="mb-2 flex items-center justify-between gap-2">
                      <label className="text-base font-black text-slate-800 ml-1 block break-keep">
                        대표자명
                      </label>
                      <HelpButton topic="REPRESENTATIVE_IDENTITY" compact />
                    </div>
                    <input
                      ref={agentRepInputRef}
                      name="agentRep"
                      value={formData.agentRep}
                      onChange={handleChange}
                      onFocus={() => setFocusedField("agentRep")}
                      disabled={identityFieldsLocked}
                      readOnly={identityFieldsLocked}
                      className={`w-full min-h-[56px] p-4 bg-slate-50 rounded-2xl border text-lg ${
                        errors.agentRep
                          ? "border-red-500 bg-red-50"
                          : "border-slate-200"
                      } focus:border-red-500 outline-none font-semibold text-slate-900 transition-all`}
                      placeholder="성함"
                    />
                    {errors.agentRep && (
                      <CustomerErrorMessage>{errors.agentRep}</CustomerErrorMessage>
                    )}
                  </div>
                  <div>
                    <div className="mb-2 flex items-center justify-between gap-2">
                      <label className="text-base font-black text-slate-800 ml-1 block break-keep">
                        사업자번호
                      </label>
                      <HelpButton topic="BUSINESS_NUMBER" compact />
                    </div>
                    <input
                      ref={agentBizNoInputRef}
                      type="tel"
                      name="agentBizNo"
                      value={formData.agentBizNo}
                      onChange={handleBizNoChange}
                      onFocus={() => setFocusedField("agentBizNo")}
                      disabled={identityFieldsLocked}
                      readOnly={identityFieldsLocked}
                      className={`w-full min-h-[56px] p-4 bg-slate-50 rounded-2xl border text-lg ${
                        errors.agentBizNo
                          ? "border-red-500 bg-red-50"
                          : "border-slate-200"
                      } focus:border-red-500 outline-none font-semibold text-slate-900 transition-all`}
                      placeholder="숫자만 입력"
                      maxLength={12}
                    />
                    {errors.agentBizNo && (
                      <CustomerErrorMessage>{errors.agentBizNo}</CustomerErrorMessage>
                    )}
                  </div>
                  {getGroupedSeniorHelpField(["agentRep", "agentBizNo"]) && (
                    <div className="sm:col-span-2">
                      {renderSeniorFieldHelp(
                        getGroupedSeniorHelpField(["agentRep", "agentBizNo"])
                      )}
                    </div>
                  )}
                </div>
                <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                  <div>
                    <div className="mb-2 flex items-center justify-between gap-2">
                      <label className="text-base font-black text-slate-800 ml-1 block break-keep">
                        대표자 생년월일
                      </label>
                      <HelpButton topic="SSN" compact />
                    </div>
                    <input
                      ref={representativeBirthDateInputRef}
                      type="tel"
                      name="representativeBirthDate"
                      value={formData.representativeBirthDate}
                      onChange={handleChange}
                      onFocus={() => setFocusedField("representativeBirthDate")}
                      disabled={identityFieldsLocked}
                      readOnly={identityFieldsLocked}
                      className={`w-full min-h-[56px] p-4 bg-slate-50 rounded-2xl border text-lg ${
                        errors.representativeBirthDate
                          ? "border-red-500 bg-red-50"
                          : "border-slate-200"
                      } focus:border-red-500 outline-none font-semibold text-slate-900 transition-all disabled:text-slate-500`}
                      placeholder="예: 900101"
                      maxLength={10}
                    />
                    {errors.representativeBirthDate && (
                      <CustomerErrorMessage>{errors.representativeBirthDate}</CustomerErrorMessage>
                    )}
                  </div>
                  <div>
                    <div className="mb-2 flex items-center justify-between gap-2">
                      <label className="text-base font-black text-slate-800 ml-1 block break-keep">
                        개업일자
                      </label>
                      <HelpButton topic="OPENING_DATE" compact />
                    </div>
                    <input
                      ref={openingDateInputRef}
                      type="tel"
                      name="openingDate"
                      value={formData.openingDate}
                      onChange={handleChange}
                      onFocus={() => setFocusedField("openingDate")}
                      disabled={identityFieldsLocked}
                      readOnly={identityFieldsLocked}
                      className={`w-full min-h-[56px] p-4 bg-slate-50 rounded-2xl border text-lg ${
                        errors.openingDate
                          ? "border-red-500 bg-red-50"
                          : "border-slate-200"
                      } focus:border-red-500 outline-none font-semibold text-slate-900 transition-all disabled:text-slate-500`}
                      placeholder="YYYY-MM-DD"
                      maxLength={10}
                    />
                    {errors.openingDate && (
                      <CustomerErrorMessage>{errors.openingDate}</CustomerErrorMessage>
                    )}
                  </div>
                  <div className="sm:col-span-2">
                    <FieldHelp step="3">
                      본인확인 완료 후 대표자명, 생년월일, 휴대폰번호는 수정할 수 없습니다. 수정하려면 본인확인 다시하기를 눌러 주세요.
                    </FieldHelp>
                    {identityFieldsLocked && (
                      <div className="mt-2 flex flex-col gap-2 rounded-2xl border border-green-200 bg-green-50 px-4 py-3 text-sm font-black text-green-800 sm:flex-row sm:items-center sm:justify-between">
                        <Lock className="h-4 w-4" />
                        <button
                          type="button"
                          onClick={handleEditVerifiedIdentityInformation}
                          className="min-h-[44px] rounded-xl border border-green-300 bg-white px-3 py-2 text-sm font-black text-green-800 active:scale-95"
                        >
                          정보 수정하기
                        </button>
                        본인확인 완료로 수정할 수 없습니다.
                      </div>
                    )}
                  </div>
                </div>
                <div className="space-y-3 rounded-2xl border border-blue-100 bg-blue-50/70 px-4 py-4">
                  <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
                    <label className="flex items-start gap-3 text-base font-black leading-7 text-blue-950 break-keep">
                      <input
                        type="checkbox"
                        checked={coRepresentativeDeclared}
                        onChange={(e) => handleCoRepresentativeDeclaredChange(e.target.checked)}
                        className="mt-1 h-5 w-5 shrink-0 accent-red-600"
                      />
                      <span>공동계약인 또는 공동사업자가 있습니다.</span>
                    </label>
                    <HelpButton topic="CO_REPRESENTATIVE" compact />
                  </div>
                  <p className="text-[15px] font-bold leading-7 text-blue-900 break-keep">
                    개인사업자든 법인사업자든 공동계약인 또는 공동사업자가 있으면 다른 대표자에게도 전자계약 참여 또는 별도 확인을 안내해 주세요.
                  </p>
                  {coRepresentativeDeclared && (
                    <div className="space-y-3 rounded-2xl bg-white/80 p-3">
                      <div className="rounded-2xl border border-amber-200 bg-amber-50 px-4 py-4 text-base font-bold leading-7 text-amber-900 break-keep">
                        <div className="mb-2 flex items-start gap-2 font-black text-amber-950">
                          <AlertTriangle className="mt-1 h-5 w-5 shrink-0" />
                          <p>{CO_REPRESENTATIVE_REQUIRED_NOTICE_TITLE}</p>
                        </div>
                        <div className="space-y-2">
                          {CO_REPRESENTATIVE_REQUIRED_NOTICE_LINES.map((line) => (
                            <p key={line}>{line}</p>
                          ))}
                        </div>
                      </div>
                      {visibleCoRepresentatives.map((item, index) => {
                        const coRepLocked = isCoRepresentativeIdentityReadyForSigning(item);
                        const coRepKcpInProgress =
                          activeCoRepresentativeKcpId === item.id && kcpLoading;
                        const coRepBadges = getCoRepresentativeStatusBadges(item, {
                          kcpInProgress: coRepKcpInProgress,
                        });
                        const helpKeyPrefix = `${item.id}:`;
                        const renderCoRepHelp = (fieldKey) =>
                          activeCoRepHelpKey === `${helpKeyPrefix}${fieldKey}` ? (
                            <p
                              id={`corep-${item.id}-${fieldKey}-help`}
                              className="mt-2 rounded-2xl border border-blue-100 bg-blue-50 px-3 py-2 text-sm font-bold leading-6 text-blue-900 break-keep"
                            >
                              {CO_REP_FIELD_HELP[fieldKey]}
                            </p>
                          ) : null;
                        const setCoRepHelp = (fieldKey) =>
                          setActiveCoRepHelpKey(`${helpKeyPrefix}${fieldKey}`);
                        const identityVerification = item.identityVerification || {};
                        const coRepTestSimulation =
                          isIdentityTestSimulation(identityVerification);
                        const verifiedName =
                          identityVerification.kcpSnapshot?.verifiedName ||
                          identityVerification.verifiedName ||
                          item.name ||
                          "공동계약인";
                        const verifiedPhone =
                          identityVerification.inputSnapshot?.phoneMasked ||
                          identityVerification.verifiedPhoneMasked ||
                          maskPhoneNumber(item.phone || "") ||
                          "미수집";
                        const verifiedAt =
                          identityVerification.verifiedAt || item.verifiedAt || "";
                        const authButtonLabel = coRepLocked
                          ? "본인확인 완료"
                          : coRepKcpInProgress
                          ? "본인확인 진행 중..."
                          : ["MISMATCHED", "FAILED"].includes(String(item.kcpStatus || ""))
                          ? "본인확인 다시하기"
                          : "공동계약인 본인확인하기";
                        const signatureMode = getCoRepresentativeSignatureMode(item);
                        const directSignatureReady =
                          hasCoRepresentativeDirectSignatureEvidence(item);
                        const directSignatureValidation =
                          item.signatureEvidence?.validation || null;

                        if (PRIMARY_CO_REP_SPLIT_FLOW_ENABLED) {
                          const phoneOk = !item.phone || isValidPhoneNumberFormat(item.phone);
                          return (
                            <div
                              key={item.id}
                              className="grid grid-cols-1 gap-3 rounded-2xl border border-blue-100 bg-white p-4"
                            >
                              <div className="flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
                                <div>
                                  <p className="text-lg font-black text-blue-950">
                                    공동계약인 {index + 1}
                                  </p>
                                  <p className="mt-1 text-sm font-bold leading-6 text-slate-500 break-keep">
                                    주대표자 화면에서는 공동계약인 이름과 휴대폰번호만 입력합니다.
                                    주민번호, 자택주소, 본인확인과 전자서명은 공동계약인 본인이 별도 링크에서 직접 진행합니다.
                                  </p>
                                </div>
                                <span className="shrink-0 rounded-full border border-amber-200 bg-amber-50 px-3 py-1 text-xs font-black text-amber-700">
                                  별도 인증 대기
                                </span>
                              </div>
                              <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                                <label className="block">
                                  <span className="mb-1 block text-base font-black text-slate-800 break-keep">
                                    공동계약인 이름
                                  </span>
                                  <input
                                    value={item.name}
                                    onChange={(event) =>
                                      updateCoRepresentativeDraft(item.id, {
                                        name: event.target.value,
                                      })
                                    }
                                    readOnly={false}
                                    disabled={false}
                                    className="min-h-[52px] w-full rounded-xl border border-slate-200 px-3 py-2 text-base font-bold outline-none focus:border-red-500"
                                    placeholder="예: 홍길동"
                                    autoComplete="name"
                                  />
                                </label>
                                <label className="block">
                                  <span className="mb-1 block text-base font-black text-slate-800 break-keep">
                                    공동계약인 휴대폰번호
                                  </span>
                                  <input
                                    value={item.phone}
                                    onChange={(event) =>
                                      updateCoRepresentativeDraft(item.id, {
                                        phone: formatPhoneNumberForDisplay(
                                          event.target.value
                                        ),
                                      })
                                    }
                                    readOnly={false}
                                    disabled={false}
                                    className={`min-h-[52px] w-full rounded-xl border px-3 py-2 text-base font-bold outline-none focus:border-red-500 ${
                                      phoneOk ? "border-slate-200" : "border-red-300 bg-red-50"
                                    }`}
                                    placeholder="010-1234-5678"
                                    inputMode="numeric"
                                    maxLength={13}
                                    autoComplete="tel"
                                  />
                                  {!phoneOk && (
                                    <p className="mt-2 rounded-xl border border-red-100 bg-red-50 px-3 py-2 text-sm font-bold leading-6 text-red-700 break-keep">
                                      공동계약인 휴대폰번호 형식을 확인해 주세요.
                                    </p>
                                  )}
                                </label>
                              </div>
                              <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm font-bold leading-6 text-slate-700 break-keep">
                                주대표자 작성 완료 후 완료 화면에서 공동계약인별 인증 및 서명 링크를 전달할 수 있습니다.
                                링크 발송만으로 본인확인 또는 CI/DI 보관 완료로 표시하지 않습니다.
                              </div>
                              <div className="flex justify-end">
                                {visibleCoRepresentatives.length > 1 && (
                                  <button
                                    type="button"
                                    onClick={() => removeCoRepresentativeDraft(item.id)}
                                    className="min-h-[44px] rounded-xl border border-slate-200 px-3 py-2 text-sm font-black text-slate-500"
                                  >
                                    공동계약인 삭제
                                  </button>
                                )}
                              </div>
                            </div>
                          );
                        }

                        return (
                          <div
                            key={item.id}
                            className="grid grid-cols-1 gap-3 rounded-2xl border border-blue-100 bg-white p-4"
                          >
                            <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                              <div>
                                <p className="text-lg font-black text-blue-950">
                                  공동계약인 {index + 1}
                                </p>
                                <p className="mt-1 text-sm font-bold leading-6 text-slate-500 break-keep">
                                  이 카드의 본인확인은 이 공동계약인의 성명, 주민번호 앞자리, 휴대폰번호로만 진행됩니다.
                                </p>
                              </div>
                              <div className="flex flex-wrap gap-2">
                                {coRepBadges.map((badge) => (
                                  <span
                                    key={badge.label}
                                    className={`rounded-full border px-3 py-1 text-xs font-black ${getCoRepresentativeBadgeClass(
                                      badge.tone
                                    )}`}
                                  >
                                    {badge.label}
                                  </span>
                                ))}
                              </div>
                            </div>
                            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
                              <label className="block">
                                <span className="mb-1 block text-base font-black text-slate-800 break-keep">
                                  공동계약인 성명
                                </span>
                                <input
                                  value={item.name}
                                  onChange={(event) =>
                                    updateCoRepresentativeDraft(item.id, {
                                      name: event.target.value,
                                    })
                                  }
                                  onFocus={() => setCoRepHelp("name")}
                                  aria-describedby={`corep-${item.id}-name-help`}
                                  disabled={coRepLocked}
                                  readOnly={coRepLocked}
                                  className="min-h-[52px] w-full rounded-xl border border-slate-200 px-3 py-2 text-base font-bold outline-none focus:border-red-500 disabled:bg-slate-100 disabled:text-slate-500"
                                  placeholder="예: 홍길동"
                                />
                                {renderCoRepHelp("name")}
                              </label>
                              <label className="block">
                                <span className="mb-1 block text-base font-black text-slate-800 break-keep">
                                  공동계약인 주민번호 앞 6자리
                                </span>
                                <input
                                  value={item.ssnFront || item.birthDate || ""}
                                  onChange={(event) =>
                                    updateCoRepresentativeDraft(
                                      item.id,
                                      buildCoRepresentativeResidentNumberPatch(
                                        "ssnFront",
                                        event.target.value
                                      )
                                    )
                                  }
                                  onFocus={() => setCoRepHelp("ssnFront")}
                                  aria-describedby={`corep-${item.id}-ssnFront-help`}
                                  disabled={coRepLocked}
                                  readOnly={coRepLocked}
                                  className="min-h-[52px] w-full rounded-xl border border-slate-200 px-3 py-2 text-base font-bold outline-none focus:border-red-500 disabled:bg-slate-100 disabled:text-slate-500"
                                  placeholder="예: 820210"
                                  type="text"
                                  inputMode="numeric"
                                  pattern="[0-9]*"
                                  maxLength={6}
                                  autoComplete="off"
                                  autoCorrect="off"
                                  autoCapitalize="off"
                                  spellCheck={false}
                                />
                                {renderCoRepHelp("ssnFront")}
                              </label>
                              <label className="block">
                                <span className="mb-1 block text-base font-black text-slate-800 break-keep">
                                  공동계약인 주민번호 뒷 7자리
                                </span>
                                <input
                                  value={item.ssnBack || ""}
                                  onChange={(event) =>
                                    updateCoRepresentativeDraft(
                                      item.id,
                                      buildCoRepresentativeResidentNumberPatch(
                                        "ssnBack",
                                        event.target.value
                                      )
                                    )
                                  }
                                  onFocus={() => setCoRepHelp("ssnBack")}
                                  aria-describedby={`corep-${item.id}-ssnBack-help`}
                                  disabled={coRepLocked}
                                  readOnly={coRepLocked}
                                  className="min-h-[52px] w-full rounded-xl border border-slate-200 px-3 py-2 text-base font-bold outline-none focus:border-red-500 disabled:bg-slate-100 disabled:text-slate-500"
                                  placeholder="뒷 7자리 입력"
                                  inputMode="numeric"
                                  pattern="[0-9]*"
                                  maxLength={7}
                                  type="password"
                                  autoComplete="off"
                                  autoCorrect="off"
                                  autoCapitalize="off"
                                  spellCheck={false}
                                />
                                {renderCoRepHelp("ssnBack")}
                              </label>
                              <label className="block">
                                <span className="mb-1 block text-base font-black text-slate-800 break-keep">
                                  공동계약인 휴대폰번호
                                </span>
                                <input
                                  value={item.phone}
                                  onChange={(event) =>
                                    updateCoRepresentativeDraft(item.id, {
                                      phone: formatPhoneNumberForDisplay(event.target.value),
                                    })
                                  }
                                  onFocus={() => setCoRepHelp("phone")}
                                  aria-describedby={`corep-${item.id}-phone-help`}
                                  disabled={coRepLocked}
                                  readOnly={coRepLocked}
                                  className="min-h-[52px] w-full rounded-xl border border-slate-200 px-3 py-2 text-base font-bold outline-none focus:border-red-500 disabled:bg-slate-100 disabled:text-slate-500"
                                  placeholder="예: 010-1234-5678"
                                  inputMode="numeric"
                                  maxLength={13}
                                />
                                {renderCoRepHelp("phone")}
                              </label>
                              <label className="block">
                                <span className="mb-1 block text-base font-black text-slate-800 break-keep">
                                  공동계약인 자택주소
                                </span>
                                <div className="flex flex-col gap-2 sm:flex-row">
                                  <input
                                    value={item.homeAddress || ""}
                                    onChange={(event) =>
                                      updateCoRepresentativeDraft(item.id, {
                                        homeAddress: event.target.value,
                                      })
                                    }
                                    onFocus={() => setCoRepHelp("homeAddress")}
                                    aria-describedby={`corep-${item.id}-homeAddress-help`}
                                    disabled={coRepLocked}
                                    readOnly={coRepLocked}
                                    className="min-h-[52px] w-full rounded-xl border border-slate-200 px-3 py-2 text-base font-bold outline-none focus:border-red-500 disabled:bg-slate-100 disabled:text-slate-500"
                                    placeholder="예: 서울시 강남구 테헤란로 123"
                                  />
                                  <button
                                    type="button"
                                    aria-label="공동계약인 자택주소 검색"
                                    onClick={() =>
                                      openCoRepresentativeAddressSearch({
                                        coRepresentativeId: item.id,
                                      })
                                    }
                                    disabled={coRepLocked}
                                    className="inline-flex min-h-[52px] shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-xl border border-blue-200 bg-blue-50 px-4 py-2 text-base font-black text-blue-900 disabled:border-slate-200 disabled:bg-slate-100 disabled:text-slate-400"
                                  >
                                    <Search className="h-4 w-4 shrink-0" />
                                    {CO_REP_ADDRESS_SEARCH_VISIBLE_LABEL}
                                  </button>
                                </div>
                                {renderCoRepHelp("homeAddress")}
                              </label>
                              <label className="block">
                                <span className="mb-1 block text-base font-black text-slate-800 break-keep">
                                  공동계약인 상세주소
                                </span>
                                <input
                                  value={item.homeAddressDetail || ""}
                                  onChange={(event) =>
                                    updateCoRepresentativeDraft(item.id, {
                                      homeAddressDetail: event.target.value,
                                    })
                                  }
                                  onFocus={() => setCoRepHelp("homeAddressDetail")}
                                  aria-describedby={`corep-${item.id}-homeAddressDetail-help`}
                                  disabled={coRepLocked}
                                  readOnly={coRepLocked}
                                  className="min-h-[52px] w-full rounded-xl border border-slate-200 px-3 py-2 text-base font-bold outline-none focus:border-red-500 disabled:bg-slate-100 disabled:text-slate-500"
                                  placeholder="예: 101동 1001호 / 상세주소"
                                />
                                {renderCoRepHelp("homeAddressDetail")}
                              </label>
                            </div>
                            {coRepLocked && (
                              <div className="rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-4 text-sm font-bold leading-6 text-emerald-900 break-keep">
                                <div className="mb-2 flex items-center gap-2 text-base font-black text-emerald-950">
                                  <ShieldCheck className="h-5 w-5" />
                                  {coRepTestSimulation ? "TEST MODE" : "본인확인 완료"}
                                </div>
                                <p>
                                  {coRepTestSimulation
                                    ? "공동계약인 TEST_SIMULATION 상태입니다. 실제 KCP 본인확인 또는 CI/DI 증빙이 아닙니다."
                                    : `공동계약인 ${verifiedName}님의 KCP 본인확인이 완료되었습니다. 이름, 생년월일, 휴대폰번호가 입력 정보와 일치합니다.`}
                                </p>
                                <div className="mt-2 grid grid-cols-1 gap-1 sm:grid-cols-2">
                                  <p>인증자명: {verifiedName}</p>
                                  <p>인증 휴대폰: {verifiedPhone}</p>
                                  <p>인증 시각: {verifiedAt || "확인됨"}</p>
                                  <p>
                                    CI/DI: {hasCoRepresentativeIdentityEvidenceStored(item) ? "CI/DI 보관됨" : "CI/DI 확인 필요"}
                                  </p>
                                </div>
                              </div>
                            )}
                            <div className="flex flex-col gap-2 sm:flex-row">
                              <button
                                type="button"
                                onClick={() =>
                                  handleStartKcpIdentity({
                                    subjectType: "CO_REP",
                                    coRepresentativeId: item.id,
                                  })
                                }
                                disabled={coRepLocked || coRepKcpInProgress}
                                className="min-h-[52px] flex-1 rounded-xl bg-blue-700 px-3 py-2 text-base font-black text-white disabled:bg-slate-300 disabled:text-slate-500"
                              >
                                {authButtonLabel}
                              </button>
                              {identityTestModeAllowed && !coRepLocked && (
                                <button
                                  type="button"
                                  onClick={() =>
                                    applyCoRepresentativeIdentityTestSimulation(item.id)
                                  }
                                  className="min-h-[52px] rounded-xl border border-red-200 bg-red-50 px-3 py-2 text-base font-black text-red-700"
                                >
                                  TEST_SIMULATION
                                </button>
                              )}
                              {coRepLocked && (
                                <button
                                  type="button"
                                  onClick={() =>
                                    updateCoRepresentativeDraft(item.id, {
                                      kcpSessionId: "",
                                      kcpStatus: "PENDING",
                                      identityStatus: "PENDING",
                                      identityVerification: null,
                                      delegatedSignatureConsent: {
                                        ...item.delegatedSignatureConsent,
                                        agreed: false,
                                        agreedAt: null,
                                        principalSignerName: "",
                                      },
                                      signatureEvidence: null,
                                      signatureHash: "",
                                      signatureImageDataUrl: "",
                                      signatureStatus: "PENDING",
                                      signedAt: null,
                                    })
                                  }
                                  className="min-h-[52px] rounded-xl border border-slate-200 px-3 py-2 text-base font-black text-slate-700"
                                >
                                  공동계약인 본인확인 다시하기
                                </button>
                              )}
                              {visibleCoRepresentatives.length > 1 && (
                                <button
                                  type="button"
                                  onClick={() => removeCoRepresentativeDraft(item.id)}
                                  disabled={coRepLocked}
                                  className="min-h-[52px] rounded-xl border border-slate-200 px-3 py-2 text-base font-black text-slate-500 disabled:bg-slate-100 disabled:text-slate-300"
                                >
                                  공동계약인 삭제
                                </button>
                              )}
                            </div>
                            <div className="rounded-2xl border border-slate-200 bg-slate-50 p-3">
                              <div className="mb-2 flex items-center justify-between gap-2">
                                <p className="text-base font-black text-slate-900 break-keep">
                                  공동계약인 서명 방식
                                </p>
                                <HelpButton
                                  topic={
                                    signatureMode ===
                                    CO_REPRESENTATIVE_SIGNATURE_MODE_DIRECT
                                      ? "DIRECT_SIGNATURE"
                                      : "DELEGATED_SIGNATURE"
                                  }
                                  compact
                                />
                              </div>
                              <div className="grid grid-cols-1 gap-2">
                                {[
                                  {
                                    value: CO_REPRESENTATIVE_SIGNATURE_MODE_DIRECT,
                                    label: "공동계약인이 직접 서명합니다",
                                    description:
                                      "공동계약인 본인확인 완료 후 해당 공동계약인이 직접 성명을 정자로 서명합니다.",
                                  },
                                  {
                                    value: CO_REPRESENTATIVE_SIGNATURE_MODE_DELEGATED,
                                    label:
                                      "공동계약인 본인확인 후 주대표자 대리서명에 동의합니다",
                                    description:
                                      "공동계약인이 현장에 없거나 직접 서명하기 어려운 경우에만 선택합니다.",
                                  },
                                ].map((option) => (
                                  <label
                                    key={option.value}
                                    className={`flex cursor-pointer items-start gap-3 rounded-xl border px-3 py-3 text-sm font-bold leading-6 break-keep ${
                                      signatureMode === option.value
                                        ? "border-blue-300 bg-white text-blue-950"
                                        : "border-slate-200 bg-white text-slate-700"
                                    }`}
                                  >
                                    <input
                                      type="radio"
                                      name={`corep-signature-mode-${item.id}`}
                                      checked={signatureMode === option.value}
                                      onChange={() =>
                                        updateCoRepresentativeSignatureMode(
                                          item.id,
                                          option.value
                                        )
                                      }
                                      className="mt-1 h-5 w-5 shrink-0 accent-blue-700"
                                    />
                                    <span>
                                      <span className="block text-base font-black">
                                        {option.label}
                                      </span>
                                      <span className="mt-1 block text-slate-600">
                                        {option.description}
                                      </span>
                                    </span>
                                  </label>
                                ))}
                              </div>
                            </div>
                            {signatureMode === CO_REPRESENTATIVE_SIGNATURE_MODE_DIRECT ? (
                              <div className="rounded-2xl border border-blue-100 bg-blue-50/70 p-3">
                                <div className="mb-2 flex items-center justify-between gap-2">
                                  <div>
                                    <p className="text-base font-black text-blue-950 break-keep">
                                      공동계약인 직접서명
                                    </p>
                                    <p className="text-sm font-bold leading-6 text-blue-800 break-keep">
                                      본인의 성명을 정자로 작성해 주세요. 점, 짧은 선, 알아보기 어려운 낙서는 서명으로 인정되지 않을 수 있습니다.
                                    </p>
                                  </div>
                                  {directSignatureReady && (
                                    <span className="shrink-0 rounded-full bg-emerald-100 px-3 py-1 text-xs font-black text-emerald-700">
                                      공동계약인 직접서명 완료
                                    </span>
                                  )}
                                  <HelpButton topic="SIGNATURE_QUALITY" compact />
                                </div>
                                <div className="relative overflow-hidden rounded-2xl border border-blue-200 bg-white">
                                  {!coRepLocked && (
                                    <div className="absolute inset-0 z-20 flex items-center justify-center bg-white/80 px-4 text-center text-sm font-black leading-6 text-slate-600 break-keep">
                                      KCP 본인확인 완료 후 공동계약인 직접서명을 입력할 수 있습니다.
                                    </div>
                                  )}
                                  {!directSignatureReady && (
                                    <div className="pointer-events-none absolute inset-0 z-10 flex select-none items-center justify-center text-center text-3xl font-black text-slate-300 opacity-70">
                                      {item.name || "공동계약인"}
                                    </div>
                                  )}
                                  <canvas
                                    ref={(canvas) =>
                                      setCoRepresentativeSignatureCanvasRef(
                                        item.id,
                                        canvas,
                                        item.signatureImageDataUrl || ""
                                      )
                                    }
                                    width={520}
                                    height={180}
                                    onMouseDown={(event) =>
                                      handleCoRepresentativeSignatureStart(event, item.id)
                                    }
                                    onMouseMove={(event) =>
                                      handleCoRepresentativeSignatureMove(event, item.id)
                                    }
                                    onMouseUp={() =>
                                      handleCoRepresentativeSignatureEnd(item.id)
                                    }
                                    onMouseLeave={() =>
                                      handleCoRepresentativeSignatureEnd(item.id)
                                    }
                                    onTouchStart={(event) =>
                                      handleCoRepresentativeSignatureStart(event, item.id)
                                    }
                                    onTouchMove={(event) =>
                                      handleCoRepresentativeSignatureMove(event, item.id)
                                    }
                                    onTouchEnd={() =>
                                      handleCoRepresentativeSignatureEnd(item.id)
                                    }
                                    onTouchCancel={() =>
                                      handleCoRepresentativeSignatureEnd(item.id)
                                    }
                                    className={`h-44 w-full touch-none bg-white ${
                                      coRepLocked ? "cursor-crosshair" : "cursor-not-allowed"
                                    }`}
                                  />
                                </div>
                                <div className="mt-2 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                                  <p className="text-sm font-bold leading-6 text-blue-900 break-keep">
                                    {directSignatureValidation?.valid === false
                                      ? "점이나 짧은 선은 서명으로 인정되지 않습니다. 다시 서명해 주세요."
                                      : directSignatureReady
                                      ? `서명일시: ${item.signatureEvidence?.signedAt || item.signedAt || "확인됨"}`
                                      : "서명란 안에 이름을 알아볼 수 있도록 작성해 주세요."}
                                  </p>
                                  <button
                                    type="button"
                                    onClick={() =>
                                      clearCoRepresentativeSignature(item.id)
                                    }
                                    disabled={!coRepLocked}
                                    className="min-h-[44px] rounded-xl border border-blue-200 bg-white px-3 py-2 text-sm font-black text-blue-800 disabled:bg-slate-100 disabled:text-slate-400"
                                  >
                                    직접서명 다시쓰기
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <div className="space-y-2">
                                <div className="flex justify-end">
                                  <HelpButton topic="DELEGATED_SIGNATURE" compact />
                                </div>
                                <label className="flex items-start gap-2 rounded-xl border border-emerald-100 bg-emerald-50 px-3 py-3 text-sm font-bold leading-6 text-emerald-950 break-keep">
                                  <input
                                    type="checkbox"
                                    checked={
                                      item.delegatedSignatureConsent?.agreed === true
                                    }
                                    disabled={!coRepLocked}
                                    onChange={(event) =>
                                      updateCoRepresentativeDraft(item.id, {
                                        signatureMode:
                                          CO_REPRESENTATIVE_SIGNATURE_MODE_DELEGATED,
                                        delegatedSignatureConsent:
                                          buildDelegatedSignatureConsent({
                                            agreed: event.target.checked,
                                            agreedAt: event.target.checked
                                              ? new Date().toISOString()
                                              : "",
                                            principalSignerName: formData.agentRep,
                                          }),
                                        signatureStatus: event.target.checked
                                          ? "DELEGATED_BY_PRINCIPAL"
                                          : "PENDING",
                                        signedAt: event.target.checked
                                          ? new Date().toISOString()
                                          : null,
                                      })
                                    }
                                    className="mt-1 h-5 w-5 shrink-0 accent-emerald-600 disabled:opacity-50"
                                  />
                                  <span>
                                    {CO_REPRESENTATIVE_DELEGATED_SIGNATURE_CONSENT_TEXT}
                                    {!coRepLocked && (
                                      <span className="mt-1 block text-emerald-700">
                                        본인확인 완료 후 체크할 수 있습니다.
                                      </span>
                                    )}
                                    {item.delegatedSignatureConsent?.agreed === true && (
                                      <span className="mt-1 block font-black text-emerald-700">
                                        주대표자 대리서명 동의 완료
                                      </span>
                                    )}
                                  </span>
                                </label>
                              </div>
                            )}
                            <p className="text-sm font-bold leading-6 text-blue-800 break-keep">
                              상태: KCP {item.kcpStatus || "PENDING"} / 서명 방식 {signatureMode} / 완료 {hasCoRepresentativeSignatureCompletion(item) ? "완료" : "대기"}
                            </p>
                            <p className="text-sm font-bold leading-6 text-blue-800 break-keep">
                              공동계약인별 KCP 본인확인 및 서명 링크 구조로 저장됩니다. NTS 공동계약인 검증이 실패하면 임의로 MATCHED 처리하지 않습니다.
                            </p>
                          </div>
                        );
                      })}
                      <button
                        type="button"
                        onClick={addCoRepresentativeDraft}
                        className="min-h-[48px] w-full rounded-2xl border border-blue-200 bg-blue-50 px-4 py-3 text-base font-black text-blue-900"
                      >
                        공동계약인 추가하기
                      </button>
                    </div>
                  )}
                  {showCoRepresentativeGuidance && (
                    <div className="rounded-2xl border border-amber-200 bg-amber-50 px-4 py-4 text-base font-bold leading-7 text-amber-900 break-keep">
                      <p className="mb-1 font-black">{CO_REPRESENTATIVE_NOTICE_TITLE}</p>
                      <p>{CO_REPRESENTATIVE_NOTICE_TEXT}</p>
                      <p className="mt-2">
                        현재 서명자는 본인이 대표자이거나 계약 체결 권한을 위임받았음을 최종 단계에서 확인해야 합니다.
                      </p>
                    </div>
                  )}
                </div>
                <div className="space-y-2">
                  <div className="flex flex-wrap items-center justify-between gap-2 mb-1">
                    <label className="text-base font-black text-slate-800 ml-1 break-keep">
                      사업장 주소
                    </label>
                    <div className="flex items-center gap-2">
                      <HelpButton topic="ADDRESS_SEARCH" compact />
                      <button
                        type="button"
                        onClick={() => setManualAddressMode((v) => !v)}
                        className="min-h-[44px] rounded-xl px-3 py-2 text-base font-black text-slate-600 underline decoration-slate-300"
                      >
                        {manualAddressMode ? "주소 검색으로 전환" : "직접 입력"}
                      </button>
                    </div>
                  </div>
                  {!manualAddressMode ? (
                    /* ── 검색 모드: readonly 표시 + 검색 버튼 ── */
                    <button
                      ref={agentAddressInputRef}
                      type="button"
                      onClick={() => { setAddressTarget("agent"); setShowAddressModal(true); }}
                      className={`w-full min-h-[56px] p-4 rounded-2xl border-2 border-dashed text-left text-base font-semibold leading-7 break-keep transition-all ${
                        errors.agentAddress
                          ? "border-red-400 bg-red-50 text-red-600"
                          : formData.agentAddress
                          ? "border-slate-200 bg-slate-50 text-slate-900"
                          : "border-slate-300 bg-white text-slate-400"
                      }`}
                    >
                      <div className="flex items-center gap-2">
                        <Search className="w-4 h-4 shrink-0" />
                        <span className={formData.agentAddress ? "font-medium" : ""}>
                          {formData.agentAddress || "주소 검색 (클릭)"}
                        </span>
                      </div>
                    </button>
                  ) : (
                    /* ── 직접 입력 모드 ── */
                    <input
                      ref={agentAddressInputRef}
                      name="agentAddress"
                      value={formData.agentAddress}
                      onChange={handleChange}
                      onFocus={() => setFocusedField("agentAddress")}
                      className={`w-full min-h-[56px] p-4 bg-slate-50 rounded-2xl border text-lg ${
                        errors.agentAddress ? "border-red-500 bg-red-50" : "border-slate-200"
                      } outline-none font-medium transition-all`}
                      placeholder="시/군/구/동/번지 직접 입력"
                    />
                  )}
                  <input
                    ref={detailAddrRef}
                    name="agentAddressDetail"
                    value={formData.agentAddressDetail}
                    onChange={handleChange}
                    className="w-full min-h-[56px] p-4 bg-slate-50 rounded-2xl border border-slate-200 focus:border-red-500 outline-none text-lg font-semibold transition-all"
                    placeholder="상세 주소 입력 (동/층/호수 등)"
                    disabled={!formData.agentAddress}
                  />
                  {renderSeniorFieldHelp("agentAddress")}
                  {errors.agentAddress && (
                    <CustomerErrorMessage>{errors.agentAddress}</CustomerErrorMessage>
                  )}
                </div>
                <div className="pt-2">
                  <label className="text-base font-black text-slate-800 ml-1 mb-2 flex justify-between break-keep">
                    <span className="flex items-center gap-1">
                      <CreditCard className="w-3 h-3" /> 결제(입금) 예정일
                    </span>
                    <label className="flex items-center gap-1 text-slate-800 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={isSameDayDeposit}
                        onChange={handleSameDayCheck}
                        className="h-5 w-5 accent-red-600"
                      />
                      <span className="text-base font-black">당일 입금</span>
                    </label>
                  </label>
                  <div
                    className={`flex items-center gap-2 p-4 rounded-2xl border ${
                      errors.depositDay
                        ? "border-red-500 bg-red-50"
                        : "border-slate-200 bg-white"
                    }`}
                  >
                    <span className="font-bold text-base text-slate-600">
                      매월
                    </span>
                    <input
                      ref={depositDayInputRef}
                      type="tel"
                      name="depositDay"
                      value={formData.depositDay}
                      onChange={handleDepositDayChange}
                      onFocus={() => setFocusedField("depositDay")}
                      disabled={isSameDayDeposit}
                      className={`w-16 p-1 border-b-2 text-center font-black text-lg outline-none ${
                        isSameDayDeposit
                          ? "bg-transparent border-slate-200 text-slate-400"
                          : "border-slate-300 focus:border-red-500 bg-transparent"
                      }`}
                      placeholder={isSameDayDeposit ? "-" : "일자"}
                    />
                    <span className="font-bold text-base text-slate-600">일</span>
                  </div>
                  {renderSeniorFieldHelp("depositDay")}
                  {errors.depositDay && (
                    <CustomerErrorMessage>{errors.depositDay}</CustomerErrorMessage>
                  )}
                </div>

                {isCorporateBiz && (
                  <div className="mt-4 pt-4 border-t border-slate-200 animate-in slide-in-from-bottom-2">
                    <h3 className="text-sm font-bold text-slate-800 mb-3 flex items-center gap-2">
                      <UserCheck className="w-4 h-4" /> 법인 대표자 개인정보
                      (공동계약 확인)
                    </h3>
                    <FieldHelp step="9">
                      법인 계약일 때는 법인 대표자 개인 정보와 자택 주소를 함께 확인합니다. 계약서 출력에는 필요한 범위만 표시됩니다.
                    </FieldHelp>
                    <div className="space-y-3">
                      <div>
                        <input
                          ref={corpRepNameInputRef}
                          name="corpRepName"
                          value={formData.corpRepName}
                          onChange={handleChange}
                          onFocus={() => setFocusedField("corpRepName")}
                          disabled={identityFieldsLocked}
                          readOnly={identityFieldsLocked}
                          className={`w-full min-h-[56px] p-4 bg-slate-50 rounded-2xl border text-lg ${
                            errors.corpRepName ? "border-red-500 bg-red-50" : "border-slate-200"
                          } focus:border-red-500 outline-none font-bold text-slate-900`}
                          placeholder="대표자 성명 (개인)"
                        />
                        {errors.corpRepName && (
                          <p className="text-[10px] text-red-500 mt-1 ml-1 flex items-center gap-1">
                            <AlertCircle className="w-3 h-3" /> {errors.corpRepName}
                          </p>
                        )}
                      </div>
                      {/* 대표자 주소 검색 */}
                      <div className="space-y-2">
                        <div className="flex flex-wrap items-center justify-between gap-2">
                          <span className="ml-1 text-base font-black text-slate-800 break-keep">대표자 자택 주소</span>
                          <div className="flex items-center gap-2">
                            <HelpButton topic="ADDRESS_SEARCH" compact />
                            <button
                              type="button"
                              onClick={() => {
                                if (identityFieldsLocked) {
                                  setToastMessage("본인확인 완료로 수정할 수 없습니다. 수정하려면 본인확인 다시하기를 눌러 주세요.");
                                  return;
                                }
                                setManualCorpAddrMode((v) => !v);
                              }}
                              disabled={identityFieldsLocked}
                              className="min-h-[44px] rounded-xl px-3 py-2 text-base font-black text-slate-600 underline decoration-slate-300 disabled:text-slate-400"
                            >
                              {manualCorpAddrMode ? "주소 검색으로 전환" : "직접 입력"}
                            </button>
                          </div>
                        </div>
                        {!manualCorpAddrMode ? (
                          <button
                            type="button"
                            onClick={() => {
                              if (identityFieldsLocked) {
                                setToastMessage("본인확인 완료로 수정할 수 없습니다. 수정하려면 본인확인 다시하기를 눌러 주세요.");
                                return;
                              }
                              setAddressTarget("corp");
                              setShowAddressModal(true);
                            }}
                            disabled={identityFieldsLocked}
                            className={`w-full min-h-[56px] p-4 rounded-2xl border-2 border-dashed text-left text-base font-semibold leading-7 break-keep transition-all ${
                              errors.corpRepAddress
                                ? "border-red-400 bg-red-50 text-red-600"
                                : formData.corpRepAddress
                                ? "border-slate-200 bg-slate-50 text-slate-900"
                                : "border-slate-300 bg-white text-slate-400"
                            }`}
                          >
                            <div className="flex items-center gap-2">
                              <Search className="w-4 h-4 shrink-0" />
                              <span className={formData.corpRepAddress ? "font-medium" : ""}>
                                {formData.corpRepAddress || "대표자 자택 주소 검색 (클릭)"}
                              </span>
                            </div>
                          </button>
                        ) : (
                          <input
                            ref={corpRepAddressInputRef}
                            name="corpRepAddress"
                            value={formData.corpRepAddress}
                            onChange={handleChange}
                            onFocus={() => setFocusedField("corpRepAddress")}
                            disabled={identityFieldsLocked}
                            readOnly={identityFieldsLocked}
                            className={`w-full min-h-[56px] p-4 bg-slate-50 rounded-2xl border text-lg ${
                              errors.corpRepAddress ? "border-red-500 bg-red-50" : "border-slate-200"
                            } outline-none font-medium`}
                            placeholder="시/군/구/동/번지 직접 입력"
                          />
                        )}
                        {errors.corpRepAddress && (
                          <CustomerErrorMessage>{errors.corpRepAddress}</CustomerErrorMessage>
                        )}
                        <input
                          name="corpRepAddressDetail"
                          value={formData.corpRepAddressDetail}
                          onChange={handleChange}
                          className="w-full min-h-[56px] p-4 bg-slate-50 rounded-2xl border border-slate-200 focus:border-red-500 outline-none text-lg font-semibold"
                          placeholder="상세 주소 (동/층/호수 등)"
                          disabled={!formData.corpRepAddress || identityFieldsLocked}
                          readOnly={identityFieldsLocked}
                        />
                      </div>
                    </div>
                  </div>
                )}

                <button
                  onClick={handleNextStepFromInfo}
                  className={`w-full py-5 mt-4 rounded-2xl font-black text-white text-lg flex justify-center items-center gap-2 shadow-xl active:scale-95 transition-all ${
                    loading ? "bg-slate-300" : "bg-red-600 shadow-red-200"
                  } ${step0ReadyPulse ? "cnfood-button-ready-pulse" : ""}`}
                >
                  {loading ? (
                    <Loader2 className="animate-spin" />
                  ) : (
                    <>
                      다음 단계{" "}
                      <ChevronRight className="w-5 h-5 stroke-[3px]" />
                    </>
                  )}
                </button>
              </div>
            </div>
          )}

          {/* Step 1: 휴대폰 번호 확인 */}
          {step === 1 && (
            <div className="space-y-5 animate-in slide-in-from-right-4">
              <h2 className="text-2xl font-black leading-tight flex items-center gap-2 text-slate-900 break-keep">
                <ShieldCheck className="text-red-600" /> {identityCopy.title}
              </h2>

              {/* ── 휴대폰 번호 확인 (개인/법인 공통) ── */}
              <SectionHelp>
                {identityProvider === "KCP"
                  ? "통신사 휴대폰 본인확인으로 이름·생년월일과 휴대폰 명의를 확인합니다. 본인확인에 사용할 휴대폰 번호를 입력해 주세요."
                  : "본인확인에 사용할 휴대폰 번호를 입력한 뒤 휴대폰 번호 확인을 진행합니다. 문자 인증은 통신사 본인확인과 다릅니다."}
              </SectionHelp>
              {renderIdentityTestModePanel("customer")}
              <div className={`p-5 rounded-[1.5rem] border-2 transition-all ${phoneVerificationSatisfied ? "bg-green-50 border-green-200" : "bg-slate-50 border-slate-200"}`}>
                <div className="flex items-center gap-2 mb-3">
                  <Smartphone className="w-4 h-4 text-slate-600" />
                  <span className="text-base font-black text-slate-800 break-keep">{identityCopy.title}</span>
                  {phoneVerificationSatisfied && (
                    <span className="ml-auto text-xs font-bold text-green-600 bg-green-100 px-2 py-0.5 rounded-full flex items-center gap-1">
                      <Check className="w-3 h-3" /> {validationSettings.enablePhoneVerification ? identityCopy.completedLabel : "확인 생략"}
                    </span>
                  )}
                </div>
                <div className="mb-4">
                  <div className="mb-2 flex items-center justify-between gap-2">
                    <label className="text-base font-black text-slate-800 ml-1 block break-keep">
                      본인확인에 사용할 휴대폰 번호
                    </label>
                    <HelpButton topic="KCP_VERIFICATION" compact />
                  </div>
                  <input
                    ref={agentContactInputRef}
                    type="tel"
                    name="agentContact"
                    value={formData.agentContact}
                    onChange={handlePhoneChange}
                    onFocus={() => setFocusedField("agentContact")}
                    disabled={identityFieldsLocked}
                    readOnly={identityFieldsLocked}
                    className={`w-full min-h-[60px] rounded-2xl border bg-white px-4 py-4 font-mono text-xl font-black tracking-tight text-slate-900 outline-none transition-all ${
                      errors.agentContact || otpError
                        ? "border-red-500 bg-red-50"
                        : "border-slate-200 focus:border-red-500"
                    }`}
                    placeholder="010-0000-0000"
                    inputMode="numeric"
                    autoComplete="tel"
                    maxLength={13}
                  />
                  {renderSeniorFieldHelp("agentContact")}
                  {errors.agentContact && (
                    <CustomerErrorMessage>{errors.agentContact}</CustomerErrorMessage>
                  )}
                  <p className="mt-2 rounded-2xl bg-white px-4 py-3 text-base font-bold leading-relaxed text-slate-700">
                    대표자 본인 명의 휴대폰으로 본인확인을 진행해야 합니다.
                    번호를 바꾸면 이전 본인확인 상태는 자동으로 초기화됩니다.
                  </p>
                </div>
                <FieldHelp step="1">
                  {identityProvider === "KCP"
                    ? "KCP 완료 시 이름·생년월일·휴대폰번호를 대표자 정보와 비교합니다. 불일치하면 계약서 확인 단계로 진행할 수 없습니다."
                    : "문자 인증은 입력한 휴대폰 번호 확인 단계입니다. CI/DI와 이름·생년월일은 제공되지 않으므로 대표자 검증 상태는 KCP 대기로 남습니다."}
                </FieldHelp>
                {!effectiveStep1PhoneVerified || !validationSettings.enablePhoneVerification ? (
                  <>
                    <div className="space-y-4 mb-2">
                      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
                      <button
                        type="button"
                        onClick={() => {
                          resetPhoneAuthState(true);
                          focusValidationIssue(
                            createValidationIssue(
                              "agentContact",
                              "본인확인에 사용할 휴대폰 번호를 다시 입력해 주세요."
                            )
                          );
                        }}
                        disabled={identityLoading}
                        className="w-full min-h-[56px] rounded-2xl bg-white border border-slate-200 px-4 py-3 text-base font-black text-slate-700 active:scale-95 transition-all disabled:opacity-50"
                      >
                        번호 다시 입력
                      </button>
                      {showKcpIdentityControls ? (
                        <div className="space-y-2">
                          <button
                            type="button"
                            onClick={handleStartKcpIdentity}
                            disabled={kcpLoading || !identityActionGate.allowed}
                            aria-label={
                              kcpFallbackReason
                                ? "통신사 본인확인 다시 시도"
                                : "통신사 PASS 인증 본인확인 시작"
                            }
                            className="cnfood-identity-cta-glow relative isolate flex min-h-[66px] w-full items-center justify-center gap-3 overflow-hidden rounded-2xl bg-gradient-to-r from-sky-500 via-cyan-500 to-blue-600 px-5 py-4 text-white shadow-xl shadow-cyan-500/30 ring-2 ring-cyan-200/70 transition active:scale-[0.98] disabled:opacity-60 disabled:active:scale-100"
                          >
                            <span
                              aria-hidden="true"
                              className="cnfood-identity-cta-shimmer pointer-events-none absolute inset-y-[-20%] left-[-35%] w-1/3 bg-white/25 blur-sm"
                            />
                            {kcpLoading ? (
                              <span className="relative inline-flex items-center justify-center gap-2 whitespace-nowrap text-base font-black">
                                <Loader2 className="h-5 w-5 animate-spin" />
                                본인확인 요청 중...
                              </span>
                            ) : (
                              <>
                                <span className="relative flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-white/20">
                                  <ShieldCheck className="h-5 w-5" />
                                </span>
                                <span className="relative flex min-w-0 flex-col items-start leading-tight">
                                  <span className="whitespace-nowrap text-xs font-bold text-cyan-50">
                                    통신사 PASS 인증
                                  </span>
                                  <span className="whitespace-nowrap text-lg font-black">
                                    {kcpFallbackReason ? "본인확인 다시 시도" : identityCopy.actionLabel}
                                  </span>
                                </span>
                              </>
                            )}
                          </button>
                          <p className="text-center text-sm font-bold leading-6 text-sky-800 break-keep">
                            본인 명의 휴대폰으로 안전하게 인증합니다.
                          </p>
                        </div>
                      ) : showSmsIdentityControls ? (
                        <button
                          onClick={otpSent
                            ? () => {
                                if (otpCooldown > 0) return;
                                resetPhoneAuthState(false);
                                handleSendOTP();
                              }
                            : handleSendOTP}
                          disabled={
                            otpLoading ||
                            (otpSent && otpCooldown > 0) ||
                            !identityActionGate.allowed
                          }
                          className="w-full min-h-[56px] rounded-2xl bg-slate-900 px-4 py-3 text-base font-black text-white active:scale-95 transition-all disabled:opacity-50 text-center sm:w-auto sm:min-w-[96px] sm:shrink-0"
                        >
                          {otpLoading
                            ? <Loader2 className="w-4 h-4 animate-spin mx-auto" />
                            : otpSent && otpCooldown > 0
                            ? `${otpCooldown}초`
                            : otpSent
                            ? "재발송"
                            : identityCopy.actionLabel}
                        </button>
                      ) : (
                        <span className="w-full min-h-[56px] rounded-2xl bg-green-100 px-4 py-3 text-base font-black text-green-700 text-center sm:w-auto sm:min-w-[96px] sm:shrink-0">
                          생략
                        </span>
                      )}
                      </div>
                      {showSmsFallbackChoice && (
                        <button
                          type="button"
                          onClick={handleSelectSmsFallback}
                          disabled={kcpLoading}
                          className="w-full min-h-[56px] rounded-2xl border border-amber-200 bg-amber-50 px-4 py-3 text-base font-black text-amber-800 active:scale-95 transition-all disabled:opacity-50"
                        >
                          문자 인증으로 계속 진행
                        </button>
                      )}
                    </div>
                    {validationSettings.enablePhoneVerification && identityProvider === "KCP" && kcpSessionId && (
                      <FieldHelp step="2">
                        KCP 본인확인 진행 상태: {kcpIdentityStatus || "대기"}. 완료 후 이 화면으로 돌아오면 상태를 자동 확인합니다.
                        {kcpVerifiedName ? ` 확인 이름: ${kcpVerifiedName}` : ""}
                      </FieldHelp>
                    )}
                    {validationSettings.enablePhoneVerification && verificationMode === "KCP_FAILED" && (
                      <FieldHelp step="2">
                        통신사 본인확인을 완료하지 못했습니다. 다시 시도하거나 문자 인증으로 계속 진행할 수 있습니다.
                      </FieldHelp>
                    )}
                    {validationSettings.enablePhoneVerification && verificationMode === "KCP_FAILED" && (
                      <CustomerErrorMessage>
                        본인확인 창이 열리지 않았거나 시간이 초과되었을 수 있습니다. 팝업 허용 후 다시 시도해 주세요.
                      </CustomerErrorMessage>
                    )}
                    {validationSettings.enablePhoneVerification && verificationMode === "SMS_FALLBACK_SELECTED" && (
                      <FieldHelp step="2">
                        문자 인증은 휴대폰 번호 확인 단계입니다. CI/DI와 이름·생년월일은 제공되지 않습니다.
                      </FieldHelp>
                    )}
                    {validationSettings.enablePhoneVerification && showSmsIdentityControls && otpSent && (
                      <div className="flex flex-col gap-2 sm:flex-row">
                        <input
                          value={otpCode}
                          onChange={(e) => setOtpCode(e.target.value.replace(/[^0-9]/g, ""))}
                          className="w-full min-h-[56px] min-w-0 rounded-2xl bg-white p-4 border border-slate-200 outline-none font-black text-lg text-center tracking-[0.4em] focus:border-red-500 sm:flex-1"
                          placeholder="인증번호 6자리"
                          type="tel"
                          maxLength={6}
                        />
                        <button
                          onClick={handleVerifyOTP}
                          disabled={otpLoading || otpCode.length < 6}
                          className="w-full min-h-[56px] rounded-2xl bg-red-600 px-4 py-3 text-base font-black text-white active:scale-95 transition-all disabled:opacity-50 sm:w-auto sm:shrink-0"
                        >
                          {otpLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : "확인"}
                        </button>
                      </div>
                    )}
                    {validationSettings.enablePhoneVerification && showSmsIdentityControls && otpSent && (
                      <FieldHelp step="2">
                        문자로 받은 6자리 숫자를 입력하고 확인을 눌러 주세요. 시간이 지나면 재발송 버튼으로 다시 받을 수 있습니다.
                      </FieldHelp>
                    )}
                    {otpError && (
                      <CustomerErrorMessage>{otpError}</CustomerErrorMessage>
                    )}
                    <p className="text-[15px] font-bold leading-7 text-slate-600 break-keep mt-2 ml-1">
                      {validationSettings.enablePhoneVerification
                        ? identityProvider === "KCP"
                          ? "* KCP 통신사 휴대폰 본인확인을 진행합니다. CI/DI 원문은 저장소와 화면에 노출하지 않습니다."
                          : kcpFallbackReason
                          ? "* 문자 인증은 입력한 휴대폰 번호 확인 단계입니다. 통신사 본인확인과 다르게 CI/DI 및 이름·생년월일은 제공되지 않습니다."
                          : `* SMS 인증번호가 발송됩니다. ${otpCooldown > 0 ? `재발송까지 ${otpCooldown}초` : "수신 후 60초 이내 입력해주세요."}`
                        : "* 휴대폰 번호 확인이 꺼져 있어 번호 형식만 확인하고 다음 단계로 진행합니다."}
                    </p>
                  </>
                ) : (
                  <div className="space-y-3">
                    <p className="text-sm font-bold text-green-700">
                      {identityProvider === "KCP"
                        ? `${kcpPhoneMasked || maskPhoneNumber(otpPhoneNumber)} 대표자 본인확인 완료`
                        : `${otpPhoneNumber} 확인 완료`}
                    </p>
                    {identityProvider === "KCP" && (
                      <button
                        type="button"
                        onClick={handleRetryRepresentativeIdentity}
                        className="flex min-h-[48px] w-full items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-3 text-base font-black text-slate-700 active:scale-95"
                      >
                        <RefreshCcw className="h-4 w-4" />
                        본인확인 다시하기
                      </button>
                    )}
                  </div>
                )}
              </div>

              {shouldShowStep1KcpCheckingCard && (
                <div
                  className="rounded-2xl border-2 border-sky-200 bg-sky-50 px-5 py-5 text-sky-950 shadow-sm"
                  role="status"
                  aria-live="polite"
                >
                  <div className="flex items-start gap-3">
                    <Loader2 className="mt-1 h-5 w-5 shrink-0 animate-spin text-sky-700" />
                    <div className="min-w-0 flex-1">
                      <h3 className="text-xl font-black leading-tight break-keep">
                        본인인증 결과를 확인 중입니다
                      </h3>
                      <p className="mt-3 text-base font-bold leading-7 break-keep">
                        인증 완료 후 결과 반영까지 잠시 걸릴 수 있습니다.
                        창을 닫거나 새로고침하지 말고 기다려 주세요.
                      </p>
                      <button
                        type="button"
                        onClick={handleRefreshRepresentativeIdentityStatus}
                        className="mt-4 flex min-h-[54px] w-full items-center justify-center gap-2 rounded-2xl bg-sky-700 px-4 py-3 text-base font-black text-white shadow-sm active:scale-95"
                      >
                        <RefreshCcw className="h-4 w-4" />
                        인증 결과 다시 확인
                      </button>
                      {kcpLaunchFallbackVisible && (
                        <button
                          type="button"
                          onClick={() => void handleStartKcpIdentity()}
                          disabled={kcpLoading || !identityActionGate.allowed}
                          className="mt-3 flex min-h-[54px] w-full items-center justify-center gap-2 rounded-2xl border border-sky-200 bg-white px-4 py-3 text-base font-black text-sky-800 shadow-sm active:scale-95 disabled:bg-slate-100 disabled:text-slate-400"
                        >
                          <ShieldCheck className="h-4 w-4" />
                          본인인증 다시 하기
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {shouldShowStep1ReauthenticationWarning && (
                <div className="rounded-2xl border-2 border-red-200 bg-red-50 px-5 py-5 text-red-950 shadow-sm">
                  <div className="flex items-start gap-3">
                    <AlertCircle className="mt-1 h-5 w-5 shrink-0 text-red-700" />
                    <div className="min-w-0 flex-1">
                      <h3 className="text-xl font-black leading-tight break-keep">
                        본인인증이 다시 필요합니다
                      </h3>
                      <p className="mt-3 text-base font-bold leading-7 break-keep">
                        휴대폰 브라우저 복귀 과정에서 인증 상태 확인이 완료되지 않았습니다.
                        아래 버튼으로 본인인증을 다시 진행해 주세요.
                      </p>
                      <button
                        type="button"
                        onClick={() => void handleStartKcpIdentity()}
                        disabled={kcpLoading || !identityActionGate.allowed}
                        className="mt-4 flex min-h-[54px] w-full items-center justify-center gap-2 rounded-2xl bg-red-700 px-4 py-3 text-base font-black text-white shadow-sm active:scale-95 disabled:bg-slate-300 disabled:text-slate-500"
                      >
                        <ShieldCheck className="h-4 w-4" />
                        본인인증 다시 하기
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* ── 주민번호 입력 ── */}
              {shouldShowResidentRegistrationFields(bizType) && (
                <div className="bg-amber-50 border-2 border-amber-200 p-5 rounded-[1.5rem] space-y-4">
                  <div className="flex items-center gap-2">
                    <AlertCircle className="w-4 h-4 text-amber-600 shrink-0" />
                    <span className="text-xl font-black leading-snug text-amber-900 break-keep">
                      주민등록번호 입력
                    </span>
                    <HelpButton topic="SSN" compact className="ml-auto" />
                  </div>
                  <p className="text-base font-bold leading-7 text-amber-800 break-keep">
                    입력한 주민등록번호는 외상거래 및 채권관리 목적에 한해 암호화되어 저장됩니다.
                    출력 화면에는 뒷자리가 마스킹되며, 본사 관리자만 열람 사유를 기록한 뒤 제한적으로 확인할 수 있습니다.
                  </p>

                  <FieldHelp step="3">
                    주민번호는 앞 6자리와 뒤 7자리를 나누어 입력합니다. 저장 시 암호화되고, 출력 화면에는 뒤 7자리가 마스킹됩니다.
                  </FieldHelp>

                  <div className="rounded-2xl bg-white/70 p-3 border border-amber-100 space-y-2">
                    <div className="text-base font-black text-amber-900 break-keep">
                      본 대표 주민번호
                    </div>
                    <div className="flex flex-col gap-2">
                      <input
                        ref={principalRepSsnFrontInputRef}
                        name="principalRepSsnFront"
                        value={
                          formData.principalRepSsnFront ||
                          formData.ssnFront ||
                          (identityFieldsLocked && restoredSsnDraft?.principalRepSsnMasked
                            ? restoredSsnDraft.principalRepSsnMasked.split("-")[0] || ""
                            : "")
                        }
                        onChange={handleSSNChange}
                        onFocus={() => setFocusedField("principalRepSsnFront")}
                        disabled={identityFieldsLocked && Boolean(restoredSsnDraft?.principalRepSsnEncrypted)}
                        readOnly={identityFieldsLocked && Boolean(restoredSsnDraft?.principalRepSsnEncrypted)}
                        className="w-full min-h-[56px] p-3 bg-white rounded-xl border border-amber-200 outline-none text-center font-black text-lg tracking-widest focus:border-amber-500"
                        placeholder="주민번호 앞 6자리"
                        maxLength={6}
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck={false}
                      />
                      <input
                        ref={principalRepSsnBackInputRef}
                        name="principalRepSsnBack"
                        value={
                          formData.principalRepSsnBack ||
                          formData.ssnBack ||
                          (identityFieldsLocked && restoredSsnDraft?.principalRepSsnEncrypted
                            ? "*******"
                            : "")
                        }
                        onChange={handleSSNChange}
                        onPaste={(event) => event.preventDefault()}
                        onFocus={() => setFocusedField("principalRepSsnBack")}
                        disabled={identityFieldsLocked && Boolean(restoredSsnDraft?.principalRepSsnEncrypted)}
                        readOnly={identityFieldsLocked && Boolean(restoredSsnDraft?.principalRepSsnEncrypted)}
                        className="w-full min-h-[56px] p-3 bg-white rounded-xl border border-amber-200 outline-none text-center font-black text-lg tracking-widest focus:border-amber-500"
                        placeholder="주민번호 뒤 7자리"
                        type="password"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        autoComplete="off"
                        autoCorrect="off"
                        autoCapitalize="off"
                        spellCheck={false}
                        maxLength={7}
                      />
                    </div>
                    {identityFieldsLocked && restoredSsnDraft?.principalRepSsnEncrypted && (
                      <p className="text-sm text-amber-700 font-medium mt-1">
                        주민번호가 암호화되어 보관 중입니다.
                      </p>
                    )}
                    {identityFieldsLocked && !restoredSsnDraft?.principalRepSsnEncrypted && (
                      <p className="text-sm text-amber-600 font-medium mt-1">
                        본인확인 완료 후 주민번호를 입력해 주세요.
                      </p>
                    )}
                    {renderSeniorFieldHelp(
                      focusedField === "principalRepSsnBack"
                        ? "principalRepSsnBack"
                        : "principalRepSsnFront"
                    )}
                  </div>

                  {shouldShowCorporateSsnFields(bizType) && (
                    <div className="rounded-2xl bg-white/70 p-3 border border-amber-100 space-y-2">
                      <div className="text-base font-black text-amber-900 break-keep">
                        공동계약인 주민번호
                      </div>
                      <div className="flex flex-col gap-2">
                        <input
                          ref={guarantorSsnFrontInputRef}
                          name="guarantorSsnFront"
                          value={
                            formData.guarantorSsnFront ||
                            (identityFieldsLocked && restoredSsnDraft?.guarantorSsnMasked
                              ? restoredSsnDraft.guarantorSsnMasked.split("-")[0] || ""
                              : "")
                          }
                          onChange={handleSSNChange}
                          onFocus={() => setFocusedField("guarantorSsnFront")}
                          disabled={identityFieldsLocked && Boolean(restoredSsnDraft?.guarantorSsnEncrypted)}
                          readOnly={identityFieldsLocked && Boolean(restoredSsnDraft?.guarantorSsnEncrypted)}
                          className="w-full min-h-[56px] p-3 bg-white rounded-xl border border-amber-200 outline-none text-center font-black text-lg tracking-widest focus:border-amber-500"
                          placeholder="주민번호 앞 6자리"
                          maxLength={6}
                          type="text"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          autoComplete="off"
                          autoCorrect="off"
                          autoCapitalize="off"
                          spellCheck={false}
                        />
                        <input
                          ref={guarantorSsnBackInputRef}
                          name="guarantorSsnBack"
                          value={
                            formData.guarantorSsnBack ||
                            (identityFieldsLocked && restoredSsnDraft?.guarantorSsnEncrypted
                              ? "*******"
                              : "")
                          }
                          onChange={handleSSNChange}
                          onPaste={(event) => event.preventDefault()}
                          onFocus={() => setFocusedField("guarantorSsnBack")}
                          disabled={identityFieldsLocked && Boolean(restoredSsnDraft?.guarantorSsnEncrypted)}
                          readOnly={identityFieldsLocked && Boolean(restoredSsnDraft?.guarantorSsnEncrypted)}
                          className="w-full min-h-[56px] p-3 bg-white rounded-xl border border-amber-200 outline-none text-center font-black text-lg tracking-widest focus:border-amber-500"
                          placeholder="주민번호 뒤 7자리"
                          type="password"
                          inputMode="numeric"
                          pattern="[0-9]*"
                          autoComplete="off"
                          autoCorrect="off"
                          autoCapitalize="off"
                          spellCheck={false}
                          maxLength={7}
                        />
                      </div>
                      {renderSeniorFieldHelp(
                        focusedField === "guarantorSsnBack"
                          ? "guarantorSsnBack"
                          : "guarantorSsnFront"
                      )}
                    </div>
                  )}
                </div>
              )}

              {/* ── 동의 항목 ── */}
              <div className="space-y-2">
                {/* 개인정보처리방침 링크 */}
                <FieldHelp step="4">
                  필수 동의 항목을 차례대로 확인해 주세요. 각 항목을 눌러 선택하면 다음 단계로 진행할 수 있습니다.
                </FieldHelp>
                {renderRequiredConsentProgress([
                  { key: "privacy-consent", checked: agreements.privacy },
                  { key: "credit-check-consent", checked: agreements.credit },
                  { key: "collection-consent", checked: agreements.collection },
                ])}
                <button
                  type="button"
                  onClick={() => setShowPrivacyPolicy(true)}
                  className="w-full text-left text-base font-bold leading-7 text-blue-700 underline px-1 pb-1 break-keep"
                >
                  개인정보 처리방침 전문 보기 →
                </button>

                <button
                  type="button"
                  ref={setRequiredConsentRef("privacy-consent")}
                  data-consent-card="privacy-consent"
                  role="checkbox"
                  aria-checked={agreements.privacy}
                  aria-invalid={highlightedConsentKey === "privacy-consent" && !agreements.privacy}
                  onClick={() => toggleStep1Agreement("privacy", "privacy-consent")}
                  className={getRequiredConsentCardClass("privacy-consent", agreements.privacy)}
                >
                  {renderRequiredConsentCheckIcon(
                    agreements.privacy,
                    highlightedConsentKey === "privacy-consent"
                  )}
                  <div className="min-w-0 flex-1 text-base font-bold leading-7 break-keep">
                    <div className="mb-2 flex flex-wrap items-center gap-2">
                      {renderRequiredConsentBadge()}
                      <span>개인정보 수집·이용 동의</span>
                    </div>
                    <span className="font-normal opacity-90">
                      수집항목: 휴대폰번호, 계약정보 | 목적: 계약체결, 휴대폰 번호 확인
                    </span>
                    {renderRequiredConsentError("privacy-consent", agreements.privacy)}
                  </div>
                </button>

                <button
                  type="button"
                  ref={setRequiredConsentRef("credit-check-consent")}
                  data-consent-card="credit-check-consent"
                  role="checkbox"
                  aria-checked={agreements.credit}
                  aria-invalid={highlightedConsentKey === "credit-check-consent" && !agreements.credit}
                  onClick={() => toggleStep1Agreement("credit", "credit-check-consent")}
                  className={getRequiredConsentCardClass("credit-check-consent", agreements.credit)}
                >
                  {renderRequiredConsentCheckIcon(
                    agreements.credit,
                    highlightedConsentKey === "credit-check-consent"
                  )}
                  <div className="min-w-0 flex-1 text-base font-bold leading-7 break-keep">
                    <div className="mb-2 flex flex-wrap items-center gap-2">
                      {renderRequiredConsentBadge()}
                      <span>본인은 신용정보 조회 및 활용에 동의합니다.</span>
                    </div>
                    <div className="mt-2 space-y-1 whitespace-normal break-keep font-normal leading-7 opacity-90">
                      <p className="text-[15px]">
                        신용정보조회회사: KCB ({CREDIT_CHECK_COMPANY})
                      </p>
                      <p className="text-[15px]">
                        목적: 거래관계 설정·유지, 채권관리, 미수금 관리,
                        신용거래 여부 판단
                      </p>
                      <p className="text-[15px]">
                        조회 정보: 개인신용평점, 신용거래정보, 연체정보,
                        채무불이행정보, 공공정보 등
                      </p>
                      <p className="text-[15px]">
                        대표자 주민등록번호는 계약서 기재 및 확인 용도로
                        암호화 저장됩니다.
                      </p>
                    </div>
                    {renderRequiredConsentError("credit-check-consent", agreements.credit)}
                  </div>
                </button>

                <button
                  type="button"
                  ref={setRequiredConsentRef("collection-consent")}
                  data-consent-card="collection-consent"
                  role="checkbox"
                  aria-checked={agreements.collection}
                  aria-invalid={highlightedConsentKey === "collection-consent" && !agreements.collection}
                  onClick={() => toggleStep1Agreement("collection", "collection-consent")}
                  className={getRequiredConsentCardClass(
                    "collection-consent",
                    agreements.collection,
                    "border-red-700 bg-red-700 text-white"
                  )}
                >
                  {renderRequiredConsentCheckIcon(
                    agreements.collection,
                    highlightedConsentKey === "collection-consent"
                  )}
                  <div className="min-w-0 flex-1 text-base font-bold leading-7 break-keep">
                    <div className="mb-2 flex flex-wrap items-center gap-2">
                      {renderRequiredConsentBadge()}
                      <span>채권추심 및 법적 절차 목적 이용 동의</span>
                    </div>
                    <span className="font-normal opacity-90 text-[15px]">
                      미수금 발생 시 채권추심·민사소송·지급명령·강제집행 등 법적 절차에 수집된 정보(주민등록번호 포함)가 이용될 수 있습니다. 보유기간: 계약종료 후 5년
                    </span>
                    {renderRequiredConsentError("collection-consent", agreements.collection)}
                  </div>
                </button>
              </div>

              <div className="flex flex-col gap-3 mt-4 sm:flex-row">
                <button
                  onClick={() => goToStep(step - 1)}
                  className="w-full min-h-[56px] rounded-2xl border-2 border-slate-100 px-4 py-4 text-base font-bold text-slate-500 sm:w-1/3"
                >
                  이전
                </button>
                <button
                  onClick={handleNextStepFromSSN}
                  disabled={!step1NextAction.enabled}
                  className={`w-full py-4 rounded-2xl font-black text-white text-base shadow-xl active:scale-95 transition-all sm:flex-1 sm:text-lg ${
                    !step1NextAction.enabled
                      ? "bg-slate-300 shadow-none"
                      : "bg-red-600 shadow-red-200"
                  } ${step1ReadyPulse ? "cnfood-button-ready-pulse" : ""}`}
                >
                  {validationSettings.enablePhoneVerification ? "다음 단계" : "인증 생략 후 다음 단계"}
                </button>
              </div>
              {!step1NextAction.enabled && step1NextAction.reason && (
                <p className="text-sm font-bold text-red-600 break-keep">
                  {step1NextAction.reason}
                </p>
              )}
            </div>
          )}

          {/* Step 2: 계약서 확인 */}
          {step === 2 && (
            <div className="space-y-4 animate-in slide-in-from-right-4 h-full flex flex-col">
              <h2 className="text-2xl font-black leading-tight flex items-center gap-2 text-slate-900 break-keep">
                <FileText className="text-red-600" /> 계약서 확인
              </h2>
              <SectionHelp>
                계약 내용을 끝까지 확인한 뒤 동의 체크를 해야 전자서명으로 이동할 수 있습니다.
              </SectionHelp>
              <div
                ref={contractPreviewRef}
                onScroll={() => {
                  const container = contractPreviewRef.current;
                  if (!container || contractScrolled) return;

                  const isScrollable = container.scrollHeight > container.clientHeight + 4;
                  if (!isScrollable) {
                    return;
                  }

                  const reachedBottom =
                    container.scrollTop + container.clientHeight >=
                    container.scrollHeight * 0.9;

                  if (reachedBottom) {
                    markContractScrolled90();
                  }
                }}
                className="min-h-[360px] max-h-[60vh] flex-grow overflow-y-auto rounded-2xl border border-slate-200 bg-slate-50 p-5 text-[15px] leading-7 text-slate-700 shadow-inner break-keep"
              >
                <h3 className="mb-6 text-center text-xl font-black leading-snug text-slate-900 underline underline-offset-4 break-keep">
                  통합 공급계약서
                </h3>
                <div className="mb-4 rounded-xl border border-blue-100 bg-blue-50 px-4 py-3 text-sm font-bold leading-6 text-blue-900 break-keep">
                  <p>
                    계약서 조항 버전:{" "}
                    {contractTemplateSnapshotFields.contractTemplateVersion}
                  </p>
                  <p>
                    {contractTemplateLoading
                      ? "계약서 최신 조항을 확인하는 중입니다."
                      : "신규 계약에는 승인본 V2 조항이 적용됩니다."}
                  </p>
                </div>
                <div className="mb-5 rounded-xl border border-slate-200 bg-white p-4 text-base leading-7 text-slate-700 break-keep">
                  <p className="font-black text-slate-900">계약 당사자</p>
                  <p>
                    공급자: 주식회사 씨엔푸드 화성지점 / 농업회사법인 주식회사 씨엔푸드
                  </p>
                  <p>
                    공급받는자: {formData.agentName || "미입력"} / 대표자 또는 계약 담당자:{" "}
                    {formData.corpRepName || formData.agentRep || "미입력"}
                  </p>
                </div>
                <div className="space-y-3">
                  <ContractTermsRenderer
                    terms={contractTemplateSnapshotFields.contractClausesSnapshot}
                    mode="SCREEN"
                  />
                </div>
              </div>
              <div className="space-y-2">
                <FieldHelp step="1">
                  계약서 미리보기 영역을 아래까지 스크롤해 전체 내용을 확인해 주세요.
                </FieldHelp>
                {renderRequiredConsentProgress([
                  { key: "contract-agreement", checked: contractAgreed },
                ])}
                <div
                  className={`rounded-2xl border p-4 transition-all ${
                    contractScrolled
                      ? "border-emerald-200 bg-emerald-50 text-emerald-700"
                      : "border-amber-200 bg-amber-50 text-amber-700"
                  }`}
                >
                  <p className="text-base font-bold leading-7 break-keep">
                    {contractScrolled
                      ? "계약 내용 확인이 완료되었습니다."
                      : "계약 내용을 끝까지 확인해 주세요."}
                  </p>
                </div>
                <label
                  ref={setRequiredConsentRef("contract-agreement")}
                  data-consent-card="contract-agreement"
                  tabIndex={0}
                  aria-invalid={highlightedConsentKey === "contract-agreement" && !contractAgreed}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      handleContractAgreementChange(!contractAgreed);
                    }
                  }}
                  className={getRequiredConsentCardClass("contract-agreement", contractAgreed)}
                >
                  <input
                    type="checkbox"
                    checked={contractAgreed}
                    onChange={(e) => handleContractAgreementChange(e.target.checked)}
                    className="mt-1 h-7 w-7 shrink-0 accent-red-600"
                  />
                  <div className="min-w-0 flex-1 text-base font-bold leading-7 break-keep">
                    <div className="mb-2 flex flex-wrap items-center gap-2">
                      {renderRequiredConsentBadge()}
                      <span>
                        본인은 계약서 내용을 확인하였고, 해당 내용에 동의합니다.
                      </span>
                    </div>
                    {renderRequiredConsentError("contract-agreement", contractAgreed)}
                  </div>
                </label>
                <FieldHelp step="2">
                  내용을 확인했다면 동의 체크박스를 선택해 주세요. 두 조건이 모두 완료되어야 서명 단계로 이동합니다.
                </FieldHelp>
                {(!contractScrolled || !contractAgreed) && (
                  <div className="rounded-2xl border border-amber-200 bg-amber-50 px-4 py-4 text-base font-bold leading-7 text-amber-800 break-keep">
                    {!contractScrolled
                      ? "계약서를 끝까지 확인해 주세요."
                      : "계약서 내용 확인 및 동의에 체크해 주세요."}
                  </div>
                )}
              </div>
              <div className="flex flex-col gap-3 mt-4 sm:flex-row">
                <button
                  onClick={() => goToStep(step - 1)}
                  className="w-full min-h-[56px] rounded-2xl border-2 border-slate-100 px-4 py-4 text-base font-bold text-slate-500 sm:w-1/3"
                >
                  이전
                </button>
                <button
                  onClick={handleGoToSignature}
                  disabled={!step2NextAction.enabled}
                  className={`w-full min-h-[56px] rounded-2xl px-4 py-4 text-base font-black text-white active:scale-95 transition-all flex justify-center items-center gap-2 sm:flex-1 ${
                    !step2NextAction.enabled
                      ? "bg-slate-300 shadow-none"
                      : "bg-red-600 shadow-xl shadow-red-200"
                  } ${step2ReadyPulse ? "cnfood-button-ready-pulse" : ""}`}
                >
                  {transitioning ? (
                    <Loader2 className="animate-spin" />
                  ) : (
                    "서명하러 가기"
                  )}
                </button>
              </div>
            </div>
          )}

          {/* Step 3: 서명 */}
          {step === 3 && (
            <div className="space-y-4 h-full flex flex-col animate-in slide-in-from-right-4">
              <div className="flex justify-between items-end px-1">
                <div>
                  <h2 className="text-2xl font-black leading-tight text-slate-900 break-keep">
                    전자 서명
                  </h2>
                  <p className="mt-1 text-base font-bold leading-7 text-slate-600 break-keep">
                    아래 서명란에 손가락 또는 마우스로 서명해 주세요.
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  <HelpButton topic="SIGNATURE_QUALITY" compact />
                  <button
                    onClick={clearSignature}
                    aria-label="서명 지우기"
                    className="inline-flex min-h-[44px] min-w-[84px] items-center justify-center gap-1 whitespace-nowrap rounded-full border border-slate-200 bg-white px-4 py-2 text-base font-bold text-slate-600 active:bg-slate-100"
                  >
                    <RefreshCcw className="h-4 w-4 shrink-0" />
                    <span>지우기</span>
                  </button>
                </div>
              </div>
              <SectionHelp>
                서명은 계약 완료본에 저장됩니다. 이름이 알아볼 수 있게 충분한 크기로 작성하고, 권한 확인 체크까지 완료해 주세요.
              </SectionHelp>
              <div className="mb-2">
                  <span className="text-base font-bold leading-7 text-slate-600 ml-1 break-keep">
                  {primarySignatureDescriptor.label}
                </span>
              </div>
              <p className="mb-2 text-base font-black leading-7 text-slate-800 break-keep">
                본인의 성명을 정자로 작성해 주세요.
              </p>
              <div className="bg-slate-50 border-2 border-dashed border-slate-300 rounded-[2rem] h-64 touch-none relative overflow-hidden shadow-inner mb-6">
                <canvas
                  ref={canvasRef}
                  width={600}
                  height={400}
                  className="w-full h-full cursor-crosshair"
                  onMouseDown={(e) => handleStartDraw(e, canvasRef)}
                  onMouseMove={(e) => handleMoveDraw(e, canvasRef)}
                  onMouseUp={(e) => handleEndDraw(canvasRef)}
                  onMouseLeave={() => handleEndDraw(canvasRef)}
                  onTouchStart={(e) => handleStartDraw(e, canvasRef)}
                  onTouchMove={(e) => handleMoveDraw(e, canvasRef)}
                  onTouchEnd={(e) => handleEndDraw(canvasRef)}
                  onTouchCancel={(e) => handleEndDraw(canvasRef)}
                  style={{ touchAction: "none", WebkitUserSelect: "none" }}
                />
                {!isSigned && (
                  <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none select-none opacity-25">
                    <PenTool className="w-16 h-16 text-slate-400 mb-2" />
                    <p className="text-4xl font-black text-slate-400">
                      {primarySignatureSignerName}
                    </p>
                    <p className="mt-2 text-base font-black text-slate-400 break-keep">
                      {primarySignatureSignerName} 님 성명을 정자로 작성해 주세요
                    </p>
                  </div>
                )}
              </div>
              <FieldHelp step="1">
                서명란의 흐린 이름은 안내용입니다. 실제 서명은 직접 작성해야 합니다. 점, 짧은 선, 알아보기 어려운 낙서는 서명으로 인정되지 않을 수 있습니다. 서명란 안에 이름을 알아볼 수 있도록 작성해 주세요.
              </FieldHelp>
              {isCorporateBiz && (
                <div className="animate-in slide-in-from-bottom-2">
                  <label
                    ref={setRequiredConsentRef("representative-personal-guarantee")}
                    data-consent-card="representative-personal-guarantee"
                    className={`mb-4 ${getRequiredConsentCardClass(
                      "representative-personal-guarantee",
                      representativePersonalGuaranteeAgreed
                    )}`}
                  >
                    <input
                      type="checkbox"
                      checked={representativePersonalGuaranteeAgreed}
                      onChange={(event) =>
                        setRepresentativePersonalGuaranteeAgreed(event.target.checked)
                      }
                      className="mt-1 h-7 w-7 shrink-0 accent-red-600"
                    />
                    <span className="min-w-0 flex-1 text-base font-bold leading-7 break-keep">
                      <span className="mb-2 flex flex-wrap items-center gap-2">
                        {renderRequiredConsentBadge()}
                        <span>대표자 공동계약 확인 동의</span>
                        <HelpButton topic="PERSONAL_GUARANTEE" compact />
                      </span>
                      <span className="block font-normal opacity-90">
                        {REPRESENTATIVE_PERSONAL_GUARANTEE_CONSENT_TEXT}
                      </span>
                      {renderRequiredConsentError(
                        "representative-personal-guarantee",
                        representativePersonalGuaranteeAgreed
                      )}
                    </span>
                  </label>
                  <div className="flex justify-between items-end px-1 mb-1">
                    <span className="text-base font-bold leading-7 text-slate-600 ml-1 break-keep">
                      대표자 공동계약 확인 서명
                    </span>
                    <button
                      onClick={clearSignature2}
                      aria-label="대표자 공동계약 확인 서명 지우기"
                      className="inline-flex min-h-[40px] items-center justify-center whitespace-nowrap px-3 text-base font-bold text-slate-600 underline"
                    >
                      지우기
                    </button>
                  </div>
                  <div className="bg-slate-50 border-2 border-dashed border-slate-300 rounded-[2rem] h-40 touch-none relative overflow-hidden shadow-inner">
                    <canvas
                      ref={canvasRef2}
                      width={600}
                      height={200}
                      className="w-full h-full cursor-crosshair"
                      onMouseDown={(e) => handleStartDraw(e, canvasRef2, true)}
                      onMouseMove={(e) => handleMoveDraw(e, canvasRef2, true)}
                      onMouseUp={(e) => handleEndDraw(canvasRef2)}
                      onMouseLeave={() => handleEndDraw(canvasRef2)}
                      onTouchStart={(e) => handleStartDraw(e, canvasRef2, true)}
                      onTouchMove={(e) => handleMoveDraw(e, canvasRef2, true)}
                      onTouchEnd={(e) => handleEndDraw(canvasRef2)}
                      onTouchCancel={(e) => handleEndDraw(canvasRef2)}
                      style={{ touchAction: "none", WebkitUserSelect: "none" }}
                    />
                    {!signature2 && (
                      <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none select-none opacity-25">
                        <span className="text-3xl font-black text-slate-400">
                          {primarySignatureSignerName}
                        </span>
                        <span className="mt-1 text-base font-bold text-slate-400 break-keep">
                          대표자 공동계약 확인 서명
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              )}
              <FieldHelp step="2">
                마지막으로 계약 체결 권한을 확인해 주세요. 이 항목은 완료 기록과 함께 저장됩니다.
              </FieldHelp>
              {renderRequiredConsentProgress([
                ...(representativePersonalGuaranteeRequired
                  ? [
                      {
                        key: "representative-personal-guarantee" as RequiredConsentKey,
                        checked: representativePersonalGuaranteeAgreed,
                      },
                    ]
                  : []),
                { key: "contract-authority", checked: hasContractAuthority },
              ])}
              {showCoRepresentativeGuidance && (
                <div className="rounded-2xl border border-amber-200 bg-amber-50 px-4 py-4 text-base font-bold leading-7 text-amber-900 break-keep">
                  <p className="mb-1 font-black">공동계약인/공동사업자 안내</p>
                  <p>다른 대표자에게도 계약 참여 또는 확인을 안내해 주세요.</p>
                  <p className="mt-2">
                    아래 권한 확인은 현재 서명자가 대표자이거나 위임받은 담당자임을 확인하는 기록으로 함께 저장됩니다.
                  </p>
                </div>
              )}
              <label
                ref={setRequiredConsentRef("contract-authority")}
                data-consent-card="contract-authority"
                tabIndex={0}
                aria-invalid={highlightedConsentKey === "contract-authority" && !hasContractAuthority}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    handleContractAuthorityChange(!hasContractAuthority);
                  }
                }}
                className={`mt-3 ${getRequiredConsentCardClass(
                  "contract-authority",
                  hasContractAuthority
                )}`}
              >
                <input
                  type="checkbox"
                  checked={hasContractAuthority}
                  onChange={(e) => handleContractAuthorityChange(e.target.checked)}
                  className="mt-1 h-7 w-7 shrink-0 accent-red-600"
                  />
                <span className="min-w-0 flex-1 text-base font-bold leading-7 break-keep">
                  <span className="mb-2 flex flex-wrap items-center gap-2">
                    {renderRequiredConsentBadge()}
                    <span>
                      본인은 위 사업자 또는 업체를 대표하거나, 해당 업체로부터 본 계약을 체결할 권한을 위임받은 담당자임을 확인합니다.
                    </span>
                  </span>
                  {renderRequiredConsentError("contract-authority", hasContractAuthority)}
                </span>
              </label>
              <div className="flex flex-col gap-3 mt-6 sm:flex-row">
                <button
                  onClick={() => goToStep(step - 1)}
                  className="w-full min-h-[56px] rounded-2xl border-2 border-slate-100 px-4 py-4 text-base font-bold text-slate-500 sm:w-1/3"
                >
                  이전
                </button>
                <button
                  onClick={submitContract}
                  type="button"
                  disabled={
                    !finalSubmitAction.enabled ||
                    isSubmittingFinal ||
                    loading ||
                    imageGenerating ||
                    ["SAVING", "CONFIRMING_RECEIPT", "CONFIRMED"].includes(
                      submitState
                    )
                  }
                  className={`w-full min-h-[56px] rounded-2xl px-4 py-4 font-black text-white text-base shadow-xl flex items-center justify-center gap-2 active:scale-95 transition-all sm:flex-1 sm:text-lg ${
                        !finalSubmitAction.enabled
                          ? "bg-slate-300 shadow-none"
                          : "bg-red-600 shadow-red-200"
                  } ${finalSubmitReadyPulse ? "cnfood-button-ready-pulse" : ""}`}
                >
                  {loading || imageGenerating || isSubmittingFinal || finalSubmitLockedByReceipt ? (
                    <Loader2 className="animate-spin" />
                  ) : (
                    "계약 완료"
                  )}
                  {submitState === "SAVING" && "저장 중입니다"}
                  {submitState === "CONFIRMING_RECEIPT" &&
                    "접수 정보를 확인하고 있습니다"}
                  {submitState === "CONFIRMED" && "정상 접수되었습니다"}
                  {(loading || imageGenerating || isSubmittingFinal) &&
                    submitState === "IDLE" &&
                    "계약 완료 처리 중..."}
                </button>
              </div>
            </div>
          )}

          {/* Step 5: 완료 */}
          {step === 5 &&
            (() => {
              const receipt =
                completionReceipt ||
                buildCompletionReceiptFromContract(lastSubmittedContractData || formData, {
                  confirmed: hasContractReceiptConfirmation(
                    lastSubmittedContractData || formData
                  ),
              });
              const receiptConfirmed = receipt?.confirmed === true;
              const pendingCoRepresentativeCompletion =
                receiptConfirmed && showCoRepresentativeSmsRequest;
              const receiptRows = [
                ["계약번호", receipt.contractNumber || "확인 중"],
                ["상호명", receipt.businessName || "미수집"],
                ["대표자명", receipt.representativeName || "미수집"],
                ["담당영업사원", receipt.managerName || COMPLETION_RECEIPT_FALLBACK_MANAGER],
                ["접수일시", formatEvidenceDate(receipt.submittedAt, "확인 중")],
                ["계약 상태", receipt.statusLabel || "접수 확인 중"],
                ["확인번호", receipt.confirmationNumber || "확인 중"],
              ];

              return (
                <div className="flex flex-col items-center pt-10 animate-in zoom-in">
                  <div
                    className={`mb-6 flex h-24 w-24 items-center justify-center rounded-full shadow-2xl ${
                      receiptConfirmed
                        ? "bg-green-500 shadow-green-200"
                        : "bg-amber-500 shadow-amber-200"
                    }`}
                  >
                    {receiptConfirmed ? (
                      <Check className="h-12 w-12 text-white stroke-[4px]" />
                    ) : (
                      <AlertTriangle className="h-12 w-12 text-white stroke-[3px]" />
                    )}
                  </div>
                  <h2 className="mb-2 break-keep text-center text-2xl font-black text-slate-900">
                    {pendingCoRepresentativeCompletion
                      ? "주대표자 작성이 완료되었습니다"
                      : receiptConfirmed
                      ? "전자계약서가 정상 접수되었습니다"
                      : "계약 제출 확인이 지연되고 있습니다."}
                  </h2>
                  <p className="mb-6 break-keep text-center text-base font-bold leading-7 text-slate-600">
                    {pendingCoRepresentativeCompletion
                      ? "공동계약인이 있는 계약입니다. 모든 공동계약인의 본인확인과 전자서명이 완료되면 최종 계약 작성이 완료됩니다."
                      : receiptConfirmed
                      ? "작성하신 전자계약서가 씨엔푸드 시스템에 정상 접수되었습니다. 담당자가 확인 후 필요한 경우 연락드릴 수 있습니다."
                      : "계약 제출은 처리되었을 수 있으나, 현재 접수 확인 정보를 불러오지 못했습니다. 새로고침이나 중복 제출을 하지 말고 잠시 후 접수정보 다시 확인을 눌러 주세요."}
                  </p>

                  {receiptConfirmed ? (
                    <div className="mb-6 w-full rounded-[1.5rem] border border-emerald-100 bg-emerald-50 p-5 text-left">
                      <div className="mb-4 flex items-center gap-2 text-emerald-900">
                        <ClipboardCheck className="h-5 w-5" />
                        <p className="text-lg font-black">
                          접수 확인 정보
                        </p>
                      </div>
                      <div className="space-y-2">
                        {receiptRows.map(([label, value]) => (
                          <div
                            key={label}
                            className="flex justify-between gap-3 border-b border-emerald-100 pb-2 text-sm font-bold last:border-b-0"
                          >
                            <span className="shrink-0 text-emerald-700">{label}</span>
                            <span className="min-w-0 break-words text-right text-slate-900">
                              {value}
                            </span>
                          </div>
                        ))}
                      </div>
                      <p className="mt-4 break-keep text-sm font-bold leading-6 text-emerald-800">
                        계약서 확인 및 후속 안내는 씨엔푸드 담당자가 진행합니다. 문의사항은 씨엔푸드 메인콜센터 {CNFOOD_SUPPORT_PHONE}로 연락해 주세요.
                      </p>
                    </div>
                  ) : (
                    <div className="mb-6 w-full rounded-[1.5rem] border border-amber-200 bg-amber-50 p-5 text-left">
                      <p className="text-lg font-black text-amber-950">
                        제출 확인 중
                      </p>
                      <p className="mt-2 break-keep text-base font-bold leading-7 text-amber-900">
                        {completionReceiptError ||
                          receipt.message ||
                          "계약 제출은 처리되었을 수 있으나, 현재 접수 확인 정보를 불러오지 못했습니다."}
                      </p>
                      <div className="mt-4 grid grid-cols-1 gap-2 sm:grid-cols-2">
                        <button
                          type="button"
                          onClick={handleRefreshCompletionReceipt}
                          disabled={completionReceiptChecking}
                          className="flex min-h-[52px] items-center justify-center gap-2 rounded-2xl bg-amber-700 px-4 py-3 text-base font-black text-white disabled:bg-slate-300"
                        >
                          {completionReceiptChecking ? (
                            <Loader2 className="h-5 w-5 animate-spin" />
                          ) : (
                            <RefreshCcw className="h-5 w-5" />
                          )}
                          접수정보 다시 확인
                        </button>
                        <button
                          type="button"
                          onClick={() => setShowUserErrorReport(true)}
                          className="flex min-h-[52px] items-center justify-center gap-2 rounded-2xl border border-amber-300 bg-white px-4 py-3 text-base font-black text-amber-800"
                        >
                          <Bug className="h-5 w-5" /> 오류신고
                        </button>
                      </div>
                      <a
                        href={`tel:${CNFOOD_SUPPORT_PHONE.replace(/-/g, "")}`}
                        className="mt-3 flex min-h-[48px] items-center justify-center rounded-2xl border border-amber-200 bg-white px-4 py-3 text-sm font-black text-amber-900"
                      >
                        고객센터 문의 {CNFOOD_SUPPORT_PHONE}
                      </a>
                    </div>
                  )}

                  {receiptConfirmed && (
                    <div className="relative mb-8 w-full overflow-hidden rounded-[2rem] border-8 border-slate-50 bg-white p-2 shadow-xl">
                      {finalContractImage ? (
                        <img
                          src={finalContractImage}
                          alt="contract"
                          className="w-full rounded-xl"
                        />
                      ) : (
                        <div className="flex h-64 flex-col items-center justify-center gap-2 text-slate-300">
                          <Loader2 className="h-8 w-8 animate-spin" />
                          <span className="text-xs font-bold">
                            계약서 생성 중...
                          </span>
                        </div>
                      )}
                      <div className="absolute right-4 top-4 rounded bg-red-600 px-2 py-1 text-[10px] font-black text-white">
                        고객보관용
                      </div>
                    </div>
                  )}

                  {receiptConfirmed && showCoRepresentativeSmsRequest && (
                    <div className="mb-6 w-full rounded-[1.5rem] border border-amber-200 bg-amber-50 p-5 text-left">
                      <h3 className="break-keep text-xl font-black leading-snug text-amber-950">
                        공동계약인 인증 및 서명 링크 전달
                      </h3>
                      <p className="mt-2 break-keep text-base font-bold leading-7 text-amber-900">
                        아래 공동계약인에게 인증 및 서명 링크를 전달해 주세요. 문자 앱이 열리면 내용을 확인한 뒤 직접 발송해 주세요.
                      </p>
                      {coRepresentativeInviteLinks.length > 0 ? (
                        <div className="mt-4 space-y-3">
                          {coRepresentativeInviteLinks.map((link) => {
                            const sourceRep = coRepresentatives.find(
                              (item) => item.id === link.coRepresentativeId
                            );
                            const smsPhone =
                              normalizePhoneDigits(sourceRep?.phone || "") ||
                              normalizePhoneDigits(coRepresentativeSmsPhone || "");
                            const smsMessage = buildCoRepresentativeSmsMessage({
                              requestLink: link.inviteUrl,
                            });
                            return (
                              <div
                                key={link.coRepresentativeId || link.inviteUrl}
                                className="rounded-2xl border border-amber-200 bg-white p-4"
                              >
                                <div className="flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
                                  <div>
                                    <p className="text-base font-black text-slate-900">
                                      {link.name || "공동계약인"}
                                    </p>
                                    <p className="text-sm font-bold text-slate-500">
                                      {link.phoneMasked || sourceRep?.phoneMasked || "휴대폰번호 확인 필요"}
                                    </p>
                                  </div>
                                  <span className="rounded-full bg-amber-100 px-3 py-1 text-xs font-black text-amber-800">
                                    링크 준비
                                  </span>
                                </div>
                                <p className="mt-3 break-all rounded-xl bg-amber-50 px-3 py-2 text-xs font-bold leading-5 text-amber-900">
                                  {link.inviteUrl}
                                </p>
                                <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2">
                                  <button
                                    type="button"
                                    onClick={() => copyTextToClipboard(link.inviteUrl)}
                                    className="flex min-h-[48px] items-center justify-center gap-2 rounded-xl border border-amber-200 bg-white px-3 py-2 text-sm font-black text-amber-900"
                                  >
                                    <ClipboardCheck className="h-4 w-4" /> 링크 복사
                                  </button>
                                  <a
                                    href={buildSmsHref(smsPhone, smsMessage)}
                                    onClick={() =>
                                      setToastMessage(
                                        "문자 앱이 열리면 내용을 확인한 뒤 직접 발송해 주세요."
                                      )
                                    }
                                    className={`flex min-h-[48px] items-center justify-center gap-2 rounded-xl px-3 py-2 text-sm font-black text-white ${
                                      smsPhone ? "bg-amber-700" : "pointer-events-none bg-slate-300"
                                    }`}
                                  >
                                    <Smartphone className="h-4 w-4" /> 문자 작성
                                  </a>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      ) : (
                        <>
                          <label className="mt-4 block">
                            <span className="mb-2 block text-base font-black text-slate-900">
                              공동계약인 휴대폰 번호
                            </span>
                            <input
                              type="tel"
                              inputMode="numeric"
                              value={coRepresentativeSmsPhone}
                              onChange={(event) => {
                                setCoRepresentativeSmsPhone(
                                  formatPhoneNumberForDisplay(event.target.value)
                                );
                                setCoRepresentativeSmsError("");
                              }}
                              placeholder="010-0000-0000"
                              className="min-h-[56px] w-full rounded-2xl border border-amber-200 bg-white px-4 py-3 text-lg font-bold text-slate-900 outline-none focus:border-amber-500 focus:ring-2 focus:ring-amber-200"
                            />
                          </label>
                          {coRepresentativeSmsError && (
                            <div className="mt-3 rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-base font-bold leading-7 text-red-700">
                              {coRepresentativeSmsError}
                            </div>
                          )}
                          <button
                            type="button"
                            onClick={handleOpenCoRepresentativeSmsDraft}
                            className="mt-4 flex min-h-[56px] w-full items-center justify-center gap-2 rounded-2xl bg-amber-700 px-4 py-3 text-base font-black text-white active:scale-95"
                          >
                            <Smartphone className="h-5 w-5" /> 문자 작성하기
                          </button>
                          <p className="mt-3 break-all rounded-2xl bg-white/80 px-4 py-3 text-sm font-bold leading-6 text-amber-900">
                            계약 작성 요청 링크: {coRepresentativeRequestLink || "초대 링크 확인 필요"}
                          </p>
                        </>
                      )}
                    </div>
                  )}

                  <div className="w-full space-y-3">
                    <div className="flex justify-end">
                      <HelpButton topic="PDF_DOWNLOAD" compact />
                    </div>
                    {receiptConfirmed && (
                      <button
                        onClick={() => handleDownloadPDF(null, "CUSTOMER")}
                        className="flex w-full items-center justify-center gap-2 rounded-2xl border-2 border-slate-100 bg-white py-5 text-sm font-black text-slate-600 transition-all active:scale-95"
                      >
                        <Download className="h-5 w-5" /> 완료본 PDF 저장
                      </button>
                    )}
                    <button
                      type="button"
                      onClick={handleRefreshCompletionReceipt}
                      disabled={completionReceiptChecking}
                      className="flex w-full items-center justify-center gap-2 rounded-2xl border-2 border-slate-100 bg-white py-5 text-sm font-black text-slate-600 transition-all active:scale-95 disabled:opacity-60"
                    >
                      {completionReceiptChecking ? (
                        <Loader2 className="h-5 w-5 animate-spin" />
                      ) : (
                        <RefreshCcw className="h-5 w-5" />
                      )}
                      접수정보 다시 확인
                    </button>
                    <button
                      type="button"
                      onClick={handleReturnToIntroAfterCompletion}
                      className="flex w-full items-center justify-center rounded-2xl bg-slate-900 py-5 text-sm font-black text-white transition-all active:scale-95"
                    >
                      처음으로
                    </button>
                  </div>
                </div>
              );
            })()}
        </div>
        <BusinessInfoFooter className="mt-6" />
      </div>

      {/* 주소 검색 모달 */}
      {showAddressModal && (
        <div className="fixed inset-0 z-[9999] bg-white flex flex-col">
          <div className="h-14 flex items-center justify-between px-4 border-b bg-white shrink-0">
            <h2 className="text-lg font-bold">주소 검색</h2>
            <button
              onClick={() => {
                setShowAddressModal(false);
                setCoRepAddressTargetId("");
              }}
              className="p-2 bg-gray-100 rounded-full"
            >
              <X className="w-6 h-6 text-slate-600" />
            </button>
          </div>
          <div
            ref={postcodeContainerRef}
            className="flex-grow w-full h-full bg-slate-50"
            style={{ minHeight: "400px" }}
          />
        </div>
      )}

      {/* 개인정보처리방침 모달 */}
      {showPrivacyPolicy && (
        <PrivacyPolicyModal onClose={() => setShowPrivacyPolicy(false)} />
      )}

      {/* Firebase Phone Auth reCAPTCHA 컨테이너 (invisible) */}
      <div id="recaptcha-container" />
    </div>
  );
};

const AppWithErrorBoundary = () => (
  <AppErrorBoundary>
    <App />
  </AppErrorBoundary>
);

export default AppWithErrorBoundary;

